(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired4cb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired4cb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Power2", () => Power2);
$parcel$export(module.exports, "Elastic", () => Elastic);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.13.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("6ShZv", function(module, exports) {
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */ 


var paper = (function(self1, undefined) {
    self1 = self1 || (parcelRequire("foUwZ"));
    var window = self1.window, document = self1.document;
    var Base = new function() {
        var hidden = /^(statics|enumerable|beans|preserve)$/, array = [], slice = array.slice, create = Object.create, describe = Object.getOwnPropertyDescriptor, define1 = Object.defineProperty, forEach = array.forEach || function(iter, bind) {
            for(var i = 0, l = this.length; i < l; i++)iter.call(bind, this[i], i, this);
        }, forIn = function(iter, bind) {
            for(var i in this)if (this.hasOwnProperty(i)) iter.call(bind, this[i], i, this);
        }, set = Object.assign || function(dst) {
            for(var i = 1, l = arguments.length; i < l; i++){
                var src = arguments[i];
                for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
            }
            return dst;
        }, each = function(obj, iter, bind) {
            if (obj) {
                var desc = describe(obj, 'length');
                (desc && typeof desc.value === 'number' ? forEach : forIn).call(obj, iter, bind = bind || obj);
            }
            return bind;
        };
        function inject(dest, src, enumerable, beans, preserve) {
            var beansNames = {};
            function field(name, val) {
                val = val || (val = describe(src, name)) && (val.get ? val : val.value);
                if (typeof val === 'string' && val[0] === '#') val = dest[val.substring(1)] || val;
                var isFunc = typeof val === 'function', res = val, prev = preserve || isFunc && !val.base ? val && val.get ? name in dest : dest[name] : null, bean;
                if (!preserve || !prev) {
                    if (isFunc && prev) val.base = prev;
                    if (isFunc && beans !== false && (bean = name.match(/^([gs]et|is)(([A-Z])(.*))$/))) beansNames[bean[3].toLowerCase() + bean[4]] = bean[2];
                    if (!res || isFunc || !res.get || typeof res.get !== 'function' || !Base.isPlainObject(res)) res = {
                        value: res,
                        writable: true
                    };
                    if ((describe(dest, name) || {
                        configurable: true
                    }).configurable) {
                        res.configurable = true;
                        res.enumerable = enumerable != null ? enumerable : !bean;
                    }
                    define1(dest, name, res);
                }
            }
            if (src) {
                for(var name in src)if (src.hasOwnProperty(name) && !hidden.test(name)) field(name);
                for(var name in beansNames){
                    var part = beansNames[name], set = dest['set' + part], get = dest['get' + part] || set && dest['is' + part];
                    if (get && (beans === true || get.length === 0)) field(name, {
                        get: get,
                        set: set
                    });
                }
            }
            return dest;
        }
        function Base() {
            for(var i = 0, l = arguments.length; i < l; i++){
                var src = arguments[i];
                if (src) set(this, src);
            }
            return this;
        }
        return inject(Base, {
            inject: function(src) {
                if (src) {
                    var statics = src.statics === true ? src : src.statics, beans = src.beans, preserve = src.preserve;
                    if (statics !== src) inject(this.prototype, src, src.enumerable, beans, preserve);
                    inject(this, statics, null, beans, preserve);
                }
                for(var i = 1, l = arguments.length; i < l; i++)this.inject(arguments[i]);
                return this;
            },
            extend: function() {
                var base = this, ctor, proto;
                for(var i = 0, obj, l = arguments.length; i < l && !(ctor && proto); i++){
                    obj = arguments[i];
                    ctor = ctor || obj.initialize;
                    proto = proto || obj.prototype;
                }
                ctor = ctor || function() {
                    base.apply(this, arguments);
                };
                proto = ctor.prototype = proto || create(this.prototype);
                define1(proto, 'constructor', {
                    value: ctor,
                    writable: true,
                    configurable: true
                });
                inject(ctor, this);
                if (arguments.length) this.inject.apply(ctor, arguments);
                ctor.base = base;
                return ctor;
            }
        }).inject({
            enumerable: false,
            initialize: Base,
            set: Base,
            inject: function() {
                for(var i = 0, l = arguments.length; i < l; i++){
                    var src = arguments[i];
                    if (src) inject(this, src, src.enumerable, src.beans, src.preserve);
                }
                return this;
            },
            extend: function() {
                var res = create(this);
                return res.inject.apply(res, arguments);
            },
            each: function(iter, bind) {
                return each(this, iter, bind);
            },
            clone: function() {
                return new this.constructor(this);
            },
            statics: {
                set: set,
                each: each,
                create: create,
                define: define1,
                describe: describe,
                clone: function(obj) {
                    return set(new obj.constructor(), obj);
                },
                isPlainObject: function(obj) {
                    var ctor = obj != null && obj.constructor;
                    return ctor && (ctor === Object || ctor === Base || ctor.name === 'Object');
                },
                pick: function(a, b) {
                    return a !== undefined ? a : b;
                },
                slice: function(list, begin, end) {
                    return slice.call(list, begin, end);
                }
            }
        });
    };
    module.exports = Base;
    Base.inject({
        enumerable: false,
        toString: function() {
            return this._id != null ? (this._class || 'Object') + (this._name ? " '" + this._name + "'" : ' @' + this._id) : '{ ' + Base.each(this, function(value, key) {
                if (!/^_/.test(key)) {
                    var type = typeof value;
                    this.push(key + ': ' + (type === 'number' ? Formatter.instance.number(value) : type === 'string' ? "'" + value + "'" : value));
                }
            }, []).join(', ') + ' }';
        },
        getClassName: function() {
            return this._class || '';
        },
        importJSON: function(json) {
            return Base.importJSON(json, this);
        },
        exportJSON: function(options) {
            return Base.exportJSON(this, options);
        },
        toJSON: function() {
            return Base.serialize(this);
        },
        set: function(props, exclude) {
            if (props) Base.filter(this, props, exclude, this._prioritize);
            return this;
        }
    }, {
        beans: false,
        statics: {
            exports: {},
            extend: function extend() {
                var res = extend.base.apply(this, arguments), name = res.prototype._class;
                if (name && !Base.exports[name]) Base.exports[name] = res;
                return res;
            },
            equals: function(obj1, obj2) {
                if (obj1 === obj2) return true;
                if (obj1 && obj1.equals) return obj1.equals(obj2);
                if (obj2 && obj2.equals) return obj2.equals(obj1);
                if (obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object') {
                    if (Array.isArray(obj1) && Array.isArray(obj2)) {
                        var length = obj1.length;
                        if (length !== obj2.length) return false;
                        while(length--){
                            if (!Base.equals(obj1[length], obj2[length])) return false;
                        }
                    } else {
                        var keys = Object.keys(obj1), length = keys.length;
                        if (length !== Object.keys(obj2).length) return false;
                        while(length--){
                            var key = keys[length];
                            if (!(obj2.hasOwnProperty(key) && Base.equals(obj1[key], obj2[key]))) return false;
                        }
                    }
                    return true;
                }
                return false;
            },
            read: function(list, start, options, amount) {
                if (this === Base) {
                    var value = this.peek(list, start);
                    list.__index++;
                    return value;
                }
                var proto = this.prototype, readIndex = proto._readIndex, begin = start || readIndex && list.__index || 0, length = list.length, obj = list[begin];
                amount = amount || length - begin;
                if (obj instanceof this || options && options.readNull && obj == null && amount <= 1) {
                    if (readIndex) list.__index = begin + 1;
                    return obj && options && options.clone ? obj.clone() : obj;
                }
                obj = Base.create(proto);
                if (readIndex) obj.__read = true;
                obj = obj.initialize.apply(obj, begin > 0 || begin + amount < length ? Base.slice(list, begin, begin + amount) : list) || obj;
                if (readIndex) {
                    list.__index = begin + obj.__read;
                    var filtered = obj.__filtered;
                    if (filtered) {
                        list.__filtered = filtered;
                        obj.__filtered = undefined;
                    }
                    obj.__read = undefined;
                }
                return obj;
            },
            peek: function(list, start) {
                return list[list.__index = start || list.__index || 0];
            },
            remain: function(list) {
                return list.length - (list.__index || 0);
            },
            readList: function(list, start, options, amount) {
                var res = [], entry, begin = start || 0, end = amount ? begin + amount : list.length;
                for(var i = begin; i < end; i++)res.push(Array.isArray(entry = list[i]) ? this.read(entry, 0, options) : this.read(list, i, options, 1));
                return res;
            },
            readNamed: function(list, name, start, options, amount) {
                var value = this.getNamed(list, name), hasValue = value !== undefined;
                if (hasValue) {
                    var filtered = list.__filtered;
                    if (!filtered) {
                        var source = this.getSource(list);
                        filtered = list.__filtered = Base.create(source);
                        filtered.__unfiltered = source;
                    }
                    filtered[name] = undefined;
                }
                return this.read(hasValue ? [
                    value
                ] : list, start, options, amount);
            },
            readSupported: function(list, dest) {
                var source = this.getSource(list), that = this, read = false;
                if (source) Object.keys(source).forEach(function(key) {
                    if (key in dest) {
                        var value = that.readNamed(list, key);
                        if (value !== undefined) dest[key] = value;
                        read = true;
                    }
                });
                return read;
            },
            getSource: function(list) {
                var source = list.__source;
                if (source === undefined) {
                    var arg = list.length === 1 && list[0];
                    source = list.__source = arg && Base.isPlainObject(arg) ? arg : null;
                }
                return source;
            },
            getNamed: function(list, name) {
                var source = this.getSource(list);
                if (source) return name ? source[name] : list.__filtered || source;
            },
            hasNamed: function(list, name) {
                return !!this.getNamed(list, name);
            },
            filter: function(dest, source, exclude, prioritize) {
                var processed;
                function handleKey(key) {
                    if (!(exclude && key in exclude) && !(processed && key in processed)) {
                        var value = source[key];
                        if (value !== undefined) dest[key] = value;
                    }
                }
                if (prioritize) {
                    var keys = {};
                    for(var i = 0, key, l = prioritize.length; i < l; i++)if ((key = prioritize[i]) in source) {
                        handleKey(key);
                        keys[key] = true;
                    }
                    processed = keys;
                }
                Object.keys(source.__unfiltered || source).forEach(handleKey);
                return dest;
            },
            isPlainValue: function(obj, asString) {
                return Base.isPlainObject(obj) || Array.isArray(obj) || asString && typeof obj === 'string';
            },
            serialize: function(obj, options, compact, dictionary) {
                options = options || {};
                var isRoot = !dictionary, res;
                if (isRoot) {
                    options.formatter = new Formatter(options.precision);
                    dictionary = {
                        length: 0,
                        definitions: {},
                        references: {},
                        add: function(item, create) {
                            var id = '#' + item._id, ref = this.references[id];
                            if (!ref) {
                                this.length++;
                                var res = create.call(item), name = item._class;
                                if (name && res[0] !== name) res.unshift(name);
                                this.definitions[id] = res;
                                ref = this.references[id] = [
                                    id
                                ];
                            }
                            return ref;
                        }
                    };
                }
                if (obj && obj._serialize) {
                    res = obj._serialize(options, dictionary);
                    var name = obj._class;
                    if (name && !obj._compactSerialize && (isRoot || !compact) && res[0] !== name) res.unshift(name);
                } else if (Array.isArray(obj)) {
                    res = [];
                    for(var i = 0, l = obj.length; i < l; i++)res[i] = Base.serialize(obj[i], options, compact, dictionary);
                } else if (Base.isPlainObject(obj)) {
                    res = {};
                    var keys = Object.keys(obj);
                    for(var i = 0, l = keys.length; i < l; i++){
                        var key = keys[i];
                        res[key] = Base.serialize(obj[key], options, compact, dictionary);
                    }
                } else if (typeof obj === 'number') res = options.formatter.number(obj, options.precision);
                else res = obj;
                return isRoot && dictionary.length > 0 ? [
                    [
                        'dictionary',
                        dictionary.definitions
                    ],
                    res
                ] : res;
            },
            deserialize: function(json, create, _data, _setDictionary, _isRoot) {
                var res = json, isFirst = !_data, hasDictionary = isFirst && json && json.length && json[0][0] === 'dictionary';
                _data = _data || {};
                if (Array.isArray(json)) {
                    var type = json[0], isDictionary = type === 'dictionary';
                    if (json.length == 1 && /^#/.test(type)) return _data.dictionary[type];
                    type = Base.exports[type];
                    res = [];
                    for(var i = type ? 1 : 0, l = json.length; i < l; i++)res.push(Base.deserialize(json[i], create, _data, isDictionary, hasDictionary));
                    if (type) {
                        var args = res;
                        if (create) res = create(type, args, isFirst || _isRoot);
                        else res = new type(args);
                    }
                } else if (Base.isPlainObject(json)) {
                    res = {};
                    if (_setDictionary) _data.dictionary = res;
                    for(var key in json)res[key] = Base.deserialize(json[key], create, _data);
                }
                return hasDictionary ? res[1] : res;
            },
            exportJSON: function(obj, options) {
                var json = Base.serialize(obj, options);
                return options && options.asString == false ? json : JSON.stringify(json);
            },
            importJSON: function(json, target) {
                return Base.deserialize(typeof json === 'string' ? JSON.parse(json) : json, function(ctor, args, isRoot) {
                    var useTarget = isRoot && target && target.constructor === ctor, obj = useTarget ? target : Base.create(ctor.prototype);
                    if (args.length === 1 && obj instanceof Item && (useTarget || !(obj instanceof Layer))) {
                        var arg = args[0];
                        if (Base.isPlainObject(arg)) {
                            arg.insert = false;
                            if (useTarget) args = args.concat([
                                Item.INSERT
                            ]);
                        }
                    }
                    (useTarget ? obj.set : ctor).apply(obj, args);
                    if (useTarget) target = null;
                    return obj;
                });
            },
            push: function(list, items) {
                var itemsLength = items.length;
                if (itemsLength < 4096) list.push.apply(list, items);
                else {
                    var startLength = list.length;
                    list.length += itemsLength;
                    for(var i = 0; i < itemsLength; i++)list[startLength + i] = items[i];
                }
                return list;
            },
            splice: function(list, items, index, remove) {
                var amount = items && items.length, append = index === undefined;
                index = append ? list.length : index;
                if (index > list.length) index = list.length;
                for(var i = 0; i < amount; i++)items[i]._index = index + i;
                if (append) {
                    Base.push(list, items);
                    return [];
                } else {
                    var args = [
                        index,
                        remove
                    ];
                    if (items) Base.push(args, items);
                    var removed = list.splice.apply(list, args);
                    for(var i = 0, l = removed.length; i < l; i++)removed[i]._index = undefined;
                    for(var i = index + amount, l = list.length; i < l; i++)list[i]._index = i;
                    return removed;
                }
            },
            capitalize: function(str) {
                return str.replace(/\b[a-z]/g, function(match) {
                    return match.toUpperCase();
                });
            },
            camelize: function(str) {
                return str.replace(/-(.)/g, function(match, chr) {
                    return chr.toUpperCase();
                });
            },
            hyphenate: function(str) {
                return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            }
        }
    });
    var Emitter = {
        on: function(type, func) {
            if (typeof type !== 'string') Base.each(type, function(value, key) {
                this.on(key, value);
            }, this);
            else {
                var types = this._eventTypes, entry = types && types[type], handlers = this._callbacks = this._callbacks || {};
                handlers = handlers[type] = handlers[type] || [];
                if (handlers.indexOf(func) === -1) {
                    handlers.push(func);
                    if (entry && entry.install && handlers.length === 1) entry.install.call(this, type);
                }
            }
            return this;
        },
        off: function(type, func) {
            if (typeof type !== 'string') {
                Base.each(type, function(value, key) {
                    this.off(key, value);
                }, this);
                return;
            }
            var types = this._eventTypes, entry = types && types[type], handlers = this._callbacks && this._callbacks[type], index;
            if (handlers) {
                if (!func || (index = handlers.indexOf(func)) !== -1 && handlers.length === 1) {
                    if (entry && entry.uninstall) entry.uninstall.call(this, type);
                    delete this._callbacks[type];
                } else if (index !== -1) handlers.splice(index, 1);
            }
            return this;
        },
        once: function(type, func) {
            return this.on(type, function handler() {
                func.apply(this, arguments);
                this.off(type, handler);
            });
        },
        emit: function(type, event) {
            var handlers = this._callbacks && this._callbacks[type];
            if (!handlers) return false;
            var args = Base.slice(arguments, 1), setTarget = event && event.target && !event.currentTarget;
            handlers = handlers.slice();
            if (setTarget) event.currentTarget = this;
            for(var i = 0, l = handlers.length; i < l; i++)if (handlers[i].apply(this, args) == false) {
                if (event && event.stop) event.stop();
                break;
            }
            if (setTarget) delete event.currentTarget;
            return true;
        },
        responds: function(type) {
            return !!(this._callbacks && this._callbacks[type]);
        },
        attach: '#on',
        detach: '#off',
        fire: '#emit',
        _installEvents: function(install) {
            var types = this._eventTypes, handlers = this._callbacks, key = install ? 'install' : 'uninstall';
            if (types) {
                for(var type in handlers)if (handlers[type].length > 0) {
                    var entry = types[type], func = entry && entry[key];
                    if (func) func.call(this, type);
                }
            }
        },
        statics: {
            inject: function inject(src) {
                var events = src._events;
                if (events) {
                    var types = {};
                    Base.each(events, function(entry, key) {
                        var isString = typeof entry === 'string', name = isString ? entry : key, part = Base.capitalize(name), type = name.substring(2).toLowerCase();
                        types[type] = isString ? {} : entry;
                        name = '_' + name;
                        src['get' + part] = function() {
                            return this[name];
                        };
                        src['set' + part] = function(func) {
                            var prev = this[name];
                            if (prev) this.off(type, prev);
                            if (func) this.on(type, func);
                            this[name] = func;
                        };
                    });
                    src._eventTypes = types;
                }
                return inject.base.apply(this, arguments);
            }
        }
    };
    var PaperScope = Base.extend({
        _class: 'PaperScope',
        initialize: function PaperScope() {
            paper = this;
            this.settings = new Base({
                applyMatrix: true,
                insertItems: true,
                handleSize: 4,
                hitTolerance: 0
            });
            this.project = null;
            this.projects = [];
            this.tools = [];
            this._id = PaperScope._id++;
            PaperScope._scopes[this._id] = this;
            var proto = PaperScope.prototype;
            if (!this.support) {
                var ctx = CanvasProvider.getContext(1, 1) || {};
                proto.support = {
                    nativeDash: 'setLineDash' in ctx || 'mozDash' in ctx,
                    nativeBlendModes: BlendMode.nativeModes
                };
                CanvasProvider.release(ctx);
            }
            if (!this.agent) {
                var user = self1.navigator.userAgent.toLowerCase(), os = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(user) || [])[0], platform = os === 'darwin' ? 'mac' : os, agent = proto.agent = proto.browser = {
                    platform: platform
                };
                if (platform) agent[platform] = true;
                user.replace(/(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g, function(match, n, v1, v2, rv) {
                    if (!agent.chrome) {
                        var v = n === 'opera' ? v2 : /^(node|trident)$/.test(n) ? rv : v1;
                        agent.version = v;
                        agent.versionNumber = parseFloat(v);
                        n = ({
                            trident: 'msie',
                            jsdom: 'node'
                        })[n] || n;
                        agent.name = n;
                        agent[n] = true;
                    }
                });
                if (agent.chrome) delete agent.webkit;
                if (agent.atom) delete agent.chrome;
            }
        },
        version: "0.12.18",
        getView: function() {
            var project = this.project;
            return project && project._view;
        },
        getPaper: function() {
            return this;
        },
        execute: function(code, options) {
            var exports = paper.PaperScript.execute(code, this, options);
            View.updateFocus();
            return exports;
        },
        install: function(scope) {
            var that = this;
            Base.each([
                'project',
                'view',
                'tool'
            ], function(key) {
                Base.define(scope, key, {
                    configurable: true,
                    get: function() {
                        return that[key];
                    }
                });
            });
            for(var key in this)if (!/^_/.test(key) && this[key]) scope[key] = this[key];
        },
        setup: function(element) {
            paper = this;
            this.project = new Project(element);
            return this;
        },
        createCanvas: function(width, height) {
            return CanvasProvider.getCanvas(width, height);
        },
        activate: function() {
            paper = this;
        },
        clear: function() {
            var projects = this.projects, tools = this.tools;
            for(var i = projects.length - 1; i >= 0; i--)projects[i].remove();
            for(var i = tools.length - 1; i >= 0; i--)tools[i].remove();
        },
        remove: function() {
            this.clear();
            delete PaperScope._scopes[this._id];
        },
        statics: new function() {
            function handleAttribute(name) {
                name += 'Attribute';
                return function(el, attr) {
                    return el[name](attr) || el[name]('data-paper-' + attr);
                };
            }
            return {
                _scopes: {},
                _id: 0,
                get: function(id) {
                    return this._scopes[id] || null;
                },
                getAttribute: handleAttribute('get'),
                hasAttribute: handleAttribute('has')
            };
        }
    });
    var PaperScopeItem = Base.extend(Emitter, {
        initialize: function(activate) {
            this._scope = paper;
            this._index = this._scope[this._list].push(this) - 1;
            if (activate || !this._scope[this._reference]) this.activate();
        },
        activate: function() {
            if (!this._scope) return false;
            var prev = this._scope[this._reference];
            if (prev && prev !== this) prev.emit('deactivate');
            this._scope[this._reference] = this;
            this.emit('activate', prev);
            return true;
        },
        isActive: function() {
            return this._scope[this._reference] === this;
        },
        remove: function() {
            if (this._index == null) return false;
            Base.splice(this._scope[this._list], null, this._index, 1);
            if (this._scope[this._reference] == this) this._scope[this._reference] = null;
            this._scope = null;
            return true;
        },
        getView: function() {
            return this._scope.getView();
        }
    });
    var CollisionDetection = {
        findItemBoundsCollisions: function(items1, items2, tolerance) {
            function getBounds(items) {
                var bounds = new Array(items.length);
                for(var i = 0; i < items.length; i++){
                    var rect = items[i].getBounds();
                    bounds[i] = [
                        rect.left,
                        rect.top,
                        rect.right,
                        rect.bottom
                    ];
                }
                return bounds;
            }
            var bounds1 = getBounds(items1), bounds2 = !items2 || items2 === items1 ? bounds1 : getBounds(items2);
            return this.findBoundsCollisions(bounds1, bounds2, tolerance || 0);
        },
        findCurveBoundsCollisions: function(curves1, curves2, tolerance, bothAxis) {
            function getBounds(curves) {
                var min = Math.min, max = Math.max, bounds = new Array(curves.length);
                for(var i = 0; i < curves.length; i++){
                    var v = curves[i];
                    bounds[i] = [
                        min(v[0], v[2], v[4], v[6]),
                        min(v[1], v[3], v[5], v[7]),
                        max(v[0], v[2], v[4], v[6]),
                        max(v[1], v[3], v[5], v[7])
                    ];
                }
                return bounds;
            }
            var bounds1 = getBounds(curves1), bounds2 = !curves2 || curves2 === curves1 ? bounds1 : getBounds(curves2);
            if (bothAxis) {
                var hor = this.findBoundsCollisions(bounds1, bounds2, tolerance || 0, false, true), ver = this.findBoundsCollisions(bounds1, bounds2, tolerance || 0, true, true), list = [];
                for(var i = 0, l = hor.length; i < l; i++)list[i] = {
                    hor: hor[i],
                    ver: ver[i]
                };
                return list;
            }
            return this.findBoundsCollisions(bounds1, bounds2, tolerance || 0);
        },
        findBoundsCollisions: function(boundsA, boundsB, tolerance, sweepVertical, onlySweepAxisCollisions) {
            var self1 = !boundsB || boundsA === boundsB, allBounds = self1 ? boundsA : boundsA.concat(boundsB), lengthA = boundsA.length, lengthAll = allBounds.length;
            function binarySearch(indices, coord, value) {
                var lo = 0, hi = indices.length;
                while(lo < hi){
                    var mid = hi + lo >>> 1;
                    if (allBounds[indices[mid]][coord] < value) lo = mid + 1;
                    else hi = mid;
                }
                return lo - 1;
            }
            var pri0 = sweepVertical ? 1 : 0, pri1 = pri0 + 2, sec0 = sweepVertical ? 0 : 1, sec1 = sec0 + 2;
            var allIndicesByPri0 = new Array(lengthAll);
            for(var i = 0; i < lengthAll; i++)allIndicesByPri0[i] = i;
            allIndicesByPri0.sort(function(i1, i2) {
                return allBounds[i1][pri0] - allBounds[i2][pri0];
            });
            var activeIndicesByPri1 = [], allCollisions = new Array(lengthA);
            for(var i = 0; i < lengthAll; i++){
                var curIndex = allIndicesByPri0[i], curBounds = allBounds[curIndex], origIndex = self1 ? curIndex : curIndex - lengthA, isCurrentA = curIndex < lengthA, isCurrentB = self1 || !isCurrentA, curCollisions = isCurrentA ? [] : null;
                if (activeIndicesByPri1.length) {
                    var pruneCount = binarySearch(activeIndicesByPri1, pri1, curBounds[pri0] - tolerance) + 1;
                    activeIndicesByPri1.splice(0, pruneCount);
                    if (self1 && onlySweepAxisCollisions) {
                        curCollisions = curCollisions.concat(activeIndicesByPri1);
                        for(var j = 0; j < activeIndicesByPri1.length; j++){
                            var activeIndex = activeIndicesByPri1[j];
                            allCollisions[activeIndex].push(origIndex);
                        }
                    } else {
                        var curSec1 = curBounds[sec1], curSec0 = curBounds[sec0];
                        for(var j = 0; j < activeIndicesByPri1.length; j++){
                            var activeIndex = activeIndicesByPri1[j], activeBounds = allBounds[activeIndex], isActiveA = activeIndex < lengthA, isActiveB = self1 || activeIndex >= lengthA;
                            if (onlySweepAxisCollisions || (isCurrentA && isActiveB || isCurrentB && isActiveA) && curSec1 >= activeBounds[sec0] - tolerance && curSec0 <= activeBounds[sec1] + tolerance) {
                                if (isCurrentA && isActiveB) curCollisions.push(self1 ? activeIndex : activeIndex - lengthA);
                                if (isCurrentB && isActiveA) allCollisions[activeIndex].push(origIndex);
                            }
                        }
                    }
                }
                if (isCurrentA) {
                    if (boundsA === boundsB) curCollisions.push(curIndex);
                    allCollisions[curIndex] = curCollisions;
                }
                if (activeIndicesByPri1.length) {
                    var curPri1 = curBounds[pri1], index = binarySearch(activeIndicesByPri1, pri1, curPri1);
                    activeIndicesByPri1.splice(index + 1, 0, curIndex);
                } else activeIndicesByPri1.push(curIndex);
            }
            for(var i = 0; i < allCollisions.length; i++){
                var collisions = allCollisions[i];
                if (collisions) collisions.sort(function(i1, i2) {
                    return i1 - i2;
                });
            }
            return allCollisions;
        }
    };
    var Formatter = Base.extend({
        initialize: function(precision) {
            this.precision = Base.pick(precision, 5);
            this.multiplier = Math.pow(10, this.precision);
        },
        number: function(val) {
            return this.precision < 16 ? Math.round(val * this.multiplier) / this.multiplier : val;
        },
        pair: function(val1, val2, separator) {
            return this.number(val1) + (separator || ',') + this.number(val2);
        },
        point: function(val, separator) {
            return this.number(val.x) + (separator || ',') + this.number(val.y);
        },
        size: function(val, separator) {
            return this.number(val.width) + (separator || ',') + this.number(val.height);
        },
        rectangle: function(val, separator) {
            return this.point(val, separator) + (separator || ',') + this.size(val, separator);
        }
    });
    Formatter.instance = new Formatter();
    var Numerical = new function() {
        var abscissas = [
            [
                0.5773502691896257645091488
            ],
            [
                0,
                0.7745966692414833770358531
            ],
            [
                0.3399810435848562648026658,
                0.8611363115940525752239465
            ],
            [
                0,
                0.5384693101056830910363144,
                0.9061798459386639927976269
            ],
            [
                0.2386191860831969086305017,
                0.6612093864662645136613996,
                0.9324695142031520278123016
            ],
            [
                0,
                0.4058451513773971669066064,
                0.7415311855993944398638648,
                0.9491079123427585245261897
            ],
            [
                0.1834346424956498049394761,
                0.5255324099163289858177390,
                0.7966664774136267395915539,
                0.9602898564975362316835609
            ],
            [
                0,
                0.3242534234038089290385380,
                0.6133714327005903973087020,
                0.8360311073266357942994298,
                0.9681602395076260898355762
            ],
            [
                0.1488743389816312108848260,
                0.4333953941292471907992659,
                0.6794095682990244062343274,
                0.8650633666889845107320967,
                0.9739065285171717200779640
            ],
            [
                0,
                0.2695431559523449723315320,
                0.5190961292068118159257257,
                0.7301520055740493240934163,
                0.8870625997680952990751578,
                0.9782286581460569928039380
            ],
            [
                0.1252334085114689154724414,
                0.3678314989981801937526915,
                0.5873179542866174472967024,
                0.7699026741943046870368938,
                0.9041172563704748566784659,
                0.9815606342467192506905491
            ],
            [
                0,
                0.2304583159551347940655281,
                0.4484927510364468528779129,
                0.6423493394403402206439846,
                0.8015780907333099127942065,
                0.9175983992229779652065478,
                0.9841830547185881494728294
            ],
            [
                0.1080549487073436620662447,
                0.3191123689278897604356718,
                0.5152486363581540919652907,
                0.6872929048116854701480198,
                0.8272013150697649931897947,
                0.9284348836635735173363911,
                0.9862838086968123388415973
            ],
            [
                0,
                0.2011940939974345223006283,
                0.3941513470775633698972074,
                0.5709721726085388475372267,
                0.7244177313601700474161861,
                0.8482065834104272162006483,
                0.9372733924007059043077589,
                0.9879925180204854284895657
            ],
            [
                0.0950125098376374401853193,
                0.2816035507792589132304605,
                0.4580167776572273863424194,
                0.6178762444026437484466718,
                0.7554044083550030338951012,
                0.8656312023878317438804679,
                0.9445750230732325760779884,
                0.9894009349916499325961542
            ]
        ];
        var weights = [
            [
                1
            ],
            [
                0.8888888888888888888888889,
                0.5555555555555555555555556
            ],
            [
                0.6521451548625461426269361,
                0.3478548451374538573730639
            ],
            [
                0.5688888888888888888888889,
                0.4786286704993664680412915,
                0.2369268850561890875142640
            ],
            [
                0.4679139345726910473898703,
                0.3607615730481386075698335,
                0.1713244923791703450402961
            ],
            [
                0.4179591836734693877551020,
                0.3818300505051189449503698,
                0.2797053914892766679014678,
                0.1294849661688696932706114
            ],
            [
                0.3626837833783619829651504,
                0.3137066458778872873379622,
                0.2223810344533744705443560,
                0.1012285362903762591525314
            ],
            [
                0.3302393550012597631645251,
                0.3123470770400028400686304,
                0.2606106964029354623187429,
                0.1806481606948574040584720,
                0.0812743883615744119718922
            ],
            [
                0.2955242247147528701738930,
                0.2692667193099963550912269,
                0.2190863625159820439955349,
                0.1494513491505805931457763,
                0.0666713443086881375935688
            ],
            [
                0.2729250867779006307144835,
                0.2628045445102466621806889,
                0.2331937645919904799185237,
                0.1862902109277342514260976,
                0.1255803694649046246346943,
                0.0556685671161736664827537
            ],
            [
                0.2491470458134027850005624,
                0.2334925365383548087608499,
                0.2031674267230659217490645,
                0.1600783285433462263346525,
                0.1069393259953184309602547,
                0.0471753363865118271946160
            ],
            [
                0.2325515532308739101945895,
                0.2262831802628972384120902,
                0.2078160475368885023125232,
                0.1781459807619457382800467,
                0.1388735102197872384636018,
                0.0921214998377284479144218,
                0.0404840047653158795200216
            ],
            [
                0.2152638534631577901958764,
                0.2051984637212956039659241,
                0.1855383974779378137417166,
                0.1572031671581935345696019,
                0.1215185706879031846894148,
                0.0801580871597602098056333,
                0.0351194603317518630318329
            ],
            [
                0.2025782419255612728806202,
                0.1984314853271115764561183,
                0.1861610000155622110268006,
                0.1662692058169939335532009,
                0.1395706779261543144478048,
                0.1071592204671719350118695,
                0.0703660474881081247092674,
                0.0307532419961172683546284
            ],
            [
                0.1894506104550684962853967,
                0.1826034150449235888667637,
                0.1691565193950025381893121,
                0.1495959888165767320815017,
                0.1246289712555338720524763,
                0.0951585116824927848099251,
                0.0622535239386478928628438,
                0.0271524594117540948517806
            ]
        ];
        var abs = Math.abs, sqrt = Math.sqrt, pow = Math.pow, log2 = Math.log2 || function(x) {
            return Math.log(x) * Math.LOG2E;
        }, EPSILON = 1e-12, MACHINE_EPSILON = 1.12e-16;
        function clamp(value, min, max) {
            return value < min ? min : value > max ? max : value;
        }
        function getDiscriminant(a, b, c) {
            function split(v) {
                var x = v * 134217729, y = v - x, hi = y + x, lo = v - hi;
                return [
                    hi,
                    lo
                ];
            }
            var D = b * b - a * c, E = b * b + a * c;
            if (abs(D) * 3 < E) {
                var ad = split(a), bd = split(b), cd = split(c), p = b * b, dp = bd[0] * bd[0] - p + 2 * bd[0] * bd[1] + bd[1] * bd[1], q = a * c, dq = ad[0] * cd[0] - q + ad[0] * cd[1] + ad[1] * cd[0] + ad[1] * cd[1];
                D = p - q + (dp - dq);
            }
            return D;
        }
        function getNormalizationFactor() {
            var norm = Math.max.apply(Math, arguments);
            return norm && (norm < 1e-8 || norm > 1e8) ? pow(2, -Math.round(log2(norm))) : 0;
        }
        return {
            EPSILON: EPSILON,
            MACHINE_EPSILON: MACHINE_EPSILON,
            CURVETIME_EPSILON: 1e-8,
            GEOMETRIC_EPSILON: 1e-7,
            TRIGONOMETRIC_EPSILON: 1e-8,
            ANGULAR_EPSILON: 1e-5,
            KAPPA: 4 * (sqrt(2) - 1) / 3,
            isZero: function(val) {
                return val >= -EPSILON && val <= EPSILON;
            },
            isMachineZero: function(val) {
                return val >= -MACHINE_EPSILON && val <= MACHINE_EPSILON;
            },
            clamp: clamp,
            integrate: function(f, a, b, n) {
                var x = abscissas[n - 2], w = weights[n - 2], A = (b - a) * 0.5, B = A + a, i = 0, m = n + 1 >> 1, sum = n & 1 ? w[i++] * f(B) : 0;
                while(i < m){
                    var Ax = A * x[i];
                    sum += w[i++] * (f(B + Ax) + f(B - Ax));
                }
                return A * sum;
            },
            findRoot: function(f, df, x, a, b, n, tolerance) {
                for(var i = 0; i < n; i++){
                    var fx = f(x), dx = fx / df(x), nx = x - dx;
                    if (abs(dx) < tolerance) {
                        x = nx;
                        break;
                    }
                    if (fx > 0) {
                        b = x;
                        x = nx <= a ? (a + b) * 0.5 : nx;
                    } else {
                        a = x;
                        x = nx >= b ? (a + b) * 0.5 : nx;
                    }
                }
                return clamp(x, a, b);
            },
            solveQuadratic: function(a, b, c, roots, min, max) {
                var x1, x2 = Infinity;
                if (abs(a) < EPSILON) {
                    if (abs(b) < EPSILON) return abs(c) < EPSILON ? -1 : 0;
                    x1 = -c / b;
                } else {
                    b *= -0.5;
                    var D = getDiscriminant(a, b, c);
                    if (D && abs(D) < MACHINE_EPSILON) {
                        var f = getNormalizationFactor(abs(a), abs(b), abs(c));
                        if (f) {
                            a *= f;
                            b *= f;
                            c *= f;
                            D = getDiscriminant(a, b, c);
                        }
                    }
                    if (D >= -MACHINE_EPSILON) {
                        var Q = D < 0 ? 0 : sqrt(D), R = b + (b < 0 ? -Q : Q);
                        if (R === 0) {
                            x1 = c / a;
                            x2 = -x1;
                        } else {
                            x1 = R / a;
                            x2 = c / R;
                        }
                    }
                }
                var count = 0, boundless = min == null, minB = min - EPSILON, maxB = max + EPSILON;
                if (isFinite(x1) && (boundless || x1 > minB && x1 < maxB)) roots[count++] = boundless ? x1 : clamp(x1, min, max);
                if (x2 !== x1 && isFinite(x2) && (boundless || x2 > minB && x2 < maxB)) roots[count++] = boundless ? x2 : clamp(x2, min, max);
                return count;
            },
            solveCubic: function(a, b, c, d, roots, min, max) {
                var f = getNormalizationFactor(abs(a), abs(b), abs(c), abs(d)), x, b1, c2, qd, q;
                if (f) {
                    a *= f;
                    b *= f;
                    c *= f;
                    d *= f;
                }
                function evaluate(x0) {
                    x = x0;
                    var tmp = a * x;
                    b1 = tmp + b;
                    c2 = b1 * x + c;
                    qd = (tmp + b1) * x + c2;
                    q = c2 * x + d;
                }
                if (abs(a) < EPSILON) {
                    a = b;
                    b1 = c;
                    c2 = d;
                    x = Infinity;
                } else if (abs(d) < EPSILON) {
                    b1 = b;
                    c2 = c;
                    x = 0;
                } else {
                    evaluate(-(b / a) / 3);
                    var t = q / a, r = pow(abs(t), 1 / 3), s = t < 0 ? -1 : 1, td = -qd / a, rd = td > 0 ? 1.324717957244746 * Math.max(r, sqrt(td)) : r, x0 = x - s * rd;
                    if (x0 !== x) {
                        do {
                            evaluate(x0);
                            x0 = qd === 0 ? x : x - q / qd / (1 + MACHINE_EPSILON);
                        }while (s * x0 > s * x);
                        if (abs(a) * x * x > abs(d / x)) {
                            c2 = -d / x;
                            b1 = (c2 - c) / x;
                        }
                    }
                }
                var count = Numerical.solveQuadratic(a, b1, c2, roots, min, max), boundless = min == null;
                if (isFinite(x) && (count === 0 || count > 0 && x !== roots[0] && x !== roots[1]) && (boundless || x > min - EPSILON && x < max + EPSILON)) roots[count++] = boundless ? x : clamp(x, min, max);
                return count;
            }
        };
    };
    var UID = {
        _id: 1,
        _pools: {},
        get: function(name) {
            if (name) {
                var pool = this._pools[name];
                if (!pool) pool = this._pools[name] = {
                    _id: 1
                };
                return pool._id++;
            } else return this._id++;
        }
    };
    var Point = Base.extend({
        _class: 'Point',
        _readIndex: true,
        initialize: function Point(arg0, arg1) {
            var type = typeof arg0, reading = this.__read, read = 0;
            if (type === 'number') {
                var hasY = typeof arg1 === 'number';
                this._set(arg0, hasY ? arg1 : arg0);
                if (reading) read = hasY ? 2 : 1;
            } else if (type === 'undefined' || arg0 === null) {
                this._set(0, 0);
                if (reading) read = arg0 === null ? 1 : 0;
            } else {
                var obj = type === 'string' ? arg0.split(/[\s,]+/) || [] : arg0;
                read = 1;
                if (Array.isArray(obj)) this._set(+obj[0], +(obj.length > 1 ? obj[1] : obj[0]));
                else if ('x' in obj) this._set(obj.x || 0, obj.y || 0);
                else if ('width' in obj) this._set(obj.width || 0, obj.height || 0);
                else if ('angle' in obj) {
                    this._set(obj.length || 0, 0);
                    this.setAngle(obj.angle || 0);
                } else {
                    this._set(0, 0);
                    read = 0;
                }
            }
            if (reading) this.__read = read;
            return this;
        },
        set: '#initialize',
        _set: function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        },
        equals: function(point) {
            return this === point || point && (this.x === point.x && this.y === point.y || Array.isArray(point) && this.x === point[0] && this.y === point[1]) || false;
        },
        clone: function() {
            return new Point(this.x, this.y);
        },
        toString: function() {
            var f = Formatter.instance;
            return '{ x: ' + f.number(this.x) + ', y: ' + f.number(this.y) + ' }';
        },
        _serialize: function(options) {
            var f = options.formatter;
            return [
                f.number(this.x),
                f.number(this.y)
            ];
        },
        getLength: function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        setLength: function(length) {
            if (this.isZero()) {
                var angle = this._angle || 0;
                this._set(Math.cos(angle) * length, Math.sin(angle) * length);
            } else {
                var scale = length / this.getLength();
                if (Numerical.isZero(scale)) this.getAngle();
                this._set(this.x * scale, this.y * scale);
            }
        },
        getAngle: function() {
            return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
        },
        setAngle: function(angle) {
            this.setAngleInRadians.call(this, angle * Math.PI / 180);
        },
        getAngleInDegrees: '#getAngle',
        setAngleInDegrees: '#setAngle',
        getAngleInRadians: function() {
            if (!arguments.length) return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
            else {
                var point = Point.read(arguments), div = this.getLength() * point.getLength();
                if (Numerical.isZero(div)) return NaN;
                else {
                    var a = this.dot(point) / div;
                    return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
                }
            }
        },
        setAngleInRadians: function(angle) {
            this._angle = angle;
            if (!this.isZero()) {
                var length = this.getLength();
                this._set(Math.cos(angle) * length, Math.sin(angle) * length);
            }
        },
        getQuadrant: function() {
            return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
        }
    }, {
        beans: false,
        getDirectedAngle: function() {
            var point = Point.read(arguments);
            return Math.atan2(this.cross(point), this.dot(point)) * 180 / Math.PI;
        },
        getDistance: function() {
            var args = arguments, point = Point.read(args), x = point.x - this.x, y = point.y - this.y, d = x * x + y * y, squared = Base.read(args);
            return squared ? d : Math.sqrt(d);
        },
        normalize: function(length) {
            if (length === undefined) length = 1;
            var current = this.getLength(), scale = current !== 0 ? length / current : 0, point = new Point(this.x * scale, this.y * scale);
            if (scale >= 0) point._angle = this._angle;
            return point;
        },
        rotate: function(angle, center) {
            if (angle === 0) return this.clone();
            angle = angle * Math.PI / 180;
            var point = center ? this.subtract(center) : this, sin = Math.sin(angle), cos = Math.cos(angle);
            point = new Point(point.x * cos - point.y * sin, point.x * sin + point.y * cos);
            return center ? point.add(center) : point;
        },
        transform: function(matrix) {
            return matrix ? matrix._transformPoint(this) : this;
        },
        add: function() {
            var point = Point.read(arguments);
            return new Point(this.x + point.x, this.y + point.y);
        },
        subtract: function() {
            var point = Point.read(arguments);
            return new Point(this.x - point.x, this.y - point.y);
        },
        multiply: function() {
            var point = Point.read(arguments);
            return new Point(this.x * point.x, this.y * point.y);
        },
        divide: function() {
            var point = Point.read(arguments);
            return new Point(this.x / point.x, this.y / point.y);
        },
        modulo: function() {
            var point = Point.read(arguments);
            return new Point(this.x % point.x, this.y % point.y);
        },
        negate: function() {
            return new Point(-this.x, -this.y);
        },
        isInside: function() {
            return Rectangle.read(arguments).contains(this);
        },
        isClose: function() {
            var args = arguments, point = Point.read(args), tolerance = Base.read(args);
            return this.getDistance(point) <= tolerance;
        },
        isCollinear: function() {
            var point = Point.read(arguments);
            return Point.isCollinear(this.x, this.y, point.x, point.y);
        },
        isColinear: '#isCollinear',
        isOrthogonal: function() {
            var point = Point.read(arguments);
            return Point.isOrthogonal(this.x, this.y, point.x, point.y);
        },
        isZero: function() {
            var isZero = Numerical.isZero;
            return isZero(this.x) && isZero(this.y);
        },
        isNaN: function() {
            return isNaN(this.x) || isNaN(this.y);
        },
        isInQuadrant: function(q) {
            return this.x * (q > 1 && q < 4 ? -1 : 1) >= 0 && this.y * (q > 2 ? -1 : 1) >= 0;
        },
        dot: function() {
            var point = Point.read(arguments);
            return this.x * point.x + this.y * point.y;
        },
        cross: function() {
            var point = Point.read(arguments);
            return this.x * point.y - this.y * point.x;
        },
        project: function() {
            var point = Point.read(arguments), scale = point.isZero() ? 0 : this.dot(point) / point.dot(point);
            return new Point(point.x * scale, point.y * scale);
        },
        statics: {
            min: function() {
                var args = arguments, point1 = Point.read(args), point2 = Point.read(args);
                return new Point(Math.min(point1.x, point2.x), Math.min(point1.y, point2.y));
            },
            max: function() {
                var args = arguments, point1 = Point.read(args), point2 = Point.read(args);
                return new Point(Math.max(point1.x, point2.x), Math.max(point1.y, point2.y));
            },
            random: function() {
                return new Point(Math.random(), Math.random());
            },
            isCollinear: function(x1, y1, x2, y2) {
                return Math.abs(x1 * y2 - y1 * x2) <= Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2)) * 1e-8;
            },
            isOrthogonal: function(x1, y1, x2, y2) {
                return Math.abs(x1 * x2 + y1 * y2) <= Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2)) * 1e-8;
            }
        }
    }, Base.each([
        'round',
        'ceil',
        'floor',
        'abs'
    ], function(key) {
        var op = Math[key];
        this[key] = function() {
            return new Point(op(this.x), op(this.y));
        };
    }, {}));
    var LinkedPoint = Point.extend({
        initialize: function Point(x, y, owner, setter) {
            this._x = x;
            this._y = y;
            this._owner = owner;
            this._setter = setter;
        },
        _set: function(x, y, _dontNotify) {
            this._x = x;
            this._y = y;
            if (!_dontNotify) this._owner[this._setter](this);
            return this;
        },
        getX: function() {
            return this._x;
        },
        setX: function(x) {
            this._x = x;
            this._owner[this._setter](this);
        },
        getY: function() {
            return this._y;
        },
        setY: function(y) {
            this._y = y;
            this._owner[this._setter](this);
        },
        isSelected: function() {
            return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(selected) {
            this._owner._changeSelection(this._getSelection(), selected);
        },
        _getSelection: function() {
            return this._setter === 'setPosition' ? 4 : 0;
        }
    });
    var Size = Base.extend({
        _class: 'Size',
        _readIndex: true,
        initialize: function Size(arg0, arg1) {
            var type = typeof arg0, reading = this.__read, read = 0;
            if (type === 'number') {
                var hasHeight = typeof arg1 === 'number';
                this._set(arg0, hasHeight ? arg1 : arg0);
                if (reading) read = hasHeight ? 2 : 1;
            } else if (type === 'undefined' || arg0 === null) {
                this._set(0, 0);
                if (reading) read = arg0 === null ? 1 : 0;
            } else {
                var obj = type === 'string' ? arg0.split(/[\s,]+/) || [] : arg0;
                read = 1;
                if (Array.isArray(obj)) this._set(+obj[0], +(obj.length > 1 ? obj[1] : obj[0]));
                else if ('width' in obj) this._set(obj.width || 0, obj.height || 0);
                else if ('x' in obj) this._set(obj.x || 0, obj.y || 0);
                else {
                    this._set(0, 0);
                    read = 0;
                }
            }
            if (reading) this.__read = read;
            return this;
        },
        set: '#initialize',
        _set: function(width, height) {
            this.width = width;
            this.height = height;
            return this;
        },
        equals: function(size) {
            return size === this || size && (this.width === size.width && this.height === size.height || Array.isArray(size) && this.width === size[0] && this.height === size[1]) || false;
        },
        clone: function() {
            return new Size(this.width, this.height);
        },
        toString: function() {
            var f = Formatter.instance;
            return '{ width: ' + f.number(this.width) + ', height: ' + f.number(this.height) + ' }';
        },
        _serialize: function(options) {
            var f = options.formatter;
            return [
                f.number(this.width),
                f.number(this.height)
            ];
        },
        add: function() {
            var size = Size.read(arguments);
            return new Size(this.width + size.width, this.height + size.height);
        },
        subtract: function() {
            var size = Size.read(arguments);
            return new Size(this.width - size.width, this.height - size.height);
        },
        multiply: function() {
            var size = Size.read(arguments);
            return new Size(this.width * size.width, this.height * size.height);
        },
        divide: function() {
            var size = Size.read(arguments);
            return new Size(this.width / size.width, this.height / size.height);
        },
        modulo: function() {
            var size = Size.read(arguments);
            return new Size(this.width % size.width, this.height % size.height);
        },
        negate: function() {
            return new Size(-this.width, -this.height);
        },
        isZero: function() {
            var isZero = Numerical.isZero;
            return isZero(this.width) && isZero(this.height);
        },
        isNaN: function() {
            return isNaN(this.width) || isNaN(this.height);
        },
        statics: {
            min: function(size1, size2) {
                return new Size(Math.min(size1.width, size2.width), Math.min(size1.height, size2.height));
            },
            max: function(size1, size2) {
                return new Size(Math.max(size1.width, size2.width), Math.max(size1.height, size2.height));
            },
            random: function() {
                return new Size(Math.random(), Math.random());
            }
        }
    }, Base.each([
        'round',
        'ceil',
        'floor',
        'abs'
    ], function(key) {
        var op = Math[key];
        this[key] = function() {
            return new Size(op(this.width), op(this.height));
        };
    }, {}));
    var LinkedSize = Size.extend({
        initialize: function Size(width, height, owner, setter) {
            this._width = width;
            this._height = height;
            this._owner = owner;
            this._setter = setter;
        },
        _set: function(width, height, _dontNotify) {
            this._width = width;
            this._height = height;
            if (!_dontNotify) this._owner[this._setter](this);
            return this;
        },
        getWidth: function() {
            return this._width;
        },
        setWidth: function(width) {
            this._width = width;
            this._owner[this._setter](this);
        },
        getHeight: function() {
            return this._height;
        },
        setHeight: function(height) {
            this._height = height;
            this._owner[this._setter](this);
        }
    });
    var Rectangle = Base.extend({
        _class: 'Rectangle',
        _readIndex: true,
        beans: true,
        initialize: function Rectangle(arg0, arg1, arg2, arg3) {
            var args = arguments, type = typeof arg0, read;
            if (type === 'number') {
                this._set(arg0, arg1, arg2, arg3);
                read = 4;
            } else if (type === 'undefined' || arg0 === null) {
                this._set(0, 0, 0, 0);
                read = arg0 === null ? 1 : 0;
            } else if (args.length === 1) {
                if (Array.isArray(arg0)) {
                    this._set.apply(this, arg0);
                    read = 1;
                } else if (arg0.x !== undefined || arg0.width !== undefined) {
                    this._set(arg0.x || 0, arg0.y || 0, arg0.width || 0, arg0.height || 0);
                    read = 1;
                } else if (arg0.from === undefined && arg0.to === undefined) {
                    this._set(0, 0, 0, 0);
                    if (Base.readSupported(args, this)) read = 1;
                }
            }
            if (read === undefined) {
                var frm = Point.readNamed(args, 'from'), next = Base.peek(args), x = frm.x, y = frm.y, width, height;
                if (next && next.x !== undefined || Base.hasNamed(args, 'to')) {
                    var to = Point.readNamed(args, 'to');
                    width = to.x - x;
                    height = to.y - y;
                    if (width < 0) {
                        x = to.x;
                        width = -width;
                    }
                    if (height < 0) {
                        y = to.y;
                        height = -height;
                    }
                } else {
                    var size = Size.read(args);
                    width = size.width;
                    height = size.height;
                }
                this._set(x, y, width, height);
                read = args.__index;
            }
            var filtered = args.__filtered;
            if (filtered) this.__filtered = filtered;
            if (this.__read) this.__read = read;
            return this;
        },
        set: '#initialize',
        _set: function(x, y, width, height) {
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
            return this;
        },
        clone: function() {
            return new Rectangle(this.x, this.y, this.width, this.height);
        },
        equals: function(rect) {
            var rt = Base.isPlainValue(rect) ? Rectangle.read(arguments) : rect;
            return rt === this || rt && this.x === rt.x && this.y === rt.y && this.width === rt.width && this.height === rt.height || false;
        },
        toString: function() {
            var f = Formatter.instance;
            return '{ x: ' + f.number(this.x) + ', y: ' + f.number(this.y) + ', width: ' + f.number(this.width) + ', height: ' + f.number(this.height) + ' }';
        },
        _serialize: function(options) {
            var f = options.formatter;
            return [
                f.number(this.x),
                f.number(this.y),
                f.number(this.width),
                f.number(this.height)
            ];
        },
        getPoint: function(_dontLink) {
            var ctor = _dontLink ? Point : LinkedPoint;
            return new ctor(this.x, this.y, this, 'setPoint');
        },
        setPoint: function() {
            var point = Point.read(arguments);
            this.x = point.x;
            this.y = point.y;
        },
        getSize: function(_dontLink) {
            var ctor = _dontLink ? Size : LinkedSize;
            return new ctor(this.width, this.height, this, 'setSize');
        },
        _fw: 1,
        _fh: 1,
        setSize: function() {
            var size = Size.read(arguments), sx = this._sx, sy = this._sy, w = size.width, h = size.height;
            if (sx) this.x += (this.width - w) * sx;
            if (sy) this.y += (this.height - h) * sy;
            this.width = w;
            this.height = h;
            this._fw = this._fh = 1;
        },
        getLeft: function() {
            return this.x;
        },
        setLeft: function(left) {
            if (!this._fw) {
                var amount = left - this.x;
                this.width -= this._sx === 0.5 ? amount * 2 : amount;
            }
            this.x = left;
            this._sx = this._fw = 0;
        },
        getTop: function() {
            return this.y;
        },
        setTop: function(top) {
            if (!this._fh) {
                var amount = top - this.y;
                this.height -= this._sy === 0.5 ? amount * 2 : amount;
            }
            this.y = top;
            this._sy = this._fh = 0;
        },
        getRight: function() {
            return this.x + this.width;
        },
        setRight: function(right) {
            if (!this._fw) {
                var amount = right - this.x;
                this.width = this._sx === 0.5 ? amount * 2 : amount;
            }
            this.x = right - this.width;
            this._sx = 1;
            this._fw = 0;
        },
        getBottom: function() {
            return this.y + this.height;
        },
        setBottom: function(bottom) {
            if (!this._fh) {
                var amount = bottom - this.y;
                this.height = this._sy === 0.5 ? amount * 2 : amount;
            }
            this.y = bottom - this.height;
            this._sy = 1;
            this._fh = 0;
        },
        getCenterX: function() {
            return this.x + this.width / 2;
        },
        setCenterX: function(x) {
            if (this._fw || this._sx === 0.5) this.x = x - this.width / 2;
            else {
                if (this._sx) this.x += (x - this.x) * 2 * this._sx;
                this.width = (x - this.x) * 2;
            }
            this._sx = 0.5;
            this._fw = 0;
        },
        getCenterY: function() {
            return this.y + this.height / 2;
        },
        setCenterY: function(y) {
            if (this._fh || this._sy === 0.5) this.y = y - this.height / 2;
            else {
                if (this._sy) this.y += (y - this.y) * 2 * this._sy;
                this.height = (y - this.y) * 2;
            }
            this._sy = 0.5;
            this._fh = 0;
        },
        getCenter: function(_dontLink) {
            var ctor = _dontLink ? Point : LinkedPoint;
            return new ctor(this.getCenterX(), this.getCenterY(), this, 'setCenter');
        },
        setCenter: function() {
            var point = Point.read(arguments);
            this.setCenterX(point.x);
            this.setCenterY(point.y);
            return this;
        },
        getArea: function() {
            return this.width * this.height;
        },
        isEmpty: function() {
            return this.width === 0 || this.height === 0;
        },
        contains: function(arg) {
            return arg && arg.width !== undefined || (Array.isArray(arg) ? arg : arguments).length === 4 ? this._containsRectangle(Rectangle.read(arguments)) : this._containsPoint(Point.read(arguments));
        },
        _containsPoint: function(point) {
            var x = point.x, y = point.y;
            return x >= this.x && y >= this.y && x <= this.x + this.width && y <= this.y + this.height;
        },
        _containsRectangle: function(rect) {
            var x = rect.x, y = rect.y;
            return x >= this.x && y >= this.y && x + rect.width <= this.x + this.width && y + rect.height <= this.y + this.height;
        },
        intersects: function() {
            var rect = Rectangle.read(arguments), epsilon = Base.read(arguments) || 0;
            return rect.x + rect.width > this.x - epsilon && rect.y + rect.height > this.y - epsilon && rect.x < this.x + this.width + epsilon && rect.y < this.y + this.height + epsilon;
        },
        intersect: function() {
            var rect = Rectangle.read(arguments), x1 = Math.max(this.x, rect.x), y1 = Math.max(this.y, rect.y), x2 = Math.min(this.x + this.width, rect.x + rect.width), y2 = Math.min(this.y + this.height, rect.y + rect.height);
            return new Rectangle(x1, y1, x2 - x1, y2 - y1);
        },
        unite: function() {
            var rect = Rectangle.read(arguments), x1 = Math.min(this.x, rect.x), y1 = Math.min(this.y, rect.y), x2 = Math.max(this.x + this.width, rect.x + rect.width), y2 = Math.max(this.y + this.height, rect.y + rect.height);
            return new Rectangle(x1, y1, x2 - x1, y2 - y1);
        },
        include: function() {
            var point = Point.read(arguments);
            var x1 = Math.min(this.x, point.x), y1 = Math.min(this.y, point.y), x2 = Math.max(this.x + this.width, point.x), y2 = Math.max(this.y + this.height, point.y);
            return new Rectangle(x1, y1, x2 - x1, y2 - y1);
        },
        expand: function() {
            var amount = Size.read(arguments), hor = amount.width, ver = amount.height;
            return new Rectangle(this.x - hor / 2, this.y - ver / 2, this.width + hor, this.height + ver);
        },
        scale: function(hor, ver) {
            return this.expand(this.width * hor - this.width, this.height * (ver === undefined ? hor : ver) - this.height);
        }
    }, Base.each([
        [
            'Top',
            'Left'
        ],
        [
            'Top',
            'Right'
        ],
        [
            'Bottom',
            'Left'
        ],
        [
            'Bottom',
            'Right'
        ],
        [
            'Left',
            'Center'
        ],
        [
            'Top',
            'Center'
        ],
        [
            'Right',
            'Center'
        ],
        [
            'Bottom',
            'Center'
        ]
    ], function(parts, index) {
        var part = parts.join(''), xFirst = /^[RL]/.test(part);
        if (index >= 4) parts[1] += xFirst ? 'Y' : 'X';
        var x = parts[xFirst ? 0 : 1], y = parts[xFirst ? 1 : 0], getX = 'get' + x, getY = 'get' + y, setX = 'set' + x, setY = 'set' + y, get = 'get' + part, set = 'set' + part;
        this[get] = function(_dontLink) {
            var ctor = _dontLink ? Point : LinkedPoint;
            return new ctor(this[getX](), this[getY](), this, set);
        };
        this[set] = function() {
            var point = Point.read(arguments);
            this[setX](point.x);
            this[setY](point.y);
        };
    }, {
        beans: true
    }));
    var LinkedRectangle = Rectangle.extend({
        initialize: function Rectangle(x, y, width, height, owner, setter) {
            this._set(x, y, width, height, true);
            this._owner = owner;
            this._setter = setter;
        },
        _set: function(x, y, width, height, _dontNotify) {
            this._x = x;
            this._y = y;
            this._width = width;
            this._height = height;
            if (!_dontNotify) this._owner[this._setter](this);
            return this;
        }
    }, new function() {
        var proto = Rectangle.prototype;
        return Base.each([
            'x',
            'y',
            'width',
            'height'
        ], function(key) {
            var part = Base.capitalize(key), internal = '_' + key;
            this['get' + part] = function() {
                return this[internal];
            };
            this['set' + part] = function(value) {
                this[internal] = value;
                if (!this._dontNotify) this._owner[this._setter](this);
            };
        }, Base.each([
            'Point',
            'Size',
            'Center',
            'Left',
            'Top',
            'Right',
            'Bottom',
            'CenterX',
            'CenterY',
            'TopLeft',
            'TopRight',
            'BottomLeft',
            'BottomRight',
            'LeftCenter',
            'TopCenter',
            'RightCenter',
            'BottomCenter'
        ], function(key) {
            var name = 'set' + key;
            this[name] = function() {
                this._dontNotify = true;
                proto[name].apply(this, arguments);
                this._dontNotify = false;
                this._owner[this._setter](this);
            };
        }, {
            isSelected: function() {
                return !!(this._owner._selection & 2);
            },
            setSelected: function(selected) {
                var owner = this._owner;
                if (owner._changeSelection) owner._changeSelection(2, selected);
            }
        }));
    });
    var Matrix = Base.extend({
        _class: 'Matrix',
        initialize: function Matrix(arg, _dontNotify) {
            var args = arguments, count = args.length, ok = true;
            if (count >= 6) this._set.apply(this, args);
            else if (count === 1 || count === 2) {
                if (arg instanceof Matrix) this._set(arg._a, arg._b, arg._c, arg._d, arg._tx, arg._ty, _dontNotify);
                else if (Array.isArray(arg)) this._set.apply(this, _dontNotify ? arg.concat([
                    _dontNotify
                ]) : arg);
                else ok = false;
            } else if (!count) this.reset();
            else ok = false;
            if (!ok) throw new Error('Unsupported matrix parameters');
            return this;
        },
        set: '#initialize',
        _set: function(a, b, c, d, tx, ty, _dontNotify) {
            this._a = a;
            this._b = b;
            this._c = c;
            this._d = d;
            this._tx = tx;
            this._ty = ty;
            if (!_dontNotify) this._changed();
            return this;
        },
        _serialize: function(options, dictionary) {
            return Base.serialize(this.getValues(), options, true, dictionary);
        },
        _changed: function() {
            var owner = this._owner;
            if (owner) {
                if (owner._applyMatrix) owner.transform(null, true);
                else owner._changed(25);
            }
        },
        clone: function() {
            return new Matrix(this._a, this._b, this._c, this._d, this._tx, this._ty);
        },
        equals: function(mx) {
            return mx === this || mx && this._a === mx._a && this._b === mx._b && this._c === mx._c && this._d === mx._d && this._tx === mx._tx && this._ty === mx._ty;
        },
        toString: function() {
            var f = Formatter.instance;
            return '[[' + [
                f.number(this._a),
                f.number(this._c),
                f.number(this._tx)
            ].join(', ') + '], [' + [
                f.number(this._b),
                f.number(this._d),
                f.number(this._ty)
            ].join(', ') + ']]';
        },
        reset: function(_dontNotify) {
            this._a = this._d = 1;
            this._b = this._c = this._tx = this._ty = 0;
            if (!_dontNotify) this._changed();
            return this;
        },
        apply: function(recursively, _setApplyMatrix) {
            var owner = this._owner;
            if (owner) {
                owner.transform(null, Base.pick(recursively, true), _setApplyMatrix);
                return this.isIdentity();
            }
            return false;
        },
        translate: function() {
            var point = Point.read(arguments), x = point.x, y = point.y;
            this._tx += x * this._a + y * this._c;
            this._ty += x * this._b + y * this._d;
            this._changed();
            return this;
        },
        scale: function() {
            var args = arguments, scale = Point.read(args), center = Point.read(args, 0, {
                readNull: true
            });
            if (center) this.translate(center);
            this._a *= scale.x;
            this._b *= scale.x;
            this._c *= scale.y;
            this._d *= scale.y;
            if (center) this.translate(center.negate());
            this._changed();
            return this;
        },
        rotate: function(angle) {
            angle *= Math.PI / 180;
            var center = Point.read(arguments, 1), x = center.x, y = center.y, cos = Math.cos(angle), sin = Math.sin(angle), tx = x - x * cos + y * sin, ty = y - x * sin - y * cos, a = this._a, b = this._b, c = this._c, d = this._d;
            this._a = cos * a + sin * c;
            this._b = cos * b + sin * d;
            this._c = -sin * a + cos * c;
            this._d = -sin * b + cos * d;
            this._tx += tx * a + ty * c;
            this._ty += tx * b + ty * d;
            this._changed();
            return this;
        },
        shear: function() {
            var args = arguments, shear = Point.read(args), center = Point.read(args, 0, {
                readNull: true
            });
            if (center) this.translate(center);
            var a = this._a, b = this._b;
            this._a += shear.y * this._c;
            this._b += shear.y * this._d;
            this._c += shear.x * a;
            this._d += shear.x * b;
            if (center) this.translate(center.negate());
            this._changed();
            return this;
        },
        skew: function() {
            var args = arguments, skew = Point.read(args), center = Point.read(args, 0, {
                readNull: true
            }), toRadians = Math.PI / 180, shear = new Point(Math.tan(skew.x * toRadians), Math.tan(skew.y * toRadians));
            return this.shear(shear, center);
        },
        append: function(mx, _dontNotify) {
            if (mx) {
                var a1 = this._a, b1 = this._b, c1 = this._c, d1 = this._d, a2 = mx._a, b2 = mx._c, c2 = mx._b, d2 = mx._d, tx2 = mx._tx, ty2 = mx._ty;
                this._a = a2 * a1 + c2 * c1;
                this._c = b2 * a1 + d2 * c1;
                this._b = a2 * b1 + c2 * d1;
                this._d = b2 * b1 + d2 * d1;
                this._tx += tx2 * a1 + ty2 * c1;
                this._ty += tx2 * b1 + ty2 * d1;
                if (!_dontNotify) this._changed();
            }
            return this;
        },
        prepend: function(mx, _dontNotify) {
            if (mx) {
                var a1 = this._a, b1 = this._b, c1 = this._c, d1 = this._d, tx1 = this._tx, ty1 = this._ty, a2 = mx._a, b2 = mx._c, c2 = mx._b, d2 = mx._d, tx2 = mx._tx, ty2 = mx._ty;
                this._a = a2 * a1 + b2 * b1;
                this._c = a2 * c1 + b2 * d1;
                this._b = c2 * a1 + d2 * b1;
                this._d = c2 * c1 + d2 * d1;
                this._tx = a2 * tx1 + b2 * ty1 + tx2;
                this._ty = c2 * tx1 + d2 * ty1 + ty2;
                if (!_dontNotify) this._changed();
            }
            return this;
        },
        appended: function(mx) {
            return this.clone().append(mx);
        },
        prepended: function(mx) {
            return this.clone().prepend(mx);
        },
        invert: function() {
            var a = this._a, b = this._b, c = this._c, d = this._d, tx = this._tx, ty = this._ty, det = a * d - b * c, res = null;
            if (det && !isNaN(det) && isFinite(tx) && isFinite(ty)) {
                this._a = d / det;
                this._b = -b / det;
                this._c = -c / det;
                this._d = a / det;
                this._tx = (c * ty - d * tx) / det;
                this._ty = (b * tx - a * ty) / det;
                res = this;
            }
            return res;
        },
        inverted: function() {
            return this.clone().invert();
        },
        concatenate: '#append',
        preConcatenate: '#prepend',
        chain: '#appended',
        _shiftless: function() {
            return new Matrix(this._a, this._b, this._c, this._d, 0, 0);
        },
        _orNullIfIdentity: function() {
            return this.isIdentity() ? null : this;
        },
        isIdentity: function() {
            return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
        },
        isInvertible: function() {
            var det = this._a * this._d - this._c * this._b;
            return det && !isNaN(det) && isFinite(this._tx) && isFinite(this._ty);
        },
        isSingular: function() {
            return !this.isInvertible();
        },
        transform: function(src, dst, count) {
            return arguments.length < 3 ? this._transformPoint(Point.read(arguments)) : this._transformCoordinates(src, dst, count);
        },
        _transformPoint: function(point, dest, _dontNotify) {
            var x = point.x, y = point.y;
            if (!dest) dest = new Point();
            return dest._set(x * this._a + y * this._c + this._tx, x * this._b + y * this._d + this._ty, _dontNotify);
        },
        _transformCoordinates: function(src, dst, count) {
            for(var i = 0, max = 2 * count; i < max; i += 2){
                var x = src[i], y = src[i + 1];
                dst[i] = x * this._a + y * this._c + this._tx;
                dst[i + 1] = x * this._b + y * this._d + this._ty;
            }
            return dst;
        },
        _transformCorners: function(rect) {
            var x1 = rect.x, y1 = rect.y, x2 = x1 + rect.width, y2 = y1 + rect.height, coords = [
                x1,
                y1,
                x2,
                y1,
                x2,
                y2,
                x1,
                y2
            ];
            return this._transformCoordinates(coords, coords, 4);
        },
        _transformBounds: function(bounds, dest, _dontNotify) {
            var coords = this._transformCorners(bounds), min = coords.slice(0, 2), max = min.slice();
            for(var i = 2; i < 8; i++){
                var val = coords[i], j = i & 1;
                if (val < min[j]) min[j] = val;
                else if (val > max[j]) max[j] = val;
            }
            if (!dest) dest = new Rectangle();
            return dest._set(min[0], min[1], max[0] - min[0], max[1] - min[1], _dontNotify);
        },
        inverseTransform: function() {
            return this._inverseTransform(Point.read(arguments));
        },
        _inverseTransform: function(point, dest, _dontNotify) {
            var a = this._a, b = this._b, c = this._c, d = this._d, tx = this._tx, ty = this._ty, det = a * d - b * c, res = null;
            if (det && !isNaN(det) && isFinite(tx) && isFinite(ty)) {
                var x = point.x - this._tx, y = point.y - this._ty;
                if (!dest) dest = new Point();
                res = dest._set((x * d - y * c) / det, (y * a - x * b) / det, _dontNotify);
            }
            return res;
        },
        decompose: function() {
            var a = this._a, b = this._b, c = this._c, d = this._d, det = a * d - b * c, sqrt = Math.sqrt, atan2 = Math.atan2, degrees = 180 / Math.PI, rotate, scale, skew;
            if (a !== 0 || b !== 0) {
                var r = sqrt(a * a + b * b);
                rotate = Math.acos(a / r) * (b > 0 ? 1 : -1);
                scale = [
                    r,
                    det / r
                ];
                skew = [
                    atan2(a * c + b * d, r * r),
                    0
                ];
            } else if (c !== 0 || d !== 0) {
                var s = sqrt(c * c + d * d);
                rotate = Math.asin(c / s) * (d > 0 ? 1 : -1);
                scale = [
                    det / s,
                    s
                ];
                skew = [
                    0,
                    atan2(a * c + b * d, s * s)
                ];
            } else {
                rotate = 0;
                skew = scale = [
                    0,
                    0
                ];
            }
            return {
                translation: this.getTranslation(),
                rotation: rotate * degrees,
                scaling: new Point(scale),
                skewing: new Point(skew[0] * degrees, skew[1] * degrees)
            };
        },
        getValues: function() {
            return [
                this._a,
                this._b,
                this._c,
                this._d,
                this._tx,
                this._ty
            ];
        },
        getTranslation: function() {
            return new Point(this._tx, this._ty);
        },
        getScaling: function() {
            return this.decompose().scaling;
        },
        getRotation: function() {
            return this.decompose().rotation;
        },
        applyToContext: function(ctx) {
            if (!this.isIdentity()) ctx.transform(this._a, this._b, this._c, this._d, this._tx, this._ty);
        }
    }, Base.each([
        'a',
        'b',
        'c',
        'd',
        'tx',
        'ty'
    ], function(key) {
        var part = Base.capitalize(key), prop = '_' + key;
        this['get' + part] = function() {
            return this[prop];
        };
        this['set' + part] = function(value) {
            this[prop] = value;
            this._changed();
        };
    }, {}));
    var Line = Base.extend({
        _class: 'Line',
        initialize: function Line(arg0, arg1, arg2, arg3, arg4) {
            var asVector = false;
            if (arguments.length >= 4) {
                this._px = arg0;
                this._py = arg1;
                this._vx = arg2;
                this._vy = arg3;
                asVector = arg4;
            } else {
                this._px = arg0.x;
                this._py = arg0.y;
                this._vx = arg1.x;
                this._vy = arg1.y;
                asVector = arg2;
            }
            if (!asVector) {
                this._vx -= this._px;
                this._vy -= this._py;
            }
        },
        getPoint: function() {
            return new Point(this._px, this._py);
        },
        getVector: function() {
            return new Point(this._vx, this._vy);
        },
        getLength: function() {
            return this.getVector().getLength();
        },
        intersect: function(line, isInfinite) {
            return Line.intersect(this._px, this._py, this._vx, this._vy, line._px, line._py, line._vx, line._vy, true, isInfinite);
        },
        getSide: function(point, isInfinite) {
            return Line.getSide(this._px, this._py, this._vx, this._vy, point.x, point.y, true, isInfinite);
        },
        getDistance: function(point) {
            return Math.abs(this.getSignedDistance(point));
        },
        getSignedDistance: function(point) {
            return Line.getSignedDistance(this._px, this._py, this._vx, this._vy, point.x, point.y, true);
        },
        isCollinear: function(line) {
            return Point.isCollinear(this._vx, this._vy, line._vx, line._vy);
        },
        isOrthogonal: function(line) {
            return Point.isOrthogonal(this._vx, this._vy, line._vx, line._vy);
        },
        statics: {
            intersect: function(p1x, p1y, v1x, v1y, p2x, p2y, v2x, v2y, asVector, isInfinite) {
                if (!asVector) {
                    v1x -= p1x;
                    v1y -= p1y;
                    v2x -= p2x;
                    v2y -= p2y;
                }
                var cross = v1x * v2y - v1y * v2x;
                if (!Numerical.isMachineZero(cross)) {
                    var dx = p1x - p2x, dy = p1y - p2y, u1 = (v2x * dy - v2y * dx) / cross, u2 = (v1x * dy - v1y * dx) / cross, epsilon = 1e-12, uMin = -epsilon, uMax = 1 + epsilon;
                    if (isInfinite || uMin < u1 && u1 < uMax && uMin < u2 && u2 < uMax) {
                        if (!isInfinite) u1 = u1 <= 0 ? 0 : u1 >= 1 ? 1 : u1;
                        return new Point(p1x + u1 * v1x, p1y + u1 * v1y);
                    }
                }
            },
            getSide: function(px, py, vx, vy, x, y, asVector, isInfinite) {
                if (!asVector) {
                    vx -= px;
                    vy -= py;
                }
                var v2x = x - px, v2y = y - py, ccw = v2x * vy - v2y * vx;
                if (!isInfinite && Numerical.isMachineZero(ccw)) {
                    ccw = (v2x * vx + v2x * vx) / (vx * vx + vy * vy);
                    if (ccw >= 0 && ccw <= 1) ccw = 0;
                }
                return ccw < 0 ? -1 : ccw > 0 ? 1 : 0;
            },
            getSignedDistance: function(px, py, vx, vy, x, y, asVector) {
                if (!asVector) {
                    vx -= px;
                    vy -= py;
                }
                return vx === 0 ? vy > 0 ? x - px : px - x : vy === 0 ? vx < 0 ? y - py : py - y : ((x - px) * vy - (y - py) * vx) / (vy > vx ? vy * Math.sqrt(1 + vx * vx / (vy * vy)) : vx * Math.sqrt(1 + vy * vy / (vx * vx)));
            },
            getDistance: function(px, py, vx, vy, x, y, asVector) {
                return Math.abs(Line.getSignedDistance(px, py, vx, vy, x, y, asVector));
            }
        }
    });
    var Project = PaperScopeItem.extend({
        _class: 'Project',
        _list: 'projects',
        _reference: 'project',
        _compactSerialize: true,
        initialize: function Project(element) {
            PaperScopeItem.call(this, true);
            this._children = [];
            this._namedChildren = {};
            this._activeLayer = null;
            this._currentStyle = new Style(null, null, this);
            this._view = View.create(this, element || CanvasProvider.getCanvas(1, 1));
            this._selectionItems = {};
            this._selectionCount = 0;
            this._updateVersion = 0;
        },
        _serialize: function(options, dictionary) {
            return Base.serialize(this._children, options, true, dictionary);
        },
        _changed: function(flags, item) {
            if (flags & 1) {
                var view = this._view;
                if (view) {
                    view._needsUpdate = true;
                    if (!view._requested && view._autoUpdate) view.requestUpdate();
                }
            }
            var changes = this._changes;
            if (changes && item) {
                var changesById = this._changesById, id = item._id, entry = changesById[id];
                if (entry) entry.flags |= flags;
                else changes.push(changesById[id] = {
                    item: item,
                    flags: flags
                });
            }
        },
        clear: function() {
            var children = this._children;
            for(var i = children.length - 1; i >= 0; i--)children[i].remove();
        },
        isEmpty: function() {
            return !this._children.length;
        },
        remove: function remove() {
            if (!remove.base.call(this)) return false;
            if (this._view) this._view.remove();
            return true;
        },
        getView: function() {
            return this._view;
        },
        getCurrentStyle: function() {
            return this._currentStyle;
        },
        setCurrentStyle: function(style) {
            this._currentStyle.set(style);
        },
        getIndex: function() {
            return this._index;
        },
        getOptions: function() {
            return this._scope.settings;
        },
        getLayers: function() {
            return this._children;
        },
        getActiveLayer: function() {
            return this._activeLayer || new Layer({
                project: this,
                insert: true
            });
        },
        getSymbolDefinitions: function() {
            var definitions = [], ids = {};
            this.getItems({
                class: SymbolItem,
                match: function(item) {
                    var definition = item._definition, id = definition._id;
                    if (!ids[id]) {
                        ids[id] = true;
                        definitions.push(definition);
                    }
                    return false;
                }
            });
            return definitions;
        },
        getSymbols: 'getSymbolDefinitions',
        getSelectedItems: function() {
            var selectionItems = this._selectionItems, items = [];
            for(var id in selectionItems){
                var item = selectionItems[id], selection = item._selection;
                if (selection & 1 && item.isInserted()) items.push(item);
                else if (!selection) this._updateSelection(item);
            }
            return items;
        },
        _updateSelection: function(item) {
            var id = item._id, selectionItems = this._selectionItems;
            if (item._selection) {
                if (selectionItems[id] !== item) {
                    this._selectionCount++;
                    selectionItems[id] = item;
                }
            } else if (selectionItems[id] === item) {
                this._selectionCount--;
                delete selectionItems[id];
            }
        },
        selectAll: function() {
            var children = this._children;
            for(var i = 0, l = children.length; i < l; i++)children[i].setFullySelected(true);
        },
        deselectAll: function() {
            var selectionItems = this._selectionItems;
            for(var i in selectionItems)selectionItems[i].setFullySelected(false);
        },
        addLayer: function(layer) {
            return this.insertLayer(undefined, layer);
        },
        insertLayer: function(index, layer) {
            if (layer instanceof Layer) {
                layer._remove(false, true);
                Base.splice(this._children, [
                    layer
                ], index, 0);
                layer._setProject(this, true);
                var name = layer._name;
                if (name) layer.setName(name);
                if (this._changes) layer._changed(5);
                if (!this._activeLayer) this._activeLayer = layer;
            } else layer = null;
            return layer;
        },
        _insertItem: function(index, item, _created) {
            item = this.insertLayer(index, item) || (this._activeLayer || this._insertItem(undefined, new Layer(Item.NO_INSERT), true)).insertChild(index, item);
            if (_created && item.activate) item.activate();
            return item;
        },
        getItems: function(options) {
            return Item._getItems(this, options);
        },
        getItem: function(options) {
            return Item._getItems(this, options, null, null, true)[0] || null;
        },
        importJSON: function(json) {
            this.activate();
            var layer = this._activeLayer;
            return Base.importJSON(json, layer && layer.isEmpty() && layer);
        },
        removeOn: function(type) {
            var sets = this._removeSets;
            if (sets) {
                if (type === 'mouseup') sets.mousedrag = null;
                var set = sets[type];
                if (set) {
                    for(var id in set){
                        var item = set[id];
                        for(var key in sets){
                            var other = sets[key];
                            if (other && other != set) delete other[item._id];
                        }
                        item.remove();
                    }
                    sets[type] = null;
                }
            }
        },
        draw: function(ctx, matrix, pixelRatio) {
            this._updateVersion++;
            ctx.save();
            matrix.applyToContext(ctx);
            var children = this._children, param = new Base({
                offset: new Point(0, 0),
                pixelRatio: pixelRatio,
                viewMatrix: matrix.isIdentity() ? null : matrix,
                matrices: [
                    new Matrix()
                ],
                updateMatrix: true
            });
            for(var i = 0, l = children.length; i < l; i++)children[i].draw(ctx, param);
            ctx.restore();
            if (this._selectionCount > 0) {
                ctx.save();
                ctx.strokeWidth = 1;
                var items = this._selectionItems, size = this._scope.settings.handleSize, version = this._updateVersion;
                for(var id in items)items[id]._drawSelection(ctx, matrix, size, items, version);
                ctx.restore();
            }
        }
    });
    var Item = Base.extend(Emitter, {
        statics: {
            extend: function extend(src) {
                if (src._serializeFields) src._serializeFields = Base.set({}, this.prototype._serializeFields, src._serializeFields);
                return extend.base.apply(this, arguments);
            },
            INSERT: {
                insert: true
            },
            NO_INSERT: {
                insert: false
            }
        },
        _class: 'Item',
        _name: null,
        _applyMatrix: true,
        _canApplyMatrix: true,
        _canScaleStroke: false,
        _pivot: null,
        _visible: true,
        _blendMode: 'normal',
        _opacity: 1,
        _locked: false,
        _guide: false,
        _clipMask: false,
        _selection: 0,
        _selectBounds: true,
        _selectChildren: false,
        _serializeFields: {
            name: null,
            applyMatrix: null,
            matrix: new Matrix(),
            pivot: null,
            visible: true,
            blendMode: 'normal',
            opacity: 1,
            locked: false,
            guide: false,
            clipMask: false,
            selected: false,
            data: {}
        },
        _prioritize: [
            'applyMatrix'
        ]
    }, new function() {
        var handlers = [
            'onMouseDown',
            'onMouseUp',
            'onMouseDrag',
            'onClick',
            'onDoubleClick',
            'onMouseMove',
            'onMouseEnter',
            'onMouseLeave'
        ];
        return Base.each(handlers, function(name) {
            this._events[name] = {
                install: function(type) {
                    this.getView()._countItemEvent(type, 1);
                },
                uninstall: function(type) {
                    this.getView()._countItemEvent(type, -1);
                }
            };
        }, {
            _events: {
                onFrame: {
                    install: function() {
                        this.getView()._animateItem(this, true);
                    },
                    uninstall: function() {
                        this.getView()._animateItem(this, false);
                    }
                },
                onLoad: {},
                onError: {}
            },
            statics: {
                _itemHandlers: handlers
            }
        });
    }, {
        initialize: function Item() {},
        _initialize: function(props, point) {
            var hasProps = props && Base.isPlainObject(props), internal = hasProps && props.internal === true, matrix = this._matrix = new Matrix(), project = hasProps && props.project || paper.project, settings = paper.settings;
            this._id = internal ? null : UID.get();
            this._parent = this._index = null;
            this._applyMatrix = this._canApplyMatrix && settings.applyMatrix;
            if (point) matrix.translate(point);
            matrix._owner = this;
            this._style = new Style(project._currentStyle, this, project);
            if (internal || hasProps && props.insert == false || !settings.insertItems && !(hasProps && props.insert == true)) this._setProject(project);
            else (hasProps && props.parent || project)._insertItem(undefined, this, true);
            if (hasProps && props !== Item.NO_INSERT && props !== Item.INSERT) this.set(props, {
                internal: true,
                insert: true,
                project: true,
                parent: true
            });
            return hasProps;
        },
        _serialize: function(options, dictionary) {
            var props = {}, that = this;
            function serialize(fields) {
                for(var key in fields){
                    var value = that[key];
                    if (!Base.equals(value, key === 'leading' ? fields.fontSize * 1.2 : fields[key])) props[key] = Base.serialize(value, options, key !== 'data', dictionary);
                }
            }
            serialize(this._serializeFields);
            if (!(this instanceof Group)) serialize(this._style._defaults);
            return [
                this._class,
                props
            ];
        },
        _changed: function(flags) {
            var symbol = this._symbol, cacheParent = this._parent || symbol, project = this._project;
            if (flags & 8) this._bounds = this._position = this._decomposed = undefined;
            if (flags & 16) this._globalMatrix = undefined;
            if (cacheParent && flags & 72) Item._clearBoundsCache(cacheParent);
            if (flags & 2) Item._clearBoundsCache(this);
            if (project) project._changed(flags, this);
            if (symbol) symbol._changed(flags);
        },
        getId: function() {
            return this._id;
        },
        getName: function() {
            return this._name;
        },
        setName: function(name) {
            if (this._name) this._removeNamed();
            if (name === +name + '') throw new Error('Names consisting only of numbers are not supported.');
            var owner = this._getOwner();
            if (name && owner) {
                var children = owner._children, namedChildren = owner._namedChildren;
                (namedChildren[name] = namedChildren[name] || []).push(this);
                if (!(name in children)) children[name] = this;
            }
            this._name = name || undefined;
            this._changed(256);
        },
        getStyle: function() {
            return this._style;
        },
        setStyle: function(style) {
            this.getStyle().set(style);
        }
    }, Base.each([
        'locked',
        'visible',
        'blendMode',
        'opacity',
        'guide'
    ], function(name) {
        var part = Base.capitalize(name), key = '_' + name, flags = {
            locked: 256,
            visible: 265
        };
        this['get' + part] = function() {
            return this[key];
        };
        this['set' + part] = function(value) {
            if (value != this[key]) {
                this[key] = value;
                this._changed(flags[name] || 257);
            }
        };
    }, {}), {
        beans: true,
        getSelection: function() {
            return this._selection;
        },
        setSelection: function(selection) {
            if (selection !== this._selection) {
                this._selection = selection;
                var project = this._project;
                if (project) {
                    project._updateSelection(this);
                    this._changed(257);
                }
            }
        },
        _changeSelection: function(flag, selected) {
            var selection = this._selection;
            this.setSelection(selected ? selection | flag : selection & ~flag);
        },
        isSelected: function() {
            if (this._selectChildren) {
                var children = this._children;
                for(var i = 0, l = children.length; i < l; i++)if (children[i].isSelected()) return true;
            }
            return !!(this._selection & 1);
        },
        setSelected: function(selected) {
            if (this._selectChildren) {
                var children = this._children;
                for(var i = 0, l = children.length; i < l; i++)children[i].setSelected(selected);
            }
            this._changeSelection(1, selected);
        },
        isFullySelected: function() {
            var children = this._children, selected = !!(this._selection & 1);
            if (children && selected) {
                for(var i = 0, l = children.length; i < l; i++)if (!children[i].isFullySelected()) return false;
                return true;
            }
            return selected;
        },
        setFullySelected: function(selected) {
            var children = this._children;
            if (children) for(var i = 0, l = children.length; i < l; i++)children[i].setFullySelected(selected);
            this._changeSelection(1, selected);
        },
        isClipMask: function() {
            return this._clipMask;
        },
        setClipMask: function(clipMask) {
            if (this._clipMask != (clipMask = !!clipMask)) {
                this._clipMask = clipMask;
                if (clipMask) {
                    this.setFillColor(null);
                    this.setStrokeColor(null);
                }
                this._changed(257);
                if (this._parent) this._parent._changed(2048);
            }
        },
        getData: function() {
            if (!this._data) this._data = {};
            return this._data;
        },
        setData: function(data) {
            this._data = data;
        },
        getPosition: function(_dontLink) {
            var ctor = _dontLink ? Point : LinkedPoint;
            var position = this._position || (this._position = this._getPositionFromBounds());
            return new ctor(position.x, position.y, this, 'setPosition');
        },
        setPosition: function() {
            this.translate(Point.read(arguments).subtract(this.getPosition(true)));
        },
        _getPositionFromBounds: function(bounds) {
            return this._pivot ? this._matrix._transformPoint(this._pivot) : (bounds || this.getBounds()).getCenter(true);
        },
        getPivot: function() {
            var pivot = this._pivot;
            return pivot ? new LinkedPoint(pivot.x, pivot.y, this, 'setPivot') : null;
        },
        setPivot: function() {
            this._pivot = Point.read(arguments, 0, {
                clone: true,
                readNull: true
            });
            this._position = undefined;
        }
    }, Base.each({
        getStrokeBounds: {
            stroke: true
        },
        getHandleBounds: {
            handle: true
        },
        getInternalBounds: {
            internal: true
        }
    }, function(options, key) {
        this[key] = function(matrix) {
            return this.getBounds(matrix, options);
        };
    }, {
        beans: true,
        getBounds: function(matrix, options) {
            var hasMatrix = options || matrix instanceof Matrix, opts = Base.set({}, hasMatrix ? options : matrix, this._boundsOptions);
            if (!opts.stroke || this.getStrokeScaling()) opts.cacheItem = this;
            var rect = this._getCachedBounds(hasMatrix && matrix, opts).rect;
            return !arguments.length ? new LinkedRectangle(rect.x, rect.y, rect.width, rect.height, this, 'setBounds') : rect;
        },
        setBounds: function() {
            var rect = Rectangle.read(arguments), bounds = this.getBounds(), _matrix = this._matrix, matrix = new Matrix(), center = rect.getCenter();
            matrix.translate(center);
            if (rect.width != bounds.width || rect.height != bounds.height) {
                if (!_matrix.isInvertible()) {
                    _matrix.set(_matrix._backup || new Matrix().translate(_matrix.getTranslation()));
                    bounds = this.getBounds();
                }
                matrix.scale(bounds.width !== 0 ? rect.width / bounds.width : 0, bounds.height !== 0 ? rect.height / bounds.height : 0);
            }
            center = bounds.getCenter();
            matrix.translate(-center.x, -center.y);
            this.transform(matrix);
        },
        _getBounds: function(matrix, options) {
            var children = this._children;
            if (!children || !children.length) return new Rectangle();
            Item._updateBoundsCache(this, options.cacheItem);
            return Item._getBounds(children, matrix, options);
        },
        _getBoundsCacheKey: function(options, internal) {
            return [
                options.stroke ? 1 : 0,
                options.handle ? 1 : 0,
                internal ? 1 : 0
            ].join('');
        },
        _getCachedBounds: function(matrix, options, noInternal) {
            matrix = matrix && matrix._orNullIfIdentity();
            var internal = options.internal && !noInternal, cacheItem = options.cacheItem, _matrix = internal ? null : this._matrix._orNullIfIdentity(), cacheKey = cacheItem && (!matrix || matrix.equals(_matrix)) && this._getBoundsCacheKey(options, internal), bounds = this._bounds;
            Item._updateBoundsCache(this._parent || this._symbol, cacheItem);
            if (cacheKey && bounds && cacheKey in bounds) {
                var cached = bounds[cacheKey];
                return {
                    rect: cached.rect.clone(),
                    nonscaling: cached.nonscaling
                };
            }
            var res = this._getBounds(matrix || _matrix, options), rect = res.rect || res, style = this._style, nonscaling = res.nonscaling || style.hasStroke() && !style.getStrokeScaling();
            if (cacheKey) {
                if (!bounds) this._bounds = bounds = {};
                var cached = bounds[cacheKey] = {
                    rect: rect.clone(),
                    nonscaling: nonscaling,
                    internal: internal
                };
            }
            return {
                rect: rect,
                nonscaling: nonscaling
            };
        },
        _getStrokeMatrix: function(matrix, options) {
            var parent = this.getStrokeScaling() ? null : options && options.internal ? this : this._parent || this._symbol && this._symbol._item, mx = parent ? parent.getViewMatrix().invert() : matrix;
            return mx && mx._shiftless();
        },
        statics: {
            _updateBoundsCache: function(parent, item) {
                if (parent && item) {
                    var id = item._id, ref = parent._boundsCache = parent._boundsCache || {
                        ids: {},
                        list: []
                    };
                    if (!ref.ids[id]) {
                        ref.list.push(item);
                        ref.ids[id] = item;
                    }
                }
            },
            _clearBoundsCache: function(item) {
                var cache = item._boundsCache;
                if (cache) {
                    item._bounds = item._position = item._boundsCache = undefined;
                    for(var i = 0, list = cache.list, l = list.length; i < l; i++){
                        var other = list[i];
                        if (other !== item) {
                            other._bounds = other._position = undefined;
                            if (other._boundsCache) Item._clearBoundsCache(other);
                        }
                    }
                }
            },
            _getBounds: function(items, matrix, options) {
                var x1 = Infinity, x2 = -x1, y1 = x1, y2 = x2, nonscaling = false;
                options = options || {};
                for(var i = 0, l = items.length; i < l; i++){
                    var item = items[i];
                    if (item._visible && !item.isEmpty(true)) {
                        var bounds = item._getCachedBounds(matrix && matrix.appended(item._matrix), options, true), rect = bounds.rect;
                        x1 = Math.min(rect.x, x1);
                        y1 = Math.min(rect.y, y1);
                        x2 = Math.max(rect.x + rect.width, x2);
                        y2 = Math.max(rect.y + rect.height, y2);
                        if (bounds.nonscaling) nonscaling = true;
                    }
                }
                return {
                    rect: isFinite(x1) ? new Rectangle(x1, y1, x2 - x1, y2 - y1) : new Rectangle(),
                    nonscaling: nonscaling
                };
            }
        }
    }), {
        beans: true,
        _decompose: function() {
            return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
            var decomposed = this._decompose();
            return decomposed ? decomposed.rotation : 0;
        },
        setRotation: function(rotation) {
            var current = this.getRotation();
            if (current != null && rotation != null) {
                var decomposed = this._decomposed;
                this.rotate(rotation - current);
                if (decomposed) {
                    decomposed.rotation = rotation;
                    this._decomposed = decomposed;
                }
            }
        },
        getScaling: function() {
            var decomposed = this._decompose(), s = decomposed && decomposed.scaling;
            return new LinkedPoint(s ? s.x : 1, s ? s.y : 1, this, 'setScaling');
        },
        setScaling: function() {
            var current = this.getScaling(), scaling = Point.read(arguments, 0, {
                clone: true,
                readNull: true
            });
            if (current && scaling && !current.equals(scaling)) {
                var rotation = this.getRotation(), decomposed = this._decomposed, matrix = new Matrix(), isZero = Numerical.isZero;
                if (isZero(current.x) || isZero(current.y)) {
                    matrix.translate(decomposed.translation);
                    if (rotation) matrix.rotate(rotation);
                    matrix.scale(scaling.x, scaling.y);
                    this._matrix.set(matrix);
                } else {
                    var center = this.getPosition(true);
                    matrix.translate(center);
                    if (rotation) matrix.rotate(rotation);
                    matrix.scale(scaling.x / current.x, scaling.y / current.y);
                    if (rotation) matrix.rotate(-rotation);
                    matrix.translate(center.negate());
                    this.transform(matrix);
                }
                if (decomposed) {
                    decomposed.scaling = scaling;
                    this._decomposed = decomposed;
                }
            }
        },
        getMatrix: function() {
            return this._matrix;
        },
        setMatrix: function() {
            var matrix = this._matrix;
            matrix.set.apply(matrix, arguments);
        },
        getGlobalMatrix: function(_dontClone) {
            var matrix = this._globalMatrix;
            if (matrix) {
                var parent = this._parent;
                var parents = [];
                while(parent){
                    if (!parent._globalMatrix) {
                        matrix = null;
                        for(var i = 0, l = parents.length; i < l; i++)parents[i]._globalMatrix = null;
                        break;
                    }
                    parents.push(parent);
                    parent = parent._parent;
                }
            }
            if (!matrix) {
                matrix = this._globalMatrix = this._matrix.clone();
                var parent = this._parent;
                if (parent) matrix.prepend(parent.getGlobalMatrix(true));
            }
            return _dontClone ? matrix : matrix.clone();
        },
        getViewMatrix: function() {
            return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
            return this._applyMatrix;
        },
        setApplyMatrix: function(apply) {
            if (this._applyMatrix = this._canApplyMatrix && !!apply) this.transform(null, true);
        },
        getTransformContent: '#getApplyMatrix',
        setTransformContent: '#setApplyMatrix'
    }, {
        getProject: function() {
            return this._project;
        },
        _setProject: function(project, installEvents) {
            if (this._project !== project) {
                if (this._project) this._installEvents(false);
                this._project = project;
                var children = this._children;
                for(var i = 0, l = children && children.length; i < l; i++)children[i]._setProject(project);
                installEvents = true;
            }
            if (installEvents) this._installEvents(true);
        },
        getView: function() {
            return this._project._view;
        },
        _installEvents: function _installEvents(install) {
            _installEvents.base.call(this, install);
            var children = this._children;
            for(var i = 0, l = children && children.length; i < l; i++)children[i]._installEvents(install);
        },
        getLayer: function() {
            var parent = this;
            while(parent = parent._parent){
                if (parent instanceof Layer) return parent;
            }
            return null;
        },
        getParent: function() {
            return this._parent;
        },
        setParent: function(item) {
            return item.addChild(this);
        },
        _getOwner: '#getParent',
        getChildren: function() {
            return this._children;
        },
        setChildren: function(items) {
            this.removeChildren();
            this.addChildren(items);
        },
        getFirstChild: function() {
            return this._children && this._children[0] || null;
        },
        getLastChild: function() {
            return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
            var owner = this._getOwner();
            return owner && owner._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
            var owner = this._getOwner();
            return owner && owner._children[this._index - 1] || null;
        },
        getIndex: function() {
            return this._index;
        },
        setIndex: function(index) {
            var parent = this._parent, children = parent && parent._children;
            if (children) parent.insertChildren(index in children ? index : undefined, [
                this
            ]);
        },
        equals: function(item) {
            return item === this || item && this._class === item._class && this._style.equals(item._style) && this._matrix.equals(item._matrix) && this._locked === item._locked && this._visible === item._visible && this._blendMode === item._blendMode && this._opacity === item._opacity && this._clipMask === item._clipMask && this._guide === item._guide && this._equals(item) || false;
        },
        _equals: function(item) {
            return Base.equals(this._children, item._children);
        },
        clone: function(options) {
            var copy = new this.constructor(Item.NO_INSERT), children = this._children, insert = Base.pick(options ? options.insert : undefined, options === undefined || options === true), deep = Base.pick(options ? options.deep : undefined, true);
            if (children) copy.copyAttributes(this);
            if (!children || deep) copy.copyContent(this);
            if (!children) copy.copyAttributes(this);
            if (insert) copy.insertAbove(this);
            var name = this._name, parent = this._parent;
            if (name && parent) {
                var children = parent._children, orig = name, i = 1;
                while(children[name])name = orig + ' ' + i++;
                if (name !== orig) copy.setName(name);
            }
            return copy;
        },
        copyContent: function(source) {
            var children = source._children;
            for(var i = 0, l = children && children.length; i < l; i++)this.addChild(children[i].clone(false), true);
        },
        copyAttributes: function(source, excludeMatrix) {
            this.setStyle(source._style);
            var keys = [
                '_locked',
                '_visible',
                '_blendMode',
                '_opacity',
                '_clipMask',
                '_guide'
            ];
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i];
                if (source.hasOwnProperty(key)) this[key] = source[key];
            }
            if (!excludeMatrix) this._matrix.set(source._matrix, true);
            this.setApplyMatrix(source._applyMatrix);
            this.setPivot(source._pivot);
            this.setSelection(source._selection);
            var data = source._data, name = source._name;
            this._data = data ? Base.clone(data) : null;
            if (name) this.setName(name);
        },
        rasterize: function(arg0, arg1) {
            var resolution, insert, raster;
            if (Base.isPlainObject(arg0)) {
                resolution = arg0.resolution;
                insert = arg0.insert;
                raster = arg0.raster;
            } else {
                resolution = arg0;
                insert = arg1;
            }
            if (!raster) raster = new Raster(Item.NO_INSERT);
            var bounds = this.getStrokeBounds(), scale = (resolution || this.getView().getResolution()) / 72, topLeft = bounds.getTopLeft().floor(), bottomRight = bounds.getBottomRight().ceil(), boundsSize = new Size(bottomRight.subtract(topLeft)), rasterSize = boundsSize.multiply(scale);
            raster.setSize(rasterSize, true);
            if (!rasterSize.isZero()) {
                var ctx = raster.getContext(true), matrix = new Matrix().scale(scale).translate(topLeft.negate());
                ctx.save();
                matrix.applyToContext(ctx);
                this.draw(ctx, new Base({
                    matrices: [
                        matrix
                    ]
                }));
                ctx.restore();
            }
            raster._matrix.set(new Matrix().translate(topLeft.add(boundsSize.divide(2))).scale(1 / scale));
            if (insert === undefined || insert) raster.insertAbove(this);
            return raster;
        },
        contains: function() {
            var matrix = this._matrix;
            return matrix.isInvertible() && !!this._contains(matrix._inverseTransform(Point.read(arguments)));
        },
        _contains: function(point) {
            var children = this._children;
            if (children) {
                for(var i = children.length - 1; i >= 0; i--){
                    if (children[i].contains(point)) return true;
                }
                return false;
            }
            return point.isInside(this.getInternalBounds());
        },
        isInside: function() {
            return Rectangle.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
            return new Path.Rectangle({
                rectangle: this.getInternalBounds(),
                matrix: this._matrix,
                insert: false
            });
        },
        intersects: function(item, _matrix) {
            if (!(item instanceof Item)) return false;
            return this._asPathItem().getIntersections(item._asPathItem(), null, _matrix, true).length > 0;
        }
    }, new function() {
        function hitTest() {
            var args = arguments;
            return this._hitTest(Point.read(args), HitResult.getOptions(args));
        }
        function hitTestAll() {
            var args = arguments, point = Point.read(args), options = HitResult.getOptions(args), all = [];
            this._hitTest(point, new Base({
                all: all
            }, options));
            return all;
        }
        function hitTestChildren(point, options, viewMatrix, _exclude) {
            var children = this._children;
            if (children) for(var i = children.length - 1; i >= 0; i--){
                var child = children[i];
                var res = child !== _exclude && child._hitTest(point, options, viewMatrix);
                if (res && !options.all) return res;
            }
            return null;
        }
        Project.inject({
            hitTest: hitTest,
            hitTestAll: hitTestAll,
            _hitTest: hitTestChildren
        });
        return {
            hitTest: hitTest,
            hitTestAll: hitTestAll,
            _hitTestChildren: hitTestChildren
        };
    }, {
        _hitTest: function(point, options, parentViewMatrix) {
            if (this._locked || !this._visible || this._guide && !options.guides || this.isEmpty()) return null;
            var matrix = this._matrix, viewMatrix = parentViewMatrix ? parentViewMatrix.appended(matrix) : this.getGlobalMatrix().prepend(this.getView()._matrix), tolerance = Math.max(options.tolerance, 1e-12), tolerancePadding = options._tolerancePadding = new Size(Path._getStrokePadding(tolerance, matrix._shiftless().invert()));
            point = matrix._inverseTransform(point);
            if (!point || !this._children && !this.getBounds({
                internal: true,
                stroke: true,
                handle: true
            }).expand(tolerancePadding.multiply(2))._containsPoint(point)) return null;
            var checkSelf = !(options.guides && !this._guide || options.selected && !this.isSelected() || options.type && options.type !== Base.hyphenate(this._class) || options.class && !(this instanceof options.class)), match = options.match, that = this, bounds, res;
            function filter(hit) {
                if (hit && match && !match(hit)) hit = null;
                if (hit && options.all) options.all.push(hit);
                return hit;
            }
            function checkPoint(type, part) {
                var pt = part ? bounds['get' + part]() : that.getPosition();
                if (point.subtract(pt).divide(tolerancePadding).length <= 1) return new HitResult(type, that, {
                    name: part ? Base.hyphenate(part) : type,
                    point: pt
                });
            }
            var checkPosition = options.position, checkCenter = options.center, checkBounds = options.bounds;
            if (checkSelf && this._parent && (checkPosition || checkCenter || checkBounds)) {
                if (checkCenter || checkBounds) bounds = this.getInternalBounds();
                res = checkPosition && checkPoint('position') || checkCenter && checkPoint('center', 'Center');
                if (!res && checkBounds) {
                    var points = [
                        'TopLeft',
                        'TopRight',
                        'BottomLeft',
                        'BottomRight',
                        'LeftCenter',
                        'TopCenter',
                        'RightCenter',
                        'BottomCenter'
                    ];
                    for(var i = 0; i < 8 && !res; i++)res = checkPoint('bounds', points[i]);
                }
                res = filter(res);
            }
            if (!res) res = this._hitTestChildren(point, options, viewMatrix) || checkSelf && filter(this._hitTestSelf(point, options, viewMatrix, this.getStrokeScaling() ? null : viewMatrix._shiftless().invert())) || null;
            if (res && res.point) res.point = matrix.transform(res.point);
            return res;
        },
        _hitTestSelf: function(point, options) {
            if (options.fill && this.hasFill() && this._contains(point)) return new HitResult('fill', this);
        },
        matches: function(name, compare) {
            function matchObject(obj1, obj2) {
                for(var i in obj1)if (obj1.hasOwnProperty(i)) {
                    var val1 = obj1[i], val2 = obj2[i];
                    if (Base.isPlainObject(val1) && Base.isPlainObject(val2)) {
                        if (!matchObject(val1, val2)) return false;
                    } else if (!Base.equals(val1, val2)) return false;
                }
                return true;
            }
            var type = typeof name;
            if (type === 'object') {
                for(var key in name){
                    if (name.hasOwnProperty(key) && !this.matches(key, name[key])) return false;
                }
                return true;
            } else if (type === 'function') return name(this);
            else if (name === 'match') return compare(this);
            else {
                var value = /^(empty|editable)$/.test(name) ? this['is' + Base.capitalize(name)]() : name === 'type' ? Base.hyphenate(this._class) : this[name];
                if (name === 'class') {
                    if (typeof compare === 'function') return this instanceof compare;
                    value = this._class;
                }
                if (typeof compare === 'function') return !!compare(value);
                else if (compare) {
                    if (compare.test) return compare.test(value);
                    else if (Base.isPlainObject(compare)) return matchObject(compare, value);
                }
                return Base.equals(value, compare);
            }
        },
        getItems: function(options) {
            return Item._getItems(this, options, this._matrix);
        },
        getItem: function(options) {
            return Item._getItems(this, options, this._matrix, null, true)[0] || null;
        },
        statics: {
            _getItems: function _getItems(item, options, matrix, param, firstOnly) {
                if (!param) {
                    var obj = typeof options === 'object' && options, overlapping = obj && obj.overlapping, inside = obj && obj.inside, bounds = overlapping || inside, rect = bounds && Rectangle.read([
                        bounds
                    ]);
                    param = {
                        items: [],
                        recursive: obj && obj.recursive !== false,
                        inside: !!inside,
                        overlapping: !!overlapping,
                        rect: rect,
                        path: overlapping && new Path.Rectangle({
                            rectangle: rect,
                            insert: false
                        })
                    };
                    if (obj) options = Base.filter({}, options, {
                        recursive: true,
                        inside: true,
                        overlapping: true
                    });
                }
                var children = item._children, items = param.items, rect = param.rect;
                matrix = rect && (matrix || new Matrix());
                for(var i = 0, l = children && children.length; i < l; i++){
                    var child = children[i], childMatrix = matrix && matrix.appended(child._matrix), add = true;
                    if (rect) {
                        var bounds = child.getBounds(childMatrix);
                        if (!rect.intersects(bounds)) continue;
                        if (!(rect.contains(bounds) || param.overlapping && (bounds.contains(rect) || param.path.intersects(child, childMatrix)))) add = false;
                    }
                    if (add && child.matches(options)) {
                        items.push(child);
                        if (firstOnly) break;
                    }
                    if (param.recursive !== false) _getItems(child, options, childMatrix, param, firstOnly);
                    if (firstOnly && items.length > 0) break;
                }
                return items;
            }
        }
    }, {
        importJSON: function(json) {
            var res = Base.importJSON(json, this);
            return res !== this ? this.addChild(res) : res;
        },
        addChild: function(item) {
            return this.insertChild(undefined, item);
        },
        insertChild: function(index, item) {
            var res = item ? this.insertChildren(index, [
                item
            ]) : null;
            return res && res[0];
        },
        addChildren: function(items) {
            return this.insertChildren(this._children.length, items);
        },
        insertChildren: function(index, items) {
            var children = this._children;
            if (children && items && items.length > 0) {
                items = Base.slice(items);
                var inserted = {};
                for(var i = items.length - 1; i >= 0; i--){
                    var item = items[i], id = item && item._id;
                    if (!item || inserted[id]) items.splice(i, 1);
                    else {
                        item._remove(false, true);
                        inserted[id] = true;
                    }
                }
                Base.splice(children, items, index, 0);
                var project = this._project, notifySelf = project._changes;
                for(var i = 0, l = items.length; i < l; i++){
                    var item = items[i], name = item._name;
                    item._parent = this;
                    item._setProject(project, true);
                    if (name) item.setName(name);
                    if (notifySelf) item._changed(5);
                }
                this._changed(11);
            } else items = null;
            return items;
        },
        _insertItem: '#insertChild',
        _insertAt: function(item, offset) {
            var owner = item && item._getOwner(), res = item !== this && owner ? this : null;
            if (res) {
                res._remove(false, true);
                owner._insertItem(item._index + offset, res);
            }
            return res;
        },
        insertAbove: function(item) {
            return this._insertAt(item, 1);
        },
        insertBelow: function(item) {
            return this._insertAt(item, 0);
        },
        sendToBack: function() {
            var owner = this._getOwner();
            return owner ? owner._insertItem(0, this) : null;
        },
        bringToFront: function() {
            var owner = this._getOwner();
            return owner ? owner._insertItem(undefined, this) : null;
        },
        appendTop: '#addChild',
        appendBottom: function(item) {
            return this.insertChild(0, item);
        },
        moveAbove: '#insertAbove',
        moveBelow: '#insertBelow',
        addTo: function(owner) {
            return owner._insertItem(undefined, this);
        },
        copyTo: function(owner) {
            return this.clone(false).addTo(owner);
        },
        reduce: function(options) {
            var children = this._children;
            if (children && children.length === 1) {
                var child = children[0].reduce(options);
                if (this._parent) {
                    child.insertAbove(this);
                    this.remove();
                } else child.remove();
                return child;
            }
            return this;
        },
        _removeNamed: function() {
            var owner = this._getOwner();
            if (owner) {
                var children = owner._children, namedChildren = owner._namedChildren, name = this._name, namedArray = namedChildren[name], index = namedArray ? namedArray.indexOf(this) : -1;
                if (index !== -1) {
                    if (children[name] == this) delete children[name];
                    namedArray.splice(index, 1);
                    if (namedArray.length) children[name] = namedArray[0];
                    else delete namedChildren[name];
                }
            }
        },
        _remove: function(notifySelf, notifyParent) {
            var owner = this._getOwner(), project = this._project, index = this._index;
            if (this._style) this._style._dispose();
            if (owner) {
                if (this._name) this._removeNamed();
                if (index != null) {
                    if (project._activeLayer === this) project._activeLayer = this.getNextSibling() || this.getPreviousSibling();
                    Base.splice(owner._children, null, index, 1);
                }
                this._installEvents(false);
                if (notifySelf && project._changes) this._changed(5);
                if (notifyParent) owner._changed(11, this);
                this._parent = null;
                return true;
            }
            return false;
        },
        remove: function() {
            return this._remove(true, true);
        },
        replaceWith: function(item) {
            var ok = item && item.insertBelow(this);
            if (ok) this.remove();
            return ok;
        },
        removeChildren: function(start, end) {
            if (!this._children) return null;
            start = start || 0;
            end = Base.pick(end, this._children.length);
            var removed = Base.splice(this._children, null, start, end - start);
            for(var i = removed.length - 1; i >= 0; i--)removed[i]._remove(true, false);
            if (removed.length > 0) this._changed(11);
            return removed;
        },
        clear: '#removeChildren',
        reverseChildren: function() {
            if (this._children) {
                this._children.reverse();
                for(var i = 0, l = this._children.length; i < l; i++)this._children[i]._index = i;
                this._changed(11);
            }
        },
        isEmpty: function(recursively) {
            var children = this._children;
            var numChildren = children ? children.length : 0;
            if (recursively) {
                for(var i = 0; i < numChildren; i++){
                    if (!children[i].isEmpty(recursively)) return false;
                }
                return true;
            }
            return !numChildren;
        },
        isEditable: function() {
            var item = this;
            while(item){
                if (!item._visible || item._locked) return false;
                item = item._parent;
            }
            return true;
        },
        hasFill: function() {
            return this.getStyle().hasFill();
        },
        hasStroke: function() {
            return this.getStyle().hasStroke();
        },
        hasShadow: function() {
            return this.getStyle().hasShadow();
        },
        _getOrder: function(item) {
            function getList(item) {
                var list = [];
                do list.unshift(item);
                while (item = item._parent);
                return list;
            }
            var list1 = getList(this), list2 = getList(item);
            for(var i = 0, l = Math.min(list1.length, list2.length); i < l; i++){
                if (list1[i] != list2[i]) return list1[i]._index < list2[i]._index ? 1 : -1;
            }
            return 0;
        },
        hasChildren: function() {
            return this._children && this._children.length > 0;
        },
        isInserted: function() {
            return this._parent ? this._parent.isInserted() : false;
        },
        isAbove: function(item) {
            return this._getOrder(item) === -1;
        },
        isBelow: function(item) {
            return this._getOrder(item) === 1;
        },
        isParent: function(item) {
            return this._parent === item;
        },
        isChild: function(item) {
            return item && item._parent === this;
        },
        isDescendant: function(item) {
            var parent = this;
            while(parent = parent._parent){
                if (parent === item) return true;
            }
            return false;
        },
        isAncestor: function(item) {
            return item ? item.isDescendant(this) : false;
        },
        isSibling: function(item) {
            return this._parent === item._parent;
        },
        isGroupedWith: function(item) {
            var parent = this._parent;
            while(parent){
                if (parent._parent && /^(Group|Layer|CompoundPath)$/.test(parent._class) && item.isDescendant(parent)) return true;
                parent = parent._parent;
            }
            return false;
        }
    }, Base.each([
        'rotate',
        'scale',
        'shear',
        'skew'
    ], function(key) {
        var rotate = key === 'rotate';
        this[key] = function() {
            var args = arguments, value = (rotate ? Base : Point).read(args), center = Point.read(args, 0, {
                readNull: true
            });
            return this.transform(new Matrix()[key](value, center || this.getPosition(true)));
        };
    }, {
        translate: function() {
            var mx = new Matrix();
            return this.transform(mx.translate.apply(mx, arguments));
        },
        transform: function(matrix, _applyRecursively, _setApplyMatrix) {
            var _matrix = this._matrix, transformMatrix = matrix && !matrix.isIdentity(), applyMatrix = _setApplyMatrix && this._canApplyMatrix || this._applyMatrix && (transformMatrix || !_matrix.isIdentity() || _applyRecursively && this._children);
            if (!transformMatrix && !applyMatrix) return this;
            if (transformMatrix) {
                if (!matrix.isInvertible() && _matrix.isInvertible()) _matrix._backup = _matrix.getValues();
                _matrix.prepend(matrix, true);
                var style = this._style, fillColor = style.getFillColor(true), strokeColor = style.getStrokeColor(true);
                if (fillColor) fillColor.transform(matrix);
                if (strokeColor) strokeColor.transform(matrix);
            }
            if (applyMatrix && (applyMatrix = this._transformContent(_matrix, _applyRecursively, _setApplyMatrix))) {
                var pivot = this._pivot;
                if (pivot) _matrix._transformPoint(pivot, pivot, true);
                _matrix.reset(true);
                if (_setApplyMatrix && this._canApplyMatrix) this._applyMatrix = true;
            }
            var bounds = this._bounds, position = this._position;
            if (transformMatrix || applyMatrix) this._changed(25);
            var decomp = transformMatrix && bounds && matrix.decompose();
            if (decomp && decomp.skewing.isZero() && decomp.rotation % 90 === 0) {
                for(var key in bounds){
                    var cache = bounds[key];
                    if (cache.nonscaling) delete bounds[key];
                    else if (applyMatrix || !cache.internal) {
                        var rect = cache.rect;
                        matrix._transformBounds(rect, rect);
                    }
                }
                this._bounds = bounds;
                var cached = bounds[this._getBoundsCacheKey(this._boundsOptions || {})];
                if (cached) this._position = this._getPositionFromBounds(cached.rect);
            } else if (transformMatrix && position && this._pivot) this._position = matrix._transformPoint(position, position);
            return this;
        },
        _transformContent: function(matrix, applyRecursively, setApplyMatrix) {
            var children = this._children;
            if (children) {
                for(var i = 0, l = children.length; i < l; i++)children[i].transform(matrix, applyRecursively, setApplyMatrix);
                return true;
            }
        },
        globalToLocal: function() {
            return this.getGlobalMatrix(true)._inverseTransform(Point.read(arguments));
        },
        localToGlobal: function() {
            return this.getGlobalMatrix(true)._transformPoint(Point.read(arguments));
        },
        parentToLocal: function() {
            return this._matrix._inverseTransform(Point.read(arguments));
        },
        localToParent: function() {
            return this._matrix._transformPoint(Point.read(arguments));
        },
        fitBounds: function(rectangle, fill) {
            rectangle = Rectangle.read(arguments);
            var bounds = this.getBounds(), itemRatio = bounds.height / bounds.width, rectRatio = rectangle.height / rectangle.width, scale = (fill ? itemRatio > rectRatio : itemRatio < rectRatio) ? rectangle.width / bounds.width : rectangle.height / bounds.height, newBounds = new Rectangle(new Point(), new Size(bounds.width * scale, bounds.height * scale));
            newBounds.setCenter(rectangle.getCenter());
            this.setBounds(newBounds);
        }
    }), {
        _setStyles: function(ctx, param, viewMatrix) {
            var style = this._style, matrix = this._matrix;
            if (style.hasFill()) ctx.fillStyle = style.getFillColor().toCanvasStyle(ctx, matrix);
            if (style.hasStroke()) {
                ctx.strokeStyle = style.getStrokeColor().toCanvasStyle(ctx, matrix);
                ctx.lineWidth = style.getStrokeWidth();
                var strokeJoin = style.getStrokeJoin(), strokeCap = style.getStrokeCap(), miterLimit = style.getMiterLimit();
                if (strokeJoin) ctx.lineJoin = strokeJoin;
                if (strokeCap) ctx.lineCap = strokeCap;
                if (miterLimit) ctx.miterLimit = miterLimit;
                if (paper.support.nativeDash) {
                    var dashArray = style.getDashArray(), dashOffset = style.getDashOffset();
                    if (dashArray && dashArray.length) {
                        if ('setLineDash' in ctx) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashOffset;
                        } else {
                            ctx.mozDash = dashArray;
                            ctx.mozDashOffset = dashOffset;
                        }
                    }
                }
            }
            if (style.hasShadow()) {
                var pixelRatio = param.pixelRatio || 1, mx = viewMatrix._shiftless().prepend(new Matrix().scale(pixelRatio, pixelRatio)), blur = mx.transform(new Point(style.getShadowBlur(), 0)), offset = mx.transform(this.getShadowOffset());
                ctx.shadowColor = style.getShadowColor().toCanvasStyle(ctx);
                ctx.shadowBlur = blur.getLength();
                ctx.shadowOffsetX = offset.x;
                ctx.shadowOffsetY = offset.y;
            }
        },
        draw: function(ctx, param, parentStrokeMatrix) {
            var updateVersion = this._updateVersion = this._project._updateVersion;
            if (!this._visible || this._opacity === 0) return;
            var matrices = param.matrices, viewMatrix = param.viewMatrix, matrix = this._matrix, globalMatrix = matrices[matrices.length - 1].appended(matrix);
            if (!globalMatrix.isInvertible()) return;
            viewMatrix = viewMatrix ? viewMatrix.appended(globalMatrix) : globalMatrix;
            matrices.push(globalMatrix);
            if (param.updateMatrix) this._globalMatrix = globalMatrix;
            var blendMode = this._blendMode, opacity = Numerical.clamp(this._opacity, 0, 1), normalBlend = blendMode === 'normal', nativeBlend = BlendMode.nativeModes[blendMode], direct = normalBlend && opacity === 1 || param.dontStart || param.clip || (nativeBlend || normalBlend && opacity < 1) && this._canComposite(), pixelRatio = param.pixelRatio || 1, mainCtx, itemOffset, prevOffset;
            if (!direct) {
                var bounds = this.getStrokeBounds(viewMatrix);
                if (!bounds.width || !bounds.height) {
                    matrices.pop();
                    return;
                }
                prevOffset = param.offset;
                itemOffset = param.offset = bounds.getTopLeft().floor();
                mainCtx = ctx;
                ctx = CanvasProvider.getContext(bounds.getSize().ceil().add(1).multiply(pixelRatio));
                if (pixelRatio !== 1) ctx.scale(pixelRatio, pixelRatio);
            }
            ctx.save();
            var strokeMatrix = parentStrokeMatrix ? parentStrokeMatrix.appended(matrix) : this._canScaleStroke && !this.getStrokeScaling(true) && viewMatrix, clip = !direct && param.clipItem, transform = !strokeMatrix || clip;
            if (direct) {
                ctx.globalAlpha = opacity;
                if (nativeBlend) ctx.globalCompositeOperation = blendMode;
            } else if (transform) ctx.translate(-itemOffset.x, -itemOffset.y);
            if (transform) (direct ? matrix : viewMatrix).applyToContext(ctx);
            if (clip) param.clipItem.draw(ctx, param.extend({
                clip: true
            }));
            if (strokeMatrix) {
                ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
                var offset = param.offset;
                if (offset) ctx.translate(-offset.x, -offset.y);
            }
            this._draw(ctx, param, viewMatrix, strokeMatrix);
            ctx.restore();
            matrices.pop();
            if (param.clip && !param.dontFinish) ctx.clip(this.getFillRule());
            if (!direct) {
                BlendMode.process(blendMode, ctx, mainCtx, opacity, itemOffset.subtract(prevOffset).multiply(pixelRatio));
                CanvasProvider.release(ctx);
                param.offset = prevOffset;
            }
        },
        _isUpdated: function(updateVersion) {
            var parent = this._parent;
            if (parent instanceof CompoundPath) return parent._isUpdated(updateVersion);
            var updated = this._updateVersion === updateVersion;
            if (!updated && parent && parent._visible && parent._isUpdated(updateVersion)) {
                this._updateVersion = updateVersion;
                updated = true;
            }
            return updated;
        },
        _drawSelection: function(ctx, matrix, size, selectionItems, updateVersion) {
            var selection = this._selection, itemSelected = selection & 1, boundsSelected = selection & 2 || itemSelected && this._selectBounds, positionSelected = selection & 4;
            if (!this._drawSelected) itemSelected = false;
            if ((itemSelected || boundsSelected || positionSelected) && this._isUpdated(updateVersion)) {
                var layer, color = this.getSelectedColor(true) || (layer = this.getLayer()) && layer.getSelectedColor(true), mx = matrix.appended(this.getGlobalMatrix(true)), half = size / 2;
                ctx.strokeStyle = ctx.fillStyle = color ? color.toCanvasStyle(ctx) : '#009dec';
                if (itemSelected) this._drawSelected(ctx, mx, selectionItems);
                if (positionSelected) {
                    var pos = this.getPosition(true), parent = this._parent, point = parent ? parent.localToGlobal(pos) : pos, x = point.x, y = point.y;
                    ctx.beginPath();
                    ctx.arc(x, y, half, 0, Math.PI * 2, true);
                    ctx.stroke();
                    var deltas = [
                        [
                            0,
                            -1
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            0,
                            1
                        ],
                        [
                            -1,
                            0
                        ]
                    ], start = half, end = size + 1;
                    for(var i = 0; i < 4; i++){
                        var delta = deltas[i], dx = delta[0], dy = delta[1];
                        ctx.moveTo(x + dx * start, y + dy * start);
                        ctx.lineTo(x + dx * end, y + dy * end);
                        ctx.stroke();
                    }
                }
                if (boundsSelected) {
                    var coords = mx._transformCorners(this.getInternalBounds());
                    ctx.beginPath();
                    for(var i = 0; i < 8; i++)ctx[!i ? 'moveTo' : 'lineTo'](coords[i], coords[++i]);
                    ctx.closePath();
                    ctx.stroke();
                    for(var i = 0; i < 8; i++)ctx.fillRect(coords[i] - half, coords[++i] - half, size, size);
                }
            }
        },
        _canComposite: function() {
            return false;
        }
    }, Base.each([
        'down',
        'drag',
        'up',
        'move'
    ], function(key) {
        this['removeOn' + Base.capitalize(key)] = function() {
            var hash = {};
            hash[key] = true;
            return this.removeOn(hash);
        };
    }, {
        removeOn: function(obj) {
            for(var name in obj)if (obj[name]) {
                var key = 'mouse' + name, project = this._project, sets = project._removeSets = project._removeSets || {};
                sets[key] = sets[key] || {};
                sets[key][this._id] = this;
            }
            return this;
        }
    }), {
        tween: function(from, to, options) {
            if (!options) {
                options = to;
                to = from;
                from = null;
                if (!options) {
                    options = to;
                    to = null;
                }
            }
            var easing = options && options.easing, start = options && options.start, duration = options != null && (typeof options === 'number' ? options : options.duration), tween = new Tween(this, from, to, duration, easing, start);
            function onFrame(event) {
                tween._handleFrame(event.time * 1000);
                if (!tween.running) this.off('frame', onFrame);
            }
            if (duration) this.on('frame', onFrame);
            return tween;
        },
        tweenTo: function(to, options) {
            return this.tween(null, to, options);
        },
        tweenFrom: function(from, options) {
            return this.tween(from, null, options);
        }
    });
    var Group = Item.extend({
        _class: 'Group',
        _selectBounds: false,
        _selectChildren: true,
        _serializeFields: {
            children: []
        },
        initialize: function Group(arg) {
            this._children = [];
            this._namedChildren = {};
            if (!this._initialize(arg)) this.addChildren(Array.isArray(arg) ? arg : arguments);
        },
        _changed: function _changed(flags) {
            _changed.base.call(this, flags);
            if (flags & 2050) this._clipItem = undefined;
        },
        _getClipItem: function() {
            var clipItem = this._clipItem;
            if (clipItem === undefined) {
                clipItem = null;
                var children = this._children;
                for(var i = 0, l = children.length; i < l; i++)if (children[i]._clipMask) {
                    clipItem = children[i];
                    break;
                }
                this._clipItem = clipItem;
            }
            return clipItem;
        },
        isClipped: function() {
            return !!this._getClipItem();
        },
        setClipped: function(clipped) {
            var child = this.getFirstChild();
            if (child) child.setClipMask(clipped);
        },
        _getBounds: function _getBounds(matrix, options) {
            var clipItem = this._getClipItem();
            return clipItem ? clipItem._getCachedBounds(clipItem._matrix.prepended(matrix), Base.set({}, options, {
                stroke: false
            })) : _getBounds.base.call(this, matrix, options);
        },
        _hitTestChildren: function _hitTestChildren(point, options, viewMatrix) {
            var clipItem = this._getClipItem();
            return (!clipItem || clipItem.contains(point)) && _hitTestChildren.base.call(this, point, options, viewMatrix, clipItem);
        },
        _draw: function(ctx, param) {
            var clip = param.clip, clipItem = !clip && this._getClipItem();
            param = param.extend({
                clipItem: clipItem,
                clip: false
            });
            if (clip) {
                ctx.beginPath();
                param.dontStart = param.dontFinish = true;
            } else if (clipItem) clipItem.draw(ctx, param.extend({
                clip: true
            }));
            var children = this._children;
            for(var i = 0, l = children.length; i < l; i++){
                var item = children[i];
                if (item !== clipItem) item.draw(ctx, param);
            }
        }
    });
    var Layer = Group.extend({
        _class: 'Layer',
        initialize: function Layer() {
            Group.apply(this, arguments);
        },
        _getOwner: function() {
            return this._parent || this._index != null && this._project;
        },
        isInserted: function isInserted() {
            return this._parent ? isInserted.base.call(this) : this._index != null;
        },
        activate: function() {
            this._project._activeLayer = this;
        },
        _hitTestSelf: function() {}
    });
    var Shape = Item.extend({
        _class: 'Shape',
        _applyMatrix: false,
        _canApplyMatrix: false,
        _canScaleStroke: true,
        _serializeFields: {
            type: null,
            size: null,
            radius: null
        },
        initialize: function Shape(props, point) {
            this._initialize(props, point);
        },
        _equals: function(item) {
            return this._type === item._type && this._size.equals(item._size) && Base.equals(this._radius, item._radius);
        },
        copyContent: function(source) {
            this.setType(source._type);
            this.setSize(source._size);
            this.setRadius(source._radius);
        },
        getType: function() {
            return this._type;
        },
        setType: function(type) {
            this._type = type;
        },
        getShape: '#getType',
        setShape: '#setType',
        getSize: function() {
            var size = this._size;
            return new LinkedSize(size.width, size.height, this, 'setSize');
        },
        setSize: function() {
            var size = Size.read(arguments);
            if (!this._size) this._size = size.clone();
            else if (!this._size.equals(size)) {
                var type = this._type, width = size.width, height = size.height;
                if (type === 'rectangle') this._radius.set(Size.min(this._radius, size.divide(2).abs()));
                else if (type === 'circle') {
                    width = height = (width + height) / 2;
                    this._radius = width / 2;
                } else if (type === 'ellipse') this._radius._set(width / 2, height / 2);
                this._size._set(width, height);
                this._changed(9);
            }
        },
        getRadius: function() {
            var rad = this._radius;
            return this._type === 'circle' ? rad : new LinkedSize(rad.width, rad.height, this, 'setRadius');
        },
        setRadius: function(radius) {
            var type = this._type;
            if (type === 'circle') {
                if (radius === this._radius) return;
                var size = radius * 2;
                this._radius = radius;
                this._size._set(size, size);
            } else {
                radius = Size.read(arguments);
                if (!this._radius) this._radius = radius.clone();
                else {
                    if (this._radius.equals(radius)) return;
                    this._radius.set(radius);
                    if (type === 'rectangle') {
                        var size = Size.max(this._size, radius.multiply(2));
                        this._size.set(size);
                    } else if (type === 'ellipse') this._size._set(radius.width * 2, radius.height * 2);
                }
            }
            this._changed(9);
        },
        isEmpty: function() {
            return false;
        },
        toPath: function(insert) {
            var path = new Path[Base.capitalize(this._type)]({
                center: new Point(),
                size: this._size,
                radius: this._radius,
                insert: false
            });
            path.copyAttributes(this);
            if (paper.settings.applyMatrix) path.setApplyMatrix(true);
            if (insert === undefined || insert) path.insertAbove(this);
            return path;
        },
        toShape: '#clone',
        _asPathItem: function() {
            return this.toPath(false);
        },
        _draw: function(ctx, param, viewMatrix, strokeMatrix) {
            var style = this._style, hasFill = style.hasFill(), hasStroke = style.hasStroke(), dontPaint = param.dontFinish || param.clip, untransformed = !strokeMatrix;
            if (hasFill || hasStroke || dontPaint) {
                var type = this._type, radius = this._radius, isCircle = type === 'circle';
                if (!param.dontStart) ctx.beginPath();
                if (untransformed && isCircle) ctx.arc(0, 0, radius, 0, Math.PI * 2, true);
                else {
                    var rx = isCircle ? radius : radius.width, ry = isCircle ? radius : radius.height, size = this._size, width = size.width, height = size.height;
                    if (untransformed && type === 'rectangle' && rx === 0 && ry === 0) ctx.rect(-width / 2, -height / 2, width, height);
                    else {
                        var x = width / 2, y = height / 2, kappa = 0.44771525016920644, cx = rx * kappa, cy = ry * kappa, c = [
                            -x,
                            -y + ry,
                            -x,
                            -y + cy,
                            -x + cx,
                            -y,
                            -x + rx,
                            -y,
                            x - rx,
                            -y,
                            x - cx,
                            -y,
                            x,
                            -y + cy,
                            x,
                            -y + ry,
                            x,
                            y - ry,
                            x,
                            y - cy,
                            x - cx,
                            y,
                            x - rx,
                            y,
                            -x + rx,
                            y,
                            -x + cx,
                            y,
                            -x,
                            y - cy,
                            -x,
                            y - ry
                        ];
                        if (strokeMatrix) strokeMatrix.transform(c, c, 32);
                        ctx.moveTo(c[0], c[1]);
                        ctx.bezierCurveTo(c[2], c[3], c[4], c[5], c[6], c[7]);
                        if (x !== rx) ctx.lineTo(c[8], c[9]);
                        ctx.bezierCurveTo(c[10], c[11], c[12], c[13], c[14], c[15]);
                        if (y !== ry) ctx.lineTo(c[16], c[17]);
                        ctx.bezierCurveTo(c[18], c[19], c[20], c[21], c[22], c[23]);
                        if (x !== rx) ctx.lineTo(c[24], c[25]);
                        ctx.bezierCurveTo(c[26], c[27], c[28], c[29], c[30], c[31]);
                    }
                }
                ctx.closePath();
            }
            if (!dontPaint && (hasFill || hasStroke)) {
                this._setStyles(ctx, param, viewMatrix);
                if (hasFill) {
                    ctx.fill(style.getFillRule());
                    ctx.shadowColor = 'rgba(0,0,0,0)';
                }
                if (hasStroke) ctx.stroke();
            }
        },
        _canComposite: function() {
            return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(matrix, options) {
            var rect = new Rectangle(this._size).setCenter(0, 0), style = this._style, strokeWidth = options.stroke && style.hasStroke() && style.getStrokeWidth();
            if (matrix) rect = matrix._transformBounds(rect);
            return strokeWidth ? rect.expand(Path._getStrokePadding(strokeWidth, this._getStrokeMatrix(matrix, options))) : rect;
        }
    }, new function() {
        function getCornerCenter(that, point, expand) {
            var radius = that._radius;
            if (!radius.isZero()) {
                var halfSize = that._size.divide(2);
                for(var q = 1; q <= 4; q++){
                    var dir = new Point(q > 1 && q < 4 ? -1 : 1, q > 2 ? -1 : 1), corner = dir.multiply(halfSize), center = corner.subtract(dir.multiply(radius)), rect = new Rectangle(expand ? corner.add(dir.multiply(expand)) : corner, center);
                    if (rect.contains(point)) return {
                        point: center,
                        quadrant: q
                    };
                }
            }
        }
        function isOnEllipseStroke(point, radius, padding, quadrant) {
            var vector = point.divide(radius);
            return (!quadrant || vector.isInQuadrant(quadrant)) && vector.subtract(vector.normalize()).multiply(radius).divide(padding).length <= 1;
        }
        return {
            _contains: function _contains(point) {
                if (this._type === 'rectangle') {
                    var center = getCornerCenter(this, point);
                    return center ? point.subtract(center.point).divide(this._radius).getLength() <= 1 : _contains.base.call(this, point);
                } else return point.divide(this.size).getLength() <= 0.5;
            },
            _hitTestSelf: function _hitTestSelf(point, options, viewMatrix, strokeMatrix) {
                var hit = false, style = this._style, hitStroke = options.stroke && style.hasStroke(), hitFill = options.fill && style.hasFill();
                if (hitStroke || hitFill) {
                    var type = this._type, radius = this._radius, strokeRadius = hitStroke ? style.getStrokeWidth() / 2 : 0, strokePadding = options._tolerancePadding.add(Path._getStrokePadding(strokeRadius, !style.getStrokeScaling() && strokeMatrix));
                    if (type === 'rectangle') {
                        var padding = strokePadding.multiply(2), center = getCornerCenter(this, point, padding);
                        if (center) hit = isOnEllipseStroke(point.subtract(center.point), radius, strokePadding, center.quadrant);
                        else {
                            var rect = new Rectangle(this._size).setCenter(0, 0), outer = rect.expand(padding), inner = rect.expand(padding.negate());
                            hit = outer._containsPoint(point) && !inner._containsPoint(point);
                        }
                    } else hit = isOnEllipseStroke(point, radius, strokePadding);
                }
                return hit ? new HitResult(hitStroke ? 'stroke' : 'fill', this) : _hitTestSelf.base.apply(this, arguments);
            }
        };
    }, {
        statics: new function() {
            function createShape(type, point, size, radius, args) {
                var item = Base.create(Shape.prototype);
                item._type = type;
                item._size = size;
                item._radius = radius;
                item._initialize(Base.getNamed(args), point);
                return item;
            }
            return {
                Circle: function() {
                    var args = arguments, center = Point.readNamed(args, 'center'), radius = Base.readNamed(args, 'radius');
                    return createShape('circle', center, new Size(radius * 2), radius, args);
                },
                Rectangle: function() {
                    var args = arguments, rect = Rectangle.readNamed(args, 'rectangle'), radius = Size.min(Size.readNamed(args, 'radius'), rect.getSize(true).divide(2));
                    return createShape('rectangle', rect.getCenter(true), rect.getSize(true), radius, args);
                },
                Ellipse: function() {
                    var args = arguments, ellipse = Shape._readEllipse(args), radius = ellipse.radius;
                    return createShape('ellipse', ellipse.center, radius.multiply(2), radius, args);
                },
                _readEllipse: function(args) {
                    var center, radius;
                    if (Base.hasNamed(args, 'radius')) {
                        center = Point.readNamed(args, 'center');
                        radius = Size.readNamed(args, 'radius');
                    } else {
                        var rect = Rectangle.readNamed(args, 'rectangle');
                        center = rect.getCenter(true);
                        radius = rect.getSize(true).divide(2);
                    }
                    return {
                        center: center,
                        radius: radius
                    };
                }
            };
        }
    });
    var Raster = Item.extend({
        _class: 'Raster',
        _applyMatrix: false,
        _canApplyMatrix: false,
        _boundsOptions: {
            stroke: false,
            handle: false
        },
        _serializeFields: {
            crossOrigin: null,
            source: null
        },
        _prioritize: [
            'crossOrigin'
        ],
        _smoothing: 'low',
        beans: true,
        initialize: function Raster(source, position) {
            if (!this._initialize(source, position !== undefined && Point.read(arguments))) {
                var image, type = typeof source, object = type === 'string' ? document.getElementById(source) : type === 'object' ? source : null;
                if (object && object !== Item.NO_INSERT) {
                    if (object.getContext || object.naturalHeight != null) image = object;
                    else if (object) {
                        var size = Size.read(arguments);
                        if (!size.isZero()) image = CanvasProvider.getCanvas(size);
                    }
                }
                if (image) this.setImage(image);
                else this.setSource(source);
            }
            if (!this._size) {
                this._size = new Size();
                this._loaded = false;
            }
        },
        _equals: function(item) {
            return this.getSource() === item.getSource();
        },
        copyContent: function(source) {
            var image = source._image, canvas = source._canvas;
            if (image) this._setImage(image);
            else if (canvas) {
                var copyCanvas = CanvasProvider.getCanvas(source._size);
                copyCanvas.getContext('2d').drawImage(canvas, 0, 0);
                this._setImage(copyCanvas);
            }
            this._crossOrigin = source._crossOrigin;
        },
        getSize: function() {
            var size = this._size;
            return new LinkedSize(size ? size.width : 0, size ? size.height : 0, this, 'setSize');
        },
        setSize: function(_size, _clear) {
            var size = Size.read(arguments);
            if (!size.equals(this._size)) {
                if (size.width > 0 && size.height > 0) {
                    var element = !_clear && this.getElement();
                    this._setImage(CanvasProvider.getCanvas(size));
                    if (element) this.getContext(true).drawImage(element, 0, 0, size.width, size.height);
                } else {
                    if (this._canvas) CanvasProvider.release(this._canvas);
                    this._size = size.clone();
                }
            } else if (_clear) this.clear();
        },
        getWidth: function() {
            return this._size ? this._size.width : 0;
        },
        setWidth: function(width) {
            this.setSize(width, this.getHeight());
        },
        getHeight: function() {
            return this._size ? this._size.height : 0;
        },
        setHeight: function(height) {
            this.setSize(this.getWidth(), height);
        },
        getLoaded: function() {
            return this._loaded;
        },
        isEmpty: function() {
            var size = this._size;
            return !size || size.width === 0 && size.height === 0;
        },
        getResolution: function() {
            var matrix = this._matrix, orig = new Point(0, 0).transform(matrix), u = new Point(1, 0).transform(matrix).subtract(orig), v = new Point(0, 1).transform(matrix).subtract(orig);
            return new Size(72 / u.getLength(), 72 / v.getLength());
        },
        getPpi: '#getResolution',
        getImage: function() {
            return this._image;
        },
        setImage: function(image) {
            var that = this;
            function emit(event) {
                var view = that.getView(), type = event && event.type || 'load';
                if (view && that.responds(type)) {
                    paper = view._scope;
                    that.emit(type, new Event(event));
                }
            }
            this._setImage(image);
            if (this._loaded) setTimeout(emit, 0);
            else if (image) DomEvent.add(image, {
                load: function(event) {
                    that._setImage(image);
                    emit(event);
                },
                error: emit
            });
        },
        _setImage: function(image) {
            if (this._canvas) CanvasProvider.release(this._canvas);
            if (image && image.getContext) {
                this._image = null;
                this._canvas = image;
                this._loaded = true;
            } else {
                this._image = image;
                this._canvas = null;
                this._loaded = !!(image && image.src && image.complete);
            }
            this._size = new Size(image ? image.naturalWidth || image.width : 0, image ? image.naturalHeight || image.height : 0);
            this._context = null;
            this._changed(1033);
        },
        getCanvas: function() {
            if (!this._canvas) {
                var ctx = CanvasProvider.getContext(this._size);
                try {
                    if (this._image) ctx.drawImage(this._image, 0, 0);
                    this._canvas = ctx.canvas;
                } catch (e) {
                    CanvasProvider.release(ctx);
                }
            }
            return this._canvas;
        },
        setCanvas: '#setImage',
        getContext: function(_change) {
            if (!this._context) this._context = this.getCanvas().getContext('2d');
            if (_change) {
                this._image = null;
                this._changed(1025);
            }
            return this._context;
        },
        setContext: function(context) {
            this._context = context;
        },
        getSource: function() {
            var image = this._image;
            return image && image.src || this.toDataURL();
        },
        setSource: function(src) {
            var image = new self1.Image(), crossOrigin = this._crossOrigin;
            if (crossOrigin) image.crossOrigin = crossOrigin;
            if (src) image.src = src;
            this.setImage(image);
        },
        getCrossOrigin: function() {
            var image = this._image;
            return image && image.crossOrigin || this._crossOrigin || '';
        },
        setCrossOrigin: function(crossOrigin) {
            this._crossOrigin = crossOrigin;
            var image = this._image;
            if (image) image.crossOrigin = crossOrigin;
        },
        getSmoothing: function() {
            return this._smoothing;
        },
        setSmoothing: function(smoothing) {
            this._smoothing = typeof smoothing === 'string' ? smoothing : smoothing ? 'low' : 'off';
            this._changed(257);
        },
        getElement: function() {
            return this._canvas || this._loaded && this._image;
        }
    }, {
        beans: false,
        getSubCanvas: function() {
            var rect = Rectangle.read(arguments), ctx = CanvasProvider.getContext(rect.getSize());
            ctx.drawImage(this.getCanvas(), rect.x, rect.y, rect.width, rect.height, 0, 0, rect.width, rect.height);
            return ctx.canvas;
        },
        getSubRaster: function() {
            var rect = Rectangle.read(arguments), raster = new Raster(Item.NO_INSERT);
            raster._setImage(this.getSubCanvas(rect));
            raster.translate(rect.getCenter().subtract(this.getSize().divide(2)));
            raster._matrix.prepend(this._matrix);
            raster.insertAbove(this);
            return raster;
        },
        toDataURL: function() {
            var image = this._image, src = image && image.src;
            if (/^data:/.test(src)) return src;
            var canvas = this.getCanvas();
            return canvas ? canvas.toDataURL.apply(canvas, arguments) : null;
        },
        drawImage: function(image) {
            var point = Point.read(arguments, 1);
            this.getContext(true).drawImage(image, point.x, point.y);
        },
        getAverageColor: function(object) {
            var bounds, path;
            if (!object) bounds = this.getBounds();
            else if (object instanceof PathItem) {
                path = object;
                bounds = object.getBounds();
            } else if (typeof object === 'object') {
                if ('width' in object) bounds = new Rectangle(object);
                else if ('x' in object) bounds = new Rectangle(object.x - 0.5, object.y - 0.5, 1, 1);
            }
            if (!bounds) return null;
            var sampleSize = 32, width = Math.min(bounds.width, sampleSize), height = Math.min(bounds.height, sampleSize);
            var ctx = Raster._sampleContext;
            if (!ctx) ctx = Raster._sampleContext = CanvasProvider.getContext(new Size(sampleSize));
            else ctx.clearRect(0, 0, sampleSize + 1, sampleSize + 1);
            ctx.save();
            var matrix = new Matrix().scale(width / bounds.width, height / bounds.height).translate(-bounds.x, -bounds.y);
            matrix.applyToContext(ctx);
            if (path) path.draw(ctx, new Base({
                clip: true,
                matrices: [
                    matrix
                ]
            }));
            this._matrix.applyToContext(ctx);
            var element = this.getElement(), size = this._size;
            if (element) ctx.drawImage(element, -size.width / 2, -size.height / 2);
            ctx.restore();
            var pixels = ctx.getImageData(0.5, 0.5, Math.ceil(width), Math.ceil(height)).data, channels = [
                0,
                0,
                0
            ], total = 0;
            for(var i = 0, l = pixels.length; i < l; i += 4){
                var alpha = pixels[i + 3];
                total += alpha;
                alpha /= 255;
                channels[0] += pixels[i] * alpha;
                channels[1] += pixels[i + 1] * alpha;
                channels[2] += pixels[i + 2] * alpha;
            }
            for(var i = 0; i < 3; i++)channels[i] /= total;
            return total ? Color.read(channels) : null;
        },
        getPixel: function() {
            var point = Point.read(arguments);
            var data = this.getContext().getImageData(point.x, point.y, 1, 1).data;
            return new Color('rgb', [
                data[0] / 255,
                data[1] / 255,
                data[2] / 255
            ], data[3] / 255);
        },
        setPixel: function() {
            var args = arguments, point = Point.read(args), color = Color.read(args), components = color._convert('rgb'), alpha = color._alpha, ctx = this.getContext(true), imageData = ctx.createImageData(1, 1), data = imageData.data;
            data[0] = components[0] * 255;
            data[1] = components[1] * 255;
            data[2] = components[2] * 255;
            data[3] = alpha != null ? alpha * 255 : 255;
            ctx.putImageData(imageData, point.x, point.y);
        },
        clear: function() {
            var size = this._size;
            this.getContext(true).clearRect(0, 0, size.width + 1, size.height + 1);
        },
        createImageData: function() {
            var size = Size.read(arguments);
            return this.getContext().createImageData(size.width, size.height);
        },
        getImageData: function() {
            var rect = Rectangle.read(arguments);
            if (rect.isEmpty()) rect = new Rectangle(this._size);
            return this.getContext().getImageData(rect.x, rect.y, rect.width, rect.height);
        },
        putImageData: function(data) {
            var point = Point.read(arguments, 1);
            this.getContext(true).putImageData(data, point.x, point.y);
        },
        setImageData: function(data) {
            this.setSize(data);
            this.getContext(true).putImageData(data, 0, 0);
        },
        _getBounds: function(matrix, options) {
            var rect = new Rectangle(this._size).setCenter(0, 0);
            return matrix ? matrix._transformBounds(rect) : rect;
        },
        _hitTestSelf: function(point) {
            if (this._contains(point)) {
                var that = this;
                return new HitResult('pixel', that, {
                    offset: point.add(that._size.divide(2)).round(),
                    color: {
                        get: function() {
                            return that.getPixel(this.offset);
                        }
                    }
                });
            }
        },
        _draw: function(ctx, param, viewMatrix) {
            var element = this.getElement();
            if (element && element.width > 0 && element.height > 0) {
                ctx.globalAlpha = Numerical.clamp(this._opacity, 0, 1);
                this._setStyles(ctx, param, viewMatrix);
                var smoothing = this._smoothing, disabled = smoothing === 'off';
                DomElement.setPrefixed(ctx, disabled ? 'imageSmoothingEnabled' : 'imageSmoothingQuality', disabled ? false : smoothing);
                ctx.drawImage(element, -this._size.width / 2, -this._size.height / 2);
            }
        },
        _canComposite: function() {
            return true;
        }
    });
    var SymbolItem = Item.extend({
        _class: 'SymbolItem',
        _applyMatrix: false,
        _canApplyMatrix: false,
        _boundsOptions: {
            stroke: true
        },
        _serializeFields: {
            symbol: null
        },
        initialize: function SymbolItem(arg0, arg1) {
            if (!this._initialize(arg0, arg1 !== undefined && Point.read(arguments, 1))) this.setDefinition(arg0 instanceof SymbolDefinition ? arg0 : new SymbolDefinition(arg0));
        },
        _equals: function(item) {
            return this._definition === item._definition;
        },
        copyContent: function(source) {
            this.setDefinition(source._definition);
        },
        getDefinition: function() {
            return this._definition;
        },
        setDefinition: function(definition) {
            this._definition = definition;
            this._changed(9);
        },
        getSymbol: '#getDefinition',
        setSymbol: '#setDefinition',
        isEmpty: function() {
            return this._definition._item.isEmpty();
        },
        _getBounds: function(matrix, options) {
            var item = this._definition._item;
            return item._getCachedBounds(item._matrix.prepended(matrix), options);
        },
        _hitTestSelf: function(point, options, viewMatrix) {
            var opts = options.extend({
                all: false
            });
            var res = this._definition._item._hitTest(point, opts, viewMatrix);
            if (res) res.item = this;
            return res;
        },
        _draw: function(ctx, param) {
            this._definition._item.draw(ctx, param);
        }
    });
    var SymbolDefinition = Base.extend({
        _class: 'SymbolDefinition',
        initialize: function SymbolDefinition(item, dontCenter) {
            this._id = UID.get();
            this.project = paper.project;
            if (item) this.setItem(item, dontCenter);
        },
        _serialize: function(options, dictionary) {
            return dictionary.add(this, function() {
                return Base.serialize([
                    this._class,
                    this._item
                ], options, false, dictionary);
            });
        },
        _changed: function(flags) {
            if (flags & 8) Item._clearBoundsCache(this);
            if (flags & 1) this.project._changed(flags);
        },
        getItem: function() {
            return this._item;
        },
        setItem: function(item, _dontCenter) {
            if (item._symbol) item = item.clone();
            if (this._item) this._item._symbol = null;
            this._item = item;
            item.remove();
            item.setSelected(false);
            if (!_dontCenter) item.setPosition(new Point());
            item._symbol = this;
            this._changed(9);
        },
        getDefinition: '#getItem',
        setDefinition: '#setItem',
        place: function(position) {
            return new SymbolItem(this, position);
        },
        clone: function() {
            return new SymbolDefinition(this._item.clone(false));
        },
        equals: function(symbol) {
            return symbol === this || symbol && this._item.equals(symbol._item) || false;
        }
    });
    var HitResult = Base.extend({
        _class: 'HitResult',
        initialize: function HitResult(type, item, values) {
            this.type = type;
            this.item = item;
            if (values) this.inject(values);
        },
        statics: {
            getOptions: function(args) {
                var options = args && Base.read(args);
                return new Base({
                    type: null,
                    tolerance: paper.settings.hitTolerance,
                    fill: !options,
                    stroke: !options,
                    segments: !options,
                    handles: false,
                    ends: false,
                    position: false,
                    center: false,
                    bounds: false,
                    guides: false,
                    selected: false
                }, options);
            }
        }
    });
    var Segment = Base.extend({
        _class: 'Segment',
        beans: true,
        _selection: 0,
        initialize: function Segment(arg0, arg1, arg2, arg3, arg4, arg5) {
            var count = arguments.length, point, handleIn, handleOut, selection;
            if (count > 0) {
                if (arg0 == null || typeof arg0 === 'object') {
                    if (count === 1 && arg0 && 'point' in arg0) {
                        point = arg0.point;
                        handleIn = arg0.handleIn;
                        handleOut = arg0.handleOut;
                        selection = arg0.selection;
                    } else {
                        point = arg0;
                        handleIn = arg1;
                        handleOut = arg2;
                        selection = arg3;
                    }
                } else {
                    point = [
                        arg0,
                        arg1
                    ];
                    handleIn = arg2 !== undefined ? [
                        arg2,
                        arg3
                    ] : null;
                    handleOut = arg4 !== undefined ? [
                        arg4,
                        arg5
                    ] : null;
                }
            }
            new SegmentPoint(point, this, '_point');
            new SegmentPoint(handleIn, this, '_handleIn');
            new SegmentPoint(handleOut, this, '_handleOut');
            if (selection) this.setSelection(selection);
        },
        _serialize: function(options, dictionary) {
            var point = this._point, selection = this._selection, obj = selection || this.hasHandles() ? [
                point,
                this._handleIn,
                this._handleOut
            ] : point;
            if (selection) obj.push(selection);
            return Base.serialize(obj, options, true, dictionary);
        },
        _changed: function(point) {
            var path = this._path;
            if (!path) return;
            var curves = path._curves, index = this._index, curve;
            if (curves) {
                if ((!point || point === this._point || point === this._handleIn) && (curve = index > 0 ? curves[index - 1] : path._closed ? curves[curves.length - 1] : null)) curve._changed();
                if ((!point || point === this._point || point === this._handleOut) && (curve = curves[index])) curve._changed();
            }
            path._changed(41);
        },
        getPoint: function() {
            return this._point;
        },
        setPoint: function() {
            this._point.set(Point.read(arguments));
        },
        getHandleIn: function() {
            return this._handleIn;
        },
        setHandleIn: function() {
            this._handleIn.set(Point.read(arguments));
        },
        getHandleOut: function() {
            return this._handleOut;
        },
        setHandleOut: function() {
            this._handleOut.set(Point.read(arguments));
        },
        hasHandles: function() {
            return !this._handleIn.isZero() || !this._handleOut.isZero();
        },
        isSmooth: function() {
            var handleIn = this._handleIn, handleOut = this._handleOut;
            return !handleIn.isZero() && !handleOut.isZero() && handleIn.isCollinear(handleOut);
        },
        clearHandles: function() {
            this._handleIn._set(0, 0);
            this._handleOut._set(0, 0);
        },
        getSelection: function() {
            return this._selection;
        },
        setSelection: function(selection) {
            var oldSelection = this._selection, path = this._path;
            this._selection = selection = selection || 0;
            if (path && selection !== oldSelection) {
                path._updateSelection(this, oldSelection, selection);
                path._changed(257);
            }
        },
        _changeSelection: function(flag, selected) {
            var selection = this._selection;
            this.setSelection(selected ? selection | flag : selection & ~flag);
        },
        isSelected: function() {
            return !!(this._selection & 7);
        },
        setSelected: function(selected) {
            this._changeSelection(7, selected);
        },
        getIndex: function() {
            return this._index !== undefined ? this._index : null;
        },
        getPath: function() {
            return this._path || null;
        },
        getCurve: function() {
            var path = this._path, index = this._index;
            if (path) {
                if (index > 0 && !path._closed && index === path._segments.length - 1) index--;
                return path.getCurves()[index] || null;
            }
            return null;
        },
        getLocation: function() {
            var curve = this.getCurve();
            return curve ? new CurveLocation(curve, this === curve._segment1 ? 0 : 1) : null;
        },
        getNext: function() {
            var segments = this._path && this._path._segments;
            return segments && (segments[this._index + 1] || this._path._closed && segments[0]) || null;
        },
        smooth: function(options, _first, _last) {
            var opts = options || {}, type = opts.type, factor = opts.factor, prev = this.getPrevious(), next = this.getNext(), p0 = (prev || this)._point, p1 = this._point, p2 = (next || this)._point, d1 = p0.getDistance(p1), d2 = p1.getDistance(p2);
            if (!type || type === 'catmull-rom') {
                var a = factor === undefined ? 0.5 : factor, d1_a = Math.pow(d1, a), d1_2a = d1_a * d1_a, d2_a = Math.pow(d2, a), d2_2a = d2_a * d2_a;
                if (!_first && prev) {
                    var A = 2 * d2_2a + 3 * d2_a * d1_a + d1_2a, N = 3 * d2_a * (d2_a + d1_a);
                    this.setHandleIn(N !== 0 ? new Point((d2_2a * p0._x + A * p1._x - d1_2a * p2._x) / N - p1._x, (d2_2a * p0._y + A * p1._y - d1_2a * p2._y) / N - p1._y) : new Point());
                }
                if (!_last && next) {
                    var A = 2 * d1_2a + 3 * d1_a * d2_a + d2_2a, N = 3 * d1_a * (d1_a + d2_a);
                    this.setHandleOut(N !== 0 ? new Point((d1_2a * p2._x + A * p1._x - d2_2a * p0._x) / N - p1._x, (d1_2a * p2._y + A * p1._y - d2_2a * p0._y) / N - p1._y) : new Point());
                }
            } else if (type === 'geometric') {
                if (prev && next) {
                    var vector = p0.subtract(p2), t = factor === undefined ? 0.4 : factor, k = t * d1 / (d1 + d2);
                    if (!_first) this.setHandleIn(vector.multiply(k));
                    if (!_last) this.setHandleOut(vector.multiply(k - t));
                }
            } else throw new Error('Smoothing method \'' + type + '\' not supported.');
        },
        getPrevious: function() {
            var segments = this._path && this._path._segments;
            return segments && (segments[this._index - 1] || this._path._closed && segments[segments.length - 1]) || null;
        },
        isFirst: function() {
            return !this._index;
        },
        isLast: function() {
            var path = this._path;
            return path && this._index === path._segments.length - 1 || false;
        },
        reverse: function() {
            var handleIn = this._handleIn, handleOut = this._handleOut, tmp = handleIn.clone();
            handleIn.set(handleOut);
            handleOut.set(tmp);
        },
        reversed: function() {
            return new Segment(this._point, this._handleOut, this._handleIn);
        },
        remove: function() {
            return this._path ? !!this._path.removeSegment(this._index) : false;
        },
        clone: function() {
            return new Segment(this._point, this._handleIn, this._handleOut);
        },
        equals: function(segment) {
            return segment === this || segment && this._class === segment._class && this._point.equals(segment._point) && this._handleIn.equals(segment._handleIn) && this._handleOut.equals(segment._handleOut) || false;
        },
        toString: function() {
            var parts = [
                'point: ' + this._point
            ];
            if (!this._handleIn.isZero()) parts.push('handleIn: ' + this._handleIn);
            if (!this._handleOut.isZero()) parts.push('handleOut: ' + this._handleOut);
            return '{ ' + parts.join(', ') + ' }';
        },
        transform: function(matrix) {
            this._transformCoordinates(matrix, new Array(6), true);
            this._changed();
        },
        interpolate: function(from, to, factor) {
            var u = 1 - factor, v = factor, point1 = from._point, point2 = to._point, handleIn1 = from._handleIn, handleIn2 = to._handleIn, handleOut2 = to._handleOut, handleOut1 = from._handleOut;
            this._point._set(u * point1._x + v * point2._x, u * point1._y + v * point2._y, true);
            this._handleIn._set(u * handleIn1._x + v * handleIn2._x, u * handleIn1._y + v * handleIn2._y, true);
            this._handleOut._set(u * handleOut1._x + v * handleOut2._x, u * handleOut1._y + v * handleOut2._y, true);
            this._changed();
        },
        _transformCoordinates: function(matrix, coords, change) {
            var point = this._point, handleIn = !change || !this._handleIn.isZero() ? this._handleIn : null, handleOut = !change || !this._handleOut.isZero() ? this._handleOut : null, x = point._x, y = point._y, i = 2;
            coords[0] = x;
            coords[1] = y;
            if (handleIn) {
                coords[i++] = handleIn._x + x;
                coords[i++] = handleIn._y + y;
            }
            if (handleOut) {
                coords[i++] = handleOut._x + x;
                coords[i++] = handleOut._y + y;
            }
            if (matrix) {
                matrix._transformCoordinates(coords, coords, i / 2);
                x = coords[0];
                y = coords[1];
                if (change) {
                    point._x = x;
                    point._y = y;
                    i = 2;
                    if (handleIn) {
                        handleIn._x = coords[i++] - x;
                        handleIn._y = coords[i++] - y;
                    }
                    if (handleOut) {
                        handleOut._x = coords[i++] - x;
                        handleOut._y = coords[i++] - y;
                    }
                } else {
                    if (!handleIn) {
                        coords[i++] = x;
                        coords[i++] = y;
                    }
                    if (!handleOut) {
                        coords[i++] = x;
                        coords[i++] = y;
                    }
                }
            }
            return coords;
        }
    });
    var SegmentPoint = Point.extend({
        initialize: function SegmentPoint(point, owner, key) {
            var x, y, selected;
            if (!point) x = y = 0;
            else if ((x = point[0]) !== undefined) y = point[1];
            else {
                var pt = point;
                if ((x = pt.x) === undefined) {
                    pt = Point.read(arguments);
                    x = pt.x;
                }
                y = pt.y;
                selected = pt.selected;
            }
            this._x = x;
            this._y = y;
            this._owner = owner;
            owner[key] = this;
            if (selected) this.setSelected(true);
        },
        _set: function(x, y) {
            this._x = x;
            this._y = y;
            this._owner._changed(this);
            return this;
        },
        getX: function() {
            return this._x;
        },
        setX: function(x) {
            this._x = x;
            this._owner._changed(this);
        },
        getY: function() {
            return this._y;
        },
        setY: function(y) {
            this._y = y;
            this._owner._changed(this);
        },
        isZero: function() {
            var isZero = Numerical.isZero;
            return isZero(this._x) && isZero(this._y);
        },
        isSelected: function() {
            return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(selected) {
            this._owner._changeSelection(this._getSelection(), selected);
        },
        _getSelection: function() {
            var owner = this._owner;
            return this === owner._point ? 1 : this === owner._handleIn ? 2 : this === owner._handleOut ? 4 : 0;
        }
    });
    var Curve = Base.extend({
        _class: 'Curve',
        beans: true,
        initialize: function Curve(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            var count = arguments.length, seg1, seg2, point1, point2, handle1, handle2;
            if (count === 3) {
                this._path = arg0;
                seg1 = arg1;
                seg2 = arg2;
            } else if (!count) {
                seg1 = new Segment();
                seg2 = new Segment();
            } else if (count === 1) {
                if ('segment1' in arg0) {
                    seg1 = new Segment(arg0.segment1);
                    seg2 = new Segment(arg0.segment2);
                } else if ('point1' in arg0) {
                    point1 = arg0.point1;
                    handle1 = arg0.handle1;
                    handle2 = arg0.handle2;
                    point2 = arg0.point2;
                } else if (Array.isArray(arg0)) {
                    point1 = [
                        arg0[0],
                        arg0[1]
                    ];
                    point2 = [
                        arg0[6],
                        arg0[7]
                    ];
                    handle1 = [
                        arg0[2] - arg0[0],
                        arg0[3] - arg0[1]
                    ];
                    handle2 = [
                        arg0[4] - arg0[6],
                        arg0[5] - arg0[7]
                    ];
                }
            } else if (count === 2) {
                seg1 = new Segment(arg0);
                seg2 = new Segment(arg1);
            } else if (count === 4) {
                point1 = arg0;
                handle1 = arg1;
                handle2 = arg2;
                point2 = arg3;
            } else if (count === 8) {
                point1 = [
                    arg0,
                    arg1
                ];
                point2 = [
                    arg6,
                    arg7
                ];
                handle1 = [
                    arg2 - arg0,
                    arg3 - arg1
                ];
                handle2 = [
                    arg4 - arg6,
                    arg5 - arg7
                ];
            }
            this._segment1 = seg1 || new Segment(point1, null, handle1);
            this._segment2 = seg2 || new Segment(point2, handle2, null);
        },
        _serialize: function(options, dictionary) {
            return Base.serialize(this.hasHandles() ? [
                this.getPoint1(),
                this.getHandle1(),
                this.getHandle2(),
                this.getPoint2()
            ] : [
                this.getPoint1(),
                this.getPoint2()
            ], options, true, dictionary);
        },
        _changed: function() {
            this._length = this._bounds = undefined;
        },
        clone: function() {
            return new Curve(this._segment1, this._segment2);
        },
        toString: function() {
            var parts = [
                'point1: ' + this._segment1._point
            ];
            if (!this._segment1._handleOut.isZero()) parts.push('handle1: ' + this._segment1._handleOut);
            if (!this._segment2._handleIn.isZero()) parts.push('handle2: ' + this._segment2._handleIn);
            parts.push('point2: ' + this._segment2._point);
            return '{ ' + parts.join(', ') + ' }';
        },
        classify: function() {
            return Curve.classify(this.getValues());
        },
        remove: function() {
            var removed = false;
            if (this._path) {
                var segment2 = this._segment2, handleOut = segment2._handleOut;
                removed = segment2.remove();
                if (removed) this._segment1._handleOut.set(handleOut);
            }
            return removed;
        },
        getPoint1: function() {
            return this._segment1._point;
        },
        setPoint1: function() {
            this._segment1._point.set(Point.read(arguments));
        },
        getPoint2: function() {
            return this._segment2._point;
        },
        setPoint2: function() {
            this._segment2._point.set(Point.read(arguments));
        },
        getHandle1: function() {
            return this._segment1._handleOut;
        },
        setHandle1: function() {
            this._segment1._handleOut.set(Point.read(arguments));
        },
        getHandle2: function() {
            return this._segment2._handleIn;
        },
        setHandle2: function() {
            this._segment2._handleIn.set(Point.read(arguments));
        },
        getSegment1: function() {
            return this._segment1;
        },
        getSegment2: function() {
            return this._segment2;
        },
        getPath: function() {
            return this._path;
        },
        getIndex: function() {
            return this._segment1._index;
        },
        getNext: function() {
            var curves = this._path && this._path._curves;
            return curves && (curves[this._segment1._index + 1] || this._path._closed && curves[0]) || null;
        },
        getPrevious: function() {
            var curves = this._path && this._path._curves;
            return curves && (curves[this._segment1._index - 1] || this._path._closed && curves[curves.length - 1]) || null;
        },
        isFirst: function() {
            return !this._segment1._index;
        },
        isLast: function() {
            var path = this._path;
            return path && this._segment1._index === path._curves.length - 1 || false;
        },
        isSelected: function() {
            return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(selected) {
            this.getPoint1().setSelected(selected);
            this.getHandle1().setSelected(selected);
            this.getHandle2().setSelected(selected);
            this.getPoint2().setSelected(selected);
        },
        getValues: function(matrix) {
            return Curve.getValues(this._segment1, this._segment2, matrix);
        },
        getPoints: function() {
            var coords = this.getValues(), points = [];
            for(var i = 0; i < 8; i += 2)points.push(new Point(coords[i], coords[i + 1]));
            return points;
        }
    }, {
        getLength: function() {
            if (this._length == null) this._length = Curve.getLength(this.getValues(), 0, 1);
            return this._length;
        },
        getArea: function() {
            return Curve.getArea(this.getValues());
        },
        getLine: function() {
            return new Line(this._segment1._point, this._segment2._point);
        },
        getPart: function(from, to) {
            return new Curve(Curve.getPart(this.getValues(), from, to));
        },
        getPartLength: function(from, to) {
            return Curve.getLength(this.getValues(), from, to);
        },
        divideAt: function(location) {
            return this.divideAtTime(location && location.curve === this ? location.time : this.getTimeAt(location));
        },
        divideAtTime: function(time, _setHandles) {
            var tMin = 1e-8, tMax = 1 - tMin, res = null;
            if (time >= tMin && time <= tMax) {
                var parts = Curve.subdivide(this.getValues(), time), left = parts[0], right = parts[1], setHandles = _setHandles || this.hasHandles(), seg1 = this._segment1, seg2 = this._segment2, path = this._path;
                if (setHandles) {
                    seg1._handleOut._set(left[2] - left[0], left[3] - left[1]);
                    seg2._handleIn._set(right[4] - right[6], right[5] - right[7]);
                }
                var x = left[6], y = left[7], segment = new Segment(new Point(x, y), setHandles && new Point(left[4] - x, left[5] - y), setHandles && new Point(right[2] - x, right[3] - y));
                if (path) {
                    path.insert(seg1._index + 1, segment);
                    res = this.getNext();
                } else {
                    this._segment2 = segment;
                    this._changed();
                    res = new Curve(segment, seg2);
                }
            }
            return res;
        },
        splitAt: function(location) {
            var path = this._path;
            return path ? path.splitAt(location) : null;
        },
        splitAtTime: function(time) {
            return this.splitAt(this.getLocationAtTime(time));
        },
        divide: function(offset, isTime) {
            return this.divideAtTime(offset === undefined ? 0.5 : isTime ? offset : this.getTimeAt(offset));
        },
        split: function(offset, isTime) {
            return this.splitAtTime(offset === undefined ? 0.5 : isTime ? offset : this.getTimeAt(offset));
        },
        reversed: function() {
            return new Curve(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
            this._segment1._handleOut._set(0, 0);
            this._segment2._handleIn._set(0, 0);
        },
        statics: {
            getValues: function(segment1, segment2, matrix, straight) {
                var p1 = segment1._point, h1 = segment1._handleOut, h2 = segment2._handleIn, p2 = segment2._point, x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, values = straight ? [
                    x1,
                    y1,
                    x1,
                    y1,
                    x2,
                    y2,
                    x2,
                    y2
                ] : [
                    x1,
                    y1,
                    x1 + h1._x,
                    y1 + h1._y,
                    x2 + h2._x,
                    y2 + h2._y,
                    x2,
                    y2
                ];
                if (matrix) matrix._transformCoordinates(values, values, 4);
                return values;
            },
            subdivide: function(v, t) {
                var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7];
                if (t === undefined) t = 0.5;
                var u = 1 - t, x4 = u * x0 + t * x1, y4 = u * y0 + t * y1, x5 = u * x1 + t * x2, y5 = u * y1 + t * y2, x6 = u * x2 + t * x3, y6 = u * y2 + t * y3, x7 = u * x4 + t * x5, y7 = u * y4 + t * y5, x8 = u * x5 + t * x6, y8 = u * y5 + t * y6, x9 = u * x7 + t * x8, y9 = u * y7 + t * y8;
                return [
                    [
                        x0,
                        y0,
                        x4,
                        y4,
                        x7,
                        y7,
                        x9,
                        y9
                    ],
                    [
                        x9,
                        y9,
                        x8,
                        y8,
                        x6,
                        y6,
                        x3,
                        y3
                    ]
                ];
            },
            getMonoCurves: function(v, dir) {
                var curves = [], io = dir ? 0 : 1, o0 = v[io + 0], o1 = v[io + 2], o2 = v[io + 4], o3 = v[io + 6];
                if (o0 >= o1 === o1 >= o2 && o1 >= o2 === o2 >= o3 || Curve.isStraight(v)) curves.push(v);
                else {
                    var a = 3 * (o1 - o2) - o0 + o3, b = 2 * (o0 + o2) - 4 * o1, c = o1 - o0, tMin = 1e-8, tMax = 1 - tMin, roots = [], n = Numerical.solveQuadratic(a, b, c, roots, tMin, tMax);
                    if (!n) curves.push(v);
                    else {
                        roots.sort();
                        var t = roots[0], parts = Curve.subdivide(v, t);
                        curves.push(parts[0]);
                        if (n > 1) {
                            t = (roots[1] - t) / (1 - t);
                            parts = Curve.subdivide(parts[1], t);
                            curves.push(parts[0]);
                        }
                        curves.push(parts[1]);
                    }
                }
                return curves;
            },
            solveCubic: function(v, coord, val, roots, min, max) {
                var v0 = v[coord], v1 = v[coord + 2], v2 = v[coord + 4], v3 = v[coord + 6], res = 0;
                if (!(v0 < val && v3 < val && v1 < val && v2 < val || v0 > val && v3 > val && v1 > val && v2 > val)) {
                    var c = 3 * (v1 - v0), b = 3 * (v2 - v1) - c, a = v3 - v0 - c - b;
                    res = Numerical.solveCubic(a, b, c, v0 - val, roots, min, max);
                }
                return res;
            },
            getTimeOf: function(v, point) {
                var p0 = new Point(v[0], v[1]), p3 = new Point(v[6], v[7]), epsilon = 1e-12, geomEpsilon = 1e-7, t = point.isClose(p0, epsilon) ? 0 : point.isClose(p3, epsilon) ? 1 : null;
                if (t === null) {
                    var coords = [
                        point.x,
                        point.y
                    ], roots = [];
                    for(var c = 0; c < 2; c++){
                        var count = Curve.solveCubic(v, c, coords[c], roots, 0, 1);
                        for(var i = 0; i < count; i++){
                            var u = roots[i];
                            if (point.isClose(Curve.getPoint(v, u), geomEpsilon)) return u;
                        }
                    }
                }
                return point.isClose(p0, geomEpsilon) ? 0 : point.isClose(p3, geomEpsilon) ? 1 : null;
            },
            getNearestTime: function(v, point) {
                if (Curve.isStraight(v)) {
                    var x0 = v[0], y0 = v[1], x3 = v[6], y3 = v[7], vx = x3 - x0, vy = y3 - y0, det = vx * vx + vy * vy;
                    if (det === 0) return 0;
                    var u = ((point.x - x0) * vx + (point.y - y0) * vy) / det;
                    return u < 1e-12 ? 0 : u > 0.999999999999 ? 1 : Curve.getTimeOf(v, new Point(x0 + u * vx, y0 + u * vy));
                }
                var count = 100, minDist = Infinity, minT = 0;
                function refine(t) {
                    if (t >= 0 && t <= 1) {
                        var dist = point.getDistance(Curve.getPoint(v, t), true);
                        if (dist < minDist) {
                            minDist = dist;
                            minT = t;
                            return true;
                        }
                    }
                }
                for(var i = 0; i <= count; i++)refine(i / count);
                var step = 1 / (count * 2);
                while(step > 1e-8)if (!refine(minT - step) && !refine(minT + step)) step /= 2;
                return minT;
            },
            getPart: function(v, from, to) {
                var flip = from > to;
                if (flip) {
                    var tmp = from;
                    from = to;
                    to = tmp;
                }
                if (from > 0) v = Curve.subdivide(v, from)[1];
                if (to < 1) v = Curve.subdivide(v, (to - from) / (1 - from))[0];
                return flip ? [
                    v[6],
                    v[7],
                    v[4],
                    v[5],
                    v[2],
                    v[3],
                    v[0],
                    v[1]
                ] : v;
            },
            isFlatEnough: function(v, flatness) {
                var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], ux = 3 * x1 - 2 * x0 - x3, uy = 3 * y1 - 2 * y0 - y3, vx = 3 * x2 - 2 * x3 - x0, vy = 3 * y2 - 2 * y3 - y0;
                return Math.max(ux * ux, vx * vx) + Math.max(uy * uy, vy * vy) <= 16 * flatness * flatness;
            },
            getArea: function(v) {
                var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7];
                return 3 * ((y3 - y0) * (x1 + x2) - (x3 - x0) * (y1 + y2) + y1 * (x0 - x2) - x1 * (y0 - y2) + y3 * (x2 + x0 / 3) - x3 * (y2 + y0 / 3)) / 20;
            },
            getBounds: function(v) {
                var min = v.slice(0, 2), max = min.slice(), roots = [
                    0,
                    0
                ];
                for(var i = 0; i < 2; i++)Curve._addBounds(v[i], v[i + 2], v[i + 4], v[i + 6], i, 0, min, max, roots);
                return new Rectangle(min[0], min[1], max[0] - min[0], max[1] - min[1]);
            },
            _addBounds: function(v0, v1, v2, v3, coord, padding, min, max, roots) {
                function add(value, padding) {
                    var left = value - padding, right = value + padding;
                    if (left < min[coord]) min[coord] = left;
                    if (right > max[coord]) max[coord] = right;
                }
                padding /= 2;
                var minPad = min[coord] + padding, maxPad = max[coord] - padding;
                if (v0 < minPad || v1 < minPad || v2 < minPad || v3 < minPad || v0 > maxPad || v1 > maxPad || v2 > maxPad || v3 > maxPad) {
                    if (v1 < v0 != v1 < v3 && v2 < v0 != v2 < v3) {
                        add(v0, 0);
                        add(v3, 0);
                    } else {
                        var a = 3 * (v1 - v2) - v0 + v3, b = 2 * (v0 + v2) - 4 * v1, c = v1 - v0, count = Numerical.solveQuadratic(a, b, c, roots), tMin = 1e-8, tMax = 1 - tMin;
                        add(v3, 0);
                        for(var i = 0; i < count; i++){
                            var t = roots[i], u = 1 - t;
                            if (tMin <= t && t <= tMax) add(u * u * u * v0 + 3 * u * u * t * v1 + 3 * u * t * t * v2 + t * t * t * v3, padding);
                        }
                    }
                }
            }
        }
    }, Base.each([
        'getBounds',
        'getStrokeBounds',
        'getHandleBounds'
    ], function(name) {
        this[name] = function() {
            if (!this._bounds) this._bounds = {};
            var bounds = this._bounds[name];
            if (!bounds) bounds = this._bounds[name] = Path[name]([
                this._segment1,
                this._segment2
            ], false, this._path);
            return bounds.clone();
        };
    }, {}), Base.each({
        isStraight: function(p1, h1, h2, p2) {
            if (h1.isZero() && h2.isZero()) return true;
            else {
                var v = p2.subtract(p1);
                if (v.isZero()) return false;
                else if (v.isCollinear(h1) && v.isCollinear(h2)) {
                    var l = new Line(p1, p2), epsilon = 1e-7;
                    if (l.getDistance(p1.add(h1)) < epsilon && l.getDistance(p2.add(h2)) < epsilon) {
                        var div = v.dot(v), s1 = v.dot(h1) / div, s2 = v.dot(h2) / div;
                        return s1 >= 0 && s1 <= 1 && s2 <= 0 && s2 >= -1;
                    }
                }
            }
            return false;
        },
        isLinear: function(p1, h1, h2, p2) {
            var third = p2.subtract(p1).divide(3);
            return h1.equals(third) && h2.negate().equals(third);
        }
    }, function(test, name) {
        this[name] = function(epsilon) {
            var seg1 = this._segment1, seg2 = this._segment2;
            return test(seg1._point, seg1._handleOut, seg2._handleIn, seg2._point, epsilon);
        };
        this.statics[name] = function(v, epsilon) {
            var x0 = v[0], y0 = v[1], x3 = v[6], y3 = v[7];
            return test(new Point(x0, y0), new Point(v[2] - x0, v[3] - y0), new Point(v[4] - x3, v[5] - y3), new Point(x3, y3), epsilon);
        };
    }, {
        statics: {},
        hasHandles: function() {
            return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(epsilon) {
            return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (epsilon || 0);
        },
        isCollinear: function(curve) {
            return curve && this.isStraight() && curve.isStraight() && this.getLine().isCollinear(curve.getLine());
        },
        isHorizontal: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
    }), {
        beans: false,
        getLocationAt: function(offset, _isTime) {
            return this.getLocationAtTime(_isTime ? offset : this.getTimeAt(offset));
        },
        getLocationAtTime: function(t) {
            return t != null && t >= 0 && t <= 1 ? new CurveLocation(this, t) : null;
        },
        getTimeAt: function(offset, start) {
            return Curve.getTimeAt(this.getValues(), offset, start);
        },
        getParameterAt: '#getTimeAt',
        getTimesWithTangent: function() {
            var tangent = Point.read(arguments);
            return tangent.isZero() ? [] : Curve.getTimesWithTangent(this.getValues(), tangent);
        },
        getOffsetAtTime: function(t) {
            return this.getPartLength(0, t);
        },
        getLocationOf: function() {
            return this.getLocationAtTime(this.getTimeOf(Point.read(arguments)));
        },
        getOffsetOf: function() {
            var loc = this.getLocationOf.apply(this, arguments);
            return loc ? loc.getOffset() : null;
        },
        getTimeOf: function() {
            return Curve.getTimeOf(this.getValues(), Point.read(arguments));
        },
        getParameterOf: '#getTimeOf',
        getNearestLocation: function() {
            var point = Point.read(arguments), values = this.getValues(), t = Curve.getNearestTime(values, point), pt = Curve.getPoint(values, t);
            return new CurveLocation(this, t, pt, null, point.getDistance(pt));
        },
        getNearestPoint: function() {
            var loc = this.getNearestLocation.apply(this, arguments);
            return loc ? loc.getPoint() : loc;
        }
    }, new function() {
        var methods = [
            'getPoint',
            'getTangent',
            'getNormal',
            'getWeightedTangent',
            'getWeightedNormal',
            'getCurvature'
        ];
        return Base.each(methods, function(name) {
            this[name + 'At'] = function(location, _isTime) {
                var values = this.getValues();
                return Curve[name](values, _isTime ? location : Curve.getTimeAt(values, location));
            };
            this[name + 'AtTime'] = function(time) {
                return Curve[name](this.getValues(), time);
            };
        }, {
            statics: {
                _evaluateMethods: methods
            }
        });
    }, new function() {
        function getLengthIntegrand(v) {
            var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], ax = 9 * (x1 - x2) + 3 * (x3 - x0), bx = 6 * (x0 + x2) - 12 * x1, cx = 3 * (x1 - x0), ay = 9 * (y1 - y2) + 3 * (y3 - y0), by = 6 * (y0 + y2) - 12 * y1, cy = 3 * (y1 - y0);
            return function(t) {
                var dx = (ax * t + bx) * t + cx, dy = (ay * t + by) * t + cy;
                return Math.sqrt(dx * dx + dy * dy);
            };
        }
        function getIterations(a, b) {
            return Math.max(2, Math.min(16, Math.ceil(Math.abs(b - a) * 32)));
        }
        function evaluate(v, t, type, normalized) {
            if (t == null || t < 0 || t > 1) return null;
            var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], isZero = Numerical.isZero;
            if (isZero(x1 - x0) && isZero(y1 - y0)) {
                x1 = x0;
                y1 = y0;
            }
            if (isZero(x2 - x3) && isZero(y2 - y3)) {
                x2 = x3;
                y2 = y3;
            }
            var cx = 3 * (x1 - x0), bx = 3 * (x2 - x1) - cx, ax = x3 - x0 - cx - bx, cy = 3 * (y1 - y0), by = 3 * (y2 - y1) - cy, ay = y3 - y0 - cy - by, x, y;
            if (type === 0) {
                x = t === 0 ? x0 : t === 1 ? x3 : ((ax * t + bx) * t + cx) * t + x0;
                y = t === 0 ? y0 : t === 1 ? y3 : ((ay * t + by) * t + cy) * t + y0;
            } else {
                var tMin = 1e-8, tMax = 1 - tMin;
                if (t < tMin) {
                    x = cx;
                    y = cy;
                } else if (t > tMax) {
                    x = 3 * (x3 - x2);
                    y = 3 * (y3 - y2);
                } else {
                    x = (3 * ax * t + 2 * bx) * t + cx;
                    y = (3 * ay * t + 2 * by) * t + cy;
                }
                if (normalized) {
                    if (x === 0 && y === 0 && (t < tMin || t > tMax)) {
                        x = x2 - x1;
                        y = y2 - y1;
                    }
                    var len = Math.sqrt(x * x + y * y);
                    if (len) {
                        x /= len;
                        y /= len;
                    }
                }
                if (type === 3) {
                    var x2 = 6 * ax * t + 2 * bx, y2 = 6 * ay * t + 2 * by, d = Math.pow(x * x + y * y, 1.5);
                    x = d !== 0 ? (x * y2 - y * x2) / d : 0;
                    y = 0;
                }
            }
            return type === 2 ? new Point(y, -x) : new Point(x, y);
        }
        return {
            statics: {
                classify: function(v) {
                    var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], a1 = x0 * (y3 - y2) + y0 * (x2 - x3) + x3 * y2 - y3 * x2, a2 = x1 * (y0 - y3) + y1 * (x3 - x0) + x0 * y3 - y0 * x3, a3 = x2 * (y1 - y0) + y2 * (x0 - x1) + x1 * y0 - y1 * x0, d3 = 3 * a3, d2 = d3 - a2, d1 = d2 - a2 + a1, l = Math.sqrt(d1 * d1 + d2 * d2 + d3 * d3), s = l !== 0 ? 1 / l : 0, isZero = Numerical.isZero, serpentine = 'serpentine';
                    d1 *= s;
                    d2 *= s;
                    d3 *= s;
                    function type(type, t1, t2) {
                        var hasRoots = t1 !== undefined, t1Ok = hasRoots && t1 > 0 && t1 < 1, t2Ok = hasRoots && t2 > 0 && t2 < 1;
                        if (hasRoots && (!(t1Ok || t2Ok) || type === 'loop' && !(t1Ok && t2Ok))) {
                            type = 'arch';
                            t1Ok = t2Ok = false;
                        }
                        return {
                            type: type,
                            roots: t1Ok || t2Ok ? t1Ok && t2Ok ? t1 < t2 ? [
                                t1,
                                t2
                            ] : [
                                t2,
                                t1
                            ] : [
                                t1Ok ? t1 : t2
                            ] : null
                        };
                    }
                    if (isZero(d1)) return isZero(d2) ? type(isZero(d3) ? 'line' : 'quadratic') : type(serpentine, d3 / (3 * d2));
                    var d = 3 * d2 * d2 - 4 * d1 * d3;
                    if (isZero(d)) return type('cusp', d2 / (2 * d1));
                    var f1 = d > 0 ? Math.sqrt(d / 3) : Math.sqrt(-d), f2 = 2 * d1;
                    return type(d > 0 ? serpentine : 'loop', (d2 + f1) / f2, (d2 - f1) / f2);
                },
                getLength: function(v, a, b, ds) {
                    if (a === undefined) a = 0;
                    if (b === undefined) b = 1;
                    if (Curve.isStraight(v)) {
                        var c = v;
                        if (b < 1) {
                            c = Curve.subdivide(c, b)[0];
                            a /= b;
                        }
                        if (a > 0) c = Curve.subdivide(c, a)[1];
                        var dx = c[6] - c[0], dy = c[7] - c[1];
                        return Math.sqrt(dx * dx + dy * dy);
                    }
                    return Numerical.integrate(ds || getLengthIntegrand(v), a, b, getIterations(a, b));
                },
                getTimeAt: function(v, offset, start) {
                    if (start === undefined) start = offset < 0 ? 1 : 0;
                    if (offset === 0) return start;
                    var abs = Math.abs, epsilon = 1e-12, forward = offset > 0, a = forward ? start : 0, b = forward ? 1 : start, ds = getLengthIntegrand(v), rangeLength = Curve.getLength(v, a, b, ds), diff = abs(offset) - rangeLength;
                    if (abs(diff) < epsilon) return forward ? b : a;
                    else if (diff > epsilon) return null;
                    var guess = offset / rangeLength, length = 0;
                    function f(t) {
                        length += Numerical.integrate(ds, start, t, getIterations(start, t));
                        start = t;
                        return length - offset;
                    }
                    return Numerical.findRoot(f, ds, start + guess, a, b, 32, 1e-12);
                },
                getPoint: function(v, t) {
                    return evaluate(v, t, 0, false);
                },
                getTangent: function(v, t) {
                    return evaluate(v, t, 1, true);
                },
                getWeightedTangent: function(v, t) {
                    return evaluate(v, t, 1, false);
                },
                getNormal: function(v, t) {
                    return evaluate(v, t, 2, true);
                },
                getWeightedNormal: function(v, t) {
                    return evaluate(v, t, 2, false);
                },
                getCurvature: function(v, t) {
                    return evaluate(v, t, 3, false).x;
                },
                getPeaks: function(v) {
                    var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], ax = -x0 + 3 * x1 - 3 * x2 + x3, bx = 3 * x0 - 6 * x1 + 3 * x2, cx = -3 * x0 + 3 * x1, ay = -y0 + 3 * y1 - 3 * y2 + y3, by = 3 * y0 - 6 * y1 + 3 * y2, cy = -3 * y0 + 3 * y1, tMin = 1e-8, tMax = 1 - tMin, roots = [];
                    Numerical.solveCubic(9 * (ax * ax + ay * ay), 9 * (ax * bx + by * ay), 2 * (bx * bx + by * by) + 3 * (cx * ax + cy * ay), cx * bx + by * cy, roots, tMin, tMax);
                    return roots.sort();
                }
            }
        };
    }, new function() {
        function addLocation(locations, include, c1, t1, c2, t2, overlap) {
            var excludeStart = !overlap && c1.getPrevious() === c2, excludeEnd = !overlap && c1 !== c2 && c1.getNext() === c2, tMin = 1e-8, tMax = 1 - tMin;
            if (t1 !== null && t1 >= (excludeStart ? tMin : 0) && t1 <= (excludeEnd ? tMax : 1)) {
                if (t2 !== null && t2 >= (excludeEnd ? tMin : 0) && t2 <= (excludeStart ? tMax : 1)) {
                    var loc1 = new CurveLocation(c1, t1, null, overlap), loc2 = new CurveLocation(c2, t2, null, overlap);
                    loc1._intersection = loc2;
                    loc2._intersection = loc1;
                    if (!include || include(loc1)) CurveLocation.insert(locations, loc1, true);
                }
            }
        }
        function addCurveIntersections(v1, v2, c1, c2, locations, include, flip, recursion, calls, tMin, tMax, uMin, uMax) {
            if (++calls >= 4096 || ++recursion >= 40) return calls;
            var fatLineEpsilon = 1e-9, q0x = v2[0], q0y = v2[1], q3x = v2[6], q3y = v2[7], getSignedDistance = Line.getSignedDistance, d1 = getSignedDistance(q0x, q0y, q3x, q3y, v2[2], v2[3]), d2 = getSignedDistance(q0x, q0y, q3x, q3y, v2[4], v2[5]), factor = d1 * d2 > 0 ? 3 / 4 : 4 / 9, dMin = factor * Math.min(0, d1, d2), dMax = factor * Math.max(0, d1, d2), dp0 = getSignedDistance(q0x, q0y, q3x, q3y, v1[0], v1[1]), dp1 = getSignedDistance(q0x, q0y, q3x, q3y, v1[2], v1[3]), dp2 = getSignedDistance(q0x, q0y, q3x, q3y, v1[4], v1[5]), dp3 = getSignedDistance(q0x, q0y, q3x, q3y, v1[6], v1[7]), hull = getConvexHull(dp0, dp1, dp2, dp3), top = hull[0], bottom = hull[1], tMinClip, tMaxClip;
            if (d1 === 0 && d2 === 0 && dp0 === 0 && dp1 === 0 && dp2 === 0 && dp3 === 0 || (tMinClip = clipConvexHull(top, bottom, dMin, dMax)) == null || (tMaxClip = clipConvexHull(top.reverse(), bottom.reverse(), dMin, dMax)) == null) return calls;
            var tMinNew = tMin + (tMax - tMin) * tMinClip, tMaxNew = tMin + (tMax - tMin) * tMaxClip;
            if (Math.max(uMax - uMin, tMaxNew - tMinNew) < fatLineEpsilon) {
                var t = (tMinNew + tMaxNew) / 2, u = (uMin + uMax) / 2;
                addLocation(locations, include, flip ? c2 : c1, flip ? u : t, flip ? c1 : c2, flip ? t : u);
            } else {
                v1 = Curve.getPart(v1, tMinClip, tMaxClip);
                var uDiff = uMax - uMin;
                if (tMaxClip - tMinClip > 0.8) {
                    if (tMaxNew - tMinNew > uDiff) {
                        var parts = Curve.subdivide(v1, 0.5), t = (tMinNew + tMaxNew) / 2;
                        calls = addCurveIntersections(v2, parts[0], c2, c1, locations, include, !flip, recursion, calls, uMin, uMax, tMinNew, t);
                        calls = addCurveIntersections(v2, parts[1], c2, c1, locations, include, !flip, recursion, calls, uMin, uMax, t, tMaxNew);
                    } else {
                        var parts = Curve.subdivide(v2, 0.5), u = (uMin + uMax) / 2;
                        calls = addCurveIntersections(parts[0], v1, c2, c1, locations, include, !flip, recursion, calls, uMin, u, tMinNew, tMaxNew);
                        calls = addCurveIntersections(parts[1], v1, c2, c1, locations, include, !flip, recursion, calls, u, uMax, tMinNew, tMaxNew);
                    }
                } else if (uDiff === 0 || uDiff >= fatLineEpsilon) calls = addCurveIntersections(v2, v1, c2, c1, locations, include, !flip, recursion, calls, uMin, uMax, tMinNew, tMaxNew);
                else calls = addCurveIntersections(v1, v2, c1, c2, locations, include, flip, recursion, calls, tMinNew, tMaxNew, uMin, uMax);
            }
            return calls;
        }
        function getConvexHull(dq0, dq1, dq2, dq3) {
            var p0 = [
                0,
                dq0
            ], p1 = [
                1 / 3,
                dq1
            ], p2 = [
                2 / 3,
                dq2
            ], p3 = [
                1,
                dq3
            ], dist1 = dq1 - (2 * dq0 + dq3) / 3, dist2 = dq2 - (dq0 + 2 * dq3) / 3, hull;
            if (dist1 * dist2 < 0) hull = [
                [
                    p0,
                    p1,
                    p3
                ],
                [
                    p0,
                    p2,
                    p3
                ]
            ];
            else {
                var distRatio = dist1 / dist2;
                hull = [
                    distRatio >= 2 ? [
                        p0,
                        p1,
                        p3
                    ] : distRatio <= 0.5 ? [
                        p0,
                        p2,
                        p3
                    ] : [
                        p0,
                        p1,
                        p2,
                        p3
                    ],
                    [
                        p0,
                        p3
                    ]
                ];
            }
            return (dist1 || dist2) < 0 ? hull.reverse() : hull;
        }
        function clipConvexHull(hullTop, hullBottom, dMin, dMax) {
            if (hullTop[0][1] < dMin) return clipConvexHullPart(hullTop, true, dMin);
            else if (hullBottom[0][1] > dMax) return clipConvexHullPart(hullBottom, false, dMax);
            else return hullTop[0][0];
        }
        function clipConvexHullPart(part, top, threshold) {
            var px = part[0][0], py = part[0][1];
            for(var i = 1, l = part.length; i < l; i++){
                var qx = part[i][0], qy = part[i][1];
                if (top ? qy >= threshold : qy <= threshold) return qy === threshold ? qx : px + (threshold - py) * (qx - px) / (qy - py);
                px = qx;
                py = qy;
            }
            return null;
        }
        function getCurveLineIntersections(v, px, py, vx, vy) {
            var isZero = Numerical.isZero;
            if (isZero(vx) && isZero(vy)) {
                var t = Curve.getTimeOf(v, new Point(px, py));
                return t === null ? [] : [
                    t
                ];
            }
            var angle = Math.atan2(-vy, vx), sin = Math.sin(angle), cos = Math.cos(angle), rv = [], roots = [];
            for(var i = 0; i < 8; i += 2){
                var x = v[i] - px, y = v[i + 1] - py;
                rv.push(x * cos - y * sin, x * sin + y * cos);
            }
            Curve.solveCubic(rv, 1, 0, roots, 0, 1);
            return roots;
        }
        function addCurveLineIntersections(v1, v2, c1, c2, locations, include, flip) {
            var x1 = v2[0], y1 = v2[1], x2 = v2[6], y2 = v2[7], roots = getCurveLineIntersections(v1, x1, y1, x2 - x1, y2 - y1);
            for(var i = 0, l = roots.length; i < l; i++){
                var t1 = roots[i], p1 = Curve.getPoint(v1, t1), t2 = Curve.getTimeOf(v2, p1);
                if (t2 !== null) addLocation(locations, include, flip ? c2 : c1, flip ? t2 : t1, flip ? c1 : c2, flip ? t1 : t2);
            }
        }
        function addLineIntersection(v1, v2, c1, c2, locations, include) {
            var pt = Line.intersect(v1[0], v1[1], v1[6], v1[7], v2[0], v2[1], v2[6], v2[7]);
            if (pt) addLocation(locations, include, c1, Curve.getTimeOf(v1, pt), c2, Curve.getTimeOf(v2, pt));
        }
        function getCurveIntersections(v1, v2, c1, c2, locations, include) {
            var epsilon = 1e-12, min = Math.min, max = Math.max;
            if (max(v1[0], v1[2], v1[4], v1[6]) + epsilon > min(v2[0], v2[2], v2[4], v2[6]) && min(v1[0], v1[2], v1[4], v1[6]) - epsilon < max(v2[0], v2[2], v2[4], v2[6]) && max(v1[1], v1[3], v1[5], v1[7]) + epsilon > min(v2[1], v2[3], v2[5], v2[7]) && min(v1[1], v1[3], v1[5], v1[7]) - epsilon < max(v2[1], v2[3], v2[5], v2[7])) {
                var overlaps = getOverlaps(v1, v2);
                if (overlaps) for(var i = 0; i < 2; i++){
                    var overlap = overlaps[i];
                    addLocation(locations, include, c1, overlap[0], c2, overlap[1], true);
                }
                else {
                    var straight1 = Curve.isStraight(v1), straight2 = Curve.isStraight(v2), straight = straight1 && straight2, flip = straight1 && !straight2, before = locations.length;
                    (straight ? addLineIntersection : straight1 || straight2 ? addCurveLineIntersections : addCurveIntersections)(flip ? v2 : v1, flip ? v1 : v2, flip ? c2 : c1, flip ? c1 : c2, locations, include, flip, 0, 0, 0, 1, 0, 1);
                    if (!straight || locations.length === before) for(var i = 0; i < 4; i++){
                        var t1 = i >> 1, t2 = i & 1, i1 = t1 * 6, i2 = t2 * 6, p1 = new Point(v1[i1], v1[i1 + 1]), p2 = new Point(v2[i2], v2[i2 + 1]);
                        if (p1.isClose(p2, epsilon)) addLocation(locations, include, c1, t1, c2, t2);
                    }
                }
            }
            return locations;
        }
        function getSelfIntersection(v1, c1, locations, include) {
            var info = Curve.classify(v1);
            if (info.type === 'loop') {
                var roots = info.roots;
                addLocation(locations, include, c1, roots[0], c1, roots[1]);
            }
            return locations;
        }
        function getIntersections(curves1, curves2, include, matrix1, matrix2, _returnFirst) {
            var epsilon = 1e-7, self1 = !curves2;
            if (self1) curves2 = curves1;
            var length1 = curves1.length, length2 = curves2.length, values1 = new Array(length1), values2 = self1 ? values1 : new Array(length2), locations = [];
            for(var i = 0; i < length1; i++)values1[i] = curves1[i].getValues(matrix1);
            if (!self1) for(var i = 0; i < length2; i++)values2[i] = curves2[i].getValues(matrix2);
            var boundsCollisions = CollisionDetection.findCurveBoundsCollisions(values1, values2, epsilon);
            for(var index1 = 0; index1 < length1; index1++){
                var curve1 = curves1[index1], v1 = values1[index1];
                if (self1) getSelfIntersection(v1, curve1, locations, include);
                var collisions1 = boundsCollisions[index1];
                if (collisions1) for(var j = 0; j < collisions1.length; j++){
                    if (_returnFirst && locations.length) return locations;
                    var index2 = collisions1[j];
                    if (!self1 || index2 > index1) {
                        var curve2 = curves2[index2], v2 = values2[index2];
                        getCurveIntersections(v1, v2, curve1, curve2, locations, include);
                    }
                }
            }
            return locations;
        }
        function getOverlaps(v1, v2) {
            function getSquaredLineLength(v) {
                var x = v[6] - v[0], y = v[7] - v[1];
                return x * x + y * y;
            }
            var abs = Math.abs, getDistance = Line.getDistance, timeEpsilon = 1e-8, geomEpsilon = 1e-7, straight1 = Curve.isStraight(v1), straight2 = Curve.isStraight(v2), straightBoth = straight1 && straight2, flip = getSquaredLineLength(v1) < getSquaredLineLength(v2), l1 = flip ? v2 : v1, l2 = flip ? v1 : v2, px = l1[0], py = l1[1], vx = l1[6] - px, vy = l1[7] - py;
            if (getDistance(px, py, vx, vy, l2[0], l2[1], true) < geomEpsilon && getDistance(px, py, vx, vy, l2[6], l2[7], true) < geomEpsilon) {
                if (!straightBoth && getDistance(px, py, vx, vy, l1[2], l1[3], true) < geomEpsilon && getDistance(px, py, vx, vy, l1[4], l1[5], true) < geomEpsilon && getDistance(px, py, vx, vy, l2[2], l2[3], true) < geomEpsilon && getDistance(px, py, vx, vy, l2[4], l2[5], true) < geomEpsilon) straight1 = straight2 = straightBoth = true;
            } else if (straightBoth) return null;
            if (straight1 ^ straight2) return null;
            var v = [
                v1,
                v2
            ], pairs = [];
            for(var i = 0; i < 4 && pairs.length < 2; i++){
                var i1 = i & 1, i2 = i1 ^ 1, t1 = i >> 1, t2 = Curve.getTimeOf(v[i1], new Point(v[i2][t1 ? 6 : 0], v[i2][t1 ? 7 : 1]));
                if (t2 != null) {
                    var pair = i1 ? [
                        t1,
                        t2
                    ] : [
                        t2,
                        t1
                    ];
                    if (!pairs.length || abs(pair[0] - pairs[0][0]) > timeEpsilon && abs(pair[1] - pairs[0][1]) > timeEpsilon) pairs.push(pair);
                }
                if (i > 2 && !pairs.length) break;
            }
            if (pairs.length !== 2) pairs = null;
            else if (!straightBoth) {
                var o1 = Curve.getPart(v1, pairs[0][0], pairs[1][0]), o2 = Curve.getPart(v2, pairs[0][1], pairs[1][1]);
                if (abs(o2[2] - o1[2]) > geomEpsilon || abs(o2[3] - o1[3]) > geomEpsilon || abs(o2[4] - o1[4]) > geomEpsilon || abs(o2[5] - o1[5]) > geomEpsilon) pairs = null;
            }
            return pairs;
        }
        function getTimesWithTangent(v, tangent) {
            var x0 = v[0], y0 = v[1], x1 = v[2], y1 = v[3], x2 = v[4], y2 = v[5], x3 = v[6], y3 = v[7], normalized = tangent.normalize(), tx = normalized.x, ty = normalized.y, ax = 3 * x3 - 9 * x2 + 9 * x1 - 3 * x0, ay = 3 * y3 - 9 * y2 + 9 * y1 - 3 * y0, bx = 6 * x2 - 12 * x1 + 6 * x0, by = 6 * y2 - 12 * y1 + 6 * y0, cx = 3 * x1 - 3 * x0, cy = 3 * y1 - 3 * y0, den = 2 * ax * ty - 2 * ay * tx, times = [];
            if (Math.abs(den) < Numerical.CURVETIME_EPSILON) {
                var num = ax * cy - ay * cx, den = ax * by - ay * bx;
                if (den != 0) {
                    var t = -num / den;
                    if (t >= 0 && t <= 1) times.push(t);
                }
            } else {
                var delta = (bx * bx - 4 * ax * cx) * ty * ty + (-2 * bx * by + 4 * ay * cx + 4 * ax * cy) * tx * ty + (by * by - 4 * ay * cy) * tx * tx, k = bx * ty - by * tx;
                if (delta >= 0 && den != 0) {
                    var d = Math.sqrt(delta), t0 = -(k + d) / den, t1 = (-k + d) / den;
                    if (t0 >= 0 && t0 <= 1) times.push(t0);
                    if (t1 >= 0 && t1 <= 1) times.push(t1);
                }
            }
            return times;
        }
        return {
            getIntersections: function(curve) {
                var v1 = this.getValues(), v2 = curve && curve !== this && curve.getValues();
                return v2 ? getCurveIntersections(v1, v2, this, curve, []) : getSelfIntersection(v1, this, []);
            },
            statics: {
                getOverlaps: getOverlaps,
                getIntersections: getIntersections,
                getCurveLineIntersections: getCurveLineIntersections,
                getTimesWithTangent: getTimesWithTangent
            }
        };
    });
    var CurveLocation = Base.extend({
        _class: 'CurveLocation',
        initialize: function CurveLocation(curve, time, point, _overlap, _distance) {
            if (time >= 0.99999999) {
                var next = curve.getNext();
                if (next) {
                    time = 0;
                    curve = next;
                }
            }
            this._setCurve(curve);
            this._time = time;
            this._point = point || curve.getPointAtTime(time);
            this._overlap = _overlap;
            this._distance = _distance;
            this._intersection = this._next = this._previous = null;
        },
        _setPath: function(path) {
            this._path = path;
            this._version = path ? path._version : 0;
        },
        _setCurve: function(curve) {
            this._setPath(curve._path);
            this._curve = curve;
            this._segment = null;
            this._segment1 = curve._segment1;
            this._segment2 = curve._segment2;
        },
        _setSegment: function(segment) {
            var curve = segment.getCurve();
            if (curve) this._setCurve(curve);
            else {
                this._setPath(segment._path);
                this._segment1 = segment;
                this._segment2 = null;
            }
            this._segment = segment;
            this._time = segment === this._segment1 ? 0 : 1;
            this._point = segment._point.clone();
        },
        getSegment: function() {
            var segment = this._segment;
            if (!segment) {
                var curve = this.getCurve(), time = this.getTime();
                if (time === 0) segment = curve._segment1;
                else if (time === 1) segment = curve._segment2;
                else if (time != null) segment = curve.getPartLength(0, time) < curve.getPartLength(time, 1) ? curve._segment1 : curve._segment2;
                this._segment = segment;
            }
            return segment;
        },
        getCurve: function() {
            var path = this._path, that = this;
            if (path && path._version !== this._version) this._time = this._offset = this._curveOffset = this._curve = null;
            function trySegment(segment) {
                var curve = segment && segment.getCurve();
                if (curve && (that._time = curve.getTimeOf(that._point)) != null) {
                    that._setCurve(curve);
                    return curve;
                }
            }
            return this._curve || trySegment(this._segment) || trySegment(this._segment1) || trySegment(this._segment2.getPrevious());
        },
        getPath: function() {
            var curve = this.getCurve();
            return curve && curve._path;
        },
        getIndex: function() {
            var curve = this.getCurve();
            return curve && curve.getIndex();
        },
        getTime: function() {
            var curve = this.getCurve(), time = this._time;
            return curve && time == null ? this._time = curve.getTimeOf(this._point) : time;
        },
        getParameter: '#getTime',
        getPoint: function() {
            return this._point;
        },
        getOffset: function() {
            var offset = this._offset;
            if (offset == null) {
                offset = 0;
                var path = this.getPath(), index = this.getIndex();
                if (path && index != null) {
                    var curves = path.getCurves();
                    for(var i = 0; i < index; i++)offset += curves[i].getLength();
                }
                this._offset = offset += this.getCurveOffset();
            }
            return offset;
        },
        getCurveOffset: function() {
            var offset = this._curveOffset;
            if (offset == null) {
                var curve = this.getCurve(), time = this.getTime();
                this._curveOffset = offset = time != null && curve && curve.getPartLength(0, time);
            }
            return offset;
        },
        getIntersection: function() {
            return this._intersection;
        },
        getDistance: function() {
            return this._distance;
        },
        divide: function() {
            var curve = this.getCurve(), res = curve && curve.divideAtTime(this.getTime());
            if (res) this._setSegment(res._segment1);
            return res;
        },
        split: function() {
            var curve = this.getCurve(), path = curve._path, res = curve && curve.splitAtTime(this.getTime());
            if (res) this._setSegment(path.getLastSegment());
            return res;
        },
        equals: function(loc, _ignoreOther) {
            var res = this === loc;
            if (!res && loc instanceof CurveLocation) {
                var c1 = this.getCurve(), c2 = loc.getCurve(), p1 = c1._path, p2 = c2._path;
                if (p1 === p2) {
                    var abs = Math.abs, epsilon = 1e-7, diff = abs(this.getOffset() - loc.getOffset()), i1 = !_ignoreOther && this._intersection, i2 = !_ignoreOther && loc._intersection;
                    res = (diff < epsilon || p1 && abs(p1.getLength() - diff) < epsilon) && (!i1 && !i2 || i1 && i2 && i1.equals(i2, true));
                }
            }
            return res;
        },
        toString: function() {
            var parts = [], point = this.getPoint(), f = Formatter.instance;
            if (point) parts.push('point: ' + point);
            var index = this.getIndex();
            if (index != null) parts.push('index: ' + index);
            var time = this.getTime();
            if (time != null) parts.push('time: ' + f.number(time));
            if (this._distance != null) parts.push('distance: ' + f.number(this._distance));
            return '{ ' + parts.join(', ') + ' }';
        },
        isTouching: function() {
            var inter = this._intersection;
            if (inter && this.getTangent().isCollinear(inter.getTangent())) {
                var curve1 = this.getCurve(), curve2 = inter.getCurve();
                return !(curve1.isStraight() && curve2.isStraight() && curve1.getLine().intersect(curve2.getLine()));
            }
            return false;
        },
        isCrossing: function() {
            var inter = this._intersection;
            if (!inter) return false;
            var t1 = this.getTime(), t2 = inter.getTime(), tMin = 1e-8, tMax = 1 - tMin, t1Inside = t1 >= tMin && t1 <= tMax, t2Inside = t2 >= tMin && t2 <= tMax;
            if (t1Inside && t2Inside) return !this.isTouching();
            var c2 = this.getCurve(), c1 = c2 && t1 < tMin ? c2.getPrevious() : c2, c4 = inter.getCurve(), c3 = c4 && t2 < tMin ? c4.getPrevious() : c4;
            if (t1 > tMax) c2 = c2.getNext();
            if (t2 > tMax) c4 = c4.getNext();
            if (!c1 || !c2 || !c3 || !c4) return false;
            var offsets = [];
            function addOffsets(curve, end) {
                var v = curve.getValues(), roots = Curve.classify(v).roots || Curve.getPeaks(v), count = roots.length, offset = Curve.getLength(v, end && count ? roots[count - 1] : 0, !end && count ? roots[0] : 1);
                offsets.push(count ? offset : offset / 32);
            }
            function isInRange(angle, min, max) {
                return min < max ? angle > min && angle < max : angle > min || angle < max;
            }
            if (!t1Inside) {
                addOffsets(c1, true);
                addOffsets(c2, false);
            }
            if (!t2Inside) {
                addOffsets(c3, true);
                addOffsets(c4, false);
            }
            var pt = this.getPoint(), offset = Math.min.apply(Math, offsets), v2 = t1Inside ? c2.getTangentAtTime(t1) : c2.getPointAt(offset).subtract(pt), v1 = t1Inside ? v2.negate() : c1.getPointAt(-offset).subtract(pt), v4 = t2Inside ? c4.getTangentAtTime(t2) : c4.getPointAt(offset).subtract(pt), v3 = t2Inside ? v4.negate() : c3.getPointAt(-offset).subtract(pt), a1 = v1.getAngle(), a2 = v2.getAngle(), a3 = v3.getAngle(), a4 = v4.getAngle();
            return !!(t1Inside ? isInRange(a1, a3, a4) ^ isInRange(a2, a3, a4) && isInRange(a1, a4, a3) ^ isInRange(a2, a4, a3) : isInRange(a3, a1, a2) ^ isInRange(a4, a1, a2) && isInRange(a3, a2, a1) ^ isInRange(a4, a2, a1));
        },
        hasOverlap: function() {
            return !!this._overlap;
        }
    }, Base.each(Curve._evaluateMethods, function(name) {
        var get = name + 'At';
        this[name] = function() {
            var curve = this.getCurve(), time = this.getTime();
            return time != null && curve && curve[get](time, true);
        };
    }, {
        preserve: true
    }), new function() {
        function insert(locations, loc, merge) {
            var length = locations.length, l = 0, r = length - 1;
            function search(index, dir) {
                for(var i = index + dir; i >= -1 && i <= length; i += dir){
                    var loc2 = locations[(i % length + length) % length];
                    if (!loc.getPoint().isClose(loc2.getPoint(), 1e-7)) break;
                    if (loc.equals(loc2)) return loc2;
                }
                return null;
            }
            while(l <= r){
                var m = l + r >>> 1, loc2 = locations[m], found;
                if (merge && (found = loc.equals(loc2) ? loc2 : search(m, -1) || search(m, 1))) {
                    if (loc._overlap) found._overlap = found._intersection._overlap = true;
                    return found;
                }
                var path1 = loc.getPath(), path2 = loc2.getPath(), diff = path1 !== path2 ? path1._id - path2._id : loc.getIndex() + loc.getTime() - (loc2.getIndex() + loc2.getTime());
                if (diff < 0) r = m - 1;
                else l = m + 1;
            }
            locations.splice(l, 0, loc);
            return loc;
        }
        return {
            statics: {
                insert: insert,
                expand: function(locations) {
                    var expanded = locations.slice();
                    for(var i = locations.length - 1; i >= 0; i--)insert(expanded, locations[i]._intersection, false);
                    return expanded;
                }
            }
        };
    });
    var PathItem = Item.extend({
        _class: 'PathItem',
        _selectBounds: false,
        _canScaleStroke: true,
        beans: true,
        initialize: function PathItem() {},
        statics: {
            create: function(arg) {
                var data, segments, compound;
                if (Base.isPlainObject(arg)) {
                    segments = arg.segments;
                    data = arg.pathData;
                } else if (Array.isArray(arg)) segments = arg;
                else if (typeof arg === 'string') data = arg;
                if (segments) {
                    var first = segments[0];
                    compound = first && Array.isArray(first[0]);
                } else if (data) compound = (data.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(data);
                var ctor = compound ? CompoundPath : Path;
                return new ctor(arg);
            }
        },
        _asPathItem: function() {
            return this;
        },
        isClockwise: function() {
            return this.getArea() >= 0;
        },
        setClockwise: function(clockwise) {
            if (this.isClockwise() != (clockwise = !!clockwise)) this.reverse();
        },
        setPathData: function(data) {
            var parts = data && data.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), coords, relative = false, previous, control, current = new Point(), start = new Point();
            function getCoord(index, coord) {
                var val = +coords[index];
                if (relative) val += current[coord];
                return val;
            }
            function getPoint(index) {
                return new Point(getCoord(index, 'x'), getCoord(index + 1, 'y'));
            }
            this.clear();
            for(var i = 0, l = parts && parts.length; i < l; i++){
                var part = parts[i], command = part[0], lower = command.toLowerCase();
                coords = part.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
                var length = coords && coords.length;
                relative = command === lower;
                if (previous === 'z' && !/[mz]/.test(lower)) this.moveTo(current);
                switch(lower){
                    case 'm':
                    case 'l':
                        var move = lower === 'm';
                        for(var j = 0; j < length; j += 2){
                            this[move ? 'moveTo' : 'lineTo'](current = getPoint(j));
                            if (move) {
                                start = current;
                                move = false;
                            }
                        }
                        control = current;
                        break;
                    case 'h':
                    case 'v':
                        var coord = lower === 'h' ? 'x' : 'y';
                        current = current.clone();
                        for(var j = 0; j < length; j++){
                            current[coord] = getCoord(j, coord);
                            this.lineTo(current);
                        }
                        control = current;
                        break;
                    case 'c':
                        for(var j = 0; j < length; j += 6)this.cubicCurveTo(getPoint(j), control = getPoint(j + 2), current = getPoint(j + 4));
                        break;
                    case 's':
                        for(var j = 0; j < length; j += 4){
                            this.cubicCurveTo(/[cs]/.test(previous) ? current.multiply(2).subtract(control) : current, control = getPoint(j), current = getPoint(j + 2));
                            previous = lower;
                        }
                        break;
                    case 'q':
                        for(var j = 0; j < length; j += 4)this.quadraticCurveTo(control = getPoint(j), current = getPoint(j + 2));
                        break;
                    case 't':
                        for(var j = 0; j < length; j += 2){
                            this.quadraticCurveTo(control = /[qt]/.test(previous) ? current.multiply(2).subtract(control) : current, current = getPoint(j));
                            previous = lower;
                        }
                        break;
                    case 'a':
                        for(var j = 0; j < length; j += 7)this.arcTo(current = getPoint(j + 5), new Size(+coords[j], +coords[j + 1]), +coords[j + 2], +coords[j + 4], +coords[j + 3]);
                        break;
                    case 'z':
                        this.closePath(1e-12);
                        current = start;
                        break;
                }
                previous = lower;
            }
        },
        _canComposite: function() {
            return !(this.hasFill() && this.hasStroke());
        },
        _contains: function(point) {
            var winding = point.isInside(this.getBounds({
                internal: true,
                handle: true
            })) ? this._getWinding(point) : {};
            return winding.onPath || !!(this.getFillRule() === 'evenodd' ? winding.windingL & 1 || winding.windingR & 1 : winding.winding);
        },
        getIntersections: function(path, include, _matrix, _returnFirst) {
            var self1 = this === path || !path, matrix1 = this._matrix._orNullIfIdentity(), matrix2 = self1 ? matrix1 : (_matrix || path._matrix)._orNullIfIdentity();
            return self1 || this.getBounds(matrix1).intersects(path.getBounds(matrix2), 1e-12) ? Curve.getIntersections(this.getCurves(), !self1 && path.getCurves(), include, matrix1, matrix2, _returnFirst) : [];
        },
        getCrossings: function(path) {
            return this.getIntersections(path, function(inter) {
                return inter.isCrossing();
            });
        },
        getNearestLocation: function() {
            var point = Point.read(arguments), curves = this.getCurves(), minDist = Infinity, minLoc = null;
            for(var i = 0, l = curves.length; i < l; i++){
                var loc = curves[i].getNearestLocation(point);
                if (loc._distance < minDist) {
                    minDist = loc._distance;
                    minLoc = loc;
                }
            }
            return minLoc;
        },
        getNearestPoint: function() {
            var loc = this.getNearestLocation.apply(this, arguments);
            return loc ? loc.getPoint() : loc;
        },
        interpolate: function(from, to, factor) {
            var isPath = !this._children, name = isPath ? '_segments' : '_children', itemsFrom = from[name], itemsTo = to[name], items = this[name];
            if (!itemsFrom || !itemsTo || itemsFrom.length !== itemsTo.length) throw new Error('Invalid operands in interpolate() call: ' + from + ', ' + to);
            var current = items.length, length = itemsTo.length;
            if (current < length) {
                var ctor = isPath ? Segment : Path;
                for(var i = current; i < length; i++)this.add(new ctor());
            } else if (current > length) this[isPath ? 'removeSegments' : 'removeChildren'](length, current);
            for(var i = 0; i < length; i++)items[i].interpolate(itemsFrom[i], itemsTo[i], factor);
            if (isPath) {
                this.setClosed(from._closed);
                this._changed(9);
            }
        },
        compare: function(path) {
            var ok = false;
            if (path) {
                var paths1 = this._children || [
                    this
                ], paths2 = path._children ? path._children.slice() : [
                    path
                ], length1 = paths1.length, length2 = paths2.length, matched = [], count = 0;
                ok = true;
                var boundsOverlaps = CollisionDetection.findItemBoundsCollisions(paths1, paths2, Numerical.GEOMETRIC_EPSILON);
                for(var i1 = length1 - 1; i1 >= 0 && ok; i1--){
                    var path1 = paths1[i1];
                    ok = false;
                    var pathBoundsOverlaps = boundsOverlaps[i1];
                    if (pathBoundsOverlaps) {
                        for(var i2 = pathBoundsOverlaps.length - 1; i2 >= 0 && !ok; i2--)if (path1.compare(paths2[pathBoundsOverlaps[i2]])) {
                            if (!matched[pathBoundsOverlaps[i2]]) {
                                matched[pathBoundsOverlaps[i2]] = true;
                                count++;
                            }
                            ok = true;
                        }
                    }
                }
                ok = ok && count === length2;
            }
            return ok;
        }
    });
    var Path = PathItem.extend({
        _class: 'Path',
        _serializeFields: {
            segments: [],
            closed: false
        },
        initialize: function Path(arg) {
            this._closed = false;
            this._segments = [];
            this._version = 0;
            var args = arguments, segments = Array.isArray(arg) ? typeof arg[0] === 'object' ? arg : args : arg && arg.size === undefined && (arg.x !== undefined || arg.point !== undefined) ? args : null;
            if (segments && segments.length > 0) this.setSegments(segments);
            else {
                this._curves = undefined;
                this._segmentSelection = 0;
                if (!segments && typeof arg === 'string') {
                    this.setPathData(arg);
                    arg = null;
                }
            }
            this._initialize(!segments && arg);
        },
        _equals: function(item) {
            return this._closed === item._closed && Base.equals(this._segments, item._segments);
        },
        copyContent: function(source) {
            this.setSegments(source._segments);
            this._closed = source._closed;
        },
        _changed: function _changed(flags) {
            _changed.base.call(this, flags);
            if (flags & 8) {
                this._length = this._area = undefined;
                if (flags & 32) this._version++;
                else if (this._curves) for(var i = 0, l = this._curves.length; i < l; i++)this._curves[i]._changed();
            } else if (flags & 64) this._bounds = undefined;
        },
        getStyle: function() {
            var parent = this._parent;
            return (parent instanceof CompoundPath ? parent : this)._style;
        },
        getSegments: function() {
            return this._segments;
        },
        setSegments: function(segments) {
            var fullySelected = this.isFullySelected(), length = segments && segments.length;
            this._segments.length = 0;
            this._segmentSelection = 0;
            this._curves = undefined;
            if (length) {
                var last = segments[length - 1];
                if (typeof last === 'boolean') {
                    this.setClosed(last);
                    length--;
                }
                this._add(Segment.readList(segments, 0, {}, length));
            }
            if (fullySelected) this.setFullySelected(true);
        },
        getFirstSegment: function() {
            return this._segments[0];
        },
        getLastSegment: function() {
            return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
            var curves = this._curves, segments = this._segments;
            if (!curves) {
                var length = this._countCurves();
                curves = this._curves = new Array(length);
                for(var i = 0; i < length; i++)curves[i] = new Curve(this, segments[i], segments[i + 1] || segments[0]);
            }
            return curves;
        },
        getFirstCurve: function() {
            return this.getCurves()[0];
        },
        getLastCurve: function() {
            var curves = this.getCurves();
            return curves[curves.length - 1];
        },
        isClosed: function() {
            return this._closed;
        },
        setClosed: function(closed) {
            if (this._closed != (closed = !!closed)) {
                this._closed = closed;
                if (this._curves) {
                    var length = this._curves.length = this._countCurves();
                    if (closed) this._curves[length - 1] = new Curve(this, this._segments[length - 1], this._segments[0]);
                }
                this._changed(41);
            }
        }
    }, {
        beans: true,
        getPathData: function(_matrix, _precision) {
            var segments = this._segments, length = segments.length, f = new Formatter(_precision), coords = new Array(6), first = true, curX, curY, prevX, prevY, inX, inY, outX, outY, parts = [];
            function addSegment(segment, skipLine) {
                segment._transformCoordinates(_matrix, coords);
                curX = coords[0];
                curY = coords[1];
                if (first) {
                    parts.push('M' + f.pair(curX, curY));
                    first = false;
                } else {
                    inX = coords[2];
                    inY = coords[3];
                    if (inX === curX && inY === curY && outX === prevX && outY === prevY) {
                        if (!skipLine) {
                            var dx = curX - prevX, dy = curY - prevY;
                            parts.push(dx === 0 ? 'v' + f.number(dy) : dy === 0 ? 'h' + f.number(dx) : 'l' + f.pair(dx, dy));
                        }
                    } else parts.push('c' + f.pair(outX - prevX, outY - prevY) + ' ' + f.pair(inX - prevX, inY - prevY) + ' ' + f.pair(curX - prevX, curY - prevY));
                }
                prevX = curX;
                prevY = curY;
                outX = coords[4];
                outY = coords[5];
            }
            if (!length) return '';
            for(var i = 0; i < length; i++)addSegment(segments[i]);
            if (this._closed && length > 0) {
                addSegment(segments[0], true);
                parts.push('z');
            }
            return parts.join('');
        },
        isEmpty: function() {
            return !this._segments.length;
        },
        _transformContent: function(matrix) {
            var segments = this._segments, coords = new Array(6);
            for(var i = 0, l = segments.length; i < l; i++)segments[i]._transformCoordinates(matrix, coords, true);
            return true;
        },
        _add: function(segs, index) {
            var segments = this._segments, curves = this._curves, amount = segs.length, append = index == null, index = append ? segments.length : index;
            for(var i = 0; i < amount; i++){
                var segment = segs[i];
                if (segment._path) segment = segs[i] = segment.clone();
                segment._path = this;
                segment._index = index + i;
                if (segment._selection) this._updateSelection(segment, 0, segment._selection);
            }
            if (append) Base.push(segments, segs);
            else {
                segments.splice.apply(segments, [
                    index,
                    0
                ].concat(segs));
                for(var i = index + amount, l = segments.length; i < l; i++)segments[i]._index = i;
            }
            if (curves) {
                var total = this._countCurves(), start = index > 0 && index + amount - 1 === total ? index - 1 : index, insert = start, end = Math.min(start + amount, total);
                if (segs._curves) {
                    curves.splice.apply(curves, [
                        start,
                        0
                    ].concat(segs._curves));
                    insert += segs._curves.length;
                }
                for(var i = insert; i < end; i++)curves.splice(i, 0, new Curve(this, null, null));
                this._adjustCurves(start, end);
            }
            this._changed(41);
            return segs;
        },
        _adjustCurves: function(start, end) {
            var segments = this._segments, curves = this._curves, curve;
            for(var i = start; i < end; i++){
                curve = curves[i];
                curve._path = this;
                curve._segment1 = segments[i];
                curve._segment2 = segments[i + 1] || segments[0];
                curve._changed();
            }
            if (curve = curves[this._closed && !start ? segments.length - 1 : start - 1]) {
                curve._segment2 = segments[start] || segments[0];
                curve._changed();
            }
            if (curve = curves[end]) {
                curve._segment1 = segments[end];
                curve._changed();
            }
        },
        _countCurves: function() {
            var length = this._segments.length;
            return !this._closed && length > 0 ? length - 1 : length;
        },
        add: function(segment1) {
            var args = arguments;
            return args.length > 1 && typeof segment1 !== 'number' ? this._add(Segment.readList(args)) : this._add([
                Segment.read(args)
            ])[0];
        },
        insert: function(index, segment1) {
            var args = arguments;
            return args.length > 2 && typeof segment1 !== 'number' ? this._add(Segment.readList(args, 1), index) : this._add([
                Segment.read(args, 1)
            ], index)[0];
        },
        addSegment: function() {
            return this._add([
                Segment.read(arguments)
            ])[0];
        },
        insertSegment: function(index) {
            return this._add([
                Segment.read(arguments, 1)
            ], index)[0];
        },
        addSegments: function(segments) {
            return this._add(Segment.readList(segments));
        },
        insertSegments: function(index, segments) {
            return this._add(Segment.readList(segments), index);
        },
        removeSegment: function(index) {
            return this.removeSegments(index, index + 1)[0] || null;
        },
        removeSegments: function(start, end, _includeCurves) {
            start = start || 0;
            end = Base.pick(end, this._segments.length);
            var segments = this._segments, curves = this._curves, count = segments.length, removed = segments.splice(start, end - start), amount = removed.length;
            if (!amount) return removed;
            for(var i = 0; i < amount; i++){
                var segment = removed[i];
                if (segment._selection) this._updateSelection(segment, segment._selection, 0);
                segment._index = segment._path = null;
            }
            for(var i = start, l = segments.length; i < l; i++)segments[i]._index = i;
            if (curves) {
                var index = start > 0 && end === count + (this._closed ? 1 : 0) ? start - 1 : start, curves = curves.splice(index, amount);
                for(var i = curves.length - 1; i >= 0; i--)curves[i]._path = null;
                if (_includeCurves) removed._curves = curves.slice(1);
                this._adjustCurves(index, index);
            }
            this._changed(41);
            return removed;
        },
        clear: '#removeSegments',
        hasHandles: function() {
            var segments = this._segments;
            for(var i = 0, l = segments.length; i < l; i++){
                if (segments[i].hasHandles()) return true;
            }
            return false;
        },
        clearHandles: function() {
            var segments = this._segments;
            for(var i = 0, l = segments.length; i < l; i++)segments[i].clearHandles();
        },
        getLength: function() {
            if (this._length == null) {
                var curves = this.getCurves(), length = 0;
                for(var i = 0, l = curves.length; i < l; i++)length += curves[i].getLength();
                this._length = length;
            }
            return this._length;
        },
        getArea: function() {
            var area = this._area;
            if (area == null) {
                var segments = this._segments, closed = this._closed;
                area = 0;
                for(var i = 0, l = segments.length; i < l; i++){
                    var last = i + 1 === l;
                    area += Curve.getArea(Curve.getValues(segments[i], segments[last ? 0 : i + 1], null, last && !closed));
                }
                this._area = area;
            }
            return area;
        },
        isFullySelected: function() {
            var length = this._segments.length;
            return this.isSelected() && length > 0 && this._segmentSelection === length * 7;
        },
        setFullySelected: function(selected) {
            if (selected) this._selectSegments(true);
            this.setSelected(selected);
        },
        setSelection: function setSelection(selection) {
            if (!(selection & 1)) this._selectSegments(false);
            setSelection.base.call(this, selection);
        },
        _selectSegments: function(selected) {
            var segments = this._segments, length = segments.length, selection = selected ? 7 : 0;
            this._segmentSelection = selection * length;
            for(var i = 0; i < length; i++)segments[i]._selection = selection;
        },
        _updateSelection: function(segment, oldSelection, newSelection) {
            segment._selection = newSelection;
            var selection = this._segmentSelection += newSelection - oldSelection;
            if (selection > 0) this.setSelected(true);
        },
        divideAt: function(location) {
            var loc = this.getLocationAt(location), curve;
            return loc && (curve = loc.getCurve().divideAt(loc.getCurveOffset())) ? curve._segment1 : null;
        },
        splitAt: function(location) {
            var loc = this.getLocationAt(location), index = loc && loc.index, time = loc && loc.time, tMin = 1e-8, tMax = 1 - tMin;
            if (time > tMax) {
                index++;
                time = 0;
            }
            var curves = this.getCurves();
            if (index >= 0 && index < curves.length) {
                if (time >= tMin) curves[index++].divideAtTime(time);
                var segs = this.removeSegments(index, this._segments.length, true), path;
                if (this._closed) {
                    this.setClosed(false);
                    path = this;
                } else {
                    path = new Path(Item.NO_INSERT);
                    path.insertAbove(this);
                    path.copyAttributes(this);
                }
                path._add(segs, 0);
                this.addSegment(segs[0]);
                return path;
            }
            return null;
        },
        split: function(index, time) {
            var curve, location = time === undefined ? index : (curve = this.getCurves()[index]) && curve.getLocationAtTime(time);
            return location != null ? this.splitAt(location) : null;
        },
        join: function(path, tolerance) {
            var epsilon = tolerance || 0;
            if (path && path !== this) {
                var segments = path._segments, last1 = this.getLastSegment(), last2 = path.getLastSegment();
                if (!last2) return this;
                if (last1 && last1._point.isClose(last2._point, epsilon)) path.reverse();
                var first2 = path.getFirstSegment();
                if (last1 && last1._point.isClose(first2._point, epsilon)) {
                    last1.setHandleOut(first2._handleOut);
                    this._add(segments.slice(1));
                } else {
                    var first1 = this.getFirstSegment();
                    if (first1 && first1._point.isClose(first2._point, epsilon)) path.reverse();
                    last2 = path.getLastSegment();
                    if (first1 && first1._point.isClose(last2._point, epsilon)) {
                        first1.setHandleIn(last2._handleIn);
                        this._add(segments.slice(0, segments.length - 1), 0);
                    } else this._add(segments.slice());
                }
                if (path._closed) this._add([
                    segments[0]
                ]);
                path.remove();
            }
            var first = this.getFirstSegment(), last = this.getLastSegment();
            if (first !== last && first._point.isClose(last._point, epsilon)) {
                first.setHandleIn(last._handleIn);
                last.remove();
                this.setClosed(true);
            }
            return this;
        },
        reduce: function(options) {
            var curves = this.getCurves(), simplify = options && options.simplify, tolerance = simplify ? 1e-7 : 0;
            for(var i = curves.length - 1; i >= 0; i--){
                var curve = curves[i];
                if (!curve.hasHandles() && (!curve.hasLength(tolerance) || simplify && curve.isCollinear(curve.getNext()))) curve.remove();
            }
            return this;
        },
        reverse: function() {
            this._segments.reverse();
            for(var i = 0, l = this._segments.length; i < l; i++){
                var segment = this._segments[i];
                var handleIn = segment._handleIn;
                segment._handleIn = segment._handleOut;
                segment._handleOut = handleIn;
                segment._index = i;
            }
            this._curves = null;
            this._changed(9);
        },
        flatten: function(flatness) {
            var flattener = new PathFlattener(this, flatness || 0.25, 256, true), parts = flattener.parts, length = parts.length, segments = [];
            for(var i = 0; i < length; i++)segments.push(new Segment(parts[i].curve.slice(0, 2)));
            if (!this._closed && length > 0) segments.push(new Segment(parts[length - 1].curve.slice(6)));
            this.setSegments(segments);
        },
        simplify: function(tolerance) {
            var segments = new PathFitter(this).fit(tolerance || 2.5);
            if (segments) this.setSegments(segments);
            return !!segments;
        },
        smooth: function(options) {
            var that = this, opts = options || {}, type = opts.type || 'asymmetric', segments = this._segments, length = segments.length, closed = this._closed;
            function getIndex(value, _default) {
                var index = value && value.index;
                if (index != null) {
                    var path = value.path;
                    if (path && path !== that) throw new Error(value._class + ' ' + index + ' of ' + path + ' is not part of ' + that);
                    if (_default && value instanceof Curve) index++;
                } else index = typeof value === 'number' ? value : _default;
                return Math.min(index < 0 && closed ? index % length : index < 0 ? index + length : index, length - 1);
            }
            var loop = closed && opts.from === undefined && opts.to === undefined, from = getIndex(opts.from, 0), to = getIndex(opts.to, length - 1);
            if (from > to) {
                if (closed) from -= length;
                else {
                    var tmp = from;
                    from = to;
                    to = tmp;
                }
            }
            if (/^(?:asymmetric|continuous)$/.test(type)) {
                var asymmetric = type === 'asymmetric', min = Math.min, amount = to - from + 1, n = amount - 1, padding = loop ? min(amount, 4) : 1, paddingLeft = padding, paddingRight = padding, knots = [];
                if (!closed) {
                    paddingLeft = min(1, from);
                    paddingRight = min(1, length - to - 1);
                }
                n += paddingLeft + paddingRight;
                if (n <= 1) return;
                for(var i = 0, j = from - paddingLeft; i <= n; i++, j++)knots[i] = segments[(j < 0 ? j + length : j) % length]._point;
                var x = knots[0]._x + 2 * knots[1]._x, y = knots[0]._y + 2 * knots[1]._y, f = 2, n_1 = n - 1, rx = [
                    x
                ], ry = [
                    y
                ], rf = [
                    f
                ], px = [], py = [];
                for(var i = 1; i < n; i++){
                    var internal = i < n_1, a = internal ? 1 : asymmetric ? 1 : 2, b = internal ? 4 : asymmetric ? 2 : 7, u = internal ? 4 : asymmetric ? 3 : 8, v = internal ? 2 : asymmetric ? 0 : 1, m = a / f;
                    f = rf[i] = b - m;
                    x = rx[i] = u * knots[i]._x + v * knots[i + 1]._x - m * x;
                    y = ry[i] = u * knots[i]._y + v * knots[i + 1]._y - m * y;
                }
                px[n_1] = rx[n_1] / rf[n_1];
                py[n_1] = ry[n_1] / rf[n_1];
                for(var i = n - 2; i >= 0; i--){
                    px[i] = (rx[i] - px[i + 1]) / rf[i];
                    py[i] = (ry[i] - py[i + 1]) / rf[i];
                }
                px[n] = (3 * knots[n]._x - px[n_1]) / 2;
                py[n] = (3 * knots[n]._y - py[n_1]) / 2;
                for(var i = paddingLeft, max = n - paddingRight, j = from; i <= max; i++, j++){
                    var segment = segments[j < 0 ? j + length : j], pt = segment._point, hx = px[i] - pt._x, hy = py[i] - pt._y;
                    if (loop || i < max) segment.setHandleOut(hx, hy);
                    if (loop || i > paddingLeft) segment.setHandleIn(-hx, -hy);
                }
            } else for(var i = from; i <= to; i++)segments[i < 0 ? i + length : i].smooth(opts, !loop && i === from, !loop && i === to);
        },
        toShape: function(insert) {
            if (!this._closed) return null;
            var segments = this._segments, type, size, radius, topCenter;
            function isCollinear(i, j) {
                var seg1 = segments[i], seg2 = seg1.getNext(), seg3 = segments[j], seg4 = seg3.getNext();
                return seg1._handleOut.isZero() && seg2._handleIn.isZero() && seg3._handleOut.isZero() && seg4._handleIn.isZero() && seg2._point.subtract(seg1._point).isCollinear(seg4._point.subtract(seg3._point));
            }
            function isOrthogonal(i) {
                var seg2 = segments[i], seg1 = seg2.getPrevious(), seg3 = seg2.getNext();
                return seg1._handleOut.isZero() && seg2._handleIn.isZero() && seg2._handleOut.isZero() && seg3._handleIn.isZero() && seg2._point.subtract(seg1._point).isOrthogonal(seg3._point.subtract(seg2._point));
            }
            function isArc(i) {
                var seg1 = segments[i], seg2 = seg1.getNext(), handle1 = seg1._handleOut, handle2 = seg2._handleIn, kappa = 0.5522847498307936;
                if (handle1.isOrthogonal(handle2)) {
                    var pt1 = seg1._point, pt2 = seg2._point, corner = new Line(pt1, handle1, true).intersect(new Line(pt2, handle2, true), true);
                    return corner && Numerical.isZero(handle1.getLength() / corner.subtract(pt1).getLength() - kappa) && Numerical.isZero(handle2.getLength() / corner.subtract(pt2).getLength() - kappa);
                }
                return false;
            }
            function getDistance(i, j) {
                return segments[i]._point.getDistance(segments[j]._point);
            }
            if (!this.hasHandles() && segments.length === 4 && isCollinear(0, 2) && isCollinear(1, 3) && isOrthogonal(1)) {
                type = Shape.Rectangle;
                size = new Size(getDistance(0, 3), getDistance(0, 1));
                topCenter = segments[1]._point.add(segments[2]._point).divide(2);
            } else if (segments.length === 8 && isArc(0) && isArc(2) && isArc(4) && isArc(6) && isCollinear(1, 5) && isCollinear(3, 7)) {
                type = Shape.Rectangle;
                size = new Size(getDistance(1, 6), getDistance(0, 3));
                radius = size.subtract(new Size(getDistance(0, 7), getDistance(1, 2))).divide(2);
                topCenter = segments[3]._point.add(segments[4]._point).divide(2);
            } else if (segments.length === 4 && isArc(0) && isArc(1) && isArc(2) && isArc(3)) {
                if (Numerical.isZero(getDistance(0, 2) - getDistance(1, 3))) {
                    type = Shape.Circle;
                    radius = getDistance(0, 2) / 2;
                } else {
                    type = Shape.Ellipse;
                    radius = new Size(getDistance(2, 0) / 2, getDistance(3, 1) / 2);
                }
                topCenter = segments[1]._point;
            }
            if (type) {
                var center = this.getPosition(true), shape = new type({
                    center: center,
                    size: size,
                    radius: radius,
                    insert: false
                });
                shape.copyAttributes(this, true);
                shape._matrix.prepend(this._matrix);
                shape.rotate(topCenter.subtract(center).getAngle() + 90);
                if (insert === undefined || insert) shape.insertAbove(this);
                return shape;
            }
            return null;
        },
        toPath: '#clone',
        compare: function compare(path) {
            if (!path || path instanceof CompoundPath) return compare.base.call(this, path);
            var curves1 = this.getCurves(), curves2 = path.getCurves(), length1 = curves1.length, length2 = curves2.length;
            if (!length1 || !length2) return length1 == length2;
            var v1 = curves1[0].getValues(), values2 = [], pos1 = 0, pos2, end1 = 0, end2;
            for(var i = 0; i < length2; i++){
                var v2 = curves2[i].getValues();
                values2.push(v2);
                var overlaps = Curve.getOverlaps(v1, v2);
                if (overlaps) {
                    pos2 = !i && overlaps[0][0] > 0 ? length2 - 1 : i;
                    end2 = overlaps[0][1];
                    break;
                }
            }
            var abs = Math.abs, epsilon = 1e-8, v2 = values2[pos2], start2;
            while(v1 && v2){
                var overlaps = Curve.getOverlaps(v1, v2);
                if (overlaps) {
                    var t1 = overlaps[0][0];
                    if (abs(t1 - end1) < epsilon) {
                        end1 = overlaps[1][0];
                        if (end1 === 1) {
                            v1 = ++pos1 < length1 ? curves1[pos1].getValues() : null;
                            end1 = 0;
                        }
                        var t2 = overlaps[0][1];
                        if (abs(t2 - end2) < epsilon) {
                            if (!start2) start2 = [
                                pos2,
                                t2
                            ];
                            end2 = overlaps[1][1];
                            if (end2 === 1) {
                                if (++pos2 >= length2) pos2 = 0;
                                v2 = values2[pos2] || curves2[pos2].getValues();
                                end2 = 0;
                            }
                            if (!v1) return start2[0] === pos2 && start2[1] === end2;
                            continue;
                        }
                    }
                }
                break;
            }
            return false;
        },
        _hitTestSelf: function(point, options, viewMatrix, strokeMatrix) {
            var that = this, style = this.getStyle(), segments = this._segments, numSegments = segments.length, closed = this._closed, tolerancePadding = options._tolerancePadding, strokePadding = tolerancePadding, join, cap, miterLimit, area, loc, res, hitStroke = options.stroke && style.hasStroke(), hitFill = options.fill && style.hasFill(), hitCurves = options.curves, strokeRadius = hitStroke ? style.getStrokeWidth() / 2 : hitFill && options.tolerance > 0 || hitCurves ? 0 : null;
            if (strokeRadius !== null) {
                if (strokeRadius > 0) {
                    join = style.getStrokeJoin();
                    cap = style.getStrokeCap();
                    miterLimit = style.getMiterLimit();
                    strokePadding = strokePadding.add(Path._getStrokePadding(strokeRadius, strokeMatrix));
                } else join = cap = 'round';
            }
            function isCloseEnough(pt, padding) {
                return point.subtract(pt).divide(padding).length <= 1;
            }
            function checkSegmentPoint(seg, pt, name) {
                if (!options.selected || pt.isSelected()) {
                    var anchor = seg._point;
                    if (pt !== anchor) pt = pt.add(anchor);
                    if (isCloseEnough(pt, strokePadding)) return new HitResult(name, that, {
                        segment: seg,
                        point: pt
                    });
                }
            }
            function checkSegmentPoints(seg, ends) {
                return (ends || options.segments) && checkSegmentPoint(seg, seg._point, 'segment') || !ends && options.handles && (checkSegmentPoint(seg, seg._handleIn, 'handle-in') || checkSegmentPoint(seg, seg._handleOut, 'handle-out'));
            }
            function addToArea(point) {
                area.add(point);
            }
            function checkSegmentStroke(segment) {
                var isJoin = closed || segment._index > 0 && segment._index < numSegments - 1;
                if ((isJoin ? join : cap) === 'round') return isCloseEnough(segment._point, strokePadding);
                else {
                    area = new Path({
                        internal: true,
                        closed: true
                    });
                    if (isJoin) {
                        if (!segment.isSmooth()) Path._addBevelJoin(segment, join, strokeRadius, miterLimit, null, strokeMatrix, addToArea, true);
                    } else if (cap === 'square') Path._addSquareCap(segment, cap, strokeRadius, null, strokeMatrix, addToArea, true);
                    if (!area.isEmpty()) {
                        var loc;
                        return area.contains(point) || (loc = area.getNearestLocation(point)) && isCloseEnough(loc.getPoint(), tolerancePadding);
                    }
                }
            }
            if (options.ends && !options.segments && !closed) {
                if (res = checkSegmentPoints(segments[0], true) || checkSegmentPoints(segments[numSegments - 1], true)) return res;
            } else if (options.segments || options.handles) {
                for(var i = 0; i < numSegments; i++)if (res = checkSegmentPoints(segments[i])) return res;
            }
            if (strokeRadius !== null) {
                loc = this.getNearestLocation(point);
                if (loc) {
                    var time = loc.getTime();
                    if (time === 0 || time === 1 && numSegments > 1) {
                        if (!checkSegmentStroke(loc.getSegment())) loc = null;
                    } else if (!isCloseEnough(loc.getPoint(), strokePadding)) loc = null;
                }
                if (!loc && join === 'miter' && numSegments > 1) for(var i = 0; i < numSegments; i++){
                    var segment = segments[i];
                    if (point.getDistance(segment._point) <= miterLimit * strokeRadius && checkSegmentStroke(segment)) {
                        loc = segment.getLocation();
                        break;
                    }
                }
            }
            return !loc && hitFill && this._contains(point) || loc && !hitStroke && !hitCurves ? new HitResult('fill', this) : loc ? new HitResult(hitStroke ? 'stroke' : 'curve', this, {
                location: loc,
                point: loc.getPoint()
            }) : null;
        }
    }, Base.each(Curve._evaluateMethods, function(name) {
        this[name + 'At'] = function(offset) {
            var loc = this.getLocationAt(offset);
            return loc && loc[name]();
        };
    }, {
        beans: false,
        getLocationOf: function() {
            var point = Point.read(arguments), curves = this.getCurves();
            for(var i = 0, l = curves.length; i < l; i++){
                var loc = curves[i].getLocationOf(point);
                if (loc) return loc;
            }
            return null;
        },
        getOffsetOf: function() {
            var loc = this.getLocationOf.apply(this, arguments);
            return loc ? loc.getOffset() : null;
        },
        getLocationAt: function(offset) {
            if (typeof offset === 'number') {
                var curves = this.getCurves(), length = 0;
                for(var i = 0, l = curves.length; i < l; i++){
                    var start = length, curve = curves[i];
                    length += curve.getLength();
                    if (length > offset) return curve.getLocationAt(offset - start);
                }
                if (curves.length > 0 && offset <= this.getLength()) return new CurveLocation(curves[curves.length - 1], 1);
            } else if (offset && offset.getPath && offset.getPath() === this) return offset;
            return null;
        },
        getOffsetsWithTangent: function() {
            var tangent = Point.read(arguments);
            if (tangent.isZero()) return [];
            var offsets = [];
            var curveStart = 0;
            var curves = this.getCurves();
            for(var i = 0, l = curves.length; i < l; i++){
                var curve = curves[i];
                var curveTimes = curve.getTimesWithTangent(tangent);
                for(var j = 0, m = curveTimes.length; j < m; j++){
                    var offset = curveStart + curve.getOffsetAtTime(curveTimes[j]);
                    if (offsets.indexOf(offset) < 0) offsets.push(offset);
                }
                curveStart += curve.length;
            }
            return offsets;
        }
    }), new function() {
        function drawHandles(ctx, segments, matrix, size) {
            if (size <= 0) return;
            var half = size / 2, miniSize = size - 2, miniHalf = half - 1, coords = new Array(6), pX, pY;
            function drawHandle(index) {
                var hX = coords[index], hY = coords[index + 1];
                if (pX != hX || pY != hY) {
                    ctx.beginPath();
                    ctx.moveTo(pX, pY);
                    ctx.lineTo(hX, hY);
                    ctx.stroke();
                    ctx.beginPath();
                    ctx.arc(hX, hY, half, 0, Math.PI * 2, true);
                    ctx.fill();
                }
            }
            for(var i = 0, l = segments.length; i < l; i++){
                var segment = segments[i], selection = segment._selection;
                segment._transformCoordinates(matrix, coords);
                pX = coords[0];
                pY = coords[1];
                if (selection & 2) drawHandle(2);
                if (selection & 4) drawHandle(4);
                ctx.fillRect(pX - half, pY - half, size, size);
                if (miniSize > 0 && !(selection & 1)) {
                    var fillStyle = ctx.fillStyle;
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(pX - miniHalf, pY - miniHalf, miniSize, miniSize);
                    ctx.fillStyle = fillStyle;
                }
            }
        }
        function drawSegments(ctx, path, matrix) {
            var segments = path._segments, length = segments.length, coords = new Array(6), first = true, curX, curY, prevX, prevY, inX, inY, outX, outY;
            function drawSegment(segment) {
                if (matrix) {
                    segment._transformCoordinates(matrix, coords);
                    curX = coords[0];
                    curY = coords[1];
                } else {
                    var point = segment._point;
                    curX = point._x;
                    curY = point._y;
                }
                if (first) {
                    ctx.moveTo(curX, curY);
                    first = false;
                } else {
                    if (matrix) {
                        inX = coords[2];
                        inY = coords[3];
                    } else {
                        var handle = segment._handleIn;
                        inX = curX + handle._x;
                        inY = curY + handle._y;
                    }
                    if (inX === curX && inY === curY && outX === prevX && outY === prevY) ctx.lineTo(curX, curY);
                    else ctx.bezierCurveTo(outX, outY, inX, inY, curX, curY);
                }
                prevX = curX;
                prevY = curY;
                if (matrix) {
                    outX = coords[4];
                    outY = coords[5];
                } else {
                    var handle = segment._handleOut;
                    outX = prevX + handle._x;
                    outY = prevY + handle._y;
                }
            }
            for(var i = 0; i < length; i++)drawSegment(segments[i]);
            if (path._closed && length > 0) drawSegment(segments[0]);
        }
        return {
            _draw: function(ctx, param, viewMatrix, strokeMatrix) {
                var dontStart = param.dontStart, dontPaint = param.dontFinish || param.clip, style = this.getStyle(), hasFill = style.hasFill(), hasStroke = style.hasStroke(), dashArray = style.getDashArray(), dashLength = !paper.support.nativeDash && hasStroke && dashArray && dashArray.length;
                if (!dontStart) ctx.beginPath();
                if (hasFill || hasStroke && !dashLength || dontPaint) {
                    drawSegments(ctx, this, strokeMatrix);
                    if (this._closed) ctx.closePath();
                }
                function getOffset(i) {
                    return dashArray[(i % dashLength + dashLength) % dashLength];
                }
                if (!dontPaint && (hasFill || hasStroke)) {
                    this._setStyles(ctx, param, viewMatrix);
                    if (hasFill) {
                        ctx.fill(style.getFillRule());
                        ctx.shadowColor = 'rgba(0,0,0,0)';
                    }
                    if (hasStroke) {
                        if (dashLength) {
                            if (!dontStart) ctx.beginPath();
                            var flattener = new PathFlattener(this, 0.25, 32, false, strokeMatrix), length = flattener.length, from = -style.getDashOffset(), to, i = 0;
                            while(from > 0)from -= getOffset(i--) + getOffset(i--);
                            while(from < length){
                                to = from + getOffset(i++);
                                if (from > 0 || to > 0) flattener.drawPart(ctx, Math.max(from, 0), Math.max(to, 0));
                                from = to + getOffset(i++);
                            }
                        }
                        ctx.stroke();
                    }
                }
            },
            _drawSelected: function(ctx, matrix) {
                ctx.beginPath();
                drawSegments(ctx, this, matrix);
                ctx.stroke();
                drawHandles(ctx, this._segments, matrix, paper.settings.handleSize);
            }
        };
    }, new function() {
        function getCurrentSegment(that) {
            var segments = that._segments;
            if (!segments.length) throw new Error('Use a moveTo() command first');
            return segments[segments.length - 1];
        }
        return {
            moveTo: function() {
                var segments = this._segments;
                if (segments.length === 1) this.removeSegment(0);
                if (!segments.length) this._add([
                    new Segment(Point.read(arguments))
                ]);
            },
            moveBy: function() {
                throw new Error('moveBy() is unsupported on Path items.');
            },
            lineTo: function() {
                this._add([
                    new Segment(Point.read(arguments))
                ]);
            },
            cubicCurveTo: function() {
                var args = arguments, handle1 = Point.read(args), handle2 = Point.read(args), to = Point.read(args), current = getCurrentSegment(this);
                current.setHandleOut(handle1.subtract(current._point));
                this._add([
                    new Segment(to, handle2.subtract(to))
                ]);
            },
            quadraticCurveTo: function() {
                var args = arguments, handle = Point.read(args), to = Point.read(args), current = getCurrentSegment(this)._point;
                this.cubicCurveTo(handle.add(current.subtract(handle).multiply(1 / 3)), handle.add(to.subtract(handle).multiply(1 / 3)), to);
            },
            curveTo: function() {
                var args = arguments, through = Point.read(args), to = Point.read(args), t = Base.pick(Base.read(args), 0.5), t1 = 1 - t, current = getCurrentSegment(this)._point, handle = through.subtract(current.multiply(t1 * t1)).subtract(to.multiply(t * t)).divide(2 * t * t1);
                if (handle.isNaN()) throw new Error('Cannot put a curve through points with parameter = ' + t);
                this.quadraticCurveTo(handle, to);
            },
            arcTo: function() {
                var args = arguments, abs = Math.abs, sqrt = Math.sqrt, current = getCurrentSegment(this), from = current._point, to = Point.read(args), through, peek = Base.peek(args), clockwise = Base.pick(peek, true), center, extent, vector, matrix;
                if (typeof clockwise === 'boolean') var middle = from.add(to).divide(2), through = middle.add(middle.subtract(from).rotate(clockwise ? -90 : 90));
                else if (Base.remain(args) <= 2) {
                    through = to;
                    to = Point.read(args);
                } else if (!from.equals(to)) {
                    var radius = Size.read(args), isZero = Numerical.isZero;
                    if (isZero(radius.width) || isZero(radius.height)) return this.lineTo(to);
                    var rotation = Base.read(args), clockwise = !!Base.read(args), large = !!Base.read(args), middle = from.add(to).divide(2), pt = from.subtract(middle).rotate(-rotation), x = pt.x, y = pt.y, rx = abs(radius.width), ry = abs(radius.height), rxSq = rx * rx, rySq = ry * ry, xSq = x * x, ySq = y * y;
                    var factor = sqrt(xSq / rxSq + ySq / rySq);
                    if (factor > 1) {
                        rx *= factor;
                        ry *= factor;
                        rxSq = rx * rx;
                        rySq = ry * ry;
                    }
                    factor = (rxSq * rySq - rxSq * ySq - rySq * xSq) / (rxSq * ySq + rySq * xSq);
                    if (abs(factor) < 1e-12) factor = 0;
                    if (factor < 0) throw new Error('Cannot create an arc with the given arguments');
                    center = new Point(rx * y / ry, -ry * x / rx).multiply((large === clockwise ? -1 : 1) * sqrt(factor)).rotate(rotation).add(middle);
                    matrix = new Matrix().translate(center).rotate(rotation).scale(rx, ry);
                    vector = matrix._inverseTransform(from);
                    extent = vector.getDirectedAngle(matrix._inverseTransform(to));
                    if (!clockwise && extent > 0) extent -= 360;
                    else if (clockwise && extent < 0) extent += 360;
                }
                if (through) {
                    var l1 = new Line(from.add(through).divide(2), through.subtract(from).rotate(90), true), l2 = new Line(through.add(to).divide(2), to.subtract(through).rotate(90), true), line = new Line(from, to), throughSide = line.getSide(through);
                    center = l1.intersect(l2, true);
                    if (!center) {
                        if (!throughSide) return this.lineTo(to);
                        throw new Error('Cannot create an arc with the given arguments');
                    }
                    vector = from.subtract(center);
                    extent = vector.getDirectedAngle(to.subtract(center));
                    var centerSide = line.getSide(center, true);
                    if (centerSide === 0) extent = throughSide * abs(extent);
                    else if (throughSide === centerSide) extent += extent < 0 ? 360 : -360;
                }
                if (extent) {
                    var epsilon = 1e-5, ext = abs(extent), count = ext >= 360 ? 4 : Math.ceil((ext - epsilon) / 90), inc = extent / count, half = inc * Math.PI / 360, z = 4 / 3 * Math.sin(half) / (1 + Math.cos(half)), segments = [];
                    for(var i = 0; i <= count; i++){
                        var pt = to, out = null;
                        if (i < count) {
                            out = vector.rotate(90).multiply(z);
                            if (matrix) {
                                pt = matrix._transformPoint(vector);
                                out = matrix._transformPoint(vector.add(out)).subtract(pt);
                            } else pt = center.add(vector);
                        }
                        if (!i) current.setHandleOut(out);
                        else {
                            var _in = vector.rotate(-90).multiply(z);
                            if (matrix) _in = matrix._transformPoint(vector.add(_in)).subtract(pt);
                            segments.push(new Segment(pt, _in, out));
                        }
                        vector = vector.rotate(inc);
                    }
                    this._add(segments);
                }
            },
            lineBy: function() {
                var to = Point.read(arguments), current = getCurrentSegment(this)._point;
                this.lineTo(current.add(to));
            },
            curveBy: function() {
                var args = arguments, through = Point.read(args), to = Point.read(args), parameter = Base.read(args), current = getCurrentSegment(this)._point;
                this.curveTo(current.add(through), current.add(to), parameter);
            },
            cubicCurveBy: function() {
                var args = arguments, handle1 = Point.read(args), handle2 = Point.read(args), to = Point.read(args), current = getCurrentSegment(this)._point;
                this.cubicCurveTo(current.add(handle1), current.add(handle2), current.add(to));
            },
            quadraticCurveBy: function() {
                var args = arguments, handle = Point.read(args), to = Point.read(args), current = getCurrentSegment(this)._point;
                this.quadraticCurveTo(current.add(handle), current.add(to));
            },
            arcBy: function() {
                var args = arguments, current = getCurrentSegment(this)._point, point = current.add(Point.read(args)), clockwise = Base.pick(Base.peek(args), true);
                if (typeof clockwise === 'boolean') this.arcTo(point, clockwise);
                else this.arcTo(point, current.add(Point.read(args)));
            },
            closePath: function(tolerance) {
                this.setClosed(true);
                this.join(this, tolerance);
            }
        };
    }, {
        _getBounds: function(matrix, options) {
            var method = options.handle ? 'getHandleBounds' : options.stroke ? 'getStrokeBounds' : 'getBounds';
            return Path[method](this._segments, this._closed, this, matrix, options);
        },
        statics: {
            getBounds: function(segments, closed, path, matrix, options, strokePadding) {
                var first = segments[0];
                if (!first) return new Rectangle();
                var coords = new Array(6), prevCoords = first._transformCoordinates(matrix, new Array(6)), min = prevCoords.slice(0, 2), max = min.slice(), roots = new Array(2);
                function processSegment(segment) {
                    segment._transformCoordinates(matrix, coords);
                    for(var i = 0; i < 2; i++)Curve._addBounds(prevCoords[i], prevCoords[i + 4], coords[i + 2], coords[i], i, strokePadding ? strokePadding[i] : 0, min, max, roots);
                    var tmp = prevCoords;
                    prevCoords = coords;
                    coords = tmp;
                }
                for(var i = 1, l = segments.length; i < l; i++)processSegment(segments[i]);
                if (closed) processSegment(first);
                return new Rectangle(min[0], min[1], max[0] - min[0], max[1] - min[1]);
            },
            getStrokeBounds: function(segments, closed, path, matrix, options) {
                var style = path.getStyle(), stroke = style.hasStroke(), strokeWidth = style.getStrokeWidth(), strokeMatrix = stroke && path._getStrokeMatrix(matrix, options), strokePadding = stroke && Path._getStrokePadding(strokeWidth, strokeMatrix), bounds = Path.getBounds(segments, closed, path, matrix, options, strokePadding);
                if (!stroke) return bounds;
                var strokeRadius = strokeWidth / 2, join = style.getStrokeJoin(), cap = style.getStrokeCap(), miterLimit = style.getMiterLimit(), joinBounds = new Rectangle(new Size(strokePadding));
                function addPoint(point) {
                    bounds = bounds.include(point);
                }
                function addRound(segment) {
                    bounds = bounds.unite(joinBounds.setCenter(segment._point.transform(matrix)));
                }
                function addJoin(segment, join) {
                    if (join === 'round' || segment.isSmooth()) addRound(segment);
                    else Path._addBevelJoin(segment, join, strokeRadius, miterLimit, matrix, strokeMatrix, addPoint);
                }
                function addCap(segment, cap) {
                    if (cap === 'round') addRound(segment);
                    else Path._addSquareCap(segment, cap, strokeRadius, matrix, strokeMatrix, addPoint);
                }
                var length = segments.length - (closed ? 0 : 1);
                if (length > 0) {
                    for(var i = 1; i < length; i++)addJoin(segments[i], join);
                    if (closed) addJoin(segments[0], join);
                    else {
                        addCap(segments[0], cap);
                        addCap(segments[segments.length - 1], cap);
                    }
                }
                return bounds;
            },
            _getStrokePadding: function(radius, matrix) {
                if (!matrix) return [
                    radius,
                    radius
                ];
                var hor = new Point(radius, 0).transform(matrix), ver = new Point(0, radius).transform(matrix), phi = hor.getAngleInRadians(), a = hor.getLength(), b = ver.getLength();
                var sin = Math.sin(phi), cos = Math.cos(phi), tan = Math.tan(phi), tx = Math.atan2(b * tan, a), ty = Math.atan2(b, tan * a);
                return [
                    Math.abs(a * Math.cos(tx) * cos + b * Math.sin(tx) * sin),
                    Math.abs(b * Math.sin(ty) * cos + a * Math.cos(ty) * sin)
                ];
            },
            _addBevelJoin: function(segment, join, radius, miterLimit, matrix, strokeMatrix, addPoint, isArea) {
                var curve2 = segment.getCurve(), curve1 = curve2.getPrevious(), point = curve2.getPoint1().transform(matrix), normal1 = curve1.getNormalAtTime(1).multiply(radius).transform(strokeMatrix), normal2 = curve2.getNormalAtTime(0).multiply(radius).transform(strokeMatrix), angle = normal1.getDirectedAngle(normal2);
                if (angle < 0 || angle >= 180) {
                    normal1 = normal1.negate();
                    normal2 = normal2.negate();
                }
                if (isArea) addPoint(point);
                addPoint(point.add(normal1));
                if (join === 'miter') {
                    var corner = new Line(point.add(normal1), new Point(-normal1.y, normal1.x), true).intersect(new Line(point.add(normal2), new Point(-normal2.y, normal2.x), true), true);
                    if (corner && point.getDistance(corner) <= miterLimit * radius) addPoint(corner);
                }
                addPoint(point.add(normal2));
            },
            _addSquareCap: function(segment, cap, radius, matrix, strokeMatrix, addPoint, isArea) {
                var point = segment._point.transform(matrix), loc = segment.getLocation(), normal = loc.getNormal().multiply(loc.getTime() === 0 ? radius : -radius).transform(strokeMatrix);
                if (cap === 'square') {
                    if (isArea) {
                        addPoint(point.subtract(normal));
                        addPoint(point.add(normal));
                    }
                    point = point.add(normal.rotate(-90));
                }
                addPoint(point.add(normal));
                addPoint(point.subtract(normal));
            },
            getHandleBounds: function(segments, closed, path, matrix, options) {
                var style = path.getStyle(), stroke = options.stroke && style.hasStroke(), strokePadding, joinPadding;
                if (stroke) {
                    var strokeMatrix = path._getStrokeMatrix(matrix, options), strokeRadius = style.getStrokeWidth() / 2, joinRadius = strokeRadius;
                    if (style.getStrokeJoin() === 'miter') joinRadius = strokeRadius * style.getMiterLimit();
                    if (style.getStrokeCap() === 'square') joinRadius = Math.max(joinRadius, strokeRadius * Math.SQRT2);
                    strokePadding = Path._getStrokePadding(strokeRadius, strokeMatrix);
                    joinPadding = Path._getStrokePadding(joinRadius, strokeMatrix);
                }
                var coords = new Array(6), x1 = Infinity, x2 = -x1, y1 = x1, y2 = x2;
                for(var i = 0, l = segments.length; i < l; i++){
                    var segment = segments[i];
                    segment._transformCoordinates(matrix, coords);
                    for(var j = 0; j < 6; j += 2){
                        var padding = !j ? joinPadding : strokePadding, paddingX = padding ? padding[0] : 0, paddingY = padding ? padding[1] : 0, x = coords[j], y = coords[j + 1], xn = x - paddingX, xx = x + paddingX, yn = y - paddingY, yx = y + paddingY;
                        if (xn < x1) x1 = xn;
                        if (xx > x2) x2 = xx;
                        if (yn < y1) y1 = yn;
                        if (yx > y2) y2 = yx;
                    }
                }
                return new Rectangle(x1, y1, x2 - x1, y2 - y1);
            }
        }
    });
    Path.inject({
        statics: new function() {
            var kappa = 0.5522847498307936, ellipseSegments = [
                new Segment([
                    -1,
                    0
                ], [
                    0,
                    kappa
                ], [
                    0,
                    -kappa
                ]),
                new Segment([
                    0,
                    -1
                ], [
                    -kappa,
                    0
                ], [
                    kappa,
                    0
                ]),
                new Segment([
                    1,
                    0
                ], [
                    0,
                    -kappa
                ], [
                    0,
                    kappa
                ]),
                new Segment([
                    0,
                    1
                ], [
                    kappa,
                    0
                ], [
                    -kappa,
                    0
                ])
            ];
            function createPath(segments, closed, args) {
                var props = Base.getNamed(args), path = new Path(props && (props.insert == true ? Item.INSERT : props.insert == false ? Item.NO_INSERT : null));
                path._add(segments);
                path._closed = closed;
                return path.set(props, Item.INSERT);
            }
            function createEllipse(center, radius, args) {
                var segments = new Array(4);
                for(var i = 0; i < 4; i++){
                    var segment = ellipseSegments[i];
                    segments[i] = new Segment(segment._point.multiply(radius).add(center), segment._handleIn.multiply(radius), segment._handleOut.multiply(radius));
                }
                return createPath(segments, true, args);
            }
            return {
                Line: function() {
                    var args = arguments;
                    return createPath([
                        new Segment(Point.readNamed(args, 'from')),
                        new Segment(Point.readNamed(args, 'to'))
                    ], false, args);
                },
                Circle: function() {
                    var args = arguments, center = Point.readNamed(args, 'center'), radius = Base.readNamed(args, 'radius');
                    return createEllipse(center, new Size(radius), args);
                },
                Rectangle: function() {
                    var args = arguments, rect = Rectangle.readNamed(args, 'rectangle'), radius = Size.readNamed(args, 'radius', 0, {
                        readNull: true
                    }), bl = rect.getBottomLeft(true), tl = rect.getTopLeft(true), tr = rect.getTopRight(true), br = rect.getBottomRight(true), segments;
                    if (!radius || radius.isZero()) segments = [
                        new Segment(bl),
                        new Segment(tl),
                        new Segment(tr),
                        new Segment(br)
                    ];
                    else {
                        radius = Size.min(radius, rect.getSize(true).divide(2));
                        var rx = radius.width, ry = radius.height, hx = rx * kappa, hy = ry * kappa;
                        segments = [
                            new Segment(bl.add(rx, 0), null, [
                                -hx,
                                0
                            ]),
                            new Segment(bl.subtract(0, ry), [
                                0,
                                hy
                            ]),
                            new Segment(tl.add(0, ry), null, [
                                0,
                                -hy
                            ]),
                            new Segment(tl.add(rx, 0), [
                                -hx,
                                0
                            ], null),
                            new Segment(tr.subtract(rx, 0), null, [
                                hx,
                                0
                            ]),
                            new Segment(tr.add(0, ry), [
                                0,
                                -hy
                            ], null),
                            new Segment(br.subtract(0, ry), null, [
                                0,
                                hy
                            ]),
                            new Segment(br.subtract(rx, 0), [
                                hx,
                                0
                            ])
                        ];
                    }
                    return createPath(segments, true, args);
                },
                RoundRectangle: '#Rectangle',
                Ellipse: function() {
                    var args = arguments, ellipse = Shape._readEllipse(args);
                    return createEllipse(ellipse.center, ellipse.radius, args);
                },
                Oval: '#Ellipse',
                Arc: function() {
                    var args = arguments, from = Point.readNamed(args, 'from'), through = Point.readNamed(args, 'through'), to = Point.readNamed(args, 'to'), props = Base.getNamed(args), path = new Path(props && props.insert == false && Item.NO_INSERT);
                    path.moveTo(from);
                    path.arcTo(through, to);
                    return path.set(props);
                },
                RegularPolygon: function() {
                    var args = arguments, center = Point.readNamed(args, 'center'), sides = Base.readNamed(args, 'sides'), radius = Base.readNamed(args, 'radius'), step = 360 / sides, three = sides % 3 === 0, vector = new Point(0, three ? -radius : radius), offset = three ? -1 : 0.5, segments = new Array(sides);
                    for(var i = 0; i < sides; i++)segments[i] = new Segment(center.add(vector.rotate((i + offset) * step)));
                    return createPath(segments, true, args);
                },
                Star: function() {
                    var args = arguments, center = Point.readNamed(args, 'center'), points = Base.readNamed(args, 'points') * 2, radius1 = Base.readNamed(args, 'radius1'), radius2 = Base.readNamed(args, 'radius2'), step = 360 / points, vector = new Point(0, -1), segments = new Array(points);
                    for(var i = 0; i < points; i++)segments[i] = new Segment(center.add(vector.rotate(step * i).multiply(i % 2 ? radius2 : radius1)));
                    return createPath(segments, true, args);
                }
            };
        }
    });
    var CompoundPath = PathItem.extend({
        _class: 'CompoundPath',
        _serializeFields: {
            children: []
        },
        beans: true,
        initialize: function CompoundPath(arg) {
            this._children = [];
            this._namedChildren = {};
            if (!this._initialize(arg)) {
                if (typeof arg === 'string') this.setPathData(arg);
                else this.addChildren(Array.isArray(arg) ? arg : arguments);
            }
        },
        insertChildren: function insertChildren(index, items) {
            var list = items, first = list[0];
            if (first && typeof first[0] === 'number') list = [
                list
            ];
            for(var i = items.length - 1; i >= 0; i--){
                var item = list[i];
                if (list === items && !(item instanceof Path)) list = Base.slice(list);
                if (Array.isArray(item)) list[i] = new Path({
                    segments: item,
                    insert: false
                });
                else if (item instanceof CompoundPath) {
                    list.splice.apply(list, [
                        i,
                        1
                    ].concat(item.removeChildren()));
                    item.remove();
                }
            }
            return insertChildren.base.call(this, index, list);
        },
        reduce: function reduce(options) {
            var children = this._children;
            for(var i = children.length - 1; i >= 0; i--){
                var path = children[i].reduce(options);
                if (path.isEmpty()) path.remove();
            }
            if (!children.length) {
                var path = new Path(Item.NO_INSERT);
                path.copyAttributes(this);
                path.insertAbove(this);
                this.remove();
                return path;
            }
            return reduce.base.call(this);
        },
        isClosed: function() {
            var children = this._children;
            for(var i = 0, l = children.length; i < l; i++){
                if (!children[i]._closed) return false;
            }
            return true;
        },
        setClosed: function(closed) {
            var children = this._children;
            for(var i = 0, l = children.length; i < l; i++)children[i].setClosed(closed);
        },
        getFirstSegment: function() {
            var first = this.getFirstChild();
            return first && first.getFirstSegment();
        },
        getLastSegment: function() {
            var last = this.getLastChild();
            return last && last.getLastSegment();
        },
        getCurves: function() {
            var children = this._children, curves = [];
            for(var i = 0, l = children.length; i < l; i++)Base.push(curves, children[i].getCurves());
            return curves;
        },
        getFirstCurve: function() {
            var first = this.getFirstChild();
            return first && first.getFirstCurve();
        },
        getLastCurve: function() {
            var last = this.getLastChild();
            return last && last.getLastCurve();
        },
        getArea: function() {
            var children = this._children, area = 0;
            for(var i = 0, l = children.length; i < l; i++)area += children[i].getArea();
            return area;
        },
        getLength: function() {
            var children = this._children, length = 0;
            for(var i = 0, l = children.length; i < l; i++)length += children[i].getLength();
            return length;
        },
        getPathData: function(_matrix, _precision) {
            var children = this._children, paths = [];
            for(var i = 0, l = children.length; i < l; i++){
                var child = children[i], mx = child._matrix;
                paths.push(child.getPathData(_matrix && !mx.isIdentity() ? _matrix.appended(mx) : _matrix, _precision));
            }
            return paths.join('');
        },
        _hitTestChildren: function _hitTestChildren(point, options, viewMatrix) {
            return _hitTestChildren.base.call(this, point, options.class === Path || options.type === 'path' ? options : Base.set({}, options, {
                fill: false
            }), viewMatrix);
        },
        _draw: function(ctx, param, viewMatrix, strokeMatrix) {
            var children = this._children;
            if (!children.length) return;
            param = param.extend({
                dontStart: true,
                dontFinish: true
            });
            ctx.beginPath();
            for(var i = 0, l = children.length; i < l; i++)children[i].draw(ctx, param, strokeMatrix);
            if (!param.clip) {
                this._setStyles(ctx, param, viewMatrix);
                var style = this._style;
                if (style.hasFill()) {
                    ctx.fill(style.getFillRule());
                    ctx.shadowColor = 'rgba(0,0,0,0)';
                }
                if (style.hasStroke()) ctx.stroke();
            }
        },
        _drawSelected: function(ctx, matrix, selectionItems) {
            var children = this._children;
            for(var i = 0, l = children.length; i < l; i++){
                var child = children[i], mx = child._matrix;
                if (!selectionItems[child._id]) child._drawSelected(ctx, mx.isIdentity() ? matrix : matrix.appended(mx));
            }
        }
    }, new function() {
        function getCurrentPath(that, check) {
            var children = that._children;
            if (check && !children.length) throw new Error('Use a moveTo() command first');
            return children[children.length - 1];
        }
        return Base.each([
            'lineTo',
            'cubicCurveTo',
            'quadraticCurveTo',
            'curveTo',
            'arcTo',
            'lineBy',
            'cubicCurveBy',
            'quadraticCurveBy',
            'curveBy',
            'arcBy'
        ], function(key) {
            this[key] = function() {
                var path = getCurrentPath(this, true);
                path[key].apply(path, arguments);
            };
        }, {
            moveTo: function() {
                var current = getCurrentPath(this), path = current && current.isEmpty() ? current : new Path(Item.NO_INSERT);
                if (path !== current) this.addChild(path);
                path.moveTo.apply(path, arguments);
            },
            moveBy: function() {
                var current = getCurrentPath(this, true), last = current && current.getLastSegment(), point = Point.read(arguments);
                this.moveTo(last ? point.add(last._point) : point);
            },
            closePath: function(tolerance) {
                getCurrentPath(this, true).closePath(tolerance);
            }
        });
    }, Base.each([
        'reverse',
        'flatten',
        'simplify',
        'smooth'
    ], function(key) {
        this[key] = function(param) {
            var children = this._children, res;
            for(var i = 0, l = children.length; i < l; i++)res = children[i][key](param) || res;
            return res;
        };
    }, {}));
    PathItem.inject(new function() {
        var min = Math.min, max = Math.max, abs = Math.abs, operators = {
            unite: {
                '1': true,
                '2': true
            },
            intersect: {
                '2': true
            },
            subtract: {
                '1': true
            },
            exclude: {
                '1': true,
                '-1': true
            }
        };
        function getPaths(path) {
            return path._children || [
                path
            ];
        }
        function preparePath(path, resolve) {
            var res = path.clone(false).reduce({
                simplify: true
            }).transform(null, true, true);
            if (resolve) {
                var paths = getPaths(res);
                for(var i = 0, l = paths.length; i < l; i++){
                    var path = paths[i];
                    if (!path._closed && !path.isEmpty()) {
                        path.closePath(1e-12);
                        path.getFirstSegment().setHandleIn(0, 0);
                        path.getLastSegment().setHandleOut(0, 0);
                    }
                }
                res = res.resolveCrossings().reorient(res.getFillRule() === 'nonzero', true);
            }
            return res;
        }
        function createResult(paths, simplify, path1, path2, options) {
            var result = new CompoundPath(Item.NO_INSERT);
            result.addChildren(paths, true);
            result = result.reduce({
                simplify: simplify
            });
            if (!(options && options.insert == false)) result.insertAbove(path2 && path1.isSibling(path2) && path1.getIndex() < path2.getIndex() ? path2 : path1);
            result.copyAttributes(path1, true);
            return result;
        }
        function filterIntersection(inter) {
            return inter.hasOverlap() || inter.isCrossing();
        }
        function traceBoolean(path1, path2, operation, options) {
            if (options && (options.trace == false || options.stroke) && /^(subtract|intersect)$/.test(operation)) return splitBoolean(path1, path2, operation);
            var _path1 = preparePath(path1, true), _path2 = path2 && path1 !== path2 && preparePath(path2, true), operator = operators[operation];
            operator[operation] = true;
            if (_path2 && (operator.subtract || operator.exclude) ^ (_path2.isClockwise() ^ _path1.isClockwise())) _path2.reverse();
            var crossings = divideLocations(CurveLocation.expand(_path1.getIntersections(_path2, filterIntersection))), paths1 = getPaths(_path1), paths2 = _path2 && getPaths(_path2), segments = [], curves = [], paths;
            function collectPaths(paths) {
                for(var i = 0, l = paths.length; i < l; i++){
                    var path = paths[i];
                    Base.push(segments, path._segments);
                    Base.push(curves, path.getCurves());
                    path._overlapsOnly = true;
                }
            }
            function getCurves(indices) {
                var list = [];
                for(var i = 0, l = indices && indices.length; i < l; i++)list.push(curves[indices[i]]);
                return list;
            }
            if (crossings.length) {
                collectPaths(paths1);
                if (paths2) collectPaths(paths2);
                var curvesValues = new Array(curves.length);
                for(var i = 0, l = curves.length; i < l; i++)curvesValues[i] = curves[i].getValues();
                var curveCollisions = CollisionDetection.findCurveBoundsCollisions(curvesValues, curvesValues, 0, true);
                var curveCollisionsMap = {};
                for(var i = 0; i < curves.length; i++){
                    var curve = curves[i], id = curve._path._id, map = curveCollisionsMap[id] = curveCollisionsMap[id] || {};
                    map[curve.getIndex()] = {
                        hor: getCurves(curveCollisions[i].hor),
                        ver: getCurves(curveCollisions[i].ver)
                    };
                }
                for(var i = 0, l = crossings.length; i < l; i++)propagateWinding(crossings[i]._segment, _path1, _path2, curveCollisionsMap, operator);
                for(var i = 0, l = segments.length; i < l; i++){
                    var segment = segments[i], inter = segment._intersection;
                    if (!segment._winding) propagateWinding(segment, _path1, _path2, curveCollisionsMap, operator);
                    if (!(inter && inter._overlap)) segment._path._overlapsOnly = false;
                }
                paths = tracePaths(segments, operator);
            } else paths = reorientPaths(paths2 ? paths1.concat(paths2) : paths1.slice(), function(w) {
                return !!operator[w];
            });
            return createResult(paths, true, path1, path2, options);
        }
        function splitBoolean(path1, path2, operation) {
            var _path1 = preparePath(path1), _path2 = preparePath(path2), crossings = _path1.getIntersections(_path2, filterIntersection), subtract = operation === 'subtract', divide = operation === 'divide', added = {}, paths = [];
            function addPath(path) {
                if (!added[path._id] && (divide || _path2.contains(path.getPointAt(path.getLength() / 2)) ^ subtract)) {
                    paths.unshift(path);
                    return added[path._id] = true;
                }
            }
            for(var i = crossings.length - 1; i >= 0; i--){
                var path = crossings[i].split();
                if (path) {
                    if (addPath(path)) path.getFirstSegment().setHandleIn(0, 0);
                    _path1.getLastSegment().setHandleOut(0, 0);
                }
            }
            addPath(_path1);
            return createResult(paths, false, path1, path2);
        }
        function linkIntersections(from, to) {
            var prev = from;
            while(prev){
                if (prev === to) return;
                prev = prev._previous;
            }
            while(from._next && from._next !== to)from = from._next;
            if (!from._next) {
                while(to._previous)to = to._previous;
                from._next = to;
                to._previous = from;
            }
        }
        function clearCurveHandles(curves) {
            for(var i = curves.length - 1; i >= 0; i--)curves[i].clearHandles();
        }
        function reorientPaths(paths, isInside, clockwise) {
            var length = paths && paths.length;
            if (length) {
                var lookup = Base.each(paths, function(path, i) {
                    this[path._id] = {
                        container: null,
                        winding: path.isClockwise() ? 1 : -1,
                        index: i
                    };
                }, {}), sorted = paths.slice().sort(function(a, b) {
                    return abs(b.getArea()) - abs(a.getArea());
                }), first = sorted[0];
                var collisions = CollisionDetection.findItemBoundsCollisions(sorted, null, Numerical.GEOMETRIC_EPSILON);
                if (clockwise == null) clockwise = first.isClockwise();
                for(var i = 0; i < length; i++){
                    var path1 = sorted[i], entry1 = lookup[path1._id], containerWinding = 0, indices = collisions[i];
                    if (indices) {
                        var point = null;
                        for(var j = indices.length - 1; j >= 0; j--)if (indices[j] < i) {
                            point = point || path1.getInteriorPoint();
                            var path2 = sorted[indices[j]];
                            if (path2.contains(point)) {
                                var entry2 = lookup[path2._id];
                                containerWinding = entry2.winding;
                                entry1.winding += containerWinding;
                                entry1.container = entry2.exclude ? entry2.container : path2;
                                break;
                            }
                        }
                    }
                    if (isInside(entry1.winding) === isInside(containerWinding)) {
                        entry1.exclude = true;
                        paths[entry1.index] = null;
                    } else {
                        var container = entry1.container;
                        path1.setClockwise(container ? !container.isClockwise() : clockwise);
                    }
                }
            }
            return paths;
        }
        function divideLocations(locations, include, clearLater) {
            var results = include && [], tMin = 1e-8, tMax = 1 - tMin, clearHandles = false, clearCurves = clearLater || [], clearLookup = clearLater && {}, renormalizeLocs, prevCurve, prevTime;
            function getId(curve) {
                return curve._path._id + '.' + curve._segment1._index;
            }
            for(var i = (clearLater && clearLater.length) - 1; i >= 0; i--){
                var curve = clearLater[i];
                if (curve._path) clearLookup[getId(curve)] = true;
            }
            for(var i = locations.length - 1; i >= 0; i--){
                var loc = locations[i], time = loc._time, origTime = time, exclude = include && !include(loc), curve = loc._curve, segment;
                if (curve) {
                    if (curve !== prevCurve) {
                        clearHandles = !curve.hasHandles() || clearLookup && clearLookup[getId(curve)];
                        renormalizeLocs = [];
                        prevTime = null;
                        prevCurve = curve;
                    } else if (prevTime >= tMin) time /= prevTime;
                }
                if (exclude) {
                    if (renormalizeLocs) renormalizeLocs.push(loc);
                    continue;
                } else if (include) results.unshift(loc);
                prevTime = origTime;
                if (time < tMin) segment = curve._segment1;
                else if (time > tMax) segment = curve._segment2;
                else {
                    var newCurve = curve.divideAtTime(time, true);
                    if (clearHandles) clearCurves.push(curve, newCurve);
                    segment = newCurve._segment1;
                    for(var j = renormalizeLocs.length - 1; j >= 0; j--){
                        var l = renormalizeLocs[j];
                        l._time = (l._time - time) / (1 - time);
                    }
                }
                loc._setSegment(segment);
                var inter = segment._intersection, dest = loc._intersection;
                if (inter) {
                    linkIntersections(inter, dest);
                    var other = inter;
                    while(other){
                        linkIntersections(other._intersection, inter);
                        other = other._next;
                    }
                } else segment._intersection = dest;
            }
            if (!clearLater) clearCurveHandles(clearCurves);
            return results || locations;
        }
        function getWinding(point, curves, dir, closed, dontFlip) {
            var curvesList = Array.isArray(curves) ? curves : curves[dir ? 'hor' : 'ver'];
            var ia = dir ? 1 : 0, io = ia ^ 1, pv = [
                point.x,
                point.y
            ], pa = pv[ia], po = pv[io], windingEpsilon = 1e-9, qualityEpsilon = 1e-6, paL = pa - windingEpsilon, paR = pa + windingEpsilon, windingL = 0, windingR = 0, pathWindingL = 0, pathWindingR = 0, onPath = false, onAnyPath = false, quality = 1, roots = [], vPrev, vClose;
            function addWinding(v) {
                var o0 = v[io + 0], o3 = v[io + 6];
                if (po < min(o0, o3) || po > max(o0, o3)) return;
                var a0 = v[ia + 0], a1 = v[ia + 2], a2 = v[ia + 4], a3 = v[ia + 6];
                if (o0 === o3) {
                    if (a0 < paR && a3 > paL || a3 < paR && a0 > paL) onPath = true;
                    return;
                }
                var t = po === o0 ? 0 : po === o3 ? 1 : paL > max(a0, a1, a2, a3) || paR < min(a0, a1, a2, a3) ? 1 : Curve.solveCubic(v, io, po, roots, 0, 1) > 0 ? roots[0] : 1, a = t === 0 ? a0 : t === 1 ? a3 : Curve.getPoint(v, t)[dir ? 'y' : 'x'], winding = o0 > o3 ? 1 : -1, windingPrev = vPrev[io] > vPrev[io + 6] ? 1 : -1, a3Prev = vPrev[ia + 6];
                if (po !== o0) {
                    if (a < paL) pathWindingL += winding;
                    else if (a > paR) pathWindingR += winding;
                    else onPath = true;
                    if (a > pa - qualityEpsilon && a < pa + qualityEpsilon) quality /= 2;
                } else {
                    if (winding !== windingPrev) {
                        if (a0 < paL) pathWindingL += winding;
                        else if (a0 > paR) pathWindingR += winding;
                    } else if (a0 != a3Prev) {
                        if (a3Prev < paR && a > paR) {
                            pathWindingR += winding;
                            onPath = true;
                        } else if (a3Prev > paL && a < paL) {
                            pathWindingL += winding;
                            onPath = true;
                        }
                    }
                    quality /= 4;
                }
                vPrev = v;
                return !dontFlip && a > paL && a < paR && Curve.getTangent(v, t)[dir ? 'x' : 'y'] === 0 && getWinding(point, curves, !dir, closed, true);
            }
            function handleCurve(v) {
                var o0 = v[io + 0], o1 = v[io + 2], o2 = v[io + 4], o3 = v[io + 6];
                if (po <= max(o0, o1, o2, o3) && po >= min(o0, o1, o2, o3)) {
                    var a0 = v[ia + 0], a1 = v[ia + 2], a2 = v[ia + 4], a3 = v[ia + 6], monoCurves = paL > max(a0, a1, a2, a3) || paR < min(a0, a1, a2, a3) ? [
                        v
                    ] : Curve.getMonoCurves(v, dir), res;
                    for(var i = 0, l = monoCurves.length; i < l; i++){
                        if (res = addWinding(monoCurves[i])) return res;
                    }
                }
            }
            for(var i = 0, l = curvesList.length; i < l; i++){
                var curve = curvesList[i], path = curve._path, v = curve.getValues(), res;
                if (!i || curvesList[i - 1]._path !== path) {
                    vPrev = null;
                    if (!path._closed) {
                        vClose = Curve.getValues(path.getLastCurve().getSegment2(), curve.getSegment1(), null, !closed);
                        if (vClose[io] !== vClose[io + 6]) vPrev = vClose;
                    }
                    if (!vPrev) {
                        vPrev = v;
                        var prev = path.getLastCurve();
                        while(prev && prev !== curve){
                            var v2 = prev.getValues();
                            if (v2[io] !== v2[io + 6]) {
                                vPrev = v2;
                                break;
                            }
                            prev = prev.getPrevious();
                        }
                    }
                }
                if (res = handleCurve(v)) return res;
                if (i + 1 === l || curvesList[i + 1]._path !== path) {
                    if (vClose && (res = handleCurve(vClose))) return res;
                    if (onPath && !pathWindingL && !pathWindingR) pathWindingL = pathWindingR = path.isClockwise(closed) ^ dir ? 1 : -1;
                    windingL += pathWindingL;
                    windingR += pathWindingR;
                    pathWindingL = pathWindingR = 0;
                    if (onPath) {
                        onAnyPath = true;
                        onPath = false;
                    }
                    vClose = null;
                }
            }
            windingL = abs(windingL);
            windingR = abs(windingR);
            return {
                winding: max(windingL, windingR),
                windingL: windingL,
                windingR: windingR,
                quality: quality,
                onPath: onAnyPath
            };
        }
        function propagateWinding(segment, path1, path2, curveCollisionsMap, operator) {
            var chain = [], start = segment, totalLength = 0, winding;
            do {
                var curve = segment.getCurve();
                if (curve) {
                    var length = curve.getLength();
                    chain.push({
                        segment: segment,
                        curve: curve,
                        length: length
                    });
                    totalLength += length;
                }
                segment = segment.getNext();
            }while (segment && !segment._intersection && segment !== start);
            var offsets = [
                0.5,
                0.25,
                0.75
            ], winding = {
                winding: 0,
                quality: -1
            }, tMin = 1e-3, tMax = 1 - tMin;
            for(var i = 0; i < offsets.length && winding.quality < 0.5; i++){
                var length = totalLength * offsets[i];
                for(var j = 0, l = chain.length; j < l; j++){
                    var entry = chain[j], curveLength = entry.length;
                    if (length <= curveLength) {
                        var curve = entry.curve, path = curve._path, parent = path._parent, operand = parent instanceof CompoundPath ? parent : path, t = Numerical.clamp(curve.getTimeAt(length), tMin, tMax), pt = curve.getPointAtTime(t), dir = abs(curve.getTangentAtTime(t).y) < Math.SQRT1_2;
                        var wind = null;
                        if (operator.subtract && path2) {
                            var otherPath = operand === path1 ? path2 : path1, pathWinding = otherPath._getWinding(pt, dir, true);
                            if (operand === path1 && pathWinding.winding || operand === path2 && !pathWinding.winding) {
                                if (pathWinding.quality < 1) continue;
                                else wind = {
                                    winding: 0,
                                    quality: 1
                                };
                            }
                        }
                        wind = wind || getWinding(pt, curveCollisionsMap[path._id][curve.getIndex()], dir, true);
                        if (wind.quality > winding.quality) winding = wind;
                        break;
                    }
                    length -= curveLength;
                }
            }
            for(var j = chain.length - 1; j >= 0; j--)chain[j].segment._winding = winding;
        }
        function tracePaths(segments, operator) {
            var paths = [], starts;
            function isValid(seg) {
                var winding;
                return !!(seg && !seg._visited && (!operator || operator[(winding = seg._winding || {}).winding] && !(operator.unite && winding.winding === 2 && winding.windingL && winding.windingR)));
            }
            function isStart(seg) {
                if (seg) for(var i = 0, l = starts.length; i < l; i++){
                    if (seg === starts[i]) return true;
                }
                return false;
            }
            function visitPath(path) {
                var segments = path._segments;
                for(var i = 0, l = segments.length; i < l; i++)segments[i]._visited = true;
            }
            function getCrossingSegments(segment, collectStarts) {
                var inter = segment._intersection, start = inter, crossings = [];
                if (collectStarts) starts = [
                    segment
                ];
                function collect(inter, end) {
                    while(inter && inter !== end){
                        var other = inter._segment, path = other && other._path;
                        if (path) {
                            var next = other.getNext() || path.getFirstSegment(), nextInter = next._intersection;
                            if (other !== segment && (isStart(other) || isStart(next) || next && isValid(other) && (isValid(next) || nextInter && isValid(nextInter._segment)))) crossings.push(other);
                            if (collectStarts) starts.push(other);
                        }
                        inter = inter._next;
                    }
                }
                if (inter) {
                    collect(inter);
                    while(inter && inter._previous)inter = inter._previous;
                    collect(inter, start);
                }
                return crossings;
            }
            segments.sort(function(seg1, seg2) {
                var inter1 = seg1._intersection, inter2 = seg2._intersection, over1 = !!(inter1 && inter1._overlap), over2 = !!(inter2 && inter2._overlap), path1 = seg1._path, path2 = seg2._path;
                return over1 ^ over2 ? over1 ? 1 : -1 : !inter1 ^ !inter2 ? inter1 ? 1 : -1 : path1 !== path2 ? path1._id - path2._id : seg1._index - seg2._index;
            });
            for(var i = 0, l = segments.length; i < l; i++){
                var seg = segments[i], valid = isValid(seg), path = null, finished = false, closed = true, branches = [], branch, visited, handleIn;
                if (valid && seg._path._overlapsOnly) {
                    var path1 = seg._path, path2 = seg._intersection._segment._path;
                    if (path1.compare(path2)) {
                        if (path1.getArea()) paths.push(path1.clone(false));
                        visitPath(path1);
                        visitPath(path2);
                        valid = false;
                    }
                }
                while(valid){
                    var first = !path, crossings = getCrossingSegments(seg, first), other = crossings.shift(), finished = !first && (isStart(seg) || isStart(other)), cross = !finished && other;
                    if (first) {
                        path = new Path(Item.NO_INSERT);
                        branch = null;
                    }
                    if (finished) {
                        if (seg.isFirst() || seg.isLast()) closed = seg._path._closed;
                        seg._visited = true;
                        break;
                    }
                    if (cross && branch) {
                        branches.push(branch);
                        branch = null;
                    }
                    if (!branch) {
                        if (cross) crossings.push(seg);
                        branch = {
                            start: path._segments.length,
                            crossings: crossings,
                            visited: visited = [],
                            handleIn: handleIn
                        };
                    }
                    if (cross) seg = other;
                    if (!isValid(seg)) {
                        path.removeSegments(branch.start);
                        for(var j = 0, k = visited.length; j < k; j++)visited[j]._visited = false;
                        visited.length = 0;
                        do {
                            seg = branch && branch.crossings.shift();
                            if (!seg || !seg._path) {
                                seg = null;
                                branch = branches.pop();
                                if (branch) {
                                    visited = branch.visited;
                                    handleIn = branch.handleIn;
                                }
                            }
                        }while (branch && !isValid(seg));
                        if (!seg) break;
                    }
                    var next = seg.getNext();
                    path.add(new Segment(seg._point, handleIn, next && seg._handleOut));
                    seg._visited = true;
                    visited.push(seg);
                    seg = next || seg._path.getFirstSegment();
                    handleIn = next && next._handleIn;
                }
                if (finished) {
                    if (closed) {
                        path.getFirstSegment().setHandleIn(handleIn);
                        path.setClosed(closed);
                    }
                    if (path.getArea() !== 0) paths.push(path);
                }
            }
            return paths;
        }
        return {
            _getWinding: function(point, dir, closed) {
                return getWinding(point, this.getCurves(), dir, closed);
            },
            unite: function(path, options) {
                return traceBoolean(this, path, 'unite', options);
            },
            intersect: function(path, options) {
                return traceBoolean(this, path, 'intersect', options);
            },
            subtract: function(path, options) {
                return traceBoolean(this, path, 'subtract', options);
            },
            exclude: function(path, options) {
                return traceBoolean(this, path, 'exclude', options);
            },
            divide: function(path, options) {
                return options && (options.trace == false || options.stroke) ? splitBoolean(this, path, 'divide') : createResult([
                    this.subtract(path, options),
                    this.intersect(path, options)
                ], true, this, path, options);
            },
            resolveCrossings: function() {
                var children = this._children, paths = children || [
                    this
                ];
                function hasOverlap(seg, path) {
                    var inter = seg && seg._intersection;
                    return inter && inter._overlap && inter._path === path;
                }
                var hasOverlaps = false, hasCrossings = false, intersections = this.getIntersections(null, function(inter) {
                    return inter.hasOverlap() && (hasOverlaps = true) || inter.isCrossing() && (hasCrossings = true);
                }), clearCurves = hasOverlaps && hasCrossings && [];
                intersections = CurveLocation.expand(intersections);
                if (hasOverlaps) {
                    var overlaps = divideLocations(intersections, function(inter) {
                        return inter.hasOverlap();
                    }, clearCurves);
                    for(var i = overlaps.length - 1; i >= 0; i--){
                        var overlap = overlaps[i], path = overlap._path, seg = overlap._segment, prev = seg.getPrevious(), next = seg.getNext();
                        if (hasOverlap(prev, path) && hasOverlap(next, path)) {
                            seg.remove();
                            prev._handleOut._set(0, 0);
                            next._handleIn._set(0, 0);
                            if (prev !== seg && !prev.getCurve().hasLength()) {
                                next._handleIn.set(prev._handleIn);
                                prev.remove();
                            }
                        }
                    }
                }
                if (hasCrossings) {
                    divideLocations(intersections, hasOverlaps && function(inter) {
                        var curve1 = inter.getCurve(), seg1 = inter.getSegment(), other = inter._intersection, curve2 = other._curve, seg2 = other._segment;
                        if (curve1 && curve2 && curve1._path && curve2._path) return true;
                        if (seg1) seg1._intersection = null;
                        if (seg2) seg2._intersection = null;
                    }, clearCurves);
                    if (clearCurves) clearCurveHandles(clearCurves);
                    paths = tracePaths(Base.each(paths, function(path) {
                        Base.push(this, path._segments);
                    }, []));
                }
                var length = paths.length, item;
                if (length > 1 && children) {
                    if (paths !== children) this.setChildren(paths);
                    item = this;
                } else if (length === 1 && !children) {
                    if (paths[0] !== this) this.setSegments(paths[0].removeSegments());
                    item = this;
                }
                if (!item) {
                    item = new CompoundPath(Item.NO_INSERT);
                    item.addChildren(paths);
                    item = item.reduce();
                    item.copyAttributes(this);
                    this.replaceWith(item);
                }
                return item;
            },
            reorient: function(nonZero, clockwise) {
                var children = this._children;
                if (children && children.length) this.setChildren(reorientPaths(this.removeChildren(), function(w) {
                    return !!(nonZero ? w : w & 1);
                }, clockwise));
                else if (clockwise !== undefined) this.setClockwise(clockwise);
                return this;
            },
            getInteriorPoint: function() {
                var bounds = this.getBounds(), point = bounds.getCenter(true);
                if (!this.contains(point)) {
                    var curves = this.getCurves(), y = point.y, intercepts = [], roots = [];
                    for(var i = 0, l = curves.length; i < l; i++){
                        var v = curves[i].getValues(), o0 = v[1], o1 = v[3], o2 = v[5], o3 = v[7];
                        if (y >= min(o0, o1, o2, o3) && y <= max(o0, o1, o2, o3)) {
                            var monoCurves = Curve.getMonoCurves(v);
                            for(var j = 0, m = monoCurves.length; j < m; j++){
                                var mv = monoCurves[j], mo0 = mv[1], mo3 = mv[7];
                                if (mo0 !== mo3 && (y >= mo0 && y <= mo3 || y >= mo3 && y <= mo0)) {
                                    var x = y === mo0 ? mv[0] : y === mo3 ? mv[6] : Curve.solveCubic(mv, 1, y, roots, 0, 1) === 1 ? Curve.getPoint(mv, roots[0]).x : (mv[0] + mv[6]) / 2;
                                    intercepts.push(x);
                                }
                            }
                        }
                    }
                    if (intercepts.length > 1) {
                        intercepts.sort(function(a, b) {
                            return a - b;
                        });
                        point.x = (intercepts[0] + intercepts[1]) / 2;
                    }
                }
                return point;
            }
        };
    });
    var PathFlattener = Base.extend({
        _class: 'PathFlattener',
        initialize: function(path, flatness, maxRecursion, ignoreStraight, matrix) {
            var curves = [], parts = [], length = 0, minSpan = 1 / (maxRecursion || 32), segments = path._segments, segment1 = segments[0], segment2;
            function addCurve(segment1, segment2) {
                var curve = Curve.getValues(segment1, segment2, matrix);
                curves.push(curve);
                computeParts(curve, segment1._index, 0, 1);
            }
            function computeParts(curve, index, t1, t2) {
                if (t2 - t1 > minSpan && !(ignoreStraight && Curve.isStraight(curve)) && !Curve.isFlatEnough(curve, flatness || 0.25)) {
                    var halves = Curve.subdivide(curve, 0.5), tMid = (t1 + t2) / 2;
                    computeParts(halves[0], index, t1, tMid);
                    computeParts(halves[1], index, tMid, t2);
                } else {
                    var dx = curve[6] - curve[0], dy = curve[7] - curve[1], dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist > 0) {
                        length += dist;
                        parts.push({
                            offset: length,
                            curve: curve,
                            index: index,
                            time: t2
                        });
                    }
                }
            }
            for(var i = 1, l = segments.length; i < l; i++){
                segment2 = segments[i];
                addCurve(segment1, segment2);
                segment1 = segment2;
            }
            if (path._closed) addCurve(segment2 || segment1, segments[0]);
            this.curves = curves;
            this.parts = parts;
            this.length = length;
            this.index = 0;
        },
        _get: function(offset) {
            var parts = this.parts, length = parts.length, start, i, j = this.index;
            for(;;){
                i = j;
                if (!j || parts[--j].offset < offset) break;
            }
            for(; i < length; i++){
                var part = parts[i];
                if (part.offset >= offset) {
                    this.index = i;
                    var prev = parts[i - 1], prevTime = prev && prev.index === part.index ? prev.time : 0, prevOffset = prev ? prev.offset : 0;
                    return {
                        index: part.index,
                        time: prevTime + (part.time - prevTime) * (offset - prevOffset) / (part.offset - prevOffset)
                    };
                }
            }
            return {
                index: parts[length - 1].index,
                time: 1
            };
        },
        drawPart: function(ctx, from, to) {
            var start = this._get(from), end = this._get(to);
            for(var i = start.index, l = end.index; i <= l; i++){
                var curve = Curve.getPart(this.curves[i], i === start.index ? start.time : 0, i === end.index ? end.time : 1);
                if (i === start.index) ctx.moveTo(curve[0], curve[1]);
                ctx.bezierCurveTo.apply(ctx, curve.slice(2));
            }
        }
    }, Base.each(Curve._evaluateMethods, function(name) {
        this[name + 'At'] = function(offset) {
            var param = this._get(offset);
            return Curve[name](this.curves[param.index], param.time);
        };
    }, {}));
    var PathFitter = Base.extend({
        initialize: function(path) {
            var points = this.points = [], segments = path._segments, closed = path._closed;
            for(var i = 0, prev, l = segments.length; i < l; i++){
                var point = segments[i].point;
                if (!prev || !prev.equals(point)) points.push(prev = point.clone());
            }
            if (closed) {
                points.unshift(points[points.length - 1]);
                points.push(points[1]);
            }
            this.closed = closed;
        },
        fit: function(error) {
            var points = this.points, length = points.length, segments = null;
            if (length > 0) {
                segments = [
                    new Segment(points[0])
                ];
                if (length > 1) {
                    this.fitCubic(segments, error, 0, length - 1, points[1].subtract(points[0]), points[length - 2].subtract(points[length - 1]));
                    if (this.closed) {
                        segments.shift();
                        segments.pop();
                    }
                }
            }
            return segments;
        },
        fitCubic: function(segments, error, first, last, tan1, tan2) {
            var points = this.points;
            if (last - first === 1) {
                var pt1 = points[first], pt2 = points[last], dist = pt1.getDistance(pt2) / 3;
                this.addCurve(segments, [
                    pt1,
                    pt1.add(tan1.normalize(dist)),
                    pt2.add(tan2.normalize(dist)),
                    pt2
                ]);
                return;
            }
            var uPrime = this.chordLengthParameterize(first, last), maxError = Math.max(error, error * error), split, parametersInOrder = true;
            for(var i = 0; i <= 4; i++){
                var curve = this.generateBezier(first, last, uPrime, tan1, tan2);
                var max = this.findMaxError(first, last, curve, uPrime);
                if (max.error < error && parametersInOrder) {
                    this.addCurve(segments, curve);
                    return;
                }
                split = max.index;
                if (max.error >= maxError) break;
                parametersInOrder = this.reparameterize(first, last, uPrime, curve);
                maxError = max.error;
            }
            var tanCenter = points[split - 1].subtract(points[split + 1]);
            this.fitCubic(segments, error, first, split, tan1, tanCenter);
            this.fitCubic(segments, error, split, last, tanCenter.negate(), tan2);
        },
        addCurve: function(segments, curve) {
            var prev = segments[segments.length - 1];
            prev.setHandleOut(curve[1].subtract(curve[0]));
            segments.push(new Segment(curve[3], curve[2].subtract(curve[3])));
        },
        generateBezier: function(first, last, uPrime, tan1, tan2) {
            var epsilon = 1e-12, abs = Math.abs, points = this.points, pt1 = points[first], pt2 = points[last], C = [
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ]
            ], X = [
                0,
                0
            ];
            for(var i = 0, l = last - first + 1; i < l; i++){
                var u = uPrime[i], t = 1 - u, b = 3 * u * t, b0 = t * t * t, b1 = b * t, b2 = b * u, b3 = u * u * u, a1 = tan1.normalize(b1), a2 = tan2.normalize(b2), tmp = points[first + i].subtract(pt1.multiply(b0 + b1)).subtract(pt2.multiply(b2 + b3));
                C[0][0] += a1.dot(a1);
                C[0][1] += a1.dot(a2);
                C[1][0] = C[0][1];
                C[1][1] += a2.dot(a2);
                X[0] += a1.dot(tmp);
                X[1] += a2.dot(tmp);
            }
            var detC0C1 = C[0][0] * C[1][1] - C[1][0] * C[0][1], alpha1, alpha2;
            if (abs(detC0C1) > epsilon) {
                var detC0X = C[0][0] * X[1] - C[1][0] * X[0], detXC1 = X[0] * C[1][1] - X[1] * C[0][1];
                alpha1 = detXC1 / detC0C1;
                alpha2 = detC0X / detC0C1;
            } else {
                var c0 = C[0][0] + C[0][1], c1 = C[1][0] + C[1][1];
                alpha1 = alpha2 = abs(c0) > epsilon ? X[0] / c0 : abs(c1) > epsilon ? X[1] / c1 : 0;
            }
            var segLength = pt2.getDistance(pt1), eps = epsilon * segLength, handle1, handle2;
            if (alpha1 < eps || alpha2 < eps) alpha1 = alpha2 = segLength / 3;
            else {
                var line = pt2.subtract(pt1);
                handle1 = tan1.normalize(alpha1);
                handle2 = tan2.normalize(alpha2);
                if (handle1.dot(line) - handle2.dot(line) > segLength * segLength) {
                    alpha1 = alpha2 = segLength / 3;
                    handle1 = handle2 = null;
                }
            }
            return [
                pt1,
                pt1.add(handle1 || tan1.normalize(alpha1)),
                pt2.add(handle2 || tan2.normalize(alpha2)),
                pt2
            ];
        },
        reparameterize: function(first, last, u, curve) {
            for(var i = first; i <= last; i++)u[i - first] = this.findRoot(curve, this.points[i], u[i - first]);
            for(var i = 1, l = u.length; i < l; i++){
                if (u[i] <= u[i - 1]) return false;
            }
            return true;
        },
        findRoot: function(curve, point, u) {
            var curve1 = [], curve2 = [];
            for(var i = 0; i <= 2; i++)curve1[i] = curve[i + 1].subtract(curve[i]).multiply(3);
            for(var i = 0; i <= 1; i++)curve2[i] = curve1[i + 1].subtract(curve1[i]).multiply(2);
            var pt = this.evaluate(3, curve, u), pt1 = this.evaluate(2, curve1, u), pt2 = this.evaluate(1, curve2, u), diff = pt.subtract(point), df = pt1.dot(pt1) + diff.dot(pt2);
            return Numerical.isMachineZero(df) ? u : u - diff.dot(pt1) / df;
        },
        evaluate: function(degree, curve, t) {
            var tmp = curve.slice();
            for(var i = 1; i <= degree; i++)for(var j = 0; j <= degree - i; j++)tmp[j] = tmp[j].multiply(1 - t).add(tmp[j + 1].multiply(t));
            return tmp[0];
        },
        chordLengthParameterize: function(first, last) {
            var u = [
                0
            ];
            for(var i = first + 1; i <= last; i++)u[i - first] = u[i - first - 1] + this.points[i].getDistance(this.points[i - 1]);
            for(var i = 1, m = last - first; i <= m; i++)u[i] /= u[m];
            return u;
        },
        findMaxError: function(first, last, curve, u) {
            var index = Math.floor((last - first + 1) / 2), maxDist = 0;
            for(var i = first + 1; i < last; i++){
                var P = this.evaluate(3, curve, u[i - first]);
                var v = P.subtract(this.points[i]);
                var dist = v.x * v.x + v.y * v.y;
                if (dist >= maxDist) {
                    maxDist = dist;
                    index = i;
                }
            }
            return {
                error: maxDist,
                index: index
            };
        }
    });
    var TextItem = Item.extend({
        _class: 'TextItem',
        _applyMatrix: false,
        _canApplyMatrix: false,
        _serializeFields: {
            content: null
        },
        _boundsOptions: {
            stroke: false,
            handle: false
        },
        initialize: function TextItem(arg) {
            this._content = '';
            this._lines = [];
            var hasProps = arg && Base.isPlainObject(arg) && arg.x === undefined && arg.y === undefined;
            this._initialize(hasProps && arg, !hasProps && Point.read(arguments));
        },
        _equals: function(item) {
            return this._content === item._content;
        },
        copyContent: function(source) {
            this.setContent(source._content);
        },
        getContent: function() {
            return this._content;
        },
        setContent: function(content) {
            this._content = '' + content;
            this._lines = this._content.split(/\r\n|\n|\r/mg);
            this._changed(521);
        },
        isEmpty: function() {
            return !this._content;
        },
        getCharacterStyle: '#getStyle',
        setCharacterStyle: '#setStyle',
        getParagraphStyle: '#getStyle',
        setParagraphStyle: '#setStyle'
    });
    var PointText = TextItem.extend({
        _class: 'PointText',
        initialize: function PointText() {
            TextItem.apply(this, arguments);
        },
        getPoint: function() {
            var point = this._matrix.getTranslation();
            return new LinkedPoint(point.x, point.y, this, 'setPoint');
        },
        setPoint: function() {
            var point = Point.read(arguments);
            this.translate(point.subtract(this._matrix.getTranslation()));
        },
        _draw: function(ctx, param, viewMatrix) {
            if (!this._content) return;
            this._setStyles(ctx, param, viewMatrix);
            var lines = this._lines, style = this._style, hasFill = style.hasFill(), hasStroke = style.hasStroke(), leading = style.getLeading(), shadowColor = ctx.shadowColor;
            ctx.font = style.getFontStyle();
            ctx.textAlign = style.getJustification();
            for(var i = 0, l = lines.length; i < l; i++){
                ctx.shadowColor = shadowColor;
                var line = lines[i];
                if (hasFill) {
                    ctx.fillText(line, 0, 0);
                    ctx.shadowColor = 'rgba(0,0,0,0)';
                }
                if (hasStroke) ctx.strokeText(line, 0, 0);
                ctx.translate(0, leading);
            }
        },
        _getBounds: function(matrix, options) {
            var style = this._style, lines = this._lines, numLines = lines.length, justification = style.getJustification(), leading = style.getLeading(), width = this.getView().getTextWidth(style.getFontStyle(), lines), x = 0;
            if (justification !== 'left') x -= width / (justification === 'center' ? 2 : 1);
            var rect = new Rectangle(x, numLines ? -0.75 * leading : 0, width, numLines * leading);
            return matrix ? matrix._transformBounds(rect, rect) : rect;
        }
    });
    var Color = Base.extend(new function() {
        var types = {
            gray: [
                'gray'
            ],
            rgb: [
                'red',
                'green',
                'blue'
            ],
            hsb: [
                'hue',
                'saturation',
                'brightness'
            ],
            hsl: [
                'hue',
                'saturation',
                'lightness'
            ],
            gradient: [
                'gradient',
                'origin',
                'destination',
                'highlight'
            ]
        };
        var componentParsers = {}, namedColors = {
            transparent: [
                0,
                0,
                0,
                0
            ]
        }, colorCtx;
        function fromCSS(string) {
            var match = string.match(/^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i) || string.match(/^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i), type = 'rgb', components;
            if (match) {
                var amount = match[4] ? 4 : 3;
                components = new Array(amount);
                for(var i = 0; i < amount; i++){
                    var value = match[i + 1];
                    components[i] = parseInt(value.length == 1 ? value + value : value, 16) / 255;
                }
            } else if (match = string.match(/^(rgb|hsl)a?\((.*)\)$/)) {
                type = match[1];
                components = match[2].trim().split(/[,\s]+/g);
                var isHSL = type === 'hsl';
                for(var i = 0, l = Math.min(components.length, 4); i < l; i++){
                    var component = components[i];
                    var value = parseFloat(component);
                    if (isHSL) {
                        if (i === 0) {
                            var unit = component.match(/([a-z]*)$/)[1];
                            value *= ({
                                turn: 360,
                                rad: 180 / Math.PI,
                                grad: 0.9
                            })[unit] || 1;
                        } else if (i < 3) value /= 100;
                    } else if (i < 3) value /= /%$/.test(component) ? 100 : 255;
                    components[i] = value;
                }
            } else {
                var color = namedColors[string];
                if (!color) {
                    if (window) {
                        if (!colorCtx) {
                            colorCtx = CanvasProvider.getContext(1, 1, {
                                willReadFrequently: true
                            });
                            colorCtx.globalCompositeOperation = 'copy';
                        }
                        colorCtx.fillStyle = 'rgba(0,0,0,0)';
                        colorCtx.fillStyle = string;
                        colorCtx.fillRect(0, 0, 1, 1);
                        var data = colorCtx.getImageData(0, 0, 1, 1).data;
                        color = namedColors[string] = [
                            data[0] / 255,
                            data[1] / 255,
                            data[2] / 255
                        ];
                    } else color = [
                        0,
                        0,
                        0
                    ];
                }
                components = color.slice();
            }
            return [
                type,
                components
            ];
        }
        var hsbIndices = [
            [
                0,
                3,
                1
            ],
            [
                2,
                0,
                1
            ],
            [
                1,
                0,
                3
            ],
            [
                1,
                2,
                0
            ],
            [
                3,
                1,
                0
            ],
            [
                0,
                1,
                2
            ]
        ];
        var converters = {
            'rgb-hsb': function(r, g, b) {
                var max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min, h = delta === 0 ? 0 : (max == r ? (g - b) / delta + (g < b ? 6 : 0) : max == g ? (b - r) / delta + 2 : (r - g) / delta + 4) * 60;
                return [
                    h,
                    max === 0 ? 0 : delta / max,
                    max
                ];
            },
            'hsb-rgb': function(h, s, b) {
                h = (h / 60 % 6 + 6) % 6;
                var i = Math.floor(h), f = h - i, i = hsbIndices[i], v = [
                    b,
                    b * (1 - s),
                    b * (1 - s * f),
                    b * (1 - s * (1 - f))
                ];
                return [
                    v[i[0]],
                    v[i[1]],
                    v[i[2]]
                ];
            },
            'rgb-hsl': function(r, g, b) {
                var max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min, achromatic = delta === 0, h = achromatic ? 0 : (max == r ? (g - b) / delta + (g < b ? 6 : 0) : max == g ? (b - r) / delta + 2 : (r - g) / delta + 4) * 60, l = (max + min) / 2, s = achromatic ? 0 : l < 0.5 ? delta / (max + min) : delta / (2 - max - min);
                return [
                    h,
                    s,
                    l
                ];
            },
            'hsl-rgb': function(h, s, l) {
                h = (h / 360 % 1 + 1) % 1;
                if (s === 0) return [
                    l,
                    l,
                    l
                ];
                var t3s = [
                    h + 1 / 3,
                    h,
                    h - 1 / 3
                ], t2 = l < 0.5 ? l * (1 + s) : l + s - l * s, t1 = 2 * l - t2, c = [];
                for(var i = 0; i < 3; i++){
                    var t3 = t3s[i];
                    if (t3 < 0) t3 += 1;
                    if (t3 > 1) t3 -= 1;
                    c[i] = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
                }
                return c;
            },
            'rgb-gray': function(r, g, b) {
                return [
                    r * 0.2989 + g * 0.587 + b * 0.114
                ];
            },
            'gray-rgb': function(g) {
                return [
                    g,
                    g,
                    g
                ];
            },
            'gray-hsb': function(g) {
                return [
                    0,
                    0,
                    g
                ];
            },
            'gray-hsl': function(g) {
                return [
                    0,
                    0,
                    g
                ];
            },
            'gradient-rgb': function() {
                return [];
            },
            'rgb-gradient': function() {
                return [];
            }
        };
        return Base.each(types, function(properties, type) {
            componentParsers[type] = [];
            Base.each(properties, function(name, index) {
                var part = Base.capitalize(name), hasOverlap = /^(hue|saturation)$/.test(name), parser = componentParsers[type][index] = type === 'gradient' ? name === 'gradient' ? function(value) {
                    var current = this._components[0];
                    value = Gradient.read(Array.isArray(value) ? value : arguments, 0, {
                        readNull: true
                    });
                    if (current !== value) {
                        if (current) current._removeOwner(this);
                        if (value) value._addOwner(this);
                    }
                    return value;
                } : function() {
                    return Point.read(arguments, 0, {
                        readNull: name === 'highlight',
                        clone: true
                    });
                } : function(value) {
                    return value == null || isNaN(value) ? 0 : +value;
                };
                this['get' + part] = function() {
                    return this._type === type || hasOverlap && /^hs[bl]$/.test(this._type) ? this._components[index] : this._convert(type)[index];
                };
                this['set' + part] = function(value) {
                    if (this._type !== type && !(hasOverlap && /^hs[bl]$/.test(this._type))) {
                        this._components = this._convert(type);
                        this._properties = types[type];
                        this._type = type;
                    }
                    this._components[index] = parser.call(this, value);
                    this._changed();
                };
            }, this);
        }, {
            _class: 'Color',
            _readIndex: true,
            initialize: function Color(arg) {
                var args = arguments, reading = this.__read, read = 0, type, components, alpha, values;
                if (Array.isArray(arg)) {
                    args = arg;
                    arg = args[0];
                }
                var argType = arg != null && typeof arg;
                if (argType === 'string' && arg in types) {
                    type = arg;
                    arg = args[1];
                    if (Array.isArray(arg)) {
                        components = arg;
                        alpha = args[2];
                    } else {
                        if (reading) read = 1;
                        args = Base.slice(args, 1);
                        argType = typeof arg;
                    }
                }
                if (!components) {
                    values = argType === 'number' ? args : argType === 'object' && arg.length != null ? arg : null;
                    if (values) {
                        if (!type) type = values.length >= 3 ? 'rgb' : 'gray';
                        var length = types[type].length;
                        alpha = values[length];
                        if (reading) read += values === arguments ? length + (alpha != null ? 1 : 0) : 1;
                        if (values.length > length) values = Base.slice(values, 0, length);
                    } else if (argType === 'string') {
                        var converted = fromCSS(arg);
                        type = converted[0];
                        components = converted[1];
                        if (components.length === 4) {
                            alpha = components[3];
                            components.length--;
                        }
                    } else if (argType === 'object') {
                        if (arg.constructor === Color) {
                            type = arg._type;
                            components = arg._components.slice();
                            alpha = arg._alpha;
                            if (type === 'gradient') for(var i = 1, l = components.length; i < l; i++){
                                var point = components[i];
                                if (point) components[i] = point.clone();
                            }
                        } else if (arg.constructor === Gradient) {
                            type = 'gradient';
                            values = args;
                        } else {
                            type = 'hue' in arg ? 'lightness' in arg ? 'hsl' : 'hsb' : 'gradient' in arg || 'stops' in arg || 'radial' in arg ? 'gradient' : 'gray' in arg ? 'gray' : 'rgb';
                            var properties = types[type], parsers = componentParsers[type];
                            this._components = components = [];
                            for(var i = 0, l = properties.length; i < l; i++){
                                var value = arg[properties[i]];
                                if (value == null && !i && type === 'gradient' && 'stops' in arg) value = {
                                    stops: arg.stops,
                                    radial: arg.radial
                                };
                                value = parsers[i].call(this, value);
                                if (value != null) components[i] = value;
                            }
                            alpha = arg.alpha;
                        }
                    }
                    if (reading && type) read = 1;
                }
                this._type = type || 'rgb';
                if (!components) {
                    this._components = components = [];
                    var parsers = componentParsers[this._type];
                    for(var i = 0, l = parsers.length; i < l; i++){
                        var value = parsers[i].call(this, values && values[i]);
                        if (value != null) components[i] = value;
                    }
                }
                this._components = components;
                this._properties = types[this._type];
                this._alpha = alpha;
                if (reading) this.__read = read;
                return this;
            },
            set: '#initialize',
            _serialize: function(options, dictionary) {
                var components = this.getComponents();
                return Base.serialize(/^(gray|rgb)$/.test(this._type) ? components : [
                    this._type
                ].concat(components), options, true, dictionary);
            },
            _changed: function() {
                this._canvasStyle = null;
                if (this._owner) {
                    if (this._setter) this._owner[this._setter](this);
                    else this._owner._changed(129);
                }
            },
            _convert: function(type) {
                var converter;
                return this._type === type ? this._components.slice() : (converter = converters[this._type + '-' + type]) ? converter.apply(this, this._components) : converters['rgb-' + type].apply(this, converters[this._type + '-rgb'].apply(this, this._components));
            },
            convert: function(type) {
                return new Color(type, this._convert(type), this._alpha);
            },
            getType: function() {
                return this._type;
            },
            setType: function(type) {
                this._components = this._convert(type);
                this._properties = types[type];
                this._type = type;
            },
            getComponents: function() {
                var components = this._components.slice();
                if (this._alpha != null) components.push(this._alpha);
                return components;
            },
            getAlpha: function() {
                return this._alpha != null ? this._alpha : 1;
            },
            setAlpha: function(alpha) {
                this._alpha = alpha == null ? null : Math.min(Math.max(alpha, 0), 1);
                this._changed();
            },
            hasAlpha: function() {
                return this._alpha != null;
            },
            equals: function(color) {
                var col = Base.isPlainValue(color, true) ? Color.read(arguments) : color;
                return col === this || col && this._class === col._class && this._type === col._type && this.getAlpha() === col.getAlpha() && Base.equals(this._components, col._components) || false;
            },
            toString: function() {
                var properties = this._properties, parts = [], isGradient = this._type === 'gradient', f = Formatter.instance;
                for(var i = 0, l = properties.length; i < l; i++){
                    var value = this._components[i];
                    if (value != null) parts.push(properties[i] + ': ' + (isGradient ? value : f.number(value)));
                }
                if (this._alpha != null) parts.push('alpha: ' + f.number(this._alpha));
                return '{ ' + parts.join(', ') + ' }';
            },
            toCSS: function(hex) {
                var components = this._convert('rgb'), alpha = hex || this._alpha == null ? 1 : this._alpha;
                function convert(val) {
                    return Math.round((val < 0 ? 0 : val > 1 ? 1 : val) * 255);
                }
                components = [
                    convert(components[0]),
                    convert(components[1]),
                    convert(components[2])
                ];
                if (alpha < 1) components.push(alpha < 0 ? 0 : alpha);
                return hex ? '#' + (16777216 + (components[0] << 16) + (components[1] << 8) + components[2]).toString(16).slice(1) : (components.length == 4 ? 'rgba(' : 'rgb(') + components.join(',') + ')';
            },
            toCanvasStyle: function(ctx, matrix) {
                if (this._canvasStyle) return this._canvasStyle;
                if (this._type !== 'gradient') return this._canvasStyle = this.toCSS();
                var components = this._components, gradient = components[0], stops = gradient._stops, origin = components[1], destination = components[2], highlight = components[3], inverse = matrix && matrix.inverted(), canvasGradient;
                if (inverse) {
                    origin = inverse._transformPoint(origin);
                    destination = inverse._transformPoint(destination);
                    if (highlight) highlight = inverse._transformPoint(highlight);
                }
                if (gradient._radial) {
                    var radius = destination.getDistance(origin);
                    if (highlight) {
                        var vector = highlight.subtract(origin);
                        if (vector.getLength() > radius) highlight = origin.add(vector.normalize(radius - 0.1));
                    }
                    var start = highlight || origin;
                    canvasGradient = ctx.createRadialGradient(start.x, start.y, 0, origin.x, origin.y, radius);
                } else canvasGradient = ctx.createLinearGradient(origin.x, origin.y, destination.x, destination.y);
                for(var i = 0, l = stops.length; i < l; i++){
                    var stop = stops[i], offset = stop._offset;
                    canvasGradient.addColorStop(offset == null ? i / (l - 1) : offset, stop._color.toCanvasStyle());
                }
                return this._canvasStyle = canvasGradient;
            },
            transform: function(matrix) {
                if (this._type === 'gradient') {
                    var components = this._components;
                    for(var i = 1, l = components.length; i < l; i++){
                        var point = components[i];
                        matrix._transformPoint(point, point, true);
                    }
                    this._changed();
                }
            },
            statics: {
                _types: types,
                random: function() {
                    var random = Math.random;
                    return new Color(random(), random(), random());
                },
                _setOwner: function(color, owner, setter) {
                    if (color) {
                        if (color._owner && owner && color._owner !== owner) color = color.clone();
                        if (!color._owner ^ !owner) {
                            color._owner = owner || null;
                            color._setter = setter || null;
                        }
                    }
                    return color;
                }
            }
        });
    }, new function() {
        var operators = {
            add: function(a, b) {
                return a + b;
            },
            subtract: function(a, b) {
                return a - b;
            },
            multiply: function(a, b) {
                return a * b;
            },
            divide: function(a, b) {
                return a / b;
            }
        };
        return Base.each(operators, function(operator, name) {
            this[name] = function(color) {
                color = Color.read(arguments);
                var type = this._type, components1 = this._components, components2 = color._convert(type);
                for(var i = 0, l = components1.length; i < l; i++)components2[i] = operator(components1[i], components2[i]);
                return new Color(type, components2, this._alpha != null ? operator(this._alpha, color.getAlpha()) : null);
            };
        }, {});
    });
    var Gradient = Base.extend({
        _class: 'Gradient',
        initialize: function Gradient(stops, radial) {
            this._id = UID.get();
            if (stops && Base.isPlainObject(stops)) {
                this.set(stops);
                stops = radial = null;
            }
            if (this._stops == null) this.setStops(stops || [
                'white',
                'black'
            ]);
            if (this._radial == null) this.setRadial(typeof radial === 'string' && radial === 'radial' || radial || false);
        },
        _serialize: function(options, dictionary) {
            return dictionary.add(this, function() {
                return Base.serialize([
                    this._stops,
                    this._radial
                ], options, true, dictionary);
            });
        },
        _changed: function() {
            for(var i = 0, l = this._owners && this._owners.length; i < l; i++)this._owners[i]._changed();
        },
        _addOwner: function(color) {
            if (!this._owners) this._owners = [];
            this._owners.push(color);
        },
        _removeOwner: function(color) {
            var index = this._owners ? this._owners.indexOf(color) : -1;
            if (index != -1) {
                this._owners.splice(index, 1);
                if (!this._owners.length) this._owners = undefined;
            }
        },
        clone: function() {
            var stops = [];
            for(var i = 0, l = this._stops.length; i < l; i++)stops[i] = this._stops[i].clone();
            return new Gradient(stops, this._radial);
        },
        getStops: function() {
            return this._stops;
        },
        setStops: function(stops) {
            if (stops.length < 2) throw new Error('Gradient stop list needs to contain at least two stops.');
            var _stops = this._stops;
            if (_stops) for(var i = 0, l = _stops.length; i < l; i++)_stops[i]._owner = undefined;
            _stops = this._stops = GradientStop.readList(stops, 0, {
                clone: true
            });
            for(var i = 0, l = _stops.length; i < l; i++)_stops[i]._owner = this;
            this._changed();
        },
        getRadial: function() {
            return this._radial;
        },
        setRadial: function(radial) {
            this._radial = radial;
            this._changed();
        },
        equals: function(gradient) {
            if (gradient === this) return true;
            if (gradient && this._class === gradient._class) {
                var stops1 = this._stops, stops2 = gradient._stops, length = stops1.length;
                if (length === stops2.length) {
                    for(var i = 0; i < length; i++){
                        if (!stops1[i].equals(stops2[i])) return false;
                    }
                    return true;
                }
            }
            return false;
        }
    });
    var GradientStop = Base.extend({
        _class: 'GradientStop',
        initialize: function GradientStop(arg0, arg1) {
            var color = arg0, offset = arg1;
            if (typeof arg0 === 'object' && arg1 === undefined) {
                if (Array.isArray(arg0) && typeof arg0[0] !== 'number') {
                    color = arg0[0];
                    offset = arg0[1];
                } else if ('color' in arg0 || 'offset' in arg0 || 'rampPoint' in arg0) {
                    color = arg0.color;
                    offset = arg0.offset || arg0.rampPoint || 0;
                }
            }
            this.setColor(color);
            this.setOffset(offset);
        },
        clone: function() {
            return new GradientStop(this._color.clone(), this._offset);
        },
        _serialize: function(options, dictionary) {
            var color = this._color, offset = this._offset;
            return Base.serialize(offset == null ? [
                color
            ] : [
                color,
                offset
            ], options, true, dictionary);
        },
        _changed: function() {
            if (this._owner) this._owner._changed(129);
        },
        getOffset: function() {
            return this._offset;
        },
        setOffset: function(offset) {
            this._offset = offset;
            this._changed();
        },
        getRampPoint: '#getOffset',
        setRampPoint: '#setOffset',
        getColor: function() {
            return this._color;
        },
        setColor: function() {
            Color._setOwner(this._color, null);
            this._color = Color._setOwner(Color.read(arguments, 0), this, 'setColor');
            this._changed();
        },
        equals: function(stop) {
            return stop === this || stop && this._class === stop._class && this._color.equals(stop._color) && this._offset == stop._offset || false;
        }
    });
    var Style = Base.extend(new function() {
        var itemDefaults = {
            fillColor: null,
            fillRule: 'nonzero',
            strokeColor: null,
            strokeWidth: 1,
            strokeCap: 'butt',
            strokeJoin: 'miter',
            strokeScaling: true,
            miterLimit: 10,
            dashOffset: 0,
            dashArray: [],
            shadowColor: null,
            shadowBlur: 0,
            shadowOffset: new Point(),
            selectedColor: null
        }, groupDefaults = Base.set({}, itemDefaults, {
            fontFamily: 'sans-serif',
            fontWeight: 'normal',
            fontSize: 12,
            leading: null,
            justification: 'left'
        }), textDefaults = Base.set({}, groupDefaults, {
            fillColor: new Color()
        }), flags = {
            strokeWidth: 193,
            strokeCap: 193,
            strokeJoin: 193,
            strokeScaling: 201,
            miterLimit: 193,
            fontFamily: 9,
            fontWeight: 9,
            fontSize: 9,
            font: 9,
            leading: 9,
            justification: 9
        }, item = {
            beans: true
        }, fields = {
            _class: 'Style',
            beans: true,
            initialize: function Style(style, _owner, _project) {
                this._values = {};
                this._owner = _owner;
                this._project = _owner && _owner._project || _project || paper.project;
                this._defaults = !_owner || _owner instanceof Group ? groupDefaults : _owner instanceof TextItem ? textDefaults : itemDefaults;
                if (style) this.set(style);
            }
        };
        Base.each(groupDefaults, function(value, key) {
            var isColor = /Color$/.test(key), isPoint = key === 'shadowOffset', part = Base.capitalize(key), flag = flags[key], set = 'set' + part, get = 'get' + part;
            fields[set] = function(value) {
                var owner = this._owner, children = owner && owner._children, applyToChildren = children && children.length > 0 && !(owner instanceof CompoundPath);
                if (applyToChildren) for(var i = 0, l = children.length; i < l; i++)children[i]._style[set](value);
                if ((key === 'selectedColor' || !applyToChildren) && key in this._defaults) {
                    var old = this._values[key];
                    if (old !== value) {
                        if (isColor) {
                            if (old) {
                                Color._setOwner(old, null);
                                old._canvasStyle = null;
                            }
                            if (value && value.constructor === Color) value = Color._setOwner(value, owner, applyToChildren && set);
                        }
                        this._values[key] = value;
                        if (owner) owner._changed(flag || 129);
                    }
                }
            };
            fields[get] = function(_dontMerge) {
                var owner = this._owner, children = owner && owner._children, applyToChildren = children && children.length > 0 && !(owner instanceof CompoundPath), value;
                if (applyToChildren && !_dontMerge) for(var i = 0, l = children.length; i < l; i++){
                    var childValue = children[i]._style[get]();
                    if (!i) value = childValue;
                    else if (!Base.equals(value, childValue)) return undefined;
                }
                else if (key in this._defaults) {
                    var value = this._values[key];
                    if (value === undefined) {
                        value = this._defaults[key];
                        if (value && value.clone) value = value.clone();
                    } else {
                        var ctor = isColor ? Color : isPoint ? Point : null;
                        if (ctor && !(value && value.constructor === ctor)) this._values[key] = value = ctor.read([
                            value
                        ], 0, {
                            readNull: true,
                            clone: true
                        });
                    }
                }
                if (value && isColor) value = Color._setOwner(value, owner, applyToChildren && set);
                return value;
            };
            item[get] = function(_dontMerge) {
                return this._style[get](_dontMerge);
            };
            item[set] = function(value) {
                this._style[set](value);
            };
        });
        Base.each({
            Font: 'FontFamily',
            WindingRule: 'FillRule'
        }, function(value, key) {
            var get = 'get' + key, set = 'set' + key;
            fields[get] = item[get] = '#get' + value;
            fields[set] = item[set] = '#set' + value;
        });
        Item.inject(item);
        return fields;
    }, {
        set: function(style) {
            var isStyle = style instanceof Style, values = isStyle ? style._values : style;
            if (values) {
                for(var key in values)if (key in this._defaults) {
                    var value = values[key];
                    this[key] = value && isStyle && value.clone ? value.clone() : value;
                }
            }
        },
        equals: function(style) {
            function compare(style1, style2, secondary) {
                var values1 = style1._values, values2 = style2._values, defaults2 = style2._defaults;
                for(var key in values1){
                    var value1 = values1[key], value2 = values2[key];
                    if (!(secondary && key in values2) && !Base.equals(value1, value2 === undefined ? defaults2[key] : value2)) return false;
                }
                return true;
            }
            return style === this || style && this._class === style._class && compare(this, style) && compare(style, this, true) || false;
        },
        _dispose: function() {
            var color;
            color = this.getFillColor();
            if (color) color._canvasStyle = null;
            color = this.getStrokeColor();
            if (color) color._canvasStyle = null;
            color = this.getShadowColor();
            if (color) color._canvasStyle = null;
        },
        hasFill: function() {
            var color = this.getFillColor();
            return !!color && color.alpha > 0;
        },
        hasStroke: function() {
            var color = this.getStrokeColor();
            return !!color && color.alpha > 0 && this.getStrokeWidth() > 0;
        },
        hasShadow: function() {
            var color = this.getShadowColor();
            return !!color && color.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
        },
        getView: function() {
            return this._project._view;
        },
        getFontStyle: function() {
            var fontSize = this.getFontSize();
            return this.getFontWeight() + ' ' + fontSize + (/[a-z]/i.test(fontSize + '') ? ' ' : 'px ') + this.getFontFamily();
        },
        getFont: '#getFontFamily',
        setFont: '#setFontFamily',
        getLeading: function getLeading() {
            var leading = getLeading.base.call(this), fontSize = this.getFontSize();
            if (/pt|em|%|px/.test(fontSize)) fontSize = this.getView().getPixelSize(fontSize);
            return leading != null ? leading : fontSize * 1.2;
        }
    });
    var DomElement = new function() {
        function handlePrefix(el, name, set, value) {
            var prefixes = [
                '',
                'webkit',
                'moz',
                'Moz',
                'ms',
                'o'
            ], suffix = name[0].toUpperCase() + name.substring(1);
            for(var i = 0; i < 6; i++){
                var prefix = prefixes[i], key = prefix ? prefix + suffix : name;
                if (key in el) {
                    if (set) el[key] = value;
                    else return el[key];
                    break;
                }
            }
        }
        return {
            getStyles: function(el) {
                var doc = el && el.nodeType !== 9 ? el.ownerDocument : el, view = doc && doc.defaultView;
                return view && view.getComputedStyle(el, '');
            },
            getBounds: function(el, viewport) {
                var doc = el.ownerDocument, body = doc.body, html = doc.documentElement, rect;
                try {
                    rect = el.getBoundingClientRect();
                } catch (e) {
                    rect = {
                        left: 0,
                        top: 0,
                        width: 0,
                        height: 0
                    };
                }
                var x = rect.left - (html.clientLeft || body.clientLeft || 0), y = rect.top - (html.clientTop || body.clientTop || 0);
                if (!viewport) {
                    var view = doc.defaultView;
                    x += view.pageXOffset || html.scrollLeft || body.scrollLeft;
                    y += view.pageYOffset || html.scrollTop || body.scrollTop;
                }
                return new Rectangle(x, y, rect.width, rect.height);
            },
            getViewportBounds: function(el) {
                var doc = el.ownerDocument, view = doc.defaultView, html = doc.documentElement;
                return new Rectangle(0, 0, view.innerWidth || html.clientWidth, view.innerHeight || html.clientHeight);
            },
            getOffset: function(el, viewport) {
                return DomElement.getBounds(el, viewport).getPoint();
            },
            getSize: function(el) {
                return DomElement.getBounds(el, true).getSize();
            },
            isInvisible: function(el) {
                return DomElement.getSize(el).equals(new Size(0, 0));
            },
            isInView: function(el) {
                return !DomElement.isInvisible(el) && DomElement.getViewportBounds(el).intersects(DomElement.getBounds(el, true));
            },
            isInserted: function(el) {
                return document.body.contains(el);
            },
            getPrefixed: function(el, name) {
                return el && handlePrefix(el, name);
            },
            setPrefixed: function(el, name, value) {
                if (typeof name === 'object') for(var key in name)handlePrefix(el, key, true, name[key]);
                else handlePrefix(el, name, true, value);
            }
        };
    };
    var DomEvent = {
        add: function(el, events) {
            if (el) for(var type in events){
                var func = events[type], parts = type.split(/[\s,]+/g);
                for(var i = 0, l = parts.length; i < l; i++){
                    var name = parts[i];
                    var options = el === document && (name === 'touchstart' || name === 'touchmove') ? {
                        passive: false
                    } : false;
                    el.addEventListener(name, func, options);
                }
            }
        },
        remove: function(el, events) {
            if (el) for(var type in events){
                var func = events[type], parts = type.split(/[\s,]+/g);
                for(var i = 0, l = parts.length; i < l; i++)el.removeEventListener(parts[i], func, false);
            }
        },
        getPoint: function(event) {
            var pos = event.targetTouches ? event.targetTouches.length ? event.targetTouches[0] : event.changedTouches[0] : event;
            return new Point(pos.pageX || pos.clientX + document.documentElement.scrollLeft, pos.pageY || pos.clientY + document.documentElement.scrollTop);
        },
        getTarget: function(event) {
            return event.target || event.srcElement;
        },
        getRelatedTarget: function(event) {
            return event.relatedTarget || event.toElement;
        },
        getOffset: function(event, target) {
            return DomEvent.getPoint(event).subtract(DomElement.getOffset(target || DomEvent.getTarget(event)));
        }
    };
    DomEvent.requestAnimationFrame = new function() {
        var nativeRequest = DomElement.getPrefixed(window, 'requestAnimationFrame'), requested = false, callbacks = [], timer;
        function handleCallbacks() {
            var functions = callbacks;
            callbacks = [];
            for(var i = 0, l = functions.length; i < l; i++)functions[i]();
            requested = nativeRequest && callbacks.length;
            if (requested) nativeRequest(handleCallbacks);
        }
        return function(callback) {
            callbacks.push(callback);
            if (nativeRequest) {
                if (!requested) {
                    nativeRequest(handleCallbacks);
                    requested = true;
                }
            } else if (!timer) timer = setInterval(handleCallbacks, 1000 / 60);
        };
    };
    var View = Base.extend(Emitter, {
        _class: 'View',
        initialize: function View(project, element) {
            function getSize(name) {
                return element[name] || parseInt(element.getAttribute(name), 10);
            }
            function getCanvasSize() {
                var size = DomElement.getSize(element);
                return size.isNaN() || size.isZero() ? new Size(getSize('width'), getSize('height')) : size;
            }
            var size;
            if (window && element) {
                this._id = element.getAttribute('id');
                if (this._id == null) element.setAttribute('id', this._id = 'paper-view-' + View._id++);
                DomEvent.add(element, this._viewEvents);
                var none = 'none';
                DomElement.setPrefixed(element.style, {
                    userDrag: none,
                    userSelect: none,
                    touchCallout: none,
                    contentZooming: none,
                    tapHighlightColor: 'rgba(0,0,0,0)'
                });
                if (PaperScope.hasAttribute(element, 'resize')) {
                    var that = this;
                    DomEvent.add(window, this._windowEvents = {
                        resize: function() {
                            that.setViewSize(getCanvasSize());
                        }
                    });
                }
                size = getCanvasSize();
                if (PaperScope.hasAttribute(element, 'stats') && typeof Stats !== 'undefined') {
                    this._stats = new Stats();
                    var stats = this._stats.domElement, style = stats.style, offset = DomElement.getOffset(element);
                    style.position = 'absolute';
                    style.left = offset.x + 'px';
                    style.top = offset.y + 'px';
                    document.body.appendChild(stats);
                }
            } else {
                size = new Size(element);
                element = null;
            }
            this._project = project;
            this._scope = project._scope;
            this._element = element;
            if (!this._pixelRatio) this._pixelRatio = window && window.devicePixelRatio || 1;
            this._setElementSize(size.width, size.height);
            this._viewSize = size;
            View._views.push(this);
            View._viewsById[this._id] = this;
            (this._matrix = new Matrix())._owner = this;
            if (!View._focused) View._focused = this;
            this._frameItems = {};
            this._frameItemCount = 0;
            this._itemEvents = {
                native: {},
                virtual: {}
            };
            this._autoUpdate = !paper.agent.node;
            this._needsUpdate = false;
        },
        remove: function() {
            if (!this._project) return false;
            if (View._focused === this) View._focused = null;
            View._views.splice(View._views.indexOf(this), 1);
            delete View._viewsById[this._id];
            var project = this._project;
            if (project._view === this) project._view = null;
            DomEvent.remove(this._element, this._viewEvents);
            DomEvent.remove(window, this._windowEvents);
            this._element = this._project = null;
            this.off('frame');
            this._animate = false;
            this._frameItems = {};
            return true;
        },
        _events: Base.each(Item._itemHandlers.concat([
            'onResize',
            'onKeyDown',
            'onKeyUp'
        ]), function(name) {
            this[name] = {};
        }, {
            onFrame: {
                install: function() {
                    this.play();
                },
                uninstall: function() {
                    this.pause();
                }
            }
        }),
        _animate: false,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
            return this._autoUpdate;
        },
        setAutoUpdate: function(autoUpdate) {
            this._autoUpdate = autoUpdate;
            if (autoUpdate) this.requestUpdate();
        },
        update: function() {},
        draw: function() {
            this.update();
        },
        requestUpdate: function() {
            if (!this._requested) {
                var that = this;
                DomEvent.requestAnimationFrame(function() {
                    that._requested = false;
                    if (that._animate) {
                        that.requestUpdate();
                        var element = that._element;
                        if ((!DomElement.getPrefixed(document, 'hidden') || PaperScope.getAttribute(element, 'keepalive') === 'true') && DomElement.isInView(element)) that._handleFrame();
                    }
                    if (that._autoUpdate) that.update();
                });
                this._requested = true;
            }
        },
        play: function() {
            this._animate = true;
            this.requestUpdate();
        },
        pause: function() {
            this._animate = false;
        },
        _handleFrame: function() {
            paper = this._scope;
            var now = Date.now() / 1000, delta = this._last ? now - this._last : 0;
            this._last = now;
            this.emit('frame', new Base({
                delta: delta,
                time: this._time += delta,
                count: this._count++
            }));
            if (this._stats) this._stats.update();
        },
        _animateItem: function(item, animate) {
            var items = this._frameItems;
            if (animate) {
                items[item._id] = {
                    item: item,
                    time: 0,
                    count: 0
                };
                if (++this._frameItemCount === 1) this.on('frame', this._handleFrameItems);
            } else {
                delete items[item._id];
                if (--this._frameItemCount === 0) this.off('frame', this._handleFrameItems);
            }
        },
        _handleFrameItems: function(event) {
            for(var i in this._frameItems){
                var entry = this._frameItems[i];
                entry.item.emit('frame', new Base(event, {
                    time: entry.time += event.delta,
                    count: entry.count++
                }));
            }
        },
        _changed: function() {
            this._project._changed(4097);
            this._bounds = this._decomposed = undefined;
        },
        getElement: function() {
            return this._element;
        },
        getPixelRatio: function() {
            return this._pixelRatio;
        },
        getResolution: function() {
            return this._pixelRatio * 72;
        },
        getViewSize: function() {
            var size = this._viewSize;
            return new LinkedSize(size.width, size.height, this, 'setViewSize');
        },
        setViewSize: function() {
            var size = Size.read(arguments), delta = size.subtract(this._viewSize);
            if (delta.isZero()) return;
            this._setElementSize(size.width, size.height);
            this._viewSize.set(size);
            this._changed();
            this.emit('resize', {
                size: size,
                delta: delta
            });
            if (this._autoUpdate) this.update();
        },
        _setElementSize: function(width, height) {
            var element = this._element;
            if (element) {
                if (element.width !== width) element.width = width;
                if (element.height !== height) element.height = height;
            }
        },
        getBounds: function() {
            if (!this._bounds) this._bounds = this._matrix.inverted()._transformBounds(new Rectangle(new Point(), this._viewSize));
            return this._bounds;
        },
        getSize: function() {
            return this.getBounds().getSize();
        },
        isVisible: function() {
            return DomElement.isInView(this._element);
        },
        isInserted: function() {
            return DomElement.isInserted(this._element);
        },
        getPixelSize: function(size) {
            var element = this._element, pixels;
            if (element) {
                var parent = element.parentNode, temp = document.createElement('div');
                temp.style.fontSize = size;
                parent.appendChild(temp);
                pixels = parseFloat(DomElement.getStyles(temp).fontSize);
                parent.removeChild(temp);
            } else pixels = parseFloat(pixels);
            return pixels;
        },
        getTextWidth: function(font, lines) {
            return 0;
        }
    }, Base.each([
        'rotate',
        'scale',
        'shear',
        'skew'
    ], function(key) {
        var rotate = key === 'rotate';
        this[key] = function() {
            var args = arguments, value = (rotate ? Base : Point).read(args), center = Point.read(args, 0, {
                readNull: true
            });
            return this.transform(new Matrix()[key](value, center || this.getCenter(true)));
        };
    }, {
        _decompose: function() {
            return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
            var mx = new Matrix();
            return this.transform(mx.translate.apply(mx, arguments));
        },
        getCenter: function() {
            return this.getBounds().getCenter();
        },
        setCenter: function() {
            var center = Point.read(arguments);
            this.translate(this.getCenter().subtract(center));
        },
        getZoom: function() {
            var scaling = this._decompose().scaling;
            return (scaling.x + scaling.y) / 2;
        },
        setZoom: function(zoom) {
            this.transform(new Matrix().scale(zoom / this.getZoom(), this.getCenter()));
        },
        getRotation: function() {
            return this._decompose().rotation;
        },
        setRotation: function(rotation) {
            var current = this.getRotation();
            if (current != null && rotation != null) this.rotate(rotation - current);
        },
        getScaling: function() {
            var scaling = this._decompose().scaling;
            return new LinkedPoint(scaling.x, scaling.y, this, 'setScaling');
        },
        setScaling: function() {
            var current = this.getScaling(), scaling = Point.read(arguments, 0, {
                clone: true,
                readNull: true
            });
            if (current && scaling) this.scale(scaling.x / current.x, scaling.y / current.y);
        },
        getMatrix: function() {
            return this._matrix;
        },
        setMatrix: function() {
            var matrix = this._matrix;
            matrix.set.apply(matrix, arguments);
        },
        transform: function(matrix) {
            this._matrix.append(matrix);
        },
        scrollBy: function() {
            this.translate(Point.read(arguments).negate());
        }
    }), {
        projectToView: function() {
            return this._matrix._transformPoint(Point.read(arguments));
        },
        viewToProject: function() {
            return this._matrix._inverseTransform(Point.read(arguments));
        },
        getEventPoint: function(event) {
            return this.viewToProject(DomEvent.getOffset(event, this._element));
        }
    }, {
        statics: {
            _views: [],
            _viewsById: {},
            _id: 0,
            create: function(project, element) {
                if (document && typeof element === 'string') element = document.getElementById(element);
                var ctor = window ? CanvasView : View;
                return new ctor(project, element);
            }
        }
    }, new function() {
        if (!window) return;
        var prevFocus, tempFocus, dragging = false, mouseDown = false;
        function getView(event) {
            var target = DomEvent.getTarget(event);
            return target.getAttribute && View._viewsById[target.getAttribute('id')];
        }
        function updateFocus() {
            var view = View._focused;
            if (!view || !view.isVisible()) {
                for(var i = 0, l = View._views.length; i < l; i++)if ((view = View._views[i]).isVisible()) {
                    View._focused = tempFocus = view;
                    break;
                }
            }
        }
        function handleMouseMove(view, event, point) {
            view._handleMouseEvent('mousemove', event, point);
        }
        var navigator = window.navigator, mousedown, mousemove, mouseup;
        if (navigator.pointerEnabled || navigator.msPointerEnabled) {
            mousedown = 'pointerdown MSPointerDown';
            mousemove = 'pointermove MSPointerMove';
            mouseup = 'pointerup pointercancel MSPointerUp MSPointerCancel';
        } else {
            mousedown = 'touchstart';
            mousemove = 'touchmove';
            mouseup = 'touchend touchcancel';
            if (!('ontouchstart' in window && navigator.userAgent.match(/mobile|tablet|ip(ad|hone|od)|android|silk/i))) {
                mousedown += ' mousedown';
                mousemove += ' mousemove';
                mouseup += ' mouseup';
            }
        }
        var viewEvents = {}, docEvents = {
            mouseout: function(event) {
                var view = View._focused, target = DomEvent.getRelatedTarget(event);
                if (view && (!target || target.nodeName === 'HTML')) {
                    var offset = DomEvent.getOffset(event, view._element), x = offset.x, abs = Math.abs, ax = abs(x), max = 33554432, diff = ax - max;
                    offset.x = abs(diff) < ax ? diff * (x < 0 ? -1 : 1) : x;
                    handleMouseMove(view, event, view.viewToProject(offset));
                }
            },
            scroll: updateFocus
        };
        viewEvents[mousedown] = function(event) {
            var view = View._focused = getView(event);
            if (!dragging) {
                dragging = true;
                view._handleMouseEvent('mousedown', event);
            }
        };
        docEvents[mousemove] = function(event) {
            var view = View._focused;
            if (!mouseDown) {
                var target = getView(event);
                if (target) {
                    if (view !== target) {
                        if (view) handleMouseMove(view, event);
                        if (!prevFocus) prevFocus = view;
                        view = View._focused = tempFocus = target;
                    }
                } else if (tempFocus && tempFocus === view) {
                    if (prevFocus && !prevFocus.isInserted()) prevFocus = null;
                    view = View._focused = prevFocus;
                    prevFocus = null;
                    updateFocus();
                }
            }
            if (view) handleMouseMove(view, event);
        };
        docEvents[mousedown] = function() {
            mouseDown = true;
        };
        docEvents[mouseup] = function(event) {
            var view = View._focused;
            if (view && dragging) view._handleMouseEvent('mouseup', event);
            mouseDown = dragging = false;
        };
        DomEvent.add(document, docEvents);
        DomEvent.add(window, {
            load: updateFocus
        });
        var called = false, prevented = false, fallbacks = {
            doubleclick: 'click',
            mousedrag: 'mousemove'
        }, wasInView = false, overView, downPoint, lastPoint, downItem, overItem, dragItem, clickItem, clickTime, dblClick;
        function emitMouseEvent(obj, target, type, event, point, prevPoint, stopItem) {
            var stopped = false, mouseEvent;
            function emit(obj, type) {
                if (obj.responds(type)) {
                    if (!mouseEvent) mouseEvent = new MouseEvent(type, event, point, target || obj, prevPoint ? point.subtract(prevPoint) : null);
                    if (obj.emit(type, mouseEvent)) {
                        called = true;
                        if (mouseEvent.prevented) prevented = true;
                        if (mouseEvent.stopped) return stopped = true;
                    }
                } else {
                    var fallback = fallbacks[type];
                    if (fallback) return emit(obj, fallback);
                }
            }
            while(obj && obj !== stopItem){
                if (emit(obj, type)) break;
                obj = obj._parent;
            }
            return stopped;
        }
        function emitMouseEvents(view, hitItem, type, event, point, prevPoint) {
            view._project.removeOn(type);
            prevented = called = false;
            return dragItem && emitMouseEvent(dragItem, null, type, event, point, prevPoint) || hitItem && hitItem !== dragItem && !hitItem.isDescendant(dragItem) && emitMouseEvent(hitItem, null, type === 'mousedrag' ? 'mousemove' : type, event, point, prevPoint, dragItem) || emitMouseEvent(view, dragItem || hitItem || view, type, event, point, prevPoint);
        }
        var itemEventsMap = {
            mousedown: {
                mousedown: 1,
                mousedrag: 1,
                click: 1,
                doubleclick: 1
            },
            mouseup: {
                mouseup: 1,
                mousedrag: 1,
                click: 1,
                doubleclick: 1
            },
            mousemove: {
                mousedrag: 1,
                mousemove: 1,
                mouseenter: 1,
                mouseleave: 1
            }
        };
        return {
            _viewEvents: viewEvents,
            _handleMouseEvent: function(type, event, point) {
                var itemEvents = this._itemEvents, hitItems = itemEvents.native[type], nativeMove = type === 'mousemove', tool = this._scope.tool, view = this;
                function responds(type) {
                    return itemEvents.virtual[type] || view.responds(type) || tool && tool.responds(type);
                }
                if (nativeMove && dragging && responds('mousedrag')) type = 'mousedrag';
                if (!point) point = this.getEventPoint(event);
                var inView = this.getBounds().contains(point), hit = hitItems && inView && view._project.hitTest(point, {
                    tolerance: 0,
                    fill: true,
                    stroke: true
                }), hitItem = hit && hit.item || null, handle = false, mouse = {};
                mouse[type.substr(5)] = true;
                if (hitItems && hitItem !== overItem) {
                    if (overItem) emitMouseEvent(overItem, null, 'mouseleave', event, point);
                    if (hitItem) emitMouseEvent(hitItem, null, 'mouseenter', event, point);
                    overItem = hitItem;
                }
                if (wasInView ^ inView) {
                    emitMouseEvent(this, null, inView ? 'mouseenter' : 'mouseleave', event, point);
                    overView = inView ? this : null;
                    handle = true;
                }
                if ((inView || mouse.drag) && !point.equals(lastPoint)) {
                    emitMouseEvents(this, hitItem, nativeMove ? type : 'mousemove', event, point, lastPoint);
                    handle = true;
                }
                wasInView = inView;
                if (mouse.down && inView || mouse.up && downPoint) {
                    emitMouseEvents(this, hitItem, type, event, point, downPoint);
                    if (mouse.down) {
                        dblClick = hitItem === clickItem && Date.now() - clickTime < 300;
                        downItem = clickItem = hitItem;
                        if (!prevented && hitItem) {
                            var item = hitItem;
                            while(item && !item.responds('mousedrag'))item = item._parent;
                            if (item) dragItem = hitItem;
                        }
                        downPoint = point;
                    } else if (mouse.up) {
                        if (!prevented && hitItem === downItem) {
                            clickTime = Date.now();
                            emitMouseEvents(this, hitItem, dblClick ? 'doubleclick' : 'click', event, point, downPoint);
                            dblClick = false;
                        }
                        downItem = dragItem = null;
                    }
                    wasInView = false;
                    handle = true;
                }
                lastPoint = point;
                if (handle && tool) called = tool._handleMouseEvent(type, event, point, mouse) || called;
                if (event.cancelable !== false && (called && !mouse.move || mouse.down && responds('mouseup'))) event.preventDefault();
            },
            _handleKeyEvent: function(type, event, key, character) {
                var scope = this._scope, tool = scope.tool, keyEvent;
                function emit(obj) {
                    if (obj.responds(type)) {
                        paper = scope;
                        obj.emit(type, keyEvent = keyEvent || new KeyEvent(type, event, key, character));
                    }
                }
                if (this.isVisible()) {
                    emit(this);
                    if (tool && tool.responds(type)) emit(tool);
                }
            },
            _countItemEvent: function(type, sign) {
                var itemEvents = this._itemEvents, native = itemEvents.native, virtual = itemEvents.virtual;
                for(var key in itemEventsMap)native[key] = (native[key] || 0) + (itemEventsMap[key][type] || 0) * sign;
                virtual[type] = (virtual[type] || 0) + sign;
            },
            statics: {
                updateFocus: updateFocus,
                _resetState: function() {
                    dragging = mouseDown = called = wasInView = false;
                    prevFocus = tempFocus = overView = downPoint = lastPoint = downItem = overItem = dragItem = clickItem = clickTime = dblClick = null;
                }
            }
        };
    });
    var CanvasView = View.extend({
        _class: 'CanvasView',
        initialize: function CanvasView(project, canvas) {
            if (!(canvas instanceof window.HTMLCanvasElement)) {
                var size = Size.read(arguments, 1);
                if (size.isZero()) throw new Error('Cannot create CanvasView with the provided argument: ' + Base.slice(arguments, 1));
                canvas = CanvasProvider.getCanvas(size);
            }
            var ctx = this._context = canvas.getContext('2d');
            ctx.save();
            this._pixelRatio = 1;
            if (!/^off|false$/.test(PaperScope.getAttribute(canvas, 'hidpi'))) {
                var deviceRatio = window.devicePixelRatio || 1, backingStoreRatio = DomElement.getPrefixed(ctx, 'backingStorePixelRatio') || 1;
                this._pixelRatio = deviceRatio / backingStoreRatio;
            }
            View.call(this, project, canvas);
            this._needsUpdate = true;
        },
        remove: function remove() {
            this._context.restore();
            return remove.base.call(this);
        },
        _setElementSize: function _setElementSize(width, height) {
            var pixelRatio = this._pixelRatio;
            _setElementSize.base.call(this, width * pixelRatio, height * pixelRatio);
            if (pixelRatio !== 1) {
                var element = this._element, ctx = this._context;
                if (!PaperScope.hasAttribute(element, 'resize')) {
                    var style = element.style;
                    style.width = width + 'px';
                    style.height = height + 'px';
                }
                ctx.restore();
                ctx.save();
                ctx.scale(pixelRatio, pixelRatio);
            }
        },
        getContext: function() {
            return this._context;
        },
        getPixelSize: function getPixelSize(size) {
            var agent = paper.agent, pixels;
            if (agent && agent.firefox) pixels = getPixelSize.base.call(this, size);
            else {
                var ctx = this._context, prevFont = ctx.font;
                ctx.font = size + ' serif';
                pixels = parseFloat(ctx.font);
                ctx.font = prevFont;
            }
            return pixels;
        },
        getTextWidth: function(font, lines) {
            var ctx = this._context, prevFont = ctx.font, width = 0;
            ctx.font = font;
            for(var i = 0, l = lines.length; i < l; i++)width = Math.max(width, ctx.measureText(lines[i]).width);
            ctx.font = prevFont;
            return width;
        },
        update: function() {
            if (!this._needsUpdate) return false;
            var project = this._project, ctx = this._context, size = this._viewSize;
            ctx.clearRect(0, 0, size.width + 1, size.height + 1);
            if (project) project.draw(ctx, this._matrix, this._pixelRatio);
            this._needsUpdate = false;
            return true;
        }
    });
    var Event = Base.extend({
        _class: 'Event',
        initialize: function Event(event) {
            this.event = event;
            this.type = event && event.type;
        },
        prevented: false,
        stopped: false,
        preventDefault: function() {
            this.prevented = true;
            this.event.preventDefault();
        },
        stopPropagation: function() {
            this.stopped = true;
            this.event.stopPropagation();
        },
        stop: function() {
            this.stopPropagation();
            this.preventDefault();
        },
        getTimeStamp: function() {
            return this.event.timeStamp;
        },
        getModifiers: function() {
            return Key.modifiers;
        }
    });
    var KeyEvent = Event.extend({
        _class: 'KeyEvent',
        initialize: function KeyEvent(type, event, key, character) {
            this.type = type;
            this.event = event;
            this.key = key;
            this.character = character;
        },
        toString: function() {
            return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
        }
    });
    var Key = new function() {
        var keyLookup = {
            '\t': 'tab',
            ' ': 'space',
            '\b': 'backspace',
            '\x7f': 'delete',
            'Spacebar': 'space',
            'Del': 'delete',
            'Win': 'meta',
            'Esc': 'escape'
        }, charLookup = {
            'tab': '\t',
            'space': ' ',
            'enter': '\r'
        }, keyMap = {}, charMap = {}, metaFixMap, downKey, modifiers = new Base({
            shift: false,
            control: false,
            alt: false,
            meta: false,
            capsLock: false,
            space: false
        }).inject({
            option: {
                get: function() {
                    return this.alt;
                }
            },
            command: {
                get: function() {
                    var agent = paper && paper.agent;
                    return agent && agent.mac ? this.meta : this.control;
                }
            }
        });
        function getKey(event) {
            var key = event.key || event.keyIdentifier;
            key = /^U\+/.test(key) ? String.fromCharCode(parseInt(key.substr(2), 16)) : /^Arrow[A-Z]/.test(key) ? key.substr(5) : key === 'Unidentified' || key === undefined ? String.fromCharCode(event.keyCode) : key;
            return keyLookup[key] || (key.length > 1 ? Base.hyphenate(key) : key.toLowerCase());
        }
        function handleKey(down, key, character, event) {
            var type = down ? 'keydown' : 'keyup', view = View._focused, name;
            keyMap[key] = down;
            if (down) charMap[key] = character;
            else delete charMap[key];
            if (key.length > 1 && (name = Base.camelize(key)) in modifiers) {
                modifiers[name] = down;
                var agent = paper && paper.agent;
                if (name === 'meta' && agent && agent.mac) {
                    if (down) metaFixMap = {};
                    else {
                        for(var k in metaFixMap)if (k in charMap) handleKey(false, k, metaFixMap[k], event);
                        metaFixMap = null;
                    }
                }
            } else if (down && metaFixMap) metaFixMap[key] = character;
            if (view) view._handleKeyEvent(down ? 'keydown' : 'keyup', event, key, character);
        }
        DomEvent.add(document, {
            keydown: function(event) {
                var key = getKey(event), agent = paper && paper.agent;
                if (key.length > 1 || agent && agent.chrome && (event.altKey || agent.mac && event.metaKey || !agent.mac && event.ctrlKey)) handleKey(true, key, charLookup[key] || (key.length > 1 ? '' : key), event);
                else downKey = key;
            },
            keypress: function(event) {
                if (downKey) {
                    var key = getKey(event), code = event.charCode, character = code >= 32 ? String.fromCharCode(code) : key.length > 1 ? '' : key;
                    if (key !== downKey) key = character.toLowerCase();
                    handleKey(true, key, character, event);
                    downKey = null;
                }
            },
            keyup: function(event) {
                var key = getKey(event);
                if (key in charMap) handleKey(false, key, charMap[key], event);
            }
        });
        DomEvent.add(window, {
            blur: function(event) {
                for(var key in charMap)handleKey(false, key, charMap[key], event);
            }
        });
        return {
            modifiers: modifiers,
            isDown: function(key) {
                return !!keyMap[key];
            }
        };
    };
    var MouseEvent = Event.extend({
        _class: 'MouseEvent',
        initialize: function MouseEvent(type, event, point, target, delta) {
            this.type = type;
            this.event = event;
            this.point = point;
            this.target = target;
            this.delta = delta;
        },
        toString: function() {
            return "{ type: '" + this.type + "', point: " + this.point + ', target: ' + this.target + (this.delta ? ', delta: ' + this.delta : '') + ', modifiers: ' + this.getModifiers() + ' }';
        }
    });
    var ToolEvent = Event.extend({
        _class: 'ToolEvent',
        _item: null,
        initialize: function ToolEvent(tool, type, event) {
            this.tool = tool;
            this.type = type;
            this.event = event;
        },
        _choosePoint: function(point, toolPoint) {
            return point ? point : toolPoint ? toolPoint.clone() : null;
        },
        getPoint: function() {
            return this._choosePoint(this._point, this.tool._point);
        },
        setPoint: function(point) {
            this._point = point;
        },
        getLastPoint: function() {
            return this._choosePoint(this._lastPoint, this.tool._lastPoint);
        },
        setLastPoint: function(lastPoint) {
            this._lastPoint = lastPoint;
        },
        getDownPoint: function() {
            return this._choosePoint(this._downPoint, this.tool._downPoint);
        },
        setDownPoint: function(downPoint) {
            this._downPoint = downPoint;
        },
        getMiddlePoint: function() {
            if (!this._middlePoint && this.tool._lastPoint) return this.tool._point.add(this.tool._lastPoint).divide(2);
            return this._middlePoint;
        },
        setMiddlePoint: function(middlePoint) {
            this._middlePoint = middlePoint;
        },
        getDelta: function() {
            return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
        },
        setDelta: function(delta) {
            this._delta = delta;
        },
        getCount: function() {
            return this.tool[/^mouse(down|up)$/.test(this.type) ? '_downCount' : '_moveCount'];
        },
        setCount: function(count) {
            this.tool[/^mouse(down|up)$/.test(this.type) ? 'downCount' : 'count'] = count;
        },
        getItem: function() {
            if (!this._item) {
                var result = this.tool._scope.project.hitTest(this.getPoint());
                if (result) {
                    var item = result.item, parent = item._parent;
                    while(/^(Group|CompoundPath)$/.test(parent._class)){
                        item = parent;
                        parent = parent._parent;
                    }
                    this._item = item;
                }
            }
            return this._item;
        },
        setItem: function(item) {
            this._item = item;
        },
        toString: function() {
            return '{ type: ' + this.type + ', point: ' + this.getPoint() + ', count: ' + this.getCount() + ', modifiers: ' + this.getModifiers() + ' }';
        }
    });
    var Tool = PaperScopeItem.extend({
        _class: 'Tool',
        _list: 'tools',
        _reference: 'tool',
        _events: [
            'onMouseDown',
            'onMouseUp',
            'onMouseDrag',
            'onMouseMove',
            'onActivate',
            'onDeactivate',
            'onEditOptions',
            'onKeyDown',
            'onKeyUp'
        ],
        initialize: function Tool(props) {
            PaperScopeItem.call(this);
            this._moveCount = -1;
            this._downCount = -1;
            this.set(props);
        },
        getMinDistance: function() {
            return this._minDistance;
        },
        setMinDistance: function(minDistance) {
            this._minDistance = minDistance;
            if (minDistance != null && this._maxDistance != null && minDistance > this._maxDistance) this._maxDistance = minDistance;
        },
        getMaxDistance: function() {
            return this._maxDistance;
        },
        setMaxDistance: function(maxDistance) {
            this._maxDistance = maxDistance;
            if (this._minDistance != null && maxDistance != null && maxDistance < this._minDistance) this._minDistance = maxDistance;
        },
        getFixedDistance: function() {
            return this._minDistance == this._maxDistance ? this._minDistance : null;
        },
        setFixedDistance: function(distance) {
            this._minDistance = this._maxDistance = distance;
        },
        _handleMouseEvent: function(type, event, point, mouse) {
            paper = this._scope;
            if (mouse.drag && !this.responds(type)) type = 'mousemove';
            var move = mouse.move || mouse.drag, responds = this.responds(type), called = false, tool = this;
            function update(minDistance, maxDistance) {
                var pt = point, toolPoint = move ? tool._point : tool._downPoint || pt;
                if (move) {
                    if (tool._moveCount >= 0 && pt.equals(toolPoint)) return false;
                    if (toolPoint && (minDistance != null || maxDistance != null)) {
                        var vector = pt.subtract(toolPoint), distance = vector.getLength();
                        if (distance < (minDistance || 0)) return false;
                        if (maxDistance) pt = toolPoint.add(vector.normalize(Math.min(distance, maxDistance)));
                    }
                    tool._moveCount++;
                }
                tool._point = pt;
                tool._lastPoint = toolPoint || pt;
                if (mouse.down) {
                    tool._moveCount = -1;
                    tool._downPoint = pt;
                    tool._downCount++;
                }
                return true;
            }
            function emit() {
                if (responds) called = tool.emit(type, new ToolEvent(tool, type, event)) || called;
            }
            if (mouse.down) {
                update();
                emit();
            } else if (mouse.up) {
                update(null, this._maxDistance);
                emit();
            } else if (responds) while(update(this._minDistance, this._maxDistance))emit();
            return called;
        }
    });
    var Tween = Base.extend(Emitter, {
        _class: 'Tween',
        statics: {
            easings: new Base({
                linear: function(t) {
                    return t;
                },
                easeInQuad: function(t) {
                    return t * t;
                },
                easeOutQuad: function(t) {
                    return t * (2 - t);
                },
                easeInOutQuad: function(t) {
                    return t < 0.5 ? 2 * t * t : -1 + 2 * (2 - t) * t;
                },
                easeInCubic: function(t) {
                    return t * t * t;
                },
                easeOutCubic: function(t) {
                    return --t * t * t + 1;
                },
                easeInOutCubic: function(t) {
                    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                },
                easeInQuart: function(t) {
                    return t * t * t * t;
                },
                easeOutQuart: function(t) {
                    return 1 - --t * t * t * t;
                },
                easeInOutQuart: function(t) {
                    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
                },
                easeInQuint: function(t) {
                    return t * t * t * t * t;
                },
                easeOutQuint: function(t) {
                    return 1 + --t * t * t * t * t;
                },
                easeInOutQuint: function(t) {
                    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
                }
            })
        },
        initialize: function Tween(object, from, to, duration, easing, start) {
            this.object = object;
            var type = typeof easing;
            var isFunction = type === 'function';
            this.type = isFunction ? type : type === 'string' ? easing : 'linear';
            this.easing = isFunction ? easing : Tween.easings[this.type];
            this.duration = duration;
            this.running = false;
            this._then = null;
            this._startTime = null;
            var state = from || to;
            this._keys = state ? Object.keys(state) : [];
            this._parsedKeys = this._parseKeys(this._keys);
            this._from = state && this._getState(from);
            this._to = state && this._getState(to);
            if (start !== false) this.start();
        },
        then: function(then) {
            this._then = then;
            return this;
        },
        start: function() {
            this._startTime = null;
            this.running = true;
            return this;
        },
        stop: function() {
            this.running = false;
            return this;
        },
        update: function(progress) {
            if (this.running) {
                if (progress >= 1) {
                    progress = 1;
                    this.running = false;
                }
                var factor = this.easing(progress), keys = this._keys, getValue = function(value) {
                    return typeof value === 'function' ? value(factor, progress) : value;
                };
                for(var i = 0, l = keys && keys.length; i < l; i++){
                    var key = keys[i], from = getValue(this._from[key]), to = getValue(this._to[key]), value = from && to && from.__add && to.__add ? to.__subtract(from).__multiply(factor).__add(from) : (to - from) * factor + from;
                    this._setProperty(this._parsedKeys[key], value);
                }
                if (this.responds('update')) this.emit('update', new Base({
                    progress: progress,
                    factor: factor
                }));
                if (!this.running && this._then) this._then(this.object);
            }
            return this;
        },
        _events: {
            onUpdate: {}
        },
        _handleFrame: function(time) {
            var startTime = this._startTime, progress = startTime ? (time - startTime) / this.duration : 0;
            if (!startTime) this._startTime = time;
            this.update(progress);
        },
        _getState: function(state) {
            var keys = this._keys, result = {};
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i], path = this._parsedKeys[key], current = this._getProperty(path), value;
                if (state) {
                    var resolved = this._resolveValue(current, state[key]);
                    this._setProperty(path, resolved);
                    value = this._getProperty(path);
                    value = value && value.clone ? value.clone() : value;
                    this._setProperty(path, current);
                } else value = current && current.clone ? current.clone() : current;
                result[key] = value;
            }
            return result;
        },
        _resolveValue: function(current, value) {
            if (value) {
                if (Array.isArray(value) && value.length === 2) {
                    var operator = value[0];
                    return operator && operator.match && operator.match(/^[+\-\*\/]=/) ? this._calculate(current, operator[0], value[1]) : value;
                } else if (typeof value === 'string') {
                    var match = value.match(/^[+\-*/]=(.*)/);
                    if (match) {
                        var parsed = JSON.parse(match[1].replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": '));
                        return this._calculate(current, value[0], parsed);
                    }
                }
            }
            return value;
        },
        _calculate: function(left, operator, right) {
            return paper.PaperScript.calculateBinary(left, operator, right);
        },
        _parseKeys: function(keys) {
            var parsed = {};
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i], path = key.replace(/\.([^.]*)/g, '/$1').replace(/\[['"]?([^'"\]]*)['"]?\]/g, '/$1');
                parsed[key] = path.split('/');
            }
            return parsed;
        },
        _getProperty: function(path, offset) {
            var obj = this.object;
            for(var i = 0, l = path.length - (offset || 0); i < l && obj; i++)obj = obj[path[i]];
            return obj;
        },
        _setProperty: function(path, value) {
            var dest = this._getProperty(path, 1);
            if (dest) dest[path[path.length - 1]] = value;
        }
    });
    var Http = {
        request: function(options) {
            var xhr = new self1.XMLHttpRequest();
            xhr.open((options.method || 'get').toUpperCase(), options.url, Base.pick(options.async, true));
            if (options.mimeType) xhr.overrideMimeType(options.mimeType);
            xhr.onload = function() {
                var status = xhr.status;
                if (status === 0 || status === 200) {
                    if (options.onLoad) options.onLoad.call(xhr, xhr.responseText);
                } else xhr.onerror();
            };
            xhr.onerror = function() {
                var status = xhr.status, message = 'Could not load "' + options.url + '" (Status: ' + status + ')';
                if (options.onError) options.onError(message, status);
                else throw new Error(message);
            };
            return xhr.send(null);
        }
    };
    var CanvasProvider = Base.exports.CanvasProvider = {
        canvases: [],
        getCanvas: function(width, height, options) {
            if (!window) return null;
            var canvas, clear = true;
            if (typeof width === 'object') {
                height = width.height;
                width = width.width;
            }
            if (this.canvases.length) canvas = this.canvases.pop();
            else {
                canvas = document.createElement('canvas');
                clear = false;
            }
            var ctx = canvas.getContext('2d', options || {});
            if (!ctx) throw new Error('Canvas ' + canvas + ' is unable to provide a 2D context.');
            if (canvas.width === width && canvas.height === height) {
                if (clear) ctx.clearRect(0, 0, width + 1, height + 1);
            } else {
                canvas.width = width;
                canvas.height = height;
            }
            ctx.save();
            return canvas;
        },
        getContext: function(width, height, options) {
            var canvas = this.getCanvas(width, height, options);
            return canvas ? canvas.getContext('2d', options || {}) : null;
        },
        release: function(obj) {
            var canvas = obj && obj.canvas ? obj.canvas : obj;
            if (canvas && canvas.getContext) {
                canvas.getContext('2d').restore();
                this.canvases.push(canvas);
            }
        }
    };
    var BlendMode = new function() {
        var min = Math.min, max = Math.max, abs = Math.abs, sr, sg, sb, sa, br, bg, bb, ba, dr, dg, db;
        function getLum(r, g, b) {
            return 0.2989 * r + 0.587 * g + 0.114 * b;
        }
        function setLum(r, g, b, l) {
            var d = l - getLum(r, g, b);
            dr = r + d;
            dg = g + d;
            db = b + d;
            var l = getLum(dr, dg, db), mn = min(dr, dg, db), mx = max(dr, dg, db);
            if (mn < 0) {
                var lmn = l - mn;
                dr = l + (dr - l) * l / lmn;
                dg = l + (dg - l) * l / lmn;
                db = l + (db - l) * l / lmn;
            }
            if (mx > 255) {
                var ln = 255 - l, mxl = mx - l;
                dr = l + (dr - l) * ln / mxl;
                dg = l + (dg - l) * ln / mxl;
                db = l + (db - l) * ln / mxl;
            }
        }
        function getSat(r, g, b) {
            return max(r, g, b) - min(r, g, b);
        }
        function setSat(r, g, b, s) {
            var col = [
                r,
                g,
                b
            ], mx = max(r, g, b), mn = min(r, g, b), md;
            mn = mn === r ? 0 : mn === g ? 1 : 2;
            mx = mx === r ? 0 : mx === g ? 1 : 2;
            md = min(mn, mx) === 0 ? max(mn, mx) === 1 ? 2 : 1 : 0;
            if (col[mx] > col[mn]) {
                col[md] = (col[md] - col[mn]) * s / (col[mx] - col[mn]);
                col[mx] = s;
            } else col[md] = col[mx] = 0;
            col[mn] = 0;
            dr = col[0];
            dg = col[1];
            db = col[2];
        }
        var modes = {
            multiply: function() {
                dr = br * sr / 255;
                dg = bg * sg / 255;
                db = bb * sb / 255;
            },
            screen: function() {
                dr = br + sr - br * sr / 255;
                dg = bg + sg - bg * sg / 255;
                db = bb + sb - bb * sb / 255;
            },
            overlay: function() {
                dr = br < 128 ? 2 * br * sr / 255 : 255 - 2 * (255 - br) * (255 - sr) / 255;
                dg = bg < 128 ? 2 * bg * sg / 255 : 255 - 2 * (255 - bg) * (255 - sg) / 255;
                db = bb < 128 ? 2 * bb * sb / 255 : 255 - 2 * (255 - bb) * (255 - sb) / 255;
            },
            'soft-light': function() {
                var t = sr * br / 255;
                dr = t + br * (255 - (255 - br) * (255 - sr) / 255 - t) / 255;
                t = sg * bg / 255;
                dg = t + bg * (255 - (255 - bg) * (255 - sg) / 255 - t) / 255;
                t = sb * bb / 255;
                db = t + bb * (255 - (255 - bb) * (255 - sb) / 255 - t) / 255;
            },
            'hard-light': function() {
                dr = sr < 128 ? 2 * sr * br / 255 : 255 - 2 * (255 - sr) * (255 - br) / 255;
                dg = sg < 128 ? 2 * sg * bg / 255 : 255 - 2 * (255 - sg) * (255 - bg) / 255;
                db = sb < 128 ? 2 * sb * bb / 255 : 255 - 2 * (255 - sb) * (255 - bb) / 255;
            },
            'color-dodge': function() {
                dr = br === 0 ? 0 : sr === 255 ? 255 : min(255, 255 * br / (255 - sr));
                dg = bg === 0 ? 0 : sg === 255 ? 255 : min(255, 255 * bg / (255 - sg));
                db = bb === 0 ? 0 : sb === 255 ? 255 : min(255, 255 * bb / (255 - sb));
            },
            'color-burn': function() {
                dr = br === 255 ? 255 : sr === 0 ? 0 : max(0, 255 - (255 - br) * 255 / sr);
                dg = bg === 255 ? 255 : sg === 0 ? 0 : max(0, 255 - (255 - bg) * 255 / sg);
                db = bb === 255 ? 255 : sb === 0 ? 0 : max(0, 255 - (255 - bb) * 255 / sb);
            },
            darken: function() {
                dr = br < sr ? br : sr;
                dg = bg < sg ? bg : sg;
                db = bb < sb ? bb : sb;
            },
            lighten: function() {
                dr = br > sr ? br : sr;
                dg = bg > sg ? bg : sg;
                db = bb > sb ? bb : sb;
            },
            difference: function() {
                dr = br - sr;
                if (dr < 0) dr = -dr;
                dg = bg - sg;
                if (dg < 0) dg = -dg;
                db = bb - sb;
                if (db < 0) db = -db;
            },
            exclusion: function() {
                dr = br + sr * (255 - br - br) / 255;
                dg = bg + sg * (255 - bg - bg) / 255;
                db = bb + sb * (255 - bb - bb) / 255;
            },
            hue: function() {
                setSat(sr, sg, sb, getSat(br, bg, bb));
                setLum(dr, dg, db, getLum(br, bg, bb));
            },
            saturation: function() {
                setSat(br, bg, bb, getSat(sr, sg, sb));
                setLum(dr, dg, db, getLum(br, bg, bb));
            },
            luminosity: function() {
                setLum(br, bg, bb, getLum(sr, sg, sb));
            },
            color: function() {
                setLum(sr, sg, sb, getLum(br, bg, bb));
            },
            add: function() {
                dr = min(br + sr, 255);
                dg = min(bg + sg, 255);
                db = min(bb + sb, 255);
            },
            subtract: function() {
                dr = max(br - sr, 0);
                dg = max(bg - sg, 0);
                db = max(bb - sb, 0);
            },
            average: function() {
                dr = (br + sr) / 2;
                dg = (bg + sg) / 2;
                db = (bb + sb) / 2;
            },
            negation: function() {
                dr = 255 - abs(255 - sr - br);
                dg = 255 - abs(255 - sg - bg);
                db = 255 - abs(255 - sb - bb);
            }
        };
        var nativeModes = this.nativeModes = Base.each([
            'source-over',
            'source-in',
            'source-out',
            'source-atop',
            'destination-over',
            'destination-in',
            'destination-out',
            'destination-atop',
            'lighter',
            'darker',
            'copy',
            'xor'
        ], function(mode) {
            this[mode] = true;
        }, {});
        var ctx = CanvasProvider.getContext(1, 1, {
            willReadFrequently: true
        });
        if (ctx) {
            Base.each(modes, function(func, mode) {
                var darken = mode === 'darken', ok = false;
                ctx.save();
                try {
                    ctx.fillStyle = darken ? '#300' : '#a00';
                    ctx.fillRect(0, 0, 1, 1);
                    ctx.globalCompositeOperation = mode;
                    if (ctx.globalCompositeOperation === mode) {
                        ctx.fillStyle = darken ? '#a00' : '#300';
                        ctx.fillRect(0, 0, 1, 1);
                        ok = ctx.getImageData(0, 0, 1, 1).data[0] !== darken ? 170 : 51;
                    }
                } catch (e) {}
                ctx.restore();
                nativeModes[mode] = ok;
            });
            CanvasProvider.release(ctx);
        }
        this.process = function(mode, srcContext, dstContext, alpha, offset) {
            var srcCanvas = srcContext.canvas, normal = mode === 'normal';
            if (normal || nativeModes[mode]) {
                dstContext.save();
                dstContext.setTransform(1, 0, 0, 1, 0, 0);
                dstContext.globalAlpha = alpha;
                if (!normal) dstContext.globalCompositeOperation = mode;
                dstContext.drawImage(srcCanvas, offset.x, offset.y);
                dstContext.restore();
            } else {
                var process = modes[mode];
                if (!process) return;
                var dstData = dstContext.getImageData(offset.x, offset.y, srcCanvas.width, srcCanvas.height), dst = dstData.data, src = srcContext.getImageData(0, 0, srcCanvas.width, srcCanvas.height).data;
                for(var i = 0, l = dst.length; i < l; i += 4){
                    sr = src[i];
                    br = dst[i];
                    sg = src[i + 1];
                    bg = dst[i + 1];
                    sb = src[i + 2];
                    bb = dst[i + 2];
                    sa = src[i + 3];
                    ba = dst[i + 3];
                    process();
                    var a1 = sa * alpha / 255, a2 = 1 - a1;
                    dst[i] = a1 * dr + a2 * br;
                    dst[i + 1] = a1 * dg + a2 * bg;
                    dst[i + 2] = a1 * db + a2 * bb;
                    dst[i + 3] = sa * alpha + a2 * ba;
                }
                dstContext.putImageData(dstData, offset.x, offset.y);
            }
        };
    };
    var SvgElement = new function() {
        var svg = 'http://www.w3.org/2000/svg', xmlns = 'http://www.w3.org/2000/xmlns', xlink = 'http://www.w3.org/1999/xlink', attributeNamespace = {
            href: xlink,
            xlink: xmlns,
            xmlns: xmlns + '/',
            'xmlns:xlink': xmlns + '/'
        };
        function create(tag, attributes, formatter) {
            return set(document.createElementNS(svg, tag), attributes, formatter);
        }
        function get(node, name) {
            var namespace = attributeNamespace[name], value = namespace ? node.getAttributeNS(namespace, name) : node.getAttribute(name);
            return value === 'null' ? null : value;
        }
        function set(node, attributes, formatter) {
            for(var name in attributes){
                var value = attributes[name], namespace = attributeNamespace[name];
                if (typeof value === 'number' && formatter) value = formatter.number(value);
                if (namespace) node.setAttributeNS(namespace, name, value);
                else node.setAttribute(name, value);
            }
            return node;
        }
        return {
            svg: svg,
            xmlns: xmlns,
            xlink: xlink,
            create: create,
            get: get,
            set: set
        };
    };
    var SvgStyles = Base.each({
        fillColor: [
            'fill',
            'color'
        ],
        fillRule: [
            'fill-rule',
            'string'
        ],
        strokeColor: [
            'stroke',
            'color'
        ],
        strokeWidth: [
            'stroke-width',
            'number'
        ],
        strokeCap: [
            'stroke-linecap',
            'string'
        ],
        strokeJoin: [
            'stroke-linejoin',
            'string'
        ],
        strokeScaling: [
            'vector-effect',
            'lookup',
            {
                true: 'none',
                false: 'non-scaling-stroke'
            },
            function(item, value) {
                return !value && (item instanceof PathItem || item instanceof Shape || item instanceof TextItem);
            }
        ],
        miterLimit: [
            'stroke-miterlimit',
            'number'
        ],
        dashArray: [
            'stroke-dasharray',
            'array'
        ],
        dashOffset: [
            'stroke-dashoffset',
            'number'
        ],
        fontFamily: [
            'font-family',
            'string'
        ],
        fontWeight: [
            'font-weight',
            'string'
        ],
        fontSize: [
            'font-size',
            'number'
        ],
        justification: [
            'text-anchor',
            'lookup',
            {
                left: 'start',
                center: 'middle',
                right: 'end'
            }
        ],
        opacity: [
            'opacity',
            'number'
        ],
        blendMode: [
            'mix-blend-mode',
            'style'
        ]
    }, function(entry, key) {
        var part = Base.capitalize(key), lookup = entry[2];
        this[key] = {
            type: entry[1],
            property: key,
            attribute: entry[0],
            toSVG: lookup,
            fromSVG: lookup && Base.each(lookup, function(value, name) {
                this[value] = name;
            }, {}),
            exportFilter: entry[3],
            get: 'get' + part,
            set: 'set' + part
        };
    }, {});
    new function() {
        var formatter;
        function getTransform(matrix, coordinates, center) {
            var attrs = new Base(), trans = matrix.getTranslation();
            if (coordinates) {
                var point;
                if (matrix.isInvertible()) {
                    matrix = matrix._shiftless();
                    point = matrix._inverseTransform(trans);
                    trans = null;
                } else point = new Point();
                attrs[center ? 'cx' : 'x'] = point.x;
                attrs[center ? 'cy' : 'y'] = point.y;
            }
            if (!matrix.isIdentity()) {
                var decomposed = matrix.decompose();
                if (decomposed) {
                    var parts = [], angle = decomposed.rotation, scale = decomposed.scaling, skew = decomposed.skewing;
                    if (trans && !trans.isZero()) parts.push('translate(' + formatter.point(trans) + ')');
                    if (angle) parts.push('rotate(' + formatter.number(angle) + ')');
                    if (!Numerical.isZero(scale.x - 1) || !Numerical.isZero(scale.y - 1)) parts.push('scale(' + formatter.point(scale) + ')');
                    if (skew.x) parts.push('skewX(' + formatter.number(skew.x) + ')');
                    if (skew.y) parts.push('skewY(' + formatter.number(skew.y) + ')');
                    attrs.transform = parts.join(' ');
                } else attrs.transform = 'matrix(' + matrix.getValues().join(',') + ')';
            }
            return attrs;
        }
        function exportGroup(item, options) {
            var attrs = getTransform(item._matrix), children = item._children;
            var node = SvgElement.create('g', attrs, formatter);
            for(var i = 0, l = children.length; i < l; i++){
                var child = children[i];
                var childNode = exportSVG(child, options);
                if (childNode) {
                    if (child.isClipMask()) {
                        var clip = SvgElement.create('clipPath');
                        clip.appendChild(childNode);
                        setDefinition(child, clip, 'clip');
                        SvgElement.set(node, {
                            'clip-path': 'url(#' + clip.id + ')'
                        });
                    } else node.appendChild(childNode);
                }
            }
            return node;
        }
        function exportRaster(item, options) {
            var attrs = getTransform(item._matrix, true), size = item.getSize(), image = item.getImage();
            attrs.x -= size.width / 2;
            attrs.y -= size.height / 2;
            attrs.width = size.width;
            attrs.height = size.height;
            attrs.href = options.embedImages == false && image && image.src || item.toDataURL();
            return SvgElement.create('image', attrs, formatter);
        }
        function exportPath(item, options) {
            var matchShapes = options.matchShapes;
            if (matchShapes) {
                var shape = item.toShape(false);
                if (shape) return exportShape(shape, options);
            }
            var segments = item._segments, length = segments.length, type, attrs = getTransform(item._matrix);
            if (matchShapes && length >= 2 && !item.hasHandles()) {
                if (length > 2) {
                    type = item._closed ? 'polygon' : 'polyline';
                    var parts = [];
                    for(var i = 0; i < length; i++)parts.push(formatter.point(segments[i]._point));
                    attrs.points = parts.join(' ');
                } else {
                    type = 'line';
                    var start = segments[0]._point, end = segments[1]._point;
                    attrs.set({
                        x1: start.x,
                        y1: start.y,
                        x2: end.x,
                        y2: end.y
                    });
                }
            } else {
                type = 'path';
                attrs.d = item.getPathData(null, options.precision);
            }
            return SvgElement.create(type, attrs, formatter);
        }
        function exportShape(item) {
            var type = item._type, radius = item._radius, attrs = getTransform(item._matrix, true, type !== 'rectangle');
            if (type === 'rectangle') {
                type = 'rect';
                var size = item._size, width = size.width, height = size.height;
                attrs.x -= width / 2;
                attrs.y -= height / 2;
                attrs.width = width;
                attrs.height = height;
                if (radius.isZero()) radius = null;
            }
            if (radius) {
                if (type === 'circle') attrs.r = radius;
                else {
                    attrs.rx = radius.width;
                    attrs.ry = radius.height;
                }
            }
            return SvgElement.create(type, attrs, formatter);
        }
        function exportCompoundPath(item, options) {
            var attrs = getTransform(item._matrix);
            var data = item.getPathData(null, options.precision);
            if (data) attrs.d = data;
            return SvgElement.create('path', attrs, formatter);
        }
        function exportSymbolItem(item, options) {
            var attrs = getTransform(item._matrix, true), definition = item._definition, node = getDefinition(definition, 'symbol'), definitionItem = definition._item, bounds = definitionItem.getStrokeBounds();
            if (!node) {
                node = SvgElement.create('symbol', {
                    viewBox: formatter.rectangle(bounds)
                });
                node.appendChild(exportSVG(definitionItem, options));
                setDefinition(definition, node, 'symbol');
            }
            attrs.href = '#' + node.id;
            attrs.x += bounds.x;
            attrs.y += bounds.y;
            attrs.width = bounds.width;
            attrs.height = bounds.height;
            attrs.overflow = 'visible';
            return SvgElement.create('use', attrs, formatter);
        }
        function exportGradient(color) {
            var gradientNode = getDefinition(color, 'color');
            if (!gradientNode) {
                var gradient = color.getGradient(), radial = gradient._radial, origin = color.getOrigin(), destination = color.getDestination(), attrs;
                if (radial) {
                    attrs = {
                        cx: origin.x,
                        cy: origin.y,
                        r: origin.getDistance(destination)
                    };
                    var highlight = color.getHighlight();
                    if (highlight) {
                        attrs.fx = highlight.x;
                        attrs.fy = highlight.y;
                    }
                } else attrs = {
                    x1: origin.x,
                    y1: origin.y,
                    x2: destination.x,
                    y2: destination.y
                };
                attrs.gradientUnits = 'userSpaceOnUse';
                gradientNode = SvgElement.create((radial ? 'radial' : 'linear') + 'Gradient', attrs, formatter);
                var stops = gradient._stops;
                for(var i = 0, l = stops.length; i < l; i++){
                    var stop = stops[i], stopColor = stop._color, alpha = stopColor.getAlpha(), offset = stop._offset;
                    attrs = {
                        offset: offset == null ? i / (l - 1) : offset
                    };
                    if (stopColor) attrs['stop-color'] = stopColor.toCSS(true);
                    if (alpha < 1) attrs['stop-opacity'] = alpha;
                    gradientNode.appendChild(SvgElement.create('stop', attrs, formatter));
                }
                setDefinition(color, gradientNode, 'color');
            }
            return 'url(#' + gradientNode.id + ')';
        }
        function exportText(item) {
            var node = SvgElement.create('text', getTransform(item._matrix, true), formatter);
            node.textContent = item._content;
            return node;
        }
        var exporters = {
            Group: exportGroup,
            Layer: exportGroup,
            Raster: exportRaster,
            Path: exportPath,
            Shape: exportShape,
            CompoundPath: exportCompoundPath,
            SymbolItem: exportSymbolItem,
            PointText: exportText
        };
        function applyStyle(item, node, options, isRoot) {
            var attrs = {}, parent = !isRoot && item.getParent(), style = [];
            if (item._name != null) attrs.id = item._name;
            Base.each(SvgStyles, function(entry) {
                var get = entry.get, type = entry.type, value = item[get]();
                if (entry.exportFilter ? entry.exportFilter(item, value) : options.reduceAttributes == false || !parent || !Base.equals(parent[get](), value)) {
                    if (type === 'color' && value != null) {
                        var alpha = value.getAlpha();
                        if (alpha < 1) attrs[entry.attribute + '-opacity'] = alpha;
                    }
                    if (type === 'style') style.push(entry.attribute + ': ' + value);
                    else attrs[entry.attribute] = value == null ? 'none' : type === 'color' ? value.gradient ? exportGradient(value, item) : value.toCSS(true) : type === 'array' ? value.join(',') : type === 'lookup' ? entry.toSVG[value] : value;
                }
            });
            if (style.length) attrs.style = style.join(';');
            if (attrs.opacity === 1) delete attrs.opacity;
            if (!item._visible) attrs.visibility = 'hidden';
            return SvgElement.set(node, attrs, formatter);
        }
        var definitions;
        function getDefinition(item, type) {
            if (!definitions) definitions = {
                ids: {},
                svgs: {}
            };
            return item && definitions.svgs[type + '-' + (item._id || item.__id || (item.__id = UID.get('svg')))];
        }
        function setDefinition(item, node, type) {
            if (!definitions) getDefinition();
            var typeId = definitions.ids[type] = (definitions.ids[type] || 0) + 1;
            node.id = type + '-' + typeId;
            definitions.svgs[type + '-' + (item._id || item.__id)] = node;
        }
        function exportDefinitions(node, options) {
            var svg = node, defs = null;
            if (definitions) {
                svg = node.nodeName.toLowerCase() === 'svg' && node;
                for(var i in definitions.svgs){
                    if (!defs) {
                        if (!svg) {
                            svg = SvgElement.create('svg');
                            svg.appendChild(node);
                        }
                        defs = svg.insertBefore(SvgElement.create('defs'), svg.firstChild);
                    }
                    defs.appendChild(definitions.svgs[i]);
                }
                definitions = null;
            }
            return options.asString ? new self1.XMLSerializer().serializeToString(svg) : svg;
        }
        function exportSVG(item, options, isRoot) {
            var exporter = exporters[item._class], node = exporter && exporter(item, options);
            if (node) {
                var onExport = options.onExport;
                if (onExport) node = onExport(item, node, options) || node;
                var data = JSON.stringify(item._data);
                if (data && data !== '{}' && data !== 'null') node.setAttribute('data-paper-data', data);
            }
            return node && applyStyle(item, node, options, isRoot);
        }
        function setOptions(options) {
            if (!options) options = {};
            formatter = new Formatter(options.precision);
            return options;
        }
        Item.inject({
            exportSVG: function(options) {
                options = setOptions(options);
                return exportDefinitions(exportSVG(this, options, true), options);
            }
        });
        Project.inject({
            exportSVG: function(options) {
                options = setOptions(options);
                var children = this._children, view = this.getView(), bounds = Base.pick(options.bounds, 'view'), mx = options.matrix || bounds === 'view' && view._matrix, matrix = mx && Matrix.read([
                    mx
                ]), rect = bounds === 'view' ? new Rectangle([
                    0,
                    0
                ], view.getViewSize()) : bounds === 'content' ? Item._getBounds(children, matrix, {
                    stroke: true
                }).rect : Rectangle.read([
                    bounds
                ], 0, {
                    readNull: true
                }), attrs = {
                    version: '1.1',
                    xmlns: SvgElement.svg,
                    'xmlns:xlink': SvgElement.xlink
                };
                if (rect) {
                    attrs.width = rect.width;
                    attrs.height = rect.height;
                    if (rect.x || rect.x === 0 || rect.y || rect.y === 0) attrs.viewBox = formatter.rectangle(rect);
                }
                var node = SvgElement.create('svg', attrs, formatter), parent = node;
                if (matrix && !matrix.isIdentity()) parent = node.appendChild(SvgElement.create('g', getTransform(matrix), formatter));
                for(var i = 0, l = children.length; i < l; i++)parent.appendChild(exportSVG(children[i], options, true));
                return exportDefinitions(node, options);
            }
        });
    };
    new function() {
        var definitions = {}, rootSize;
        function getValue(node, name, isString, allowNull, allowPercent, defaultValue) {
            var value = SvgElement.get(node, name) || defaultValue, res = value == null ? allowNull ? null : isString ? '' : 0 : isString ? value : parseFloat(value);
            return /%\s*$/.test(value) ? res / 100 * (allowPercent ? 1 : rootSize[/x|^width/.test(name) ? 'width' : 'height']) : res;
        }
        function getPoint(node, x, y, allowNull, allowPercent, defaultX, defaultY) {
            x = getValue(node, x || 'x', false, allowNull, allowPercent, defaultX);
            y = getValue(node, y || 'y', false, allowNull, allowPercent, defaultY);
            return allowNull && (x == null || y == null) ? null : new Point(x, y);
        }
        function getSize(node, w, h, allowNull, allowPercent) {
            w = getValue(node, w || 'width', false, allowNull, allowPercent);
            h = getValue(node, h || 'height', false, allowNull, allowPercent);
            return allowNull && (w == null || h == null) ? null : new Size(w, h);
        }
        function convertValue(value, type, lookup) {
            return value === 'none' ? null : type === 'number' ? parseFloat(value) : type === 'array' ? value ? value.split(/[\s,]+/g).map(parseFloat) : [] : type === 'color' ? getDefinition(value) || value : type === 'lookup' ? lookup[value] : value;
        }
        function importGroup(node, type, options, isRoot) {
            var nodes = node.childNodes, isClip = type === 'clippath', isDefs = type === 'defs', item = new Group(), project = item._project, currentStyle = project._currentStyle, children = [];
            if (!isClip && !isDefs) {
                item = applyAttributes(item, node, isRoot);
                project._currentStyle = item._style.clone();
            }
            if (isRoot) {
                var defs = node.querySelectorAll('defs');
                for(var i = 0, l = defs.length; i < l; i++)importNode(defs[i], options, false);
            }
            for(var i = 0, l = nodes.length; i < l; i++){
                var childNode = nodes[i], child;
                if (childNode.nodeType === 1 && !/^defs$/i.test(childNode.nodeName) && (child = importNode(childNode, options, false)) && !(child instanceof SymbolDefinition)) children.push(child);
            }
            item.addChildren(children);
            if (isClip) item = applyAttributes(item.reduce(), node, isRoot);
            project._currentStyle = currentStyle;
            if (isClip || isDefs) {
                item.remove();
                item = null;
            }
            return item;
        }
        function importPoly(node, type) {
            var coords = node.getAttribute('points').match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g), points = [];
            for(var i = 0, l = coords.length; i < l; i += 2)points.push(new Point(parseFloat(coords[i]), parseFloat(coords[i + 1])));
            var path = new Path(points);
            if (type === 'polygon') path.closePath();
            return path;
        }
        function importPath(node) {
            return PathItem.create(node.getAttribute('d'));
        }
        function importGradient(node, type) {
            var id = (getValue(node, 'href', true) || '').substring(1), radial = type === 'radialgradient', gradient;
            if (id) {
                gradient = definitions[id].getGradient();
                if (gradient._radial ^ radial) {
                    gradient = gradient.clone();
                    gradient._radial = radial;
                }
            } else {
                var nodes = node.childNodes, stops = [];
                for(var i = 0, l = nodes.length; i < l; i++){
                    var child = nodes[i];
                    if (child.nodeType === 1) stops.push(applyAttributes(new GradientStop(), child));
                }
                gradient = new Gradient(stops, radial);
            }
            var origin, destination, highlight, scaleToBounds = getValue(node, 'gradientUnits', true) !== 'userSpaceOnUse';
            if (radial) {
                origin = getPoint(node, 'cx', 'cy', false, scaleToBounds, '50%', '50%');
                destination = origin.add(getValue(node, 'r', false, false, scaleToBounds, '50%'), 0);
                highlight = getPoint(node, 'fx', 'fy', true, scaleToBounds);
            } else {
                origin = getPoint(node, 'x1', 'y1', false, scaleToBounds, '0%', '0%');
                destination = getPoint(node, 'x2', 'y2', false, scaleToBounds, '100%', '0%');
            }
            var color = applyAttributes(new Color(gradient, origin, destination, highlight), node);
            color._scaleToBounds = scaleToBounds;
            return null;
        }
        var importers = {
            '#document': function(node, type, options, isRoot) {
                var nodes = node.childNodes;
                for(var i = 0, l = nodes.length; i < l; i++){
                    var child = nodes[i];
                    if (child.nodeType === 1) return importNode(child, options, isRoot);
                }
            },
            g: importGroup,
            svg: importGroup,
            clippath: importGroup,
            polygon: importPoly,
            polyline: importPoly,
            path: importPath,
            lineargradient: importGradient,
            radialgradient: importGradient,
            image: function(node) {
                var raster = new Raster(getValue(node, 'href', true));
                raster.on('load', function() {
                    var size = getSize(node);
                    this.setSize(size);
                    var center = getPoint(node).add(size.divide(2));
                    this._matrix.append(new Matrix().translate(center));
                });
                return raster;
            },
            symbol: function(node, type, options, isRoot) {
                return new SymbolDefinition(importGroup(node, type, options, isRoot), true);
            },
            defs: importGroup,
            use: function(node) {
                var id = (getValue(node, 'href', true) || '').substring(1), definition = definitions[id], point = getPoint(node);
                return definition ? definition instanceof SymbolDefinition ? definition.place(point) : definition.clone().translate(point) : null;
            },
            circle: function(node) {
                return new Shape.Circle(getPoint(node, 'cx', 'cy'), getValue(node, 'r'));
            },
            ellipse: function(node) {
                return new Shape.Ellipse({
                    center: getPoint(node, 'cx', 'cy'),
                    radius: getSize(node, 'rx', 'ry')
                });
            },
            rect: function(node) {
                return new Shape.Rectangle(new Rectangle(getPoint(node), getSize(node)), getSize(node, 'rx', 'ry'));
            },
            line: function(node) {
                return new Path.Line(getPoint(node, 'x1', 'y1'), getPoint(node, 'x2', 'y2'));
            },
            text: function(node) {
                var text = new PointText(getPoint(node).add(getPoint(node, 'dx', 'dy')));
                text.setContent(node.textContent.trim() || '');
                return text;
            },
            switch: importGroup
        };
        function applyTransform(item, value, name, node) {
            if (item.transform) {
                var transforms = (node.getAttribute(name) || '').split(/\)\s*/g), matrix = new Matrix();
                for(var i = 0, l = transforms.length; i < l; i++){
                    var transform = transforms[i];
                    if (!transform) break;
                    var parts = transform.split(/\(\s*/), command = parts[0].trim(), v = parts[1].split(/[\s,]+/g);
                    for(var j = 0, m = v.length; j < m; j++)v[j] = parseFloat(v[j]);
                    switch(command){
                        case 'matrix':
                            matrix.append(new Matrix(v[0], v[1], v[2], v[3], v[4], v[5]));
                            break;
                        case 'rotate':
                            matrix.rotate(v[0], v[1] || 0, v[2] || 0);
                            break;
                        case 'translate':
                            matrix.translate(v[0], v[1] || 0);
                            break;
                        case 'scale':
                            matrix.scale(v);
                            break;
                        case 'skewX':
                            matrix.skew(v[0], 0);
                            break;
                        case 'skewY':
                            matrix.skew(0, v[0]);
                            break;
                    }
                }
                item.transform(matrix);
            }
        }
        function applyOpacity(item, value, name) {
            var key = name === 'fill-opacity' ? 'getFillColor' : 'getStrokeColor', color = item[key] && item[key]();
            if (color) color.setAlpha(parseFloat(value));
        }
        var attributes = Base.set(Base.each(SvgStyles, function(entry) {
            this[entry.attribute] = function(item, value) {
                if (item[entry.set]) {
                    item[entry.set](convertValue(value, entry.type, entry.fromSVG));
                    if (entry.type === 'color') {
                        var color = item[entry.get]();
                        if (color) {
                            if (color._scaleToBounds) {
                                var bounds = item.getBounds();
                                color.transform(new Matrix().translate(bounds.getPoint()).scale(bounds.getSize()));
                            }
                        }
                    }
                }
            };
        }, {}), {
            id: function(item, value) {
                definitions[value] = item;
                if (item.setName) item.setName(value);
            },
            'clip-path': function(item, value) {
                var clip = getDefinition(value);
                if (clip) {
                    clip = clip.clone();
                    clip.setClipMask(true);
                    if (item instanceof Group) item.insertChild(0, clip);
                    else return new Group(clip, item);
                }
            },
            gradientTransform: applyTransform,
            transform: applyTransform,
            'fill-opacity': applyOpacity,
            'stroke-opacity': applyOpacity,
            visibility: function(item, value) {
                if (item.setVisible) item.setVisible(value === 'visible');
            },
            display: function(item, value) {
                if (item.setVisible) item.setVisible(value !== null);
            },
            'stop-color': function(item, value) {
                if (item.setColor) item.setColor(value);
            },
            'stop-opacity': function(item, value) {
                if (item._color) item._color.setAlpha(parseFloat(value));
            },
            offset: function(item, value) {
                if (item.setOffset) {
                    var percent = value.match(/(.*)%$/);
                    item.setOffset(percent ? percent[1] / 100 : parseFloat(value));
                }
            },
            viewBox: function(item, value, name, node, styles) {
                var rect = new Rectangle(convertValue(value, 'array')), size = getSize(node, null, null, true), group, matrix;
                if (item instanceof Group) {
                    var scale = size ? size.divide(rect.getSize()) : 1, matrix = new Matrix().scale(scale).translate(rect.getPoint().negate());
                    group = item;
                } else if (item instanceof SymbolDefinition) {
                    if (size) rect.setSize(size);
                    group = item._item;
                }
                if (group) {
                    if (getAttribute(node, 'overflow', styles) !== 'visible') {
                        var clip = new Shape.Rectangle(rect);
                        clip.setClipMask(true);
                        group.addChild(clip);
                    }
                    if (matrix) group.transform(matrix);
                }
            }
        });
        function getAttribute(node, name, styles) {
            var attr = node.attributes[name], value = attr && attr.value;
            if (!value && node.style) {
                var style = Base.camelize(name);
                value = node.style[style];
                if (!value && styles.node[style] !== styles.parent[style]) value = styles.node[style];
            }
            return !value ? undefined : value === 'none' ? null : value;
        }
        function applyAttributes(item, node, isRoot) {
            var parent = node.parentNode, styles = {
                node: DomElement.getStyles(node) || {},
                parent: !isRoot && !/^defs$/i.test(parent.tagName) && DomElement.getStyles(parent) || {}
            };
            Base.each(attributes, function(apply, name) {
                var value = getAttribute(node, name, styles);
                item = value !== undefined && apply(item, value, name, node, styles) || item;
            });
            return item;
        }
        function getDefinition(value) {
            var match = value && value.match(/\((?:["'#]*)([^"')]+)/), name = match && match[1], res = name && definitions[window ? name.replace(window.location.href.split('#')[0] + '#', '') : name];
            if (res && res._scaleToBounds) {
                res = res.clone();
                res._scaleToBounds = true;
            }
            return res;
        }
        function importNode(node, options, isRoot) {
            var type = node.nodeName.toLowerCase(), isElement = type !== '#document', body = document.body, container, parent, next;
            if (isRoot && isElement) {
                rootSize = paper.getView().getSize();
                rootSize = getSize(node, null, null, true) || rootSize;
                container = SvgElement.create('svg', {
                    style: 'stroke-width: 1px; stroke-miterlimit: 10'
                });
                parent = node.parentNode;
                next = node.nextSibling;
                container.appendChild(node);
                body.appendChild(container);
            }
            var settings = paper.settings, applyMatrix = settings.applyMatrix, insertItems = settings.insertItems;
            settings.applyMatrix = false;
            settings.insertItems = false;
            var importer = importers[type], item = importer && importer(node, type, options, isRoot) || null;
            settings.insertItems = insertItems;
            settings.applyMatrix = applyMatrix;
            if (item) {
                if (isElement && !(item instanceof Group)) item = applyAttributes(item, node, isRoot);
                var onImport = options.onImport, data = isElement && node.getAttribute('data-paper-data');
                if (onImport) item = onImport(node, item, options) || item;
                if (options.expandShapes && item instanceof Shape) {
                    item.remove();
                    item = item.toPath();
                }
                if (data) item._data = JSON.parse(data);
            }
            if (container) {
                body.removeChild(container);
                if (parent) {
                    if (next) parent.insertBefore(node, next);
                    else parent.appendChild(node);
                }
            }
            if (isRoot) {
                definitions = {};
                if (item && Base.pick(options.applyMatrix, applyMatrix)) item.matrix.apply(true, true);
            }
            return item;
        }
        function importSVG(source, options, owner) {
            if (!source) return null;
            options = typeof options === 'function' ? {
                onLoad: options
            } : options || {};
            var scope = paper, item = null;
            function onLoad(svg) {
                try {
                    var node = typeof svg === 'object' ? svg : new self1.DOMParser().parseFromString(svg.trim(), 'image/svg+xml');
                    if (!node.nodeName) {
                        node = null;
                        throw new Error('Unsupported SVG source: ' + source);
                    }
                    paper = scope;
                    item = importNode(node, options, true);
                    if (!options || options.insert !== false) owner._insertItem(undefined, item);
                    var onLoad = options.onLoad;
                    if (onLoad) onLoad(item, svg);
                } catch (e) {
                    onError(e);
                }
            }
            function onError(message, status) {
                var onError = options.onError;
                if (onError) onError(message, status);
                else throw new Error(message);
            }
            if (typeof source === 'string' && !/^[\s\S]*</.test(source)) {
                var node = document.getElementById(source);
                if (node) onLoad(node);
                else Http.request({
                    url: source,
                    async: true,
                    onLoad: onLoad,
                    onError: onError
                });
            } else if (typeof File !== 'undefined' && source instanceof File) {
                var reader = new FileReader();
                reader.onload = function() {
                    onLoad(reader.result);
                };
                reader.onerror = function() {
                    onError(reader.error);
                };
                return reader.readAsText(source);
            } else onLoad(source);
            return item;
        }
        Item.inject({
            importSVG: function(node, options) {
                return importSVG(node, options, this);
            }
        });
        Project.inject({
            importSVG: function(node, options) {
                this.activate();
                return importSVG(node, options, this);
            }
        });
    };
    Base.exports.PaperScript = (function() {
        var global = this, acorn = global.acorn;
        if (!acorn && true) try {
            acorn = $5015bddb86ad6882$import$5f21f58ae769140f;
        } catch (e) {}
        if (!acorn) {
            var exports, module1;
            acorn = exports = module1 = {};
            (function(root, mod) {
                if (typeof exports == "object" && typeof module1 == "object") return mod(exports);
                if (typeof define == "function" && define.amd) return define([
                    "exports"
                ], mod);
                mod(root.acorn || (root.acorn = {}));
            })(this, function(exports) {
                "use strict";
                exports.version = "0.5.0";
                var options, input, inputLen, sourceFile;
                exports.parse = function(inpt, opts) {
                    input = String(inpt);
                    inputLen = input.length;
                    setOptions(opts);
                    initTokenState();
                    return parseTopLevel(options.program);
                };
                var defaultOptions = exports.defaultOptions = {
                    ecmaVersion: 5,
                    strictSemicolons: false,
                    allowTrailingCommas: true,
                    forbidReserved: false,
                    allowReturnOutsideFunction: false,
                    locations: false,
                    onComment: null,
                    ranges: false,
                    program: null,
                    sourceFile: null,
                    directSourceFile: null
                };
                function setOptions(opts) {
                    options = opts || {};
                    for(var opt in defaultOptions)if (!Object.prototype.hasOwnProperty.call(options, opt)) options[opt] = defaultOptions[opt];
                    sourceFile = options.sourceFile || null;
                }
                var getLineInfo = exports.getLineInfo = function(input, offset) {
                    for(var line = 1, cur = 0;;){
                        lineBreak.lastIndex = cur;
                        var match = lineBreak.exec(input);
                        if (match && match.index < offset) {
                            ++line;
                            cur = match.index + match[0].length;
                        } else break;
                    }
                    return {
                        line: line,
                        column: offset - cur
                    };
                };
                exports.tokenize = function(inpt, opts) {
                    input = String(inpt);
                    inputLen = input.length;
                    setOptions(opts);
                    initTokenState();
                    var t = {};
                    function getToken(forceRegexp) {
                        lastEnd = tokEnd;
                        readToken(forceRegexp);
                        t.start = tokStart;
                        t.end = tokEnd;
                        t.startLoc = tokStartLoc;
                        t.endLoc = tokEndLoc;
                        t.type = tokType;
                        t.value = tokVal;
                        return t;
                    }
                    getToken.jumpTo = function(pos, reAllowed) {
                        tokPos = pos;
                        if (options.locations) {
                            tokCurLine = 1;
                            tokLineStart = lineBreak.lastIndex = 0;
                            var match;
                            while((match = lineBreak.exec(input)) && match.index < pos){
                                ++tokCurLine;
                                tokLineStart = match.index + match[0].length;
                            }
                        }
                        tokRegexpAllowed = reAllowed;
                        skipSpace();
                    };
                    return getToken;
                };
                var tokPos;
                var tokStart, tokEnd;
                var tokStartLoc, tokEndLoc;
                var tokType, tokVal;
                var tokRegexpAllowed;
                var tokCurLine, tokLineStart;
                var lastStart, lastEnd, lastEndLoc;
                var inFunction, labels, strict;
                function raise(pos, message) {
                    var loc = getLineInfo(input, pos);
                    message += " (" + loc.line + ":" + loc.column + ")";
                    var err = new SyntaxError(message);
                    err.pos = pos;
                    err.loc = loc;
                    err.raisedAt = tokPos;
                    throw err;
                }
                var empty = [];
                var _num = {
                    type: "num"
                }, _regexp = {
                    type: "regexp"
                }, _string = {
                    type: "string"
                };
                var _name = {
                    type: "name"
                }, _eof = {
                    type: "eof"
                };
                var _break = {
                    keyword: "break"
                }, _case = {
                    keyword: "case",
                    beforeExpr: true
                }, _catch = {
                    keyword: "catch"
                };
                var _continue = {
                    keyword: "continue"
                }, _debugger = {
                    keyword: "debugger"
                }, _default = {
                    keyword: "default"
                };
                var _do = {
                    keyword: "do",
                    isLoop: true
                }, _else = {
                    keyword: "else",
                    beforeExpr: true
                };
                var _finally = {
                    keyword: "finally"
                }, _for = {
                    keyword: "for",
                    isLoop: true
                }, _function = {
                    keyword: "function"
                };
                var _if = {
                    keyword: "if"
                }, _return = {
                    keyword: "return",
                    beforeExpr: true
                }, _switch = {
                    keyword: "switch"
                };
                var _throw = {
                    keyword: "throw",
                    beforeExpr: true
                }, _try = {
                    keyword: "try"
                }, _var = {
                    keyword: "var"
                };
                var _while = {
                    keyword: "while",
                    isLoop: true
                }, _with = {
                    keyword: "with"
                }, _new = {
                    keyword: "new",
                    beforeExpr: true
                };
                var _this = {
                    keyword: "this"
                };
                var _null = {
                    keyword: "null",
                    atomValue: null
                }, _true = {
                    keyword: "true",
                    atomValue: true
                };
                var _false = {
                    keyword: "false",
                    atomValue: false
                };
                var _in = {
                    keyword: "in",
                    binop: 7,
                    beforeExpr: true
                };
                var keywordTypes = {
                    "break": _break,
                    "case": _case,
                    "catch": _catch,
                    "continue": _continue,
                    "debugger": _debugger,
                    "default": _default,
                    "do": _do,
                    "else": _else,
                    "finally": _finally,
                    "for": _for,
                    "function": _function,
                    "if": _if,
                    "return": _return,
                    "switch": _switch,
                    "throw": _throw,
                    "try": _try,
                    "var": _var,
                    "while": _while,
                    "with": _with,
                    "null": _null,
                    "true": _true,
                    "false": _false,
                    "new": _new,
                    "in": _in,
                    "instanceof": {
                        keyword: "instanceof",
                        binop: 7,
                        beforeExpr: true
                    },
                    "this": _this,
                    "typeof": {
                        keyword: "typeof",
                        prefix: true,
                        beforeExpr: true
                    },
                    "void": {
                        keyword: "void",
                        prefix: true,
                        beforeExpr: true
                    },
                    "delete": {
                        keyword: "delete",
                        prefix: true,
                        beforeExpr: true
                    }
                };
                var _bracketL = {
                    type: "[",
                    beforeExpr: true
                }, _bracketR = {
                    type: "]"
                }, _braceL = {
                    type: "{",
                    beforeExpr: true
                };
                var _braceR = {
                    type: "}"
                }, _parenL = {
                    type: "(",
                    beforeExpr: true
                }, _parenR = {
                    type: ")"
                };
                var _comma = {
                    type: ",",
                    beforeExpr: true
                }, _semi = {
                    type: ";",
                    beforeExpr: true
                };
                var _colon = {
                    type: ":",
                    beforeExpr: true
                }, _dot = {
                    type: "."
                }, _question = {
                    type: "?",
                    beforeExpr: true
                };
                var _slash = {
                    binop: 10,
                    beforeExpr: true
                }, _eq = {
                    isAssign: true,
                    beforeExpr: true
                };
                var _assign = {
                    isAssign: true,
                    beforeExpr: true
                };
                var _incDec = {
                    postfix: true,
                    prefix: true,
                    isUpdate: true
                }, _prefix = {
                    prefix: true,
                    beforeExpr: true
                };
                var _logicalOR = {
                    binop: 1,
                    beforeExpr: true
                };
                var _logicalAND = {
                    binop: 2,
                    beforeExpr: true
                };
                var _bitwiseOR = {
                    binop: 3,
                    beforeExpr: true
                };
                var _bitwiseXOR = {
                    binop: 4,
                    beforeExpr: true
                };
                var _bitwiseAND = {
                    binop: 5,
                    beforeExpr: true
                };
                var _equality = {
                    binop: 6,
                    beforeExpr: true
                };
                var _relational = {
                    binop: 7,
                    beforeExpr: true
                };
                var _bitShift = {
                    binop: 8,
                    beforeExpr: true
                };
                var _plusMin = {
                    binop: 9,
                    prefix: true,
                    beforeExpr: true
                };
                var _multiplyModulo = {
                    binop: 10,
                    beforeExpr: true
                };
                exports.tokTypes = {
                    bracketL: _bracketL,
                    bracketR: _bracketR,
                    braceL: _braceL,
                    braceR: _braceR,
                    parenL: _parenL,
                    parenR: _parenR,
                    comma: _comma,
                    semi: _semi,
                    colon: _colon,
                    dot: _dot,
                    question: _question,
                    slash: _slash,
                    eq: _eq,
                    name: _name,
                    eof: _eof,
                    num: _num,
                    regexp: _regexp,
                    string: _string
                };
                for(var kw in keywordTypes)exports.tokTypes["_" + kw] = keywordTypes[kw];
                function makePredicate(words) {
                    words = words.split(" ");
                    var f = "", cats = [];
                    out: for(var i = 0; i < words.length; ++i){
                        for(var j = 0; j < cats.length; ++j)if (cats[j][0].length == words[i].length) {
                            cats[j].push(words[i]);
                            continue out;
                        }
                        cats.push([
                            words[i]
                        ]);
                    }
                    function compareTo(arr) {
                        if (arr.length == 1) return f += "return str === " + JSON.stringify(arr[0]) + ";";
                        f += "switch(str){";
                        for(var i = 0; i < arr.length; ++i)f += "case " + JSON.stringify(arr[i]) + ":";
                        f += "return true}return false;";
                    }
                    if (cats.length > 3) {
                        cats.sort(function(a, b) {
                            return b.length - a.length;
                        });
                        f += "switch(str.length){";
                        for(var i = 0; i < cats.length; ++i){
                            var cat = cats[i];
                            f += "case " + cat[0].length + ":";
                            compareTo(cat);
                        }
                        f += "}";
                    } else compareTo(words);
                    return new Function("str", f);
                }
                var isReservedWord3 = makePredicate("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile");
                var isReservedWord5 = makePredicate("class enum extends super const export import");
                var isStrictReservedWord = makePredicate("implements interface let package private protected public static yield");
                var isStrictBadIdWord = makePredicate("eval arguments");
                var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this");
                var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
                var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
                var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
                var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
                var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
                var newline = /[\n\r\u2028\u2029]/;
                var lineBreak = /\r\n|[\n\r\u2028\u2029]/g;
                var isIdentifierStart = exports.isIdentifierStart = function(code) {
                    if (code < 65) return code === 36;
                    if (code < 91) return true;
                    if (code < 97) return code === 95;
                    if (code < 123) return true;
                    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
                };
                var isIdentifierChar = exports.isIdentifierChar = function(code) {
                    if (code < 48) return code === 36;
                    if (code < 58) return true;
                    if (code < 65) return false;
                    if (code < 91) return true;
                    if (code < 97) return code === 95;
                    if (code < 123) return true;
                    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
                };
                function line_loc_t() {
                    this.line = tokCurLine;
                    this.column = tokPos - tokLineStart;
                }
                function initTokenState() {
                    tokCurLine = 1;
                    tokPos = tokLineStart = 0;
                    tokRegexpAllowed = true;
                    skipSpace();
                }
                function finishToken(type, val) {
                    tokEnd = tokPos;
                    if (options.locations) tokEndLoc = new line_loc_t;
                    tokType = type;
                    skipSpace();
                    tokVal = val;
                    tokRegexpAllowed = type.beforeExpr;
                }
                function skipBlockComment() {
                    var startLoc = options.onComment && options.locations && new line_loc_t;
                    var start = tokPos, end = input.indexOf("*/", tokPos += 2);
                    if (end === -1) raise(tokPos - 2, "Unterminated comment");
                    tokPos = end + 2;
                    if (options.locations) {
                        lineBreak.lastIndex = start;
                        var match;
                        while((match = lineBreak.exec(input)) && match.index < tokPos){
                            ++tokCurLine;
                            tokLineStart = match.index + match[0].length;
                        }
                    }
                    if (options.onComment) options.onComment(true, input.slice(start + 2, end), start, tokPos, startLoc, options.locations && new line_loc_t);
                }
                function skipLineComment() {
                    var start = tokPos;
                    var startLoc = options.onComment && options.locations && new line_loc_t;
                    var ch = input.charCodeAt(tokPos += 2);
                    while(tokPos < inputLen && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233){
                        ++tokPos;
                        ch = input.charCodeAt(tokPos);
                    }
                    if (options.onComment) options.onComment(false, input.slice(start + 2, tokPos), start, tokPos, startLoc, options.locations && new line_loc_t);
                }
                function skipSpace() {
                    while(tokPos < inputLen){
                        var ch = input.charCodeAt(tokPos);
                        if (ch === 32) ++tokPos;
                        else if (ch === 13) {
                            ++tokPos;
                            var next = input.charCodeAt(tokPos);
                            if (next === 10) ++tokPos;
                            if (options.locations) {
                                ++tokCurLine;
                                tokLineStart = tokPos;
                            }
                        } else if (ch === 10 || ch === 8232 || ch === 8233) {
                            ++tokPos;
                            if (options.locations) {
                                ++tokCurLine;
                                tokLineStart = tokPos;
                            }
                        } else if (ch > 8 && ch < 14) ++tokPos;
                        else if (ch === 47) {
                            var next = input.charCodeAt(tokPos + 1);
                            if (next === 42) skipBlockComment();
                            else if (next === 47) skipLineComment();
                            else break;
                        } else if (ch === 160) ++tokPos;
                        else if (ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) ++tokPos;
                        else break;
                    }
                }
                function readToken_dot() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next >= 48 && next <= 57) return readNumber(true);
                    ++tokPos;
                    return finishToken(_dot);
                }
                function readToken_slash() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (tokRegexpAllowed) {
                        ++tokPos;
                        return readRegexp();
                    }
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_slash, 1);
                }
                function readToken_mult_modulo() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_multiplyModulo, 1);
                }
                function readToken_pipe_amp(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === code) return finishOp(code === 124 ? _logicalOR : _logicalAND, 2);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(code === 124 ? _bitwiseOR : _bitwiseAND, 1);
                }
                function readToken_caret() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_bitwiseXOR, 1);
                }
                function readToken_plus_min(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === code) {
                        if (next == 45 && input.charCodeAt(tokPos + 2) == 62 && newline.test(input.slice(lastEnd, tokPos))) {
                            tokPos += 3;
                            skipLineComment();
                            skipSpace();
                            return readToken();
                        }
                        return finishOp(_incDec, 2);
                    }
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_plusMin, 1);
                }
                function readToken_lt_gt(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    var size = 1;
                    if (next === code) {
                        size = code === 62 && input.charCodeAt(tokPos + 2) === 62 ? 3 : 2;
                        if (input.charCodeAt(tokPos + size) === 61) return finishOp(_assign, size + 1);
                        return finishOp(_bitShift, size);
                    }
                    if (next == 33 && code == 60 && input.charCodeAt(tokPos + 2) == 45 && input.charCodeAt(tokPos + 3) == 45) {
                        tokPos += 4;
                        skipLineComment();
                        skipSpace();
                        return readToken();
                    }
                    if (next === 61) size = input.charCodeAt(tokPos + 2) === 61 ? 3 : 2;
                    return finishOp(_relational, size);
                }
                function readToken_eq_excl(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_equality, input.charCodeAt(tokPos + 2) === 61 ? 3 : 2);
                    return finishOp(code === 61 ? _eq : _prefix, 1);
                }
                function getTokenFromCode(code) {
                    switch(code){
                        case 46:
                            return readToken_dot();
                        case 40:
                            ++tokPos;
                            return finishToken(_parenL);
                        case 41:
                            ++tokPos;
                            return finishToken(_parenR);
                        case 59:
                            ++tokPos;
                            return finishToken(_semi);
                        case 44:
                            ++tokPos;
                            return finishToken(_comma);
                        case 91:
                            ++tokPos;
                            return finishToken(_bracketL);
                        case 93:
                            ++tokPos;
                            return finishToken(_bracketR);
                        case 123:
                            ++tokPos;
                            return finishToken(_braceL);
                        case 125:
                            ++tokPos;
                            return finishToken(_braceR);
                        case 58:
                            ++tokPos;
                            return finishToken(_colon);
                        case 63:
                            ++tokPos;
                            return finishToken(_question);
                        case 48:
                            var next = input.charCodeAt(tokPos + 1);
                            if (next === 120 || next === 88) return readHexNumber();
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return readNumber(false);
                        case 34:
                        case 39:
                            return readString(code);
                        case 47:
                            return readToken_slash(code);
                        case 37:
                        case 42:
                            return readToken_mult_modulo();
                        case 124:
                        case 38:
                            return readToken_pipe_amp(code);
                        case 94:
                            return readToken_caret();
                        case 43:
                        case 45:
                            return readToken_plus_min(code);
                        case 60:
                        case 62:
                            return readToken_lt_gt(code);
                        case 61:
                        case 33:
                            return readToken_eq_excl(code);
                        case 126:
                            return finishOp(_prefix, 1);
                    }
                    return false;
                }
                function readToken(forceRegexp) {
                    if (!forceRegexp) tokStart = tokPos;
                    else tokPos = tokStart + 1;
                    if (options.locations) tokStartLoc = new line_loc_t;
                    if (forceRegexp) return readRegexp();
                    if (tokPos >= inputLen) return finishToken(_eof);
                    var code = input.charCodeAt(tokPos);
                    if (isIdentifierStart(code) || code === 92) return readWord();
                    var tok = getTokenFromCode(code);
                    if (tok === false) {
                        var ch = String.fromCharCode(code);
                        if (ch === "\\" || nonASCIIidentifierStart.test(ch)) return readWord();
                        raise(tokPos, "Unexpected character '" + ch + "'");
                    }
                    return tok;
                }
                function finishOp(type, size) {
                    var str = input.slice(tokPos, tokPos + size);
                    tokPos += size;
                    finishToken(type, str);
                }
                function readRegexp() {
                    var content = "", escaped, inClass, start = tokPos;
                    for(;;){
                        if (tokPos >= inputLen) raise(start, "Unterminated regular expression");
                        var ch = input.charAt(tokPos);
                        if (newline.test(ch)) raise(start, "Unterminated regular expression");
                        if (!escaped) {
                            if (ch === "[") inClass = true;
                            else if (ch === "]" && inClass) inClass = false;
                            else if (ch === "/" && !inClass) break;
                            escaped = ch === "\\";
                        } else escaped = false;
                        ++tokPos;
                    }
                    var content = input.slice(start, tokPos);
                    ++tokPos;
                    var mods = readWord1();
                    if (mods && !/^[gmsiy]*$/.test(mods)) raise(start, "Invalid regexp flag");
                    try {
                        var value = new RegExp(content, mods);
                    } catch (e) {
                        if (e instanceof SyntaxError) raise(start, e.message);
                        raise(e);
                    }
                    return finishToken(_regexp, value);
                }
                function readInt(radix, len) {
                    var start = tokPos, total = 0;
                    for(var i = 0, e = len == null ? Infinity : len; i < e; ++i){
                        var code = input.charCodeAt(tokPos), val;
                        if (code >= 97) val = code - 97 + 10;
                        else if (code >= 65) val = code - 65 + 10;
                        else if (code >= 48 && code <= 57) val = code - 48;
                        else val = Infinity;
                        if (val >= radix) break;
                        ++tokPos;
                        total = total * radix + val;
                    }
                    if (tokPos === start || len != null && tokPos - start !== len) return null;
                    return total;
                }
                function readHexNumber() {
                    tokPos += 2;
                    var val = readInt(16);
                    if (val == null) raise(tokStart + 2, "Expected hexadecimal number");
                    if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                    return finishToken(_num, val);
                }
                function readNumber(startsWithDot) {
                    var start = tokPos, isFloat = false, octal = input.charCodeAt(tokPos) === 48;
                    if (!startsWithDot && readInt(10) === null) raise(start, "Invalid number");
                    if (input.charCodeAt(tokPos) === 46) {
                        ++tokPos;
                        readInt(10);
                        isFloat = true;
                    }
                    var next = input.charCodeAt(tokPos);
                    if (next === 69 || next === 101) {
                        next = input.charCodeAt(++tokPos);
                        if (next === 43 || next === 45) ++tokPos;
                        if (readInt(10) === null) raise(start, "Invalid number");
                        isFloat = true;
                    }
                    if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                    var str = input.slice(start, tokPos), val;
                    if (isFloat) val = parseFloat(str);
                    else if (!octal || str.length === 1) val = parseInt(str, 10);
                    else if (/[89]/.test(str) || strict) raise(start, "Invalid number");
                    else val = parseInt(str, 8);
                    return finishToken(_num, val);
                }
                function readString(quote) {
                    tokPos++;
                    var out = "";
                    for(;;){
                        if (tokPos >= inputLen) raise(tokStart, "Unterminated string constant");
                        var ch = input.charCodeAt(tokPos);
                        if (ch === quote) {
                            ++tokPos;
                            return finishToken(_string, out);
                        }
                        if (ch === 92) {
                            ch = input.charCodeAt(++tokPos);
                            var octal = /^[0-7]+/.exec(input.slice(tokPos, tokPos + 3));
                            if (octal) octal = octal[0];
                            while(octal && parseInt(octal, 8) > 255)octal = octal.slice(0, -1);
                            if (octal === "0") octal = null;
                            ++tokPos;
                            if (octal) {
                                if (strict) raise(tokPos - 2, "Octal literal in strict mode");
                                out += String.fromCharCode(parseInt(octal, 8));
                                tokPos += octal.length - 1;
                            } else switch(ch){
                                case 110:
                                    out += "\n";
                                    break;
                                case 114:
                                    out += "\r";
                                    break;
                                case 120:
                                    out += String.fromCharCode(readHexChar(2));
                                    break;
                                case 117:
                                    out += String.fromCharCode(readHexChar(4));
                                    break;
                                case 85:
                                    out += String.fromCharCode(readHexChar(8));
                                    break;
                                case 116:
                                    out += "\t";
                                    break;
                                case 98:
                                    out += "\b";
                                    break;
                                case 118:
                                    out += "\u000b";
                                    break;
                                case 102:
                                    out += "\f";
                                    break;
                                case 48:
                                    out += "\0";
                                    break;
                                case 13:
                                    if (input.charCodeAt(tokPos) === 10) ++tokPos;
                                case 10:
                                    if (options.locations) {
                                        tokLineStart = tokPos;
                                        ++tokCurLine;
                                    }
                                    break;
                                default:
                                    out += String.fromCharCode(ch);
                                    break;
                            }
                        } else {
                            if (ch === 13 || ch === 10 || ch === 8232 || ch === 8233) raise(tokStart, "Unterminated string constant");
                            out += String.fromCharCode(ch);
                            ++tokPos;
                        }
                    }
                }
                function readHexChar(len) {
                    var n = readInt(16, len);
                    if (n === null) raise(tokStart, "Bad character escape sequence");
                    return n;
                }
                var containsEsc;
                function readWord1() {
                    containsEsc = false;
                    var word, first = true, start = tokPos;
                    for(;;){
                        var ch = input.charCodeAt(tokPos);
                        if (isIdentifierChar(ch)) {
                            if (containsEsc) word += input.charAt(tokPos);
                            ++tokPos;
                        } else if (ch === 92) {
                            if (!containsEsc) word = input.slice(start, tokPos);
                            containsEsc = true;
                            if (input.charCodeAt(++tokPos) != 117) raise(tokPos, "Expecting Unicode escape sequence \\uXXXX");
                            ++tokPos;
                            var esc = readHexChar(4);
                            var escStr = String.fromCharCode(esc);
                            if (!escStr) raise(tokPos - 1, "Invalid Unicode escape");
                            if (!(first ? isIdentifierStart(esc) : isIdentifierChar(esc))) raise(tokPos - 4, "Invalid Unicode escape");
                            word += escStr;
                        } else break;
                        first = false;
                    }
                    return containsEsc ? word : input.slice(start, tokPos);
                }
                function readWord() {
                    var word = readWord1();
                    var type = _name;
                    if (!containsEsc && isKeyword(word)) type = keywordTypes[word];
                    return finishToken(type, word);
                }
                function next() {
                    lastStart = tokStart;
                    lastEnd = tokEnd;
                    lastEndLoc = tokEndLoc;
                    readToken();
                }
                function setStrict(strct) {
                    strict = strct;
                    tokPos = tokStart;
                    if (options.locations) while(tokPos < tokLineStart){
                        tokLineStart = input.lastIndexOf("\n", tokLineStart - 2) + 1;
                        --tokCurLine;
                    }
                    skipSpace();
                    readToken();
                }
                function node_t() {
                    this.type = null;
                    this.start = tokStart;
                    this.end = null;
                }
                function node_loc_t() {
                    this.start = tokStartLoc;
                    this.end = null;
                    if (sourceFile !== null) this.source = sourceFile;
                }
                function startNode() {
                    var node = new node_t();
                    if (options.locations) node.loc = new node_loc_t();
                    if (options.directSourceFile) node.sourceFile = options.directSourceFile;
                    if (options.ranges) node.range = [
                        tokStart,
                        0
                    ];
                    return node;
                }
                function startNodeFrom(other) {
                    var node = new node_t();
                    node.start = other.start;
                    if (options.locations) {
                        node.loc = new node_loc_t();
                        node.loc.start = other.loc.start;
                    }
                    if (options.ranges) node.range = [
                        other.range[0],
                        0
                    ];
                    return node;
                }
                function finishNode(node, type) {
                    node.type = type;
                    node.end = lastEnd;
                    if (options.locations) node.loc.end = lastEndLoc;
                    if (options.ranges) node.range[1] = lastEnd;
                    return node;
                }
                function isUseStrict(stmt) {
                    return options.ecmaVersion >= 5 && stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && stmt.expression.value === "use strict";
                }
                function eat(type) {
                    if (tokType === type) {
                        next();
                        return true;
                    }
                }
                function canInsertSemicolon() {
                    return !options.strictSemicolons && (tokType === _eof || tokType === _braceR || newline.test(input.slice(lastEnd, tokStart)));
                }
                function semicolon() {
                    if (!eat(_semi) && !canInsertSemicolon()) unexpected();
                }
                function expect(type) {
                    if (tokType === type) next();
                    else unexpected();
                }
                function unexpected() {
                    raise(tokStart, "Unexpected token");
                }
                function checkLVal(expr) {
                    if (expr.type !== "Identifier" && expr.type !== "MemberExpression") raise(expr.start, "Assigning to rvalue");
                    if (strict && expr.type === "Identifier" && isStrictBadIdWord(expr.name)) raise(expr.start, "Assigning to " + expr.name + " in strict mode");
                }
                function parseTopLevel(program) {
                    lastStart = lastEnd = tokPos;
                    if (options.locations) lastEndLoc = new line_loc_t;
                    inFunction = strict = null;
                    labels = [];
                    readToken();
                    var node = program || startNode(), first = true;
                    if (!program) node.body = [];
                    while(tokType !== _eof){
                        var stmt = parseStatement();
                        node.body.push(stmt);
                        if (first && isUseStrict(stmt)) setStrict(true);
                        first = false;
                    }
                    return finishNode(node, "Program");
                }
                var loopLabel = {
                    kind: "loop"
                }, switchLabel = {
                    kind: "switch"
                };
                function parseStatement() {
                    if (tokType === _slash || tokType === _assign && tokVal == "/=") readToken(true);
                    var starttype = tokType, node = startNode();
                    switch(starttype){
                        case _break:
                        case _continue:
                            next();
                            var isBreak = starttype === _break;
                            if (eat(_semi) || canInsertSemicolon()) node.label = null;
                            else if (tokType !== _name) unexpected();
                            else {
                                node.label = parseIdent();
                                semicolon();
                            }
                            for(var i = 0; i < labels.length; ++i){
                                var lab = labels[i];
                                if (node.label == null || lab.name === node.label.name) {
                                    if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
                                    if (node.label && isBreak) break;
                                }
                            }
                            if (i === labels.length) raise(node.start, "Unsyntactic " + starttype.keyword);
                            return finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
                        case _debugger:
                            next();
                            semicolon();
                            return finishNode(node, "DebuggerStatement");
                        case _do:
                            next();
                            labels.push(loopLabel);
                            node.body = parseStatement();
                            labels.pop();
                            expect(_while);
                            node.test = parseParenExpression();
                            semicolon();
                            return finishNode(node, "DoWhileStatement");
                        case _for:
                            next();
                            labels.push(loopLabel);
                            expect(_parenL);
                            if (tokType === _semi) return parseFor(node, null);
                            if (tokType === _var) {
                                var init = startNode();
                                next();
                                parseVar(init, true);
                                finishNode(init, "VariableDeclaration");
                                if (init.declarations.length === 1 && eat(_in)) return parseForIn(node, init);
                                return parseFor(node, init);
                            }
                            var init = parseExpression(false, true);
                            if (eat(_in)) {
                                checkLVal(init);
                                return parseForIn(node, init);
                            }
                            return parseFor(node, init);
                        case _function:
                            next();
                            return parseFunction(node, true);
                        case _if:
                            next();
                            node.test = parseParenExpression();
                            node.consequent = parseStatement();
                            node.alternate = eat(_else) ? parseStatement() : null;
                            return finishNode(node, "IfStatement");
                        case _return:
                            if (!inFunction && !options.allowReturnOutsideFunction) raise(tokStart, "'return' outside of function");
                            next();
                            if (eat(_semi) || canInsertSemicolon()) node.argument = null;
                            else {
                                node.argument = parseExpression();
                                semicolon();
                            }
                            return finishNode(node, "ReturnStatement");
                        case _switch:
                            next();
                            node.discriminant = parseParenExpression();
                            node.cases = [];
                            expect(_braceL);
                            labels.push(switchLabel);
                            for(var cur, sawDefault; tokType != _braceR;)if (tokType === _case || tokType === _default) {
                                var isCase = tokType === _case;
                                if (cur) finishNode(cur, "SwitchCase");
                                node.cases.push(cur = startNode());
                                cur.consequent = [];
                                next();
                                if (isCase) cur.test = parseExpression();
                                else {
                                    if (sawDefault) raise(lastStart, "Multiple default clauses");
                                    sawDefault = true;
                                    cur.test = null;
                                }
                                expect(_colon);
                            } else {
                                if (!cur) unexpected();
                                cur.consequent.push(parseStatement());
                            }
                            if (cur) finishNode(cur, "SwitchCase");
                            next();
                            labels.pop();
                            return finishNode(node, "SwitchStatement");
                        case _throw:
                            next();
                            if (newline.test(input.slice(lastEnd, tokStart))) raise(lastEnd, "Illegal newline after throw");
                            node.argument = parseExpression();
                            semicolon();
                            return finishNode(node, "ThrowStatement");
                        case _try:
                            next();
                            node.block = parseBlock();
                            node.handler = null;
                            if (tokType === _catch) {
                                var clause = startNode();
                                next();
                                expect(_parenL);
                                clause.param = parseIdent();
                                if (strict && isStrictBadIdWord(clause.param.name)) raise(clause.param.start, "Binding " + clause.param.name + " in strict mode");
                                expect(_parenR);
                                clause.guard = null;
                                clause.body = parseBlock();
                                node.handler = finishNode(clause, "CatchClause");
                            }
                            node.guardedHandlers = empty;
                            node.finalizer = eat(_finally) ? parseBlock() : null;
                            if (!node.handler && !node.finalizer) raise(node.start, "Missing catch or finally clause");
                            return finishNode(node, "TryStatement");
                        case _var:
                            next();
                            parseVar(node);
                            semicolon();
                            return finishNode(node, "VariableDeclaration");
                        case _while:
                            next();
                            node.test = parseParenExpression();
                            labels.push(loopLabel);
                            node.body = parseStatement();
                            labels.pop();
                            return finishNode(node, "WhileStatement");
                        case _with:
                            if (strict) raise(tokStart, "'with' in strict mode");
                            next();
                            node.object = parseParenExpression();
                            node.body = parseStatement();
                            return finishNode(node, "WithStatement");
                        case _braceL:
                            return parseBlock();
                        case _semi:
                            next();
                            return finishNode(node, "EmptyStatement");
                        default:
                            var maybeName = tokVal, expr = parseExpression();
                            if (starttype === _name && expr.type === "Identifier" && eat(_colon)) {
                                for(var i = 0; i < labels.length; ++i)if (labels[i].name === maybeName) raise(expr.start, "Label '" + maybeName + "' is already declared");
                                var kind = tokType.isLoop ? "loop" : tokType === _switch ? "switch" : null;
                                labels.push({
                                    name: maybeName,
                                    kind: kind
                                });
                                node.body = parseStatement();
                                labels.pop();
                                node.label = expr;
                                return finishNode(node, "LabeledStatement");
                            } else {
                                node.expression = expr;
                                semicolon();
                                return finishNode(node, "ExpressionStatement");
                            }
                    }
                }
                function parseParenExpression() {
                    expect(_parenL);
                    var val = parseExpression();
                    expect(_parenR);
                    return val;
                }
                function parseBlock(allowStrict) {
                    var node = startNode(), first = true, strict = false, oldStrict;
                    node.body = [];
                    expect(_braceL);
                    while(!eat(_braceR)){
                        var stmt = parseStatement();
                        node.body.push(stmt);
                        if (first && allowStrict && isUseStrict(stmt)) {
                            oldStrict = strict;
                            setStrict(strict = true);
                        }
                        first = false;
                    }
                    if (strict && !oldStrict) setStrict(false);
                    return finishNode(node, "BlockStatement");
                }
                function parseFor(node, init) {
                    node.init = init;
                    expect(_semi);
                    node.test = tokType === _semi ? null : parseExpression();
                    expect(_semi);
                    node.update = tokType === _parenR ? null : parseExpression();
                    expect(_parenR);
                    node.body = parseStatement();
                    labels.pop();
                    return finishNode(node, "ForStatement");
                }
                function parseForIn(node, init) {
                    node.left = init;
                    node.right = parseExpression();
                    expect(_parenR);
                    node.body = parseStatement();
                    labels.pop();
                    return finishNode(node, "ForInStatement");
                }
                function parseVar(node, noIn) {
                    node.declarations = [];
                    node.kind = "var";
                    for(;;){
                        var decl = startNode();
                        decl.id = parseIdent();
                        if (strict && isStrictBadIdWord(decl.id.name)) raise(decl.id.start, "Binding " + decl.id.name + " in strict mode");
                        decl.init = eat(_eq) ? parseExpression(true, noIn) : null;
                        node.declarations.push(finishNode(decl, "VariableDeclarator"));
                        if (!eat(_comma)) break;
                    }
                    return node;
                }
                function parseExpression(noComma, noIn) {
                    var expr = parseMaybeAssign(noIn);
                    if (!noComma && tokType === _comma) {
                        var node = startNodeFrom(expr);
                        node.expressions = [
                            expr
                        ];
                        while(eat(_comma))node.expressions.push(parseMaybeAssign(noIn));
                        return finishNode(node, "SequenceExpression");
                    }
                    return expr;
                }
                function parseMaybeAssign(noIn) {
                    var left = parseMaybeConditional(noIn);
                    if (tokType.isAssign) {
                        var node = startNodeFrom(left);
                        node.operator = tokVal;
                        node.left = left;
                        next();
                        node.right = parseMaybeAssign(noIn);
                        checkLVal(left);
                        return finishNode(node, "AssignmentExpression");
                    }
                    return left;
                }
                function parseMaybeConditional(noIn) {
                    var expr = parseExprOps(noIn);
                    if (eat(_question)) {
                        var node = startNodeFrom(expr);
                        node.test = expr;
                        node.consequent = parseExpression(true);
                        expect(_colon);
                        node.alternate = parseExpression(true, noIn);
                        return finishNode(node, "ConditionalExpression");
                    }
                    return expr;
                }
                function parseExprOps(noIn) {
                    return parseExprOp(parseMaybeUnary(), -1, noIn);
                }
                function parseExprOp(left, minPrec, noIn) {
                    var prec = tokType.binop;
                    if (prec != null && (!noIn || tokType !== _in)) {
                        if (prec > minPrec) {
                            var node = startNodeFrom(left);
                            node.left = left;
                            node.operator = tokVal;
                            var op = tokType;
                            next();
                            node.right = parseExprOp(parseMaybeUnary(), prec, noIn);
                            var exprNode = finishNode(node, op === _logicalOR || op === _logicalAND ? "LogicalExpression" : "BinaryExpression");
                            return parseExprOp(exprNode, minPrec, noIn);
                        }
                    }
                    return left;
                }
                function parseMaybeUnary() {
                    if (tokType.prefix) {
                        var node = startNode(), update = tokType.isUpdate;
                        node.operator = tokVal;
                        node.prefix = true;
                        tokRegexpAllowed = true;
                        next();
                        node.argument = parseMaybeUnary();
                        if (update) checkLVal(node.argument);
                        else if (strict && node.operator === "delete" && node.argument.type === "Identifier") raise(node.start, "Deleting local variable in strict mode");
                        return finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
                    }
                    var expr = parseExprSubscripts();
                    while(tokType.postfix && !canInsertSemicolon()){
                        var node = startNodeFrom(expr);
                        node.operator = tokVal;
                        node.prefix = false;
                        node.argument = expr;
                        checkLVal(expr);
                        next();
                        expr = finishNode(node, "UpdateExpression");
                    }
                    return expr;
                }
                function parseExprSubscripts() {
                    return parseSubscripts(parseExprAtom());
                }
                function parseSubscripts(base, noCalls) {
                    if (eat(_dot)) {
                        var node = startNodeFrom(base);
                        node.object = base;
                        node.property = parseIdent(true);
                        node.computed = false;
                        return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                    } else if (eat(_bracketL)) {
                        var node = startNodeFrom(base);
                        node.object = base;
                        node.property = parseExpression();
                        node.computed = true;
                        expect(_bracketR);
                        return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                    } else if (!noCalls && eat(_parenL)) {
                        var node = startNodeFrom(base);
                        node.callee = base;
                        node.arguments = parseExprList(_parenR, false);
                        return parseSubscripts(finishNode(node, "CallExpression"), noCalls);
                    } else return base;
                }
                function parseExprAtom() {
                    switch(tokType){
                        case _this:
                            var node = startNode();
                            next();
                            return finishNode(node, "ThisExpression");
                        case _name:
                            return parseIdent();
                        case _num:
                        case _string:
                        case _regexp:
                            var node = startNode();
                            node.value = tokVal;
                            node.raw = input.slice(tokStart, tokEnd);
                            next();
                            return finishNode(node, "Literal");
                        case _null:
                        case _true:
                        case _false:
                            var node = startNode();
                            node.value = tokType.atomValue;
                            node.raw = tokType.keyword;
                            next();
                            return finishNode(node, "Literal");
                        case _parenL:
                            var tokStartLoc1 = tokStartLoc, tokStart1 = tokStart;
                            next();
                            var val = parseExpression();
                            val.start = tokStart1;
                            val.end = tokEnd;
                            if (options.locations) {
                                val.loc.start = tokStartLoc1;
                                val.loc.end = tokEndLoc;
                            }
                            if (options.ranges) val.range = [
                                tokStart1,
                                tokEnd
                            ];
                            expect(_parenR);
                            return val;
                        case _bracketL:
                            var node = startNode();
                            next();
                            node.elements = parseExprList(_bracketR, true, true);
                            return finishNode(node, "ArrayExpression");
                        case _braceL:
                            return parseObj();
                        case _function:
                            var node = startNode();
                            next();
                            return parseFunction(node, false);
                        case _new:
                            return parseNew();
                        default:
                            unexpected();
                    }
                }
                function parseNew() {
                    var node = startNode();
                    next();
                    node.callee = parseSubscripts(parseExprAtom(), true);
                    if (eat(_parenL)) node.arguments = parseExprList(_parenR, false);
                    else node.arguments = empty;
                    return finishNode(node, "NewExpression");
                }
                function parseObj() {
                    var node = startNode(), first = true, sawGetSet = false;
                    node.properties = [];
                    next();
                    while(!eat(_braceR)){
                        if (!first) {
                            expect(_comma);
                            if (options.allowTrailingCommas && eat(_braceR)) break;
                        } else first = false;
                        var prop = {
                            key: parsePropertyName()
                        }, isGetSet = false, kind;
                        if (eat(_colon)) {
                            prop.value = parseExpression(true);
                            kind = prop.kind = "init";
                        } else if (options.ecmaVersion >= 5 && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set")) {
                            isGetSet = sawGetSet = true;
                            kind = prop.kind = prop.key.name;
                            prop.key = parsePropertyName();
                            if (tokType !== _parenL) unexpected();
                            prop.value = parseFunction(startNode(), false);
                        } else unexpected();
                        if (prop.key.type === "Identifier" && (strict || sawGetSet)) for(var i = 0; i < node.properties.length; ++i){
                            var other = node.properties[i];
                            if (other.key.name === prop.key.name) {
                                var conflict = kind == other.kind || isGetSet && other.kind === "init" || kind === "init" && (other.kind === "get" || other.kind === "set");
                                if (conflict && !strict && kind === "init" && other.kind === "init") conflict = false;
                                if (conflict) raise(prop.key.start, "Redefinition of property");
                            }
                        }
                        node.properties.push(prop);
                    }
                    return finishNode(node, "ObjectExpression");
                }
                function parsePropertyName() {
                    if (tokType === _num || tokType === _string) return parseExprAtom();
                    return parseIdent(true);
                }
                function parseFunction(node, isStatement) {
                    if (tokType === _name) node.id = parseIdent();
                    else if (isStatement) unexpected();
                    else node.id = null;
                    node.params = [];
                    var first = true;
                    expect(_parenL);
                    while(!eat(_parenR)){
                        if (!first) expect(_comma);
                        else first = false;
                        node.params.push(parseIdent());
                    }
                    var oldInFunc = inFunction, oldLabels = labels;
                    inFunction = true;
                    labels = [];
                    node.body = parseBlock(true);
                    inFunction = oldInFunc;
                    labels = oldLabels;
                    if (strict || node.body.body.length && isUseStrict(node.body.body[0])) for(var i = node.id ? -1 : 0; i < node.params.length; ++i){
                        var id = i < 0 ? node.id : node.params[i];
                        if (isStrictReservedWord(id.name) || isStrictBadIdWord(id.name)) raise(id.start, "Defining '" + id.name + "' in strict mode");
                        if (i >= 0) {
                            for(var j = 0; j < i; ++j)if (id.name === node.params[j].name) raise(id.start, "Argument name clash in strict mode");
                        }
                    }
                    return finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
                }
                function parseExprList(close, allowTrailingComma, allowEmpty) {
                    var elts = [], first = true;
                    while(!eat(close)){
                        if (!first) {
                            expect(_comma);
                            if (allowTrailingComma && options.allowTrailingCommas && eat(close)) break;
                        } else first = false;
                        if (allowEmpty && tokType === _comma) elts.push(null);
                        else elts.push(parseExpression(true));
                    }
                    return elts;
                }
                function parseIdent(liberal) {
                    var node = startNode();
                    if (liberal && options.forbidReserved == "everywhere") liberal = false;
                    if (tokType === _name) {
                        if (!liberal && (options.forbidReserved && (options.ecmaVersion === 3 ? isReservedWord3 : isReservedWord5)(tokVal) || strict && isStrictReservedWord(tokVal)) && input.slice(tokStart, tokEnd).indexOf("\\") == -1) raise(tokStart, "The keyword '" + tokVal + "' is reserved");
                        node.name = tokVal;
                    } else if (liberal && tokType.keyword) node.name = tokType.keyword;
                    else unexpected();
                    tokRegexpAllowed = false;
                    next();
                    return finishNode(node, "Identifier");
                }
            });
            if (!acorn.version) acorn = null;
        }
        function parse(code, options) {
            return (global.acorn || acorn).parse(code, options);
        }
        var binaryOperators = {
            '+': '__add',
            '-': '__subtract',
            '*': '__multiply',
            '/': '__divide',
            '%': '__modulo',
            '==': '__equals',
            '!=': '__equals'
        };
        var unaryOperators = {
            '-': '__negate',
            '+': '__self'
        };
        var fields = Base.each([
            'add',
            'subtract',
            'multiply',
            'divide',
            'modulo',
            'equals',
            'negate'
        ], function(name) {
            this['__' + name] = '#' + name;
        }, {
            __self: function() {
                return this;
            }
        });
        Point.inject(fields);
        Size.inject(fields);
        Color.inject(fields);
        function __$__(left, operator, right) {
            var handler = binaryOperators[operator];
            if (left && left[handler]) {
                var res = left[handler](right);
                return operator === '!=' ? !res : res;
            }
            switch(operator){
                case '+':
                    return left + right;
                case '-':
                    return left - right;
                case '*':
                    return left * right;
                case '/':
                    return left / right;
                case '%':
                    return left % right;
                case '==':
                    return left == right;
                case '!=':
                    return left != right;
            }
        }
        function $__(operator, value) {
            var handler = unaryOperators[operator];
            if (value && value[handler]) return value[handler]();
            switch(operator){
                case '+':
                    return +value;
                case '-':
                    return -value;
            }
        }
        function compile(code, options) {
            if (!code) return '';
            options = options || {};
            var insertions = [];
            function getOffset(offset) {
                for(var i = 0, l = insertions.length; i < l; i++){
                    var insertion = insertions[i];
                    if (insertion[0] >= offset) break;
                    offset += insertion[1];
                }
                return offset;
            }
            function getCode(node) {
                return code.substring(getOffset(node.range[0]), getOffset(node.range[1]));
            }
            function getBetween(left, right) {
                return code.substring(getOffset(left.range[1]), getOffset(right.range[0]));
            }
            function replaceCode(node, str) {
                var start = getOffset(node.range[0]), end = getOffset(node.range[1]), insert = 0;
                for(var i = insertions.length - 1; i >= 0; i--)if (start > insertions[i][0]) {
                    insert = i + 1;
                    break;
                }
                insertions.splice(insert, 0, [
                    start,
                    str.length - end + start
                ]);
                code = code.substring(0, start) + str + code.substring(end);
            }
            function handleOverloading(node, parent) {
                switch(node.type){
                    case 'UnaryExpression':
                        if (node.operator in unaryOperators && node.argument.type !== 'Literal') {
                            var arg = getCode(node.argument);
                            replaceCode(node, '$__("' + node.operator + '", ' + arg + ')');
                        }
                        break;
                    case 'BinaryExpression':
                        if (node.operator in binaryOperators && node.left.type !== 'Literal') {
                            var left = getCode(node.left), right = getCode(node.right), between = getBetween(node.left, node.right), operator = node.operator;
                            replaceCode(node, '__$__(' + left + ',' + between.replace(new RegExp('\\' + operator), '"' + operator + '"') + ', ' + right + ')');
                        }
                        break;
                    case 'UpdateExpression':
                    case 'AssignmentExpression':
                        var parentType = parent && parent.type;
                        if (!(parentType === 'ForStatement' || parentType === 'BinaryExpression' && /^[=!<>]/.test(parent.operator) || parentType === 'MemberExpression' && parent.computed)) {
                            if (node.type === 'UpdateExpression') {
                                var arg = getCode(node.argument), exp = '__$__(' + arg + ', "' + node.operator[0] + '", 1)', str = arg + ' = ' + exp;
                                if (node.prefix) str = '(' + str + ')';
                                else if (parentType === 'AssignmentExpression' || parentType === 'VariableDeclarator' || parentType === 'BinaryExpression') {
                                    if (getCode(parent.left || parent.id) === arg) str = exp;
                                    str = arg + '; ' + str;
                                }
                                replaceCode(node, str);
                            } else if (/^.=$/.test(node.operator) && node.left.type !== 'Literal') {
                                var left = getCode(node.left), right = getCode(node.right), exp = left + ' = __$__(' + left + ', "' + node.operator[0] + '", ' + right + ')';
                                replaceCode(node, /^\(.*\)$/.test(getCode(node)) ? '(' + exp + ')' : exp);
                            }
                        }
                        break;
                }
            }
            function handleExports(node) {
                switch(node.type){
                    case 'ExportDefaultDeclaration':
                        replaceCode({
                            range: [
                                node.start,
                                node.declaration.start
                            ]
                        }, 'module.exports = ');
                        break;
                    case 'ExportNamedDeclaration':
                        var declaration = node.declaration;
                        var specifiers = node.specifiers;
                        if (declaration) {
                            var declarations = declaration.declarations;
                            if (declarations) {
                                declarations.forEach(function(dec) {
                                    replaceCode(dec, 'module.exports.' + getCode(dec));
                                });
                                replaceCode({
                                    range: [
                                        node.start,
                                        declaration.start + declaration.kind.length
                                    ]
                                }, '');
                            }
                        } else if (specifiers) {
                            var exports = specifiers.map(function(specifier) {
                                var name = getCode(specifier);
                                return 'module.exports.' + name + ' = ' + name + '; ';
                            }).join('');
                            if (exports) replaceCode(node, exports);
                        }
                        break;
                }
            }
            function walkAST(node, parent, paperFeatures) {
                if (node) {
                    for(var key in node)if (key !== 'range' && key !== 'loc') {
                        var value = node[key];
                        if (Array.isArray(value)) for(var i = 0, l = value.length; i < l; i++)walkAST(value[i], node, paperFeatures);
                        else if (value && typeof value === 'object') walkAST(value, node, paperFeatures);
                    }
                    if (paperFeatures.operatorOverloading !== false) handleOverloading(node, parent);
                    if (paperFeatures.moduleExports !== false) handleExports(node);
                }
            }
            function encodeVLQ(value) {
                var res = '', base64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                value = (Math.abs(value) << 1) + (value < 0 ? 1 : 0);
                while(value || !res){
                    var next = value & 31;
                    value >>= 5;
                    if (value) next |= 32;
                    res += base64[next];
                }
                return res;
            }
            var url = options.url || '', sourceMaps = options.sourceMaps, paperFeatures = options.paperFeatures || {}, source = options.source || code, offset = options.offset || 0, agent = paper.agent, version = agent.versionNumber, offsetCode = false, lineBreaks = /\r\n|\n|\r/mg, map;
            if (sourceMaps && (agent.chrome && version >= 30 || agent.webkit && version >= 537.76 || agent.firefox && version >= 23 || agent.node)) {
                if (agent.node) offset -= 2;
                else if (window && url && !window.location.href.indexOf(url)) {
                    var html = document.getElementsByTagName('html')[0].innerHTML;
                    offset = html.substr(0, html.indexOf(code) + 1).match(lineBreaks).length + 1;
                }
                offsetCode = offset > 0 && !(agent.chrome && version >= 36 || agent.safari && version >= 600 || agent.firefox && version >= 40 || agent.node);
                var mappings = [
                    'AA' + encodeVLQ(offsetCode ? 0 : offset) + 'A'
                ];
                mappings.length = (code.match(lineBreaks) || []).length + 1 + (offsetCode ? offset : 0);
                map = {
                    version: 3,
                    file: url,
                    names: [],
                    mappings: mappings.join(';AACA'),
                    sourceRoot: '',
                    sources: [
                        url
                    ],
                    sourcesContent: [
                        source
                    ]
                };
            }
            if (paperFeatures.operatorOverloading !== false || paperFeatures.moduleExports !== false) walkAST(parse(code, {
                ranges: true,
                preserveParens: true,
                sourceType: 'module'
            }), null, paperFeatures);
            if (map) {
                if (offsetCode) code = new Array(offset + 1).join('\n') + code;
                if (/^(inline|both)$/.test(sourceMaps)) code += "\n//# sourceMappingURL=data:application/json;base64," + self1.btoa(unescape(encodeURIComponent(JSON.stringify(map))));
                code += "\n//# sourceURL=" + (url || 'paperscript');
            }
            return {
                url: url,
                source: source,
                code: code,
                map: map
            };
        }
        function execute(code, scope, options) {
            paper = scope;
            var view = scope.getView(), tool = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(code) && !/\bnew\s+Tool\b/.test(code) ? new Tool() : null, toolHandlers = tool ? tool._events : [], handlers = [
                'onFrame',
                'onResize'
            ].concat(toolHandlers), params = [], args = [], func, compiled = typeof code === 'object' ? code : compile(code, options);
            code = compiled.code;
            function expose(scope, hidden) {
                for(var key in scope)if ((hidden || !/^_/.test(key)) && new RegExp('([\\b\\s\\W]|^)' + key.replace(/\$/g, '\\$') + '\\b').test(code)) {
                    params.push(key);
                    args.push(scope[key]);
                }
            }
            expose({
                __$__: __$__,
                $__: $__,
                paper: scope,
                tool: tool
            }, true);
            expose(scope);
            code = 'var module = { exports: {} }; ' + code;
            var exports = Base.each(handlers, function(key) {
                if (new RegExp('\\s+' + key + '\\b').test(code)) {
                    params.push(key);
                    this.push('module.exports.' + key + ' = ' + key + ';');
                }
            }, []).join('\n');
            if (exports) code += '\n' + exports;
            code += '\nreturn module.exports;';
            var agent = paper.agent;
            if (document && (agent.chrome || agent.firefox && agent.versionNumber < 40)) {
                var script = document.createElement('script'), head = document.head || document.getElementsByTagName('head')[0];
                if (agent.firefox) code = '\n' + code;
                script.appendChild(document.createTextNode('document.__paperscript__ = function(' + params + ') {' + code + '\n}'));
                head.appendChild(script);
                func = document.__paperscript__;
                delete document.__paperscript__;
                head.removeChild(script);
            } else func = Function(params, code);
            var exports = func && func.apply(scope, args);
            var obj = exports || {};
            Base.each(toolHandlers, function(key) {
                var value = obj[key];
                if (value) tool[key] = value;
            });
            if (view) {
                if (obj.onResize) view.setOnResize(obj.onResize);
                view.emit('resize', {
                    size: view.size,
                    delta: new Point()
                });
                if (obj.onFrame) view.setOnFrame(obj.onFrame);
                view.requestUpdate();
            }
            return exports;
        }
        function loadScript(script) {
            if (/^text\/(?:x-|)paperscript$/.test(script.type) && PaperScope.getAttribute(script, 'ignore') !== 'true') {
                var canvasId = PaperScope.getAttribute(script, 'canvas'), canvas = document.getElementById(canvasId), src = script.src || script.getAttribute('data-src'), async = PaperScope.hasAttribute(script, 'async'), scopeAttribute = 'data-paper-scope';
                if (!canvas) throw new Error('Unable to find canvas with id "' + canvasId + '"');
                var scope = PaperScope.get(canvas.getAttribute(scopeAttribute)) || new PaperScope().setup(canvas);
                canvas.setAttribute(scopeAttribute, scope._id);
                if (src) Http.request({
                    url: src,
                    async: async,
                    mimeType: 'text/plain',
                    onLoad: function(code) {
                        execute(code, scope, src);
                    }
                });
                else execute(script.innerHTML, scope, script.baseURI);
                script.setAttribute('data-paper-ignore', 'true');
                return scope;
            }
        }
        function loadAll() {
            Base.each(document && document.getElementsByTagName('script'), loadScript);
        }
        function load(script) {
            return script ? loadScript(script) : loadAll();
        }
        if (window) {
            if (document.readyState === 'complete') setTimeout(loadAll);
            else DomEvent.add(window, {
                load: loadAll
            });
        }
        return {
            compile: compile,
            execute: execute,
            load: load,
            parse: parse,
            calculateBinary: __$__,
            calculateUnary: $__
        };
    }).call(this);
    var paper = new (PaperScope.inject(Base.exports, {
        Base: Base,
        Numerical: Numerical,
        Key: Key,
        DomEvent: DomEvent,
        DomElement: DomElement,
        document: document,
        window: window,
        Symbol: SymbolDefinition,
        PlacedSymbol: SymbolItem
    }))();
    if (paper.agent.node) (parcelRequire("foUwZ"))(paper);
    if (typeof define === 'function' && define.amd) define('paper', paper);
    else if (module) module.exports = paper;
    return paper;
}).call(this, typeof self === 'object' ? self : null);

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});


var $dc57b31f1b066f38$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $dc57b31f1b066f38$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $dc57b31f1b066f38$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $dc57b31f1b066f38$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



// Klasa	          | Efekt                        | Parametry CSS Custom Properties
// .parallax-3d	    | Perspektywa 3D	             | --parallax-intensity: 2;
// .animate-stagger | Kaskadowe animacje elementów | --stagger-delay: 0.1s;
// .blur-transition | Rozmycie przy zmianie sekcji | --blur-amount: 5px;
// <div class="section four parallax parallax-3d" style="--parallax-intensity: 3;">
//     <div data-depth="0.5" class="animate-stagger" style="--stagger-delay: 0.2s;">
//         Tekst będzie się animował z opóźnieniem
//     </div>
// </div>
function $8f731f645b12aa47$export$b0c9e2140e094320() {
    const container = document.querySelector(".container");
    // Dynamiczne pobieranie elementów
    const sections = ()=>document.querySelectorAll(".section");
    // Stan aplikacji
    const appState = {
        currentSection: 0,
        horizontalStates: new Map()
    };
    // Tymczasowe dane z myszki/palca
    const inputState = {
        isPointerDown: false,
        startX: 0,
        startY: 0
    };
    // Techniczne flagi i konfiguracja
    const scrollControl = {
        isScrolling: false,
        lastSectionDirection: 1,
        threshold: 30,
        lastScrollTime: 0
    };
    // Poczekaj ~1sek a potem wywołaj funkcję resolve
    const wait = (delay = 700)=>new Promise((resolve)=>setTimeout(resolve, delay));
    // function wait(delay = 700) {
    //   return new Promise(resolve => setTimeout(resolve, delay));
    // }
    /**
  * Funkcje liczy ilość sekcji
  **/ function getTotalSections() {
        return sections().length;
    }
    /**
  * Podswietlenie aktywnej sekcji
  **/ // Funkcja aktualizuje menu nawigacyjne, podświetlając aktualnie 
    // aktywną sekcję. Dodaje lub usuwa klasę .active
    function updateMenu() {
        const currentSection = sections()[appState.currentSection];
        document.querySelectorAll('.menu a').forEach((link)=>{
            const rawHref = link.getAttribute('href'); // np. "#section2:2"
            // Zabezpiecznie dla linków z klasycznymi adresami
            if (!rawHref) return;
            if (rawHref.startsWith('http://') || rawHref.startsWith('https://') || rawHref.includes('//')) return;
            const href = decodeURIComponent(rawHref);
            const parts = href.split(':'); // Rozdziel po ":"
            const targetId = parts[0]; // "#section2"
            const targetSection = document.querySelector(targetId);
            // Bezpośrednie porównanie elementów DOM
            link.classList.toggle('active', targetSection === currentSection);
        });
    }
    /**
  * Menu podsekcji 
  **/ // Funkcja aktualizuje menu podsekcji, podświetlających aktualnie 
    // aktywną (widoczną) subsekcję. Dodaje lub usuwa klasę .active
    function updateSubsectionMenu() {
        // 1. Znajdź aktualnie wyświetlaną sekcję
        const currentSectionElement = sections()[appState.currentSection];
        if (!currentSectionElement) return;
        // 2. Znajdź menu podsekcji wewnątrz tej sekcji
        const subsectionMenu = currentSectionElement.querySelector('.subsection-menu');
        // 3. Jeśli nie ma takiego menu, zakończ działanie funkcji
        if (!subsectionMenu) {
            // Dodatkowo, jeśli w innej sekcji było aktywne menu, możemy je wyczyścić.
            // To na wszelki wypadek, gdybyś dodał więcej takich menu w przyszłości.
            document.querySelectorAll('.subsection-menu a.active').forEach((link)=>link.classList.remove('active'));
            return;
        }
        // 4. Pobierz aktualny stan horyzontalny dla tej sekcji
        const horizontalState = getCurrentHorizontalState();
        if (!horizontalState) return; // Jeśli z jakiegoś powodu stan nie istnieje
        // 5. Pobierz indeks aktywnej podsekcji
        const activeSubsectionIndex = horizontalState.currentSubsection;
        // Najpierw usuń wszystkie poprzednie klasy 'submenu-*', aby uniknąć ich kumulacji.
        // Używamy pętli, bo element może mieć inne klasy, których nie chcemy ruszać.
        for (const cls of Array.from(subsectionMenu.classList))if (cls.startsWith('submenu-')) subsectionMenu.classList.remove(cls);
        // Następnie dodaj nową, aktualną klasę. Używamy indeksu + 1, żeby było czytelniej.
        // Twój pierwszy slajd ma indeks 0, więc dostanie klasę 'submenu-1'.
        subsectionMenu.classList.add(`submenu-${activeSubsectionIndex + 1}`);
        // 6. Przejdź przez wszystkie linki w menu podsekcji
        const links = subsectionMenu.querySelectorAll('a');
        links.forEach((link)=>{
            const rawHref = link.getAttribute('href'); // np. "#section3:2"
            const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :
            const parts = href.split(':');
            // Domyślnie zakładamy, że link nie ma określonej podsekcji (np. href="#section3")
            // co mogłoby oznaczać podsekcję 0. W Twoim przypadku zawsze jest indeks.
            let linkTargetIndex = null;
            if (parts.length > 1) linkTargetIndex = parseInt(parts[1], 10);
            // Porównaj indeks z linku z aktywnym indeksem w stanie aplikacji
            // i odpowiednio przełącz klasę 'active'
            const isActive = linkTargetIndex === activeSubsectionIndex;
            link.classList.toggle('active', isActive);
        });
    }
    /**
  * Wymiary i stan dla sekcji poziomych przed ich użyciem
  **/ // Funkcja oblicza szerokość kontenerów (.horizontal-wrapper) 
    // na podstawie liczby podsekcji oraz ustawia początkowy stan 
    // widoczności – czyli która podsekcja jest aktywna przy starcie.
    //
    function initDimensions() {
        sections().forEach((section, index)=>{
            if (section.classList.contains("horizontal")) {
                const wrapper = section.querySelector(".horizontal-wrapper");
                const subsections = wrapper.querySelectorAll(".subsection");
                wrapper.style.width = `${subsections.length * 100}vw`;
                appState.horizontalStates.set(index, {
                    currentSubsection: 0,
                    totalSubsections: subsections.length
                });
            }
        });
    }
    /**
  * Określa stan aktualnej sekcji poziomej
  **/ // Funkcja zwraca stan podsekcji bieżącej sekcji poziomej, podając indeks 
    // aktualnie widocznej podsekcji oraz całkowitą liczbę podsekcji w kontenerze.
    function getCurrentHorizontalState() {
        const sectionIndex = appState.currentSection;
        const section = sections()[sectionIndex];
        return section?.classList.contains("horizontal") ? appState.horizontalStates.get(sectionIndex) : null;
    }
    /**
  * Przesuwanie między sekcjami pionowymi
  **/ // Funkcja przesuwa widok w górę lub w dół, dodając i usuwając klasy sygnalizujące proces przewijania. 
    // Aktualizuje menu, podświetlając aktualną pozycję w menu głównym  i w menu podsekcji.
    // Ustawia stan podsekcji w sekcjach poziomych:
    //    - przy przewijaniu w dół ustawia aktywną ostatnią podsekcję,
    //    - przy przewijaniu w górę ustawia aktywną pierwszą podsekcję.
    // Obsługuje również sekcje `sticky-section`, czyli wprowadza opóźnienie dla sekcji "przyklejonych".
    async function navigateSection(direction) {
        const newIndex = appState.currentSection + direction;
        if (newIndex < 0 || newIndex >= getTotalSections()) return;
        const currentSection = sections()[appState.currentSection];
        const newSection = sections()[newIndex];
        scrollControl.isScrolling = true;
        scrollControl.lastSectionDirection = direction;
        if (currentSection.classList.contains("sticky-section") && direction === 1) await handleStickyScroll(currentSection);
        currentSection.classList.add('animate-out', 'slide-up');
        const currentHorizontal = getCurrentHorizontalState();
        if (currentHorizontal) currentHorizontal.currentSubsection = direction === 1 ? currentHorizontal.totalSubsections - 1 : 0;
        appState.currentSection = newIndex;
        container.style.transform = `translateY(-${newIndex * 100}vh)`;
        newSection.classList.add('animate-in', 'zoom-in');
        const newHorizontal = getCurrentHorizontalState();
        if (newHorizontal) {
            const wrapper = sections()[newIndex].querySelector(".horizontal-wrapper");
            wrapper.style.transform = `translateX(-${newHorizontal.currentSubsection * 100}vw)`;
        }
        await wait(700);
        currentSection.classList.remove('animate-out', 'slide-up');
        newSection.classList.remove('animate-in', 'zoom-in');
        scrollControl.isScrolling = false;
        updateMenu(); // Aktualizacja menu po zmianie sekcji
        updateSubsectionMenu();
    }
    /**
  * Mierzenie postępu przewijania sekcji (sticky-section)
  **/ // Funkcja mierzy postęp przewijania sekcji sticky i zapisuje go w zmiennej CSS --scroll-progress, 
    // przypisując wartości z przedziału pomiędzy 0 do 1. 
    // Umożliwia to sterowanie animacjami lub efektami w zależności od stopnia przewinięcia rolki myszki.
    function handleStickySectionScroll() {
        const stickySection = document.querySelector('.sticky-section');
        if (!stickySection) return;
        const stickyContent = stickySection.querySelector('.sticky-content');
        const sectionTop = stickySection.getBoundingClientRect().top;
        const sectionHeight = stickyContent.offsetHeight - stickySection.offsetHeight;
        let progress;
        // Sprawdź, czy sticky-section jest w widoku
        if (sectionTop <= 0 && Math.abs(sectionTop) <= sectionHeight) // Oblicz postęp przewijania
        progress = Math.min(Math.max(Math.abs(sectionTop) / sectionHeight, 0), 1);
        else // Jeśli poza zakresem, ustaw progress na 0 lub 1
        progress = sectionTop > 0 ? 0 : 1;
        stickySection.style.setProperty('--scroll-progress', progress);
    // console.log(`Scroll progress: ${progress}`);
    }
    /**
  * Blokowanie przewijania sekcji sticky (sticky-section)
  **/ // Funkcja monitoruje scroll wewnątrz `.sticky-content` i sprawdza, jak daleko
    // użytkownik przewinął zawartość.
    // - Gdy przewinie do końca sticky-content, aplikacja wie, że można przejść
    //   do następnej sekcji.
    // - Gdy przewinie do początku, aplikacja wie, że można wrócić do poprzedniej sekcji.
    // - W trakcie przewijania zapisuje postęp w atrybucie data-progress w %
    async function handleStickyScroll(section) {
        return new Promise((resolve)=>{
            const stickyContent = section.querySelector(".sticky-content"); // Znajdź sticky-content
            if (!stickyContent) {
                console.error("Brak .sticky-content w sekcji!");
                resolve(0);
                return;
            }
            const maxScroll = stickyContent.scrollHeight - stickyContent.clientHeight; // Maksymalne przewinięcie
            let progress = 0;
            const onScroll = ()=>{
                const scrollTop = stickyContent.scrollTop; // Ile przewinięto sticky-content
                progress = Math.min(100, Math.max(0, scrollTop / maxScroll * 100));
                section.setAttribute("data-progress", `${Math.floor(progress)}%`);
                console.log("Progress:", progress);
                if (progress >= 100) {
                    stickyContent.removeEventListener("scroll", onScroll);
                    resolve(1); // Przejście do kolejnej sekcji
                }
                if (progress <= 0) {
                    stickyContent.removeEventListener("scroll", onScroll);
                    resolve(-1); // Powrót do poprzedniej sekcji
                }
            };
            stickyContent.addEventListener("scroll", onScroll);
            onScroll(); // Sprawdź od razu
        });
    }
    /**
  * Nawigacja pozioma subsekcji
  **/ // Funkcja przesuwa widok w lewo lub w prawo. Aktualizuje indeks 
    // bieżącej podsekcji, odtwarza dźwięk `rollover` i aktualizuje 
    // menu podsekcji.
    async function navigateSubsection(direction) {
        const horizontal = getCurrentHorizontalState();
        if (!horizontal) return;
        const newIndex = horizontal.currentSubsection + direction;
        if (newIndex < 0 || newIndex >= horizontal.totalSubsections) return;
        scrollControl.isScrolling = true;
        horizontal.currentSubsection = newIndex;
        const wrapper = sections()[appState.currentSection].querySelector(".horizontal-wrapper");
        wrapper.style.transform = `translateX(-${newIndex * 100}vw)`;
        // dziwęk
        const smashRollover = document.getElementById('sound-rollover');
        smashRollover?.play().catch(()=>{});
        await wait();
        scrollControl.isScrolling = false;
        updateSubsectionMenu();
    }
    /**
  * Nawigacja między sekcjami
  **/ // Funkcja jest głównym mechanizmem nawigacji w aplikacji. 
    // Decyduje, co przesunąć w zależności od stanu aplikacji i kierunku:
    // - Jeśli sekcja jest pozioma, przesuwa podsekcję lub całą sekcję pionową, 
    //   jeśli osiągnięto pierwszą lub ostatnią podsekcję.
    // - Jeśli sekcja jest typu sticky, blokuje przewijanie, dopóki nie 
    //   przewiniemy całej zawartości.
    // - Jeśli zwykła sekcja pionowa, przesuwa ją w górę lub w dół.
    // Funkcja aktualizuje menu główne i menu podsekcji oraz steruje 
    // animacjami przewijania.
    function autoNavigate(direction) {
        if (scrollControl.isScrolling) return;
        const currentSection = sections()[appState.currentSection];
        const horizontal = getCurrentHorizontalState();
        // Sprawdź czy aktualna sekcja jest "sticky" i czy można ją opuścić
        if (currentSection.classList.contains("sticky-section")) {
            const stickyContent = currentSection.querySelector(".sticky-content");
            if (stickyContent) {
                const isAtTop = stickyContent.scrollTop === 0;
                const isAtBottom = stickyContent.scrollTop + stickyContent.clientHeight >= stickyContent.scrollHeight - 1;
                // Blokuj nawigację jeśli nie osiągnięto odpowiedniego progu
                if (direction === 1 && !isAtBottom) return;
                if (direction === -1 && !isAtTop) return;
            }
        }
        if (horizontal) {
            const isFirstSub = horizontal.currentSubsection === 0;
            const isLastSub = horizontal.currentSubsection === horizontal.totalSubsections - 1;
            direction === 1 ? isLastSub ? navigateSection(1) : navigateSubsection(1) : isFirstSub ? navigateSection(-1) : navigateSubsection(-1);
        } else navigateSection(direction);
    }
    /**
  * Sterowanie zmianami sekcji
  **/ // Zestaw funkcji pozwalających użytkownikowi poruszać się po stronach 
    // za pomocą myszki, touchpada, klawiatury lub palca na ekranie.  
    // Przesuwa widok w górę, w dół lub na boki. Dba o płynność ruchu, 
    // blokując kolejne przewinięcia podczas animacji i reagując tylko na 
    // ruchy wystarczająco duże, aby uznać je za zamiar przewinięcia.
    function handleScroll(e) {
        // Throttling scrolla 
        // ograniczenie bardzo dużych wartości deltaY dla trackpadów 
        // które przewijały wiele sekcji na raz
        const now = Date.now();
        const intensity = Math.abs(e.deltaY);
        const adaptiveCooldown = Math.min(1500, 300 + intensity * 2); // np. 300–1500ms
        if (now - scrollControl.lastScrollTime < adaptiveCooldown) return;
        if (intensity < 30) return;
        // Oryginalna obsługa handleScroll(e)
        const direction = e.deltaY > 0 ? 1 : -1;
        autoNavigate(direction);
        scrollControl.lastScrollTime = now;
    }
    function handleKeys(e) {
        const keyActions = {
            ArrowDown: ()=>autoNavigate(1),
            ArrowUp: ()=>autoNavigate(-1),
            ArrowRight: ()=>{
                const horizontal = getCurrentHorizontalState();
                if (horizontal) navigateSubsection(1);
            },
            ArrowLeft: ()=>{
                const horizontal = getCurrentHorizontalState();
                if (horizontal) navigateSubsection(-1);
            }
        };
        keyActions[e.key]?.();
    }
    function handlePointerStart(e) {
        if (scrollControl.isScrolling) return;
        const coords = e.touches ? e.touches[0] : e;
        inputState.startX = coords.clientX;
        inputState.startY = coords.clientY;
        inputState.isPointerDown = true;
    }
    function handlePointerMove(e) {
        if (!inputState.isPointerDown) return;
        e.preventDefault();
    }
    function handlePointerEnd(e) {
        if (!inputState.isPointerDown || scrollControl.isScrolling) return;
        inputState.isPointerDown = false;
        const coords = e.changedTouches ? e.changedTouches[0] : e;
        const deltaX = coords.clientX - inputState.startX;
        const deltaY = coords.clientY - inputState.startY;
        if (Math.abs(deltaX) + Math.abs(deltaY) < scrollControl.threshold) return;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            const horizontal = getCurrentHorizontalState();
            if (horizontal) {
                const direction = deltaX > 0 ? -1 : 1;
                navigateSubsection(direction);
            }
        } else {
            const direction = deltaY > 0 ? -1 : 1;
            autoNavigate(direction);
        }
    }
    /**
  * Efekt paralaksy dla elementów w sekcjach z klasą `.parallax`.
  **/ // Każda sekcja `.parallax` może zawierać elementy z atrybutem `data-depth`.
    // `data-depth` określa siłę przesunięcia elementu w reakcji na scroll:
    //    - np. 0.2 → element przesuwa się wolniej niż scroll
    //    - np. 1   → element porusza się równomiernie ze scrollowaniem
    // Funkcja oblicza offset w osi Y dla każdego elementu:
    //    offset = (scrollPos - sectionTop) * depth * 0.5
    // Offset jest przypisywany przez CSS transform: translateY(offset)
    //
    // Optymalizacja:
    // Scroll jest throttlowany przez requestAnimationFrame i flagę `isTicking`, 
    // co zapobiega nadmiernym obliczeniom i zwiększa wydajność.
    //
    // Przykład:
    // <section class="parallax">
    //   <img src="bg.png" data-depth="0.1">
    //   <img src="midground.png" data-depth="0.5">
    //   <img src="foreground.png" data-depth="1">
    // </section>
    function initParallax() {
        let isTicking = false;
        const update = ()=>{
            document.querySelectorAll('.parallax').forEach((section)=>{
                const elements = section.querySelectorAll('[data-depth]');
                const scrollPos = window.pageYOffset;
                const sectionTop = section.offsetTop;
                elements.forEach((el)=>{
                    const depth = parseFloat(el.dataset.depth);
                    const offset = (scrollPos - sectionTop) * depth * 0.5;
                    el.style.transform = `translateY(${offset}px)`;
                });
            });
            isTicking = false;
        };
        window.addEventListener('scroll', ()=>{
            if (!isTicking) {
                requestAnimationFrame(update);
                isTicking = true;
            }
        });
    }
    /**
  * Aanimacja pzypieta oparty na postępie przewijania sekcji.
  **/ // Obserwuje zmiany atrybutu `data-progress` w zadanych sekcjach (triggerach).
    // Dla każdej sekcji można określić wiele "warstw" (targets), które aktywują się niezależnie.
    // Każda warstwa ma własne progi procentowe:
    //   - activateAt: procent przewinięcia, przy którym dodawana jest klasa `.active`
    //   - resetAt: procent przewinięcia, przy którym klasa `.active` jest usuwana
    // Animacja aktywuje się tylko raz na cykl przewijania i resetuje po powrocie scrolla poniżej resetAt.
    //
    // Konfiguracja:
    // - configs: tablica obiektów opisujących sekcje i ich warstwy:
    //       [
    //           {
    //               trigger: '.three',        // selektor sekcji obserwowanej
    //               targets: [
    //                   { selector: '.layer1', activateAt: 20, resetAt: 5 },
    //                   { selector: '.layer2', activateAt: 50, resetAt: 10 },
    //                   { selector: '.layer3', activateAt: 80, resetAt: 30 },
    //               ]
    //           },
    //       ]
    //
    // Zasady działania:
    // 1. Każda sekcja obserwowana jest przez MutationObserver, który reaguje na zmianę data-progress.
    // 2. Każda warstwa w sekcji posiada własny stan (`isActive`, `previousProgress`).
    // 3. Po przekroczeniu activateAt → dodanie klasy `.active`.
    // 4. Po powrocie poniżej resetAt → usunięcie klasy `.active`.
    // 5. Można łatwo dodać nowe sekcje i/lub warstwy, zmieniając tylko tablicę configs.
    function initProgressAnimations(configs) {
        configs.forEach(({ trigger: trigger, targets: targets })=>{
            const sectionEl = document.querySelector(trigger);
            if (!sectionEl || !targets?.length) return;
            const states = targets.map(()=>({
                    previousProgress: 0,
                    isActive: false
                }));
            const observer = new MutationObserver(()=>{
                const progress = parseFloat(sectionEl.getAttribute('data-progress'));
                if (isNaN(progress)) return;
                targets.forEach((t, i)=>{
                    const { selector: selector, activateAt: activateAt = 50, resetAt: resetAt = 10 } = t;
                    const targetEl = document.querySelector(selector);
                    if (!targetEl) return;
                    const state = states[i];
                    if (progress < resetAt && state.previousProgress > 90) {
                        targetEl.classList.remove('active');
                        state.isActive = false;
                    }
                    if (progress >= activateAt && !state.isActive) {
                        targetEl.classList.add('active');
                        state.isActive = true;
                    }
                    state.previousProgress = progress;
                });
            });
            observer.observe(sectionEl, {
                attributes: true,
                attributeFilter: [
                    'data-progress'
                ]
            });
        });
    }
    /**
 * Nawigacja za pomocą menu lub linków
 **/ // Przechodzi do wskazanej sekcji (i opcjonalnie podsekcji),
    // jednocześnie inteligentnie ustawiając stan pośrednich sekcji horyzontalnych.
    // Parametry:
    //   @param {string} targetId - ID sekcji docelowej, np. "#section3"
    //   @param {number|null} subsectionIndex - Indeks podsekcji docelowej lub null.
    function handleMenuNavigation(targetId, subsectionIndex = null) {
        const targetSection = document.querySelector(targetId);
        if (!targetSection) {
            console.error("Sekcja docelowa nie zosta\u0142a znaleziona:", targetId);
            return;
        }
        const sectionsArray = Array.from(sections());
        const newIndex = sectionsArray.indexOf(targetSection);
        // Ignoruj, jeśli kliknięto w aktywny link lub sekcja nie istnieje
        if (newIndex === -1) return;
        // Sprawdzamy, czy docelowa sekcja I podsekcja są DOKŁADNIE takie same jak obecne.
        // Kończymy działanie TYLKO wtedy, gdy nie ma absolutnie nic do zmiany.
        const hStateCurrent = appState.horizontalStates.get(newIndex);
        if (newIndex === appState.currentSection && hStateCurrent && hStateCurrent.currentSubsection === (subsectionIndex ?? 0)) return;
        // --- KLUCZOWA LOGIKA ---
        // Przejdź przez wszystkie sekcje i ustaw stan horyzontalny
        // w zależności od ich położenia względem nowej, docelowej sekcji.
        sectionsArray.forEach((section, i)=>{
            // Sprawdź, czy dana sekcja jest sekcją horyzontalną
            if (appState.horizontalStates.has(i)) {
                const hState = appState.horizontalStates.get(i);
                const wrapper = section.querySelector(".horizontal-wrapper");
                if (i < newIndex) // Ta sekcja jest PRZED sekcją docelową.
                // Ustawiamy ją na ostatnią podsekcję, aby umożliwić płynny powrót (scroll-up).
                hState.currentSubsection = hState.totalSubsections - 1;
                else if (i > newIndex) // Ta sekcja jest PO sekcji docelowej.
                // Resetujemy ją do pierwszej podsekcji, przygotowując na przyszłe przewijanie w dół.
                hState.currentSubsection = 0;
                else // To jest nasza sekcja docelowa.
                // Ustawiamy ją na wskazaną podsekcję lub na pierwszą, jeśli nie podano inaczej.
                hState.currentSubsection = subsectionIndex ?? 0;
                // Zastosuj odpowiednią transformację CSS, aby wizualnie odzwierciedlić nowy stan.
                if (wrapper) wrapper.style.transform = `translateX(-${hState.currentSubsection * 100}vw)`;
            }
        });
        // Zaktualizuj główny stan aplikacji i przesuń kontener pionowo
        appState.currentSection = newIndex;
        container.style.transform = `translateY(-${newIndex * 100}vh)`;
        // Zaktualizuj wizualnie menu
        updateMenu();
        updateSubsectionMenu();
    }
    //  * ************************************
    //  * Inicjalizacja
    //  * ************************************
    function init() {
        initDimensions();
        initParallax();
        initProgressAnimations([
            {
                trigger: '.three2',
                targets: [
                    {
                        selector: '.layer1',
                        activateAt: 20,
                        resetAt: 5
                    },
                    {
                        selector: '.layer2',
                        activateAt: 50,
                        resetAt: 10
                    },
                    {
                        selector: '.layer3',
                        activateAt: 80,
                        resetAt: 30
                    }
                ]
            },
            {
                trigger: '.three',
                targets: [
                    {
                        selector: '.facetos-content-dwa',
                        activateAt: 50,
                        resetAt: 10
                    }
                ]
            }
        ]);
        // Obsługa menu
        document.querySelectorAll('.menu a').forEach((link)=>{
            link.addEventListener('click', function(e) {
                const rawHref = this.getAttribute('href'); // np. "#section2:2"
                if (!rawHref) return;
                // Jeześli to nie jest "#...", otwieramy w nowej karcie
                if (!rawHref.startsWith('#')) {
                    e.preventDefault();
                    window.open(rawHref, '_blank');
                    return;
                }
                e.preventDefault();
                const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :
                const parts = href.split(':'); // Rozdziel po ":"
                const targetId = parts[0]; // "#section2"
                const subsectionIndex = parts.length > 1 ? parseInt(parts[1], 10) : null;
                handleMenuNavigation(targetId, subsectionIndex);
            });
        });
        // Obsługa linków miedzysekcyjnych
        document.querySelectorAll('a.linka[href^="#"]').forEach((link)=>{
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const rawHref = this.getAttribute('href'); // np. "#section2:2"
                const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :
                const parts = href.split(':'); // Rozdziel po ":"
                const targetId = parts[0]; // "#section2"
                const subsectionIndex = parts.length > 1 ? parseInt(parts[1], 10) : null;
                handleMenuNavigation(targetId, subsectionIndex);
            });
        });
        document.querySelectorAll('.sticky-section .sticky-content').forEach((content)=>{
            content.addEventListener('scroll', function(e) {
                const section = this.closest('.section');
                const scrollTop = this.scrollTop;
                const maxScroll = this.scrollHeight - this.clientHeight;
                const progress = Math.min(100, Math.max(0, scrollTop / maxScroll * 100));
                section.setAttribute("data-progress", `${Math.floor(progress)}%`);
            });
        });
        // Event listeners
        document.addEventListener("touchstart", handlePointerStart, {
            passive: true
        });
        document.addEventListener("touchmove", handlePointerMove, {
            passive: false
        });
        document.addEventListener("touchend", handlePointerEnd, {
            passive: true
        });
        document.addEventListener("mousedown", handlePointerStart);
        document.addEventListener("mousemove", handlePointerMove);
        document.addEventListener("mouseup", handlePointerEnd);
        document.addEventListener("mouseleave", handlePointerEnd);
        document.addEventListener("wheel", handleScroll, {
            passive: false
        });
        document.addEventListener("keydown", handleKeys);
        document.addEventListener('scroll', handleStickySectionScroll);
        // Usuń event listeners przy czyszczeniu
        // nie jestem pewien czy to działa 
        // window.addEventListener('beforeunload', () => {
        //   window.removeEventListener('scroll', scrollHandler);
        //   document.removeEventListener('wheel', handleScroll);
        // });
        updateMenu(); // Inicjalna aktualizacja menu
        updateSubsectionMenu();
    }
    init();
} // END:  export function initMechanika()


/*** 
 * Odblokowanie dźwięków 
 * 
 * Obejście dla blokady dźwieków przez chrome
 * odtwarza i pauzuje wszystkie <audio>, żeby uzyskać zgodę przeglądarki.
 */ function $842f69af235281a6$export$7cc880c51f50f061() {
    let soundsUnlocked = false;
    function unlockSounds() {
        if (!soundsUnlocked) {
            document.querySelectorAll('audio').forEach((audio)=>{
                try {
                    audio.play().catch(()=>{}); // próbujemy, żeby przeglądarka "zezwoliła"
                    audio.pause();
                    audio.currentTime = 0;
                } catch (e) {
                    console.warn("B\u0142\u0105d przy odblokowywaniu d\u017Awi\u0119ku:", e);
                }
            });
            soundsUnlocked = true;
        }
    }
    window.addEventListener('click', unlockSounds);
    window.addEventListener('touchstart', unlockSounds); // dla ekranów dotykowych
}


/**
 * AudioPlayer — skalowalny moduł odtwarzacza audio
 * ------------------------------------------------------
 * Obsługuje wiele instancji odtwarzaczy na stronie. 
 * Każda instancja działa niezależnie, z własnym przyciskiem i paskiem postępu.
 *
 * Struktura HTML:
 * <div class="playeros">
 *   <canvas class="player-circle" width="170" height="170"></canvas>  // pasek postępu
 *   <div class="btn-palyer trigger-player" data-audio="sound.mp3">
 *     <div class="btn-palyer-fog">
 *       <svg>...</svg>  // ikona play
 *     </div>
 *   </div>
 * </div>
 *
 * Atrybuty danych (data-*):
 * - data-audio → ścieżka do pliku audio dla przycisku
 *
 * Zachowanie:
 * - Kliknięcie przycisku odtwarza lub pauzuje odpowiadający plik audio
 * - Każdy przycisk posiada klasę 'played' podczas odtwarzania
 * - Pasek postępu (.player-circle) aktualizuje się w czasie rzeczywistym
 * - IntersectionObserver zatrzymuje odtwarzanie, gdy kontener nie jest widocz*
 **/ class $03290796f2fc6bfc$export$832cc5475f11d8b4 {
    constructor(container){
        this.container = container;
        this.audio = container.querySelector('audio') || document.createElement('audio');
        if (!container.contains(this.audio)) container.appendChild(this.audio);
        this.buttons = container.querySelectorAll('.trigger-player');
        this.circleCanvases = container.querySelectorAll('.player-circle');
        this.currentButton = null;
        this.animFrame = null;
        // flagi do observera
        this.userPaused = false;
        this.pausedByObserver = false;
        this.initButtons();
        this.initAudioEvents();
        this.initVisibilityObserver();
        // stan początkowy
        this.container.classList.remove('playing');
        this.circleCanvases.forEach((c)=>this.drawCircle(c, 0));
    }
    /* ------------------------------------ */ /* Buttons                              */ /* ------------------------------------ */ initButtons() {
        this.buttons.forEach((button)=>{
            button.addEventListener('click', async ()=>{
                const sameButton = this.currentButton === button;
                const isPlaying = !this.audio.paused;
                // klik = intencja użytkownika
                this.container.classList.add('playing');
                this.userPaused = false;
                if (sameButton) {
                    if (isPlaying) {
                        this.audio.pause();
                        this.userPaused = true;
                        button.classList.remove('played');
                    } else {
                        await this.audio.play().catch(()=>{});
                        button.classList.add('played');
                    }
                    return;
                }
                if (this.currentButton) this.currentButton.classList.remove('played');
                this.currentButton = button;
                button.classList.add('played');
                if (this.audio.src !== button.dataset.audio) {
                    this.audio.src = button.dataset.audio;
                    await new Promise((resolve)=>this.audio.addEventListener('canplay', resolve, {
                            once: true
                        }));
                }
                await this.audio.play().catch(()=>{});
            });
        });
    }
    /* ------------------------------------ */ /* Audio events                         */ /* ------------------------------------ */ initAudioEvents() {
        this.audio.addEventListener('play', ()=>{
            this.updateCircles();
        });
        this.audio.addEventListener('pause', ()=>{
            cancelAnimationFrame(this.animFrame);
        });
        this.audio.addEventListener('ended', ()=>{
            cancelAnimationFrame(this.animFrame);
            if (this.currentButton) {
                this.currentButton.classList.remove('played');
                this.currentButton = null;
            }
            this.userPaused = false;
            this.pausedByObserver = false;
            this.container.classList.remove('playing');
            this.circleCanvases.forEach((c)=>this.drawCircle(c, 0));
        });
    }
    /* ------------------------------------ */ /* IntersectionObserver                 */ /* ------------------------------------ */ initVisibilityObserver() {
        const observer = new IntersectionObserver(([entry])=>{
            const isActive = this.container.classList.contains('playing');
            // wyjechaliśmy z widoku
            if (!entry.isIntersecting && isActive && !this.audio.paused) {
                this.pausedByObserver = true;
                this.audio.pause();
            }
            // wróciliśmy — wznów TYLKO jeśli observer pauzował
            if (entry.isIntersecting && this.pausedByObserver && !this.userPaused) {
                this.pausedByObserver = false;
                this.audio.play().catch(()=>{});
            }
        }, {
            threshold: 0.15
        });
        observer.observe(this.container);
    }
    /* ------------------------------------ */ /* Canvas                               */ /* ------------------------------------ */ drawCircle(canvas, progress) {
        const ctx = canvas.getContext('2d');
        const r = canvas.width / 2 - 5;
        const c = canvas.width / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();
        ctx.arc(c, c, r, 0, 2 * Math.PI);
        ctx.strokeStyle = '#f1f1f1';
        ctx.lineWidth = 10;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(c, c, r, -Math.PI / 2, -Math.PI / 2 + 2 * Math.PI * progress);
        ctx.strokeStyle = '#f00';
        ctx.lineWidth = 10;
        ctx.stroke();
    }
    updateCircles() {
        const progress = this.audio.duration > 0 ? this.audio.currentTime / this.audio.duration : 0;
        this.circleCanvases.forEach((c)=>this.drawCircle(c, progress));
        if (!this.audio.paused) this.animFrame = requestAnimationFrame(()=>this.updateCircles());
    }
}


/**
 * Menu - animacja rozwinięcia
 * -  pokazanie podsawowej naimacji (menu) po kliknieciu hamburgermenu
 */ function $c2175d535efe4d56$export$22ea07d0c2ddb570() {
    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('.menu');
    if (!hamburger || !menu) return;
    const links = menu.querySelectorAll('a');
    hamburger.addEventListener('click', ()=>{
        const isOpen = menu.classList.contains('show');
        if (!isOpen) {
            // 🔹 Przy otwieraniu — reset do pozycji startowej
            links.forEach((link)=>{
                link.style.transition = 'none';
                link.style.transform = 'translateX(20px)';
                link.style.opacity = '0';
            });
            // 🔹 Wymuszenie odświeżenia (reset animacji)
            menu.offsetWidth;
            // 🔹 Pokazujemy menu i odpalamy animację
            menu.classList.add('show');
            links.forEach((link, i)=>{
                link.style.transition = '';
                link.style.transitionDelay = `${i * 0.13}s`;
                link.style.transform = 'translateY(0)';
                link.style.opacity = '1';
            });
        } else {
            // 🔹 Zamykamy z odwrotną animacją sprężyny
            links.forEach((link, i)=>{
                link.style.transitionDelay = `${i * 0.13}s`;
                link.style.transform = 'translateX(20px)';
                link.style.opacity = '0';
            });
            // 🔹 Usuwamy klasę po zakończeniu animacji
            setTimeout(()=>{
                menu.classList.remove('show');
            }, 800);
        }
    });
}
function $c2175d535efe4d56$export$f556f36ead468c30() {
    const blackSections = document.querySelectorAll('.section.black');
    if (blackSections.length === 0) return;
    const observer = new IntersectionObserver(()=>{
        const anyVisible = Array.from(blackSections).some((sec)=>{
            const rect = sec.getBoundingClientRect();
            return rect.top < window.innerHeight * 0.6 && rect.bottom > window.innerHeight * 0.4;
        });
        document.body.classList.toggle('dark', anyVisible);
    }, {
        threshold: 0.4
    });
    blackSections.forEach((section)=>observer.observe(section));
}


/**
 * Efekt dialogów kontaktowych
 * 
 *  "speech" Standardowy dymek dialogowy. Najczęściej używany. { spec: { style: 'speech' }}
 *  "thought" Dymek myśli, składający się z "chmurek". { spec: { style: 'thought' } }
 *  "pointedArcs" Dymek krzyku. Tworzy kształt z "kolcami".Be ogonka  { spec: { style: 'pointedArcs', points: 12 } }
 *   "caption" Dymek narracyjny. Prostokątny, często używany do opisów sceny. Bez ogonka. 	{ spec: { style: 'caption' } }
 *  "rectangle" 	Zwykły prostokąt. Podobny do caption, ale bardziej generyczny. Bez ogonka. { spec: { style: 'rectangle' } }
 *  "none" 	Brak widocznego dymka. Używane, gdy chcesz mieć sam tekst. Bez ogonka. { spec: { style: 'none' } }
 */ function $30eef45fbcef7f49$export$a671ad4ae5dc9baf() {
    const allParentElements = Array.from(document.querySelectorAll('.subsection[id^="section6"]'));
    if (allParentElements.length === 0) return;
    // --- FUNKCJE POMOCNICZE ---
    function getBreakpoint() {
        const width = window.innerWidth;
        if (width < 768) return 'mobile';
        if (width < 1024) return 'tablet';
        return 'desktop';
    }
    function parseCoords(str) {
        if (!str) return null;
        const parts = str.split(',').map((s)=>parseFloat(s.trim()));
        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) return {
            x: parts[0],
            y: parts[1]
        };
        return null;
    }
    // --- GŁÓWNA FUNKCJA RYSOWANIA ---
    function configureAndDrawAllComics() {
        const breakpoint = getBreakpoint();
        // console.log(`🎨 Rysowanie komiksu dla widoku: ${breakpoint}`);
        // 1️⃣ Ustaw pozycje CSS dymków
        const allBubbles = document.querySelectorAll('.dialogue[id^="bubble"]');
        allBubbles.forEach((bubbleEl)=>{
            const breakpointKey = `pos${breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1)}`;
            let posStr = bubbleEl.dataset[breakpointKey] || bubbleEl.dataset.posDesktop;
            if (posStr) bubbleEl.style.cssText = posStr;
        });
        // 2️⃣ Etap 1: Konfiguracja dymków-rodziców
        allBubbles.forEach((bubbleEl)=>{
            if (bubbleEl.dataset.parentId) return; // pomijamy dzieci
            const style = bubbleEl.dataset.specStyle || 'speech';
            const bubble = new Bubble(bubbleEl);
            const spec = Bubble.getDefaultBubbleSpec(bubbleEl, style);
            spec.level = parseInt(bubbleEl.dataset.specLevel, 10) || spec.level;
            if (bubbleEl.dataset.colorBg) spec.backgroundColors = [
                bubbleEl.dataset.colorBg
            ];
            if (style === 'speech' || style === 'thought') {
                const breakpointKey = `tailTo${breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1)}`;
                let coordsStr = bubbleEl.dataset[breakpointKey] || bubbleEl.dataset.tailToDesktop;
                if (coordsStr) {
                    const coords = parseCoords(coordsStr);
                    if (coords && spec.tails[0]) {
                        spec.tails[0].tipX = coords.x;
                        spec.tails[0].tipY = coords.y;
                    }
                }
            }
            bubble.setBubbleSpec(spec);
        });
        // 3️⃣ Etap 2: Rysowanie i relacje
        Comical.startEditing(allParentElements);
        allBubbles.forEach((bubbleEl)=>{
            if (bubbleEl.dataset.parentId) {
                const parentBubbleEl = document.getElementById(bubbleEl.dataset.parentId);
                if (parentBubbleEl) Comical.initializeChild(bubbleEl, parentBubbleEl);
            }
        });
        allParentElements.forEach((parent)=>Comical.update(parent));
        Comical.stopEditing();
    }
    // --- ANIMACJE WIDOCZNOŚCI ---
    function setupVisibilityAnimations() {
        document.querySelectorAll('.dialogue, .comical-generated').forEach((el)=>el.classList.add('is-hidden'));
        allParentElements.forEach((parent)=>{
            const svgShape = parent.querySelector('.comical-generated');
            const bubblesInSection = Array.from(parent.querySelectorAll('.dialogue'));
            if (!svgShape) return;
            const elementsToAnimate = [
                svgShape,
                ...bubblesInSection
            ];
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) {
                        setTimeout(()=>svgShape.classList.remove('is-hidden'), 100);
                        bubblesInSection.forEach((bubbleEl)=>{
                            const delay = parseInt(bubbleEl.dataset.delay, 10) || 200;
                            setTimeout(()=>bubbleEl.classList.remove('is-hidden'), delay);
                        });
                    } else elementsToAnimate.forEach((el)=>el.classList.add('is-hidden'));
                });
            }, {
                threshold: 0.3
            });
            observer.observe(parent);
        });
    }
    // --- DEBOUNCE (opóźnianie rysowania przy resize) ---
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>func(...args), wait);
        };
    }
    // --- URUCHOMIENIE GŁÓWNE ---
    configureAndDrawAllComics();
    setupVisibilityAnimations();
    const debouncedRedraw = debounce(configureAndDrawAllComics, 250);
    window.addEventListener('resize', debouncedRedraw);
}


/**
 * Inicjalizacja logiki strzałek nawigacyjnych (sekcja 6)
 * - Aktywuje odpowiednie strzałki w zależności od widocznej sekcji.
 * - Udostępnia funkcję simulateKey() do symulacji wciśnięcia klawiszy.
 */ function $c37127fb35c64e86$export$93f7ad4ec63225e6() {
    const arrows = {
        up: document.getElementById("arrow-up"),
        down: document.getElementById("arrow-down"),
        left: document.getElementById("arrow-left"),
        right: document.getElementById("arrow-right")
    };
    const sectionConfigs = {
        section6a: [
            "right"
        ],
        section6b: [
            "right",
            "left"
        ],
        section6c: [
            "right",
            "left"
        ],
        section6d: [
            "right",
            "left"
        ],
        section6e: [
            "left",
            "down"
        ]
    };
    // Filtruj tylko sekcje, które istnieją w DOM
    const sections = Object.keys(sectionConfigs).map((id)=>document.getElementById(id)).filter(Boolean);
    // --- Pomocnicze funkcje ---
    function updateArrowsFor(sectionId) {
        // usuń active ze wszystkich
        Object.values(arrows).forEach((el)=>el?.classList.remove("active"));
        // dodaj active tym, które są zdefiniowane dla danej sekcji
        const activeArrows = sectionConfigs[sectionId] || [];
        activeArrows.forEach((dir)=>{
            if (arrows[dir]) arrows[dir].classList.add("active");
        });
    }
    function simulateKey(key) {
        const keyCodes = {
            ArrowUp: 38,
            ArrowDown: 40,
            ArrowLeft: 37,
            ArrowRight: 39
        };
        const event = new KeyboardEvent("keydown", {
            key: key,
            code: key,
            keyCode: keyCodes[key],
            which: keyCodes[key],
            bubbles: true
        });
        document.dispatchEvent(event);
    }
    // Udostępnij globalnie, jeśli inne moduły mają z tego korzystać
    window.simulateKey = simulateKey;
    //  Obserwacja widoczności sekcji 
    // IntersectionObserver = elegancki sposób sprawdzania, która sekcja jest widoczna
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) updateArrowsFor(entry.target.id);
        });
    }, {
        threshold: 0.6
    } // 60% widoczności sekcji
    );
    sections.forEach((section)=>observer.observe(section));
}


/**
 * Finalna, stabilna wersja animacji. Czyta treść z kontenera DIV
 * i wznawia animację od ostatniego aktywnego slajdu.
 * @param {string} selector - Selektor CSS dla kontenera animacji (np. '[data-resolver-container]').
 * @param {object} [customOptions={}] - Opcjonalne opcje.
 */ function $7cb61fe63502ce5a$export$41d3aefe73d36205(selector, customOptions = {}) {
    const element = document.querySelector(selector);
    if (!element) {
        console.error(`Nie znaleziono elementu dla selektora: "${selector}"`);
        return;
    }
    const originalHTML = element.innerHTML.trim();
    if (!originalHTML) return;
    // Po odczytaniu treści, czyścimy kontener i czynimy go widocznym.
    // Jest pusty, więc nic nie "miga".
    element.innerHTML = '';
    element.style.visibility = 'visible'; // Usunięcie !important nie jest konieczne, styl inline wygra.
    const slideDelimiter = /<hr\s*\/?>/i;
    const texts = originalHTML.split(slideDelimiter).filter((text)=>text && text.trim() !== '');
    let animationIsActive = false;
    let animationIsRunning = false;
    let counter = 0;
    let slideTimeoutId = null;
    // --- Silnik animacji (wewnętrzny, stabilny) ---
    const resolver = {
        resolve: function resolve(options, callback) {
            const resolveString = options.resolveString;
            const tagsToSkip = [
                '<b>',
                '</b>',
                '<br>',
                '<br/>',
                '<br />',
                '<i>',
                '</i>'
            ];
            function getRandomInteger(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
            function randomCharacter(characters) {
                return characters[getRandomInteger(0, characters.length - 1)];
            }
            function isHTMLTag(str, index) {
                if (str[index] !== '<') return false;
                const endTagIndex = str.indexOf('>', index);
                if (endTagIndex === -1) return false;
                const tag = str.substring(index, endTagIndex + 1);
                return tagsToSkip.includes(tag);
            }
            function doRandomiserEffect(options, callback) {
                const { characters: characters, element: element, partialString: partialString } = options;
                let iterations = options.iterations;
                setTimeout(()=>{
                    if (!animationIsActive) return; // Mechanizm zatrzymywania
                    if (iterations >= 0) {
                        const nextOptions = {
                            ...options,
                            iterations: iterations - 1
                        };
                        if (iterations === 0) element.innerHTML = partialString;
                        else {
                            let result = '';
                            let i = 0;
                            while(i < partialString.length)if (isHTMLTag(partialString, i)) {
                                const tagEnd = partialString.indexOf('>', i) + 1;
                                result += partialString.substring(i, tagEnd);
                                i = tagEnd;
                            } else {
                                result += i === partialString.length - 1 ? randomCharacter(characters) : partialString[i];
                                i++;
                            }
                            element.innerHTML = result;
                        }
                        doRandomiserEffect(nextOptions, callback);
                    } else if (typeof callback === "function") callback();
                }, options.timeout);
            }
            function doResolverEffect(options, callback) {
                if (!animationIsActive) return;
                const { resolveString: resolveString, offset: offset } = options;
                let partialString = '';
                let visibleCharCount = 0;
                let i = 0;
                while(i < resolveString.length && visibleCharCount <= offset)if (isHTMLTag(resolveString, i)) {
                    const tagEnd = resolveString.indexOf('>', i) + 1;
                    partialString += resolveString.substring(i, tagEnd);
                    i = tagEnd;
                } else {
                    partialString += resolveString[i];
                    visibleCharCount++;
                    i++;
                }
                doRandomiserEffect({
                    ...options,
                    partialString: partialString
                }, ()=>{
                    if (!animationIsActive) return;
                    const nextOptions = {
                        ...options,
                        offset: offset + 1
                    };
                    const totalVisibleChars = resolveString.replace(/<[^>]*>/g, '').length;
                    if (visibleCharCount < totalVisibleChars) doResolverEffect(nextOptions, callback);
                    else if (typeof callback === "function") callback();
                });
            }
            doResolverEffect({
                ...options,
                resolveString: resolveString
            }, callback);
        }
    };
    const defaultOptions = {
        offset: 0,
        timeout: 10,
        iterations: 2,
        characters: [
            'a',
            'b',
            'c',
            'd',
            'e',
            'f',
            'g',
            'h',
            'i',
            'j',
            'k',
            'l',
            'm',
            'n',
            'o',
            'p',
            'q',
            'r',
            's',
            't',
            'u',
            'v',
            'x',
            'y',
            'z',
            '#',
            '%',
            '&',
            '-'
        ]
    };
    const options = {
        ...defaultOptions,
        ...customOptions,
        element: element
    };
    function animationCycle() {
        if (!animationIsActive) {
            animationIsRunning = false;
            return;
        }
        const currentOptions = {
            ...options,
            offset: 0,
            resolveString: texts[counter]
        };
        resolver.resolve(currentOptions, ()=>{
            if (!animationIsActive) return;
            slideTimeoutId = setTimeout(()=>{
                counter = (counter + 1) % texts.length;
                animationCycle();
            }, 5500);
        });
    }
    // Opcjonalnie (options.scrollContainer): animacja rusza dopiero, gdy napis osiagnie docelowa pozycje.
    // - z options.settleTarget: gdy ten przodek (position: sticky) dojedzie do swojego `top` i sie zatrzyma,
    //   a scroll moze isc dalej (kolejne napisy),
    // - bez: gdy kontener jest doscrollowany do konca.
    const scroller = options.scrollContainer ? element.closest(options.scrollContainer) : null;
    const settleEl = scroller && options.settleTarget ? element.closest(options.settleTarget) : null;
    const atScrollEnd = ()=>{
        if (!scroller) return true;
        if (settleEl) {
            const pinTop = parseFloat(getComputedStyle(settleEl).top) || 0;
            return settleEl.getBoundingClientRect().top - scroller.getBoundingClientRect().top <= pinTop + 2;
        }
        return scroller.scrollTop >= scroller.scrollHeight - scroller.clientHeight - 2;
    };
    let isVisible = false;
    function update() {
        if (isVisible && atScrollEnd()) {
            animationIsActive = true;
            if (!animationIsRunning) {
                animationIsRunning = true;
                if (slideTimeoutId) clearTimeout(slideTimeoutId);
                animationCycle();
            }
        } else {
            animationIsActive = false;
            animationIsRunning = false;
            if (slideTimeoutId) {
                clearTimeout(slideTimeoutId);
                slideTimeoutId = null;
            }
            // Przy scrollContainer cofniecie scrolla czysci napis i zeruje animacje,
            // zeby po ponownym dociagnieciu ruszyla od poczatku.
            if (scroller) {
                element.innerHTML = '';
                counter = 0;
            }
        }
    }
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            isVisible = entry.isIntersecting;
        });
        update();
    }, {
        threshold: options.threshold ?? 0.5
    });
    observer.observe(element);
    if (scroller) scroller.addEventListener('scroll', update, {
        passive: true
    });
}


/**
 * Cursor Glow Effect
 * @description Tworzy efekt świecącego kursora, aktywowany tylko lokalnie.
 */ function $b199725cc0758a2e$export$e9d04ed4d4d1e83d(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    if (!section) return console.warn(`Brak sekcji: ${sectionSelector}`);
    const corner = section.querySelector('.corner');
    const inside = section.querySelector('.inside');
    const navbar = document.querySelector('.navbar');
    const cursorGlow = section.querySelector('#cursor-glow');
    if (!corner || !inside || !cursorGlow) return;
    let inputLocked = false;
    function interceptNavigationEvents(e) {
        if (!inputLocked) return;
        const blockedKeys = [
            'ArrowUp',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'PageUp',
            'PageDown',
            ' ',
            'Home',
            'End'
        ];
        if (e.type === 'keydown' && blockedKeys.includes(e.key)) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
        if (e.type === 'wheel' || e.type === 'touchmove') {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    }
    function lockInteraction() {
        inputLocked = true;
    }
    function unlockInteraction() {
        inputLocked = false;
    }
    function onCornerClick() {
        if (navbar) navbar.style.display = 'none';
        corner.style.display = 'none';
        inside.style.display = 'block';
        inside.classList.add('active');
        inside.style.clipPath = 'inset(0 0 0 0)';
        document.body.style.cursor = 'none';
        cursorGlow.style.display = 'block';
        lockInteraction();
    }
    function onInsideClick() {
        inside.style.opacity = '0';
        setTimeout(()=>{
            inside.style.display = 'none';
            inside.classList.remove('active');
            inside.style.opacity = '';
            document.body.style.cursor = '';
            cursorGlow.style.display = 'none';
            if (navbar) navbar.style.display = 'flex';
            corner.style.display = 'block';
            unlockInteraction();
        }, 600);
    }
    function onMouseMove(e) {
        if (cursorGlow.style.display === 'block') {
            cursorGlow.style.left = `${e.clientX}px`;
            cursorGlow.style.top = `${e.clientY}px`;
        }
    }
    // Start / Stop w zależności od widoczności sekcji
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('wheel', interceptNavigationEvents, {
                    passive: false,
                    capture: true
                });
                document.addEventListener('touchmove', interceptNavigationEvents, {
                    passive: false,
                    capture: true
                });
                document.addEventListener('keydown', interceptNavigationEvents, true);
                corner.addEventListener('click', onCornerClick);
                inside.addEventListener('click', onInsideClick);
            } else {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('wheel', interceptNavigationEvents, true);
                document.removeEventListener('touchmove', interceptNavigationEvents, true);
                document.removeEventListener('keydown', interceptNavigationEvents, true);
                corner.removeEventListener('click', onCornerClick);
                inside.removeEventListener('click', onInsideClick);
                unlockInteraction();
            }
        });
    }, {
        threshold: 0.3
    });
    observer.observe(section);
}


/**
 * Dust Animation
 * @description Tworzy animację pyłu w sekcji.
 */ function $e84e48740dbfbbb6$export$a7f2c272381f5db7(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    const canvas = section?.querySelector("#dustCanvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d", {
        willReadFrequently: true
    });
    let particles = [];
    let animationFrameId = null;
    function resizeCanvas() {
        canvas.width = section.clientWidth;
        canvas.height = section.clientHeight;
    }
    function generateParticles() {
        particles = [];
        for(let i = 0; i < 1000; i++)particles.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 0.8 + 0.2,
            speedY: Math.random() * 0.8 + 0.4
        });
    }
    let cursorX = 0;
    let cursorY = 0;
    function onMouseMove(e) {
        const rect = canvas.getBoundingClientRect();
        cursorX = e.clientX - rect.left;
        cursorY = e.clientY - rect.top;
    }
    function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createRadialGradient(cursorX, cursorY, 0, cursorX, cursorY, 150);
        gradient.addColorStop(0, "rgba(255,255,255,0.25)");
        gradient.addColorStop(1, "rgba(255,255,255,0)");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.save();
        ctx.beginPath();
        ctx.arc(cursorX, cursorY, 150, 0, Math.PI * 2);
        ctx.clip();
        for (let p of particles){
            ctx.beginPath();
            ctx.fillStyle = "rgba(255,255,255,0.25)";
            ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
            ctx.fill();
            p.y += p.speedY;
            if (p.y > canvas.height) {
                p.y = 0;
                p.x = Math.random() * canvas.width;
            }
        }
        ctx.restore();
        animationFrameId = requestAnimationFrame(animate);
    }
    function start() {
        if (!animationFrameId) animate();
    }
    function stop() {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    // Uruchamianie tylko, gdy sekcja widoczna
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                resizeCanvas();
                generateParticles();
                window.addEventListener("mousemove", onMouseMove);
                start();
            } else {
                window.removeEventListener("mousemove", onMouseMove);
                stop();
            }
        });
    }, {
        threshold: 0.4
    });
    observer.observe(section);
}



var $6ShZv = parcelRequire("6ShZv");
function $d205a870e220ee31$export$eba565bdc753e540(canvasSelector, options = {}) {
    const canvas = document.querySelector(canvasSelector);
    if (!canvas) return console.error(`Nie znaleziono canvasa: ${canvasSelector}`);
    // Inicjalizacja Paper.js
    (0, (/*@__PURE__*/$parcel$interopDefault($6ShZv))).setup(canvas);
    const { view: view, Path: Path, Point: Point } = (0, (/*@__PURE__*/$parcel$interopDefault($6ShZv)));
    const values = {
        friction: 0.8,
        timeStep: 0.01,
        amount: 15,
        mass: 2,
        invMass: 0.5
    };
    let path;
    let springs = [];
    let size = view.size.multiply([
        1.2,
        1
    ]);
    // Klasa Spring
    class Spring {
        constructor(a, b, strength, restLength){
            this.a = a;
            this.b = b;
            this.restLength = restLength || 80;
            this.strength = strength || 0.55;
            this.mamb = values.invMass * values.invMass;
        }
        update() {
            const delta = this.b.subtract(this.a);
            const dist = delta.length;
            const normDistStrength = (dist - this.restLength) / (dist * this.mamb) * this.strength;
            delta.y *= normDistStrength * values.invMass * 0.2;
            if (!this.a.fixed) this.a.y += delta.y;
            if (!this.b.fixed) this.b.y -= delta.y;
        }
    }
    function createPath(strength) {
        const path = new Path({
            fillColor: 'black'
        });
        springs = [];
        for(let i = 0; i <= values.amount; i++){
            const segment = path.add(new Point(i / values.amount, 0.5).multiply(size));
            const point = segment.point;
            if (i === 0 || i === values.amount) point.y += size.height;
            point.px = point.x;
            point.py = point.y;
            point.fixed = i < 2 || i > values.amount - 2;
            if (i > 0) springs.push(new Spring(segment.previous.point, point, strength));
        }
        path.position.x -= size.width / 4;
        return path;
    }
    function updateWave(path) {
        const force = 1 - values.friction * values.timeStep * values.timeStep;
        for (const seg of path.segments){
            const point = seg.point;
            const dy = (point.y - point.py) * force;
            point.py = point.y;
            point.y = Math.max(point.y + dy, 0);
        }
        for (const s of springs)s.update();
        path.smooth({
            type: 'continuous'
        });
    }
    function resize() {
        if (path) path.remove();
        size = view.bounds.size.multiply([
            2,
            1
        ]);
        path = createPath(0.1);
    }
    function mouseMove(event) {
        const location = path.getNearestLocation(event.point);
        const segment = location.segment;
        const point = segment.point;
        if (!point.fixed && location.distance < size.height / 4) {
            const y = event.point.y;
            point.y += (y - point.y) / 6;
            if (segment.previous && !segment.previous.fixed) {
                const prev = segment.previous.point;
                prev.y += (y - prev.y) / 24;
            }
            if (segment.next && !segment.next.fixed) {
                const next = segment.next.point;
                next.y += (y - next.y) / 24;
            }
        }
    }
    // Eventy Paper.js
    view.onResize = resize;
    view.onMouseMove = mouseMove;
    view.onFrame = ()=>updateWave(path);
    resize();
    // Opcjonalnie (options.reveal = selektor elementu pod falą):
    // element jest klikalny dopiero tam, gdzie fala go odsłoniła. Canvas dalej odbiera
    // ruch myszy (potrzebny fali), więc o odsłonięciu decyduje przezroczystość piksela canvasa.
    if (options.reveal) {
        const ctx = canvas.getContext('2d');
        const revealedTargetAt = (clientX, clientY)=>{
            const el = document.querySelector(options.reveal);
            if (!el) return null;
            const r = el.getBoundingClientRect();
            if (clientX < r.left || clientX > r.right || clientY < r.top || clientY > r.bottom) return null;
            const c = canvas.getBoundingClientRect();
            const px = Math.floor((clientX - c.left) * canvas.width / c.width);
            const py = Math.floor((clientY - c.top) * canvas.height / c.height);
            const covered = ctx.getImageData(px, py, 1, 1).data[3] > 20;
            return covered ? null : el;
        };
        canvas.addEventListener('mousemove', (e)=>{
            canvas.style.cursor = revealedTargetAt(e.clientX, e.clientY) ? 'pointer' : '';
        });
        canvas.addEventListener('click', (e)=>{
            const el = revealedTargetAt(e.clientX, e.clientY);
            if (el) (el.closest('a') || el).click();
        });
    }
}


/**
 * PerlinContour — animacja poziomic
 * @author Mikhaell
 * @basedOn https://codepen.io/angularek/pen/ByNQvQe
 */ // import noise from 'noisejs'; // <- lokalna wersja lub npm, patrz niżej
var $84dd35cdcc411869$exports = {};
/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ (function(global) {
    // Passing in seed will seed this Noise instance
    function Noise(seed) {
        function Grad(x, y, z) {
            this.x = x;
            this.y = y;
            this.z = z;
        }
        Grad.prototype.dot2 = function(x, y) {
            return this.x * x + this.y * y;
        };
        Grad.prototype.dot3 = function(x, y, z) {
            return this.x * x + this.y * y + this.z * z;
        };
        this.grad3 = [
            new Grad(1, 1, 0),
            new Grad(-1, 1, 0),
            new Grad(1, -1, 0),
            new Grad(-1, -1, 0),
            new Grad(1, 0, 1),
            new Grad(-1, 0, 1),
            new Grad(1, 0, -1),
            new Grad(-1, 0, -1),
            new Grad(0, 1, 1),
            new Grad(0, -1, 1),
            new Grad(0, 1, -1),
            new Grad(0, -1, -1)
        ];
        this.p = [
            151,
            160,
            137,
            91,
            90,
            15,
            131,
            13,
            201,
            95,
            96,
            53,
            194,
            233,
            7,
            225,
            140,
            36,
            103,
            30,
            69,
            142,
            8,
            99,
            37,
            240,
            21,
            10,
            23,
            190,
            6,
            148,
            247,
            120,
            234,
            75,
            0,
            26,
            197,
            62,
            94,
            252,
            219,
            203,
            117,
            35,
            11,
            32,
            57,
            177,
            33,
            88,
            237,
            149,
            56,
            87,
            174,
            20,
            125,
            136,
            171,
            168,
            68,
            175,
            74,
            165,
            71,
            134,
            139,
            48,
            27,
            166,
            77,
            146,
            158,
            231,
            83,
            111,
            229,
            122,
            60,
            211,
            133,
            230,
            220,
            105,
            92,
            41,
            55,
            46,
            245,
            40,
            244,
            102,
            143,
            54,
            65,
            25,
            63,
            161,
            1,
            216,
            80,
            73,
            209,
            76,
            132,
            187,
            208,
            89,
            18,
            169,
            200,
            196,
            135,
            130,
            116,
            188,
            159,
            86,
            164,
            100,
            109,
            198,
            173,
            186,
            3,
            64,
            52,
            217,
            226,
            250,
            124,
            123,
            5,
            202,
            38,
            147,
            118,
            126,
            255,
            82,
            85,
            212,
            207,
            206,
            59,
            227,
            47,
            16,
            58,
            17,
            182,
            189,
            28,
            42,
            223,
            183,
            170,
            213,
            119,
            248,
            152,
            2,
            44,
            154,
            163,
            70,
            221,
            153,
            101,
            155,
            167,
            43,
            172,
            9,
            129,
            22,
            39,
            253,
            19,
            98,
            108,
            110,
            79,
            113,
            224,
            232,
            178,
            185,
            112,
            104,
            218,
            246,
            97,
            228,
            251,
            34,
            242,
            193,
            238,
            210,
            144,
            12,
            191,
            179,
            162,
            241,
            81,
            51,
            145,
            235,
            249,
            14,
            239,
            107,
            49,
            192,
            214,
            31,
            181,
            199,
            106,
            157,
            184,
            84,
            204,
            176,
            115,
            121,
            50,
            45,
            127,
            4,
            150,
            254,
            138,
            236,
            205,
            93,
            222,
            114,
            67,
            29,
            24,
            72,
            243,
            141,
            128,
            195,
            78,
            66,
            215,
            61,
            156,
            180
        ];
        // To remove the need for index wrapping, double the permutation table length
        this.perm = new Array(512);
        this.gradP = new Array(512);
        this.seed(seed || 0);
    }
    // This isn't a very good seeding function, but it works ok. It supports 2^16
    // different seed values. Write something better if you need more seeds.
    Noise.prototype.seed = function(seed) {
        if (seed > 0 && seed < 1) // Scale the seed out
        seed *= 65536;
        seed = Math.floor(seed);
        if (seed < 256) seed |= seed << 8;
        var p = this.p;
        for(var i = 0; i < 256; i++){
            var v;
            if (i & 1) v = p[i] ^ seed & 255;
            else v = p[i] ^ seed >> 8 & 255;
            var perm = this.perm;
            var gradP = this.gradP;
            perm[i] = perm[i + 256] = v;
            gradP[i] = gradP[i + 256] = this.grad3[v % 12];
        }
    };
    /*
  for(var i=0; i<256; i++) {
    perm[i] = perm[i + 256] = p[i];
    gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
  }*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
    var F2 = 0.5 * (Math.sqrt(3) - 1);
    var G2 = (3 - Math.sqrt(3)) / 6;
    var F3 = 1 / 3;
    var G3 = 1 / 6;
    // 2D simplex noise
    Noise.prototype.simplex2 = function(xin, yin) {
        var n0, n1, n2; // Noise contributions from the three corners
        // Skew the input space to determine which simplex cell we're in
        var s = (xin + yin) * F2; // Hairy factor for 2D
        var i = Math.floor(xin + s);
        var j = Math.floor(yin + s);
        var t = (i + j) * G2;
        var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
        var y0 = yin - j + t;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        }
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
        var y1 = y0 - j1 + G2;
        var x2 = x0 - 1 + 2 * G2; // Offsets for last corner in (x,y) unskewed coords
        var y2 = y0 - 1 + 2 * G2;
        // Work out the hashed gradient indices of the three simplex corners
        i &= 255;
        j &= 255;
        var perm = this.perm;
        var gradP = this.gradP;
        var gi0 = gradP[i + perm[j]];
        var gi1 = gradP[i + i1 + perm[j + j1]];
        var gi2 = gradP[i + 1 + perm[j + 1]];
        // Calculate the contribution from the three corners
        var t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 < 0) n0 = 0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
        }
        var t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 < 0) n1 = 0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * gi1.dot2(x1, y1);
        }
        var t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 < 0) n2 = 0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * gi2.dot2(x2, y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70 * (n0 + n1 + n2);
    };
    // 3D simplex noise
    Noise.prototype.simplex3 = function(xin, yin, zin) {
        var n0, n1, n2, n3; // Noise contributions from the four corners
        // Skew the input space to determine which simplex cell we're in
        var s = (xin + yin + zin) * F3; // Hairy factor for 2D
        var i = Math.floor(xin + s);
        var j = Math.floor(yin + s);
        var k = Math.floor(zin + s);
        var t = (i + j + k) * G3;
        var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
        var y0 = yin - j + t;
        var z0 = zin - k + t;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
        var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            }
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            }
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        var x1 = x0 - i1 + G3; // Offsets for second corner
        var y1 = y0 - j1 + G3;
        var z1 = z0 - k1 + G3;
        var x2 = x0 - i2 + 2 * G3; // Offsets for third corner
        var y2 = y0 - j2 + 2 * G3;
        var z2 = z0 - k2 + 2 * G3;
        var x3 = x0 - 1 + 3 * G3; // Offsets for fourth corner
        var y3 = y0 - 1 + 3 * G3;
        var z3 = z0 - 1 + 3 * G3;
        // Work out the hashed gradient indices of the four simplex corners
        i &= 255;
        j &= 255;
        k &= 255;
        var perm = this.perm;
        var gradP = this.gradP;
        var gi0 = gradP[i + perm[j + perm[k]]];
        var gi1 = gradP[i + i1 + perm[j + j1 + perm[k + k1]]];
        var gi2 = gradP[i + i2 + perm[j + j2 + perm[k + k2]]];
        var gi3 = gradP[i + 1 + perm[j + 1 + perm[k + 1]]];
        // Calculate the contribution from the four corners
        var t0 = 0.5 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * gi0.dot3(x0, y0, z0); // (x,y) of grad3 used for 2D gradient
        }
        var t1 = 0.5 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * gi1.dot3(x1, y1, z1);
        }
        var t2 = 0.5 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * gi2.dot3(x2, y2, z2);
        }
        var t3 = 0.5 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0;
        else {
            t3 *= t3;
            n3 = t3 * t3 * gi3.dot3(x3, y3, z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 32 * (n0 + n1 + n2 + n3);
    };
    // ##### Perlin noise stuff
    function fade(t) {
        return t * t * t * (t * (t * 6 - 15) + 10);
    }
    function lerp(a, b, t) {
        return (1 - t) * a + t * b;
    }
    // 2D Perlin Noise
    Noise.prototype.perlin2 = function(x, y) {
        // Find unit grid cell containing point
        var X = Math.floor(x), Y = Math.floor(y);
        // Get relative xy coordinates of point within that cell
        x = x - X;
        y = y - Y;
        // Wrap the integer cells at 255 (smaller integer period can be introduced here)
        X = X & 255;
        Y = Y & 255;
        // Calculate noise contributions from each of the four corners
        var perm = this.perm;
        var gradP = this.gradP;
        var n00 = gradP[X + perm[Y]].dot2(x, y);
        var n01 = gradP[X + perm[Y + 1]].dot2(x, y - 1);
        var n10 = gradP[X + 1 + perm[Y]].dot2(x - 1, y);
        var n11 = gradP[X + 1 + perm[Y + 1]].dot2(x - 1, y - 1);
        // Compute the fade curve value for x
        var u = fade(x);
        // Interpolate the four results
        return lerp(lerp(n00, n10, u), lerp(n01, n11, u), fade(y));
    };
    // 3D Perlin Noise
    Noise.prototype.perlin3 = function(x, y, z) {
        // Find unit grid cell containing point
        var X = Math.floor(x), Y = Math.floor(y), Z = Math.floor(z);
        // Get relative xyz coordinates of point within that cell
        x = x - X;
        y = y - Y;
        z = z - Z;
        // Wrap the integer cells at 255 (smaller integer period can be introduced here)
        X = X & 255;
        Y = Y & 255;
        Z = Z & 255;
        // Calculate noise contributions from each of the eight corners
        var perm = this.perm;
        var gradP = this.gradP;
        var n000 = gradP[X + perm[Y + perm[Z]]].dot3(x, y, z);
        var n001 = gradP[X + perm[Y + perm[Z + 1]]].dot3(x, y, z - 1);
        var n010 = gradP[X + perm[Y + 1 + perm[Z]]].dot3(x, y - 1, z);
        var n011 = gradP[X + perm[Y + 1 + perm[Z + 1]]].dot3(x, y - 1, z - 1);
        var n100 = gradP[X + 1 + perm[Y + perm[Z]]].dot3(x - 1, y, z);
        var n101 = gradP[X + 1 + perm[Y + perm[Z + 1]]].dot3(x - 1, y, z - 1);
        var n110 = gradP[X + 1 + perm[Y + 1 + perm[Z]]].dot3(x - 1, y - 1, z);
        var n111 = gradP[X + 1 + perm[Y + 1 + perm[Z + 1]]].dot3(x - 1, y - 1, z - 1);
        // Compute the fade curve value for x, y, z
        var u = fade(x);
        var v = fade(y);
        var w = fade(z);
        // Interpolate
        return lerp(lerp(lerp(n000, n100, u), lerp(n001, n101, u), w), lerp(lerp(n010, n110, u), lerp(n011, n111, u), w), v);
    };
    global.Noise = Noise;
})((0, $84dd35cdcc411869$exports));


const $e82d643cecacd259$var$noise = new (0, $84dd35cdcc411869$exports.Noise)(Math.random());
class $e82d643cecacd259$export$48edc82c95396f4c {
    constructor(canvasElement){
        const BASE_CONFIG = {
            showFPS: false,
            MAX_FPS: 40,
            thresholdIncrement: 10,
            thickLineThresholdMultiple: 103,
            res: 12,
            baseZOffset: 0.0011,
            lineColor: '#f0f0f0'
        };
        this.canvas = canvasElement;
        this.ctx = canvasElement.getContext('2d');
        if (!this.ctx) return;
        this.config = {
            ...BASE_CONFIG
        };
        if (canvasElement.dataset.res) this.config.res = +canvasElement.dataset.res;
        if (canvasElement.dataset.lineColor) this.config.lineColor = canvasElement.dataset.lineColor;
        if (canvasElement.dataset.thresholdIncrement) this.config.thresholdIncrement = +canvasElement.dataset.thresholdIncrement;
        if (canvasElement.dataset.baseZOffset) this.config.baseZOffset = +canvasElement.dataset.baseZOffset;
        this.mousePos = {
            x: -99,
            y: -99
        };
        this.zOffset = 0;
        this.noiseMin = 100;
        this.noiseMax = 0;
        this.cols = 0;
        this.rows = 0;
        this.inputValues = [];
        this.zBoostValues = [];
        this.currentThreshold = 0;
        this.frameValues = [];
        this.canvas.addEventListener('mousemove', (e)=>{
            this.mousePos = {
                x: e.offsetX,
                y: e.offsetY
            };
        });
        this.canvasSize();
        window.addEventListener('resize', ()=>this.canvasSize());
        this.animateLoop();
    }
    canvasSize() {
        const rect = this.canvas.getBoundingClientRect();
        this.canvas.width = rect.width * window.devicePixelRatio;
        this.canvas.height = rect.height * window.devicePixelRatio;
        this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        this.canvas.style.width = rect.width + 'px';
        this.canvas.style.height = rect.height + 'px';
        this.cols = Math.floor(this.canvas.width / this.config.res) + 1;
        this.rows = Math.floor(this.canvas.height / this.config.res) + 1;
        this.zBoostValues = Array.from({
            length: this.rows
        }, ()=>Array(this.cols).fill(0));
    }
    animateLoop() {
        setTimeout(()=>requestAnimationFrame(()=>this.animateLoop()), 1000 / this.config.MAX_FPS);
        if (!this.isInViewport()) return;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.zOffset += this.config.baseZOffset;
        this.generateNoise();
        const roundedMin = Math.floor(this.noiseMin / this.config.thresholdIncrement) * this.config.thresholdIncrement;
        const roundedMax = Math.ceil(this.noiseMax / this.config.thresholdIncrement) * this.config.thresholdIncrement;
        for(let t = roundedMin; t < roundedMax; t += this.config.thresholdIncrement){
            this.currentThreshold = t;
            this.renderAtThreshold();
        }
        this.noiseMin = 100;
        this.noiseMax = 0;
    }
    generateNoise() {
        const s = 0.02;
        for(let y = 0; y < this.rows; y++){
            this.inputValues[y] = [];
            for(let x = 0; x < this.cols; x++){
                const value = $e82d643cecacd259$var$noise.perlin3(x * s, y * s, this.zOffset + this.zBoostValues[y][x]) * 100;
                this.inputValues[y][x] = value;
                if (value < this.noiseMin) this.noiseMin = value;
                if (value > this.noiseMax) this.noiseMax = value;
                if (this.zBoostValues[y][x] > 0) this.zBoostValues[y][x] *= 0.99;
            }
        }
    }
    renderAtThreshold() {
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.config.lineColor;
        this.ctx.lineWidth = this.currentThreshold % (this.config.thresholdIncrement * this.config.thickLineThresholdMultiple) === 0 ? 2 : 1;
        const res = this.config.res;
        for(let y = 0; y < this.rows - 1; y++)for(let x = 0; x < this.cols - 1; x++){
            const nw = this.inputValues[y][x];
            const ne = this.inputValues[y][x + 1];
            const se = this.inputValues[y + 1][x + 1];
            const sw = this.inputValues[y + 1][x];
            if ([
                nw,
                ne,
                se,
                sw
            ].every((v)=>v > this.currentThreshold)) continue;
            if ([
                nw,
                ne,
                se,
                sw
            ].every((v)=>v < this.currentThreshold)) continue;
            const gridType = this.binaryToType(nw > this.currentThreshold, ne > this.currentThreshold, se > this.currentThreshold, sw > this.currentThreshold);
            this.placeLines(gridType, x, y);
        }
        this.ctx.stroke();
    }
    binaryToType(nw, ne, se, sw) {
        return [
            nw,
            ne,
            se,
            sw
        ].reduce((acc, v)=>acc << 1 | (v ? 1 : 0), 0);
    }
    placeLines(type, x, y) {
        const r = this.config.res;
        const nw = this.inputValues[y][x];
        const ne = this.inputValues[y][x + 1];
        const se = this.inputValues[y + 1][x + 1];
        const sw = this.inputValues[y + 1][x];
        const lerp = this.linInterpolate.bind(this);
        let a, b, c, d;
        switch(type){
            case 1:
            case 14:
                c = [
                    x * r + r * lerp(sw, se),
                    y * r + r
                ];
                d = [
                    x * r,
                    y * r + r * lerp(nw, sw)
                ];
                this.line(d, c);
                break;
            case 2:
            case 13:
                b = [
                    x * r + r,
                    y * r + r * lerp(ne, se)
                ];
                c = [
                    x * r + r * lerp(sw, se),
                    y * r + r
                ];
                this.line(b, c);
                break;
            case 3:
            case 12:
                b = [
                    x * r + r,
                    y * r + r * lerp(ne, se)
                ];
                d = [
                    x * r,
                    y * r + r * lerp(nw, sw)
                ];
                this.line(d, b);
                break;
            case 4:
            case 11:
                a = [
                    x * r + r * lerp(nw, ne),
                    y * r
                ];
                b = [
                    x * r + r,
                    y * r + r * lerp(ne, se)
                ];
                this.line(a, b);
                break;
            case 5:
                a = [
                    x * r + r * lerp(nw, ne),
                    y * r
                ];
                b = [
                    x * r + r,
                    y * r + r * lerp(ne, se)
                ];
                c = [
                    x * r + r * lerp(sw, se),
                    y * r + r
                ];
                d = [
                    x * r,
                    y * r + r * lerp(nw, sw)
                ];
                this.line(d, a);
                this.line(c, b);
                break;
            case 6:
            case 9:
                a = [
                    x * r + r * lerp(nw, ne),
                    y * r
                ];
                c = [
                    x * r + r * lerp(sw, se),
                    y * r + r
                ];
                this.line(c, a);
                break;
            case 7:
            case 8:
                a = [
                    x * r + r * lerp(nw, ne),
                    y * r
                ];
                d = [
                    x * r,
                    y * r + r * lerp(nw, sw)
                ];
                this.line(d, a);
                break;
            case 10:
                a = [
                    x * r + r * lerp(nw, ne),
                    y * r
                ];
                b = [
                    x * r + r,
                    y * r + r * lerp(ne, se)
                ];
                c = [
                    x * r + r * lerp(sw, se),
                    y * r + r
                ];
                d = [
                    x * r,
                    y * r + r * lerp(nw, sw)
                ];
                this.line(a, b);
                this.line(c, d);
                break;
        }
    }
    linInterpolate(x0, x1, y0 = 0, y1 = 1) {
        if (x0 === x1) return 0;
        return y0 + (y1 - y0) * (this.currentThreshold - x0) / (x1 - x0);
    }
    line(from, to) {
        this.ctx.moveTo(from[0], from[1]);
        this.ctx.lineTo(to[0], to[1]);
    }
    isInViewport() {
        const rect = this.canvas.getBoundingClientRect();
        return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    }
}
function $e82d643cecacd259$export$f4b3eaae6950b78f() {
    $e82d643cecacd259$var$noise.seed(Math.random());
    document.querySelectorAll('.res-canvas').forEach((canvas)=>{
        new $e82d643cecacd259$export$48edc82c95396f4c(canvas);
    });
}


(()=>{
    var t, e = {};
    window, e = function() {
        var t = {
            "./node_modules/acorn/dist/acorn.mjs": function(t, e, i) {
                "use strict";
                i.r(e), i.d(e, "Node", function() {
                    return ti;
                }), i.d(e, "Parser", function() {
                    return F;
                }), i.d(e, "Position", function() {
                    return O;
                }), i.d(e, "SourceLocation", function() {
                    return N;
                }), i.d(e, "TokContext", function() {
                    return ts;
                }), i.d(e, "Token", function() {
                    return tA;
                }), i.d(e, "TokenType", function() {
                    return v;
                }), i.d(e, "defaultOptions", function() {
                    return R;
                }), i.d(e, "getLineInfo", function() {
                    return z;
                }), i.d(e, "isIdentifierChar", function() {
                    return g;
                }), i.d(e, "isIdentifierStart", function() {
                    return f;
                }), i.d(e, "isNewLine", function() {
                    return k;
                }), i.d(e, "keywordTypes", function() {
                    return b;
                }), i.d(e, "lineBreak", function() {
                    return C;
                }), i.d(e, "lineBreakG", function() {
                    return S;
                }), i.d(e, "nonASCIIwhitespace", function() {
                    return P;
                }), i.d(e, "parse", function() {
                    return tM;
                }), i.d(e, "parseExpressionAt", function() {
                    return tB;
                }), i.d(e, "tokContexts", function() {
                    return ta;
                }), i.d(e, "tokTypes", function() {
                    return w;
                }), i.d(e, "tokenizer", function() {
                    return tO;
                }), i.d(e, "version", function() {
                    return tL;
                });
                var n = {
                    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
                    5: "class enum extends super const export import",
                    6: "enum",
                    strict: "implements interface let package private protected public static yield",
                    strictBind: "eval arguments"
                }, r = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", s = {
                    5: r,
                    "5module": r + " export import",
                    6: r + " const class extends export import super"
                }, a = /^in(stanceof)?$/, o = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", h = "\u200C\u200D\xb7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", l = RegExp("[" + o + "]"), u = RegExp("[" + o + h + "]");
                o = h = null;
                var c = [
                    0,
                    11,
                    2,
                    25,
                    2,
                    18,
                    2,
                    1,
                    2,
                    14,
                    3,
                    13,
                    35,
                    122,
                    70,
                    52,
                    268,
                    28,
                    4,
                    48,
                    48,
                    31,
                    14,
                    29,
                    6,
                    37,
                    11,
                    29,
                    3,
                    35,
                    5,
                    7,
                    2,
                    4,
                    43,
                    157,
                    19,
                    35,
                    5,
                    35,
                    5,
                    39,
                    9,
                    51,
                    157,
                    310,
                    10,
                    21,
                    11,
                    7,
                    153,
                    5,
                    3,
                    0,
                    2,
                    43,
                    2,
                    1,
                    4,
                    0,
                    3,
                    22,
                    11,
                    22,
                    10,
                    30,
                    66,
                    18,
                    2,
                    1,
                    11,
                    21,
                    11,
                    25,
                    71,
                    55,
                    7,
                    1,
                    65,
                    0,
                    16,
                    3,
                    2,
                    2,
                    2,
                    28,
                    43,
                    28,
                    4,
                    28,
                    36,
                    7,
                    2,
                    27,
                    28,
                    53,
                    11,
                    21,
                    11,
                    18,
                    14,
                    17,
                    111,
                    72,
                    56,
                    50,
                    14,
                    50,
                    14,
                    35,
                    477,
                    28,
                    11,
                    0,
                    9,
                    21,
                    155,
                    22,
                    13,
                    52,
                    76,
                    44,
                    33,
                    24,
                    27,
                    35,
                    30,
                    0,
                    12,
                    34,
                    4,
                    0,
                    13,
                    47,
                    15,
                    3,
                    22,
                    0,
                    2,
                    0,
                    36,
                    17,
                    2,
                    24,
                    85,
                    6,
                    2,
                    0,
                    2,
                    3,
                    2,
                    14,
                    2,
                    9,
                    8,
                    46,
                    39,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    4,
                    0,
                    19,
                    0,
                    13,
                    4,
                    159,
                    52,
                    19,
                    3,
                    21,
                    0,
                    33,
                    47,
                    21,
                    1,
                    2,
                    0,
                    185,
                    46,
                    42,
                    3,
                    37,
                    47,
                    21,
                    0,
                    60,
                    42,
                    14,
                    0,
                    72,
                    26,
                    230,
                    43,
                    117,
                    63,
                    32,
                    0,
                    161,
                    7,
                    3,
                    38,
                    17,
                    0,
                    2,
                    0,
                    29,
                    0,
                    11,
                    39,
                    8,
                    0,
                    22,
                    0,
                    12,
                    45,
                    20,
                    0,
                    35,
                    56,
                    264,
                    8,
                    2,
                    36,
                    18,
                    0,
                    50,
                    29,
                    113,
                    6,
                    2,
                    1,
                    2,
                    37,
                    22,
                    0,
                    26,
                    5,
                    2,
                    1,
                    2,
                    31,
                    15,
                    0,
                    328,
                    18,
                    270,
                    921,
                    103,
                    110,
                    18,
                    195,
                    2749,
                    1070,
                    4050,
                    582,
                    8634,
                    568,
                    8,
                    30,
                    114,
                    29,
                    19,
                    47,
                    17,
                    3,
                    32,
                    20,
                    6,
                    18,
                    689,
                    63,
                    129,
                    74,
                    6,
                    0,
                    67,
                    12,
                    65,
                    1,
                    2,
                    0,
                    29,
                    6135,
                    9,
                    754,
                    9486,
                    286,
                    50,
                    2,
                    18,
                    3,
                    9,
                    395,
                    2309,
                    106,
                    6,
                    12,
                    4,
                    8,
                    8,
                    9,
                    5991,
                    84,
                    2,
                    70,
                    2,
                    1,
                    3,
                    0,
                    3,
                    1,
                    3,
                    3,
                    2,
                    11,
                    2,
                    0,
                    2,
                    6,
                    2,
                    64,
                    2,
                    3,
                    3,
                    7,
                    2,
                    6,
                    2,
                    27,
                    2,
                    3,
                    2,
                    4,
                    2,
                    0,
                    4,
                    6,
                    2,
                    339,
                    3,
                    24,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    7,
                    2357,
                    44,
                    11,
                    6,
                    17,
                    0,
                    370,
                    43,
                    1301,
                    196,
                    60,
                    67,
                    8,
                    0,
                    1205,
                    3,
                    2,
                    26,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    9,
                    2,
                    3,
                    2,
                    0,
                    2,
                    0,
                    7,
                    0,
                    5,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    3,
                    3,
                    2,
                    6,
                    2,
                    3,
                    2,
                    3,
                    2,
                    0,
                    2,
                    9,
                    2,
                    16,
                    6,
                    2,
                    2,
                    4,
                    2,
                    16,
                    4421,
                    42710,
                    42,
                    4148,
                    12,
                    221,
                    3,
                    5761,
                    15,
                    7472,
                    3104,
                    541
                ], d = [
                    509,
                    0,
                    227,
                    0,
                    150,
                    4,
                    294,
                    9,
                    1368,
                    2,
                    2,
                    1,
                    6,
                    3,
                    41,
                    2,
                    5,
                    0,
                    166,
                    1,
                    574,
                    3,
                    9,
                    9,
                    525,
                    10,
                    176,
                    2,
                    54,
                    14,
                    32,
                    9,
                    16,
                    3,
                    46,
                    10,
                    54,
                    9,
                    7,
                    2,
                    37,
                    13,
                    2,
                    9,
                    6,
                    1,
                    45,
                    0,
                    13,
                    2,
                    49,
                    13,
                    9,
                    3,
                    4,
                    9,
                    83,
                    11,
                    7,
                    0,
                    161,
                    11,
                    6,
                    9,
                    7,
                    3,
                    56,
                    1,
                    2,
                    6,
                    3,
                    1,
                    3,
                    2,
                    10,
                    0,
                    11,
                    1,
                    3,
                    6,
                    4,
                    4,
                    193,
                    17,
                    10,
                    9,
                    5,
                    0,
                    82,
                    19,
                    13,
                    9,
                    214,
                    6,
                    3,
                    8,
                    28,
                    1,
                    83,
                    16,
                    16,
                    9,
                    82,
                    12,
                    9,
                    9,
                    84,
                    14,
                    5,
                    9,
                    243,
                    14,
                    166,
                    9,
                    232,
                    6,
                    3,
                    6,
                    4,
                    0,
                    29,
                    9,
                    41,
                    6,
                    2,
                    3,
                    9,
                    0,
                    10,
                    10,
                    47,
                    15,
                    406,
                    7,
                    2,
                    7,
                    17,
                    9,
                    57,
                    21,
                    2,
                    13,
                    123,
                    5,
                    4,
                    0,
                    2,
                    1,
                    2,
                    6,
                    2,
                    0,
                    9,
                    9,
                    49,
                    4,
                    2,
                    1,
                    2,
                    4,
                    9,
                    9,
                    330,
                    3,
                    19306,
                    9,
                    135,
                    4,
                    60,
                    6,
                    26,
                    9,
                    1014,
                    0,
                    2,
                    54,
                    8,
                    3,
                    19723,
                    1,
                    5319,
                    4,
                    4,
                    5,
                    9,
                    7,
                    3,
                    6,
                    31,
                    3,
                    149,
                    2,
                    1418,
                    49,
                    513,
                    54,
                    5,
                    49,
                    9,
                    0,
                    15,
                    0,
                    23,
                    4,
                    2,
                    14,
                    1361,
                    6,
                    2,
                    16,
                    3,
                    6,
                    2,
                    1,
                    2,
                    4,
                    262,
                    6,
                    10,
                    9,
                    419,
                    13,
                    1495,
                    6,
                    110,
                    6,
                    6,
                    9,
                    792487,
                    239
                ];
                function p(t, e) {
                    for(var i = 65536, n = 0; n < e.length; n += 2){
                        if ((i += e[n]) > t) return !1;
                        if ((i += e[n + 1]) >= t) return !0;
                    }
                }
                function f(t, e) {
                    return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && l.test(String.fromCharCode(t)) : !1 !== e && p(t, c)));
                }
                function g(t, e) {
                    return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && u.test(String.fromCharCode(t)) : !1 !== e && (p(t, c) || p(t, d)))));
                }
                var v = function(t, e) {
                    void 0 === e && (e = {}), this.label = t, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = e.binop || null, this.updateContext = null;
                };
                function _(t, e) {
                    return new v(t, {
                        beforeExpr: !0,
                        binop: e
                    });
                }
                var m = {
                    beforeExpr: !0
                }, y = {
                    startsExpr: !0
                }, b = {};
                function x(t, e) {
                    return void 0 === e && (e = {}), e.keyword = t, b[t] = new v(t, e);
                }
                var w = {
                    num: new v("num", y),
                    regexp: new v("regexp", y),
                    string: new v("string", y),
                    name: new v("name", y),
                    eof: new v("eof"),
                    bracketL: new v("[", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    bracketR: new v("]"),
                    braceL: new v("{", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    braceR: new v("}"),
                    parenL: new v("(", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    parenR: new v(")"),
                    comma: new v(",", m),
                    semi: new v(";", m),
                    colon: new v(":", m),
                    dot: new v("."),
                    question: new v("?", m),
                    arrow: new v("=>", m),
                    template: new v("template"),
                    invalidTemplate: new v("invalidTemplate"),
                    ellipsis: new v("...", m),
                    backQuote: new v("`", y),
                    dollarBraceL: new v("${", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    eq: new v("=", {
                        beforeExpr: !0,
                        isAssign: !0
                    }),
                    assign: new v("_=", {
                        beforeExpr: !0,
                        isAssign: !0
                    }),
                    incDec: new v("++/--", {
                        prefix: !0,
                        postfix: !0,
                        startsExpr: !0
                    }),
                    prefix: new v("!/~", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    logicalOR: _("||", 1),
                    logicalAND: _("&&", 2),
                    bitwiseOR: _("|", 3),
                    bitwiseXOR: _("^", 4),
                    bitwiseAND: _("&", 5),
                    equality: _("==/!=/===/!==", 6),
                    relational: _("</>/<=/>=", 7),
                    bitShift: _("<</>>/>>>", 8),
                    plusMin: new v("+/-", {
                        beforeExpr: !0,
                        binop: 9,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    modulo: _("%", 10),
                    star: _("*", 10),
                    slash: _("/", 10),
                    starstar: new v("**", {
                        beforeExpr: !0
                    }),
                    _break: x("break"),
                    _case: x("case", m),
                    _catch: x("catch"),
                    _continue: x("continue"),
                    _debugger: x("debugger"),
                    _default: x("default", m),
                    _do: x("do", {
                        isLoop: !0,
                        beforeExpr: !0
                    }),
                    _else: x("else", m),
                    _finally: x("finally"),
                    _for: x("for", {
                        isLoop: !0
                    }),
                    _function: x("function", y),
                    _if: x("if"),
                    _return: x("return", m),
                    _switch: x("switch"),
                    _throw: x("throw", m),
                    _try: x("try"),
                    _var: x("var"),
                    _const: x("const"),
                    _while: x("while", {
                        isLoop: !0
                    }),
                    _with: x("with"),
                    _new: x("new", {
                        beforeExpr: !0,
                        startsExpr: !0
                    }),
                    _this: x("this", y),
                    _super: x("super", y),
                    _class: x("class", y),
                    _extends: x("extends", m),
                    _export: x("export"),
                    _import: x("import", y),
                    _null: x("null", y),
                    _true: x("true", y),
                    _false: x("false", y),
                    _in: x("in", {
                        beforeExpr: !0,
                        binop: 7
                    }),
                    _instanceof: x("instanceof", {
                        beforeExpr: !0,
                        binop: 7
                    }),
                    _typeof: x("typeof", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    _void: x("void", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    }),
                    _delete: x("delete", {
                        beforeExpr: !0,
                        prefix: !0,
                        startsExpr: !0
                    })
                }, C = /\r\n?|\n|\u2028|\u2029/, S = RegExp(C.source, "g");
                function k(t, e) {
                    return 10 === t || 13 === t || !e && (8232 === t || 8233 === t);
                }
                var P = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, A = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, I = Object.prototype, T = I.hasOwnProperty, E = I.toString;
                function L(t, e) {
                    return T.call(t, e);
                }
                var M = Array.isArray || function(t) {
                    return "[object Array]" === E.call(t);
                };
                function B(t) {
                    return RegExp("^(?:" + t.replace(/ /g, "|") + ")$");
                }
                var O = function(t, e) {
                    this.line = t, this.column = e;
                };
                O.prototype.offset = function(t) {
                    return new O(this.line, this.column + t);
                };
                var N = function(t, e, i) {
                    this.start = e, this.end = i, null !== t.sourceFile && (this.source = t.sourceFile);
                };
                function z(t, e) {
                    for(var i = 1, n = 0;;){
                        S.lastIndex = n;
                        var r = S.exec(t);
                        if (!r || !(r.index < e)) return new O(i, e - n);
                        ++i, n = r.index + r[0].length;
                    }
                }
                var R = {
                    ecmaVersion: 9,
                    sourceType: "script",
                    onInsertedSemicolon: null,
                    onTrailingComma: null,
                    allowReserved: null,
                    allowReturnOutsideFunction: !1,
                    allowImportExportEverywhere: !1,
                    allowAwaitOutsideFunction: !1,
                    allowHashBang: !1,
                    locations: !1,
                    onToken: null,
                    onComment: null,
                    ranges: !1,
                    program: null,
                    sourceFile: null,
                    directSourceFile: null,
                    preserveParens: !1
                };
                function V(t, e) {
                    return 2 | 4 * !!t | 8 * !!e;
                }
                var F = function(t, e, i) {
                    this.options = t = function(t) {
                        var e, i, n = {};
                        for(var r in R)n[r] = t && L(t, r) ? t[r] : R[r];
                        if (n.ecmaVersion >= 2015 && (n.ecmaVersion -= 2009), null == n.allowReserved && (n.allowReserved = n.ecmaVersion < 5), M(n.onToken)) {
                            var s = n.onToken;
                            n.onToken = function(t) {
                                return s.push(t);
                            };
                        }
                        return M(n.onComment) && (e = n, i = n.onComment, n.onComment = function(t, n, r, s, a, o) {
                            var h = {
                                type: t ? "Block" : "Line",
                                value: n,
                                start: r,
                                end: s
                            };
                            e.locations && (h.loc = new N(this, a, o)), e.ranges && (h.range = [
                                r,
                                s
                            ]), i.push(h);
                        }), n;
                    }(t), this.sourceFile = t.sourceFile, this.keywords = B(s[t.ecmaVersion >= 6 ? 6 : "module" === t.sourceType ? "5module" : 5]);
                    var r = "";
                    if (!0 !== t.allowReserved) {
                        for(var a = t.ecmaVersion; !(r = n[a]); a--);
                        "module" === t.sourceType && (r += " await");
                    }
                    this.reservedWords = B(r);
                    var o = (r ? r + " " : "") + n.strict;
                    this.reservedWordsStrict = B(o), this.reservedWordsStrictBind = B(o + " " + n.strictBind), this.input = String(e), this.containsEsc = !1, i ? (this.pos = i, this.lineStart = this.input.lastIndexOf("\n", i - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(C).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = w.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = "module" === t.sourceType, this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, 0 === this.pos && t.allowHashBang && "#!" === this.input.slice(0, 2) && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
                }, D = {
                    inFunction: {
                        configurable: !0
                    },
                    inGenerator: {
                        configurable: !0
                    },
                    inAsync: {
                        configurable: !0
                    },
                    allowSuper: {
                        configurable: !0
                    },
                    allowDirectSuper: {
                        configurable: !0
                    },
                    treatFunctionsAsVar: {
                        configurable: !0
                    }
                };
                F.prototype.parse = function() {
                    var t = this.options.program || this.startNode();
                    return this.nextToken(), this.parseTopLevel(t);
                }, D.inFunction.get = function() {
                    return (2 & this.currentVarScope().flags) > 0;
                }, D.inGenerator.get = function() {
                    return (8 & this.currentVarScope().flags) > 0;
                }, D.inAsync.get = function() {
                    return (4 & this.currentVarScope().flags) > 0;
                }, D.allowSuper.get = function() {
                    return (64 & this.currentThisScope().flags) > 0;
                }, D.allowDirectSuper.get = function() {
                    return (128 & this.currentThisScope().flags) > 0;
                }, D.treatFunctionsAsVar.get = function() {
                    return this.treatFunctionsAsVarInScope(this.currentScope());
                }, F.prototype.inNonArrowFunction = function() {
                    return (2 & this.currentThisScope().flags) > 0;
                }, F.extend = function() {
                    for(var t = [], e = arguments.length; e--;)t[e] = arguments[e];
                    for(var i = this, n = 0; n < t.length; n++)i = t[n](i);
                    return i;
                }, F.parse = function(t, e) {
                    return new this(e, t).parse();
                }, F.parseExpressionAt = function(t, e, i) {
                    var n = new this(i, t, e);
                    return n.nextToken(), n.parseExpression();
                }, F.tokenizer = function(t, e) {
                    return new this(e, t);
                }, Object.defineProperties(F.prototype, D);
                var j = F.prototype, H = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
                function q() {
                    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
                }
                j.strictDirective = function(t) {
                    for(;;){
                        A.lastIndex = t, t += A.exec(this.input)[0].length;
                        var e = H.exec(this.input.slice(t));
                        if (!e) return !1;
                        if ("use strict" === (e[1] || e[2])) return !0;
                        A.lastIndex = t += e[0].length, t += A.exec(this.input)[0].length, ";" === this.input[t] && t++;
                    }
                }, j.eat = function(t) {
                    return this.type === t && (this.next(), !0);
                }, j.isContextual = function(t) {
                    return this.type === w.name && this.value === t && !this.containsEsc;
                }, j.eatContextual = function(t) {
                    return !!this.isContextual(t) && (this.next(), !0);
                }, j.expectContextual = function(t) {
                    this.eatContextual(t) || this.unexpected();
                }, j.canInsertSemicolon = function() {
                    return this.type === w.eof || this.type === w.braceR || C.test(this.input.slice(this.lastTokEnd, this.start));
                }, j.insertSemicolon = function() {
                    if (this.canInsertSemicolon()) return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
                }, j.semicolon = function() {
                    this.eat(w.semi) || this.insertSemicolon() || this.unexpected();
                }, j.afterTrailingComma = function(t, e) {
                    if (this.type === t) return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), e || this.next(), !0;
                }, j.expect = function(t) {
                    this.eat(t) || this.unexpected();
                }, j.unexpected = function(t) {
                    this.raise(null != t ? t : this.start, "Unexpected token");
                }, j.checkPatternErrors = function(t, e) {
                    if (t) {
                        t.trailingComma > -1 && this.raiseRecoverable(t.trailingComma, "Comma is not permitted after the rest element");
                        var i = e ? t.parenthesizedAssign : t.parenthesizedBind;
                        i > -1 && this.raiseRecoverable(i, "Parenthesized pattern");
                    }
                }, j.checkExpressionErrors = function(t, e) {
                    if (!t) return !1;
                    var i = t.shorthandAssign, n = t.doubleProto;
                    if (!e) return i >= 0 || n >= 0;
                    i >= 0 && this.raise(i, "Shorthand property assignments are valid only in destructuring patterns"), n >= 0 && this.raiseRecoverable(n, "Redefinition of __proto__ property");
                }, j.checkYieldAwaitInDefaultParams = function() {
                    this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
                }, j.isSimpleAssignTarget = function(t) {
                    return "ParenthesizedExpression" === t.type ? this.isSimpleAssignTarget(t.expression) : "Identifier" === t.type || "MemberExpression" === t.type;
                };
                var U = F.prototype;
                U.parseTopLevel = function(t) {
                    var e = {};
                    for(t.body || (t.body = []); this.type !== w.eof;){
                        var i = this.parseStatement(null, !0, e);
                        t.body.push(i);
                    }
                    if (this.inModule) for(var n = 0, r = Object.keys(this.undefinedExports); n < r.length; n += 1){
                        var s = r[n];
                        this.raiseRecoverable(this.undefinedExports[s].start, "Export '" + s + "' is not defined");
                    }
                    return this.adaptDirectivePrologue(t.body), this.next(), t.sourceType = this.options.sourceType, this.finishNode(t, "Program");
                };
                var W = {
                    kind: "loop"
                }, G = {
                    kind: "switch"
                };
                U.isLet = function(t) {
                    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return !1;
                    A.lastIndex = this.pos;
                    var e = A.exec(this.input), i = this.pos + e[0].length, n = this.input.charCodeAt(i);
                    if (91 === n) return !0;
                    if (t) return !1;
                    if (123 === n) return !0;
                    if (f(n, !0)) {
                        for(var r = i + 1; g(this.input.charCodeAt(r), !0);)++r;
                        var s = this.input.slice(i, r);
                        if (!a.test(s)) return !0;
                    }
                    return !1;
                }, U.isAsyncFunction = function() {
                    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return !1;
                    A.lastIndex = this.pos;
                    var t = A.exec(this.input), e = this.pos + t[0].length;
                    return !C.test(this.input.slice(this.pos, e)) && "function" === this.input.slice(e, e + 8) && (e + 8 === this.input.length || !g(this.input.charAt(e + 8)));
                }, U.parseStatement = function(t, e, i) {
                    var n, r = this.type, s = this.startNode();
                    switch(this.isLet(t) && (r = w._var, n = "let"), r){
                        case w._break:
                        case w._continue:
                            return this.parseBreakContinueStatement(s, r.keyword);
                        case w._debugger:
                            return this.parseDebuggerStatement(s);
                        case w._do:
                            return this.parseDoStatement(s);
                        case w._for:
                            return this.parseForStatement(s);
                        case w._function:
                            return t && (this.strict || "if" !== t && "label" !== t) && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(s, !1, !t);
                        case w._class:
                            return t && this.unexpected(), this.parseClass(s, !0);
                        case w._if:
                            return this.parseIfStatement(s);
                        case w._return:
                            return this.parseReturnStatement(s);
                        case w._switch:
                            return this.parseSwitchStatement(s);
                        case w._throw:
                            return this.parseThrowStatement(s);
                        case w._try:
                            return this.parseTryStatement(s);
                        case w._const:
                        case w._var:
                            return n = n || this.value, t && "var" !== n && this.unexpected(), this.parseVarStatement(s, n);
                        case w._while:
                            return this.parseWhileStatement(s);
                        case w._with:
                            return this.parseWithStatement(s);
                        case w.braceL:
                            return this.parseBlock(!0, s);
                        case w.semi:
                            return this.parseEmptyStatement(s);
                        case w._export:
                        case w._import:
                            if (this.options.ecmaVersion > 10 && r === w._import) {
                                A.lastIndex = this.pos;
                                var a = A.exec(this.input), o = this.pos + a[0].length;
                                if (40 === this.input.charCodeAt(o)) return this.parseExpressionStatement(s, this.parseExpression());
                            }
                            return !this.options.allowImportExportEverywhere && (e || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), r === w._import ? this.parseImport(s) : this.parseExport(s, i);
                        default:
                            if (this.isAsyncFunction()) return t && this.unexpected(), this.next(), this.parseFunctionStatement(s, !0, !t);
                            var h = this.value, l = this.parseExpression();
                            if (r === w.name && "Identifier" === l.type && this.eat(w.colon)) return this.parseLabeledStatement(s, h, l, t);
                            return this.parseExpressionStatement(s, l);
                    }
                }, U.parseBreakContinueStatement = function(t, e) {
                    var i = "break" === e;
                    this.next(), this.eat(w.semi) || this.insertSemicolon() ? t.label = null : this.type !== w.name ? this.unexpected() : (t.label = this.parseIdent(), this.semicolon());
                    for(var n = 0; n < this.labels.length; ++n){
                        var r = this.labels[n];
                        if ((null == t.label || r.name === t.label.name) && (null != r.kind && (i || "loop" === r.kind) || t.label && i)) break;
                    }
                    return n === this.labels.length && this.raise(t.start, "Unsyntactic " + e), this.finishNode(t, i ? "BreakStatement" : "ContinueStatement");
                }, U.parseDebuggerStatement = function(t) {
                    return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
                }, U.parseDoStatement = function(t) {
                    return this.next(), this.labels.push(W), t.body = this.parseStatement("do"), this.labels.pop(), this.expect(w._while), t.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(w.semi) : this.semicolon(), this.finishNode(t, "DoWhileStatement");
                }, U.parseForStatement = function(t) {
                    this.next();
                    var e = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
                    if (this.labels.push(W), this.enterScope(0), this.expect(w.parenL), this.type === w.semi) return e > -1 && this.unexpected(e), this.parseFor(t, null);
                    var i = this.isLet();
                    if (this.type === w._var || this.type === w._const || i) {
                        var n = this.startNode(), r = i ? "let" : this.value;
                        return (this.next(), this.parseVar(n, !0, r), this.finishNode(n, "VariableDeclaration"), (this.type === w._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && 1 === n.declarations.length) ? (this.options.ecmaVersion >= 9 && (this.type === w._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.parseForIn(t, n)) : (e > -1 && this.unexpected(e), this.parseFor(t, n));
                    }
                    var s = new q, a = this.parseExpression(!0, s);
                    return this.type === w._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === w._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.toAssignable(a, !1, s), this.checkLVal(a), this.parseForIn(t, a)) : (this.checkExpressionErrors(s, !0), e > -1 && this.unexpected(e), this.parseFor(t, a));
                }, U.parseFunctionStatement = function(t, e, i) {
                    return this.next(), this.parseFunction(t, X | (i ? 0 : $), !1, e);
                }, U.parseIfStatement = function(t) {
                    return this.next(), t.test = this.parseParenExpression(), t.consequent = this.parseStatement("if"), t.alternate = this.eat(w._else) ? this.parseStatement("if") : null, this.finishNode(t, "IfStatement");
                }, U.parseReturnStatement = function(t) {
                    return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(w.semi) || this.insertSemicolon() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
                }, U.parseSwitchStatement = function(t) {
                    this.next(), t.discriminant = this.parseParenExpression(), t.cases = [], this.expect(w.braceL), this.labels.push(G), this.enterScope(0);
                    for(var e, i = !1; this.type !== w.braceR;)if (this.type === w._case || this.type === w._default) {
                        var n = this.type === w._case;
                        e && this.finishNode(e, "SwitchCase"), t.cases.push(e = this.startNode()), e.consequent = [], this.next(), n ? e.test = this.parseExpression() : (i && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), i = !0, e.test = null), this.expect(w.colon);
                    } else e || this.unexpected(), e.consequent.push(this.parseStatement(null));
                    return this.exitScope(), e && this.finishNode(e, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(t, "SwitchStatement");
                }, U.parseThrowStatement = function(t) {
                    return this.next(), C.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
                };
                var Z = [];
                U.parseTryStatement = function(t) {
                    if (this.next(), t.block = this.parseBlock(), t.handler = null, this.type === w._catch) {
                        var e = this.startNode();
                        if (this.next(), this.eat(w.parenL)) {
                            e.param = this.parseBindingAtom();
                            var i = "Identifier" === e.param.type;
                            this.enterScope(32 * !!i), this.checkLVal(e.param, i ? 4 : 2), this.expect(w.parenR);
                        } else this.options.ecmaVersion < 10 && this.unexpected(), e.param = null, this.enterScope(0);
                        e.body = this.parseBlock(!1), this.exitScope(), t.handler = this.finishNode(e, "CatchClause");
                    }
                    return t.finalizer = this.eat(w._finally) ? this.parseBlock() : null, t.handler || t.finalizer || this.raise(t.start, "Missing catch or finally clause"), this.finishNode(t, "TryStatement");
                }, U.parseVarStatement = function(t, e) {
                    return this.next(), this.parseVar(t, !1, e), this.semicolon(), this.finishNode(t, "VariableDeclaration");
                }, U.parseWhileStatement = function(t) {
                    return this.next(), t.test = this.parseParenExpression(), this.labels.push(W), t.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(t, "WhileStatement");
                }, U.parseWithStatement = function(t) {
                    return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), t.object = this.parseParenExpression(), t.body = this.parseStatement("with"), this.finishNode(t, "WithStatement");
                }, U.parseEmptyStatement = function(t) {
                    return this.next(), this.finishNode(t, "EmptyStatement");
                }, U.parseLabeledStatement = function(t, e, i, n) {
                    for(var r = 0, s = this.labels; r < s.length; r += 1)s[r].name === e && this.raise(i.start, "Label '" + e + "' is already declared");
                    for(var a = this.type.isLoop ? "loop" : this.type === w._switch ? "switch" : null, o = this.labels.length - 1; o >= 0; o--){
                        var h = this.labels[o];
                        if (h.statementStart === t.start) h.statementStart = this.start, h.kind = a;
                        else break;
                    }
                    return this.labels.push({
                        name: e,
                        kind: a,
                        statementStart: this.start
                    }), t.body = this.parseStatement(n ? -1 === n.indexOf("label") ? n + "label" : n : "label"), this.labels.pop(), t.label = i, this.finishNode(t, "LabeledStatement");
                }, U.parseExpressionStatement = function(t, e) {
                    return t.expression = e, this.semicolon(), this.finishNode(t, "ExpressionStatement");
                }, U.parseBlock = function(t, e) {
                    for(void 0 === t && (t = !0), void 0 === e && (e = this.startNode()), e.body = [], this.expect(w.braceL), t && this.enterScope(0); !this.eat(w.braceR);){
                        var i = this.parseStatement(null);
                        e.body.push(i);
                    }
                    return t && this.exitScope(), this.finishNode(e, "BlockStatement");
                }, U.parseFor = function(t, e) {
                    return t.init = e, this.expect(w.semi), t.test = this.type === w.semi ? null : this.parseExpression(), this.expect(w.semi), t.update = this.type === w.parenR ? null : this.parseExpression(), this.expect(w.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, "ForStatement");
                }, U.parseForIn = function(t, e) {
                    var i = this.type === w._in;
                    return this.next(), "VariableDeclaration" === e.type && null != e.declarations[0].init && (!i || this.options.ecmaVersion < 8 || this.strict || "var" !== e.kind || "Identifier" !== e.declarations[0].id.type) ? this.raise(e.start, (i ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : "AssignmentPattern" === e.type && this.raise(e.start, "Invalid left-hand side in for-loop"), t.left = e, t.right = i ? this.parseExpression() : this.parseMaybeAssign(), this.expect(w.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, i ? "ForInStatement" : "ForOfStatement");
                }, U.parseVar = function(t, e, i) {
                    for(t.declarations = [], t.kind = i;;){
                        var n = this.startNode();
                        if (this.parseVarId(n, i), this.eat(w.eq) ? n.init = this.parseMaybeAssign(e) : "const" !== i || this.type === w._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? "Identifier" === n.id.type || e && (this.type === w._in || this.isContextual("of")) ? n.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), t.declarations.push(this.finishNode(n, "VariableDeclarator")), !this.eat(w.comma)) break;
                    }
                    return t;
                }, U.parseVarId = function(t, e) {
                    t.id = this.parseBindingAtom(), this.checkLVal(t.id, "var" === e ? 1 : 2, !1);
                };
                var X = 1, $ = 2;
                U.parseFunction = function(t, e, i, n) {
                    this.initFunction(t), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !n) && (this.type === w.star && e & $ && this.unexpected(), t.generator = this.eat(w.star)), this.options.ecmaVersion >= 8 && (t.async = !!n), e & X && (t.id = 4 & e && this.type !== w.name ? null : this.parseIdent(), t.id && !(e & $) && this.checkLVal(t.id, this.strict || t.generator || t.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
                    var r = this.yieldPos, s = this.awaitPos, a = this.awaitIdentPos;
                    return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(V(t.async, t.generator)), e & X || (t.id = this.type === w.name ? this.parseIdent() : null), this.parseFunctionParams(t), this.parseFunctionBody(t, i, !1), this.yieldPos = r, this.awaitPos = s, this.awaitIdentPos = a, this.finishNode(t, e & X ? "FunctionDeclaration" : "FunctionExpression");
                }, U.parseFunctionParams = function(t) {
                    this.expect(w.parenL), t.params = this.parseBindingList(w.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
                }, U.parseClass = function(t, e) {
                    this.next();
                    var i = this.strict;
                    this.strict = !0, this.parseClassId(t, e), this.parseClassSuper(t);
                    var n = this.startNode(), r = !1;
                    for(n.body = [], this.expect(w.braceL); !this.eat(w.braceR);){
                        var s = this.parseClassElement(null !== t.superClass);
                        s && (n.body.push(s), "MethodDefinition" === s.type && "constructor" === s.kind && (r && this.raise(s.start, "Duplicate constructor in the same class"), r = !0));
                    }
                    return t.body = this.finishNode(n, "ClassBody"), this.strict = i, this.finishNode(t, e ? "ClassDeclaration" : "ClassExpression");
                }, U.parseClassElement = function(t) {
                    var e = this;
                    if (this.eat(w.semi)) return null;
                    var i = this.startNode(), n = function(t, n) {
                        void 0 === n && (n = !1);
                        var r = e.start, s = e.startLoc;
                        return !!e.eatContextual(t) && (!(e.type === w.parenL || n && e.canInsertSemicolon()) || (i.key && e.unexpected(), i.computed = !1, i.key = e.startNodeAt(r, s), i.key.name = t, e.finishNode(i.key, "Identifier"), !1));
                    };
                    i.kind = "method", i.static = n("static");
                    var r = this.eat(w.star), s = !1;
                    !r && (this.options.ecmaVersion >= 8 && n("async", !0) ? (s = !0, r = this.options.ecmaVersion >= 9 && this.eat(w.star)) : n("get") ? i.kind = "get" : n("set") && (i.kind = "set")), i.key || this.parsePropertyName(i);
                    var a = i.key, o = !1;
                    return i.computed || i.static || ("Identifier" !== a.type || "constructor" !== a.name) && ("Literal" !== a.type || "constructor" !== a.value) ? i.static && "Identifier" === a.type && "prototype" === a.name && this.raise(a.start, "Classes may not have a static property named prototype") : ("method" !== i.kind && this.raise(a.start, "Constructor can't have get/set modifier"), r && this.raise(a.start, "Constructor can't be a generator"), s && this.raise(a.start, "Constructor can't be an async method"), i.kind = "constructor", o = t), this.parseClassMethod(i, r, s, o), "get" === i.kind && 0 !== i.value.params.length && this.raiseRecoverable(i.value.start, "getter should have no params"), "set" === i.kind && 1 !== i.value.params.length && this.raiseRecoverable(i.value.start, "setter should have exactly one param"), "set" === i.kind && "RestElement" === i.value.params[0].type && this.raiseRecoverable(i.value.params[0].start, "Setter cannot use rest params"), i;
                }, U.parseClassMethod = function(t, e, i, n) {
                    return t.value = this.parseMethod(e, i, n), this.finishNode(t, "MethodDefinition");
                }, U.parseClassId = function(t, e) {
                    this.type === w.name ? (t.id = this.parseIdent(), e && this.checkLVal(t.id, 2, !1)) : (!0 === e && this.unexpected(), t.id = null);
                }, U.parseClassSuper = function(t) {
                    t.superClass = this.eat(w._extends) ? this.parseExprSubscripts() : null;
                }, U.parseExport = function(t, e) {
                    if (this.next(), this.eat(w.star)) return this.expectContextual("from"), this.type !== w.string && this.unexpected(), t.source = this.parseExprAtom(), this.semicolon(), this.finishNode(t, "ExportAllDeclaration");
                    if (this.eat(w._default)) {
                        if (this.checkExport(e, "default", this.lastTokStart), this.type === w._function || (i = this.isAsyncFunction())) {
                            var i, n = this.startNode();
                            this.next(), i && this.next(), t.declaration = this.parseFunction(n, 4 | X, !1, i);
                        } else if (this.type === w._class) {
                            var r = this.startNode();
                            t.declaration = this.parseClass(r, "nullableID");
                        } else t.declaration = this.parseMaybeAssign(), this.semicolon();
                        return this.finishNode(t, "ExportDefaultDeclaration");
                    }
                    if (this.shouldParseExportStatement()) t.declaration = this.parseStatement(null), "VariableDeclaration" === t.declaration.type ? this.checkVariableExport(e, t.declaration.declarations) : this.checkExport(e, t.declaration.id.name, t.declaration.id.start), t.specifiers = [], t.source = null;
                    else {
                        if (t.declaration = null, t.specifiers = this.parseExportSpecifiers(e), this.eatContextual("from")) this.type !== w.string && this.unexpected(), t.source = this.parseExprAtom();
                        else {
                            for(var s = 0, a = t.specifiers; s < a.length; s += 1){
                                var o = a[s];
                                this.checkUnreserved(o.local), this.checkLocalExport(o.local);
                            }
                            t.source = null;
                        }
                        this.semicolon();
                    }
                    return this.finishNode(t, "ExportNamedDeclaration");
                }, U.checkExport = function(t, e, i) {
                    t && (L(t, e) && this.raiseRecoverable(i, "Duplicate export '" + e + "'"), t[e] = !0);
                }, U.checkPatternExport = function(t, e) {
                    var i = e.type;
                    if ("Identifier" === i) this.checkExport(t, e.name, e.start);
                    else if ("ObjectPattern" === i) for(var n = 0, r = e.properties; n < r.length; n += 1){
                        var s = r[n];
                        this.checkPatternExport(t, s);
                    }
                    else if ("ArrayPattern" === i) for(var a = 0, o = e.elements; a < o.length; a += 1){
                        var h = o[a];
                        h && this.checkPatternExport(t, h);
                    }
                    else "Property" === i ? this.checkPatternExport(t, e.value) : "AssignmentPattern" === i ? this.checkPatternExport(t, e.left) : "RestElement" === i ? this.checkPatternExport(t, e.argument) : "ParenthesizedExpression" === i && this.checkPatternExport(t, e.expression);
                }, U.checkVariableExport = function(t, e) {
                    if (t) for(var i = 0; i < e.length; i += 1){
                        var n = e[i];
                        this.checkPatternExport(t, n.id);
                    }
                }, U.shouldParseExportStatement = function() {
                    return "var" === this.type.keyword || "const" === this.type.keyword || "class" === this.type.keyword || "function" === this.type.keyword || this.isLet() || this.isAsyncFunction();
                }, U.parseExportSpecifiers = function(t) {
                    var e = [], i = !0;
                    for(this.expect(w.braceL); !this.eat(w.braceR);){
                        if (i) i = !1;
                        else if (this.expect(w.comma), this.afterTrailingComma(w.braceR)) break;
                        var n = this.startNode();
                        n.local = this.parseIdent(!0), n.exported = this.eatContextual("as") ? this.parseIdent(!0) : n.local, this.checkExport(t, n.exported.name, n.exported.start), e.push(this.finishNode(n, "ExportSpecifier"));
                    }
                    return e;
                }, U.parseImport = function(t) {
                    return this.next(), this.type === w.string ? (t.specifiers = Z, t.source = this.parseExprAtom()) : (t.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), t.source = this.type === w.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(t, "ImportDeclaration");
                }, U.parseImportSpecifiers = function() {
                    var t = [], e = !0;
                    if (this.type === w.name) {
                        var i = this.startNode();
                        if (i.local = this.parseIdent(), this.checkLVal(i.local, 2), t.push(this.finishNode(i, "ImportDefaultSpecifier")), !this.eat(w.comma)) return t;
                    }
                    if (this.type === w.star) {
                        var n = this.startNode();
                        return this.next(), this.expectContextual("as"), n.local = this.parseIdent(), this.checkLVal(n.local, 2), t.push(this.finishNode(n, "ImportNamespaceSpecifier")), t;
                    }
                    for(this.expect(w.braceL); !this.eat(w.braceR);){
                        if (e) e = !1;
                        else if (this.expect(w.comma), this.afterTrailingComma(w.braceR)) break;
                        var r = this.startNode();
                        r.imported = this.parseIdent(!0), this.eatContextual("as") ? r.local = this.parseIdent() : (this.checkUnreserved(r.imported), r.local = r.imported), this.checkLVal(r.local, 2), t.push(this.finishNode(r, "ImportSpecifier"));
                    }
                    return t;
                }, U.adaptDirectivePrologue = function(t) {
                    for(var e = 0; e < t.length && this.isDirectiveCandidate(t[e]); ++e)t[e].directive = t[e].expression.raw.slice(1, -1);
                }, U.isDirectiveCandidate = function(t) {
                    return "ExpressionStatement" === t.type && "Literal" === t.expression.type && "string" == typeof t.expression.value && ('"' === this.input[t.start] || "'" === this.input[t.start]);
                };
                var Q = F.prototype;
                Q.toAssignable = function(t, e, i) {
                    if (this.options.ecmaVersion >= 6 && t) switch(t.type){
                        case "Identifier":
                            this.inAsync && "await" === t.name && this.raise(t.start, "Cannot use 'await' as identifier inside an async function");
                            break;
                        case "ObjectPattern":
                        case "ArrayPattern":
                        case "RestElement":
                            break;
                        case "ObjectExpression":
                            t.type = "ObjectPattern", i && this.checkPatternErrors(i, !0);
                            for(var n = 0, r = t.properties; n < r.length; n += 1){
                                var s = r[n];
                                this.toAssignable(s, e), "RestElement" === s.type && ("ArrayPattern" === s.argument.type || "ObjectPattern" === s.argument.type) && this.raise(s.argument.start, "Unexpected token");
                            }
                            break;
                        case "Property":
                            "init" !== t.kind && this.raise(t.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(t.value, e);
                            break;
                        case "ArrayExpression":
                            t.type = "ArrayPattern", i && this.checkPatternErrors(i, !0), this.toAssignableList(t.elements, e);
                            break;
                        case "SpreadElement":
                            t.type = "RestElement", this.toAssignable(t.argument, e), "AssignmentPattern" === t.argument.type && this.raise(t.argument.start, "Rest elements cannot have a default value");
                            break;
                        case "AssignmentExpression":
                            "=" !== t.operator && this.raise(t.left.end, "Only '=' operator can be used for specifying default value."), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left, e);
                        case "AssignmentPattern":
                            break;
                        case "ParenthesizedExpression":
                            this.toAssignable(t.expression, e, i);
                            break;
                        case "MemberExpression":
                            if (!e) break;
                        default:
                            this.raise(t.start, "Assigning to rvalue");
                    }
                    else i && this.checkPatternErrors(i, !0);
                    return t;
                }, Q.toAssignableList = function(t, e) {
                    for(var i = t.length, n = 0; n < i; n++){
                        var r = t[n];
                        r && this.toAssignable(r, e);
                    }
                    if (i) {
                        var s = t[i - 1];
                        6 === this.options.ecmaVersion && e && s && "RestElement" === s.type && "Identifier" !== s.argument.type && this.unexpected(s.argument.start);
                    }
                    return t;
                }, Q.parseSpread = function(t) {
                    var e = this.startNode();
                    return this.next(), e.argument = this.parseMaybeAssign(!1, t), this.finishNode(e, "SpreadElement");
                }, Q.parseRestBinding = function() {
                    var t = this.startNode();
                    return this.next(), 6 === this.options.ecmaVersion && this.type !== w.name && this.unexpected(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
                }, Q.parseBindingAtom = function() {
                    if (this.options.ecmaVersion >= 6) switch(this.type){
                        case w.bracketL:
                            var t = this.startNode();
                            return this.next(), t.elements = this.parseBindingList(w.bracketR, !0, !0), this.finishNode(t, "ArrayPattern");
                        case w.braceL:
                            return this.parseObj(!0);
                    }
                    return this.parseIdent();
                }, Q.parseBindingList = function(t, e, i) {
                    for(var n = [], r = !0; !this.eat(t);)if (r ? r = !1 : this.expect(w.comma), e && this.type === w.comma) n.push(null);
                    else if (i && this.afterTrailingComma(t)) break;
                    else if (this.type === w.ellipsis) {
                        var s = this.parseRestBinding();
                        this.parseBindingListItem(s), n.push(s), this.type === w.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(t);
                        break;
                    } else {
                        var a = this.parseMaybeDefault(this.start, this.startLoc);
                        this.parseBindingListItem(a), n.push(a);
                    }
                    return n;
                }, Q.parseBindingListItem = function(t) {
                    return t;
                }, Q.parseMaybeDefault = function(t, e, i) {
                    if (i = i || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(w.eq)) return i;
                    var n = this.startNodeAt(t, e);
                    return n.left = i, n.right = this.parseMaybeAssign(), this.finishNode(n, "AssignmentPattern");
                }, Q.checkLVal = function(t, e, i) {
                    switch(void 0 === e && (e = 0), t.type){
                        case "Identifier":
                            2 === e && "let" === t.name && this.raiseRecoverable(t.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(t.name) && this.raiseRecoverable(t.start, (e ? "Binding " : "Assigning to ") + t.name + " in strict mode"), i && (L(i, t.name) && this.raiseRecoverable(t.start, "Argument name clash"), i[t.name] = !0), 0 !== e && 5 !== e && this.declareName(t.name, e, t.start);
                            break;
                        case "MemberExpression":
                            e && this.raiseRecoverable(t.start, "Binding member expression");
                            break;
                        case "ObjectPattern":
                            for(var n = 0, r = t.properties; n < r.length; n += 1){
                                var s = r[n];
                                this.checkLVal(s, e, i);
                            }
                            break;
                        case "Property":
                            this.checkLVal(t.value, e, i);
                            break;
                        case "ArrayPattern":
                            for(var a = 0, o = t.elements; a < o.length; a += 1){
                                var h = o[a];
                                h && this.checkLVal(h, e, i);
                            }
                            break;
                        case "AssignmentPattern":
                            this.checkLVal(t.left, e, i);
                            break;
                        case "RestElement":
                            this.checkLVal(t.argument, e, i);
                            break;
                        case "ParenthesizedExpression":
                            this.checkLVal(t.expression, e, i);
                            break;
                        default:
                            this.raise(t.start, (e ? "Binding" : "Assigning to") + " rvalue");
                    }
                };
                var Y = F.prototype;
                Y.checkPropClash = function(t, e, i) {
                    if ((!(this.options.ecmaVersion >= 9) || "SpreadElement" !== t.type) && (!(this.options.ecmaVersion >= 6) || !t.computed && !t.method && !t.shorthand)) {
                        var n, r, s = t.key;
                        switch(s.type){
                            case "Identifier":
                                n = s.name;
                                break;
                            case "Literal":
                                n = String(s.value);
                                break;
                            default:
                                return;
                        }
                        var a = t.kind;
                        if (this.options.ecmaVersion >= 6) {
                            "__proto__" === n && "init" === a && (e.proto && (i && i.doubleProto < 0 ? i.doubleProto = s.start : this.raiseRecoverable(s.start, "Redefinition of __proto__ property")), e.proto = !0);
                            return;
                        }
                        var o = e[n = "$" + n];
                        o ? ("init" === a ? this.strict && o.init || o.get || o.set : o.init || o[a]) && this.raiseRecoverable(s.start, "Redefinition of property") : o = e[n] = {
                            init: !1,
                            get: !1,
                            set: !1
                        }, o[a] = !0;
                    }
                }, Y.parseExpression = function(t, e) {
                    var i = this.start, n = this.startLoc, r = this.parseMaybeAssign(t, e);
                    if (this.type === w.comma) {
                        var s = this.startNodeAt(i, n);
                        for(s.expressions = [
                            r
                        ]; this.eat(w.comma);)s.expressions.push(this.parseMaybeAssign(t, e));
                        return this.finishNode(s, "SequenceExpression");
                    }
                    return r;
                }, Y.parseMaybeAssign = function(t, e, i) {
                    if (this.isContextual("yield")) {
                        if (this.inGenerator) return this.parseYield(t);
                        else this.exprAllowed = !1;
                    }
                    var n = !1, r = -1, s = -1, a = -1;
                    e ? (r = e.parenthesizedAssign, s = e.trailingComma, a = e.shorthandAssign, e.parenthesizedAssign = e.trailingComma = e.shorthandAssign = -1) : (e = new q, n = !0);
                    var o = this.start, h = this.startLoc;
                    (this.type === w.parenL || this.type === w.name) && (this.potentialArrowAt = this.start);
                    var l = this.parseMaybeConditional(t, e);
                    if (i && (l = i.call(this, l, o, h)), this.type.isAssign) {
                        var u = this.startNodeAt(o, h);
                        return u.operator = this.value, u.left = this.type === w.eq ? this.toAssignable(l, !1, e) : l, n || q.call(e), e.shorthandAssign = -1, this.checkLVal(l), this.next(), u.right = this.parseMaybeAssign(t), this.finishNode(u, "AssignmentExpression");
                    }
                    return n && this.checkExpressionErrors(e, !0), r > -1 && (e.parenthesizedAssign = r), s > -1 && (e.trailingComma = s), a > -1 && (e.shorthandAssign = a), l;
                }, Y.parseMaybeConditional = function(t, e) {
                    var i = this.start, n = this.startLoc, r = this.parseExprOps(t, e);
                    if (this.checkExpressionErrors(e)) return r;
                    if (this.eat(w.question)) {
                        var s = this.startNodeAt(i, n);
                        return s.test = r, s.consequent = this.parseMaybeAssign(), this.expect(w.colon), s.alternate = this.parseMaybeAssign(t), this.finishNode(s, "ConditionalExpression");
                    }
                    return r;
                }, Y.parseExprOps = function(t, e) {
                    var i = this.start, n = this.startLoc, r = this.parseMaybeUnary(e, !1);
                    return this.checkExpressionErrors(e) || r.start === i && "ArrowFunctionExpression" === r.type ? r : this.parseExprOp(r, i, n, -1, t);
                }, Y.parseExprOp = function(t, e, i, n, r) {
                    var s = this.type.binop;
                    if (null != s && (!r || this.type !== w._in) && s > n) {
                        var a = this.type === w.logicalOR || this.type === w.logicalAND, o = this.value;
                        this.next();
                        var h = this.start, l = this.startLoc, u = this.parseExprOp(this.parseMaybeUnary(null, !1), h, l, s, r), c = this.buildBinary(e, i, t, u, o, a);
                        return this.parseExprOp(c, e, i, n, r);
                    }
                    return t;
                }, Y.buildBinary = function(t, e, i, n, r, s) {
                    var a = this.startNodeAt(t, e);
                    return a.left = i, a.operator = r, a.right = n, this.finishNode(a, s ? "LogicalExpression" : "BinaryExpression");
                }, Y.parseMaybeUnary = function(t, e) {
                    var i, n = this.start, r = this.startLoc;
                    if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction)) i = this.parseAwait(), e = !0;
                    else if (this.type.prefix) {
                        var s = this.startNode(), a = this.type === w.incDec;
                        s.operator = this.value, s.prefix = !0, this.next(), s.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(t, !0), a ? this.checkLVal(s.argument) : this.strict && "delete" === s.operator && "Identifier" === s.argument.type ? this.raiseRecoverable(s.start, "Deleting local variable in strict mode") : e = !0, i = this.finishNode(s, a ? "UpdateExpression" : "UnaryExpression");
                    } else {
                        if (i = this.parseExprSubscripts(t), this.checkExpressionErrors(t)) return i;
                        for(; this.type.postfix && !this.canInsertSemicolon();){
                            var o = this.startNodeAt(n, r);
                            o.operator = this.value, o.prefix = !1, o.argument = i, this.checkLVal(i), this.next(), i = this.finishNode(o, "UpdateExpression");
                        }
                    }
                    return !e && this.eat(w.starstar) ? this.buildBinary(n, r, i, this.parseMaybeUnary(null, !1), "**", !1) : i;
                }, Y.parseExprSubscripts = function(t) {
                    var e = this.start, i = this.startLoc, n = this.parseExprAtom(t), r = "ArrowFunctionExpression" === n.type && ")" !== this.input.slice(this.lastTokStart, this.lastTokEnd);
                    if (this.checkExpressionErrors(t) || r) return n;
                    var s = this.parseSubscripts(n, e, i);
                    return t && "MemberExpression" === s.type && (t.parenthesizedAssign >= s.start && (t.parenthesizedAssign = -1), t.parenthesizedBind >= s.start && (t.parenthesizedBind = -1)), s;
                }, Y.parseSubscripts = function(t, e, i, n) {
                    for(var r = this.options.ecmaVersion >= 8 && "Identifier" === t.type && "async" === t.name && this.lastTokEnd === t.end && !this.canInsertSemicolon() && "async" === this.input.slice(t.start, t.end);;){
                        var s = this.parseSubscript(t, e, i, n, r);
                        if (s === t || "ArrowFunctionExpression" === s.type) return s;
                        t = s;
                    }
                }, Y.parseSubscript = function(t, e, i, n, r) {
                    var s = this.eat(w.bracketL);
                    if (s || this.eat(w.dot)) {
                        var a = this.startNodeAt(e, i);
                        a.object = t, a.property = s ? this.parseExpression() : this.parseIdent("never" !== this.options.allowReserved), a.computed = !!s, s && this.expect(w.bracketR), t = this.finishNode(a, "MemberExpression");
                    } else if (!n && this.eat(w.parenL)) {
                        var o = new q, h = this.yieldPos, l = this.awaitPos, u = this.awaitIdentPos;
                        this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
                        var c = this.parseExprList(w.parenR, this.options.ecmaVersion >= 8 && "Import" !== t.type, !1, o);
                        if (r && !this.canInsertSemicolon() && this.eat(w.arrow)) return this.checkPatternErrors(o, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = h, this.awaitPos = l, this.awaitIdentPos = u, this.parseArrowExpression(this.startNodeAt(e, i), c, !0);
                        this.checkExpressionErrors(o, !0), this.yieldPos = h || this.yieldPos, this.awaitPos = l || this.awaitPos, this.awaitIdentPos = u || this.awaitIdentPos;
                        var d = this.startNodeAt(e, i);
                        if (d.callee = t, d.arguments = c, "Import" === d.callee.type) {
                            1 !== d.arguments.length && this.raise(d.start, "import() requires exactly one argument");
                            var p = d.arguments[0];
                            p && "SpreadElement" === p.type && this.raise(p.start, "... is not allowed in import()");
                        }
                        t = this.finishNode(d, "CallExpression");
                    } else if (this.type === w.backQuote) {
                        var f = this.startNodeAt(e, i);
                        f.tag = t, f.quasi = this.parseTemplate({
                            isTagged: !0
                        }), t = this.finishNode(f, "TaggedTemplateExpression");
                    }
                    return t;
                }, Y.parseExprAtom = function(t) {
                    this.type === w.slash && this.readRegexp();
                    var e, i = this.potentialArrowAt === this.start;
                    switch(this.type){
                        case w._super:
                            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), e = this.startNode(), this.next(), this.type !== w.parenL || this.allowDirectSuper || this.raise(e.start, "super() call outside constructor of a subclass"), this.type !== w.dot && this.type !== w.bracketL && this.type !== w.parenL && this.unexpected(), this.finishNode(e, "Super");
                        case w._this:
                            return e = this.startNode(), this.next(), this.finishNode(e, "ThisExpression");
                        case w.name:
                            var n = this.start, r = this.startLoc, s = this.containsEsc, a = this.parseIdent(!1);
                            if (this.options.ecmaVersion >= 8 && !s && "async" === a.name && !this.canInsertSemicolon() && this.eat(w._function)) return this.parseFunction(this.startNodeAt(n, r), 0, !1, !0);
                            if (i && !this.canInsertSemicolon()) {
                                if (this.eat(w.arrow)) return this.parseArrowExpression(this.startNodeAt(n, r), [
                                    a
                                ], !1);
                                if (this.options.ecmaVersion >= 8 && "async" === a.name && this.type === w.name && !s) return a = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(w.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(n, r), [
                                    a
                                ], !0);
                            }
                            return a;
                        case w.regexp:
                            var o = this.value;
                            return (e = this.parseLiteral(o.value)).regex = {
                                pattern: o.pattern,
                                flags: o.flags
                            }, e;
                        case w.num:
                        case w.string:
                            return this.parseLiteral(this.value);
                        case w._null:
                        case w._true:
                        case w._false:
                            return (e = this.startNode()).value = this.type === w._null ? null : this.type === w._true, e.raw = this.type.keyword, this.next(), this.finishNode(e, "Literal");
                        case w.parenL:
                            var h = this.start, l = this.parseParenAndDistinguishExpression(i);
                            return t && (t.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(l) && (t.parenthesizedAssign = h), t.parenthesizedBind < 0 && (t.parenthesizedBind = h)), l;
                        case w.bracketL:
                            return e = this.startNode(), this.next(), e.elements = this.parseExprList(w.bracketR, !0, !0, t), this.finishNode(e, "ArrayExpression");
                        case w.braceL:
                            return this.parseObj(!1, t);
                        case w._function:
                            return e = this.startNode(), this.next(), this.parseFunction(e, 0);
                        case w._class:
                            return this.parseClass(this.startNode(), !1);
                        case w._new:
                            return this.parseNew();
                        case w.backQuote:
                            return this.parseTemplate();
                        case w._import:
                            if (this.options.ecmaVersion > 10) return this.parseDynamicImport();
                            return this.unexpected();
                        default:
                            this.unexpected();
                    }
                }, Y.parseDynamicImport = function() {
                    var t = this.startNode();
                    return this.next(), this.type !== w.parenL && this.unexpected(), this.finishNode(t, "Import");
                }, Y.parseLiteral = function(t) {
                    var e = this.startNode();
                    return e.value = t, e.raw = this.input.slice(this.start, this.end), 110 === e.raw.charCodeAt(e.raw.length - 1) && (e.bigint = e.raw.slice(0, -1)), this.next(), this.finishNode(e, "Literal");
                }, Y.parseParenExpression = function() {
                    this.expect(w.parenL);
                    var t = this.parseExpression();
                    return this.expect(w.parenR), t;
                }, Y.parseParenAndDistinguishExpression = function(t) {
                    var e, i = this.start, n = this.startLoc, r = this.options.ecmaVersion >= 8;
                    if (this.options.ecmaVersion >= 6) {
                        this.next();
                        var s, a = this.start, o = this.startLoc, h = [], l = !0, u = !1, c = new q, d = this.yieldPos, p = this.awaitPos;
                        for(this.yieldPos = 0, this.awaitPos = 0; this.type !== w.parenR;){
                            if (l ? l = !1 : this.expect(w.comma), r && this.afterTrailingComma(w.parenR, !0)) {
                                u = !0;
                                break;
                            }
                            if (this.type === w.ellipsis) {
                                s = this.start, h.push(this.parseParenItem(this.parseRestBinding())), this.type === w.comma && this.raise(this.start, "Comma is not permitted after the rest element");
                                break;
                            }
                            h.push(this.parseMaybeAssign(!1, c, this.parseParenItem));
                        }
                        var f = this.start, g = this.startLoc;
                        if (this.expect(w.parenR), t && !this.canInsertSemicolon() && this.eat(w.arrow)) return this.checkPatternErrors(c, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d, this.awaitPos = p, this.parseParenArrowList(i, n, h);
                        (!h.length || u) && this.unexpected(this.lastTokStart), s && this.unexpected(s), this.checkExpressionErrors(c, !0), this.yieldPos = d || this.yieldPos, this.awaitPos = p || this.awaitPos, h.length > 1 ? ((e = this.startNodeAt(a, o)).expressions = h, this.finishNodeAt(e, "SequenceExpression", f, g)) : e = h[0];
                    } else e = this.parseParenExpression();
                    if (!this.options.preserveParens) return e;
                    var v = this.startNodeAt(i, n);
                    return v.expression = e, this.finishNode(v, "ParenthesizedExpression");
                }, Y.parseParenItem = function(t) {
                    return t;
                }, Y.parseParenArrowList = function(t, e, i) {
                    return this.parseArrowExpression(this.startNodeAt(t, e), i);
                };
                var J = [];
                Y.parseNew = function() {
                    var t = this.startNode(), e = this.parseIdent(!0);
                    if (this.options.ecmaVersion >= 6 && this.eat(w.dot)) {
                        t.meta = e;
                        var i = this.containsEsc;
                        return t.property = this.parseIdent(!0), ("target" !== t.property.name || i) && this.raiseRecoverable(t.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(t.start, "new.target can only be used in functions"), this.finishNode(t, "MetaProperty");
                    }
                    var n = this.start, r = this.startLoc;
                    return t.callee = this.parseSubscripts(this.parseExprAtom(), n, r, !0), this.options.ecmaVersion > 10 && "Import" === t.callee.type && this.raise(t.callee.start, "Cannot use new with import(...)"), this.eat(w.parenL) ? t.arguments = this.parseExprList(w.parenR, this.options.ecmaVersion >= 8 && "Import" !== t.callee.type, !1) : t.arguments = J, this.finishNode(t, "NewExpression");
                }, Y.parseTemplateElement = function(t) {
                    var e = t.isTagged, i = this.startNode();
                    return this.type === w.invalidTemplate ? (e || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), i.value = {
                        raw: this.value,
                        cooked: null
                    }) : i.value = {
                        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
                        cooked: this.value
                    }, this.next(), i.tail = this.type === w.backQuote, this.finishNode(i, "TemplateElement");
                }, Y.parseTemplate = function(t) {
                    void 0 === t && (t = {});
                    var e = t.isTagged;
                    void 0 === e && (e = !1);
                    var i = this.startNode();
                    this.next(), i.expressions = [];
                    var n = this.parseTemplateElement({
                        isTagged: e
                    });
                    for(i.quasis = [
                        n
                    ]; !n.tail;)this.type === w.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(w.dollarBraceL), i.expressions.push(this.parseExpression()), this.expect(w.braceR), i.quasis.push(n = this.parseTemplateElement({
                        isTagged: e
                    }));
                    return this.next(), this.finishNode(i, "TemplateLiteral");
                }, Y.isAsyncProp = function(t) {
                    return !t.computed && "Identifier" === t.key.type && "async" === t.key.name && (this.type === w.name || this.type === w.num || this.type === w.string || this.type === w.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === w.star) && !C.test(this.input.slice(this.lastTokEnd, this.start));
                }, Y.parseObj = function(t, e) {
                    var i = this.startNode(), n = !0, r = {};
                    for(i.properties = [], this.next(); !this.eat(w.braceR);){
                        if (n) n = !1;
                        else if (this.expect(w.comma), this.afterTrailingComma(w.braceR)) break;
                        var s = this.parseProperty(t, e);
                        t || this.checkPropClash(s, r, e), i.properties.push(s);
                    }
                    return this.finishNode(i, t ? "ObjectPattern" : "ObjectExpression");
                }, Y.parseProperty = function(t, e) {
                    var i, n, r, s, a = this.startNode();
                    if (this.options.ecmaVersion >= 9 && this.eat(w.ellipsis)) return t ? (a.argument = this.parseIdent(!1), this.type === w.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(a, "RestElement")) : (this.type === w.parenL && e && (e.parenthesizedAssign < 0 && (e.parenthesizedAssign = this.start), e.parenthesizedBind < 0 && (e.parenthesizedBind = this.start)), a.argument = this.parseMaybeAssign(!1, e), this.type === w.comma && e && e.trailingComma < 0 && (e.trailingComma = this.start), this.finishNode(a, "SpreadElement"));
                    this.options.ecmaVersion >= 6 && (a.method = !1, a.shorthand = !1, (t || e) && (r = this.start, s = this.startLoc), t || (i = this.eat(w.star)));
                    var o = this.containsEsc;
                    return this.parsePropertyName(a), !t && !o && this.options.ecmaVersion >= 8 && !i && this.isAsyncProp(a) ? (n = !0, i = this.options.ecmaVersion >= 9 && this.eat(w.star), this.parsePropertyName(a, e)) : n = !1, this.parsePropertyValue(a, t, i, n, r, s, e, o), this.finishNode(a, "Property");
                }, Y.parsePropertyValue = function(t, e, i, n, r, s, a, o) {
                    if ((i || n) && this.type === w.colon && this.unexpected(), this.eat(w.colon)) t.value = e ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, a), t.kind = "init";
                    else if (this.options.ecmaVersion >= 6 && this.type === w.parenL) e && this.unexpected(), t.kind = "init", t.method = !0, t.value = this.parseMethod(i, n);
                    else if (e || o || !(this.options.ecmaVersion >= 5) || t.computed || "Identifier" !== t.key.type || "get" !== t.key.name && "set" !== t.key.name || this.type === w.comma || this.type === w.braceR) this.options.ecmaVersion >= 6 && !t.computed && "Identifier" === t.key.type ? ((i || n) && this.unexpected(), this.checkUnreserved(t.key), "await" !== t.key.name || this.awaitIdentPos || (this.awaitIdentPos = r), t.kind = "init", e ? t.value = this.parseMaybeDefault(r, s, t.key) : this.type === w.eq && a ? (a.shorthandAssign < 0 && (a.shorthandAssign = this.start), t.value = this.parseMaybeDefault(r, s, t.key)) : t.value = t.key, t.shorthand = !0) : this.unexpected();
                    else {
                        (i || n) && this.unexpected(), t.kind = t.key.name, this.parsePropertyName(t), t.value = this.parseMethod(!1);
                        var h = +("get" !== t.kind);
                        if (t.value.params.length !== h) {
                            var l = t.value.start;
                            "get" === t.kind ? this.raiseRecoverable(l, "getter should have no params") : this.raiseRecoverable(l, "setter should have exactly one param");
                        } else "set" === t.kind && "RestElement" === t.value.params[0].type && this.raiseRecoverable(t.value.params[0].start, "Setter cannot use rest params");
                    }
                }, Y.parsePropertyName = function(t) {
                    if (this.options.ecmaVersion >= 6) {
                        if (this.eat(w.bracketL)) return t.computed = !0, t.key = this.parseMaybeAssign(), this.expect(w.bracketR), t.key;
                        else t.computed = !1;
                    }
                    return t.key = this.type === w.num || this.type === w.string ? this.parseExprAtom() : this.parseIdent("never" !== this.options.allowReserved);
                }, Y.initFunction = function(t) {
                    t.id = null, this.options.ecmaVersion >= 6 && (t.generator = t.expression = !1), this.options.ecmaVersion >= 8 && (t.async = !1);
                }, Y.parseMethod = function(t, e, i) {
                    var n = this.startNode(), r = this.yieldPos, s = this.awaitPos, a = this.awaitIdentPos;
                    return this.initFunction(n), this.options.ecmaVersion >= 6 && (n.generator = t), this.options.ecmaVersion >= 8 && (n.async = !!e), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | V(e, n.generator) | 128 * !!i), this.expect(w.parenL), n.params = this.parseBindingList(w.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(n, !1, !0), this.yieldPos = r, this.awaitPos = s, this.awaitIdentPos = a, this.finishNode(n, "FunctionExpression");
                }, Y.parseArrowExpression = function(t, e, i) {
                    var n = this.yieldPos, r = this.awaitPos, s = this.awaitIdentPos;
                    return this.enterScope(16 | V(i, !1)), this.initFunction(t), this.options.ecmaVersion >= 8 && (t.async = !!i), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, t.params = this.toAssignableList(e, !0), this.parseFunctionBody(t, !0, !1), this.yieldPos = n, this.awaitPos = r, this.awaitIdentPos = s, this.finishNode(t, "ArrowFunctionExpression");
                }, Y.parseFunctionBody = function(t, e, i) {
                    var n = e && this.type !== w.braceL, r = this.strict, s = !1;
                    if (n) t.body = this.parseMaybeAssign(), t.expression = !0, this.checkParams(t, !1);
                    else {
                        var a = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(t.params);
                        (!r || a) && (s = this.strictDirective(this.end)) && a && this.raiseRecoverable(t.start, "Illegal 'use strict' directive in function with non-simple parameter list");
                        var o = this.labels;
                        this.labels = [], s && (this.strict = !0), this.checkParams(t, !r && !s && !e && !i && this.isSimpleParamList(t.params)), t.body = this.parseBlock(!1), t.expression = !1, this.adaptDirectivePrologue(t.body.body), this.labels = o;
                    }
                    this.exitScope(), this.strict && t.id && this.checkLVal(t.id, 5), this.strict = r;
                }, Y.isSimpleParamList = function(t) {
                    for(var e = 0; e < t.length; e += 1)if ("Identifier" !== t[e].type) return !1;
                    return !0;
                }, Y.checkParams = function(t, e) {
                    for(var i = {}, n = 0, r = t.params; n < r.length; n += 1){
                        var s = r[n];
                        this.checkLVal(s, 1, e ? null : i);
                    }
                }, Y.parseExprList = function(t, e, i, n) {
                    for(var r = [], s = !0; !this.eat(t);){
                        if (s) s = !1;
                        else if (this.expect(w.comma), e && this.afterTrailingComma(t)) break;
                        var a = void 0;
                        i && this.type === w.comma ? a = null : this.type === w.ellipsis ? (a = this.parseSpread(n), n && this.type === w.comma && n.trailingComma < 0 && (n.trailingComma = this.start)) : a = this.parseMaybeAssign(!1, n), r.push(a);
                    }
                    return r;
                }, Y.checkUnreserved = function(t) {
                    var e = t.start, i = t.end, n = t.name;
                    this.inGenerator && "yield" === n && this.raiseRecoverable(e, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && "await" === n && this.raiseRecoverable(e, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(n) && this.raise(e, "Unexpected keyword '" + n + "'"), (!(this.options.ecmaVersion < 6) || -1 === this.input.slice(e, i).indexOf("\\")) && (this.strict ? this.reservedWordsStrict : this.reservedWords).test(n) && (this.inAsync || "await" !== n || this.raiseRecoverable(e, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(e, "The keyword '" + n + "' is reserved"));
                }, Y.parseIdent = function(t, e) {
                    var i = this.startNode();
                    return this.type === w.name ? i.name = this.value : this.type.keyword ? (i.name = this.type.keyword, ("class" === i.name || "function" === i.name) && (this.lastTokEnd !== this.lastTokStart + 1 || 46 !== this.input.charCodeAt(this.lastTokStart)) && this.context.pop()) : this.unexpected(), this.next(), this.finishNode(i, "Identifier"), !t && (this.checkUnreserved(i), "await" !== i.name || this.awaitIdentPos || (this.awaitIdentPos = i.start)), i;
                }, Y.parseYield = function(t) {
                    this.yieldPos || (this.yieldPos = this.start);
                    var e = this.startNode();
                    return this.next(), this.type === w.semi || this.canInsertSemicolon() || this.type !== w.star && !this.type.startsExpr ? (e.delegate = !1, e.argument = null) : (e.delegate = this.eat(w.star), e.argument = this.parseMaybeAssign(t)), this.finishNode(e, "YieldExpression");
                }, Y.parseAwait = function() {
                    this.awaitPos || (this.awaitPos = this.start);
                    var t = this.startNode();
                    return this.next(), t.argument = this.parseMaybeUnary(null, !0), this.finishNode(t, "AwaitExpression");
                };
                var K = F.prototype;
                K.raise = function(t, e) {
                    var i = z(this.input, t), n = SyntaxError(e += " (" + i.line + ":" + i.column + ")");
                    throw n.pos = t, n.loc = i, n.raisedAt = this.pos, n;
                }, K.raiseRecoverable = K.raise, K.curPosition = function() {
                    if (this.options.locations) return new O(this.curLine, this.pos - this.lineStart);
                };
                var tt = F.prototype, te = function(t) {
                    this.flags = t, this.var = [], this.lexical = [], this.functions = [];
                };
                tt.enterScope = function(t) {
                    this.scopeStack.push(new te(t));
                }, tt.exitScope = function() {
                    this.scopeStack.pop();
                }, tt.treatFunctionsAsVarInScope = function(t) {
                    return 2 & t.flags || !this.inModule && 1 & t.flags;
                }, tt.declareName = function(t, e, i) {
                    var n = !1;
                    if (2 === e) {
                        var r = this.currentScope();
                        n = r.lexical.indexOf(t) > -1 || r.functions.indexOf(t) > -1 || r.var.indexOf(t) > -1, r.lexical.push(t), this.inModule && 1 & r.flags && delete this.undefinedExports[t];
                    } else if (4 === e) this.currentScope().lexical.push(t);
                    else if (3 === e) {
                        var s = this.currentScope();
                        n = this.treatFunctionsAsVar ? s.lexical.indexOf(t) > -1 : s.lexical.indexOf(t) > -1 || s.var.indexOf(t) > -1, s.functions.push(t);
                    } else for(var a = this.scopeStack.length - 1; a >= 0; --a){
                        var o = this.scopeStack[a];
                        if (o.lexical.indexOf(t) > -1 && !(32 & o.flags && o.lexical[0] === t) || !this.treatFunctionsAsVarInScope(o) && o.functions.indexOf(t) > -1) {
                            n = !0;
                            break;
                        }
                        if (o.var.push(t), this.inModule && 1 & o.flags && delete this.undefinedExports[t], 3 & o.flags) break;
                    }
                    n && this.raiseRecoverable(i, "Identifier '" + t + "' has already been declared");
                }, tt.checkLocalExport = function(t) {
                    -1 === this.scopeStack[0].lexical.indexOf(t.name) && -1 === this.scopeStack[0].var.indexOf(t.name) && (this.undefinedExports[t.name] = t);
                }, tt.currentScope = function() {
                    return this.scopeStack[this.scopeStack.length - 1];
                }, tt.currentVarScope = function() {
                    for(var t = this.scopeStack.length - 1;; t--){
                        var e = this.scopeStack[t];
                        if (3 & e.flags) return e;
                    }
                }, tt.currentThisScope = function() {
                    for(var t = this.scopeStack.length - 1;; t--){
                        var e = this.scopeStack[t];
                        if (3 & e.flags && !(16 & e.flags)) return e;
                    }
                };
                var ti = function(t, e, i) {
                    this.type = "", this.start = e, this.end = 0, t.options.locations && (this.loc = new N(t, i)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [
                        e,
                        0
                    ]);
                }, tn = F.prototype;
                function tr(t, e, i, n) {
                    return t.type = e, t.end = i, this.options.locations && (t.loc.end = n), this.options.ranges && (t.range[1] = i), t;
                }
                tn.startNode = function() {
                    return new ti(this, this.start, this.startLoc);
                }, tn.startNodeAt = function(t, e) {
                    return new ti(this, t, e);
                }, tn.finishNode = function(t, e) {
                    return tr.call(this, t, e, this.lastTokEnd, this.lastTokEndLoc);
                }, tn.finishNodeAt = function(t, e, i, n) {
                    return tr.call(this, t, e, i, n);
                };
                var ts = function(t, e, i, n, r) {
                    this.token = t, this.isExpr = !!e, this.preserveSpace = !!i, this.override = n, this.generator = !!r;
                }, ta = {
                    b_stat: new ts("{", !1),
                    b_expr: new ts("{", !0),
                    b_tmpl: new ts("${", !1),
                    p_stat: new ts("(", !1),
                    p_expr: new ts("(", !0),
                    q_tmpl: new ts("`", !0, !0, function(t) {
                        return t.tryReadTemplateToken();
                    }),
                    f_stat: new ts("function", !1),
                    f_expr: new ts("function", !0),
                    f_expr_gen: new ts("function", !0, !1, null, !0),
                    f_gen: new ts("function", !1, !1, null, !0)
                }, to = F.prototype;
                to.initialContext = function() {
                    return [
                        ta.b_stat
                    ];
                }, to.braceIsBlock = function(t) {
                    var e = this.curContext();
                    return e === ta.f_expr || e === ta.f_stat || (t === w.colon && (e === ta.b_stat || e === ta.b_expr) ? !e.isExpr : t === w._return || t === w.name && this.exprAllowed ? C.test(this.input.slice(this.lastTokEnd, this.start)) : t === w._else || t === w.semi || t === w.eof || t === w.parenR || t === w.arrow || (t === w.braceL ? e === ta.b_stat : t !== w._var && t !== w._const && t !== w.name && !this.exprAllowed));
                }, to.inGeneratorContext = function() {
                    for(var t = this.context.length - 1; t >= 1; t--){
                        var e = this.context[t];
                        if ("function" === e.token) return e.generator;
                    }
                    return !1;
                }, to.updateContext = function(t) {
                    var e, i = this.type;
                    i.keyword && t === w.dot ? this.exprAllowed = !1 : (e = i.updateContext) ? e.call(this, t) : this.exprAllowed = i.beforeExpr;
                }, w.parenR.updateContext = w.braceR.updateContext = function() {
                    if (1 === this.context.length) {
                        this.exprAllowed = !0;
                        return;
                    }
                    var t = this.context.pop();
                    t === ta.b_stat && "function" === this.curContext().token && (t = this.context.pop()), this.exprAllowed = !t.isExpr;
                }, w.braceL.updateContext = function(t) {
                    this.context.push(this.braceIsBlock(t) ? ta.b_stat : ta.b_expr), this.exprAllowed = !0;
                }, w.dollarBraceL.updateContext = function() {
                    this.context.push(ta.b_tmpl), this.exprAllowed = !0;
                }, w.parenL.updateContext = function(t) {
                    var e = t === w._if || t === w._for || t === w._with || t === w._while;
                    this.context.push(e ? ta.p_stat : ta.p_expr), this.exprAllowed = !0;
                }, w.incDec.updateContext = function() {}, w._function.updateContext = w._class.updateContext = function(t) {
                    t.beforeExpr && t !== w.semi && t !== w._else && !(t === w._return && C.test(this.input.slice(this.lastTokEnd, this.start))) && (t !== w.colon && t !== w.braceL || this.curContext() !== ta.b_stat) ? this.context.push(ta.f_expr) : this.context.push(ta.f_stat), this.exprAllowed = !1;
                }, w.backQuote.updateContext = function() {
                    this.curContext() === ta.q_tmpl ? this.context.pop() : this.context.push(ta.q_tmpl), this.exprAllowed = !1;
                }, w.star.updateContext = function(t) {
                    if (t === w._function) {
                        var e = this.context.length - 1;
                        this.context[e] === ta.f_expr ? this.context[e] = ta.f_expr_gen : this.context[e] = ta.f_gen;
                    }
                    this.exprAllowed = !0;
                }, w.name.updateContext = function(t) {
                    var e = !1;
                    this.options.ecmaVersion >= 6 && t !== w.dot && ("of" === this.value && !this.exprAllowed || "yield" === this.value && this.inGeneratorContext()) && (e = !0), this.exprAllowed = e;
                };
                var th = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", tl = th + " Extended_Pictographic", tu = {
                    9: th,
                    10: tl,
                    11: tl
                }, tc = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", td = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", tp = td + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", tf = {
                    9: td,
                    10: tp,
                    11: tp + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho"
                }, tg = {};
                function tv(t) {
                    var e = tg[t] = {
                        binary: B(tu[t] + " " + tc),
                        nonBinary: {
                            General_Category: B(tc),
                            Script: B(tf[t])
                        }
                    };
                    e.nonBinary.Script_Extensions = e.nonBinary.Script, e.nonBinary.gc = e.nonBinary.General_Category, e.nonBinary.sc = e.nonBinary.Script, e.nonBinary.scx = e.nonBinary.Script_Extensions;
                }
                tv(9), tv(10), tv(11);
                var t_ = F.prototype, tm = function(t) {
                    this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = tg[t.options.ecmaVersion >= 11 ? 11 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
                };
                function ty(t) {
                    return t <= 65535 ? String.fromCharCode(t) : String.fromCharCode(((t -= 65536) >> 10) + 55296, (1023 & t) + 56320);
                }
                function tb(t) {
                    return 36 === t || t >= 40 && t <= 43 || 46 === t || 63 === t || t >= 91 && t <= 94 || t >= 123 && t <= 125;
                }
                function tx(t) {
                    return t >= 65 && t <= 90 || t >= 97 && t <= 122;
                }
                function tw(t) {
                    return tx(t) || 95 === t;
                }
                function tC(t) {
                    return t >= 48 && t <= 57;
                }
                function tS(t) {
                    return t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102;
                }
                function tk(t) {
                    return t >= 65 && t <= 70 ? 10 + (t - 65) : t >= 97 && t <= 102 ? 10 + (t - 97) : t - 48;
                }
                function tP(t) {
                    return t >= 48 && t <= 55;
                }
                tm.prototype.reset = function(t, e, i) {
                    var n = -1 !== i.indexOf("u");
                    this.start = 0 | t, this.source = e + "", this.flags = i, this.switchU = n && this.parser.options.ecmaVersion >= 6, this.switchN = n && this.parser.options.ecmaVersion >= 9;
                }, tm.prototype.raise = function(t) {
                    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
                }, tm.prototype.at = function(t) {
                    var e = this.source, i = e.length;
                    if (t >= i) return -1;
                    var n = e.charCodeAt(t);
                    if (!this.switchU || n <= 55295 || n >= 57344 || t + 1 >= i) return n;
                    var r = e.charCodeAt(t + 1);
                    return r >= 56320 && r <= 57343 ? (n << 10) + r - 0x35fdc00 : n;
                }, tm.prototype.nextIndex = function(t) {
                    var e = this.source, i = e.length;
                    if (t >= i) return i;
                    var n, r = e.charCodeAt(t);
                    return !this.switchU || r <= 55295 || r >= 57344 || t + 1 >= i || (n = e.charCodeAt(t + 1)) < 56320 || n > 57343 ? t + 1 : t + 2;
                }, tm.prototype.current = function() {
                    return this.at(this.pos);
                }, tm.prototype.lookahead = function() {
                    return this.at(this.nextIndex(this.pos));
                }, tm.prototype.advance = function() {
                    this.pos = this.nextIndex(this.pos);
                }, tm.prototype.eat = function(t) {
                    return this.current() === t && (this.advance(), !0);
                }, t_.validateRegExpFlags = function(t) {
                    for(var e = t.validFlags, i = t.flags, n = 0; n < i.length; n++){
                        var r = i.charAt(n);
                        -1 === e.indexOf(r) && this.raise(t.start, "Invalid regular expression flag"), i.indexOf(r, n + 1) > -1 && this.raise(t.start, "Duplicate regular expression flag");
                    }
                }, t_.validateRegExpPattern = function(t) {
                    this.regexp_pattern(t), !t.switchN && this.options.ecmaVersion >= 9 && t.groupNames.length > 0 && (t.switchN = !0, this.regexp_pattern(t));
                }, t_.regexp_pattern = function(t) {
                    t.pos = 0, t.lastIntValue = 0, t.lastStringValue = "", t.lastAssertionIsQuantifiable = !1, t.numCapturingParens = 0, t.maxBackReference = 0, t.groupNames.length = 0, t.backReferenceNames.length = 0, this.regexp_disjunction(t), t.pos !== t.source.length && (t.eat(41) && t.raise("Unmatched ')'"), (t.eat(93) || t.eat(125)) && t.raise("Lone quantifier brackets")), t.maxBackReference > t.numCapturingParens && t.raise("Invalid escape");
                    for(var e = 0, i = t.backReferenceNames; e < i.length; e += 1){
                        var n = i[e];
                        -1 === t.groupNames.indexOf(n) && t.raise("Invalid named capture referenced");
                    }
                }, t_.regexp_disjunction = function(t) {
                    for(this.regexp_alternative(t); t.eat(124);)this.regexp_alternative(t);
                    this.regexp_eatQuantifier(t, !0) && t.raise("Nothing to repeat"), t.eat(123) && t.raise("Lone quantifier brackets");
                }, t_.regexp_alternative = function(t) {
                    for(; t.pos < t.source.length && this.regexp_eatTerm(t););
                }, t_.regexp_eatTerm = function(t) {
                    return this.regexp_eatAssertion(t) ? (t.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(t) && t.switchU && t.raise("Invalid quantifier"), !0) : (t.switchU ? !!this.regexp_eatAtom(t) : !!this.regexp_eatExtendedAtom(t)) && (this.regexp_eatQuantifier(t), !0);
                }, t_.regexp_eatAssertion = function(t) {
                    var e = t.pos;
                    if (t.lastAssertionIsQuantifiable = !1, t.eat(94) || t.eat(36)) return !0;
                    if (t.eat(92)) {
                        if (t.eat(66) || t.eat(98)) return !0;
                        t.pos = e;
                    }
                    if (t.eat(40) && t.eat(63)) {
                        var i = !1;
                        if (this.options.ecmaVersion >= 9 && (i = t.eat(60)), t.eat(61) || t.eat(33)) return this.regexp_disjunction(t), t.eat(41) || t.raise("Unterminated group"), t.lastAssertionIsQuantifiable = !i, !0;
                    }
                    return t.pos = e, !1;
                }, t_.regexp_eatQuantifier = function(t, e) {
                    return void 0 === e && (e = !1), !!this.regexp_eatQuantifierPrefix(t, e) && (t.eat(63), !0);
                }, t_.regexp_eatQuantifierPrefix = function(t, e) {
                    return t.eat(42) || t.eat(43) || t.eat(63) || this.regexp_eatBracedQuantifier(t, e);
                }, t_.regexp_eatBracedQuantifier = function(t, e) {
                    var i = t.pos;
                    if (t.eat(123)) {
                        var n = 0, r = -1;
                        if (this.regexp_eatDecimalDigits(t) && (n = t.lastIntValue, t.eat(44) && this.regexp_eatDecimalDigits(t) && (r = t.lastIntValue), t.eat(125))) return -1 !== r && r < n && !e && t.raise("numbers out of order in {} quantifier"), !0;
                        t.switchU && !e && t.raise("Incomplete quantifier"), t.pos = i;
                    }
                    return !1;
                }, t_.regexp_eatAtom = function(t) {
                    return this.regexp_eatPatternCharacters(t) || t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t);
                }, t_.regexp_eatReverseSolidusAtomEscape = function(t) {
                    var e = t.pos;
                    if (t.eat(92)) {
                        if (this.regexp_eatAtomEscape(t)) return !0;
                        t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatUncapturingGroup = function(t) {
                    var e = t.pos;
                    if (t.eat(40)) {
                        if (t.eat(63) && t.eat(58)) {
                            if (this.regexp_disjunction(t), t.eat(41)) return !0;
                            t.raise("Unterminated group");
                        }
                        t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatCapturingGroup = function(t) {
                    if (t.eat(40)) {
                        if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(t) : 63 === t.current() && t.raise("Invalid group"), this.regexp_disjunction(t), t.eat(41)) return t.numCapturingParens += 1, !0;
                        t.raise("Unterminated group");
                    }
                    return !1;
                }, t_.regexp_eatExtendedAtom = function(t) {
                    return t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t) || this.regexp_eatInvalidBracedQuantifier(t) || this.regexp_eatExtendedPatternCharacter(t);
                }, t_.regexp_eatInvalidBracedQuantifier = function(t) {
                    return this.regexp_eatBracedQuantifier(t, !0) && t.raise("Nothing to repeat"), !1;
                }, t_.regexp_eatSyntaxCharacter = function(t) {
                    var e = t.current();
                    return !!tb(e) && (t.lastIntValue = e, t.advance(), !0);
                }, t_.regexp_eatPatternCharacters = function(t) {
                    for(var e = t.pos, i = 0; -1 !== (i = t.current()) && !tb(i);)t.advance();
                    return t.pos !== e;
                }, t_.regexp_eatExtendedPatternCharacter = function(t) {
                    var e = t.current();
                    return -1 !== e && 36 !== e && (!(e >= 40) || !(e <= 43)) && 46 !== e && 63 !== e && 91 !== e && 94 !== e && 124 !== e && (t.advance(), !0);
                }, t_.regexp_groupSpecifier = function(t) {
                    if (t.eat(63)) {
                        if (this.regexp_eatGroupName(t)) {
                            -1 !== t.groupNames.indexOf(t.lastStringValue) && t.raise("Duplicate capture group name"), t.groupNames.push(t.lastStringValue);
                            return;
                        }
                        t.raise("Invalid group");
                    }
                }, t_.regexp_eatGroupName = function(t) {
                    if (t.lastStringValue = "", t.eat(60)) {
                        if (this.regexp_eatRegExpIdentifierName(t) && t.eat(62)) return !0;
                        t.raise("Invalid capture group name");
                    }
                    return !1;
                }, t_.regexp_eatRegExpIdentifierName = function(t) {
                    if (t.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(t)) {
                        for(t.lastStringValue += ty(t.lastIntValue); this.regexp_eatRegExpIdentifierPart(t);)t.lastStringValue += ty(t.lastIntValue);
                        return !0;
                    }
                    return !1;
                }, t_.regexp_eatRegExpIdentifierStart = function(t) {
                    var e, i = t.pos, n = t.current();
                    return (t.advance(), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(t) && (n = t.lastIntValue), f(e = n, !0) || 36 === e || 95 === e) ? (t.lastIntValue = n, !0) : (t.pos = i, !1);
                }, t_.regexp_eatRegExpIdentifierPart = function(t) {
                    var e, i = t.pos, n = t.current();
                    return (t.advance(), 92 === n && this.regexp_eatRegExpUnicodeEscapeSequence(t) && (n = t.lastIntValue), g(e = n, !0) || 36 === e || 95 === e || 8204 === e || 8205 === e) ? (t.lastIntValue = n, !0) : (t.pos = i, !1);
                }, t_.regexp_eatAtomEscape = function(t) {
                    return !!(this.regexp_eatBackReference(t) || this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t) || t.switchN && this.regexp_eatKGroupName(t)) || (t.switchU && (99 === t.current() && t.raise("Invalid unicode escape"), t.raise("Invalid escape")), !1);
                }, t_.regexp_eatBackReference = function(t) {
                    var e = t.pos;
                    if (this.regexp_eatDecimalEscape(t)) {
                        var i = t.lastIntValue;
                        if (t.switchU) return i > t.maxBackReference && (t.maxBackReference = i), !0;
                        if (i <= t.numCapturingParens) return !0;
                        t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatKGroupName = function(t) {
                    if (t.eat(107)) {
                        if (this.regexp_eatGroupName(t)) return t.backReferenceNames.push(t.lastStringValue), !0;
                        t.raise("Invalid named reference");
                    }
                    return !1;
                }, t_.regexp_eatCharacterEscape = function(t) {
                    return this.regexp_eatControlEscape(t) || this.regexp_eatCControlLetter(t) || this.regexp_eatZero(t) || this.regexp_eatHexEscapeSequence(t) || this.regexp_eatRegExpUnicodeEscapeSequence(t) || !t.switchU && this.regexp_eatLegacyOctalEscapeSequence(t) || this.regexp_eatIdentityEscape(t);
                }, t_.regexp_eatCControlLetter = function(t) {
                    var e = t.pos;
                    if (t.eat(99)) {
                        if (this.regexp_eatControlLetter(t)) return !0;
                        t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatZero = function(t) {
                    return !(48 !== t.current() || tC(t.lookahead())) && (t.lastIntValue = 0, t.advance(), !0);
                }, t_.regexp_eatControlEscape = function(t) {
                    var e = t.current();
                    return 116 === e ? (t.lastIntValue = 9, t.advance(), !0) : 110 === e ? (t.lastIntValue = 10, t.advance(), !0) : 118 === e ? (t.lastIntValue = 11, t.advance(), !0) : 102 === e ? (t.lastIntValue = 12, t.advance(), !0) : 114 === e && (t.lastIntValue = 13, t.advance(), !0);
                }, t_.regexp_eatControlLetter = function(t) {
                    var e = t.current();
                    return !!tx(e) && (t.lastIntValue = e % 32, t.advance(), !0);
                }, t_.regexp_eatRegExpUnicodeEscapeSequence = function(t) {
                    var e = t.pos;
                    if (t.eat(117)) {
                        if (this.regexp_eatFixedHexDigits(t, 4)) {
                            var i, n = t.lastIntValue;
                            if (t.switchU && n >= 55296 && n <= 56319) {
                                var r = t.pos;
                                if (t.eat(92) && t.eat(117) && this.regexp_eatFixedHexDigits(t, 4)) {
                                    var s = t.lastIntValue;
                                    if (s >= 56320 && s <= 57343) return t.lastIntValue = (n - 55296) * 1024 + (s - 56320) + 65536, !0;
                                }
                                t.pos = r, t.lastIntValue = n;
                            }
                            return !0;
                        }
                        if (t.switchU && t.eat(123) && this.regexp_eatHexDigits(t) && t.eat(125) && (i = t.lastIntValue) >= 0 && i <= 1114111) return !0;
                        t.switchU && t.raise("Invalid unicode escape"), t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatIdentityEscape = function(t) {
                    if (t.switchU) return !!this.regexp_eatSyntaxCharacter(t) || !!t.eat(47) && (t.lastIntValue = 47, !0);
                    var e = t.current();
                    return 99 !== e && (!t.switchN || 107 !== e) && (t.lastIntValue = e, t.advance(), !0);
                }, t_.regexp_eatDecimalEscape = function(t) {
                    t.lastIntValue = 0;
                    var e = t.current();
                    if (e >= 49 && e <= 57) {
                        do t.lastIntValue = 10 * t.lastIntValue + (e - 48), t.advance();
                        while ((e = t.current()) >= 48 && e <= 57);
                        return !0;
                    }
                    return !1;
                }, t_.regexp_eatCharacterClassEscape = function(t) {
                    var e, i = t.current();
                    if (100 === (e = i) || 68 === e || 115 === e || 83 === e || 119 === e || 87 === e) return t.lastIntValue = -1, t.advance(), !0;
                    if (t.switchU && this.options.ecmaVersion >= 9 && (80 === i || 112 === i)) {
                        if (t.lastIntValue = -1, t.advance(), t.eat(123) && this.regexp_eatUnicodePropertyValueExpression(t) && t.eat(125)) return !0;
                        t.raise("Invalid property name");
                    }
                    return !1;
                }, t_.regexp_eatUnicodePropertyValueExpression = function(t) {
                    var e = t.pos;
                    if (this.regexp_eatUnicodePropertyName(t) && t.eat(61)) {
                        var i = t.lastStringValue;
                        if (this.regexp_eatUnicodePropertyValue(t)) {
                            var n = t.lastStringValue;
                            return this.regexp_validateUnicodePropertyNameAndValue(t, i, n), !0;
                        }
                    }
                    if (t.pos = e, this.regexp_eatLoneUnicodePropertyNameOrValue(t)) {
                        var r = t.lastStringValue;
                        return this.regexp_validateUnicodePropertyNameOrValue(t, r), !0;
                    }
                    return !1;
                }, t_.regexp_validateUnicodePropertyNameAndValue = function(t, e, i) {
                    L(t.unicodeProperties.nonBinary, e) || t.raise("Invalid property name"), t.unicodeProperties.nonBinary[e].test(i) || t.raise("Invalid property value");
                }, t_.regexp_validateUnicodePropertyNameOrValue = function(t, e) {
                    t.unicodeProperties.binary.test(e) || t.raise("Invalid property name");
                }, t_.regexp_eatUnicodePropertyName = function(t) {
                    var e = 0;
                    for(t.lastStringValue = ""; tw(e = t.current());)t.lastStringValue += ty(e), t.advance();
                    return "" !== t.lastStringValue;
                }, t_.regexp_eatUnicodePropertyValue = function(t) {
                    var e, i = 0;
                    for(t.lastStringValue = ""; tw(e = i = t.current()) || tC(e);)t.lastStringValue += ty(i), t.advance();
                    return "" !== t.lastStringValue;
                }, t_.regexp_eatLoneUnicodePropertyNameOrValue = function(t) {
                    return this.regexp_eatUnicodePropertyValue(t);
                }, t_.regexp_eatCharacterClass = function(t) {
                    if (t.eat(91)) {
                        if (t.eat(94), this.regexp_classRanges(t), t.eat(93)) return !0;
                        t.raise("Unterminated character class");
                    }
                    return !1;
                }, t_.regexp_classRanges = function(t) {
                    for(; this.regexp_eatClassAtom(t);){
                        var e = t.lastIntValue;
                        if (t.eat(45) && this.regexp_eatClassAtom(t)) {
                            var i = t.lastIntValue;
                            t.switchU && (-1 === e || -1 === i) && t.raise("Invalid character class"), -1 !== e && -1 !== i && e > i && t.raise("Range out of order in character class");
                        }
                    }
                }, t_.regexp_eatClassAtom = function(t) {
                    var e = t.pos;
                    if (t.eat(92)) {
                        if (this.regexp_eatClassEscape(t)) return !0;
                        if (t.switchU) {
                            var i = t.current();
                            (99 === i || tP(i)) && t.raise("Invalid class escape"), t.raise("Invalid escape");
                        }
                        t.pos = e;
                    }
                    var n = t.current();
                    return 93 !== n && (t.lastIntValue = n, t.advance(), !0);
                }, t_.regexp_eatClassEscape = function(t) {
                    var e = t.pos;
                    if (t.eat(98)) return t.lastIntValue = 8, !0;
                    if (t.switchU && t.eat(45)) return t.lastIntValue = 45, !0;
                    if (!t.switchU && t.eat(99)) {
                        if (this.regexp_eatClassControlLetter(t)) return !0;
                        t.pos = e;
                    }
                    return this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t);
                }, t_.regexp_eatClassControlLetter = function(t) {
                    var e = t.current();
                    return (!!tC(e) || 95 === e) && (t.lastIntValue = e % 32, t.advance(), !0);
                }, t_.regexp_eatHexEscapeSequence = function(t) {
                    var e = t.pos;
                    if (t.eat(120)) {
                        if (this.regexp_eatFixedHexDigits(t, 2)) return !0;
                        t.switchU && t.raise("Invalid escape"), t.pos = e;
                    }
                    return !1;
                }, t_.regexp_eatDecimalDigits = function(t) {
                    var e = t.pos, i = 0;
                    for(t.lastIntValue = 0; tC(i = t.current());)t.lastIntValue = 10 * t.lastIntValue + (i - 48), t.advance();
                    return t.pos !== e;
                }, t_.regexp_eatHexDigits = function(t) {
                    var e = t.pos, i = 0;
                    for(t.lastIntValue = 0; tS(i = t.current());)t.lastIntValue = 16 * t.lastIntValue + tk(i), t.advance();
                    return t.pos !== e;
                }, t_.regexp_eatLegacyOctalEscapeSequence = function(t) {
                    if (this.regexp_eatOctalDigit(t)) {
                        var e = t.lastIntValue;
                        if (this.regexp_eatOctalDigit(t)) {
                            var i = t.lastIntValue;
                            e <= 3 && this.regexp_eatOctalDigit(t) ? t.lastIntValue = 64 * e + 8 * i + t.lastIntValue : t.lastIntValue = 8 * e + i;
                        } else t.lastIntValue = e;
                        return !0;
                    }
                    return !1;
                }, t_.regexp_eatOctalDigit = function(t) {
                    var e = t.current();
                    return tP(e) ? (t.lastIntValue = e - 48, t.advance(), !0) : (t.lastIntValue = 0, !1);
                }, t_.regexp_eatFixedHexDigits = function(t, e) {
                    var i = t.pos;
                    t.lastIntValue = 0;
                    for(var n = 0; n < e; ++n){
                        var r = t.current();
                        if (!tS(r)) return t.pos = i, !1;
                        t.lastIntValue = 16 * t.lastIntValue + tk(r), t.advance();
                    }
                    return !0;
                };
                var tA = function(t) {
                    this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new N(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [
                        t.start,
                        t.end
                    ]);
                }, tI = F.prototype;
                function tT(t) {
                    return t <= 65535 ? String.fromCharCode(t) : String.fromCharCode(((t -= 65536) >> 10) + 55296, (1023 & t) + 56320);
                }
                tI.next = function() {
                    this.options.onToken && this.options.onToken(new tA(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
                }, tI.getToken = function() {
                    return this.next(), new tA(this);
                }, "undefined" != typeof Symbol && (tI[Symbol.iterator] = function() {
                    var t = this;
                    return {
                        next: function() {
                            var e = t.getToken();
                            return {
                                done: e.type === w.eof,
                                value: e
                            };
                        }
                    };
                }), tI.curContext = function() {
                    return this.context[this.context.length - 1];
                }, tI.nextToken = function() {
                    var t = this.curContext();
                    return (t && t.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length) ? this.finishToken(w.eof) : t.override ? t.override(this) : void this.readToken(this.fullCharCodeAtPos());
                }, tI.readToken = function(t) {
                    return f(t, this.options.ecmaVersion >= 6) || 92 === t ? this.readWord() : this.getTokenFromCode(t);
                }, tI.fullCharCodeAtPos = function() {
                    var t = this.input.charCodeAt(this.pos);
                    return t <= 55295 || t >= 57344 ? t : (t << 10) + this.input.charCodeAt(this.pos + 1) - 0x35fdc00;
                }, tI.skipBlockComment = function() {
                    var t, e = this.options.onComment && this.curPosition(), i = this.pos, n = this.input.indexOf("*/", this.pos += 2);
                    if (-1 === n && this.raise(this.pos - 2, "Unterminated comment"), this.pos = n + 2, this.options.locations) for(S.lastIndex = i; (t = S.exec(this.input)) && t.index < this.pos;)++this.curLine, this.lineStart = t.index + t[0].length;
                    this.options.onComment && this.options.onComment(!0, this.input.slice(i + 2, n), i, this.pos, e, this.curPosition());
                }, tI.skipLineComment = function(t) {
                    for(var e = this.pos, i = this.options.onComment && this.curPosition(), n = this.input.charCodeAt(this.pos += t); this.pos < this.input.length && !k(n);)n = this.input.charCodeAt(++this.pos);
                    this.options.onComment && this.options.onComment(!1, this.input.slice(e + t, this.pos), e, this.pos, i, this.curPosition());
                }, tI.skipSpace = function() {
                    t: for(; this.pos < this.input.length;){
                        var t = this.input.charCodeAt(this.pos);
                        switch(t){
                            case 32:
                            case 160:
                                ++this.pos;
                                break;
                            case 13:
                                10 === this.input.charCodeAt(this.pos + 1) && ++this.pos;
                            case 10:
                            case 8232:
                            case 8233:
                                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                                break;
                            case 47:
                                switch(this.input.charCodeAt(this.pos + 1)){
                                    case 42:
                                        this.skipBlockComment();
                                        break;
                                    case 47:
                                        this.skipLineComment(2);
                                        break;
                                    default:
                                        break t;
                                }
                                break;
                            default:
                                if (t > 8 && t < 14 || t >= 5760 && P.test(String.fromCharCode(t))) ++this.pos;
                                else break t;
                        }
                    }
                }, tI.finishToken = function(t, e) {
                    this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
                    var i = this.type;
                    this.type = t, this.value = e, this.updateContext(i);
                }, tI.readToken_dot = function() {
                    var t = this.input.charCodeAt(this.pos + 1);
                    if (t >= 48 && t <= 57) return this.readNumber(!0);
                    var e = this.input.charCodeAt(this.pos + 2);
                    return this.options.ecmaVersion >= 6 && 46 === t && 46 === e ? (this.pos += 3, this.finishToken(w.ellipsis)) : (++this.pos, this.finishToken(w.dot));
                }, tI.readToken_slash = function() {
                    var t = this.input.charCodeAt(this.pos + 1);
                    return this.exprAllowed ? (++this.pos, this.readRegexp()) : 61 === t ? this.finishOp(w.assign, 2) : this.finishOp(w.slash, 1);
                }, tI.readToken_mult_modulo_exp = function(t) {
                    var e = this.input.charCodeAt(this.pos + 1), i = 1, n = 42 === t ? w.star : w.modulo;
                    return (this.options.ecmaVersion >= 7 && 42 === t && 42 === e && (++i, n = w.starstar, e = this.input.charCodeAt(this.pos + 2)), 61 === e) ? this.finishOp(w.assign, i + 1) : this.finishOp(n, i);
                }, tI.readToken_pipe_amp = function(t) {
                    var e = this.input.charCodeAt(this.pos + 1);
                    return e === t ? this.finishOp(124 === t ? w.logicalOR : w.logicalAND, 2) : 61 === e ? this.finishOp(w.assign, 2) : this.finishOp(124 === t ? w.bitwiseOR : w.bitwiseAND, 1);
                }, tI.readToken_caret = function() {
                    return 61 === this.input.charCodeAt(this.pos + 1) ? this.finishOp(w.assign, 2) : this.finishOp(w.bitwiseXOR, 1);
                }, tI.readToken_plus_min = function(t) {
                    var e = this.input.charCodeAt(this.pos + 1);
                    return e === t ? 45 === e && !this.inModule && 62 === this.input.charCodeAt(this.pos + 2) && (0 === this.lastTokEnd || C.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(w.incDec, 2) : 61 === e ? this.finishOp(w.assign, 2) : this.finishOp(w.plusMin, 1);
                }, tI.readToken_lt_gt = function(t) {
                    var e = this.input.charCodeAt(this.pos + 1), i = 1;
                    return e === t ? (i = 62 === t && 62 === this.input.charCodeAt(this.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.pos + i)) ? this.finishOp(w.assign, i + 1) : this.finishOp(w.bitShift, i) : 33 !== e || 60 !== t || this.inModule || 45 !== this.input.charCodeAt(this.pos + 2) || 45 !== this.input.charCodeAt(this.pos + 3) ? (61 === e && (i = 2), this.finishOp(w.relational, i)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
                }, tI.readToken_eq_excl = function(t) {
                    var e = this.input.charCodeAt(this.pos + 1);
                    return 61 === e ? this.finishOp(w.equality, 61 === this.input.charCodeAt(this.pos + 2) ? 3 : 2) : 61 === t && 62 === e && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(w.arrow)) : this.finishOp(61 === t ? w.eq : w.prefix, 1);
                }, tI.getTokenFromCode = function(t) {
                    switch(t){
                        case 46:
                            return this.readToken_dot();
                        case 40:
                            return ++this.pos, this.finishToken(w.parenL);
                        case 41:
                            return ++this.pos, this.finishToken(w.parenR);
                        case 59:
                            return ++this.pos, this.finishToken(w.semi);
                        case 44:
                            return ++this.pos, this.finishToken(w.comma);
                        case 91:
                            return ++this.pos, this.finishToken(w.bracketL);
                        case 93:
                            return ++this.pos, this.finishToken(w.bracketR);
                        case 123:
                            return ++this.pos, this.finishToken(w.braceL);
                        case 125:
                            return ++this.pos, this.finishToken(w.braceR);
                        case 58:
                            return ++this.pos, this.finishToken(w.colon);
                        case 63:
                            return ++this.pos, this.finishToken(w.question);
                        case 96:
                            if (this.options.ecmaVersion < 6) break;
                            return ++this.pos, this.finishToken(w.backQuote);
                        case 48:
                            var e = this.input.charCodeAt(this.pos + 1);
                            if (120 === e || 88 === e) return this.readRadixNumber(16);
                            if (this.options.ecmaVersion >= 6) {
                                if (111 === e || 79 === e) return this.readRadixNumber(8);
                                if (98 === e || 66 === e) return this.readRadixNumber(2);
                            }
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return this.readNumber(!1);
                        case 34:
                        case 39:
                            return this.readString(t);
                        case 47:
                            return this.readToken_slash();
                        case 37:
                        case 42:
                            return this.readToken_mult_modulo_exp(t);
                        case 124:
                        case 38:
                            return this.readToken_pipe_amp(t);
                        case 94:
                            return this.readToken_caret();
                        case 43:
                        case 45:
                            return this.readToken_plus_min(t);
                        case 60:
                        case 62:
                            return this.readToken_lt_gt(t);
                        case 61:
                        case 33:
                            return this.readToken_eq_excl(t);
                        case 126:
                            return this.finishOp(w.prefix, 1);
                    }
                    this.raise(this.pos, "Unexpected character '" + tT(t) + "'");
                }, tI.finishOp = function(t, e) {
                    var i = this.input.slice(this.pos, this.pos + e);
                    return this.pos += e, this.finishToken(t, i);
                }, tI.readRegexp = function() {
                    for(var t, e, i = this.pos;;){
                        this.pos >= this.input.length && this.raise(i, "Unterminated regular expression");
                        var n = this.input.charAt(this.pos);
                        if (C.test(n) && this.raise(i, "Unterminated regular expression"), t) t = !1;
                        else {
                            if ("[" === n) e = !0;
                            else if ("]" === n && e) e = !1;
                            else if ("/" === n && !e) break;
                            t = "\\" === n;
                        }
                        ++this.pos;
                    }
                    var r = this.input.slice(i, this.pos);
                    ++this.pos;
                    var s = this.pos, a = this.readWord1();
                    this.containsEsc && this.unexpected(s);
                    var o = this.regexpState || (this.regexpState = new tm(this));
                    o.reset(i, r, a), this.validateRegExpFlags(o), this.validateRegExpPattern(o);
                    var h = null;
                    try {
                        h = new RegExp(r, a);
                    } catch (t) {}
                    return this.finishToken(w.regexp, {
                        pattern: r,
                        flags: a,
                        value: h
                    });
                }, tI.readInt = function(t, e) {
                    for(var i = this.pos, n = 0, r = 0, s = null == e ? 1 / 0 : e; r < s; ++r){
                        var a = this.input.charCodeAt(this.pos), o = void 0;
                        if ((o = a >= 97 ? a - 97 + 10 : a >= 65 ? a - 65 + 10 : a >= 48 && a <= 57 ? a - 48 : 1 / 0) >= t) break;
                        ++this.pos, n = n * t + o;
                    }
                    return this.pos === i || null != e && this.pos - i !== e ? null : n;
                }, tI.readRadixNumber = function(t) {
                    var e = this.pos;
                    this.pos += 2;
                    var i = this.readInt(t);
                    return null == i && this.raise(this.start + 2, "Expected number in radix " + t), this.options.ecmaVersion >= 11 && 110 === this.input.charCodeAt(this.pos) ? (i = "undefined" != typeof BigInt ? BigInt(this.input.slice(e, this.pos)) : null, ++this.pos) : f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(w.num, i);
                }, tI.readNumber = function(t) {
                    var e = this.pos;
                    t || null !== this.readInt(10) || this.raise(e, "Invalid number");
                    var i = this.pos - e >= 2 && 48 === this.input.charCodeAt(e);
                    i && this.strict && this.raise(e, "Invalid number"), i && /[89]/.test(this.input.slice(e, this.pos)) && (i = !1);
                    var n = this.input.charCodeAt(this.pos);
                    if (!i && !t && this.options.ecmaVersion >= 11 && 110 === n) {
                        var r = this.input.slice(e, this.pos), s = "undefined" != typeof BigInt ? BigInt(r) : null;
                        return ++this.pos, f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(w.num, s);
                    }
                    46 !== n || i || (++this.pos, this.readInt(10), n = this.input.charCodeAt(this.pos)), 69 !== n && 101 !== n || i || ((43 === (n = this.input.charCodeAt(++this.pos)) || 45 === n) && ++this.pos, null === this.readInt(10) && this.raise(e, "Invalid number")), f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
                    var a = this.input.slice(e, this.pos), o = i ? parseInt(a, 8) : parseFloat(a);
                    return this.finishToken(w.num, o);
                }, tI.readCodePoint = function() {
                    var t;
                    if (123 === this.input.charCodeAt(this.pos)) {
                        this.options.ecmaVersion < 6 && this.unexpected();
                        var e = ++this.pos;
                        t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(e, "Code point out of bounds");
                    } else t = this.readHexChar(4);
                    return t;
                }, tI.readString = function(t) {
                    for(var e = "", i = ++this.pos;;){
                        this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
                        var n = this.input.charCodeAt(this.pos);
                        if (n === t) break;
                        92 === n ? (e += this.input.slice(i, this.pos), e += this.readEscapedChar(!1), i = this.pos) : (k(n, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
                    }
                    return e += this.input.slice(i, this.pos++), this.finishToken(w.string, e);
                };
                var tE = {};
                tI.tryReadTemplateToken = function() {
                    this.inTemplateElement = !0;
                    try {
                        this.readTmplToken();
                    } catch (t) {
                        if (t === tE) this.readInvalidTemplateToken();
                        else throw t;
                    }
                    this.inTemplateElement = !1;
                }, tI.invalidStringToken = function(t, e) {
                    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw tE;
                    this.raise(t, e);
                }, tI.readTmplToken = function() {
                    for(var t = "", e = this.pos;;){
                        this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
                        var i = this.input.charCodeAt(this.pos);
                        if (96 === i || 36 === i && 123 === this.input.charCodeAt(this.pos + 1)) {
                            if (this.pos === this.start && (this.type === w.template || this.type === w.invalidTemplate)) {
                                if (36 === i) return this.pos += 2, this.finishToken(w.dollarBraceL);
                                else return ++this.pos, this.finishToken(w.backQuote);
                            }
                            return t += this.input.slice(e, this.pos), this.finishToken(w.template, t);
                        }
                        if (92 === i) t += this.input.slice(e, this.pos), t += this.readEscapedChar(!0), e = this.pos;
                        else if (k(i)) {
                            switch(t += this.input.slice(e, this.pos), ++this.pos, i){
                                case 13:
                                    10 === this.input.charCodeAt(this.pos) && ++this.pos;
                                case 10:
                                    t += "\n";
                                    break;
                                default:
                                    t += String.fromCharCode(i);
                            }
                            this.options.locations && (++this.curLine, this.lineStart = this.pos), e = this.pos;
                        } else ++this.pos;
                    }
                }, tI.readInvalidTemplateToken = function() {
                    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
                        case "\\":
                            ++this.pos;
                            break;
                        case "$":
                            if ("{" !== this.input[this.pos + 1]) break;
                        case "`":
                            return this.finishToken(w.invalidTemplate, this.input.slice(this.start, this.pos));
                    }
                    this.raise(this.start, "Unterminated template");
                }, tI.readEscapedChar = function(t) {
                    var e = this.input.charCodeAt(++this.pos);
                    switch(++this.pos, e){
                        case 110:
                            return "\n";
                        case 114:
                            return "\r";
                        case 120:
                            return String.fromCharCode(this.readHexChar(2));
                        case 117:
                            return tT(this.readCodePoint());
                        case 116:
                            return "	";
                        case 98:
                            return "\b";
                        case 118:
                            return "\v";
                        case 102:
                            return "\f";
                        case 13:
                            10 === this.input.charCodeAt(this.pos) && ++this.pos;
                        case 10:
                            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
                        default:
                            if (e >= 48 && e <= 55) {
                                var i = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], n = parseInt(i, 8);
                                return n > 255 && (n = parseInt(i = i.slice(0, -1), 8)), this.pos += i.length - 1, e = this.input.charCodeAt(this.pos), ("0" !== i || 56 === e || 57 === e) && (this.strict || t) && this.invalidStringToken(this.pos - 1 - i.length, t ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(n);
                            }
                            if (k(e)) return "";
                            return String.fromCharCode(e);
                    }
                }, tI.readHexChar = function(t) {
                    var e = this.pos, i = this.readInt(16, t);
                    return null === i && this.invalidStringToken(e, "Bad character escape sequence"), i;
                }, tI.readWord1 = function() {
                    this.containsEsc = !1;
                    for(var t = "", e = !0, i = this.pos, n = this.options.ecmaVersion >= 6; this.pos < this.input.length;){
                        var r = this.fullCharCodeAtPos();
                        if (g(r, n)) this.pos += r <= 65535 ? 1 : 2;
                        else if (92 === r) {
                            this.containsEsc = !0, t += this.input.slice(i, this.pos);
                            var s = this.pos;
                            117 !== this.input.charCodeAt(++this.pos) && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
                            var a = this.readCodePoint();
                            (e ? f : g)(a, n) || this.invalidStringToken(s, "Invalid Unicode escape"), t += tT(a), i = this.pos;
                        } else break;
                        e = !1;
                    }
                    return t + this.input.slice(i, this.pos);
                }, tI.readWord = function() {
                    var t = this.readWord1(), e = w.name;
                    return this.keywords.test(t) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + t), e = b[t]), this.finishToken(e, t);
                };
                var tL = "6.4.2";
                function tM(t, e) {
                    return F.parse(t, e);
                }
                function tB(t, e, i) {
                    return F.parseExpressionAt(t, e, i);
                }
                function tO(t, e) {
                    return F.tokenizer(t, e);
                }
                F.acorn = {
                    Parser: F,
                    version: tL,
                    defaultOptions: R,
                    Position: O,
                    SourceLocation: N,
                    getLineInfo: z,
                    Node: ti,
                    TokenType: v,
                    tokTypes: w,
                    keywordTypes: b,
                    TokContext: ts,
                    tokContexts: ta,
                    isIdentifierChar: g,
                    isIdentifierStart: f,
                    Token: tA,
                    isNewLine: k,
                    lineBreak: C,
                    lineBreakG: S,
                    nonASCIIwhitespace: P
                };
            },
            "./node_modules/paper/dist/paper-full.js": function(t, e, i) {
                var n, r, s;
                (function(a, o) {
                    var h = (a = a || i(0)).window, l = a.document, u = new function() {
                        var t = /^(statics|enumerable|beans|preserve)$/, e = [], i = e.slice, n = Object.create, r = Object.getOwnPropertyDescriptor, s = Object.defineProperty, a = e.forEach || function(t, e) {
                            for(var i = 0, n = this.length; i < n; i++)t.call(e, this[i], i, this);
                        }, h = function(t, e) {
                            for(var i in this)this.hasOwnProperty(i) && t.call(e, this[i], i, this);
                        }, l = Object.assign || function(t) {
                            for(var e = 1, i = arguments.length; e < i; e++){
                                var n = arguments[e];
                                for(var r in n)n.hasOwnProperty(r) && (t[r] = n[r]);
                            }
                            return t;
                        }, u = function(t, e, i) {
                            if (t) {
                                var n = r(t, "length");
                                (n && "number" == typeof n.value ? a : h).call(t, e, i = i || t);
                            }
                            return i;
                        };
                        function c(e, i, n, a, o) {
                            var h = {};
                            function l(t, l) {
                                "string" == typeof (l = l || (l = r(i, t)) && (l.get ? l : l.value)) && "#" === l[0] && (l = e[l.substring(1)] || l);
                                var u, c = "function" == typeof l, p = l, f = o || c && !l.base ? l && l.get ? t in e : e[t] : null;
                                o && f || (c && f && (l.base = f), c && !1 !== a && (u = t.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (h[u[3].toLowerCase() + u[4]] = u[2]), p && !c && p.get && "function" == typeof p.get && d.isPlainObject(p) || (p = {
                                    value: p,
                                    writable: !0
                                }), (r(e, t) || {
                                    configurable: !0
                                }).configurable && (p.configurable = !0, p.enumerable = null != n ? n : !u), s(e, t, p));
                            }
                            if (i) {
                                for(var u in i)i.hasOwnProperty(u) && !t.test(u) && l(u);
                                for(var u in h){
                                    var c = h[u], p = e["set" + c], f = e["get" + c] || p && e["is" + c];
                                    f && (!0 === a || 0 === f.length) && l(u, {
                                        get: f,
                                        set: p
                                    });
                                }
                            }
                            return e;
                        }
                        function d() {
                            for(var t = 0, e = arguments.length; t < e; t++){
                                var i = arguments[t];
                                i && l(this, i);
                            }
                            return this;
                        }
                        return c(d, {
                            inject: function(t) {
                                if (t) {
                                    var e = !0 === t.statics ? t : t.statics, i = t.beans, n = t.preserve;
                                    e !== t && c(this.prototype, t, t.enumerable, i, n), c(this, e, null, i, n);
                                }
                                for(var r = 1, s = arguments.length; r < s; r++)this.inject(arguments[r]);
                                return this;
                            },
                            extend: function() {
                                for(var t, e, i, r = this, a = 0, o = arguments.length; a < o && !(t && e); a++)i = arguments[a], t = t || i.initialize, e = e || i.prototype;
                                return s(e = (t = t || function() {
                                    r.apply(this, arguments);
                                }).prototype = e || n(this.prototype), "constructor", {
                                    value: t,
                                    writable: !0,
                                    configurable: !0
                                }), c(t, this), arguments.length && this.inject.apply(t, arguments), t.base = r, t;
                            }
                        }).inject({
                            enumerable: !1,
                            initialize: d,
                            set: d,
                            inject: function() {
                                for(var t = 0, e = arguments.length; t < e; t++){
                                    var i = arguments[t];
                                    i && c(this, i, i.enumerable, i.beans, i.preserve);
                                }
                                return this;
                            },
                            extend: function() {
                                var t = n(this);
                                return t.inject.apply(t, arguments);
                            },
                            each: function(t, e) {
                                return u(this, t, e);
                            },
                            clone: function() {
                                return new this.constructor(this);
                            },
                            statics: {
                                set: l,
                                each: u,
                                create: n,
                                define: s,
                                describe: r,
                                clone: function(t) {
                                    return l(new t.constructor, t);
                                },
                                isPlainObject: function(t) {
                                    var e = null != t && t.constructor;
                                    return e && (e === Object || e === d || "Object" === e.name);
                                },
                                pick: function(t, e) {
                                    return t !== o ? t : e;
                                },
                                slice: function(t, e, n) {
                                    return i.call(t, e, n);
                                }
                            }
                        });
                    };
                    t.exports = u, u.inject({
                        enumerable: !1,
                        toString: function() {
                            return null != this._id ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + u.each(this, function(t, e) {
                                if (!/^_/.test(e)) {
                                    var i = typeof t;
                                    this.push(e + ": " + ("number" === i ? g.instance.number(t) : "string" === i ? "'" + t + "'" : t));
                                }
                            }, []).join(", ") + " }";
                        },
                        getClassName: function() {
                            return this._class || "";
                        },
                        importJSON: function(t) {
                            return u.importJSON(t, this);
                        },
                        exportJSON: function(t) {
                            return u.exportJSON(this, t);
                        },
                        toJSON: function() {
                            return u.serialize(this);
                        },
                        set: function(t, e) {
                            return t && u.filter(this, t, e, this._prioritize), this;
                        }
                    }, {
                        beans: !1,
                        statics: {
                            exports: {},
                            extend: function t() {
                                var e = t.base.apply(this, arguments), i = e.prototype._class;
                                return i && !u.exports[i] && (u.exports[i] = e), e;
                            },
                            equals: function(t, e) {
                                if (t === e) return !0;
                                if (t && t.equals) return t.equals(e);
                                if (e && e.equals) return e.equals(t);
                                if (t && e && "object" == typeof t && "object" == typeof e) {
                                    if (Array.isArray(t) && Array.isArray(e)) {
                                        var i = t.length;
                                        if (i !== e.length) return !1;
                                        for(; i--;)if (!u.equals(t[i], e[i])) return !1;
                                    } else {
                                        var n = Object.keys(t), i = n.length;
                                        if (i !== Object.keys(e).length) return !1;
                                        for(; i--;){
                                            var r = n[i];
                                            if (!(e.hasOwnProperty(r) && u.equals(t[r], e[r]))) return !1;
                                        }
                                    }
                                    return !0;
                                }
                                return !1;
                            },
                            read: function(t, e, i, n) {
                                if (this === u) {
                                    var r = this.peek(t, e);
                                    return t.__index++, r;
                                }
                                var s = this.prototype, a = s._readIndex, h = e || a && t.__index || 0, l = t.length, c = t[h];
                                if (n = n || l - h, c instanceof this || i && i.readNull && null == c && n <= 1) return a && (t.__index = h + 1), c && i && i.clone ? c.clone() : c;
                                if (c = u.create(s), a && (c.__read = !0), c = c.initialize.apply(c, h > 0 || h + n < l ? u.slice(t, h, h + n) : t) || c, a) {
                                    t.__index = h + c.__read;
                                    var d = c.__filtered;
                                    d && (t.__filtered = d, c.__filtered = o), c.__read = o;
                                }
                                return c;
                            },
                            peek: function(t, e) {
                                return t[t.__index = e || t.__index || 0];
                            },
                            remain: function(t) {
                                return t.length - (t.__index || 0);
                            },
                            readList: function(t, e, i, n) {
                                for(var r, s = [], a = e || 0, o = n ? a + n : t.length, h = a; h < o; h++)s.push(Array.isArray(r = t[h]) ? this.read(r, 0, i) : this.read(t, h, i, 1));
                                return s;
                            },
                            readNamed: function(t, e, i, n, r) {
                                var s = this.getNamed(t, e), a = s !== o;
                                if (a) {
                                    var h = t.__filtered;
                                    if (!h) {
                                        var l = this.getSource(t);
                                        (h = t.__filtered = u.create(l)).__unfiltered = l;
                                    }
                                    h[e] = o;
                                }
                                return this.read(a ? [
                                    s
                                ] : t, i, n, r);
                            },
                            readSupported: function(t, e) {
                                var i = this.getSource(t), n = this, r = !1;
                                return i && Object.keys(i).forEach(function(i) {
                                    if (i in e) {
                                        var s = n.readNamed(t, i);
                                        s !== o && (e[i] = s), r = !0;
                                    }
                                }), r;
                            },
                            getSource: function(t) {
                                var e = t.__source;
                                if (e === o) {
                                    var i = 1 === t.length && t[0];
                                    e = t.__source = i && u.isPlainObject(i) ? i : null;
                                }
                                return e;
                            },
                            getNamed: function(t, e) {
                                var i = this.getSource(t);
                                if (i) return e ? i[e] : t.__filtered || i;
                            },
                            hasNamed: function(t, e) {
                                return !!this.getNamed(t, e);
                            },
                            filter: function(t, e, i, n) {
                                function r(n) {
                                    if (!(i && n in i) && !(s && n in s)) {
                                        var r = e[n];
                                        r !== o && (t[n] = r);
                                    }
                                }
                                if (n) {
                                    for(var s, a, h = {}, l = 0, u = n.length; l < u; l++)(a = n[l]) in e && (r(a), h[a] = !0);
                                    s = h;
                                }
                                return Object.keys(e.__unfiltered || e).forEach(r), t;
                            },
                            isPlainValue: function(t, e) {
                                return u.isPlainObject(t) || Array.isArray(t) || e && "string" == typeof t;
                            },
                            serialize: function(t, e, i, n) {
                                e = e || {};
                                var r, s = !n;
                                if (s && (e.formatter = new g(e.precision), n = {
                                    length: 0,
                                    definitions: {},
                                    references: {},
                                    add: function(t, e) {
                                        var i = "#" + t._id, n = this.references[i];
                                        if (!n) {
                                            this.length++;
                                            var r = e.call(t), s = t._class;
                                            s && r[0] !== s && r.unshift(s), this.definitions[i] = r, n = this.references[i] = [
                                                i
                                            ];
                                        }
                                        return n;
                                    }
                                }), t && t._serialize) {
                                    r = t._serialize(e, n);
                                    var a = t._class;
                                    a && !t._compactSerialize && (s || !i) && r[0] !== a && r.unshift(a);
                                } else if (Array.isArray(t)) {
                                    r = [];
                                    for(var o = 0, h = t.length; o < h; o++)r[o] = u.serialize(t[o], e, i, n);
                                } else if (u.isPlainObject(t)) {
                                    r = {};
                                    for(var l = Object.keys(t), o = 0, h = l.length; o < h; o++){
                                        var c = l[o];
                                        r[c] = u.serialize(t[c], e, i, n);
                                    }
                                } else r = "number" == typeof t ? e.formatter.number(t, e.precision) : t;
                                return s && n.length > 0 ? [
                                    [
                                        "dictionary",
                                        n.definitions
                                    ],
                                    r
                                ] : r;
                            },
                            deserialize: function(t, e, i, n, r) {
                                var s = t, a = !i, o = a && t && t.length && "dictionary" === t[0][0];
                                if (i = i || {}, Array.isArray(t)) {
                                    var h = t[0], l = "dictionary" === h;
                                    if (1 == t.length && /^#/.test(h)) return i.dictionary[h];
                                    h = u.exports[h], s = [];
                                    for(var c = +!!h, d = t.length; c < d; c++)s.push(u.deserialize(t[c], e, i, l, o));
                                    if (h) {
                                        var p = s;
                                        s = e ? e(h, p, a || r) : new h(p);
                                    }
                                } else if (u.isPlainObject(t)) for(var f in s = {}, n && (i.dictionary = s), t)s[f] = u.deserialize(t[f], e, i);
                                return o ? s[1] : s;
                            },
                            exportJSON: function(t, e) {
                                var i = u.serialize(t, e);
                                return e && !1 == e.asString ? i : JSON.stringify(i);
                            },
                            importJSON: function(t, e) {
                                return u.deserialize("string" == typeof t ? JSON.parse(t) : t, function(t, i, n) {
                                    var r = n && e && e.constructor === t, s = r ? e : u.create(t.prototype);
                                    if (1 === i.length && s instanceof A && (r || !(s instanceof T))) {
                                        var a = i[0];
                                        u.isPlainObject(a) && (a.insert = !1, r && (i = i.concat([
                                            {
                                                insert: !0
                                            }
                                        ])));
                                    }
                                    return (r ? s.set : t).apply(s, i), r && (e = null), s;
                                });
                            },
                            push: function(t, e) {
                                var i = e.length;
                                if (i < 4096) t.push.apply(t, e);
                                else {
                                    var n = t.length;
                                    t.length += i;
                                    for(var r = 0; r < i; r++)t[n + r] = e[r];
                                }
                                return t;
                            },
                            splice: function(t, e, i, n) {
                                var r = e && e.length, s = i === o;
                                (i = s ? t.length : i) > t.length && (i = t.length);
                                for(var a = 0; a < r; a++)e[a]._index = i + a;
                                if (s) return u.push(t, e), [];
                                var h = [
                                    i,
                                    n
                                ];
                                e && u.push(h, e);
                                for(var l = t.splice.apply(t, h), a = 0, c = l.length; a < c; a++)l[a]._index = o;
                                for(var a = i + r, c = t.length; a < c; a++)t[a]._index = a;
                                return l;
                            },
                            capitalize: function(t) {
                                return t.replace(/\b[a-z]/g, function(t) {
                                    return t.toUpperCase();
                                });
                            },
                            camelize: function(t) {
                                return t.replace(/-(.)/g, function(t, e) {
                                    return e.toUpperCase();
                                });
                            },
                            hyphenate: function(t) {
                                return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
                            }
                        }
                    });
                    var c = {
                        on: function(t, e) {
                            if ("string" != typeof t) u.each(t, function(t, e) {
                                this.on(e, t);
                            }, this);
                            else {
                                var i = this._eventTypes, n = i && i[t], r = this._callbacks = this._callbacks || {};
                                -1 === (r = r[t] = r[t] || []).indexOf(e) && (r.push(e), n && n.install && 1 === r.length && n.install.call(this, t));
                            }
                            return this;
                        },
                        off: function(t, e) {
                            if ("string" != typeof t) return void u.each(t, function(t, e) {
                                this.off(e, t);
                            }, this);
                            var i, n = this._eventTypes, r = n && n[t], s = this._callbacks && this._callbacks[t];
                            return s && (e && (-1 === (i = s.indexOf(e)) || 1 !== s.length) ? -1 !== i && s.splice(i, 1) : (r && r.uninstall && r.uninstall.call(this, t), delete this._callbacks[t])), this;
                        },
                        once: function(t, e) {
                            return this.on(t, function i() {
                                e.apply(this, arguments), this.off(t, i);
                            });
                        },
                        emit: function(t, e) {
                            var i = this._callbacks && this._callbacks[t];
                            if (!i) return !1;
                            var n = u.slice(arguments, 1), r = e && e.target && !e.currentTarget;
                            i = i.slice(), r && (e.currentTarget = this);
                            for(var s = 0, a = i.length; s < a; s++)if (!1 == i[s].apply(this, n)) {
                                e && e.stop && e.stop();
                                break;
                            }
                            return r && delete e.currentTarget, !0;
                        },
                        responds: function(t) {
                            return !!(this._callbacks && this._callbacks[t]);
                        },
                        attach: "#on",
                        detach: "#off",
                        fire: "#emit",
                        _installEvents: function(t) {
                            var e = this._eventTypes, i = this._callbacks, n = t ? "install" : "uninstall";
                            if (e) {
                                for(var r in i)if (i[r].length > 0) {
                                    var s = e[r], a = s && s[n];
                                    a && a.call(this, r);
                                }
                            }
                        },
                        statics: {
                            inject: function t(e) {
                                var i = e._events;
                                if (i) {
                                    var n = {};
                                    u.each(i, function(t, i) {
                                        var r = "string" == typeof t, s = r ? t : i, a = u.capitalize(s), o = s.substring(2).toLowerCase();
                                        n[o] = r ? {} : t, s = "_" + s, e["get" + a] = function() {
                                            return this[s];
                                        }, e["set" + a] = function(t) {
                                            var e = this[s];
                                            e && this.off(o, e), t && this.on(o, t), this[s] = t;
                                        };
                                    }), e._eventTypes = n;
                                }
                                return t.base.apply(this, arguments);
                            }
                        }
                    }, d = u.extend({
                        _class: "PaperScope",
                        initialize: function t() {
                            td = this, this.settings = new u({
                                applyMatrix: !0,
                                insertItems: !0,
                                handleSize: 4,
                                hitTolerance: 0
                            }), this.project = null, this.projects = [], this.tools = [], this._id = t._id++, t._scopes[this._id] = this;
                            var e = t.prototype;
                            if (!this.support) {
                                var i = th.getContext(1, 1) || {};
                                e.support = {
                                    nativeDash: "setLineDash" in i || "mozDash" in i,
                                    nativeBlendModes: tl.nativeModes
                                }, th.release(i);
                            }
                            if (!this.agent) {
                                var n = a.navigator.userAgent.toLowerCase(), r = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(n) || [])[0], s = "darwin" === r ? "mac" : r, o = e.agent = e.browser = {
                                    platform: s
                                };
                                s && (o[s] = !0), n.replace(/(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g, function(t, e, i, n, r) {
                                    if (!o.chrome) {
                                        var s = "opera" === e ? n : /^(node|trident)$/.test(e) ? r : i;
                                        o.version = s, o.versionNumber = parseFloat(s), o.name = e = ({
                                            trident: "msie",
                                            jsdom: "node"
                                        })[e] || e, o[e] = !0;
                                    }
                                }), o.chrome && delete o.webkit, o.atom && delete o.chrome;
                            }
                        },
                        version: "0.12.8",
                        getView: function() {
                            var t = this.project;
                            return t && t._view;
                        },
                        getPaper: function() {
                            return this;
                        },
                        execute: function(t, e) {
                            var i = td.PaperScript.execute(t, this, e);
                            return J.updateFocus(), i;
                        },
                        install: function(t) {
                            var e = this;
                            for(var i in u.each([
                                "project",
                                "view",
                                "tool"
                            ], function(i) {
                                u.define(t, i, {
                                    configurable: !0,
                                    get: function() {
                                        return e[i];
                                    }
                                });
                            }), this)!/^_/.test(i) && this[i] && (t[i] = this[i]);
                        },
                        setup: function(t) {
                            return td = this, this.project = new P(t), this;
                        },
                        createCanvas: function(t, e) {
                            return th.getCanvas(t, e);
                        },
                        activate: function() {
                            td = this;
                        },
                        clear: function() {
                            for(var t = this.projects, e = this.tools, i = t.length - 1; i >= 0; i--)t[i].remove();
                            for(var i = e.length - 1; i >= 0; i--)e[i].remove();
                        },
                        remove: function() {
                            this.clear(), delete d._scopes[this._id];
                        },
                        statics: new function() {
                            function t(t) {
                                return t += "Attribute", function(e, i) {
                                    return e[t](i) || e[t]("data-paper-" + i);
                                };
                            }
                            return {
                                _scopes: {},
                                _id: 0,
                                get: function(t) {
                                    return this._scopes[t] || null;
                                },
                                getAttribute: t("get"),
                                hasAttribute: t("has")
                            };
                        }
                    }), p = u.extend(c, {
                        initialize: function(t) {
                            this._scope = td, this._index = this._scope[this._list].push(this) - 1, (t || !this._scope[this._reference]) && this.activate();
                        },
                        activate: function() {
                            if (!this._scope) return !1;
                            var t = this._scope[this._reference];
                            return t && t !== this && t.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", t), !0;
                        },
                        isActive: function() {
                            return this._scope[this._reference] === this;
                        },
                        remove: function() {
                            return null != this._index && (u.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
                        },
                        getView: function() {
                            return this._scope.getView();
                        }
                    }), f = {
                        findItemBoundsCollisions: function(t, e, i) {
                            function n(t) {
                                for(var e = Array(t.length), i = 0; i < t.length; i++){
                                    var n = t[i].getBounds();
                                    e[i] = [
                                        n.left,
                                        n.top,
                                        n.right,
                                        n.bottom
                                    ];
                                }
                                return e;
                            }
                            var r = n(t), s = e && e !== t ? n(e) : r;
                            return this.findBoundsCollisions(r, s, i || 0);
                        },
                        findCurveBoundsCollisions: function(t, e, i, n) {
                            function r(t) {
                                for(var e = Math.min, i = Math.max, n = Array(t.length), r = 0; r < t.length; r++){
                                    var s = t[r];
                                    n[r] = [
                                        e(s[0], s[2], s[4], s[6]),
                                        e(s[1], s[3], s[5], s[7]),
                                        i(s[0], s[2], s[4], s[6]),
                                        i(s[1], s[3], s[5], s[7])
                                    ];
                                }
                                return n;
                            }
                            var s = r(t), a = e && e !== t ? r(e) : s;
                            if (n) {
                                for(var o = this.findBoundsCollisions(s, a, i || 0, !1, !0), h = this.findBoundsCollisions(s, a, i || 0, !0, !0), l = [], u = 0, c = o.length; u < c; u++)l[u] = {
                                    hor: o[u],
                                    ver: h[u]
                                };
                                return l;
                            }
                            return this.findBoundsCollisions(s, a, i || 0);
                        },
                        findBoundsCollisions: function(t, e, i, n, r) {
                            var s = !e || t === e, a = s ? t : t.concat(e), o = t.length, h = a.length;
                            function l(t, e, i) {
                                for(var n = 0, r = t.length; n < r;){
                                    var s = r + n >>> 1;
                                    a[t[s]][e] < i ? n = s + 1 : r = s;
                                }
                                return n - 1;
                            }
                            for(var u = +!!n, c = u + 2, d = +!n, p = d + 2, f = Array(h), g = 0; g < h; g++)f[g] = g;
                            f.sort(function(t, e) {
                                return a[t][u] - a[e][u];
                            });
                            for(var v = [], _ = Array(o), g = 0; g < h; g++){
                                var m = f[g], y = a[m], b = s ? m : m - o, x = m < o, w = s || !x, C = x ? [] : null;
                                if (v.length) {
                                    var S = l(v, c, y[u] - i) + 1;
                                    if (v.splice(0, S), s && r) {
                                        C = C.concat(v);
                                        for(var k = 0; k < v.length; k++){
                                            var P = v[k];
                                            _[P].push(b);
                                        }
                                    } else for(var A = y[p], I = y[d], k = 0; k < v.length; k++){
                                        var P = v[k], T = a[P], E = P < o, L = s || P >= o;
                                        (r || (x && L || w && E) && A >= T[d] - i && I <= T[p] + i) && (x && L && C.push(s ? P : P - o), w && E && _[P].push(b));
                                    }
                                }
                                if (x && (t === e && C.push(m), _[m] = C), v.length) {
                                    var M = y[c], B = l(v, c, M);
                                    v.splice(B + 1, 0, m);
                                } else v.push(m);
                            }
                            for(var g = 0; g < _.length; g++){
                                var O = _[g];
                                O && O.sort(function(t, e) {
                                    return t - e;
                                });
                            }
                            return _;
                        }
                    }, g = u.extend({
                        initialize: function(t) {
                            this.precision = u.pick(t, 5), this.multiplier = Math.pow(10, this.precision);
                        },
                        number: function(t) {
                            return this.precision < 16 ? Math.round(t * this.multiplier) / this.multiplier : t;
                        },
                        pair: function(t, e, i) {
                            return this.number(t) + (i || ",") + this.number(e);
                        },
                        point: function(t, e) {
                            return this.number(t.x) + (e || ",") + this.number(t.y);
                        },
                        size: function(t, e) {
                            return this.number(t.width) + (e || ",") + this.number(t.height);
                        },
                        rectangle: function(t, e) {
                            return this.point(t, e) + (e || ",") + this.size(t, e);
                        }
                    });
                    g.instance = new g;
                    var v = new function() {
                        var t = [
                            [
                                .5773502691896257
                            ],
                            [
                                0,
                                .7745966692414834
                            ],
                            [
                                .33998104358485626,
                                .8611363115940526
                            ],
                            [
                                0,
                                .5384693101056831,
                                .906179845938664
                            ],
                            [
                                .2386191860831969,
                                .6612093864662645,
                                .932469514203152
                            ],
                            [
                                0,
                                .4058451513773972,
                                .7415311855993945,
                                .9491079123427585
                            ],
                            [
                                .1834346424956498,
                                .525532409916329,
                                .7966664774136267,
                                .9602898564975363
                            ],
                            [
                                0,
                                .3242534234038089,
                                .6133714327005904,
                                .8360311073266358,
                                .9681602395076261
                            ],
                            [
                                .14887433898163122,
                                .4333953941292472,
                                .6794095682990244,
                                .8650633666889845,
                                .9739065285171717
                            ],
                            [
                                0,
                                .26954315595234496,
                                .5190961292068118,
                                .7301520055740494,
                                .8870625997680953,
                                .978228658146057
                            ],
                            [
                                .1252334085114689,
                                .3678314989981802,
                                .5873179542866175,
                                .7699026741943047,
                                .9041172563704749,
                                .9815606342467192
                            ],
                            [
                                0,
                                .2304583159551348,
                                .44849275103644687,
                                .6423493394403402,
                                .8015780907333099,
                                .9175983992229779,
                                .9841830547185881
                            ],
                            [
                                .10805494870734367,
                                .31911236892788974,
                                .5152486363581541,
                                .6872929048116855,
                                .827201315069765,
                                .9284348836635735,
                                .9862838086968123
                            ],
                            [
                                0,
                                .20119409399743451,
                                .3941513470775634,
                                .5709721726085388,
                                .7244177313601701,
                                .8482065834104272,
                                .937273392400706,
                                .9879925180204854
                            ],
                            [
                                .09501250983763744,
                                .2816035507792589,
                                .45801677765722737,
                                .6178762444026438,
                                .755404408355003,
                                .8656312023878318,
                                .9445750230732326,
                                .9894009349916499
                            ]
                        ], e = [
                            [
                                1
                            ],
                            [
                                .8888888888888888,
                                .5555555555555556
                            ],
                            [
                                .6521451548625461,
                                .34785484513745385
                            ],
                            [
                                .5688888888888889,
                                .47862867049936647,
                                .23692688505618908
                            ],
                            [
                                .46791393457269104,
                                .3607615730481386,
                                .17132449237917036
                            ],
                            [
                                .4179591836734694,
                                .3818300505051189,
                                .27970539148927664,
                                .1294849661688697
                            ],
                            [
                                .362683783378362,
                                .31370664587788727,
                                .22238103445337448,
                                .10122853629037626
                            ],
                            [
                                .3302393550012598,
                                .31234707704000286,
                                .26061069640293544,
                                .1806481606948574,
                                .08127438836157441
                            ],
                            [
                                .29552422471475287,
                                .26926671930999635,
                                .21908636251598204,
                                .1494513491505806,
                                .06667134430868814
                            ],
                            [
                                .2729250867779006,
                                .26280454451024665,
                                .23319376459199048,
                                .18629021092773426,
                                .1255803694649046,
                                .05566856711617366
                            ],
                            [
                                .24914704581340277,
                                .2334925365383548,
                                .20316742672306592,
                                .16007832854334622,
                                .10693932599531843,
                                .04717533638651183
                            ],
                            [
                                .2325515532308739,
                                .22628318026289723,
                                .2078160475368885,
                                .17814598076194574,
                                .13887351021978725,
                                .09212149983772845,
                                .04048400476531588
                            ],
                            [
                                .2152638534631578,
                                .2051984637212956,
                                .18553839747793782,
                                .15720316715819355,
                                .12151857068790319,
                                .08015808715976021,
                                .03511946033175186
                            ],
                            [
                                .2025782419255613,
                                .19843148532711158,
                                .1861610000155622,
                                .16626920581699392,
                                .13957067792615432,
                                .10715922046717194,
                                .07036604748810812,
                                .03075324199611727
                            ],
                            [
                                .1894506104550685,
                                .18260341504492358,
                                .16915651939500254,
                                .14959598881657674,
                                .12462897125553388,
                                .09515851168249279,
                                .062253523938647894,
                                .027152459411754096
                            ]
                        ], i = Math.abs, n = Math.sqrt, r = Math.pow, s = Math.log2 || function(t) {
                            return Math.log(t) * Math.LOG2E;
                        };
                        function a(t, e, i) {
                            return t < e ? e : t > i ? i : t;
                        }
                        function o(t, e, n) {
                            function r(t) {
                                var e = 0x8000001 * t, i = t - e + e;
                                return [
                                    i,
                                    t - i
                                ];
                            }
                            var s = e * e - t * n, a = e * e + t * n;
                            if (3 * i(s) < a) {
                                var o = r(t), h = r(e), l = r(n), u = e * e, c = h[0] * h[0] - u + 2 * h[0] * h[1] + h[1] * h[1], d = t * n, p = o[0] * l[0] - d + o[0] * l[1] + o[1] * l[0] + o[1] * l[1];
                                s = u - d + (c - p);
                            }
                            return s;
                        }
                        function h() {
                            var t = Math.max.apply(Math, arguments);
                            return t && (t < 1e-8 || t > 1e8) ? r(2, -Math.round(s(t))) : 0;
                        }
                        return {
                            EPSILON: 1e-12,
                            MACHINE_EPSILON: 112e-18,
                            CURVETIME_EPSILON: 1e-8,
                            GEOMETRIC_EPSILON: 1e-7,
                            TRIGONOMETRIC_EPSILON: 1e-8,
                            KAPPA: 4 * (n(2) - 1) / 3,
                            isZero: function(t) {
                                return t >= -0.000000000001 && t <= 1e-12;
                            },
                            isMachineZero: function(t) {
                                return t >= -0.000000000000000112 && t <= 112e-18;
                            },
                            clamp: a,
                            integrate: function(i, n, r, s) {
                                for(var a = t[s - 2], o = e[s - 2], h = (r - n) * .5, l = h + n, u = 0, c = s + 1 >> 1, d = 1 & s ? o[u++] * i(l) : 0; u < c;){
                                    var p = h * a[u];
                                    d += o[u++] * (i(l + p) + i(l - p));
                                }
                                return h * d;
                            },
                            findRoot: function(t, e, n, r, s, o, h) {
                                for(var l = 0; l < o; l++){
                                    var u = t(n), c = u / e(n), d = n - c;
                                    if (i(c) < h) {
                                        n = d;
                                        break;
                                    }
                                    u > 0 ? (s = n, n = d <= r ? (r + s) * .5 : d) : (r = n, n = d >= s ? (r + s) * .5 : d);
                                }
                                return a(n, r, s);
                            },
                            solveQuadratic: function(t, e, r, s, l, u) {
                                var c, d = 1 / 0;
                                if (1e-12 > i(t)) {
                                    if (1e-12 > i(e)) return 1e-12 > i(r) ? -1 : 0;
                                    c = -r / e;
                                } else {
                                    var p = o(t, e *= -0.5, r);
                                    if (p && 112e-18 > i(p)) {
                                        var f = h(i(t), i(e), i(r));
                                        f && (t *= f, e *= f, r *= f, p = o(t, e, r));
                                    }
                                    if (p >= -0.000000000000000112) {
                                        var g = p < 0 ? 0 : n(p), v = e + (e < 0 ? -g : g);
                                        0 === v ? d = -(c = r / t) : (c = v / t, d = r / v);
                                    }
                                }
                                var _ = 0, m = null == l, y = l - 1e-12, b = u + 1e-12;
                                return isFinite(c) && (m || c > y && c < b) && (s[_++] = m ? c : a(c, l, u)), d !== c && isFinite(d) && (m || d > y && d < b) && (s[_++] = m ? d : a(d, l, u)), _;
                            },
                            solveCubic: function(t, e, s, o, l, u, c) {
                                var d, p, f, g, _, m = h(i(t), i(e), i(s), i(o));
                                function y(i) {
                                    var n = t * (d = i);
                                    f = (p = n + e) * d + s, g = (n + p) * d + f, _ = f * d + o;
                                }
                                if (m && (t *= m, e *= m, s *= m, o *= m), 1e-12 > i(t)) t = e, p = s, f = o, d = 1 / 0;
                                else if (1e-12 > i(o)) p = e, f = s, d = 0;
                                else {
                                    y(-(e / t) / 3);
                                    var b = _ / t, x = r(i(b), 1 / 3), w = b < 0 ? -1 : 1, C = -g / t, S = C > 0 ? 1.324717957244746 * Math.max(x, n(C)) : x, k = d - w * S;
                                    if (k !== d) {
                                        do y(k), k = 0 === g ? d : d - _ / g / 1.0000000000000002;
                                        while (w * k > w * d);
                                        i(t) * d * d > i(o / d) && (p = ((f = -o / d) - s) / d);
                                    }
                                }
                                var P = v.solveQuadratic(t, p, f, l, u, c), A = null == u;
                                return isFinite(d) && (0 === P || P > 0 && d !== l[0] && d !== l[1]) && (A || d > u - 1e-12 && d < c + 1e-12) && (l[P++] = A ? d : a(d, u, c)), P;
                            }
                        };
                    }, _ = {
                        _id: 1,
                        _pools: {},
                        get: function(t) {
                            if (!t) return this._id++;
                            var e = this._pools[t];
                            return e || (e = this._pools[t] = {
                                _id: 1
                            }), e._id++;
                        }
                    }, m = u.extend({
                        _class: "Point",
                        _readIndex: !0,
                        initialize: function(t, e) {
                            var i = typeof t, n = this.__read, r = 0;
                            if ("number" === i) {
                                var s = "number" == typeof e;
                                this._set(t, s ? e : t), n && (r = s ? 2 : 1);
                            } else if ("undefined" === i || null === t) this._set(0, 0), n && (r = +(null === t));
                            else {
                                var a = "string" === i ? t.split(/[\s,]+/) || [] : t;
                                r = 1, Array.isArray(a) ? this._set(+a[0], +(a.length > 1 ? a[1] : a[0])) : "x" in a ? this._set(a.x || 0, a.y || 0) : "width" in a ? this._set(a.width || 0, a.height || 0) : "angle" in a ? (this._set(a.length || 0, 0), this.setAngle(a.angle || 0)) : (this._set(0, 0), r = 0);
                            }
                            return n && (this.__read = r), this;
                        },
                        set: "#initialize",
                        _set: function(t, e) {
                            return this.x = t, this.y = e, this;
                        },
                        equals: function(t) {
                            return this === t || t && (this.x === t.x && this.y === t.y || Array.isArray(t) && this.x === t[0] && this.y === t[1]) || !1;
                        },
                        clone: function() {
                            return new m(this.x, this.y);
                        },
                        toString: function() {
                            var t = g.instance;
                            return "{ x: " + t.number(this.x) + ", y: " + t.number(this.y) + " }";
                        },
                        _serialize: function(t) {
                            var e = t.formatter;
                            return [
                                e.number(this.x),
                                e.number(this.y)
                            ];
                        },
                        getLength: function() {
                            return Math.sqrt(this.x * this.x + this.y * this.y);
                        },
                        setLength: function(t) {
                            if (this.isZero()) {
                                var e = this._angle || 0;
                                this._set(Math.cos(e) * t, Math.sin(e) * t);
                            } else {
                                var i = t / this.getLength();
                                v.isZero(i) && this.getAngle(), this._set(this.x * i, this.y * i);
                            }
                        },
                        getAngle: function() {
                            return 180 * this.getAngleInRadians.apply(this, arguments) / Math.PI;
                        },
                        setAngle: function(t) {
                            this.setAngleInRadians.call(this, t * Math.PI / 180);
                        },
                        getAngleInDegrees: "#getAngle",
                        setAngleInDegrees: "#setAngle",
                        getAngleInRadians: function() {
                            if (!arguments.length) return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
                            var t = m.read(arguments), e = this.getLength() * t.getLength();
                            if (v.isZero(e)) return NaN;
                            var i = this.dot(t) / e;
                            return Math.acos(i < -1 ? -1 : i > 1 ? 1 : i);
                        },
                        setAngleInRadians: function(t) {
                            if (this._angle = t, !this.isZero()) {
                                var e = this.getLength();
                                this._set(Math.cos(t) * e, Math.sin(t) * e);
                            }
                        },
                        getQuadrant: function() {
                            return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
                        }
                    }, {
                        beans: !1,
                        getDirectedAngle: function() {
                            var t = m.read(arguments);
                            return 180 * Math.atan2(this.cross(t), this.dot(t)) / Math.PI;
                        },
                        getDistance: function() {
                            var t = arguments, e = m.read(t), i = e.x - this.x, n = e.y - this.y, r = i * i + n * n;
                            return u.read(t) ? r : Math.sqrt(r);
                        },
                        normalize: function(t) {
                            t === o && (t = 1);
                            var e = this.getLength(), i = 0 !== e ? t / e : 0, n = new m(this.x * i, this.y * i);
                            return i >= 0 && (n._angle = this._angle), n;
                        },
                        rotate: function(t, e) {
                            if (0 === t) return this.clone();
                            t = t * Math.PI / 180;
                            var i = e ? this.subtract(e) : this, n = Math.sin(t), r = Math.cos(t);
                            return i = new m(i.x * r - i.y * n, i.x * n + i.y * r), e ? i.add(e) : i;
                        },
                        transform: function(t) {
                            return t ? t._transformPoint(this) : this;
                        },
                        add: function() {
                            var t = m.read(arguments);
                            return new m(this.x + t.x, this.y + t.y);
                        },
                        subtract: function() {
                            var t = m.read(arguments);
                            return new m(this.x - t.x, this.y - t.y);
                        },
                        multiply: function() {
                            var t = m.read(arguments);
                            return new m(this.x * t.x, this.y * t.y);
                        },
                        divide: function() {
                            var t = m.read(arguments);
                            return new m(this.x / t.x, this.y / t.y);
                        },
                        modulo: function() {
                            var t = m.read(arguments);
                            return new m(this.x % t.x, this.y % t.y);
                        },
                        negate: function() {
                            return new m(-this.x, -this.y);
                        },
                        isInside: function() {
                            return w.read(arguments).contains(this);
                        },
                        isClose: function() {
                            var t = arguments, e = m.read(t), i = u.read(t);
                            return this.getDistance(e) <= i;
                        },
                        isCollinear: function() {
                            var t = m.read(arguments);
                            return m.isCollinear(this.x, this.y, t.x, t.y);
                        },
                        isColinear: "#isCollinear",
                        isOrthogonal: function() {
                            var t = m.read(arguments);
                            return m.isOrthogonal(this.x, this.y, t.x, t.y);
                        },
                        isZero: function() {
                            var t = v.isZero;
                            return t(this.x) && t(this.y);
                        },
                        isNaN: function() {
                            return isNaN(this.x) || isNaN(this.y);
                        },
                        isInQuadrant: function(t) {
                            return this.x * (t > 1 && t < 4 ? -1 : 1) >= 0 && this.y * (t > 2 ? -1 : 1) >= 0;
                        },
                        dot: function() {
                            var t = m.read(arguments);
                            return this.x * t.x + this.y * t.y;
                        },
                        cross: function() {
                            var t = m.read(arguments);
                            return this.x * t.y - this.y * t.x;
                        },
                        project: function() {
                            var t = m.read(arguments), e = t.isZero() ? 0 : this.dot(t) / t.dot(t);
                            return new m(t.x * e, t.y * e);
                        },
                        statics: {
                            min: function() {
                                var t = arguments, e = m.read(t), i = m.read(t);
                                return new m(Math.min(e.x, i.x), Math.min(e.y, i.y));
                            },
                            max: function() {
                                var t = arguments, e = m.read(t), i = m.read(t);
                                return new m(Math.max(e.x, i.x), Math.max(e.y, i.y));
                            },
                            random: function() {
                                return new m(Math.random(), Math.random());
                            },
                            isCollinear: function(t, e, i, n) {
                                return Math.abs(t * n - e * i) <= 1e-8 * Math.sqrt((t * t + e * e) * (i * i + n * n));
                            },
                            isOrthogonal: function(t, e, i, n) {
                                return Math.abs(t * i + e * n) <= 1e-8 * Math.sqrt((t * t + e * e) * (i * i + n * n));
                            }
                        }
                    }, u.each([
                        "round",
                        "ceil",
                        "floor",
                        "abs"
                    ], function(t) {
                        var e = Math[t];
                        this[t] = function() {
                            return new m(e(this.x), e(this.y));
                        };
                    }, {})), y = m.extend({
                        initialize: function(t, e, i, n) {
                            this._x = t, this._y = e, this._owner = i, this._setter = n;
                        },
                        _set: function(t, e, i) {
                            return this._x = t, this._y = e, i || this._owner[this._setter](this), this;
                        },
                        getX: function() {
                            return this._x;
                        },
                        setX: function(t) {
                            this._x = t, this._owner[this._setter](this);
                        },
                        getY: function() {
                            return this._y;
                        },
                        setY: function(t) {
                            this._y = t, this._owner[this._setter](this);
                        },
                        isSelected: function() {
                            return !!(this._owner._selection & this._getSelection());
                        },
                        setSelected: function(t) {
                            this._owner._changeSelection(this._getSelection(), t);
                        },
                        _getSelection: function() {
                            return 4 * ("setPosition" === this._setter);
                        }
                    }), b = u.extend({
                        _class: "Size",
                        _readIndex: !0,
                        initialize: function(t, e) {
                            var i = typeof t, n = this.__read, r = 0;
                            if ("number" === i) {
                                var s = "number" == typeof e;
                                this._set(t, s ? e : t), n && (r = s ? 2 : 1);
                            } else if ("undefined" === i || null === t) this._set(0, 0), n && (r = +(null === t));
                            else {
                                var a = "string" === i ? t.split(/[\s,]+/) || [] : t;
                                r = 1, Array.isArray(a) ? this._set(+a[0], +(a.length > 1 ? a[1] : a[0])) : "width" in a ? this._set(a.width || 0, a.height || 0) : "x" in a ? this._set(a.x || 0, a.y || 0) : (this._set(0, 0), r = 0);
                            }
                            return n && (this.__read = r), this;
                        },
                        set: "#initialize",
                        _set: function(t, e) {
                            return this.width = t, this.height = e, this;
                        },
                        equals: function(t) {
                            return t === this || t && (this.width === t.width && this.height === t.height || Array.isArray(t) && this.width === t[0] && this.height === t[1]) || !1;
                        },
                        clone: function() {
                            return new b(this.width, this.height);
                        },
                        toString: function() {
                            var t = g.instance;
                            return "{ width: " + t.number(this.width) + ", height: " + t.number(this.height) + " }";
                        },
                        _serialize: function(t) {
                            var e = t.formatter;
                            return [
                                e.number(this.width),
                                e.number(this.height)
                            ];
                        },
                        add: function() {
                            var t = b.read(arguments);
                            return new b(this.width + t.width, this.height + t.height);
                        },
                        subtract: function() {
                            var t = b.read(arguments);
                            return new b(this.width - t.width, this.height - t.height);
                        },
                        multiply: function() {
                            var t = b.read(arguments);
                            return new b(this.width * t.width, this.height * t.height);
                        },
                        divide: function() {
                            var t = b.read(arguments);
                            return new b(this.width / t.width, this.height / t.height);
                        },
                        modulo: function() {
                            var t = b.read(arguments);
                            return new b(this.width % t.width, this.height % t.height);
                        },
                        negate: function() {
                            return new b(-this.width, -this.height);
                        },
                        isZero: function() {
                            var t = v.isZero;
                            return t(this.width) && t(this.height);
                        },
                        isNaN: function() {
                            return isNaN(this.width) || isNaN(this.height);
                        },
                        statics: {
                            min: function(t, e) {
                                return new b(Math.min(t.width, e.width), Math.min(t.height, e.height));
                            },
                            max: function(t, e) {
                                return new b(Math.max(t.width, e.width), Math.max(t.height, e.height));
                            },
                            random: function() {
                                return new b(Math.random(), Math.random());
                            }
                        }
                    }, u.each([
                        "round",
                        "ceil",
                        "floor",
                        "abs"
                    ], function(t) {
                        var e = Math[t];
                        this[t] = function() {
                            return new b(e(this.width), e(this.height));
                        };
                    }, {})), x = b.extend({
                        initialize: function(t, e, i, n) {
                            this._width = t, this._height = e, this._owner = i, this._setter = n;
                        },
                        _set: function(t, e, i) {
                            return this._width = t, this._height = e, i || this._owner[this._setter](this), this;
                        },
                        getWidth: function() {
                            return this._width;
                        },
                        setWidth: function(t) {
                            this._width = t, this._owner[this._setter](this);
                        },
                        getHeight: function() {
                            return this._height;
                        },
                        setHeight: function(t) {
                            this._height = t, this._owner[this._setter](this);
                        }
                    }), w = u.extend({
                        _class: "Rectangle",
                        _readIndex: !0,
                        beans: !0,
                        initialize: function(t, e, i, n) {
                            var r, s = arguments, a = typeof t;
                            if ("number" === a ? (this._set(t, e, i, n), r = 4) : "undefined" === a || null === t ? (this._set(0, 0, 0, 0), r = +(null === t)) : 1 === s.length && (Array.isArray(t) ? (this._set.apply(this, t), r = 1) : t.x !== o || t.width !== o ? (this._set(t.x || 0, t.y || 0, t.width || 0, t.height || 0), r = 1) : t.from === o && t.to === o && (this._set(0, 0, 0, 0), u.readSupported(s, this) && (r = 1))), r === o) {
                                var h, l, c = m.readNamed(s, "from"), d = u.peek(s), p = c.x, f = c.y;
                                if (d && d.x !== o || u.hasNamed(s, "to")) {
                                    var g = m.readNamed(s, "to");
                                    h = g.x - p, l = g.y - f, h < 0 && (p = g.x, h = -h), l < 0 && (f = g.y, l = -l);
                                } else {
                                    var v = b.read(s);
                                    h = v.width, l = v.height;
                                }
                                this._set(p, f, h, l), r = s.__index;
                            }
                            var _ = s.__filtered;
                            return _ && (this.__filtered = _), this.__read && (this.__read = r), this;
                        },
                        set: "#initialize",
                        _set: function(t, e, i, n) {
                            return this.x = t, this.y = e, this.width = i, this.height = n, this;
                        },
                        clone: function() {
                            return new w(this.x, this.y, this.width, this.height);
                        },
                        equals: function(t) {
                            var e = u.isPlainValue(t) ? w.read(arguments) : t;
                            return e === this || e && this.x === e.x && this.y === e.y && this.width === e.width && this.height === e.height || !1;
                        },
                        toString: function() {
                            var t = g.instance;
                            return "{ x: " + t.number(this.x) + ", y: " + t.number(this.y) + ", width: " + t.number(this.width) + ", height: " + t.number(this.height) + " }";
                        },
                        _serialize: function(t) {
                            var e = t.formatter;
                            return [
                                e.number(this.x),
                                e.number(this.y),
                                e.number(this.width),
                                e.number(this.height)
                            ];
                        },
                        getPoint: function(t) {
                            return new (t ? m : y)(this.x, this.y, this, "setPoint");
                        },
                        setPoint: function() {
                            var t = m.read(arguments);
                            this.x = t.x, this.y = t.y;
                        },
                        getSize: function(t) {
                            return new (t ? b : x)(this.width, this.height, this, "setSize");
                        },
                        _fw: 1,
                        _fh: 1,
                        setSize: function() {
                            var t = b.read(arguments), e = this._sx, i = this._sy, n = t.width, r = t.height;
                            e && (this.x += (this.width - n) * e), i && (this.y += (this.height - r) * i), this.width = n, this.height = r, this._fw = this._fh = 1;
                        },
                        getLeft: function() {
                            return this.x;
                        },
                        setLeft: function(t) {
                            if (!this._fw) {
                                var e = t - this.x;
                                this.width -= .5 === this._sx ? 2 * e : e;
                            }
                            this.x = t, this._sx = this._fw = 0;
                        },
                        getTop: function() {
                            return this.y;
                        },
                        setTop: function(t) {
                            if (!this._fh) {
                                var e = t - this.y;
                                this.height -= .5 === this._sy ? 2 * e : e;
                            }
                            this.y = t, this._sy = this._fh = 0;
                        },
                        getRight: function() {
                            return this.x + this.width;
                        },
                        setRight: function(t) {
                            if (!this._fw) {
                                var e = t - this.x;
                                this.width = .5 === this._sx ? 2 * e : e;
                            }
                            this.x = t - this.width, this._sx = 1, this._fw = 0;
                        },
                        getBottom: function() {
                            return this.y + this.height;
                        },
                        setBottom: function(t) {
                            if (!this._fh) {
                                var e = t - this.y;
                                this.height = .5 === this._sy ? 2 * e : e;
                            }
                            this.y = t - this.height, this._sy = 1, this._fh = 0;
                        },
                        getCenterX: function() {
                            return this.x + this.width / 2;
                        },
                        setCenterX: function(t) {
                            this._fw || .5 === this._sx ? this.x = t - this.width / 2 : (this._sx && (this.x += (t - this.x) * 2 * this._sx), this.width = (t - this.x) * 2), this._sx = .5, this._fw = 0;
                        },
                        getCenterY: function() {
                            return this.y + this.height / 2;
                        },
                        setCenterY: function(t) {
                            this._fh || .5 === this._sy ? this.y = t - this.height / 2 : (this._sy && (this.y += (t - this.y) * 2 * this._sy), this.height = (t - this.y) * 2), this._sy = .5, this._fh = 0;
                        },
                        getCenter: function(t) {
                            return new (t ? m : y)(this.getCenterX(), this.getCenterY(), this, "setCenter");
                        },
                        setCenter: function() {
                            var t = m.read(arguments);
                            return this.setCenterX(t.x), this.setCenterY(t.y), this;
                        },
                        getArea: function() {
                            return this.width * this.height;
                        },
                        isEmpty: function() {
                            return 0 === this.width || 0 === this.height;
                        },
                        contains: function(t) {
                            return t && t.width !== o || 4 === (Array.isArray(t) ? t : arguments).length ? this._containsRectangle(w.read(arguments)) : this._containsPoint(m.read(arguments));
                        },
                        _containsPoint: function(t) {
                            var e = t.x, i = t.y;
                            return e >= this.x && i >= this.y && e <= this.x + this.width && i <= this.y + this.height;
                        },
                        _containsRectangle: function(t) {
                            var e = t.x, i = t.y;
                            return e >= this.x && i >= this.y && e + t.width <= this.x + this.width && i + t.height <= this.y + this.height;
                        },
                        intersects: function() {
                            var t = w.read(arguments), e = u.read(arguments) || 0;
                            return t.x + t.width > this.x - e && t.y + t.height > this.y - e && t.x < this.x + this.width + e && t.y < this.y + this.height + e;
                        },
                        intersect: function() {
                            var t = w.read(arguments), e = Math.max(this.x, t.x), i = Math.max(this.y, t.y);
                            return new w(e, i, Math.min(this.x + this.width, t.x + t.width) - e, Math.min(this.y + this.height, t.y + t.height) - i);
                        },
                        unite: function() {
                            var t = w.read(arguments), e = Math.min(this.x, t.x), i = Math.min(this.y, t.y);
                            return new w(e, i, Math.max(this.x + this.width, t.x + t.width) - e, Math.max(this.y + this.height, t.y + t.height) - i);
                        },
                        include: function() {
                            var t = m.read(arguments), e = Math.min(this.x, t.x), i = Math.min(this.y, t.y);
                            return new w(e, i, Math.max(this.x + this.width, t.x) - e, Math.max(this.y + this.height, t.y) - i);
                        },
                        expand: function() {
                            var t = b.read(arguments), e = t.width, i = t.height;
                            return new w(this.x - e / 2, this.y - i / 2, this.width + e, this.height + i);
                        },
                        scale: function(t, e) {
                            return this.expand(this.width * t - this.width, this.height * (e === o ? t : e) - this.height);
                        }
                    }, u.each([
                        [
                            "Top",
                            "Left"
                        ],
                        [
                            "Top",
                            "Right"
                        ],
                        [
                            "Bottom",
                            "Left"
                        ],
                        [
                            "Bottom",
                            "Right"
                        ],
                        [
                            "Left",
                            "Center"
                        ],
                        [
                            "Top",
                            "Center"
                        ],
                        [
                            "Right",
                            "Center"
                        ],
                        [
                            "Bottom",
                            "Center"
                        ]
                    ], function(t, e) {
                        var i = t.join(""), n = /^[RL]/.test(i);
                        e >= 4 && (t[1] += n ? "Y" : "X");
                        var r = t[+!n], s = t[+!!n], a = "get" + r, o = "get" + s, h = "set" + r, l = "set" + s, u = "get" + i, c = "set" + i;
                        this[u] = function(t) {
                            return new (t ? m : y)(this[a](), this[o](), this, c);
                        }, this[c] = function() {
                            var t = m.read(arguments);
                            this[h](t.x), this[l](t.y);
                        };
                    }, {
                        beans: !0
                    })), C = w.extend({
                        initialize: function(t, e, i, n, r, s) {
                            this._set(t, e, i, n, !0), this._owner = r, this._setter = s;
                        },
                        _set: function(t, e, i, n, r) {
                            return this._x = t, this._y = e, this._width = i, this._height = n, r || this._owner[this._setter](this), this;
                        }
                    }, new function() {
                        var t = w.prototype;
                        return u.each([
                            "x",
                            "y",
                            "width",
                            "height"
                        ], function(t) {
                            var e = u.capitalize(t), i = "_" + t;
                            this["get" + e] = function() {
                                return this[i];
                            }, this["set" + e] = function(t) {
                                this[i] = t, this._dontNotify || this._owner[this._setter](this);
                            };
                        }, u.each([
                            "Point",
                            "Size",
                            "Center",
                            "Left",
                            "Top",
                            "Right",
                            "Bottom",
                            "CenterX",
                            "CenterY",
                            "TopLeft",
                            "TopRight",
                            "BottomLeft",
                            "BottomRight",
                            "LeftCenter",
                            "TopCenter",
                            "RightCenter",
                            "BottomCenter"
                        ], function(e) {
                            var i = "set" + e;
                            this[i] = function() {
                                this._dontNotify = !0, t[i].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
                            };
                        }, {
                            isSelected: function() {
                                return !!(2 & this._owner._selection);
                            },
                            setSelected: function(t) {
                                var e = this._owner;
                                e._changeSelection && e._changeSelection(2, t);
                            }
                        }));
                    }), S = u.extend({
                        _class: "Matrix",
                        initialize: function t(e, i) {
                            var n = arguments, r = n.length, s = !0;
                            if (r >= 6 ? this._set.apply(this, n) : 1 === r || 2 === r ? e instanceof t ? this._set(e._a, e._b, e._c, e._d, e._tx, e._ty, i) : Array.isArray(e) ? this._set.apply(this, i ? e.concat([
                                i
                            ]) : e) : s = !1 : r ? s = !1 : this.reset(), !s) throw Error("Unsupported matrix parameters");
                            return this;
                        },
                        set: "#initialize",
                        _set: function(t, e, i, n, r, s, a) {
                            return this._a = t, this._b = e, this._c = i, this._d = n, this._tx = r, this._ty = s, a || this._changed(), this;
                        },
                        _serialize: function(t, e) {
                            return u.serialize(this.getValues(), t, !0, e);
                        },
                        _changed: function() {
                            var t = this._owner;
                            t && (t._applyMatrix ? t.transform(null, !0) : t._changed(25));
                        },
                        clone: function() {
                            return new S(this._a, this._b, this._c, this._d, this._tx, this._ty);
                        },
                        equals: function(t) {
                            return t === this || t && this._a === t._a && this._b === t._b && this._c === t._c && this._d === t._d && this._tx === t._tx && this._ty === t._ty;
                        },
                        toString: function() {
                            var t = g.instance;
                            return "[[" + [
                                t.number(this._a),
                                t.number(this._c),
                                t.number(this._tx)
                            ].join(", ") + "], [" + [
                                t.number(this._b),
                                t.number(this._d),
                                t.number(this._ty)
                            ].join(", ") + "]]";
                        },
                        reset: function(t) {
                            return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, t || this._changed(), this;
                        },
                        apply: function(t, e) {
                            var i = this._owner;
                            return !!i && (i.transform(null, u.pick(t, !0), e), this.isIdentity());
                        },
                        translate: function() {
                            var t = m.read(arguments), e = t.x, i = t.y;
                            return this._tx += e * this._a + i * this._c, this._ty += e * this._b + i * this._d, this._changed(), this;
                        },
                        scale: function() {
                            var t = arguments, e = m.read(t), i = m.read(t, 0, {
                                readNull: !0
                            });
                            return i && this.translate(i), this._a *= e.x, this._b *= e.x, this._c *= e.y, this._d *= e.y, i && this.translate(i.negate()), this._changed(), this;
                        },
                        rotate: function(t) {
                            t *= Math.PI / 180;
                            var e = m.read(arguments, 1), i = e.x, n = e.y, r = Math.cos(t), s = Math.sin(t), a = i - i * r + n * s, o = n - i * s - n * r, h = this._a, l = this._b, u = this._c, c = this._d;
                            return this._a = r * h + s * u, this._b = r * l + s * c, this._c = -s * h + r * u, this._d = -s * l + r * c, this._tx += a * h + o * u, this._ty += a * l + o * c, this._changed(), this;
                        },
                        shear: function() {
                            var t = arguments, e = m.read(t), i = m.read(t, 0, {
                                readNull: !0
                            });
                            i && this.translate(i);
                            var n = this._a, r = this._b;
                            return this._a += e.y * this._c, this._b += e.y * this._d, this._c += e.x * n, this._d += e.x * r, i && this.translate(i.negate()), this._changed(), this;
                        },
                        skew: function() {
                            var t = arguments, e = m.read(t), i = m.read(t, 0, {
                                readNull: !0
                            }), n = Math.PI / 180, r = new m(Math.tan(e.x * n), Math.tan(e.y * n));
                            return this.shear(r, i);
                        },
                        append: function(t, e) {
                            if (t) {
                                var i = this._a, n = this._b, r = this._c, s = this._d, a = t._a, o = t._c, h = t._b, l = t._d, u = t._tx, c = t._ty;
                                this._a = a * i + h * r, this._c = o * i + l * r, this._b = a * n + h * s, this._d = o * n + l * s, this._tx += u * i + c * r, this._ty += u * n + c * s, e || this._changed();
                            }
                            return this;
                        },
                        prepend: function(t, e) {
                            if (t) {
                                var i = this._a, n = this._b, r = this._c, s = this._d, a = this._tx, o = this._ty, h = t._a, l = t._c, u = t._b, c = t._d, d = t._tx, p = t._ty;
                                this._a = h * i + l * n, this._c = h * r + l * s, this._b = u * i + c * n, this._d = u * r + c * s, this._tx = h * a + l * o + d, this._ty = u * a + c * o + p, e || this._changed();
                            }
                            return this;
                        },
                        appended: function(t) {
                            return this.clone().append(t);
                        },
                        prepended: function(t) {
                            return this.clone().prepend(t);
                        },
                        invert: function() {
                            var t = this._a, e = this._b, i = this._c, n = this._d, r = this._tx, s = this._ty, a = t * n - e * i, o = null;
                            return a && !isNaN(a) && isFinite(r) && isFinite(s) && (this._a = n / a, this._b = -e / a, this._c = -i / a, this._d = t / a, this._tx = (i * s - n * r) / a, this._ty = (e * r - t * s) / a, o = this), o;
                        },
                        inverted: function() {
                            return this.clone().invert();
                        },
                        concatenate: "#append",
                        preConcatenate: "#prepend",
                        chain: "#appended",
                        _shiftless: function() {
                            return new S(this._a, this._b, this._c, this._d, 0, 0);
                        },
                        _orNullIfIdentity: function() {
                            return this.isIdentity() ? null : this;
                        },
                        isIdentity: function() {
                            return 1 === this._a && 0 === this._b && 0 === this._c && 1 === this._d && 0 === this._tx && 0 === this._ty;
                        },
                        isInvertible: function() {
                            var t = this._a * this._d - this._c * this._b;
                            return t && !isNaN(t) && isFinite(this._tx) && isFinite(this._ty);
                        },
                        isSingular: function() {
                            return !this.isInvertible();
                        },
                        transform: function(t, e, i) {
                            return arguments.length < 3 ? this._transformPoint(m.read(arguments)) : this._transformCoordinates(t, e, i);
                        },
                        _transformPoint: function(t, e, i) {
                            var n = t.x, r = t.y;
                            return e || (e = new m), e._set(n * this._a + r * this._c + this._tx, n * this._b + r * this._d + this._ty, i);
                        },
                        _transformCoordinates: function(t, e, i) {
                            for(var n = 0, r = 2 * i; n < r; n += 2){
                                var s = t[n], a = t[n + 1];
                                e[n] = s * this._a + a * this._c + this._tx, e[n + 1] = s * this._b + a * this._d + this._ty;
                            }
                            return e;
                        },
                        _transformCorners: function(t) {
                            var e = t.x, i = t.y, n = e + t.width, r = i + t.height, s = [
                                e,
                                i,
                                n,
                                i,
                                n,
                                r,
                                e,
                                r
                            ];
                            return this._transformCoordinates(s, s, 4);
                        },
                        _transformBounds: function(t, e, i) {
                            for(var n = this._transformCorners(t), r = n.slice(0, 2), s = r.slice(), a = 2; a < 8; a++){
                                var o = n[a], h = 1 & a;
                                o < r[h] ? r[h] = o : o > s[h] && (s[h] = o);
                            }
                            return e || (e = new w), e._set(r[0], r[1], s[0] - r[0], s[1] - r[1], i);
                        },
                        inverseTransform: function() {
                            return this._inverseTransform(m.read(arguments));
                        },
                        _inverseTransform: function(t, e, i) {
                            var n = this._a, r = this._b, s = this._c, a = this._d, o = this._tx, h = this._ty, l = n * a - r * s, u = null;
                            if (l && !isNaN(l) && isFinite(o) && isFinite(h)) {
                                var c = t.x - this._tx, d = t.y - this._ty;
                                e || (e = new m), u = e._set((c * a - d * s) / l, (d * n - c * r) / l, i);
                            }
                            return u;
                        },
                        decompose: function() {
                            var t, e, i, n = this._a, r = this._b, s = this._c, a = this._d, o = n * a - r * s, h = Math.sqrt, l = Math.atan2, u = 180 / Math.PI;
                            if (0 !== n || 0 !== r) {
                                var c = h(n * n + r * r);
                                t = Math.acos(n / c) * (r > 0 ? 1 : -1), e = [
                                    c,
                                    o / c
                                ], i = [
                                    l(n * s + r * a, c * c),
                                    0
                                ];
                            } else if (0 !== s || 0 !== a) {
                                var d = h(s * s + a * a);
                                t = Math.asin(s / d) * (a > 0 ? 1 : -1), e = [
                                    o / d,
                                    d
                                ], i = [
                                    0,
                                    l(n * s + r * a, d * d)
                                ];
                            } else t = 0, i = e = [
                                0,
                                0
                            ];
                            return {
                                translation: this.getTranslation(),
                                rotation: t * u,
                                scaling: new m(e),
                                skewing: new m(i[0] * u, i[1] * u)
                            };
                        },
                        getValues: function() {
                            return [
                                this._a,
                                this._b,
                                this._c,
                                this._d,
                                this._tx,
                                this._ty
                            ];
                        },
                        getTranslation: function() {
                            return new m(this._tx, this._ty);
                        },
                        getScaling: function() {
                            return this.decompose().scaling;
                        },
                        getRotation: function() {
                            return this.decompose().rotation;
                        },
                        applyToContext: function(t) {
                            this.isIdentity() || t.transform(this._a, this._b, this._c, this._d, this._tx, this._ty);
                        }
                    }, u.each([
                        "a",
                        "b",
                        "c",
                        "d",
                        "tx",
                        "ty"
                    ], function(t) {
                        var e = u.capitalize(t), i = "_" + t;
                        this["get" + e] = function() {
                            return this[i];
                        }, this["set" + e] = function(t) {
                            this[i] = t, this._changed();
                        };
                    }, {})), k = u.extend({
                        _class: "Line",
                        initialize: function(t, e, i, n, r) {
                            var s = !1;
                            arguments.length >= 4 ? (this._px = t, this._py = e, this._vx = i, this._vy = n, s = r) : (this._px = t.x, this._py = t.y, this._vx = e.x, this._vy = e.y, s = i), s || (this._vx -= this._px, this._vy -= this._py);
                        },
                        getPoint: function() {
                            return new m(this._px, this._py);
                        },
                        getVector: function() {
                            return new m(this._vx, this._vy);
                        },
                        getLength: function() {
                            return this.getVector().getLength();
                        },
                        intersect: function(t, e) {
                            return k.intersect(this._px, this._py, this._vx, this._vy, t._px, t._py, t._vx, t._vy, !0, e);
                        },
                        getSide: function(t, e) {
                            return k.getSide(this._px, this._py, this._vx, this._vy, t.x, t.y, !0, e);
                        },
                        getDistance: function(t) {
                            return Math.abs(this.getSignedDistance(t));
                        },
                        getSignedDistance: function(t) {
                            return k.getSignedDistance(this._px, this._py, this._vx, this._vy, t.x, t.y, !0);
                        },
                        isCollinear: function(t) {
                            return m.isCollinear(this._vx, this._vy, t._vx, t._vy);
                        },
                        isOrthogonal: function(t) {
                            return m.isOrthogonal(this._vx, this._vy, t._vx, t._vy);
                        },
                        statics: {
                            intersect: function(t, e, i, n, r, s, a, o, h, l) {
                                h || (i -= t, n -= e, a -= r, o -= s);
                                var u = i * o - n * a;
                                if (!v.isMachineZero(u)) {
                                    var c = t - r, d = e - s, p = (a * d - o * c) / u, f = (i * d - n * c) / u;
                                    if (l || -0.000000000001 < p && p < 1.000000000001 && -0.000000000001 < f && f < 1.000000000001) return l || (p = p <= 0 ? 0 : p >= 1 ? 1 : p), new m(t + p * i, e + p * n);
                                }
                            },
                            getSide: function(t, e, i, n, r, s, a, o) {
                                a || (i -= t, n -= e);
                                var h = r - t, l = h * n - (s - e) * i;
                                return !o && v.isMachineZero(l) && (l = (h * i + h * i) / (i * i + n * n)) >= 0 && l <= 1 && (l = 0), l < 0 ? -1 : +(l > 0);
                            },
                            getSignedDistance: function(t, e, i, n, r, s, a) {
                                return a || (i -= t, n -= e), 0 === i ? n > 0 ? r - t : t - r : 0 === n ? i < 0 ? s - e : e - s : ((r - t) * n - (s - e) * i) / (n > i ? n * Math.sqrt(1 + i * i / (n * n)) : i * Math.sqrt(1 + n * n / (i * i)));
                            },
                            getDistance: function(t, e, i, n, r, s, a) {
                                return Math.abs(k.getSignedDistance(t, e, i, n, r, s, a));
                            }
                        }
                    }), P = p.extend({
                        _class: "Project",
                        _list: "projects",
                        _reference: "project",
                        _compactSerialize: !0,
                        initialize: function(t) {
                            p.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new $(null, null, this), this._view = J.create(this, t || th.getCanvas(1, 1)), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
                        },
                        _serialize: function(t, e) {
                            return u.serialize(this._children, t, !0, e);
                        },
                        _changed: function(t, e) {
                            if (1 & t) {
                                var i = this._view;
                                i && (i._needsUpdate = !0, !i._requested && i._autoUpdate && i.requestUpdate());
                            }
                            var n = this._changes;
                            if (n && e) {
                                var r = this._changesById, s = e._id, a = r[s];
                                a ? a.flags |= t : n.push(r[s] = {
                                    item: e,
                                    flags: t
                                });
                            }
                        },
                        clear: function() {
                            for(var t = this._children, e = t.length - 1; e >= 0; e--)t[e].remove();
                        },
                        isEmpty: function() {
                            return !this._children.length;
                        },
                        remove: function t() {
                            return !!t.base.call(this) && (this._view && this._view.remove(), !0);
                        },
                        getView: function() {
                            return this._view;
                        },
                        getCurrentStyle: function() {
                            return this._currentStyle;
                        },
                        setCurrentStyle: function(t) {
                            this._currentStyle.set(t);
                        },
                        getIndex: function() {
                            return this._index;
                        },
                        getOptions: function() {
                            return this._scope.settings;
                        },
                        getLayers: function() {
                            return this._children;
                        },
                        getActiveLayer: function() {
                            return this._activeLayer || new T({
                                project: this,
                                insert: !0
                            });
                        },
                        getSymbolDefinitions: function() {
                            var t = [], e = {};
                            return this.getItems({
                                class: M,
                                match: function(i) {
                                    var n = i._definition, r = n._id;
                                    return e[r] || (e[r] = !0, t.push(n)), !1;
                                }
                            }), t;
                        },
                        getSymbols: "getSymbolDefinitions",
                        getSelectedItems: function() {
                            var t = this._selectionItems, e = [];
                            for(var i in t){
                                var n = t[i], r = n._selection;
                                1 & r && n.isInserted() ? e.push(n) : r || this._updateSelection(n);
                            }
                            return e;
                        },
                        _updateSelection: function(t) {
                            var e = t._id, i = this._selectionItems;
                            t._selection ? i[e] !== t && (this._selectionCount++, i[e] = t) : i[e] === t && (this._selectionCount--, delete i[e]);
                        },
                        selectAll: function() {
                            for(var t = this._children, e = 0, i = t.length; e < i; e++)t[e].setFullySelected(!0);
                        },
                        deselectAll: function() {
                            var t = this._selectionItems;
                            for(var e in t)t[e].setFullySelected(!1);
                        },
                        addLayer: function(t) {
                            return this.insertLayer(o, t);
                        },
                        insertLayer: function(t, e) {
                            if (e instanceof T) {
                                e._remove(!1, !0), u.splice(this._children, [
                                    e
                                ], t, 0), e._setProject(this, !0);
                                var i = e._name;
                                i && e.setName(i), this._changes && e._changed(5), this._activeLayer || (this._activeLayer = e);
                            } else e = null;
                            return e;
                        },
                        _insertItem: function(t, e, i) {
                            return e = this.insertLayer(t, e) || (this._activeLayer || this._insertItem(o, new T(A.NO_INSERT), !0)).insertChild(t, e), i && e.activate && e.activate(), e;
                        },
                        getItems: function(t) {
                            return A._getItems(this, t);
                        },
                        getItem: function(t) {
                            return A._getItems(this, t, null, null, !0)[0] || null;
                        },
                        importJSON: function(t) {
                            this.activate();
                            var e = this._activeLayer;
                            return u.importJSON(t, e && e.isEmpty() && e);
                        },
                        removeOn: function(t) {
                            var e = this._removeSets;
                            if (e) {
                                "mouseup" === t && (e.mousedrag = null);
                                var i = e[t];
                                if (i) {
                                    for(var n in i){
                                        var r = i[n];
                                        for(var s in e){
                                            var a = e[s];
                                            a && a != i && delete a[r._id];
                                        }
                                        r.remove();
                                    }
                                    e[t] = null;
                                }
                            }
                        },
                        draw: function(t, e, i) {
                            this._updateVersion++, t.save(), e.applyToContext(t);
                            for(var n = this._children, r = new u({
                                offset: new m(0, 0),
                                pixelRatio: i,
                                viewMatrix: e.isIdentity() ? null : e,
                                matrices: [
                                    new S
                                ],
                                updateMatrix: !0
                            }), s = 0, a = n.length; s < a; s++)n[s].draw(t, r);
                            if (t.restore(), this._selectionCount > 0) {
                                t.save(), t.strokeWidth = 1;
                                var o = this._selectionItems, h = this._scope.settings.handleSize, l = this._updateVersion;
                                for(var c in o)o[c]._drawSelection(t, e, h, o, l);
                                t.restore();
                            }
                        }
                    }), A = u.extend(c, {
                        statics: {
                            extend: function t(e) {
                                return e._serializeFields && (e._serializeFields = u.set({}, this.prototype._serializeFields, e._serializeFields)), t.base.apply(this, arguments);
                            },
                            NO_INSERT: {
                                insert: !1
                            }
                        },
                        _class: "Item",
                        _name: null,
                        _applyMatrix: !0,
                        _canApplyMatrix: !0,
                        _canScaleStroke: !1,
                        _pivot: null,
                        _visible: !0,
                        _blendMode: "normal",
                        _opacity: 1,
                        _locked: !1,
                        _guide: !1,
                        _clipMask: !1,
                        _selection: 0,
                        _selectBounds: !0,
                        _selectChildren: !1,
                        _serializeFields: {
                            name: null,
                            applyMatrix: null,
                            matrix: new S,
                            pivot: null,
                            visible: !0,
                            blendMode: "normal",
                            opacity: 1,
                            locked: !1,
                            guide: !1,
                            clipMask: !1,
                            selected: !1,
                            data: {}
                        },
                        _prioritize: [
                            "applyMatrix"
                        ]
                    }, new function() {
                        var t = [
                            "onMouseDown",
                            "onMouseUp",
                            "onMouseDrag",
                            "onClick",
                            "onDoubleClick",
                            "onMouseMove",
                            "onMouseEnter",
                            "onMouseLeave"
                        ];
                        return u.each(t, function(t) {
                            this._events[t] = {
                                install: function(t) {
                                    this.getView()._countItemEvent(t, 1);
                                },
                                uninstall: function(t) {
                                    this.getView()._countItemEvent(t, -1);
                                }
                            };
                        }, {
                            _events: {
                                onFrame: {
                                    install: function() {
                                        this.getView()._animateItem(this, !0);
                                    },
                                    uninstall: function() {
                                        this.getView()._animateItem(this, !1);
                                    }
                                },
                                onLoad: {},
                                onError: {}
                            },
                            statics: {
                                _itemHandlers: t
                            }
                        });
                    }, {
                        initialize: function() {},
                        _initialize: function(t, e) {
                            var i = t && u.isPlainObject(t), n = i && !0 === t.internal, r = this._matrix = new S, s = i && t.project || td.project, a = td.settings;
                            return this._id = n ? null : _.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && a.applyMatrix, e && r.translate(e), r._owner = this, this._style = new $(s._currentStyle, this, s), n || i && !1 == t.insert || !a.insertItems && !(i && !0 === t.insert) ? this._setProject(s) : (i && t.parent || s)._insertItem(o, this, !0), i && t !== A.NO_INSERT && this.set(t, {
                                internal: !0,
                                insert: !0,
                                project: !0,
                                parent: !0
                            }), i;
                        },
                        _serialize: function(t, e) {
                            var i = {}, n = this;
                            function r(r) {
                                for(var s in r){
                                    var a = n[s];
                                    u.equals(a, "leading" === s ? 1.2 * r.fontSize : r[s]) || (i[s] = u.serialize(a, t, "data" !== s, e));
                                }
                            }
                            return r(this._serializeFields), this instanceof I || r(this._style._defaults), [
                                this._class,
                                i
                            ];
                        },
                        _changed: function(t) {
                            var e = this._symbol, i = this._parent || e, n = this._project;
                            8 & t && (this._bounds = this._position = this._decomposed = o), 16 & t && (this._globalMatrix = o), i && 72 & t && A._clearBoundsCache(i), 2 & t && A._clearBoundsCache(this), n && n._changed(t, this), e && e._changed(t);
                        },
                        getId: function() {
                            return this._id;
                        },
                        getName: function() {
                            return this._name;
                        },
                        setName: function(t) {
                            if (this._name && this._removeNamed(), t === +t + "") throw Error("Names consisting only of numbers are not supported.");
                            var e = this._getOwner();
                            if (t && e) {
                                var i = e._children, n = e._namedChildren;
                                (n[t] = n[t] || []).push(this), t in i || (i[t] = this);
                            }
                            this._name = t || o, this._changed(256);
                        },
                        getStyle: function() {
                            return this._style;
                        },
                        setStyle: function(t) {
                            this.getStyle().set(t);
                        }
                    }, u.each([
                        "locked",
                        "visible",
                        "blendMode",
                        "opacity",
                        "guide"
                    ], function(t) {
                        var e = u.capitalize(t), i = "_" + t, n = {
                            locked: 256,
                            visible: 265
                        };
                        this["get" + e] = function() {
                            return this[i];
                        }, this["set" + e] = function(e) {
                            e != this[i] && (this[i] = e, this._changed(n[t] || 257));
                        };
                    }, {}), {
                        beans: !0,
                        getSelection: function() {
                            return this._selection;
                        },
                        setSelection: function(t) {
                            if (t !== this._selection) {
                                this._selection = t;
                                var e = this._project;
                                e && (e._updateSelection(this), this._changed(257));
                            }
                        },
                        _changeSelection: function(t, e) {
                            var i = this._selection;
                            this.setSelection(e ? i | t : i & ~t);
                        },
                        isSelected: function() {
                            if (this._selectChildren) {
                                for(var t = this._children, e = 0, i = t.length; e < i; e++)if (t[e].isSelected()) return !0;
                            }
                            return !!(1 & this._selection);
                        },
                        setSelected: function(t) {
                            if (this._selectChildren) for(var e = this._children, i = 0, n = e.length; i < n; i++)e[i].setSelected(t);
                            this._changeSelection(1, t);
                        },
                        isFullySelected: function() {
                            var t = this._children, e = !!(1 & this._selection);
                            if (t && e) {
                                for(var i = 0, n = t.length; i < n; i++)if (!t[i].isFullySelected()) return !1;
                                return !0;
                            }
                            return e;
                        },
                        setFullySelected: function(t) {
                            var e = this._children;
                            if (e) for(var i = 0, n = e.length; i < n; i++)e[i].setFullySelected(t);
                            this._changeSelection(1, t);
                        },
                        isClipMask: function() {
                            return this._clipMask;
                        },
                        setClipMask: function(t) {
                            this._clipMask != (t = !!t) && (this._clipMask = t, t && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
                        },
                        getData: function() {
                            return this._data || (this._data = {}), this._data;
                        },
                        setData: function(t) {
                            this._data = t;
                        },
                        getPosition: function(t) {
                            var e = t ? m : y, i = this._position || (this._position = this._getPositionFromBounds());
                            return new e(i.x, i.y, this, "setPosition");
                        },
                        setPosition: function() {
                            this.translate(m.read(arguments).subtract(this.getPosition(!0)));
                        },
                        _getPositionFromBounds: function(t) {
                            return this._pivot ? this._matrix._transformPoint(this._pivot) : (t || this.getBounds()).getCenter(!0);
                        },
                        getPivot: function() {
                            var t = this._pivot;
                            return t ? new y(t.x, t.y, this, "setPivot") : null;
                        },
                        setPivot: function() {
                            this._pivot = m.read(arguments, 0, {
                                clone: !0,
                                readNull: !0
                            }), this._position = o;
                        }
                    }, u.each({
                        getStrokeBounds: {
                            stroke: !0
                        },
                        getHandleBounds: {
                            handle: !0
                        },
                        getInternalBounds: {
                            internal: !0
                        }
                    }, function(t, e) {
                        this[e] = function(e) {
                            return this.getBounds(e, t);
                        };
                    }, {
                        beans: !0,
                        getBounds: function(t, e) {
                            var i = e || t instanceof S, n = u.set({}, i ? e : t, this._boundsOptions);
                            (!n.stroke || this.getStrokeScaling()) && (n.cacheItem = this);
                            var r = this._getCachedBounds(i && t, n).rect;
                            return arguments.length ? r : new C(r.x, r.y, r.width, r.height, this, "setBounds");
                        },
                        setBounds: function() {
                            var t = w.read(arguments), e = this.getBounds(), i = this._matrix, n = new S, r = t.getCenter();
                            n.translate(r), (t.width != e.width || t.height != e.height) && (i.isInvertible() || (i.set(i._backup || new S().translate(i.getTranslation())), e = this.getBounds()), n.scale(0 !== e.width ? t.width / e.width : 0, 0 !== e.height ? t.height / e.height : 0)), r = e.getCenter(), n.translate(-r.x, -r.y), this.transform(n);
                        },
                        _getBounds: function(t, e) {
                            var i = this._children;
                            return i && i.length ? (A._updateBoundsCache(this, e.cacheItem), A._getBounds(i, t, e)) : new w;
                        },
                        _getBoundsCacheKey: function(t, e) {
                            return [
                                +!!t.stroke,
                                +!!t.handle,
                                +!!e
                            ].join("");
                        },
                        _getCachedBounds: function(t, e, i) {
                            t = t && t._orNullIfIdentity();
                            var n = e.internal && !i, r = e.cacheItem, s = n ? null : this._matrix._orNullIfIdentity(), a = r && (!t || t.equals(s)) && this._getBoundsCacheKey(e, n), o = this._bounds;
                            if (A._updateBoundsCache(this._parent || this._symbol, r), a && o && a in o) {
                                var h = o[a];
                                return {
                                    rect: h.rect.clone(),
                                    nonscaling: h.nonscaling
                                };
                            }
                            var l = this._getBounds(t || s, e), u = l.rect || l, c = this._style, d = l.nonscaling || c.hasStroke() && !c.getStrokeScaling();
                            if (a) {
                                o || (this._bounds = o = {});
                                var h = o[a] = {
                                    rect: u.clone(),
                                    nonscaling: d,
                                    internal: n
                                };
                            }
                            return {
                                rect: u,
                                nonscaling: d
                            };
                        },
                        _getStrokeMatrix: function(t, e) {
                            var i = this.getStrokeScaling() ? null : e && e.internal ? this : this._parent || this._symbol && this._symbol._item, n = i ? i.getViewMatrix().invert() : t;
                            return n && n._shiftless();
                        },
                        statics: {
                            _updateBoundsCache: function(t, e) {
                                if (t && e) {
                                    var i = e._id, n = t._boundsCache = t._boundsCache || {
                                        ids: {},
                                        list: []
                                    };
                                    n.ids[i] || (n.list.push(e), n.ids[i] = e);
                                }
                            },
                            _clearBoundsCache: function(t) {
                                var e = t._boundsCache;
                                if (e) {
                                    t._bounds = t._position = t._boundsCache = o;
                                    for(var i = 0, n = e.list, r = n.length; i < r; i++){
                                        var s = n[i];
                                        s !== t && (s._bounds = s._position = o, s._boundsCache && A._clearBoundsCache(s));
                                    }
                                }
                            },
                            _getBounds: function(t, e, i) {
                                var n = 1 / 0, r = -1 / 0, s = 1 / 0, a = r, o = !1;
                                i = i || {};
                                for(var h = 0, l = t.length; h < l; h++){
                                    var u = t[h];
                                    if (u._visible && !u.isEmpty(!0)) {
                                        var c = u._getCachedBounds(e && e.appended(u._matrix), i, !0), d = c.rect;
                                        n = Math.min(d.x, n), s = Math.min(d.y, s), r = Math.max(d.x + d.width, r), a = Math.max(d.y + d.height, a), c.nonscaling && (o = !0);
                                    }
                                }
                                return {
                                    rect: isFinite(n) ? new w(n, s, r - n, a - s) : new w,
                                    nonscaling: o
                                };
                            }
                        }
                    }), {
                        beans: !0,
                        _decompose: function() {
                            return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
                        },
                        getRotation: function() {
                            var t = this._decompose();
                            return t ? t.rotation : 0;
                        },
                        setRotation: function(t) {
                            var e = this.getRotation();
                            if (null != e && null != t) {
                                var i = this._decomposed;
                                this.rotate(t - e), i && (i.rotation = t, this._decomposed = i);
                            }
                        },
                        getScaling: function() {
                            var t = this._decompose(), e = t && t.scaling;
                            return new y(e ? e.x : 1, e ? e.y : 1, this, "setScaling");
                        },
                        setScaling: function() {
                            var t = this.getScaling(), e = m.read(arguments, 0, {
                                clone: !0,
                                readNull: !0
                            });
                            if (t && e && !t.equals(e)) {
                                var i = this.getRotation(), n = this._decomposed, r = new S, s = v.isZero;
                                if (s(t.x) || s(t.y)) r.translate(n.translation), i && r.rotate(i), r.scale(e.x, e.y), this._matrix.set(r);
                                else {
                                    var a = this.getPosition(!0);
                                    r.translate(a), i && r.rotate(i), r.scale(e.x / t.x, e.y / t.y), i && r.rotate(-i), r.translate(a.negate()), this.transform(r);
                                }
                                n && (n.scaling = e, this._decomposed = n);
                            }
                        },
                        getMatrix: function() {
                            return this._matrix;
                        },
                        setMatrix: function() {
                            var t = this._matrix;
                            t.set.apply(t, arguments);
                        },
                        getGlobalMatrix: function(t) {
                            var e = this._globalMatrix;
                            if (e) for(var i = this._parent, n = []; i;){
                                if (!i._globalMatrix) {
                                    e = null;
                                    for(var r = 0, s = n.length; r < s; r++)n[r]._globalMatrix = null;
                                    break;
                                }
                                n.push(i), i = i._parent;
                            }
                            if (!e) {
                                e = this._globalMatrix = this._matrix.clone();
                                var i = this._parent;
                                i && e.prepend(i.getGlobalMatrix(!0));
                            }
                            return t ? e : e.clone();
                        },
                        getViewMatrix: function() {
                            return this.getGlobalMatrix().prepend(this.getView()._matrix);
                        },
                        getApplyMatrix: function() {
                            return this._applyMatrix;
                        },
                        setApplyMatrix: function(t) {
                            (this._applyMatrix = this._canApplyMatrix && !!t) && this.transform(null, !0);
                        },
                        getTransformContent: "#getApplyMatrix",
                        setTransformContent: "#setApplyMatrix"
                    }, {
                        getProject: function() {
                            return this._project;
                        },
                        _setProject: function(t, e) {
                            if (this._project !== t) {
                                this._project && this._installEvents(!1), this._project = t;
                                for(var i = this._children, n = 0, r = i && i.length; n < r; n++)i[n]._setProject(t);
                                e = !0;
                            }
                            e && this._installEvents(!0);
                        },
                        getView: function() {
                            return this._project._view;
                        },
                        _installEvents: function t(e) {
                            t.base.call(this, e);
                            for(var i = this._children, n = 0, r = i && i.length; n < r; n++)i[n]._installEvents(e);
                        },
                        getLayer: function() {
                            for(var t = this; t = t._parent;)if (t instanceof T) return t;
                            return null;
                        },
                        getParent: function() {
                            return this._parent;
                        },
                        setParent: function(t) {
                            return t.addChild(this);
                        },
                        _getOwner: "#getParent",
                        getChildren: function() {
                            return this._children;
                        },
                        setChildren: function(t) {
                            this.removeChildren(), this.addChildren(t);
                        },
                        getFirstChild: function() {
                            return this._children && this._children[0] || null;
                        },
                        getLastChild: function() {
                            return this._children && this._children[this._children.length - 1] || null;
                        },
                        getNextSibling: function() {
                            var t = this._getOwner();
                            return t && t._children[this._index + 1] || null;
                        },
                        getPreviousSibling: function() {
                            var t = this._getOwner();
                            return t && t._children[this._index - 1] || null;
                        },
                        getIndex: function() {
                            return this._index;
                        },
                        equals: function(t) {
                            return t === this || t && this._class === t._class && this._style.equals(t._style) && this._matrix.equals(t._matrix) && this._locked === t._locked && this._visible === t._visible && this._blendMode === t._blendMode && this._opacity === t._opacity && this._clipMask === t._clipMask && this._guide === t._guide && this._equals(t) || !1;
                        },
                        _equals: function(t) {
                            return u.equals(this._children, t._children);
                        },
                        clone: function(t) {
                            var e = new this.constructor(A.NO_INSERT), i = this._children, n = u.pick(t ? t.insert : o, t === o || !0 === t), r = u.pick(t ? t.deep : o, !0);
                            i && e.copyAttributes(this), (!i || r) && e.copyContent(this), i || e.copyAttributes(this), n && e.insertAbove(this);
                            var s = this._name, a = this._parent;
                            if (s && a) {
                                for(var i = a._children, h = s, l = 1; i[s];)s = h + " " + l++;
                                s !== h && e.setName(s);
                            }
                            return e;
                        },
                        copyContent: function(t) {
                            for(var e = t._children, i = 0, n = e && e.length; i < n; i++)this.addChild(e[i].clone(!1), !0);
                        },
                        copyAttributes: function(t, e) {
                            this.setStyle(t._style);
                            for(var i = [
                                "_locked",
                                "_visible",
                                "_blendMode",
                                "_opacity",
                                "_clipMask",
                                "_guide"
                            ], n = 0, r = i.length; n < r; n++){
                                var s = i[n];
                                t.hasOwnProperty(s) && (this[s] = t[s]);
                            }
                            e || this._matrix.set(t._matrix, !0), this.setApplyMatrix(t._applyMatrix), this.setPivot(t._pivot), this.setSelection(t._selection);
                            var a = t._data, o = t._name;
                            this._data = a ? u.clone(a) : null, o && this.setName(o);
                        },
                        rasterize: function(t, e) {
                            var i = this.getStrokeBounds(), n = (t || this.getView().getResolution()) / 72, r = i.getTopLeft().floor(), s = new b(i.getBottomRight().ceil().subtract(r)), a = new L(A.NO_INSERT);
                            if (!s.isZero()) {
                                var h = th.getCanvas(s.multiply(n)), l = h.getContext("2d"), c = new S().scale(n).translate(r.negate());
                                l.save(), c.applyToContext(l), this.draw(l, new u({
                                    matrices: [
                                        c
                                    ]
                                })), l.restore(), a.setCanvas(h);
                            }
                            return a.transform(new S().translate(r.add(s.divide(2))).scale(1 / n)), (e === o || e) && a.insertAbove(this), a;
                        },
                        contains: function() {
                            var t = this._matrix;
                            return t.isInvertible() && !!this._contains(t._inverseTransform(m.read(arguments)));
                        },
                        _contains: function(t) {
                            var e = this._children;
                            if (e) {
                                for(var i = e.length - 1; i >= 0; i--)if (e[i].contains(t)) return !0;
                                return !1;
                            }
                            return t.isInside(this.getInternalBounds());
                        },
                        isInside: function() {
                            return w.read(arguments).contains(this.getBounds());
                        },
                        _asPathItem: function() {
                            return new D.Rectangle({
                                rectangle: this.getInternalBounds(),
                                matrix: this._matrix,
                                insert: !1
                            });
                        },
                        intersects: function(t, e) {
                            return t instanceof A && this._asPathItem().getIntersections(t._asPathItem(), null, e, !0).length > 0;
                        }
                    }, new function() {
                        function t() {
                            var t = arguments;
                            return this._hitTest(m.read(t), O.getOptions(t));
                        }
                        function e() {
                            var t = arguments, e = m.read(t), i = O.getOptions(t), n = [];
                            return this._hitTest(e, new u({
                                all: n
                            }, i)), n;
                        }
                        function i(t, e, i, n) {
                            var r = this._children;
                            if (r) for(var s = r.length - 1; s >= 0; s--){
                                var a = r[s], o = a !== n && a._hitTest(t, e, i);
                                if (o && !e.all) return o;
                            }
                            return null;
                        }
                        return P.inject({
                            hitTest: t,
                            hitTestAll: e,
                            _hitTest: i
                        }), {
                            hitTest: t,
                            hitTestAll: e,
                            _hitTestChildren: i
                        };
                    }, {
                        _hitTest: function(t, e, i) {
                            if (this._locked || !this._visible || this._guide && !e.guides || this.isEmpty()) return null;
                            var n = this._matrix, r = i ? i.appended(n) : this.getGlobalMatrix().prepend(this.getView()._matrix), s = Math.max(e.tolerance, 1e-12), a = e._tolerancePadding = new b(D._getStrokePadding(s, n._shiftless().invert()));
                            if (!(t = n._inverseTransform(t)) || !this._children && !this.getBounds({
                                internal: !0,
                                stroke: !0,
                                handle: !0
                            }).expand(a.multiply(2))._containsPoint(t)) return null;
                            var o, h, l = !(e.guides && !this._guide || e.selected && !this.isSelected() || e.type && e.type !== u.hyphenate(this._class) || e.class && !(this instanceof e.class)), c = e.match, d = this;
                            function p(t) {
                                return t && c && !c(t) && (t = null), t && e.all && e.all.push(t), t;
                            }
                            function f(e, i) {
                                var n = i ? o["get" + i]() : d.getPosition();
                                if (t.subtract(n).divide(a).length <= 1) return new O(e, d, {
                                    name: i ? u.hyphenate(i) : e,
                                    point: n
                                });
                            }
                            var g = e.position, v = e.center, _ = e.bounds;
                            if (l && this._parent && (g || v || _)) {
                                if ((v || _) && (o = this.getInternalBounds()), !(h = g && f("position") || v && f("center", "Center")) && _) for(var m = [
                                    "TopLeft",
                                    "TopRight",
                                    "BottomLeft",
                                    "BottomRight",
                                    "LeftCenter",
                                    "TopCenter",
                                    "RightCenter",
                                    "BottomCenter"
                                ], y = 0; y < 8 && !h; y++)h = f("bounds", m[y]);
                                h = p(h);
                            }
                            return h || (h = this._hitTestChildren(t, e, r) || l && p(this._hitTestSelf(t, e, r, this.getStrokeScaling() ? null : r._shiftless().invert())) || null), h && h.point && (h.point = n.transform(h.point)), h;
                        },
                        _hitTestSelf: function(t, e) {
                            if (e.fill && this.hasFill() && this._contains(t)) return new O("fill", this);
                        },
                        matches: function(t, e) {
                            var i = typeof t;
                            if ("object" === i) {
                                for(var n in t)if (t.hasOwnProperty(n) && !this.matches(n, t[n])) return !1;
                                return !0;
                            }
                            if ("function" === i) return t(this);
                            if ("match" === t) return e(this);
                            var r = /^(empty|editable)$/.test(t) ? this["is" + u.capitalize(t)]() : "type" === t ? u.hyphenate(this._class) : this[t];
                            if ("class" === t) {
                                if ("function" == typeof e) return this instanceof e;
                                r = this._class;
                            }
                            if ("function" == typeof e) return !!e(r);
                            if (e) {
                                if (e.test) return e.test(r);
                                else if (u.isPlainObject(e)) return function t(e, i) {
                                    for(var n in e)if (e.hasOwnProperty(n)) {
                                        var r = e[n], s = i[n];
                                        if (u.isPlainObject(r) && u.isPlainObject(s)) {
                                            if (!t(r, s)) return !1;
                                        } else if (!u.equals(r, s)) return !1;
                                    }
                                    return !0;
                                }(e, r);
                            }
                            return u.equals(r, e);
                        },
                        getItems: function(t) {
                            return A._getItems(this, t, this._matrix);
                        },
                        getItem: function(t) {
                            return A._getItems(this, t, this._matrix, null, !0)[0] || null;
                        },
                        statics: {
                            _getItems: function t(e, i, n, r, s) {
                                if (!r) {
                                    var a = "object" == typeof i && i, o = a && a.overlapping, h = a && a.inside, l = o || h, c = l && w.read([
                                        l
                                    ]);
                                    r = {
                                        items: [],
                                        recursive: a && !1 !== a.recursive,
                                        inside: !!h,
                                        overlapping: !!o,
                                        rect: c,
                                        path: o && new D.Rectangle({
                                            rectangle: c,
                                            insert: !1
                                        })
                                    }, a && (i = u.filter({}, i, {
                                        recursive: !0,
                                        inside: !0,
                                        overlapping: !0
                                    }));
                                }
                                var d = e._children, p = r.items, c = r.rect;
                                n = c && (n || new S);
                                for(var f = 0, g = d && d.length; f < g; f++){
                                    var v = d[f], _ = n && n.appended(v._matrix), m = !0;
                                    if (c) {
                                        var l = v.getBounds(_);
                                        if (!c.intersects(l)) continue;
                                        c.contains(l) || r.overlapping && (l.contains(c) || r.path.intersects(v, _)) || (m = !1);
                                    }
                                    if (m && v.matches(i) && (p.push(v), s) || (!1 !== r.recursive && t(v, i, _, r, s), s && p.length > 0)) break;
                                }
                                return p;
                            }
                        }
                    }, {
                        importJSON: function(t) {
                            var e = u.importJSON(t, this);
                            return e !== this ? this.addChild(e) : e;
                        },
                        addChild: function(t) {
                            return this.insertChild(o, t);
                        },
                        insertChild: function(t, e) {
                            var i = e ? this.insertChildren(t, [
                                e
                            ]) : null;
                            return i && i[0];
                        },
                        addChildren: function(t) {
                            return this.insertChildren(this._children.length, t);
                        },
                        insertChildren: function(t, e) {
                            var i = this._children;
                            if (i && e && e.length > 0) {
                                e = u.slice(e);
                                for(var n = {}, r = e.length - 1; r >= 0; r--){
                                    var s = e[r], a = s && s._id;
                                    !s || n[a] ? e.splice(r, 1) : (s._remove(!1, !0), n[a] = !0);
                                }
                                u.splice(i, e, t, 0);
                                for(var o = this._project, h = o._changes, r = 0, l = e.length; r < l; r++){
                                    var s = e[r], c = s._name;
                                    s._parent = this, s._setProject(o, !0), c && s.setName(c), h && s._changed(5);
                                }
                                this._changed(11);
                            } else e = null;
                            return e;
                        },
                        _insertItem: "#insertChild",
                        _insertAt: function(t, e) {
                            var i = t && t._getOwner(), n = t !== this && i ? this : null;
                            return n && (n._remove(!1, !0), i._insertItem(t._index + e, n)), n;
                        },
                        insertAbove: function(t) {
                            return this._insertAt(t, 1);
                        },
                        insertBelow: function(t) {
                            return this._insertAt(t, 0);
                        },
                        sendToBack: function() {
                            var t = this._getOwner();
                            return t ? t._insertItem(0, this) : null;
                        },
                        bringToFront: function() {
                            var t = this._getOwner();
                            return t ? t._insertItem(o, this) : null;
                        },
                        appendTop: "#addChild",
                        appendBottom: function(t) {
                            return this.insertChild(0, t);
                        },
                        moveAbove: "#insertAbove",
                        moveBelow: "#insertBelow",
                        addTo: function(t) {
                            return t._insertItem(o, this);
                        },
                        copyTo: function(t) {
                            return this.clone(!1).addTo(t);
                        },
                        reduce: function(t) {
                            var e = this._children;
                            if (e && 1 === e.length) {
                                var i = e[0].reduce(t);
                                return this._parent ? (i.insertAbove(this), this.remove()) : i.remove(), i;
                            }
                            return this;
                        },
                        _removeNamed: function() {
                            var t = this._getOwner();
                            if (t) {
                                var e = t._children, i = t._namedChildren, n = this._name, r = i[n], s = r ? r.indexOf(this) : -1;
                                -1 !== s && (e[n] == this && delete e[n], r.splice(s, 1), r.length ? e[n] = r[0] : delete i[n]);
                            }
                        },
                        _remove: function(t, e) {
                            var i = this._getOwner(), n = this._project, r = this._index;
                            return this._style && this._style._dispose(), !!i && (this._name && this._removeNamed(), null != r && (n._activeLayer === this && (n._activeLayer = this.getNextSibling() || this.getPreviousSibling()), u.splice(i._children, null, r, 1)), this._installEvents(!1), t && n._changes && this._changed(5), e && i._changed(11, this), this._parent = null, !0);
                        },
                        remove: function() {
                            return this._remove(!0, !0);
                        },
                        replaceWith: function(t) {
                            var e = t && t.insertBelow(this);
                            return e && this.remove(), e;
                        },
                        removeChildren: function(t, e) {
                            if (!this._children) return null;
                            t = t || 0, e = u.pick(e, this._children.length);
                            for(var i = u.splice(this._children, null, t, e - t), n = i.length - 1; n >= 0; n--)i[n]._remove(!0, !1);
                            return i.length > 0 && this._changed(11), i;
                        },
                        clear: "#removeChildren",
                        reverseChildren: function() {
                            if (this._children) {
                                this._children.reverse();
                                for(var t = 0, e = this._children.length; t < e; t++)this._children[t]._index = t;
                                this._changed(11);
                            }
                        },
                        isEmpty: function(t) {
                            var e = this._children, i = e ? e.length : 0;
                            if (t) {
                                for(var n = 0; n < i; n++)if (!e[n].isEmpty(t)) return !1;
                                return !0;
                            }
                            return !i;
                        },
                        isEditable: function() {
                            for(var t = this; t;){
                                if (!t._visible || t._locked) return !1;
                                t = t._parent;
                            }
                            return !0;
                        },
                        hasFill: function() {
                            return this.getStyle().hasFill();
                        },
                        hasStroke: function() {
                            return this.getStyle().hasStroke();
                        },
                        hasShadow: function() {
                            return this.getStyle().hasShadow();
                        },
                        _getOrder: function(t) {
                            function e(t) {
                                var e = [];
                                do e.unshift(t);
                                while (t = t._parent);
                                return e;
                            }
                            for(var i = e(this), n = e(t), r = 0, s = Math.min(i.length, n.length); r < s; r++)if (i[r] != n[r]) return i[r]._index < n[r]._index ? 1 : -1;
                            return 0;
                        },
                        hasChildren: function() {
                            return this._children && this._children.length > 0;
                        },
                        isInserted: function() {
                            return !!this._parent && this._parent.isInserted();
                        },
                        isAbove: function(t) {
                            return -1 === this._getOrder(t);
                        },
                        isBelow: function(t) {
                            return 1 === this._getOrder(t);
                        },
                        isParent: function(t) {
                            return this._parent === t;
                        },
                        isChild: function(t) {
                            return t && t._parent === this;
                        },
                        isDescendant: function(t) {
                            for(var e = this; e = e._parent;)if (e === t) return !0;
                            return !1;
                        },
                        isAncestor: function(t) {
                            return !!t && t.isDescendant(this);
                        },
                        isSibling: function(t) {
                            return this._parent === t._parent;
                        },
                        isGroupedWith: function(t) {
                            for(var e = this._parent; e;){
                                if (e._parent && /^(Group|Layer|CompoundPath)$/.test(e._class) && t.isDescendant(e)) return !0;
                                e = e._parent;
                            }
                            return !1;
                        }
                    }, u.each([
                        "rotate",
                        "scale",
                        "shear",
                        "skew"
                    ], function(t) {
                        var e = "rotate" === t;
                        this[t] = function() {
                            var i = arguments, n = (e ? u : m).read(i), r = m.read(i, 0, {
                                readNull: !0
                            });
                            return this.transform(new S()[t](n, r || this.getPosition(!0)));
                        };
                    }, {
                        translate: function() {
                            var t = new S;
                            return this.transform(t.translate.apply(t, arguments));
                        },
                        transform: function(t, e, i) {
                            var n = this._matrix, r = t && !t.isIdentity(), s = i && this._canApplyMatrix || this._applyMatrix && (r || !n.isIdentity() || e && this._children);
                            if (!r && !s) return this;
                            if (r) {
                                !t.isInvertible() && n.isInvertible() && (n._backup = n.getValues()), n.prepend(t, !0);
                                var a = this._style, o = a.getFillColor(!0), h = a.getStrokeColor(!0);
                                o && o.transform(t), h && h.transform(t);
                            }
                            if (s && (s = this._transformContent(n, e, i))) {
                                var l = this._pivot;
                                l && n._transformPoint(l, l, !0), n.reset(!0), i && this._canApplyMatrix && (this._applyMatrix = !0);
                            }
                            var u = this._bounds, c = this._position;
                            (r || s) && this._changed(25);
                            var d = r && u && t.decompose();
                            if (d && d.skewing.isZero() && d.rotation % 90 == 0) {
                                for(var p in u){
                                    var f = u[p];
                                    if (f.nonscaling) delete u[p];
                                    else if (s || !f.internal) {
                                        var g = f.rect;
                                        t._transformBounds(g, g);
                                    }
                                }
                                this._bounds = u;
                                var v = u[this._getBoundsCacheKey(this._boundsOptions || {})];
                                v && (this._position = this._getPositionFromBounds(v.rect));
                            } else r && c && this._pivot && (this._position = t._transformPoint(c, c));
                            return this;
                        },
                        _transformContent: function(t, e, i) {
                            var n = this._children;
                            if (n) {
                                for(var r = 0, s = n.length; r < s; r++)n[r].transform(t, e, i);
                                return !0;
                            }
                        },
                        globalToLocal: function() {
                            return this.getGlobalMatrix(!0)._inverseTransform(m.read(arguments));
                        },
                        localToGlobal: function() {
                            return this.getGlobalMatrix(!0)._transformPoint(m.read(arguments));
                        },
                        parentToLocal: function() {
                            return this._matrix._inverseTransform(m.read(arguments));
                        },
                        localToParent: function() {
                            return this._matrix._transformPoint(m.read(arguments));
                        },
                        fitBounds: function(t, e) {
                            t = w.read(arguments);
                            var i = this.getBounds(), n = i.height / i.width, r = t.height / t.width, s = (e ? n > r : n < r) ? t.width / i.width : t.height / i.height, a = new w(new m, new b(i.width * s, i.height * s));
                            a.setCenter(t.getCenter()), this.setBounds(a);
                        }
                    }), {
                        _setStyles: function(t, e, i) {
                            var n = this._style, r = this._matrix;
                            if (n.hasFill() && (t.fillStyle = n.getFillColor().toCanvasStyle(t, r)), n.hasStroke()) {
                                t.strokeStyle = n.getStrokeColor().toCanvasStyle(t, r), t.lineWidth = n.getStrokeWidth();
                                var s = n.getStrokeJoin(), a = n.getStrokeCap(), o = n.getMiterLimit();
                                if (s && (t.lineJoin = s), a && (t.lineCap = a), o && (t.miterLimit = o), td.support.nativeDash) {
                                    var h = n.getDashArray(), l = n.getDashOffset();
                                    h && h.length && ("setLineDash" in t ? (t.setLineDash(h), t.lineDashOffset = l) : (t.mozDash = h, t.mozDashOffset = l));
                                }
                            }
                            if (n.hasShadow()) {
                                var u = e.pixelRatio || 1, c = i._shiftless().prepend(new S().scale(u, u)), d = c.transform(new m(n.getShadowBlur(), 0)), p = c.transform(this.getShadowOffset());
                                t.shadowColor = n.getShadowColor().toCanvasStyle(t), t.shadowBlur = d.getLength(), t.shadowOffsetX = p.x, t.shadowOffsetY = p.y;
                            }
                        },
                        draw: function(t, e, i) {
                            if (this._updateVersion = this._project._updateVersion, this._visible && 0 !== this._opacity) {
                                var n = e.matrices, r = e.viewMatrix, s = this._matrix, a = n[n.length - 1].appended(s);
                                if (a.isInvertible()) {
                                    r = r ? r.appended(a) : a, n.push(a), e.updateMatrix && (this._globalMatrix = a);
                                    var o, h, l, u = this._blendMode, c = v.clamp(this._opacity, 0, 1), d = "normal" === u, p = tl.nativeModes[u], f = d && 1 === c || e.dontStart || e.clip || (p || d && c < 1) && this._canComposite(), g = e.pixelRatio || 1;
                                    if (!f) {
                                        var _ = this.getStrokeBounds(r);
                                        if (!_.width || !_.height) return void n.pop();
                                        l = e.offset, h = e.offset = _.getTopLeft().floor(), o = t, t = th.getContext(_.getSize().ceil().add(1).multiply(g)), 1 !== g && t.scale(g, g);
                                    }
                                    t.save();
                                    var m = i ? i.appended(s) : this._canScaleStroke && !this.getStrokeScaling(!0) && r, y = !f && e.clipItem, b = !m || y;
                                    if (f ? (t.globalAlpha = c, p && (t.globalCompositeOperation = u)) : b && t.translate(-h.x, -h.y), b && (f ? s : r).applyToContext(t), y && e.clipItem.draw(t, e.extend({
                                        clip: !0
                                    })), m) {
                                        t.setTransform(g, 0, 0, g, 0, 0);
                                        var x = e.offset;
                                        x && t.translate(-x.x, -x.y);
                                    }
                                    this._draw(t, e, r, m), t.restore(), n.pop(), e.clip && !e.dontFinish && t.clip(this.getFillRule()), f || (tl.process(u, t, o, c, h.subtract(l).multiply(g)), th.release(t), e.offset = l);
                                }
                            }
                        },
                        _isUpdated: function(t) {
                            var e = this._parent;
                            if (e instanceof j) return e._isUpdated(t);
                            var i = this._updateVersion === t;
                            return !i && e && e._visible && e._isUpdated(t) && (this._updateVersion = t, i = !0), i;
                        },
                        _drawSelection: function(t, e, i, n, r) {
                            var s = this._selection, a = 1 & s, o = 2 & s || a && this._selectBounds, h = 4 & s;
                            if (this._drawSelected || (a = !1), (a || o || h) && this._isUpdated(r)) {
                                var l, u = this.getSelectedColor(!0) || (l = this.getLayer()) && l.getSelectedColor(!0), c = e.appended(this.getGlobalMatrix(!0)), d = i / 2;
                                if (t.strokeStyle = t.fillStyle = u ? u.toCanvasStyle(t) : "#009dec", a && this._drawSelected(t, c, n), h) {
                                    var p = this.getPosition(!0), f = this._parent, g = f ? f.localToGlobal(p) : p, v = g.x, _ = g.y;
                                    t.beginPath(), t.arc(v, _, d, 0, 2 * Math.PI, !0), t.stroke();
                                    for(var m = [
                                        [
                                            0,
                                            -1
                                        ],
                                        [
                                            1,
                                            0
                                        ],
                                        [
                                            0,
                                            1
                                        ],
                                        [
                                            -1,
                                            0
                                        ]
                                    ], y = i + 1, b = 0; b < 4; b++){
                                        var x = m[b], w = x[0], C = x[1];
                                        t.moveTo(v + w * d, _ + C * d), t.lineTo(v + w * y, _ + C * y), t.stroke();
                                    }
                                }
                                if (o) {
                                    var S = c._transformCorners(this.getInternalBounds());
                                    t.beginPath();
                                    for(var b = 0; b < 8; b++)t[!b ? "moveTo" : "lineTo"](S[b], S[++b]);
                                    t.closePath(), t.stroke();
                                    for(var b = 0; b < 8; b++)t.fillRect(S[b] - d, S[++b] - d, i, i);
                                }
                            }
                        },
                        _canComposite: function() {
                            return !1;
                        }
                    }, u.each([
                        "down",
                        "drag",
                        "up",
                        "move"
                    ], function(t) {
                        this["removeOn" + u.capitalize(t)] = function() {
                            var e = {};
                            return e[t] = !0, this.removeOn(e);
                        };
                    }, {
                        removeOn: function(t) {
                            for(var e in t)if (t[e]) {
                                var i = "mouse" + e, n = this._project, r = n._removeSets = n._removeSets || {};
                                r[i] = r[i] || {}, r[i][this._id] = this;
                            }
                            return this;
                        }
                    }), {
                        tween: function(t, e, i) {
                            !i && (i = e, e = t, t = null, i || (i = e, e = null));
                            var n = i && i.easing, r = i && i.start, s = null != i && ("number" == typeof i ? i : i.duration), a = new ta(this, t, e, s, n, r);
                            return s && this.on("frame", function t(e) {
                                a._handleFrame(1e3 * e.time), a.running || this.off("frame", t);
                            }), a;
                        },
                        tweenTo: function(t, e) {
                            return this.tween(null, t, e);
                        },
                        tweenFrom: function(t, e) {
                            return this.tween(t, null, e);
                        }
                    }), I = A.extend({
                        _class: "Group",
                        _selectBounds: !1,
                        _selectChildren: !0,
                        _serializeFields: {
                            children: []
                        },
                        initialize: function(t) {
                            this._children = [], this._namedChildren = {}, this._initialize(t) || this.addChildren(Array.isArray(t) ? t : arguments);
                        },
                        _changed: function t(e) {
                            t.base.call(this, e), 2050 & e && (this._clipItem = o);
                        },
                        _getClipItem: function() {
                            var t = this._clipItem;
                            if (t === o) {
                                t = null;
                                for(var e = this._children, i = 0, n = e.length; i < n; i++)if (e[i]._clipMask) {
                                    t = e[i];
                                    break;
                                }
                                this._clipItem = t;
                            }
                            return t;
                        },
                        isClipped: function() {
                            return !!this._getClipItem();
                        },
                        setClipped: function(t) {
                            var e = this.getFirstChild();
                            e && e.setClipMask(t);
                        },
                        _getBounds: function t(e, i) {
                            var n = this._getClipItem();
                            return n ? n._getCachedBounds(n._matrix.prepended(e), u.set({}, i, {
                                stroke: !1
                            })) : t.base.call(this, e, i);
                        },
                        _hitTestChildren: function t(e, i, n) {
                            var r = this._getClipItem();
                            return (!r || r.contains(e)) && t.base.call(this, e, i, n, r);
                        },
                        _draw: function(t, e) {
                            var i = e.clip, n = !i && this._getClipItem();
                            e = e.extend({
                                clipItem: n,
                                clip: !1
                            }), i ? (t.beginPath(), e.dontStart = e.dontFinish = !0) : n && n.draw(t, e.extend({
                                clip: !0
                            }));
                            for(var r = this._children, s = 0, a = r.length; s < a; s++){
                                var o = r[s];
                                o !== n && o.draw(t, e);
                            }
                        }
                    }), T = I.extend({
                        _class: "Layer",
                        initialize: function() {
                            I.apply(this, arguments);
                        },
                        _getOwner: function() {
                            return this._parent || null != this._index && this._project;
                        },
                        isInserted: function t() {
                            return this._parent ? t.base.call(this) : null != this._index;
                        },
                        activate: function() {
                            this._project._activeLayer = this;
                        },
                        _hitTestSelf: function() {}
                    }), E = A.extend({
                        _class: "Shape",
                        _applyMatrix: !1,
                        _canApplyMatrix: !1,
                        _canScaleStroke: !0,
                        _serializeFields: {
                            type: null,
                            size: null,
                            radius: null
                        },
                        initialize: function(t, e) {
                            this._initialize(t, e);
                        },
                        _equals: function(t) {
                            return this._type === t._type && this._size.equals(t._size) && u.equals(this._radius, t._radius);
                        },
                        copyContent: function(t) {
                            this.setType(t._type), this.setSize(t._size), this.setRadius(t._radius);
                        },
                        getType: function() {
                            return this._type;
                        },
                        setType: function(t) {
                            this._type = t;
                        },
                        getShape: "#getType",
                        setShape: "#setType",
                        getSize: function() {
                            var t = this._size;
                            return new x(t.width, t.height, this, "setSize");
                        },
                        setSize: function() {
                            var t = b.read(arguments);
                            if (this._size) {
                                if (!this._size.equals(t)) {
                                    var e = this._type, i = t.width, n = t.height;
                                    "rectangle" === e ? this._radius.set(b.min(this._radius, t.divide(2).abs())) : "circle" === e ? (i = n = (i + n) / 2, this._radius = i / 2) : "ellipse" === e && this._radius._set(i / 2, n / 2), this._size._set(i, n), this._changed(9);
                                }
                            } else this._size = t.clone();
                        },
                        getRadius: function() {
                            var t = this._radius;
                            return "circle" === this._type ? t : new x(t.width, t.height, this, "setRadius");
                        },
                        setRadius: function(t) {
                            var e = this._type;
                            if ("circle" === e) {
                                if (t === this._radius) return;
                                var i = 2 * t;
                                this._radius = t, this._size._set(i, i);
                            } else if (t = b.read(arguments), this._radius) {
                                if (this._radius.equals(t)) return;
                                if (this._radius.set(t), "rectangle" === e) {
                                    var i = b.max(this._size, t.multiply(2));
                                    this._size.set(i);
                                } else "ellipse" === e && this._size._set(2 * t.width, 2 * t.height);
                            } else this._radius = t.clone();
                            this._changed(9);
                        },
                        isEmpty: function() {
                            return !1;
                        },
                        toPath: function(t) {
                            var e = new D[u.capitalize(this._type)]({
                                center: new m,
                                size: this._size,
                                radius: this._radius,
                                insert: !1
                            });
                            return e.copyAttributes(this), td.settings.applyMatrix && e.setApplyMatrix(!0), (t === o || t) && e.insertAbove(this), e;
                        },
                        toShape: "#clone",
                        _asPathItem: function() {
                            return this.toPath(!1);
                        },
                        _draw: function(t, e, i, n) {
                            var r = this._style, s = r.hasFill(), a = r.hasStroke(), o = e.dontFinish || e.clip, h = !n;
                            if (s || a || o) {
                                var l = this._type, u = this._radius, c = "circle" === l;
                                if (e.dontStart || t.beginPath(), h && c) t.arc(0, 0, u, 0, 2 * Math.PI, !0);
                                else {
                                    var d = c ? u : u.width, p = c ? u : u.height, f = this._size, g = f.width, v = f.height;
                                    if (h && "rectangle" === l && 0 === d && 0 === p) t.rect(-g / 2, -v / 2, g, v);
                                    else {
                                        var _ = g / 2, m = v / 2, y = .44771525016920644 * d, b = .44771525016920644 * p, x = [
                                            -_,
                                            -m + p,
                                            -_,
                                            -m + b,
                                            -_ + y,
                                            -m,
                                            -_ + d,
                                            -m,
                                            _ - d,
                                            -m,
                                            _ - y,
                                            -m,
                                            _,
                                            -m + b,
                                            _,
                                            -m + p,
                                            _,
                                            m - p,
                                            _,
                                            m - b,
                                            _ - y,
                                            m,
                                            _ - d,
                                            m,
                                            -_ + d,
                                            m,
                                            -_ + y,
                                            m,
                                            -_,
                                            m - b,
                                            -_,
                                            m - p
                                        ];
                                        n && n.transform(x, x, 32), t.moveTo(x[0], x[1]), t.bezierCurveTo(x[2], x[3], x[4], x[5], x[6], x[7]), _ !== d && t.lineTo(x[8], x[9]), t.bezierCurveTo(x[10], x[11], x[12], x[13], x[14], x[15]), m !== p && t.lineTo(x[16], x[17]), t.bezierCurveTo(x[18], x[19], x[20], x[21], x[22], x[23]), _ !== d && t.lineTo(x[24], x[25]), t.bezierCurveTo(x[26], x[27], x[28], x[29], x[30], x[31]);
                                    }
                                }
                                t.closePath();
                            }
                            !o && (s || a) && (this._setStyles(t, e, i), s && (t.fill(r.getFillRule()), t.shadowColor = "rgba(0,0,0,0)"), a && t.stroke());
                        },
                        _canComposite: function() {
                            return !(this.hasFill() && this.hasStroke());
                        },
                        _getBounds: function(t, e) {
                            var i = new w(this._size).setCenter(0, 0), n = this._style, r = e.stroke && n.hasStroke() && n.getStrokeWidth();
                            return t && (i = t._transformBounds(i)), r ? i.expand(D._getStrokePadding(r, this._getStrokeMatrix(t, e))) : i;
                        }
                    }, new function() {
                        function t(t, e, i) {
                            var n = t._radius;
                            if (!n.isZero()) for(var r = t._size.divide(2), s = 1; s <= 4; s++){
                                var a = new m(s > 1 && s < 4 ? -1 : 1, s > 2 ? -1 : 1), o = a.multiply(r), h = o.subtract(a.multiply(n));
                                if (new w(i ? o.add(a.multiply(i)) : o, h).contains(e)) return {
                                    point: h,
                                    quadrant: s
                                };
                            }
                        }
                        function e(t, e, i, n) {
                            var r = t.divide(e);
                            return (!n || r.isInQuadrant(n)) && r.subtract(r.normalize()).multiply(e).divide(i).length <= 1;
                        }
                        return {
                            _contains: function e(i) {
                                if ("rectangle" !== this._type) return .5 >= i.divide(this.size).getLength();
                                var n = t(this, i);
                                return n ? 1 >= i.subtract(n.point).divide(this._radius).getLength() : e.base.call(this, i);
                            },
                            _hitTestSelf: function i(n, r, s, a) {
                                var o = !1, h = this._style, l = r.stroke && h.hasStroke(), u = r.fill && h.hasFill();
                                if (l || u) {
                                    var c = this._type, d = this._radius, p = l ? h.getStrokeWidth() / 2 : 0, f = r._tolerancePadding.add(D._getStrokePadding(p, !h.getStrokeScaling() && a));
                                    if ("rectangle" === c) {
                                        var g = f.multiply(2), v = t(this, n, g);
                                        if (v) o = e(n.subtract(v.point), d, f, v.quadrant);
                                        else {
                                            var _ = new w(this._size).setCenter(0, 0), m = _.expand(g), y = _.expand(g.negate());
                                            o = m._containsPoint(n) && !y._containsPoint(n);
                                        }
                                    } else o = e(n, d, f);
                                }
                                return o ? new O(l ? "stroke" : "fill", this) : i.base.apply(this, arguments);
                            }
                        };
                    }, {
                        statics: new function() {
                            function t(t, e, i, n, r) {
                                var s = u.create(E.prototype);
                                return s._type = t, s._size = i, s._radius = n, s._initialize(u.getNamed(r), e), s;
                            }
                            return {
                                Circle: function() {
                                    var e = arguments, i = m.readNamed(e, "center"), n = u.readNamed(e, "radius");
                                    return t("circle", i, new b(2 * n), n, e);
                                },
                                Rectangle: function() {
                                    var e = arguments, i = w.readNamed(e, "rectangle"), n = b.min(b.readNamed(e, "radius"), i.getSize(!0).divide(2));
                                    return t("rectangle", i.getCenter(!0), i.getSize(!0), n, e);
                                },
                                Ellipse: function() {
                                    var e = arguments, i = E._readEllipse(e), n = i.radius;
                                    return t("ellipse", i.center, n.multiply(2), n, e);
                                },
                                _readEllipse: function(t) {
                                    var e, i;
                                    if (u.hasNamed(t, "radius")) e = m.readNamed(t, "center"), i = b.readNamed(t, "radius");
                                    else {
                                        var n = w.readNamed(t, "rectangle");
                                        e = n.getCenter(!0), i = n.getSize(!0).divide(2);
                                    }
                                    return {
                                        center: e,
                                        radius: i
                                    };
                                }
                            };
                        }
                    }), L = A.extend({
                        _class: "Raster",
                        _applyMatrix: !1,
                        _canApplyMatrix: !1,
                        _boundsOptions: {
                            stroke: !1,
                            handle: !1
                        },
                        _serializeFields: {
                            crossOrigin: null,
                            source: null
                        },
                        _prioritize: [
                            "crossOrigin"
                        ],
                        _smoothing: !0,
                        beans: !0,
                        initialize: function(t, e) {
                            if (!this._initialize(t, e !== o && m.read(arguments))) {
                                var i, n = typeof t, r = "string" === n ? l.getElementById(t) : "object" === n ? t : null;
                                if (r && r !== A.NO_INSERT) {
                                    if (r.getContext || null != r.naturalHeight) i = r;
                                    else if (r) {
                                        var s = b.read(arguments);
                                        s.isZero() || (i = th.getCanvas(s));
                                    }
                                }
                                i ? this.setImage(i) : this.setSource(t);
                            }
                            this._size || (this._size = new b, this._loaded = !1);
                        },
                        _equals: function(t) {
                            return this.getSource() === t.getSource();
                        },
                        copyContent: function(t) {
                            var e = t._image, i = t._canvas;
                            if (e) this._setImage(e);
                            else if (i) {
                                var n = th.getCanvas(t._size);
                                n.getContext("2d").drawImage(i, 0, 0), this._setImage(n);
                            }
                            this._crossOrigin = t._crossOrigin;
                        },
                        getSize: function() {
                            var t = this._size;
                            return new x(t ? t.width : 0, t ? t.height : 0, this, "setSize");
                        },
                        setSize: function() {
                            var t = b.read(arguments);
                            if (!t.equals(this._size)) {
                                if (t.width > 0 && t.height > 0) {
                                    var e = this.getElement();
                                    this._setImage(th.getCanvas(t)), e && this.getContext(!0).drawImage(e, 0, 0, t.width, t.height);
                                } else this._canvas && th.release(this._canvas), this._size = t.clone();
                            }
                        },
                        getWidth: function() {
                            return this._size ? this._size.width : 0;
                        },
                        setWidth: function(t) {
                            this.setSize(t, this.getHeight());
                        },
                        getHeight: function() {
                            return this._size ? this._size.height : 0;
                        },
                        setHeight: function(t) {
                            this.setSize(this.getWidth(), t);
                        },
                        getLoaded: function() {
                            return this._loaded;
                        },
                        isEmpty: function() {
                            var t = this._size;
                            return !t || 0 === t.width && 0 === t.height;
                        },
                        getResolution: function() {
                            var t = this._matrix, e = new m(0, 0).transform(t), i = new m(1, 0).transform(t).subtract(e), n = new m(0, 1).transform(t).subtract(e);
                            return new b(72 / i.getLength(), 72 / n.getLength());
                        },
                        getPpi: "#getResolution",
                        getImage: function() {
                            return this._image;
                        },
                        setImage: function(t) {
                            var e = this;
                            function i(t) {
                                var i = e.getView(), n = t && t.type || "load";
                                i && e.responds(n) && (td = i._scope, e.emit(n, new tt(t)));
                            }
                            this._setImage(t), this._loaded ? setTimeout(i, 0) : t && Y.add(t, {
                                load: function(n) {
                                    e._setImage(t), i(n);
                                },
                                error: i
                            });
                        },
                        _setImage: function(t) {
                            this._canvas && th.release(this._canvas), t && t.getContext ? (this._image = null, this._canvas = t, this._loaded = !0) : (this._image = t, this._canvas = null, this._loaded = !!(t && t.src && t.complete)), this._size = new b(t ? t.naturalWidth || t.width : 0, t ? t.naturalHeight || t.height : 0), this._context = null, this._changed(1033);
                        },
                        getCanvas: function() {
                            if (!this._canvas) {
                                var t = th.getContext(this._size);
                                try {
                                    this._image && t.drawImage(this._image, 0, 0), this._canvas = t.canvas;
                                } catch (e) {
                                    th.release(t);
                                }
                            }
                            return this._canvas;
                        },
                        setCanvas: "#setImage",
                        getContext: function(t) {
                            return this._context || (this._context = this.getCanvas().getContext("2d")), t && (this._image = null, this._changed(1025)), this._context;
                        },
                        setContext: function(t) {
                            this._context = t;
                        },
                        getSource: function() {
                            var t = this._image;
                            return t && t.src || this.toDataURL();
                        },
                        setSource: function(t) {
                            var e = new a.Image, i = this._crossOrigin;
                            i && (e.crossOrigin = i), t && (e.src = t), this.setImage(e);
                        },
                        getCrossOrigin: function() {
                            var t = this._image;
                            return t && t.crossOrigin || this._crossOrigin || "";
                        },
                        setCrossOrigin: function(t) {
                            this._crossOrigin = t;
                            var e = this._image;
                            e && (e.crossOrigin = t);
                        },
                        getSmoothing: function() {
                            return this._smoothing;
                        },
                        setSmoothing: function(t) {
                            this._smoothing = t, this._changed(257);
                        },
                        getElement: function() {
                            return this._canvas || this._loaded && this._image;
                        }
                    }, {
                        beans: !1,
                        getSubCanvas: function() {
                            var t = w.read(arguments), e = th.getContext(t.getSize());
                            return e.drawImage(this.getCanvas(), t.x, t.y, t.width, t.height, 0, 0, t.width, t.height), e.canvas;
                        },
                        getSubRaster: function() {
                            var t = w.read(arguments), e = new L(A.NO_INSERT);
                            return e._setImage(this.getSubCanvas(t)), e.translate(t.getCenter().subtract(this.getSize().divide(2))), e._matrix.prepend(this._matrix), e.insertAbove(this), e;
                        },
                        toDataURL: function() {
                            var t = this._image, e = t && t.src;
                            if (/^data:/.test(e)) return e;
                            var i = this.getCanvas();
                            return i ? i.toDataURL.apply(i, arguments) : null;
                        },
                        drawImage: function(t) {
                            var e = m.read(arguments, 1);
                            this.getContext(!0).drawImage(t, e.x, e.y);
                        },
                        getAverageColor: function(t) {
                            if (t ? t instanceof F ? (i = t, e = t.getBounds()) : "object" == typeof t && ("width" in t ? e = new w(t) : "x" in t && (e = new w(t.x - .5, t.y - .5, 1, 1))) : e = this.getBounds(), !e) return null;
                            var e, i, n = Math.min(e.width, 32), r = Math.min(e.height, 32), s = L._sampleContext;
                            s ? s.clearRect(0, 0, 33, 33) : s = L._sampleContext = th.getContext(new b(32)), s.save();
                            var a = new S().scale(n / e.width, r / e.height).translate(-e.x, -e.y);
                            a.applyToContext(s), i && i.draw(s, new u({
                                clip: !0,
                                matrices: [
                                    a
                                ]
                            })), this._matrix.applyToContext(s);
                            var o = this.getElement(), h = this._size;
                            o && s.drawImage(o, -h.width / 2, -h.height / 2), s.restore();
                            for(var l = s.getImageData(.5, .5, Math.ceil(n), Math.ceil(r)).data, c = [
                                0,
                                0,
                                0
                            ], d = 0, p = 0, f = l.length; p < f; p += 4){
                                var g = l[p + 3];
                                d += g, g /= 255, c[0] += l[p] * g, c[1] += l[p + 1] * g, c[2] += l[p + 2] * g;
                            }
                            for(var p = 0; p < 3; p++)c[p] /= d;
                            return d ? G.read(c) : null;
                        },
                        getPixel: function() {
                            var t = m.read(arguments), e = this.getContext().getImageData(t.x, t.y, 1, 1).data;
                            return new G("rgb", [
                                e[0] / 255,
                                e[1] / 255,
                                e[2] / 255
                            ], e[3] / 255);
                        },
                        setPixel: function() {
                            var t = arguments, e = m.read(t), i = G.read(t), n = i._convert("rgb"), r = i._alpha, s = this.getContext(!0), a = s.createImageData(1, 1), o = a.data;
                            o[0] = 255 * n[0], o[1] = 255 * n[1], o[2] = 255 * n[2], o[3] = null != r ? 255 * r : 255, s.putImageData(a, e.x, e.y);
                        },
                        clear: function() {
                            var t = this._size;
                            this.getContext(!0).clearRect(0, 0, t.width + 1, t.height + 1);
                        },
                        createImageData: function() {
                            var t = b.read(arguments);
                            return this.getContext().createImageData(t.width, t.height);
                        },
                        getImageData: function() {
                            var t = w.read(arguments);
                            return t.isEmpty() && (t = new w(this._size)), this.getContext().getImageData(t.x, t.y, t.width, t.height);
                        },
                        setImageData: function(t) {
                            var e = m.read(arguments, 1);
                            this.getContext(!0).putImageData(t, e.x, e.y);
                        },
                        _getBounds: function(t, e) {
                            var i = new w(this._size).setCenter(0, 0);
                            return t ? t._transformBounds(i) : i;
                        },
                        _hitTestSelf: function(t) {
                            if (this._contains(t)) {
                                var e = this;
                                return new O("pixel", e, {
                                    offset: t.add(e._size.divide(2)).round(),
                                    color: {
                                        get: function() {
                                            return e.getPixel(this.offset);
                                        }
                                    }
                                });
                            }
                        },
                        _draw: function(t, e, i) {
                            var n = this.getElement();
                            n && n.width > 0 && n.height > 0 && (t.globalAlpha = v.clamp(this._opacity, 0, 1), this._setStyles(t, e, i), Q.setPrefixed(t, "imageSmoothingEnabled", this._smoothing), t.drawImage(n, -this._size.width / 2, -this._size.height / 2));
                        },
                        _canComposite: function() {
                            return !0;
                        }
                    }), M = A.extend({
                        _class: "SymbolItem",
                        _applyMatrix: !1,
                        _canApplyMatrix: !1,
                        _boundsOptions: {
                            stroke: !0
                        },
                        _serializeFields: {
                            symbol: null
                        },
                        initialize: function(t, e) {
                            this._initialize(t, e !== o && m.read(arguments, 1)) || this.setDefinition(t instanceof B ? t : new B(t));
                        },
                        _equals: function(t) {
                            return this._definition === t._definition;
                        },
                        copyContent: function(t) {
                            this.setDefinition(t._definition);
                        },
                        getDefinition: function() {
                            return this._definition;
                        },
                        setDefinition: function(t) {
                            this._definition = t, this._changed(9);
                        },
                        getSymbol: "#getDefinition",
                        setSymbol: "#setDefinition",
                        isEmpty: function() {
                            return this._definition._item.isEmpty();
                        },
                        _getBounds: function(t, e) {
                            var i = this._definition._item;
                            return i._getCachedBounds(i._matrix.prepended(t), e);
                        },
                        _hitTestSelf: function(t, e, i) {
                            var n = e.extend({
                                all: !1
                            }), r = this._definition._item._hitTest(t, n, i);
                            return r && (r.item = this), r;
                        },
                        _draw: function(t, e) {
                            this._definition._item.draw(t, e);
                        }
                    }), B = u.extend({
                        _class: "SymbolDefinition",
                        initialize: function(t, e) {
                            this._id = _.get(), this.project = td.project, t && this.setItem(t, e);
                        },
                        _serialize: function(t, e) {
                            return e.add(this, function() {
                                return u.serialize([
                                    this._class,
                                    this._item
                                ], t, !1, e);
                            });
                        },
                        _changed: function(t) {
                            8 & t && A._clearBoundsCache(this), 1 & t && this.project._changed(t);
                        },
                        getItem: function() {
                            return this._item;
                        },
                        setItem: function(t, e) {
                            t._symbol && (t = t.clone()), this._item && (this._item._symbol = null), this._item = t, t.remove(), t.setSelected(!1), e || t.setPosition(new m), t._symbol = this, this._changed(9);
                        },
                        getDefinition: "#getItem",
                        setDefinition: "#setItem",
                        place: function(t) {
                            return new M(this, t);
                        },
                        clone: function() {
                            return new B(this._item.clone(!1));
                        },
                        equals: function(t) {
                            return t === this || t && this._item.equals(t._item) || !1;
                        }
                    }), O = u.extend({
                        _class: "HitResult",
                        initialize: function(t, e, i) {
                            this.type = t, this.item = e, i && this.inject(i);
                        },
                        statics: {
                            getOptions: function(t) {
                                var e = t && u.read(t);
                                return new u({
                                    type: null,
                                    tolerance: td.settings.hitTolerance,
                                    fill: !e,
                                    stroke: !e,
                                    segments: !e,
                                    handles: !1,
                                    ends: !1,
                                    position: !1,
                                    center: !1,
                                    bounds: !1,
                                    guides: !1,
                                    selected: !1
                                }, e);
                            }
                        }
                    }), N = u.extend({
                        _class: "Segment",
                        beans: !0,
                        _selection: 0,
                        initialize: function(t, e, i, n, r, s) {
                            var a, h, l, u, c = arguments.length;
                            c > 0 && (null == t || "object" == typeof t ? 1 === c && t && "point" in t ? (a = t.point, h = t.handleIn, l = t.handleOut, u = t.selection) : (a = t, h = e, l = i, u = n) : (a = [
                                t,
                                e
                            ], h = i !== o ? [
                                i,
                                n
                            ] : null, l = r !== o ? [
                                r,
                                s
                            ] : null)), new z(a, this, "_point"), new z(h, this, "_handleIn"), new z(l, this, "_handleOut"), u && this.setSelection(u);
                        },
                        _serialize: function(t, e) {
                            var i = this._point, n = this._selection, r = n || this.hasHandles() ? [
                                i,
                                this._handleIn,
                                this._handleOut
                            ] : i;
                            return n && r.push(n), u.serialize(r, t, !0, e);
                        },
                        _changed: function(t) {
                            var e = this._path;
                            if (e) {
                                var i, n = e._curves, r = this._index;
                                n && ((!t || t === this._point || t === this._handleIn) && (i = r > 0 ? n[r - 1] : e._closed ? n[n.length - 1] : null) && i._changed(), (!t || t === this._point || t === this._handleOut) && (i = n[r]) && i._changed()), e._changed(41);
                            }
                        },
                        getPoint: function() {
                            return this._point;
                        },
                        setPoint: function() {
                            this._point.set(m.read(arguments));
                        },
                        getHandleIn: function() {
                            return this._handleIn;
                        },
                        setHandleIn: function() {
                            this._handleIn.set(m.read(arguments));
                        },
                        getHandleOut: function() {
                            return this._handleOut;
                        },
                        setHandleOut: function() {
                            this._handleOut.set(m.read(arguments));
                        },
                        hasHandles: function() {
                            return !this._handleIn.isZero() || !this._handleOut.isZero();
                        },
                        isSmooth: function() {
                            var t = this._handleIn, e = this._handleOut;
                            return !t.isZero() && !e.isZero() && t.isCollinear(e);
                        },
                        clearHandles: function() {
                            this._handleIn._set(0, 0), this._handleOut._set(0, 0);
                        },
                        getSelection: function() {
                            return this._selection;
                        },
                        setSelection: function(t) {
                            var e = this._selection, i = this._path;
                            this._selection = t = t || 0, i && t !== e && (i._updateSelection(this, e, t), i._changed(257));
                        },
                        _changeSelection: function(t, e) {
                            var i = this._selection;
                            this.setSelection(e ? i | t : i & ~t);
                        },
                        isSelected: function() {
                            return !!(7 & this._selection);
                        },
                        setSelected: function(t) {
                            this._changeSelection(7, t);
                        },
                        getIndex: function() {
                            return this._index !== o ? this._index : null;
                        },
                        getPath: function() {
                            return this._path || null;
                        },
                        getCurve: function() {
                            var t = this._path, e = this._index;
                            return t ? (e > 0 && !t._closed && e === t._segments.length - 1 && e--, t.getCurves()[e] || null) : null;
                        },
                        getLocation: function() {
                            var t = this.getCurve();
                            return t ? new V(t, +(this !== t._segment1)) : null;
                        },
                        getNext: function() {
                            var t = this._path && this._path._segments;
                            return t && (t[this._index + 1] || this._path._closed && t[0]) || null;
                        },
                        smooth: function(t, e, i) {
                            var n = t || {}, r = n.type, s = n.factor, a = this.getPrevious(), h = this.getNext(), l = (a || this)._point, u = this._point, c = (h || this)._point, d = l.getDistance(u), p = u.getDistance(c);
                            if (r && "catmull-rom" !== r) {
                                if ("geometric" === r) {
                                    if (a && h) {
                                        var f = l.subtract(c), g = s === o ? .4 : s, v = g * d / (d + p);
                                        e || this.setHandleIn(f.multiply(v)), i || this.setHandleOut(f.multiply(v - g));
                                    }
                                } else throw Error("Smoothing method '" + r + "' not supported.");
                            } else {
                                var _ = s === o ? .5 : s, y = Math.pow(d, _), b = y * y, x = Math.pow(p, _), w = x * x;
                                if (!e && a) {
                                    var C = 2 * w + 3 * x * y + b, S = 3 * x * (x + y);
                                    this.setHandleIn(0 !== S ? new m((w * l._x + C * u._x - b * c._x) / S - u._x, (w * l._y + C * u._y - b * c._y) / S - u._y) : new m);
                                }
                                if (!i && h) {
                                    var C = 2 * b + 3 * y * x + w, S = 3 * y * (y + x);
                                    this.setHandleOut(0 !== S ? new m((b * c._x + C * u._x - w * l._x) / S - u._x, (b * c._y + C * u._y - w * l._y) / S - u._y) : new m);
                                }
                            }
                        },
                        getPrevious: function() {
                            var t = this._path && this._path._segments;
                            return t && (t[this._index - 1] || this._path._closed && t[t.length - 1]) || null;
                        },
                        isFirst: function() {
                            return !this._index;
                        },
                        isLast: function() {
                            var t = this._path;
                            return t && this._index === t._segments.length - 1 || !1;
                        },
                        reverse: function() {
                            var t = this._handleIn, e = this._handleOut, i = t.clone();
                            t.set(e), e.set(i);
                        },
                        reversed: function() {
                            return new N(this._point, this._handleOut, this._handleIn);
                        },
                        remove: function() {
                            return !!this._path && !!this._path.removeSegment(this._index);
                        },
                        clone: function() {
                            return new N(this._point, this._handleIn, this._handleOut);
                        },
                        equals: function(t) {
                            return t === this || t && this._class === t._class && this._point.equals(t._point) && this._handleIn.equals(t._handleIn) && this._handleOut.equals(t._handleOut) || !1;
                        },
                        toString: function() {
                            var t = [
                                "point: " + this._point
                            ];
                            return this._handleIn.isZero() || t.push("handleIn: " + this._handleIn), this._handleOut.isZero() || t.push("handleOut: " + this._handleOut), "{ " + t.join(", ") + " }";
                        },
                        transform: function(t) {
                            this._transformCoordinates(t, Array(6), !0), this._changed();
                        },
                        interpolate: function(t, e, i) {
                            var n = 1 - i, r = t._point, s = e._point, a = t._handleIn, o = e._handleIn, h = e._handleOut, l = t._handleOut;
                            this._point._set(n * r._x + i * s._x, n * r._y + i * s._y, !0), this._handleIn._set(n * a._x + i * o._x, n * a._y + i * o._y, !0), this._handleOut._set(n * l._x + i * h._x, n * l._y + i * h._y, !0), this._changed();
                        },
                        _transformCoordinates: function(t, e, i) {
                            var n = this._point, r = i && this._handleIn.isZero() ? null : this._handleIn, s = i && this._handleOut.isZero() ? null : this._handleOut, a = n._x, o = n._y, h = 2;
                            return e[0] = a, e[1] = o, r && (e[h++] = r._x + a, e[h++] = r._y + o), s && (e[h++] = s._x + a, e[h++] = s._y + o), t && (t._transformCoordinates(e, e, h / 2), a = e[0], o = e[1], i ? (n._x = a, n._y = o, h = 2, r && (r._x = e[h++] - a, r._y = e[h++] - o), s && (s._x = e[h++] - a, s._y = e[h++] - o)) : (r || (e[h++] = a, e[h++] = o), s || (e[h++] = a, e[h++] = o))), e;
                        }
                    }), z = m.extend({
                        initialize: function(t, e, i) {
                            var n, r, s;
                            if (t) {
                                if ((n = t[0]) !== o) r = t[1];
                                else {
                                    var a = t;
                                    (n = a.x) === o && (a = m.read(arguments), n = a.x), r = a.y, s = a.selected;
                                }
                            } else n = r = 0;
                            this._x = n, this._y = r, this._owner = e, e[i] = this, s && this.setSelected(!0);
                        },
                        _set: function(t, e) {
                            return this._x = t, this._y = e, this._owner._changed(this), this;
                        },
                        getX: function() {
                            return this._x;
                        },
                        setX: function(t) {
                            this._x = t, this._owner._changed(this);
                        },
                        getY: function() {
                            return this._y;
                        },
                        setY: function(t) {
                            this._y = t, this._owner._changed(this);
                        },
                        isZero: function() {
                            var t = v.isZero;
                            return t(this._x) && t(this._y);
                        },
                        isSelected: function() {
                            return !!(this._owner._selection & this._getSelection());
                        },
                        setSelected: function(t) {
                            this._owner._changeSelection(this._getSelection(), t);
                        },
                        _getSelection: function() {
                            var t = this._owner;
                            return this === t._point ? 1 : this === t._handleIn ? 2 : 4 * (this === t._handleOut);
                        }
                    }), R = u.extend({
                        _class: "Curve",
                        beans: !0,
                        initialize: function(t, e, i, n, r, s, a, o) {
                            var h, l, u, c, d, p, f = arguments.length;
                            3 === f ? (this._path = t, h = e, l = i) : f ? 1 === f ? "segment1" in t ? (h = new N(t.segment1), l = new N(t.segment2)) : "point1" in t ? (u = t.point1, d = t.handle1, p = t.handle2, c = t.point2) : Array.isArray(t) && (u = [
                                t[0],
                                t[1]
                            ], c = [
                                t[6],
                                t[7]
                            ], d = [
                                t[2] - t[0],
                                t[3] - t[1]
                            ], p = [
                                t[4] - t[6],
                                t[5] - t[7]
                            ]) : 2 === f ? (h = new N(t), l = new N(e)) : 4 === f ? (u = t, d = e, p = i, c = n) : 8 === f && (u = [
                                t,
                                e
                            ], c = [
                                a,
                                o
                            ], d = [
                                i - t,
                                n - e
                            ], p = [
                                r - a,
                                s - o
                            ]) : (h = new N, l = new N), this._segment1 = h || new N(u, null, d), this._segment2 = l || new N(c, p, null);
                        },
                        _serialize: function(t, e) {
                            return u.serialize(this.hasHandles() ? [
                                this.getPoint1(),
                                this.getHandle1(),
                                this.getHandle2(),
                                this.getPoint2()
                            ] : [
                                this.getPoint1(),
                                this.getPoint2()
                            ], t, !0, e);
                        },
                        _changed: function() {
                            this._length = this._bounds = o;
                        },
                        clone: function() {
                            return new R(this._segment1, this._segment2);
                        },
                        toString: function() {
                            var t = [
                                "point1: " + this._segment1._point
                            ];
                            return this._segment1._handleOut.isZero() || t.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || t.push("handle2: " + this._segment2._handleIn), t.push("point2: " + this._segment2._point), "{ " + t.join(", ") + " }";
                        },
                        classify: function() {
                            return R.classify(this.getValues());
                        },
                        remove: function() {
                            var t = !1;
                            if (this._path) {
                                var e = this._segment2, i = e._handleOut;
                                (t = e.remove()) && this._segment1._handleOut.set(i);
                            }
                            return t;
                        },
                        getPoint1: function() {
                            return this._segment1._point;
                        },
                        setPoint1: function() {
                            this._segment1._point.set(m.read(arguments));
                        },
                        getPoint2: function() {
                            return this._segment2._point;
                        },
                        setPoint2: function() {
                            this._segment2._point.set(m.read(arguments));
                        },
                        getHandle1: function() {
                            return this._segment1._handleOut;
                        },
                        setHandle1: function() {
                            this._segment1._handleOut.set(m.read(arguments));
                        },
                        getHandle2: function() {
                            return this._segment2._handleIn;
                        },
                        setHandle2: function() {
                            this._segment2._handleIn.set(m.read(arguments));
                        },
                        getSegment1: function() {
                            return this._segment1;
                        },
                        getSegment2: function() {
                            return this._segment2;
                        },
                        getPath: function() {
                            return this._path;
                        },
                        getIndex: function() {
                            return this._segment1._index;
                        },
                        getNext: function() {
                            var t = this._path && this._path._curves;
                            return t && (t[this._segment1._index + 1] || this._path._closed && t[0]) || null;
                        },
                        getPrevious: function() {
                            var t = this._path && this._path._curves;
                            return t && (t[this._segment1._index - 1] || this._path._closed && t[t.length - 1]) || null;
                        },
                        isFirst: function() {
                            return !this._segment1._index;
                        },
                        isLast: function() {
                            var t = this._path;
                            return t && this._segment1._index === t._curves.length - 1 || !1;
                        },
                        isSelected: function() {
                            return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
                        },
                        setSelected: function(t) {
                            this.getPoint1().setSelected(t), this.getHandle1().setSelected(t), this.getHandle2().setSelected(t), this.getPoint2().setSelected(t);
                        },
                        getValues: function(t) {
                            return R.getValues(this._segment1, this._segment2, t);
                        },
                        getPoints: function() {
                            for(var t = this.getValues(), e = [], i = 0; i < 8; i += 2)e.push(new m(t[i], t[i + 1]));
                            return e;
                        }
                    }, {
                        getLength: function() {
                            return null == this._length && (this._length = R.getLength(this.getValues(), 0, 1)), this._length;
                        },
                        getArea: function() {
                            return R.getArea(this.getValues());
                        },
                        getLine: function() {
                            return new k(this._segment1._point, this._segment2._point);
                        },
                        getPart: function(t, e) {
                            return new R(R.getPart(this.getValues(), t, e));
                        },
                        getPartLength: function(t, e) {
                            return R.getLength(this.getValues(), t, e);
                        },
                        divideAt: function(t) {
                            return this.divideAtTime(t && t.curve === this ? t.time : this.getTimeAt(t));
                        },
                        divideAtTime: function(t, e) {
                            var i = null;
                            if (t >= 1e-8 && t <= .99999999) {
                                var n = R.subdivide(this.getValues(), t), r = n[0], s = n[1], a = e || this.hasHandles(), o = this._segment1, h = this._segment2, l = this._path;
                                a && (o._handleOut._set(r[2] - r[0], r[3] - r[1]), h._handleIn._set(s[4] - s[6], s[5] - s[7]));
                                var u = r[6], c = r[7], d = new N(new m(u, c), a && new m(r[4] - u, r[5] - c), a && new m(s[2] - u, s[3] - c));
                                l ? (l.insert(o._index + 1, d), i = this.getNext()) : (this._segment2 = d, this._changed(), i = new R(d, h));
                            }
                            return i;
                        },
                        splitAt: function(t) {
                            var e = this._path;
                            return e ? e.splitAt(t) : null;
                        },
                        splitAtTime: function(t) {
                            return this.splitAt(this.getLocationAtTime(t));
                        },
                        divide: function(t, e) {
                            return this.divideAtTime(t === o ? .5 : e ? t : this.getTimeAt(t));
                        },
                        split: function(t, e) {
                            return this.splitAtTime(t === o ? .5 : e ? t : this.getTimeAt(t));
                        },
                        reversed: function() {
                            return new R(this._segment2.reversed(), this._segment1.reversed());
                        },
                        clearHandles: function() {
                            this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
                        },
                        statics: {
                            getValues: function(t, e, i, n) {
                                var r = t._point, s = t._handleOut, a = e._handleIn, o = e._point, h = r.x, l = r.y, u = o.x, c = o.y, d = n ? [
                                    h,
                                    l,
                                    h,
                                    l,
                                    u,
                                    c,
                                    u,
                                    c
                                ] : [
                                    h,
                                    l,
                                    h + s._x,
                                    l + s._y,
                                    u + a._x,
                                    c + a._y,
                                    u,
                                    c
                                ];
                                return i && i._transformCoordinates(d, d, 4), d;
                            },
                            subdivide: function(t, e) {
                                var i = t[0], n = t[1], r = t[2], s = t[3], a = t[4], h = t[5], l = t[6], u = t[7];
                                e === o && (e = .5);
                                var c = 1 - e, d = c * i + e * r, p = c * n + e * s, f = c * r + e * a, g = c * s + e * h, v = c * a + e * l, _ = c * h + e * u, m = c * d + e * f, y = c * p + e * g, b = c * f + e * v, x = c * g + e * _, w = c * m + e * b, C = c * y + e * x;
                                return [
                                    [
                                        i,
                                        n,
                                        d,
                                        p,
                                        m,
                                        y,
                                        w,
                                        C
                                    ],
                                    [
                                        w,
                                        C,
                                        b,
                                        x,
                                        v,
                                        _,
                                        l,
                                        u
                                    ]
                                ];
                            },
                            getMonoCurves: function(t, e) {
                                var i = [], n = +!e, r = t[n + 0], s = t[n + 2], a = t[n + 4], o = t[n + 6];
                                if (r >= s == s >= a && s >= a == a >= o || R.isStraight(t)) i.push(t);
                                else {
                                    var h = [], l = v.solveQuadratic(3 * (s - a) - r + o, 2 * (r + a) - 4 * s, s - r, h, 1e-8, .99999999);
                                    if (l) {
                                        h.sort();
                                        var u = h[0], c = R.subdivide(t, u);
                                        i.push(c[0]), l > 1 && (u = (h[1] - u) / (1 - u), c = R.subdivide(c[1], u), i.push(c[0])), i.push(c[1]);
                                    } else i.push(t);
                                }
                                return i;
                            },
                            solveCubic: function(t, e, i, n, r, s) {
                                var a = t[e], o = t[e + 2], h = t[e + 4], l = t[e + 6], u = 0;
                                if (!(a < i && l < i && o < i && h < i || a > i && l > i && o > i && h > i)) {
                                    var c = 3 * (o - a), d = 3 * (h - o) - c;
                                    u = v.solveCubic(l - a - c - d, d, c, a - i, n, r, s);
                                }
                                return u;
                            },
                            getTimeOf: function(t, e) {
                                var i = new m(t[0], t[1]), n = new m(t[6], t[7]);
                                if (null === (e.isClose(i, 1e-12) ? 0 : e.isClose(n, 1e-12) ? 1 : null)) for(var r = [
                                    e.x,
                                    e.y
                                ], s = [], a = 0; a < 2; a++)for(var o = R.solveCubic(t, a, r[a], s, 0, 1), h = 0; h < o; h++){
                                    var l = s[h];
                                    if (e.isClose(R.getPoint(t, l), 1e-7)) return l;
                                }
                                return e.isClose(i, 1e-7) ? 0 : e.isClose(n, 1e-7) ? 1 : null;
                            },
                            getNearestTime: function(t, e) {
                                if (R.isStraight(t)) {
                                    var i = t[0], n = t[1], r = t[6], s = t[7], a = r - i, o = s - n, h = a * a + o * o;
                                    if (0 === h) return 0;
                                    var l = ((e.x - i) * a + (e.y - n) * o) / h;
                                    return l < 1e-12 ? 0 : l > .999999999999 ? 1 : R.getTimeOf(t, new m(i + l * a, n + l * o));
                                }
                                var u = 1 / 0, c = 0;
                                function d(i) {
                                    if (i >= 0 && i <= 1) {
                                        var n = e.getDistance(R.getPoint(t, i), !0);
                                        if (n < u) return u = n, c = i, !0;
                                    }
                                }
                                for(var p = 0; p <= 100; p++)d(p / 100);
                                for(var f = .005; f > 1e-8;)d(c - f) || d(c + f) || (f /= 2);
                                return c;
                            },
                            getPart: function(t, e, i) {
                                var n = e > i;
                                if (n) {
                                    var r = e;
                                    e = i, i = r;
                                }
                                return e > 0 && (t = R.subdivide(t, e)[1]), i < 1 && (t = R.subdivide(t, (i - e) / (1 - e))[0]), n ? [
                                    t[6],
                                    t[7],
                                    t[4],
                                    t[5],
                                    t[2],
                                    t[3],
                                    t[0],
                                    t[1]
                                ] : t;
                            },
                            isFlatEnough: function(t, e) {
                                var i = t[0], n = t[1], r = t[2], s = t[3], a = t[4], o = t[5], h = t[6], l = t[7], u = 3 * r - 2 * i - h, c = 3 * s - 2 * n - l, d = 3 * a - 2 * h - i, p = 3 * o - 2 * l - n;
                                return Math.max(u * u, d * d) + Math.max(c * c, p * p) <= 16 * e * e;
                            },
                            getArea: function(t) {
                                var e = t[0], i = t[1], n = t[2], r = t[3], s = t[4], a = t[5], o = t[6], h = t[7];
                                return 3 * ((h - i) * (n + s) - (o - e) * (r + a) + r * (e - s) - n * (i - a) + h * (s + e / 3) - o * (a + i / 3)) / 20;
                            },
                            getBounds: function(t) {
                                for(var e = t.slice(0, 2), i = e.slice(), n = [
                                    0,
                                    0
                                ], r = 0; r < 2; r++)R._addBounds(t[r], t[r + 2], t[r + 4], t[r + 6], r, 0, e, i, n);
                                return new w(e[0], e[1], i[0] - e[0], i[1] - e[1]);
                            },
                            _addBounds: function(t, e, i, n, r, s, a, o, h) {
                                function l(t, e) {
                                    var i = t - e, n = t + e;
                                    i < a[r] && (a[r] = i), n > o[r] && (o[r] = n);
                                }
                                s /= 2;
                                var u = a[r] - s, c = o[r] + s;
                                if (t < u || e < u || i < u || n < u || t > c || e > c || i > c || n > c) {
                                    if (e < t != e < n && i < t != i < n) l(t, 0), l(n, 0);
                                    else {
                                        var d = v.solveQuadratic(3 * (e - i) - t + n, 2 * (t + i) - 4 * e, e - t, h);
                                        l(n, 0);
                                        for(var p = 0; p < d; p++){
                                            var f = h[p], g = 1 - f;
                                            1e-8 <= f && f <= .99999999 && l(g * g * g * t + 3 * g * g * f * e + 3 * g * f * f * i + f * f * f * n, s);
                                        }
                                    }
                                }
                            }
                        }
                    }, u.each([
                        "getBounds",
                        "getStrokeBounds",
                        "getHandleBounds"
                    ], function(t) {
                        this[t] = function() {
                            this._bounds || (this._bounds = {});
                            var e = this._bounds[t];
                            return e || (e = this._bounds[t] = D[t]([
                                this._segment1,
                                this._segment2
                            ], !1, this._path)), e.clone();
                        };
                    }, {}), u.each({
                        isStraight: function(t, e, i, n) {
                            if (e.isZero() && i.isZero()) return !0;
                            var r = n.subtract(t);
                            if (r.isZero()) ;
                            else if (r.isCollinear(e) && r.isCollinear(i)) {
                                var s = new k(t, n);
                                if (1e-7 > s.getDistance(t.add(e)) && 1e-7 > s.getDistance(n.add(i))) {
                                    var a = r.dot(r), o = r.dot(e) / a, h = r.dot(i) / a;
                                    return o >= 0 && o <= 1 && h <= 0 && h >= -1;
                                }
                            }
                            return !1;
                        },
                        isLinear: function(t, e, i, n) {
                            var r = n.subtract(t).divide(3);
                            return e.equals(r) && i.negate().equals(r);
                        }
                    }, function(t, e) {
                        this[e] = function(e) {
                            var i = this._segment1, n = this._segment2;
                            return t(i._point, i._handleOut, n._handleIn, n._point, e);
                        }, this.statics[e] = function(e, i) {
                            var n = e[0], r = e[1], s = e[6], a = e[7];
                            return t(new m(n, r), new m(e[2] - n, e[3] - r), new m(e[4] - s, e[5] - a), new m(s, a), i);
                        };
                    }, {
                        statics: {},
                        hasHandles: function() {
                            return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
                        },
                        hasLength: function(t) {
                            return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (t || 0);
                        },
                        isCollinear: function(t) {
                            return t && this.isStraight() && t.isStraight() && this.getLine().isCollinear(t.getLine());
                        },
                        isHorizontal: function() {
                            return this.isStraight() && 1e-8 > Math.abs(this.getTangentAtTime(.5).y);
                        },
                        isVertical: function() {
                            return this.isStraight() && 1e-8 > Math.abs(this.getTangentAtTime(.5).x);
                        }
                    }), {
                        beans: !1,
                        getLocationAt: function(t, e) {
                            return this.getLocationAtTime(e ? t : this.getTimeAt(t));
                        },
                        getLocationAtTime: function(t) {
                            return null != t && t >= 0 && t <= 1 ? new V(this, t) : null;
                        },
                        getTimeAt: function(t, e) {
                            return R.getTimeAt(this.getValues(), t, e);
                        },
                        getParameterAt: "#getTimeAt",
                        getTimesWithTangent: function() {
                            var t = m.read(arguments);
                            return t.isZero() ? [] : R.getTimesWithTangent(this.getValues(), t);
                        },
                        getOffsetAtTime: function(t) {
                            return this.getPartLength(0, t);
                        },
                        getLocationOf: function() {
                            return this.getLocationAtTime(this.getTimeOf(m.read(arguments)));
                        },
                        getOffsetOf: function() {
                            var t = this.getLocationOf.apply(this, arguments);
                            return t ? t.getOffset() : null;
                        },
                        getTimeOf: function() {
                            return R.getTimeOf(this.getValues(), m.read(arguments));
                        },
                        getParameterOf: "#getTimeOf",
                        getNearestLocation: function() {
                            var t = m.read(arguments), e = this.getValues(), i = R.getNearestTime(e, t), n = R.getPoint(e, i);
                            return new V(this, i, n, null, t.getDistance(n));
                        },
                        getNearestPoint: function() {
                            var t = this.getNearestLocation.apply(this, arguments);
                            return t ? t.getPoint() : t;
                        }
                    }, new function() {
                        var t = [
                            "getPoint",
                            "getTangent",
                            "getNormal",
                            "getWeightedTangent",
                            "getWeightedNormal",
                            "getCurvature"
                        ];
                        return u.each(t, function(t) {
                            this[t + "At"] = function(e, i) {
                                var n = this.getValues();
                                return R[t](n, i ? e : R.getTimeAt(n, e));
                            }, this[t + "AtTime"] = function(e) {
                                return R[t](this.getValues(), e);
                            };
                        }, {
                            statics: {
                                _evaluateMethods: t
                            }
                        });
                    }, new function() {
                        function t(t) {
                            var e = t[0], i = t[1], n = t[2], r = t[3], s = t[4], a = t[5], o = t[6], h = t[7], l = 9 * (n - s) + 3 * (o - e), u = 6 * (e + s) - 12 * n, c = 3 * (n - e), d = 9 * (r - a) + 3 * (h - i), p = 6 * (i + a) - 12 * r, f = 3 * (r - i);
                            return function(t) {
                                var e = (l * t + u) * t + c, i = (d * t + p) * t + f;
                                return Math.sqrt(e * e + i * i);
                            };
                        }
                        function e(t, e) {
                            return Math.max(2, Math.min(16, Math.ceil(32 * Math.abs(e - t))));
                        }
                        function i(t, e, i, n) {
                            if (null == e || e < 0 || e > 1) return null;
                            var r = t[0], s = t[1], a = t[2], o = t[3], h = t[4], l = t[5], u = t[6], c = t[7], d = v.isZero;
                            d(a - r) && d(o - s) && (a = r, o = s), d(h - u) && d(l - c) && (h = u, l = c);
                            var p, f, g = 3 * (a - r), _ = 3 * (h - a) - g, y = u - r - g - _, b = 3 * (o - s), x = 3 * (l - o) - b, w = c - s - b - x;
                            if (0 === i) p = 0 === e ? r : 1 === e ? u : ((y * e + _) * e + g) * e + r, f = 0 === e ? s : 1 === e ? c : ((w * e + x) * e + b) * e + s;
                            else {
                                if (e < 1e-8 ? (p = g, f = b) : e > .99999999 ? (p = 3 * (u - h), f = 3 * (c - l)) : (p = (3 * y * e + 2 * _) * e + g, f = (3 * w * e + 2 * x) * e + b), n) {
                                    0 === p && 0 === f && (e < 1e-8 || e > .99999999) && (p = h - a, f = l - o);
                                    var C = Math.sqrt(p * p + f * f);
                                    C && (p /= C, f /= C);
                                }
                                if (3 === i) {
                                    var h = 6 * y * e + 2 * _, l = 6 * w * e + 2 * x, S = Math.pow(p * p + f * f, 1.5);
                                    p = 0 !== S ? (p * l - f * h) / S : 0, f = 0;
                                }
                            }
                            return 2 === i ? new m(f, -p) : new m(p, f);
                        }
                        return {
                            statics: {
                                classify: function(t) {
                                    var e = t[0], i = t[1], n = t[2], r = t[3], s = t[4], a = t[5], h = t[6], l = t[7], u = n * (i - l) + r * (h - e) + e * l - i * h, c = 3 * (s * (r - i) + a * (e - n) + n * i - r * e), d = c - u, p = d - u + (e * (l - a) + i * (s - h) + h * a - l * s), f = Math.sqrt(p * p + d * d + c * c), g = 0 !== f ? 1 / f : 0, _ = v.isZero, m = "serpentine";
                                    function y(t, e, i) {
                                        var n = e !== o, r = n && e > 0 && e < 1, s = n && i > 0 && i < 1;
                                        return !n || (r || s) && ("loop" !== t || r && s) || (t = "arch", r = s = !1), {
                                            type: t,
                                            roots: r || s ? r && s ? e < i ? [
                                                e,
                                                i
                                            ] : [
                                                i,
                                                e
                                            ] : [
                                                r ? e : i
                                            ] : null
                                        };
                                    }
                                    if (p *= g, d *= g, c *= g, _(p)) return _(d) ? y(_(c) ? "line" : "quadratic") : y(m, c / (3 * d));
                                    var b = 3 * d * d - 4 * p * c;
                                    if (_(b)) return y("cusp", d / (2 * p));
                                    var x = b > 0 ? Math.sqrt(b / 3) : Math.sqrt(-b), w = 2 * p;
                                    return y(b > 0 ? m : "loop", (d + x) / w, (d - x) / w);
                                },
                                getLength: function(i, n, r, s) {
                                    if (n === o && (n = 0), r === o && (r = 1), R.isStraight(i)) {
                                        var a = i;
                                        r < 1 && (a = R.subdivide(a, r)[0], n /= r), n > 0 && (a = R.subdivide(a, n)[1]);
                                        var h = a[6] - a[0], l = a[7] - a[1];
                                        return Math.sqrt(h * h + l * l);
                                    }
                                    return v.integrate(s || t(i), n, r, e(n, r));
                                },
                                getTimeAt: function(i, n, r) {
                                    if (r === o && (r = +(n < 0)), 0 === n) return r;
                                    var s = Math.abs, a = n > 0, h = a ? r : 0, l = a ? 1 : r, u = t(i), c = R.getLength(i, h, l, u), d = s(n) - c;
                                    if (1e-12 > s(d)) return a ? l : h;
                                    if (d > 1e-12) return null;
                                    var p = n / c, f = 0;
                                    return v.findRoot(function(t) {
                                        return f += v.integrate(u, r, t, e(r, t)), r = t, f - n;
                                    }, u, r + p, h, l, 32, 1e-12);
                                },
                                getPoint: function(t, e) {
                                    return i(t, e, 0, !1);
                                },
                                getTangent: function(t, e) {
                                    return i(t, e, 1, !0);
                                },
                                getWeightedTangent: function(t, e) {
                                    return i(t, e, 1, !1);
                                },
                                getNormal: function(t, e) {
                                    return i(t, e, 2, !0);
                                },
                                getWeightedNormal: function(t, e) {
                                    return i(t, e, 2, !1);
                                },
                                getCurvature: function(t, e) {
                                    return i(t, e, 3, !1).x;
                                },
                                getPeaks: function(t) {
                                    var e = t[0], i = t[1], n = t[2], r = t[3], s = t[4], a = t[5], o = t[6], h = t[7], l = -e + 3 * n - 3 * s + o, u = 3 * e - 6 * n + 3 * s, c = -3 * e + 3 * n, d = -i + 3 * r - 3 * a + h, p = 3 * i - 6 * r + 3 * a, f = -3 * i + 3 * r, g = [];
                                    return v.solveCubic(9 * (l * l + d * d), 9 * (l * u + p * d), 2 * (u * u + p * p) + 3 * (c * l + f * d), c * u + p * f, g, 1e-8, .99999999), g.sort();
                                }
                            }
                        };
                    }, new function() {
                        function t(t, e, i, n, r, s, a) {
                            var o = !a && i.getPrevious() === r, h = !a && i !== r && i.getNext() === r;
                            if (null !== n && n >= 1e-8 * !!o && n <= (h ? .99999999 : 1) && null !== s && s >= 1e-8 * !!h && s <= (o ? .99999999 : 1)) {
                                var l = new V(i, n, null, a), u = new V(r, s, null, a);
                                l._intersection = u, u._intersection = l, (!e || e(l)) && V.insert(t, l, !0);
                            }
                        }
                        function e(t, e, n, r) {
                            return t[0][1] < n ? i(t, !0, n) : e[0][1] > r ? i(e, !1, r) : t[0][0];
                        }
                        function i(t, e, i) {
                            for(var n = t[0][0], r = t[0][1], s = 1, a = t.length; s < a; s++){
                                var o = t[s][0], h = t[s][1];
                                if (e ? h >= i : h <= i) return h === i ? o : n + (i - r) * (o - n) / (h - r);
                                n = o, r = h;
                            }
                            return null;
                        }
                        function n(t, e, i, n, r) {
                            var s = v.isZero;
                            if (s(n) && s(r)) {
                                var a = R.getTimeOf(t, new m(e, i));
                                return null === a ? [] : [
                                    a
                                ];
                            }
                            for(var o = Math.atan2(-r, n), h = Math.sin(o), l = Math.cos(o), u = [], c = [], d = 0; d < 8; d += 2){
                                var p = t[d] - e, f = t[d + 1] - i;
                                u.push(p * l - f * h, p * h + f * l);
                            }
                            return R.solveCubic(u, 1, 0, c, 0, 1), c;
                        }
                        function r(i, r, s, o, h, l) {
                            var u = Math.min, c = Math.max;
                            if (c(i[0], i[2], i[4], i[6]) + 1e-12 > u(r[0], r[2], r[4], r[6]) && u(i[0], i[2], i[4], i[6]) - 1e-12 < c(r[0], r[2], r[4], r[6]) && c(i[1], i[3], i[5], i[7]) + 1e-12 > u(r[1], r[3], r[5], r[7]) && u(i[1], i[3], i[5], i[7]) - 1e-12 < c(r[1], r[3], r[5], r[7])) {
                                var d = a(i, r);
                                if (d) for(var p = 0; p < 2; p++){
                                    var f = d[p];
                                    t(h, l, s, f[0], o, f[1], !0);
                                }
                                else {
                                    var g = R.isStraight(i), v = R.isStraight(r), _ = g && v, y = g && !v, b = h.length;
                                    if ((_ ? function(e, i, n, r, s, a) {
                                        var o = k.intersect(e[0], e[1], e[6], e[7], i[0], i[1], i[6], i[7]);
                                        o && t(s, a, n, R.getTimeOf(e, o), r, R.getTimeOf(i, o));
                                    } : g || v ? function(e, i, r, s, a, o, h) {
                                        for(var l = i[0], u = i[1], c = n(e, l, u, i[6] - l, i[7] - u), d = 0, p = c.length; d < p; d++){
                                            var f = c[d], g = R.getPoint(e, f), v = R.getTimeOf(i, g);
                                            null !== v && t(a, o, h ? s : r, h ? v : f, h ? r : s, h ? f : v);
                                        }
                                    } : function i(n, r, s, a, o, h, l, u, c, d, p, f, g) {
                                        if (++c >= 4096 || ++u >= 40) return c;
                                        var v, _, m = r[0], y = r[1], b = r[6], x = r[7], w = k.getSignedDistance, C = w(m, y, b, x, r[2], r[3]), S = w(m, y, b, x, r[4], r[5]), P = C * S > 0 ? 3 / 4 : 4 / 9, A = P * Math.min(0, C, S), I = P * Math.max(0, C, S), T = w(m, y, b, x, n[0], n[1]), E = w(m, y, b, x, n[2], n[3]), L = w(m, y, b, x, n[4], n[5]), M = w(m, y, b, x, n[6], n[7]), B = function(t, e, i, n) {
                                            var r, s = [
                                                0,
                                                t
                                            ], a = [
                                                1 / 3,
                                                e
                                            ], o = [
                                                2 / 3,
                                                i
                                            ], h = [
                                                1,
                                                n
                                            ], l = e - (2 * t + n) / 3, u = i - (t + 2 * n) / 3;
                                            if (l * u < 0) r = [
                                                [
                                                    s,
                                                    a,
                                                    h
                                                ],
                                                [
                                                    s,
                                                    o,
                                                    h
                                                ]
                                            ];
                                            else {
                                                var c = l / u;
                                                r = [
                                                    c >= 2 ? [
                                                        s,
                                                        a,
                                                        h
                                                    ] : c <= .5 ? [
                                                        s,
                                                        o,
                                                        h
                                                    ] : [
                                                        s,
                                                        a,
                                                        o,
                                                        h
                                                    ],
                                                    [
                                                        s,
                                                        h
                                                    ]
                                                ];
                                            }
                                            return 0 > (l || u) ? r.reverse() : r;
                                        }(T, E, L, M), O = B[0], N = B[1];
                                        if (0 === C && 0 === S && 0 === T && 0 === E && 0 === L && 0 === M || null == (v = e(O, N, A, I)) || null == (_ = e(O.reverse(), N.reverse(), A, I))) return c;
                                        var z = d + (p - d) * v, V = d + (p - d) * _;
                                        if (1e-9 > Math.max(g - f, V - z)) {
                                            var F = (z + V) / 2, D = (f + g) / 2;
                                            t(o, h, l ? a : s, l ? D : F, l ? s : a, l ? F : D);
                                        } else {
                                            n = R.getPart(n, v, _);
                                            var j = g - f;
                                            if (_ - v > .8) {
                                                if (V - z > j) {
                                                    var H = R.subdivide(n, .5), F = (z + V) / 2;
                                                    c = i(r, H[0], a, s, o, h, !l, u, c, f, g, z, F), c = i(r, H[1], a, s, o, h, !l, u, c, f, g, F, V);
                                                } else {
                                                    var H = R.subdivide(r, .5), D = (f + g) / 2;
                                                    c = i(H[0], n, a, s, o, h, !l, u, c, f, D, z, V), c = i(H[1], n, a, s, o, h, !l, u, c, D, g, z, V);
                                                }
                                            } else c = 0 === j || j >= 1e-9 ? i(r, n, a, s, o, h, !l, u, c, f, g, z, V) : i(n, r, s, a, o, h, l, u, c, z, V, f, g);
                                        }
                                        return c;
                                    })(y ? r : i, y ? i : r, y ? o : s, y ? s : o, h, l, y, 0, 0, 0, 1, 0, 1), !_ || h.length === b) for(var p = 0; p < 4; p++){
                                        var x = p >> 1, w = 1 & p, C = 6 * x, S = 6 * w, P = new m(i[C], i[C + 1]), A = new m(r[S], r[S + 1]);
                                        P.isClose(A, 1e-12) && t(h, l, s, x, o, w);
                                    }
                                }
                            }
                            return h;
                        }
                        function s(e, i, n, r) {
                            var s = R.classify(e);
                            if ("loop" === s.type) {
                                var a = s.roots;
                                t(n, r, i, a[0], i, a[1]);
                            }
                            return n;
                        }
                        function a(t, e) {
                            function i(t) {
                                var e = t[6] - t[0], i = t[7] - t[1];
                                return e * e + i * i;
                            }
                            var n = Math.abs, r = k.getDistance, s = R.isStraight(t), a = R.isStraight(e), o = s && a, h = i(t) < i(e), l = h ? e : t, u = h ? t : e, c = l[0], d = l[1], p = l[6] - c, f = l[7] - d;
                            if (1e-7 > r(c, d, p, f, u[0], u[1], !0) && 1e-7 > r(c, d, p, f, u[6], u[7], !0)) !o && 1e-7 > r(c, d, p, f, l[2], l[3], !0) && 1e-7 > r(c, d, p, f, l[4], l[5], !0) && 1e-7 > r(c, d, p, f, u[2], u[3], !0) && 1e-7 > r(c, d, p, f, u[4], u[5], !0) && (s = a = o = !0);
                            else if (o) return null;
                            if (s ^ a) return null;
                            for(var g = [
                                t,
                                e
                            ], v = [], _ = 0; _ < 4 && v.length < 2; _++){
                                var y = 1 & _, b = 1 ^ y, x = _ >> 1, w = R.getTimeOf(g[y], new m(g[b][6 * !!x], g[b][x ? 7 : 1]));
                                if (null != w) {
                                    var C = y ? [
                                        x,
                                        w
                                    ] : [
                                        w,
                                        x
                                    ];
                                    (!v.length || n(C[0] - v[0][0]) > 1e-8 && n(C[1] - v[0][1]) > 1e-8) && v.push(C);
                                }
                                if (_ > 2 && !v.length) break;
                            }
                            if (2 !== v.length) v = null;
                            else if (!o) {
                                var S = R.getPart(t, v[0][0], v[1][0]), P = R.getPart(e, v[0][1], v[1][1]);
                                (n(P[2] - S[2]) > 1e-7 || n(P[3] - S[3]) > 1e-7 || n(P[4] - S[4]) > 1e-7 || n(P[5] - S[5]) > 1e-7) && (v = null);
                            }
                            return v;
                        }
                        return {
                            getIntersections: function(t) {
                                var e = this.getValues(), i = t && t !== this && t.getValues();
                                return i ? r(e, i, this, t, []) : s(e, this, []);
                            },
                            statics: {
                                getOverlaps: a,
                                getIntersections: function(t, e, i, n, a, o) {
                                    var h = !e;
                                    h && (e = t);
                                    for(var l = t.length, u = e.length, c = Array(l), d = h ? c : Array(u), p = [], g = 0; g < l; g++)c[g] = t[g].getValues(n);
                                    if (!h) for(var g = 0; g < u; g++)d[g] = e[g].getValues(a);
                                    for(var v = f.findCurveBoundsCollisions(c, d, 1e-7), _ = 0; _ < l; _++){
                                        var m = t[_], y = c[_];
                                        h && s(y, m, p, i);
                                        var b = v[_];
                                        if (b) for(var x = 0; x < b.length; x++){
                                            if (o && p.length) return p;
                                            var w = b[x];
                                            if (!h || w > _) {
                                                var C = e[w];
                                                r(y, d[w], m, C, p, i);
                                            }
                                        }
                                    }
                                    return p;
                                },
                                getCurveLineIntersections: n,
                                getTimesWithTangent: function(t, e) {
                                    var i = t[0], n = t[1], r = t[2], s = t[3], a = t[4], o = t[5], h = t[6], l = t[7], u = e.normalize(), c = u.x, d = u.y, p = 3 * h - 9 * a + 9 * r - 3 * i, f = 3 * l - 9 * o + 9 * s - 3 * n, g = 6 * a - 12 * r + 6 * i, _ = 6 * o - 12 * s + 6 * n, m = 3 * r - 3 * i, y = 3 * s - 3 * n, b = 2 * p * d - 2 * f * c, x = [];
                                    if (Math.abs(b) < v.CURVETIME_EPSILON) {
                                        var b = p * _ - f * g;
                                        if (0 != b) {
                                            var w = -(p * y - f * m) / b;
                                            w >= 0 && w <= 1 && x.push(w);
                                        }
                                    } else {
                                        var C = (g * g - 4 * p * m) * d * d + (-2 * g * _ + 4 * f * m + 4 * p * y) * c * d + (_ * _ - 4 * f * y) * c * c, S = g * d - _ * c;
                                        if (C >= 0 && 0 != b) {
                                            var k = Math.sqrt(C), P = -(S + k) / b, A = (-S + k) / b;
                                            P >= 0 && P <= 1 && x.push(P), A >= 0 && A <= 1 && x.push(A);
                                        }
                                    }
                                    return x;
                                }
                            }
                        };
                    }), V = u.extend({
                        _class: "CurveLocation",
                        initialize: function(t, e, i, n, r) {
                            if (e >= .99999999) {
                                var s = t.getNext();
                                s && (e = 0, t = s);
                            }
                            this._setCurve(t), this._time = e, this._point = i || t.getPointAtTime(e), this._overlap = n, this._distance = r, this._intersection = this._next = this._previous = null;
                        },
                        _setPath: function(t) {
                            this._path = t, this._version = t ? t._version : 0;
                        },
                        _setCurve: function(t) {
                            this._setPath(t._path), this._curve = t, this._segment = null, this._segment1 = t._segment1, this._segment2 = t._segment2;
                        },
                        _setSegment: function(t) {
                            var e = t.getCurve();
                            e ? this._setCurve(e) : (this._setPath(t._path), this._segment1 = t, this._segment2 = null), this._segment = t, this._time = +(t !== this._segment1), this._point = t._point.clone();
                        },
                        getSegment: function() {
                            var t = this._segment;
                            if (!t) {
                                var e = this.getCurve(), i = this.getTime();
                                0 === i ? t = e._segment1 : 1 === i ? t = e._segment2 : null != i && (t = e.getPartLength(0, i) < e.getPartLength(i, 1) ? e._segment1 : e._segment2), this._segment = t;
                            }
                            return t;
                        },
                        getCurve: function() {
                            var t = this._path, e = this;
                            function i(t) {
                                var i = t && t.getCurve();
                                if (i && null != (e._time = i.getTimeOf(e._point))) return e._setCurve(i), i;
                            }
                            return t && t._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null), this._curve || i(this._segment) || i(this._segment1) || i(this._segment2.getPrevious());
                        },
                        getPath: function() {
                            var t = this.getCurve();
                            return t && t._path;
                        },
                        getIndex: function() {
                            var t = this.getCurve();
                            return t && t.getIndex();
                        },
                        getTime: function() {
                            var t = this.getCurve(), e = this._time;
                            return t && null == e ? this._time = t.getTimeOf(this._point) : e;
                        },
                        getParameter: "#getTime",
                        getPoint: function() {
                            return this._point;
                        },
                        getOffset: function() {
                            var t = this._offset;
                            if (null == t) {
                                t = 0;
                                var e = this.getPath(), i = this.getIndex();
                                if (e && null != i) for(var n = e.getCurves(), r = 0; r < i; r++)t += n[r].getLength();
                                this._offset = t += this.getCurveOffset();
                            }
                            return t;
                        },
                        getCurveOffset: function() {
                            var t = this._curveOffset;
                            if (null == t) {
                                var e = this.getCurve(), i = this.getTime();
                                this._curveOffset = t = null != i && e && e.getPartLength(0, i);
                            }
                            return t;
                        },
                        getIntersection: function() {
                            return this._intersection;
                        },
                        getDistance: function() {
                            return this._distance;
                        },
                        divide: function() {
                            var t = this.getCurve(), e = t && t.divideAtTime(this.getTime());
                            return e && this._setSegment(e._segment1), e;
                        },
                        split: function() {
                            var t = this.getCurve(), e = t._path, i = t && t.splitAtTime(this.getTime());
                            return i && this._setSegment(e.getLastSegment()), i;
                        },
                        equals: function(t, e) {
                            var i = this === t;
                            if (!i && t instanceof V) {
                                var n = this.getCurve(), r = t.getCurve(), s = n._path;
                                if (s === r._path) {
                                    var a = Math.abs, o = a(this.getOffset() - t.getOffset()), h = !e && this._intersection, l = !e && t._intersection;
                                    i = (o < 1e-7 || s && 1e-7 > a(s.getLength() - o)) && (!h && !l || h && l && h.equals(l, !0));
                                }
                            }
                            return i;
                        },
                        toString: function() {
                            var t = [], e = this.getPoint(), i = g.instance;
                            e && t.push("point: " + e);
                            var n = this.getIndex();
                            null != n && t.push("index: " + n);
                            var r = this.getTime();
                            return null != r && t.push("time: " + i.number(r)), null != this._distance && t.push("distance: " + i.number(this._distance)), "{ " + t.join(", ") + " }";
                        },
                        isTouching: function() {
                            var t = this._intersection;
                            if (t && this.getTangent().isCollinear(t.getTangent())) {
                                var e = this.getCurve(), i = t.getCurve();
                                return !(e.isStraight() && i.isStraight() && e.getLine().intersect(i.getLine()));
                            }
                            return !1;
                        },
                        isCrossing: function() {
                            var t = this._intersection;
                            if (!t) return !1;
                            var e = this.getTime(), i = t.getTime(), n = e >= 1e-8 && e <= .99999999, r = i >= 1e-8 && i <= .99999999;
                            if (n && r) return !this.isTouching();
                            var s = this.getCurve(), a = s && e < 1e-8 ? s.getPrevious() : s, o = t.getCurve(), h = o && i < 1e-8 ? o.getPrevious() : o;
                            if (e > .99999999 && (s = s.getNext()), i > .99999999 && (o = o.getNext()), !a || !s || !h || !o) return !1;
                            var l = [];
                            function u(t, e) {
                                var i = t.getValues(), n = R.classify(i).roots || R.getPeaks(i), r = n.length, s = R.getLength(i, e && r ? n[r - 1] : 0, !e && r ? n[0] : 1);
                                l.push(r ? s : s / 32);
                            }
                            function c(t, e, i) {
                                return e < i ? t > e && t < i : t > e || t < i;
                            }
                            n || (u(a, !0), u(s, !1)), r || (u(h, !0), u(o, !1));
                            var d = this.getPoint(), p = Math.min.apply(Math, l), f = n ? s.getTangentAtTime(e) : s.getPointAt(p).subtract(d), g = n ? f.negate() : a.getPointAt(-p).subtract(d), v = r ? o.getTangentAtTime(i) : o.getPointAt(p).subtract(d), _ = r ? v.negate() : h.getPointAt(-p).subtract(d), m = g.getAngle(), y = f.getAngle(), b = _.getAngle(), x = v.getAngle();
                            return !!(n ? c(m, b, x) ^ c(y, b, x) && c(m, x, b) ^ c(y, x, b) : c(b, m, y) ^ c(x, m, y) && c(b, y, m) ^ c(x, y, m));
                        },
                        hasOverlap: function() {
                            return !!this._overlap;
                        }
                    }, u.each(R._evaluateMethods, function(t) {
                        var e = t + "At";
                        this[t] = function() {
                            var t = this.getCurve(), i = this.getTime();
                            return null != i && t && t[e](i, !0);
                        };
                    }, {
                        preserve: !0
                    }), new function() {
                        function t(t, e, i) {
                            var n = t.length, r = 0, s = n - 1;
                            function a(i, r) {
                                for(var s = i + r; s >= -1 && s <= n; s += r){
                                    var a = t[(s % n + n) % n];
                                    if (!e.getPoint().isClose(a.getPoint(), 1e-7)) break;
                                    if (e.equals(a)) return a;
                                }
                                return null;
                            }
                            for(; r <= s;){
                                var o, h = r + s >>> 1, l = t[h];
                                if (i && (o = e.equals(l) ? l : a(h, -1) || a(h, 1))) return e._overlap && (o._overlap = o._intersection._overlap = !0), o;
                                var u = e.getPath(), c = l.getPath();
                                (u !== c ? u._id - c._id : e.getIndex() + e.getTime() - (l.getIndex() + l.getTime())) < 0 ? s = h - 1 : r = h + 1;
                            }
                            return t.splice(r, 0, e), e;
                        }
                        return {
                            statics: {
                                insert: t,
                                expand: function(e) {
                                    for(var i = e.slice(), n = e.length - 1; n >= 0; n--)t(i, e[n]._intersection, !1);
                                    return i;
                                }
                            }
                        };
                    }), F = A.extend({
                        _class: "PathItem",
                        _selectBounds: !1,
                        _canScaleStroke: !0,
                        beans: !0,
                        initialize: function() {},
                        statics: {
                            create: function(t) {
                                if (u.isPlainObject(t) ? (i = t.segments, e = t.pathData) : Array.isArray(t) ? i = t : "string" == typeof t && (e = t), i) {
                                    var e, i, n, r = i[0];
                                    n = r && Array.isArray(r[0]);
                                } else e && (n = (e.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(e));
                                return new (n ? j : D)(t);
                            }
                        },
                        _asPathItem: function() {
                            return this;
                        },
                        isClockwise: function() {
                            return this.getArea() >= 0;
                        },
                        setClockwise: function(t) {
                            this.isClockwise() != (t = !!t) && this.reverse();
                        },
                        setPathData: function(t) {
                            var e, i, n, r = t && t.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), s = !1, a = new m, o = new m;
                            function h(t, i) {
                                var n = +e[t];
                                return s && (n += a[i]), n;
                            }
                            function l(t) {
                                return new m(h(t, "x"), h(t + 1, "y"));
                            }
                            this.clear();
                            for(var u = 0, c = r && r.length; u < c; u++){
                                var d = r[u], p = d[0], f = p.toLowerCase(), g = (e = d.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g)) && e.length;
                                switch(s = p === f, "z" === i && !/[mz]/.test(f) && this.moveTo(a), f){
                                    case "m":
                                    case "l":
                                        for(var v = "m" === f, _ = 0; _ < g; _ += 2)this[v ? "moveTo" : "lineTo"](a = l(_)), v && (o = a, v = !1);
                                        n = a;
                                        break;
                                    case "h":
                                    case "v":
                                        var y = "h" === f ? "x" : "y";
                                        a = a.clone();
                                        for(var _ = 0; _ < g; _++)a[y] = h(_, y), this.lineTo(a);
                                        n = a;
                                        break;
                                    case "c":
                                        for(var _ = 0; _ < g; _ += 6)this.cubicCurveTo(l(_), n = l(_ + 2), a = l(_ + 4));
                                        break;
                                    case "s":
                                        for(var _ = 0; _ < g; _ += 4)this.cubicCurveTo(/[cs]/.test(i) ? a.multiply(2).subtract(n) : a, n = l(_), a = l(_ + 2)), i = f;
                                        break;
                                    case "q":
                                        for(var _ = 0; _ < g; _ += 4)this.quadraticCurveTo(n = l(_), a = l(_ + 2));
                                        break;
                                    case "t":
                                        for(var _ = 0; _ < g; _ += 2)this.quadraticCurveTo(n = /[qt]/.test(i) ? a.multiply(2).subtract(n) : a, a = l(_)), i = f;
                                        break;
                                    case "a":
                                        for(var _ = 0; _ < g; _ += 7)this.arcTo(a = l(_ + 5), new b(+e[_], +e[_ + 1]), +e[_ + 2], +e[_ + 4], +e[_ + 3]);
                                        break;
                                    case "z":
                                        this.closePath(1e-12), a = o;
                                }
                                i = f;
                            }
                        },
                        _canComposite: function() {
                            return !(this.hasFill() && this.hasStroke());
                        },
                        _contains: function(t) {
                            var e = t.isInside(this.getBounds({
                                internal: !0,
                                handle: !0
                            })) ? this._getWinding(t) : {};
                            return e.onPath || !!("evenodd" === this.getFillRule() ? 1 & e.windingL || 1 & e.windingR : e.winding);
                        },
                        getIntersections: function(t, e, i, n) {
                            var r = this === t || !t, s = this._matrix._orNullIfIdentity(), a = r ? s : (i || t._matrix)._orNullIfIdentity();
                            return r || this.getBounds(s).intersects(t.getBounds(a), 1e-12) ? R.getIntersections(this.getCurves(), !r && t.getCurves(), e, s, a, n) : [];
                        },
                        getCrossings: function(t) {
                            return this.getIntersections(t, function(t) {
                                return t.isCrossing();
                            });
                        },
                        getNearestLocation: function() {
                            for(var t = m.read(arguments), e = this.getCurves(), i = 1 / 0, n = null, r = 0, s = e.length; r < s; r++){
                                var a = e[r].getNearestLocation(t);
                                a._distance < i && (i = a._distance, n = a);
                            }
                            return n;
                        },
                        getNearestPoint: function() {
                            var t = this.getNearestLocation.apply(this, arguments);
                            return t ? t.getPoint() : t;
                        },
                        interpolate: function(t, e, i) {
                            var n = !this._children, r = n ? "_segments" : "_children", s = t[r], a = e[r], o = this[r];
                            if (!s || !a || s.length !== a.length) throw Error("Invalid operands in interpolate() call: " + t + ", " + e);
                            var h = o.length, l = a.length;
                            if (h < l) for(var u = n ? N : D, c = h; c < l; c++)this.add(new u);
                            else h > l && this[n ? "removeSegments" : "removeChildren"](l, h);
                            for(var c = 0; c < l; c++)o[c].interpolate(s[c], a[c], i);
                            n && (this.setClosed(t._closed), this._changed(9));
                        },
                        compare: function(t) {
                            var e = !1;
                            if (t) {
                                var i = this._children || [
                                    this
                                ], n = t._children ? t._children.slice() : [
                                    t
                                ], r = i.length, s = n.length, a = [], o = 0;
                                e = !0;
                                for(var h = f.findItemBoundsCollisions(i, n, v.GEOMETRIC_EPSILON), l = r - 1; l >= 0 && e; l--){
                                    var u = i[l];
                                    e = !1;
                                    var c = h[l];
                                    if (c) for(var d = c.length - 1; d >= 0 && !e; d--)u.compare(n[c[d]]) && (!a[c[d]] && (a[c[d]] = !0, o++), e = !0);
                                }
                                e = e && o === s;
                            }
                            return e;
                        }
                    }), D = F.extend({
                        _class: "Path",
                        _serializeFields: {
                            segments: [],
                            closed: !1
                        },
                        initialize: function(t) {
                            this._closed = !1, this._segments = [], this._version = 0;
                            var e = arguments, i = Array.isArray(t) ? "object" == typeof t[0] ? t : e : t && t.size === o && (t.x !== o || t.point !== o) ? e : null;
                            i && i.length > 0 ? this.setSegments(i) : (this._curves = o, this._segmentSelection = 0, i || "string" != typeof t || (this.setPathData(t), t = null)), this._initialize(!i && t);
                        },
                        _equals: function(t) {
                            return this._closed === t._closed && u.equals(this._segments, t._segments);
                        },
                        copyContent: function(t) {
                            this.setSegments(t._segments), this._closed = t._closed;
                        },
                        _changed: function t(e) {
                            if (t.base.call(this, e), 8 & e) {
                                if (this._length = this._area = o, 32 & e) this._version++;
                                else if (this._curves) for(var i = 0, n = this._curves.length; i < n; i++)this._curves[i]._changed();
                            } else 64 & e && (this._bounds = o);
                        },
                        getStyle: function() {
                            var t = this._parent;
                            return (t instanceof j ? t : this)._style;
                        },
                        getSegments: function() {
                            return this._segments;
                        },
                        setSegments: function(t) {
                            var e = this.isFullySelected(), i = t && t.length;
                            if (this._segments.length = 0, this._segmentSelection = 0, this._curves = o, i) {
                                var n = t[i - 1];
                                "boolean" == typeof n && (this.setClosed(n), i--), this._add(N.readList(t, 0, {}, i));
                            }
                            e && this.setFullySelected(!0);
                        },
                        getFirstSegment: function() {
                            return this._segments[0];
                        },
                        getLastSegment: function() {
                            return this._segments[this._segments.length - 1];
                        },
                        getCurves: function() {
                            var t = this._curves, e = this._segments;
                            if (!t) {
                                var i = this._countCurves();
                                t = this._curves = Array(i);
                                for(var n = 0; n < i; n++)t[n] = new R(this, e[n], e[n + 1] || e[0]);
                            }
                            return t;
                        },
                        getFirstCurve: function() {
                            return this.getCurves()[0];
                        },
                        getLastCurve: function() {
                            var t = this.getCurves();
                            return t[t.length - 1];
                        },
                        isClosed: function() {
                            return this._closed;
                        },
                        setClosed: function(t) {
                            if (this._closed != (t = !!t)) {
                                if (this._closed = t, this._curves) {
                                    var e = this._curves.length = this._countCurves();
                                    t && (this._curves[e - 1] = new R(this, this._segments[e - 1], this._segments[0]));
                                }
                                this._changed(41);
                            }
                        }
                    }, {
                        beans: !0,
                        getPathData: function(t, e) {
                            var i, n, r, s, a, o, h, l, u = this._segments, c = u.length, d = new g(e), p = Array(6), f = !0, v = [];
                            function _(e, u) {
                                if (e._transformCoordinates(t, p), i = p[0], n = p[1], f) v.push("M" + d.pair(i, n)), f = !1;
                                else if (a = p[2], o = p[3], a === i && o === n && h === r && l === s) {
                                    if (!u) {
                                        var c = i - r, g = n - s;
                                        v.push(0 === c ? "v" + d.number(g) : 0 === g ? "h" + d.number(c) : "l" + d.pair(c, g));
                                    }
                                } else v.push("c" + d.pair(h - r, l - s) + " " + d.pair(a - r, o - s) + " " + d.pair(i - r, n - s));
                                r = i, s = n, h = p[4], l = p[5];
                            }
                            if (!c) return "";
                            for(var m = 0; m < c; m++)_(u[m]);
                            return this._closed && c > 0 && (_(u[0], !0), v.push("z")), v.join("");
                        },
                        isEmpty: function() {
                            return !this._segments.length;
                        },
                        _transformContent: function(t) {
                            for(var e = this._segments, i = Array(6), n = 0, r = e.length; n < r; n++)e[n]._transformCoordinates(t, i, !0);
                            return !0;
                        },
                        _add: function(t, e) {
                            for(var i = this._segments, n = this._curves, r = t.length, s = null == e, e = s ? i.length : e, a = 0; a < r; a++){
                                var o = t[a];
                                o._path && (o = t[a] = o.clone()), o._path = this, o._index = e + a, o._selection && this._updateSelection(o, 0, o._selection);
                            }
                            if (s) u.push(i, t);
                            else {
                                i.splice.apply(i, [
                                    e,
                                    0
                                ].concat(t));
                                for(var a = e + r, h = i.length; a < h; a++)i[a]._index = a;
                            }
                            if (n) {
                                var l = this._countCurves(), c = e > 0 && e + r - 1 === l ? e - 1 : e, d = c, p = Math.min(c + r, l);
                                t._curves && (n.splice.apply(n, [
                                    c,
                                    0
                                ].concat(t._curves)), d += t._curves.length);
                                for(var a = d; a < p; a++)n.splice(a, 0, new R(this, null, null));
                                this._adjustCurves(c, p);
                            }
                            return this._changed(41), t;
                        },
                        _adjustCurves: function(t, e) {
                            for(var i, n = this._segments, r = this._curves, s = t; s < e; s++)(i = r[s])._path = this, i._segment1 = n[s], i._segment2 = n[s + 1] || n[0], i._changed();
                            (i = r[this._closed && !t ? n.length - 1 : t - 1]) && (i._segment2 = n[t] || n[0], i._changed()), (i = r[e]) && (i._segment1 = n[e], i._changed());
                        },
                        _countCurves: function() {
                            var t = this._segments.length;
                            return !this._closed && t > 0 ? t - 1 : t;
                        },
                        add: function(t) {
                            var e = arguments;
                            return e.length > 1 && "number" != typeof t ? this._add(N.readList(e)) : this._add([
                                N.read(e)
                            ])[0];
                        },
                        insert: function(t, e) {
                            var i = arguments;
                            return i.length > 2 && "number" != typeof e ? this._add(N.readList(i, 1), t) : this._add([
                                N.read(i, 1)
                            ], t)[0];
                        },
                        addSegment: function() {
                            return this._add([
                                N.read(arguments)
                            ])[0];
                        },
                        insertSegment: function(t) {
                            return this._add([
                                N.read(arguments, 1)
                            ], t)[0];
                        },
                        addSegments: function(t) {
                            return this._add(N.readList(t));
                        },
                        insertSegments: function(t, e) {
                            return this._add(N.readList(e), t);
                        },
                        removeSegment: function(t) {
                            return this.removeSegments(t, t + 1)[0] || null;
                        },
                        removeSegments: function(t, e, i) {
                            t = t || 0, e = u.pick(e, this._segments.length);
                            var n = this._segments, r = this._curves, s = n.length, a = n.splice(t, e - t), o = a.length;
                            if (!o) return a;
                            for(var h = 0; h < o; h++){
                                var l = a[h];
                                l._selection && this._updateSelection(l, l._selection, 0), l._index = l._path = null;
                            }
                            for(var h = t, c = n.length; h < c; h++)n[h]._index = h;
                            if (r) {
                                for(var d = t > 0 && e === s + +!!this._closed ? t - 1 : t, r = r.splice(d, o), h = r.length - 1; h >= 0; h--)r[h]._path = null;
                                i && (a._curves = r.slice(1)), this._adjustCurves(d, d);
                            }
                            return this._changed(41), a;
                        },
                        clear: "#removeSegments",
                        hasHandles: function() {
                            for(var t = this._segments, e = 0, i = t.length; e < i; e++)if (t[e].hasHandles()) return !0;
                            return !1;
                        },
                        clearHandles: function() {
                            for(var t = this._segments, e = 0, i = t.length; e < i; e++)t[e].clearHandles();
                        },
                        getLength: function() {
                            if (null == this._length) {
                                for(var t = this.getCurves(), e = 0, i = 0, n = t.length; i < n; i++)e += t[i].getLength();
                                this._length = e;
                            }
                            return this._length;
                        },
                        getArea: function() {
                            var t = this._area;
                            if (null == t) {
                                var e = this._segments, i = this._closed;
                                t = 0;
                                for(var n = 0, r = e.length; n < r; n++){
                                    var s = n + 1 === r;
                                    t += R.getArea(R.getValues(e[n], e[s ? 0 : n + 1], null, s && !i));
                                }
                                this._area = t;
                            }
                            return t;
                        },
                        isFullySelected: function() {
                            var t = this._segments.length;
                            return this.isSelected() && t > 0 && this._segmentSelection === 7 * t;
                        },
                        setFullySelected: function(t) {
                            t && this._selectSegments(!0), this.setSelected(t);
                        },
                        setSelection: function t(e) {
                            1 & e || this._selectSegments(!1), t.base.call(this, e);
                        },
                        _selectSegments: function(t) {
                            var e = this._segments, i = e.length, n = 7 * !!t;
                            this._segmentSelection = n * i;
                            for(var r = 0; r < i; r++)e[r]._selection = n;
                        },
                        _updateSelection: function(t, e, i) {
                            t._selection = i, (this._segmentSelection += i - e) > 0 && this.setSelected(!0);
                        },
                        divideAt: function(t) {
                            var e, i = this.getLocationAt(t);
                            return i && (e = i.getCurve().divideAt(i.getCurveOffset())) ? e._segment1 : null;
                        },
                        splitAt: function(t) {
                            var e = this.getLocationAt(t), i = e && e.index, n = e && e.time;
                            n > .99999999 && (i++, n = 0);
                            var r = this.getCurves();
                            if (i >= 0 && i < r.length) {
                                n >= 1e-8 && r[i++].divideAtTime(n);
                                var s, a = this.removeSegments(i, this._segments.length, !0);
                                return this._closed ? (this.setClosed(!1), s = this) : ((s = new D(A.NO_INSERT)).insertAbove(this), s.copyAttributes(this)), s._add(a, 0), this.addSegment(a[0]), s;
                            }
                            return null;
                        },
                        split: function(t, e) {
                            var i, n = e === o ? t : (i = this.getCurves()[t]) && i.getLocationAtTime(e);
                            return null != n ? this.splitAt(n) : null;
                        },
                        join: function(t, e) {
                            var i = e || 0;
                            if (t && t !== this) {
                                var n = t._segments, r = this.getLastSegment(), s = t.getLastSegment();
                                if (!s) return this;
                                r && r._point.isClose(s._point, i) && t.reverse();
                                var a = t.getFirstSegment();
                                if (r && r._point.isClose(a._point, i)) r.setHandleOut(a._handleOut), this._add(n.slice(1));
                                else {
                                    var o = this.getFirstSegment();
                                    o && o._point.isClose(a._point, i) && t.reverse(), s = t.getLastSegment(), o && o._point.isClose(s._point, i) ? (o.setHandleIn(s._handleIn), this._add(n.slice(0, n.length - 1), 0)) : this._add(n.slice());
                                }
                                t._closed && this._add([
                                    n[0]
                                ]), t.remove();
                            }
                            var h = this.getFirstSegment(), l = this.getLastSegment();
                            return h !== l && h._point.isClose(l._point, i) && (h.setHandleIn(l._handleIn), l.remove(), this.setClosed(!0)), this;
                        },
                        reduce: function(t) {
                            for(var e = this.getCurves(), i = t && t.simplify, n = 1e-7 * !!i, r = e.length - 1; r >= 0; r--){
                                var s = e[r];
                                !s.hasHandles() && (!s.hasLength(n) || i && s.isCollinear(s.getNext())) && s.remove();
                            }
                            return this;
                        },
                        reverse: function() {
                            this._segments.reverse();
                            for(var t = 0, e = this._segments.length; t < e; t++){
                                var i = this._segments[t], n = i._handleIn;
                                i._handleIn = i._handleOut, i._handleOut = n, i._index = t;
                            }
                            this._curves = null, this._changed(9);
                        },
                        flatten: function(t) {
                            for(var e = new H(this, t || .25, 256, !0).parts, i = e.length, n = [], r = 0; r < i; r++)n.push(new N(e[r].curve.slice(0, 2)));
                            !this._closed && i > 0 && n.push(new N(e[i - 1].curve.slice(6))), this.setSegments(n);
                        },
                        simplify: function(t) {
                            var e = new q(this).fit(t || 2.5);
                            return e && this.setSegments(e), !!e;
                        },
                        smooth: function(t) {
                            var e = this, i = t || {}, n = i.type || "asymmetric", r = this._segments, s = r.length, a = this._closed;
                            function h(t, i) {
                                var n = t && t.index;
                                if (null != n) {
                                    var r = t.path;
                                    if (r && r !== e) throw Error(t._class + " " + n + " of " + r + " is not part of " + e);
                                    i && t instanceof R && n++;
                                } else n = "number" == typeof t ? t : i;
                                return Math.min(n < 0 && a ? n % s : n < 0 ? n + s : n, s - 1);
                            }
                            var l = a && i.from === o && i.to === o, u = h(i.from, 0), c = h(i.to, s - 1);
                            if (u > c) {
                                if (a) u -= s;
                                else {
                                    var d = u;
                                    u = c, c = d;
                                }
                            }
                            if (/^(?:asymmetric|continuous)$/.test(n)) {
                                var p = "asymmetric" === n, f = Math.min, g = c - u + 1, v = g - 1, _ = l ? f(g, 4) : 1, m = _, y = _, b = [];
                                if (a || (m = f(1, u), y = f(1, s - c - 1)), (v += m + y) <= 1) return;
                                for(var x = 0, w = u - m; x <= v; x++, w++)b[x] = r[(w < 0 ? w + s : w) % s]._point;
                                for(var C = b[0]._x + 2 * b[1]._x, S = b[0]._y + 2 * b[1]._y, k = 2, P = v - 1, A = [
                                    C
                                ], I = [
                                    S
                                ], T = [
                                    2
                                ], E = [], L = [], x = 1; x < v; x++){
                                    var M = x < P, B = M || p ? 1 : 2, O = M ? 4 : p ? 2 : 7, N = M ? 4 : p ? 3 : 8, z = M ? 2 : +!p, V = B / k;
                                    k = T[x] = O - V, C = A[x] = N * b[x]._x + z * b[x + 1]._x - V * C, S = I[x] = N * b[x]._y + z * b[x + 1]._y - V * S;
                                }
                                E[P] = A[P] / T[P], L[P] = I[P] / T[P];
                                for(var x = v - 2; x >= 0; x--)E[x] = (A[x] - E[x + 1]) / T[x], L[x] = (I[x] - L[x + 1]) / T[x];
                                E[v] = (3 * b[v]._x - E[P]) / 2, L[v] = (3 * b[v]._y - L[P]) / 2;
                                for(var x = m, F = v - y, w = u; x <= F; x++, w++){
                                    var D = r[w < 0 ? w + s : w], j = D._point, H = E[x] - j._x, q = L[x] - j._y;
                                    (l || x < F) && D.setHandleOut(H, q), (l || x > m) && D.setHandleIn(-H, -q);
                                }
                            } else for(var x = u; x <= c; x++)r[x < 0 ? x + s : x].smooth(i, !l && x === u, !l && x === c);
                        },
                        toShape: function(t) {
                            if (!this._closed) return null;
                            var e, i, n, r, s, a, h, l = this._segments;
                            function u(t, e) {
                                var i = l[t], n = i.getNext(), r = l[e], s = r.getNext();
                                return i._handleOut.isZero() && n._handleIn.isZero() && r._handleOut.isZero() && s._handleIn.isZero() && n._point.subtract(i._point).isCollinear(s._point.subtract(r._point));
                            }
                            function c(t) {
                                var e = l[t], i = e.getNext(), n = e._handleOut, r = i._handleIn;
                                if (n.isOrthogonal(r)) {
                                    var s = e._point, a = i._point, o = new k(s, n, !0).intersect(new k(a, r, !0), !0);
                                    return o && v.isZero(n.getLength() / o.subtract(s).getLength() - .5522847498307936) && v.isZero(r.getLength() / o.subtract(a).getLength() - .5522847498307936);
                                }
                                return !1;
                            }
                            function d(t, e) {
                                return l[t]._point.getDistance(l[e]._point);
                            }
                            if (!this.hasHandles() && 4 === l.length && u(0, 2) && u(1, 3) && (i = (e = l[1]).getPrevious(), n = e.getNext(), i._handleOut.isZero() && e._handleIn.isZero() && e._handleOut.isZero() && n._handleIn.isZero() && e._point.subtract(i._point).isOrthogonal(n._point.subtract(e._point))) ? (r = E.Rectangle, s = new b(d(0, 3), d(0, 1)), h = l[1]._point.add(l[2]._point).divide(2)) : 8 === l.length && c(0) && c(2) && c(4) && c(6) && u(1, 5) && u(3, 7) ? (r = E.Rectangle, a = (s = new b(d(1, 6), d(0, 3))).subtract(new b(d(0, 7), d(1, 2))).divide(2), h = l[3]._point.add(l[4]._point).divide(2)) : 4 === l.length && c(0) && c(1) && c(2) && c(3) && (v.isZero(d(0, 2) - d(1, 3)) ? (r = E.Circle, a = d(0, 2) / 2) : (r = E.Ellipse, a = new b(d(2, 0) / 2, d(3, 1) / 2)), h = l[1]._point), r) {
                                var p = this.getPosition(!0), f = new r({
                                    center: p,
                                    size: s,
                                    radius: a,
                                    insert: !1
                                });
                                return f.copyAttributes(this, !0), f._matrix.prepend(this._matrix), f.rotate(h.subtract(p).getAngle() + 90), (t === o || t) && f.insertAbove(this), f;
                            }
                            return null;
                        },
                        toPath: "#clone",
                        compare: function t(e) {
                            if (!e || e instanceof j) return t.base.call(this, e);
                            var i = this.getCurves(), n = e.getCurves(), r = i.length, s = n.length;
                            if (!r || !s) return r == s;
                            for(var a, o, h = i[0].getValues(), l = [], u = 0, c = 0, d = 0; d < s; d++){
                                var p = n[d].getValues();
                                l.push(p);
                                var f = R.getOverlaps(h, p);
                                if (f) {
                                    a = !d && f[0][0] > 0 ? s - 1 : d, o = f[0][1];
                                    break;
                                }
                            }
                            for(var g, v = Math.abs, p = l[a]; h && p;){
                                var f = R.getOverlaps(h, p);
                                if (f && 1e-8 > v(f[0][0] - c)) {
                                    1 === (c = f[1][0]) && (h = ++u < r ? i[u].getValues() : null, c = 0);
                                    var _ = f[0][1];
                                    if (1e-8 > v(_ - o)) {
                                        if (g || (g = [
                                            a,
                                            _
                                        ]), 1 === (o = f[1][1]) && (++a >= s && (a = 0), p = l[a] || n[a].getValues(), o = 0), !h) return g[0] === a && g[1] === o;
                                        continue;
                                    }
                                }
                                break;
                            }
                            return !1;
                        },
                        _hitTestSelf: function(t, e, i, n) {
                            var r, s, a, o, h, l, u = this, c = this.getStyle(), d = this._segments, p = d.length, f = this._closed, g = e._tolerancePadding, v = g, _ = e.stroke && c.hasStroke(), m = e.fill && c.hasFill(), y = e.curves, b = _ ? c.getStrokeWidth() / 2 : m && e.tolerance > 0 || y ? 0 : null;
                            function x(e, i) {
                                return t.subtract(e).divide(i).length <= 1;
                            }
                            function w(t, i, n) {
                                if (!e.selected || i.isSelected()) {
                                    var r = t._point;
                                    if (i !== r && (i = i.add(r)), x(i, v)) return new O(n, u, {
                                        segment: t,
                                        point: i
                                    });
                                }
                            }
                            function C(t, i) {
                                return (i || e.segments) && w(t, t._point, "segment") || !i && e.handles && (w(t, t._handleIn, "handle-in") || w(t, t._handleOut, "handle-out"));
                            }
                            function S(t) {
                                o.add(t);
                            }
                            function k(e) {
                                var i, h = f || e._index > 0 && e._index < p - 1;
                                return (h ? r : s) === "round" ? x(e._point, v) : (o = new D({
                                    internal: !0,
                                    closed: !0
                                }), h ? e.isSmooth() || D._addBevelJoin(e, r, b, a, null, n, S, !0) : "square" === s && D._addSquareCap(e, s, b, null, n, S, !0), o.isEmpty()) ? void 0 : o.contains(t) || (i = o.getNearestLocation(t)) && x(i.getPoint(), g);
                            }
                            if (null !== b && (b > 0 ? (r = c.getStrokeJoin(), s = c.getStrokeCap(), a = c.getMiterLimit(), v = v.add(D._getStrokePadding(b, n))) : r = s = "round"), !e.ends || e.segments || f) {
                                if (e.segments || e.handles) {
                                    for(var P = 0; P < p; P++)if (l = C(d[P])) return l;
                                }
                            } else if (l = C(d[0], !0) || C(d[p - 1], !0)) return l;
                            if (null !== b) {
                                if (h = this.getNearestLocation(t)) {
                                    var A = h.getTime();
                                    0 === A || 1 === A && p > 1 ? k(h.getSegment()) || (h = null) : x(h.getPoint(), v) || (h = null);
                                }
                                if (!h && "miter" === r && p > 1) for(var P = 0; P < p; P++){
                                    var I = d[P];
                                    if (t.getDistance(I._point) <= a * b && k(I)) {
                                        h = I.getLocation();
                                        break;
                                    }
                                }
                            }
                            return !h && m && this._contains(t) || h && !_ && !y ? new O("fill", this) : h ? new O(_ ? "stroke" : "curve", this, {
                                location: h,
                                point: h.getPoint()
                            }) : null;
                        }
                    }, u.each(R._evaluateMethods, function(t) {
                        this[t + "At"] = function(e) {
                            var i = this.getLocationAt(e);
                            return i && i[t]();
                        };
                    }, {
                        beans: !1,
                        getLocationOf: function() {
                            for(var t = m.read(arguments), e = this.getCurves(), i = 0, n = e.length; i < n; i++){
                                var r = e[i].getLocationOf(t);
                                if (r) return r;
                            }
                            return null;
                        },
                        getOffsetOf: function() {
                            var t = this.getLocationOf.apply(this, arguments);
                            return t ? t.getOffset() : null;
                        },
                        getLocationAt: function(t) {
                            if ("number" == typeof t) {
                                for(var e = this.getCurves(), i = 0, n = 0, r = e.length; n < r; n++){
                                    var s = i, a = e[n];
                                    if ((i += a.getLength()) > t) return a.getLocationAt(t - s);
                                }
                                if (e.length > 0 && t <= this.getLength()) return new V(e[e.length - 1], 1);
                            } else if (t && t.getPath && t.getPath() === this) return t;
                            return null;
                        },
                        getOffsetsWithTangent: function() {
                            var t = m.read(arguments);
                            if (t.isZero()) return [];
                            for(var e = [], i = 0, n = this.getCurves(), r = 0, s = n.length; r < s; r++){
                                for(var a = n[r], o = a.getTimesWithTangent(t), h = 0, l = o.length; h < l; h++){
                                    var u = i + a.getOffsetAtTime(o[h]);
                                    0 > e.indexOf(u) && e.push(u);
                                }
                                i += a.length;
                            }
                            return e;
                        }
                    }), new function() {
                        function t(t, e, i) {
                            var n, r, s, a, o, h, l, u, c = e._segments, d = c.length, p = Array(6), f = !0;
                            function g(e) {
                                if (i) e._transformCoordinates(i, p), n = p[0], r = p[1];
                                else {
                                    var c = e._point;
                                    n = c._x, r = c._y;
                                }
                                if (f) t.moveTo(n, r), f = !1;
                                else {
                                    if (i) o = p[2], h = p[3];
                                    else {
                                        var d = e._handleIn;
                                        o = n + d._x, h = r + d._y;
                                    }
                                    o === n && h === r && l === s && u === a ? t.lineTo(n, r) : t.bezierCurveTo(l, u, o, h, n, r);
                                }
                                if (s = n, a = r, i) l = p[4], u = p[5];
                                else {
                                    var d = e._handleOut;
                                    l = s + d._x, u = a + d._y;
                                }
                            }
                            for(var v = 0; v < d; v++)g(c[v]);
                            e._closed && d > 0 && g(c[0]);
                        }
                        return {
                            _draw: function(e, i, n, r) {
                                var s = i.dontStart, a = i.dontFinish || i.clip, o = this.getStyle(), h = o.hasFill(), l = o.hasStroke(), u = o.getDashArray(), c = !td.support.nativeDash && l && u && u.length;
                                function d(t) {
                                    return u[(t % c + c) % c];
                                }
                                if (s || e.beginPath(), (h || l && !c || a) && (t(e, this, r), this._closed && e.closePath()), !a && (h || l) && (this._setStyles(e, i, n), h && (e.fill(o.getFillRule()), e.shadowColor = "rgba(0,0,0,0)"), l)) {
                                    if (c) {
                                        s || e.beginPath();
                                        for(var p, f = new H(this, .25, 32, !1, r), g = f.length, v = -o.getDashOffset(), _ = 0; v > 0;)v -= d(_--) + d(_--);
                                        for(; v < g;)p = v + d(_++), (v > 0 || p > 0) && f.drawPart(e, Math.max(v, 0), Math.max(p, 0)), v = p + d(_++);
                                    }
                                    e.stroke();
                                }
                            },
                            _drawSelected: function(e, i) {
                                e.beginPath(), t(e, this, i), e.stroke(), function(t, e, i, n) {
                                    if (!(n <= 0)) for(var r, s, a = n / 2, o = n - 2, h = a - 1, l = Array(6), u = 0, c = e.length; u < c; u++){
                                        var d = e[u], p = d._selection;
                                        if (d._transformCoordinates(i, l), r = l[0], s = l[1], 2 & p && g(2), 4 & p && g(4), t.fillRect(r - a, s - a, n, n), o > 0 && !(1 & p)) {
                                            var f = t.fillStyle;
                                            t.fillStyle = "#ffffff", t.fillRect(r - h, s - h, o, o), t.fillStyle = f;
                                        }
                                    }
                                    function g(e) {
                                        var i = l[e], n = l[e + 1];
                                        (r != i || s != n) && (t.beginPath(), t.moveTo(r, s), t.lineTo(i, n), t.stroke(), t.beginPath(), t.arc(i, n, a, 0, 2 * Math.PI, !0), t.fill());
                                    }
                                }(e, this._segments, i, td.settings.handleSize);
                            }
                        };
                    }, new function() {
                        function t(t) {
                            var e = t._segments;
                            if (!e.length) throw Error("Use a moveTo() command first");
                            return e[e.length - 1];
                        }
                        return {
                            moveTo: function() {
                                var t = this._segments;
                                1 === t.length && this.removeSegment(0), t.length || this._add([
                                    new N(m.read(arguments))
                                ]);
                            },
                            moveBy: function() {
                                throw Error("moveBy() is unsupported on Path items.");
                            },
                            lineTo: function() {
                                this._add([
                                    new N(m.read(arguments))
                                ]);
                            },
                            cubicCurveTo: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = m.read(e), s = t(this);
                                s.setHandleOut(i.subtract(s._point)), this._add([
                                    new N(r, n.subtract(r))
                                ]);
                            },
                            quadraticCurveTo: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = t(this)._point;
                                this.cubicCurveTo(i.add(r.subtract(i).multiply(1 / 3)), i.add(n.subtract(i).multiply(1 / 3)), n);
                            },
                            curveTo: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = u.pick(u.read(e), .5), s = 1 - r, a = t(this)._point, o = i.subtract(a.multiply(s * s)).subtract(n.multiply(r * r)).divide(2 * r * s);
                                if (o.isNaN()) throw Error("Cannot put a curve through points with parameter = " + r);
                                this.quadraticCurveTo(o, n);
                            },
                            arcTo: function() {
                                var e, i, n, r, s, a = arguments, o = Math.abs, h = Math.sqrt, l = t(this), c = l._point, d = m.read(a), p = u.peek(a), f = u.pick(p, !0);
                                if ("boolean" == typeof f) var g = c.add(d).divide(2), e = g.add(g.subtract(c).rotate(f ? -90 : 90));
                                else if (2 >= u.remain(a)) e = d, d = m.read(a);
                                else if (!c.equals(d)) {
                                    var _ = b.read(a), y = v.isZero;
                                    if (y(_.width) || y(_.height)) return this.lineTo(d);
                                    var x = u.read(a), f = !!u.read(a), w = !!u.read(a), g = c.add(d).divide(2), C = c.subtract(g).rotate(-x), P = C.x, A = C.y, I = o(_.width), T = o(_.height), E = I * I, L = T * T, M = P * P, B = A * A, O = h(M / E + B / L);
                                    if (O > 1 && (I *= O, T *= O, E = I * I, L = T * T), 1e-12 > o(O = (E * L - E * B - L * M) / (E * B + L * M)) && (O = 0), O < 0) throw Error("Cannot create an arc with the given arguments");
                                    i = new m(I * A / T, -T * P / I).multiply((w === f ? -1 : 1) * h(O)).rotate(x).add(g), n = (r = (s = new S().translate(i).rotate(x).scale(I, T))._inverseTransform(c)).getDirectedAngle(s._inverseTransform(d)), !f && n > 0 ? n -= 360 : f && n < 0 && (n += 360);
                                }
                                if (e) {
                                    var z = new k(c.add(e).divide(2), e.subtract(c).rotate(90), !0), R = new k(e.add(d).divide(2), d.subtract(e).rotate(90), !0), V = new k(c, d), F = V.getSide(e);
                                    if (!(i = z.intersect(R, !0))) {
                                        if (!F) return this.lineTo(d);
                                        throw Error("Cannot create an arc with the given arguments");
                                    }
                                    n = (r = c.subtract(i)).getDirectedAngle(d.subtract(i));
                                    var D = V.getSide(i, !0);
                                    0 === D ? n = F * o(n) : F === D && (n += n < 0 ? 360 : -360);
                                }
                                if (n) {
                                    for(var j = o(n), H = j >= 360 ? 4 : Math.ceil((j - 1e-7) / 90), q = n / H, U = q * Math.PI / 360, W = 4 / 3 * Math.sin(U) / (1 + Math.cos(U)), G = [], Z = 0; Z <= H; Z++){
                                        var C = d, X = null;
                                        if (Z < H && (X = r.rotate(90).multiply(W), s ? (C = s._transformPoint(r), X = s._transformPoint(r.add(X)).subtract(C)) : C = i.add(r)), Z) {
                                            var $ = r.rotate(-90).multiply(W);
                                            s && ($ = s._transformPoint(r.add($)).subtract(C)), G.push(new N(C, $, X));
                                        } else l.setHandleOut(X);
                                        r = r.rotate(q);
                                    }
                                    this._add(G);
                                }
                            },
                            lineBy: function() {
                                var e = m.read(arguments), i = t(this)._point;
                                this.lineTo(i.add(e));
                            },
                            curveBy: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = u.read(e), s = t(this)._point;
                                this.curveTo(s.add(i), s.add(n), r);
                            },
                            cubicCurveBy: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = m.read(e), s = t(this)._point;
                                this.cubicCurveTo(s.add(i), s.add(n), s.add(r));
                            },
                            quadraticCurveBy: function() {
                                var e = arguments, i = m.read(e), n = m.read(e), r = t(this)._point;
                                this.quadraticCurveTo(r.add(i), r.add(n));
                            },
                            arcBy: function() {
                                var e = arguments, i = t(this)._point, n = i.add(m.read(e)), r = u.pick(u.peek(e), !0);
                                "boolean" == typeof r ? this.arcTo(n, r) : this.arcTo(n, i.add(m.read(e)));
                            },
                            closePath: function(t) {
                                this.setClosed(!0), this.join(this, t);
                            }
                        };
                    }, {
                        _getBounds: function(t, e) {
                            return D[e.handle ? "getHandleBounds" : e.stroke ? "getStrokeBounds" : "getBounds"](this._segments, this._closed, this, t, e);
                        },
                        statics: {
                            getBounds: function(t, e, i, n, r, s) {
                                var a = t[0];
                                if (!a) return new w;
                                var o = Array(6), h = a._transformCoordinates(n, Array(6)), l = h.slice(0, 2), u = l.slice(), c = [
                                    ,
                                    , 
                                ];
                                function d(t) {
                                    t._transformCoordinates(n, o);
                                    for(var e = 0; e < 2; e++)R._addBounds(h[e], h[e + 4], o[e + 2], o[e], e, s ? s[e] : 0, l, u, c);
                                    var i = h;
                                    h = o, o = i;
                                }
                                for(var p = 1, f = t.length; p < f; p++)d(t[p]);
                                return e && d(a), new w(l[0], l[1], u[0] - l[0], u[1] - l[1]);
                            },
                            getStrokeBounds: function(t, e, i, n, r) {
                                var s = i.getStyle(), a = s.hasStroke(), o = s.getStrokeWidth(), h = a && i._getStrokeMatrix(n, r), l = a && D._getStrokePadding(o, h), u = D.getBounds(t, e, i, n, r, l);
                                if (!a) return u;
                                var c = o / 2, d = s.getStrokeJoin(), p = s.getStrokeCap(), f = s.getMiterLimit(), g = new w(new b(l));
                                function v(t) {
                                    u = u.include(t);
                                }
                                function _(t) {
                                    u = u.unite(g.setCenter(t._point.transform(n)));
                                }
                                function m(t, e) {
                                    "round" === e || t.isSmooth() ? _(t) : D._addBevelJoin(t, e, c, f, n, h, v);
                                }
                                function y(t, e) {
                                    "round" === e ? _(t) : D._addSquareCap(t, e, c, n, h, v);
                                }
                                var x = t.length - !e;
                                if (x > 0) {
                                    for(var C = 1; C < x; C++)m(t[C], d);
                                    e ? m(t[0], d) : (y(t[0], p), y(t[t.length - 1], p));
                                }
                                return u;
                            },
                            _getStrokePadding: function(t, e) {
                                if (!e) return [
                                    t,
                                    t
                                ];
                                var i = new m(t, 0).transform(e), n = new m(0, t).transform(e), r = i.getAngleInRadians(), s = i.getLength(), a = n.getLength(), o = Math.sin(r), h = Math.cos(r), l = Math.tan(r), u = Math.atan2(a * l, s), c = Math.atan2(a, l * s);
                                return [
                                    Math.abs(s * Math.cos(u) * h + a * Math.sin(u) * o),
                                    Math.abs(a * Math.sin(c) * h + s * Math.cos(c) * o)
                                ];
                            },
                            _addBevelJoin: function(t, e, i, n, r, s, a, o) {
                                var h = t.getCurve(), l = h.getPrevious(), u = h.getPoint1().transform(r), c = l.getNormalAtTime(1).multiply(i).transform(s), d = h.getNormalAtTime(0).multiply(i).transform(s), p = c.getDirectedAngle(d);
                                if ((p < 0 || p >= 180) && (c = c.negate(), d = d.negate()), o && a(u), a(u.add(c)), "miter" === e) {
                                    var f = new k(u.add(c), new m(-c.y, c.x), !0).intersect(new k(u.add(d), new m(-d.y, d.x), !0), !0);
                                    f && u.getDistance(f) <= n * i && a(f);
                                }
                                a(u.add(d));
                            },
                            _addSquareCap: function(t, e, i, n, r, s, a) {
                                var o = t._point.transform(n), h = t.getLocation(), l = h.getNormal().multiply(0 === h.getTime() ? i : -i).transform(r);
                                "square" === e && (a && (s(o.subtract(l)), s(o.add(l))), o = o.add(l.rotate(-90))), s(o.add(l)), s(o.subtract(l));
                            },
                            getHandleBounds: function(t, e, i, n, r) {
                                var s, a, o = i.getStyle();
                                if (r.stroke && o.hasStroke()) {
                                    var h = i._getStrokeMatrix(n, r), l = o.getStrokeWidth() / 2, u = l;
                                    "miter" === o.getStrokeJoin() && (u = l * o.getMiterLimit()), "square" === o.getStrokeCap() && (u = Math.max(u, l * Math.SQRT2)), s = D._getStrokePadding(l, h), a = D._getStrokePadding(u, h);
                                }
                                for(var c = Array(6), d = 1 / 0, p = -1 / 0, f = 1 / 0, g = p, v = 0, _ = t.length; v < _; v++){
                                    t[v]._transformCoordinates(n, c);
                                    for(var m = 0; m < 6; m += 2){
                                        var y = m ? s : a, b = y ? y[0] : 0, x = y ? y[1] : 0, C = c[m], S = c[m + 1], k = C - b, P = C + b, A = S - x, I = S + x;
                                        k < d && (d = k), P > p && (p = P), A < f && (f = A), I > g && (g = I);
                                    }
                                }
                                return new w(d, f, p - d, g - f);
                            }
                        }
                    });
                    D.inject({
                        statics: new function() {
                            var t = [
                                new N([
                                    -1,
                                    0
                                ], [
                                    0,
                                    .5522847498307936
                                ], [
                                    0,
                                    -0.5522847498307936
                                ]),
                                new N([
                                    0,
                                    -1
                                ], [
                                    -0.5522847498307936,
                                    0
                                ], [
                                    .5522847498307936,
                                    0
                                ]),
                                new N([
                                    1,
                                    0
                                ], [
                                    0,
                                    -0.5522847498307936
                                ], [
                                    0,
                                    .5522847498307936
                                ]),
                                new N([
                                    0,
                                    1
                                ], [
                                    .5522847498307936,
                                    0
                                ], [
                                    -0.5522847498307936,
                                    0
                                ])
                            ];
                            function e(t, e, i) {
                                var n = u.getNamed(i), r = new D(n && !1 == n.insert && A.NO_INSERT);
                                return r._add(t), r._closed = e, r.set(n, {
                                    insert: !0
                                });
                            }
                            function i(i, n, r) {
                                for(var s = [
                                    ,
                                    ,
                                    ,
                                    , 
                                ], a = 0; a < 4; a++){
                                    var o = t[a];
                                    s[a] = new N(o._point.multiply(n).add(i), o._handleIn.multiply(n), o._handleOut.multiply(n));
                                }
                                return e(s, !0, r);
                            }
                            return {
                                Line: function() {
                                    var t = arguments;
                                    return e([
                                        new N(m.readNamed(t, "from")),
                                        new N(m.readNamed(t, "to"))
                                    ], !1, t);
                                },
                                Circle: function() {
                                    var t = arguments;
                                    return i(m.readNamed(t, "center"), new b(u.readNamed(t, "radius")), t);
                                },
                                Rectangle: function() {
                                    var t, i = arguments, n = w.readNamed(i, "rectangle"), r = b.readNamed(i, "radius", 0, {
                                        readNull: !0
                                    }), s = n.getBottomLeft(!0), a = n.getTopLeft(!0), o = n.getTopRight(!0), h = n.getBottomRight(!0);
                                    if (!r || r.isZero()) t = [
                                        new N(s),
                                        new N(a),
                                        new N(o),
                                        new N(h)
                                    ];
                                    else {
                                        var l = (r = b.min(r, n.getSize(!0).divide(2))).width, u = r.height, c = .5522847498307936 * l, d = .5522847498307936 * u;
                                        t = [
                                            new N(s.add(l, 0), null, [
                                                -c,
                                                0
                                            ]),
                                            new N(s.subtract(0, u), [
                                                0,
                                                d
                                            ]),
                                            new N(a.add(0, u), null, [
                                                0,
                                                -d
                                            ]),
                                            new N(a.add(l, 0), [
                                                -c,
                                                0
                                            ], null),
                                            new N(o.subtract(l, 0), null, [
                                                c,
                                                0
                                            ]),
                                            new N(o.add(0, u), [
                                                0,
                                                -d
                                            ], null),
                                            new N(h.subtract(0, u), null, [
                                                0,
                                                d
                                            ]),
                                            new N(h.subtract(l, 0), [
                                                c,
                                                0
                                            ])
                                        ];
                                    }
                                    return e(t, !0, i);
                                },
                                RoundRectangle: "#Rectangle",
                                Ellipse: function() {
                                    var t = arguments, e = E._readEllipse(t);
                                    return i(e.center, e.radius, t);
                                },
                                Oval: "#Ellipse",
                                Arc: function() {
                                    var t = arguments, e = m.readNamed(t, "from"), i = m.readNamed(t, "through"), n = m.readNamed(t, "to"), r = u.getNamed(t), s = new D(r && !1 == r.insert && A.NO_INSERT);
                                    return s.moveTo(e), s.arcTo(i, n), s.set(r);
                                },
                                RegularPolygon: function() {
                                    for(var t = arguments, i = m.readNamed(t, "center"), n = u.readNamed(t, "sides"), r = u.readNamed(t, "radius"), s = 360 / n, a = n % 3 == 0, o = new m(0, a ? -r : r), h = a ? -1 : .5, l = Array(n), c = 0; c < n; c++)l[c] = new N(i.add(o.rotate((c + h) * s)));
                                    return e(l, !0, t);
                                },
                                Star: function() {
                                    for(var t = arguments, i = m.readNamed(t, "center"), n = 2 * u.readNamed(t, "points"), r = u.readNamed(t, "radius1"), s = u.readNamed(t, "radius2"), a = 360 / n, o = new m(0, -1), h = Array(n), l = 0; l < n; l++)h[l] = new N(i.add(o.rotate(a * l).multiply(l % 2 ? s : r)));
                                    return e(h, !0, t);
                                }
                            };
                        }
                    });
                    var j = F.extend({
                        _class: "CompoundPath",
                        _serializeFields: {
                            children: []
                        },
                        beans: !0,
                        initialize: function(t) {
                            this._children = [], this._namedChildren = {}, this._initialize(t) || ("string" == typeof t ? this.setPathData(t) : this.addChildren(Array.isArray(t) ? t : arguments));
                        },
                        insertChildren: function t(e, i) {
                            var n = i, r = n[0];
                            r && "number" == typeof r[0] && (n = [
                                n
                            ]);
                            for(var s = i.length - 1; s >= 0; s--){
                                var a = n[s];
                                n !== i || a instanceof D || (n = u.slice(n)), Array.isArray(a) ? n[s] = new D({
                                    segments: a,
                                    insert: !1
                                }) : a instanceof j && (n.splice.apply(n, [
                                    s,
                                    1
                                ].concat(a.removeChildren())), a.remove());
                            }
                            return t.base.call(this, e, n);
                        },
                        reduce: function t(e) {
                            for(var i = this._children, n = i.length - 1; n >= 0; n--){
                                var r = i[n].reduce(e);
                                r.isEmpty() && r.remove();
                            }
                            if (!i.length) {
                                var r = new D(A.NO_INSERT);
                                return r.copyAttributes(this), r.insertAbove(this), this.remove(), r;
                            }
                            return t.base.call(this);
                        },
                        isClosed: function() {
                            for(var t = this._children, e = 0, i = t.length; e < i; e++)if (!t[e]._closed) return !1;
                            return !0;
                        },
                        setClosed: function(t) {
                            for(var e = this._children, i = 0, n = e.length; i < n; i++)e[i].setClosed(t);
                        },
                        getFirstSegment: function() {
                            var t = this.getFirstChild();
                            return t && t.getFirstSegment();
                        },
                        getLastSegment: function() {
                            var t = this.getLastChild();
                            return t && t.getLastSegment();
                        },
                        getCurves: function() {
                            for(var t = this._children, e = [], i = 0, n = t.length; i < n; i++)u.push(e, t[i].getCurves());
                            return e;
                        },
                        getFirstCurve: function() {
                            var t = this.getFirstChild();
                            return t && t.getFirstCurve();
                        },
                        getLastCurve: function() {
                            var t = this.getLastChild();
                            return t && t.getLastCurve();
                        },
                        getArea: function() {
                            for(var t = this._children, e = 0, i = 0, n = t.length; i < n; i++)e += t[i].getArea();
                            return e;
                        },
                        getLength: function() {
                            for(var t = this._children, e = 0, i = 0, n = t.length; i < n; i++)e += t[i].getLength();
                            return e;
                        },
                        getPathData: function(t, e) {
                            for(var i = this._children, n = [], r = 0, s = i.length; r < s; r++){
                                var a = i[r], o = a._matrix;
                                n.push(a.getPathData(t && !o.isIdentity() ? t.appended(o) : t, e));
                            }
                            return n.join("");
                        },
                        _hitTestChildren: function t(e, i, n) {
                            return t.base.call(this, e, i.class === D || "path" === i.type ? i : u.set({}, i, {
                                fill: !1
                            }), n);
                        },
                        _draw: function(t, e, i, n) {
                            var r = this._children;
                            if (r.length) {
                                e = e.extend({
                                    dontStart: !0,
                                    dontFinish: !0
                                }), t.beginPath();
                                for(var s = 0, a = r.length; s < a; s++)r[s].draw(t, e, n);
                                if (!e.clip) {
                                    this._setStyles(t, e, i);
                                    var o = this._style;
                                    o.hasFill() && (t.fill(o.getFillRule()), t.shadowColor = "rgba(0,0,0,0)"), o.hasStroke() && t.stroke();
                                }
                            }
                        },
                        _drawSelected: function(t, e, i) {
                            for(var n = this._children, r = 0, s = n.length; r < s; r++){
                                var a = n[r], o = a._matrix;
                                i[a._id] || a._drawSelected(t, o.isIdentity() ? e : e.appended(o));
                            }
                        }
                    }, new function() {
                        function t(t, e) {
                            var i = t._children;
                            if (e && !i.length) throw Error("Use a moveTo() command first");
                            return i[i.length - 1];
                        }
                        return u.each([
                            "lineTo",
                            "cubicCurveTo",
                            "quadraticCurveTo",
                            "curveTo",
                            "arcTo",
                            "lineBy",
                            "cubicCurveBy",
                            "quadraticCurveBy",
                            "curveBy",
                            "arcBy"
                        ], function(e) {
                            this[e] = function() {
                                var i = t(this, !0);
                                i[e].apply(i, arguments);
                            };
                        }, {
                            moveTo: function() {
                                var e = t(this), i = e && e.isEmpty() ? e : new D(A.NO_INSERT);
                                i !== e && this.addChild(i), i.moveTo.apply(i, arguments);
                            },
                            moveBy: function() {
                                var e = t(this, !0), i = e && e.getLastSegment(), n = m.read(arguments);
                                this.moveTo(i ? n.add(i._point) : n);
                            },
                            closePath: function(e) {
                                t(this, !0).closePath(e);
                            }
                        });
                    }, u.each([
                        "reverse",
                        "flatten",
                        "simplify",
                        "smooth"
                    ], function(t) {
                        this[t] = function(e) {
                            for(var i, n = this._children, r = 0, s = n.length; r < s; r++)i = n[r][t](e) || i;
                            return i;
                        };
                    }, {}));
                    F.inject(new function() {
                        var t = Math.min, e = Math.max, i = Math.abs, n = {
                            unite: {
                                1: !0,
                                2: !0
                            },
                            intersect: {
                                2: !0
                            },
                            subtract: {
                                1: !0
                            },
                            exclude: {
                                1: !0,
                                "-1": !0
                            }
                        };
                        function r(t) {
                            return t._children || [
                                t
                            ];
                        }
                        function s(t, e) {
                            var i = t.clone(!1).reduce({
                                simplify: !0
                            }).transform(null, !0, !0);
                            if (e) {
                                for(var n = r(i), s = 0, a = n.length; s < a; s++){
                                    var t = n[s];
                                    t._closed || t.isEmpty() || (t.closePath(1e-12), t.getFirstSegment().setHandleIn(0, 0), t.getLastSegment().setHandleOut(0, 0));
                                }
                                i = i.resolveCrossings().reorient("nonzero" === i.getFillRule(), !0);
                            }
                            return i;
                        }
                        function a(t, e, i, n, r) {
                            var s = new j(A.NO_INSERT);
                            return s.addChildren(t, !0), s = s.reduce({
                                simplify: e
                            }), r && !1 == r.insert || s.insertAbove(n && i.isSibling(n) && i.getIndex() < n.getIndex() ? n : i), s.copyAttributes(i, !0), s;
                        }
                        function h(t) {
                            return t.hasOverlap() || t.isCrossing();
                        }
                        function l(t, e, i, o) {
                            if (o && (!1 == o.trace || o.stroke) && /^(subtract|intersect)$/.test(i)) return c(t, e, i);
                            var l = s(t, !0), d = e && t !== e && s(e, !0), p = n[i];
                            p[i] = !0, d && (p.subtract || p.exclude) ^ (d.isClockwise() ^ l.isClockwise()) && d.reverse();
                            var v, m = _(V.expand(l.getIntersections(d, h))), x = r(l), w = d && r(d), C = [], S = [];
                            function k(t) {
                                for(var e = 0, i = t.length; e < i; e++){
                                    var n = t[e];
                                    u.push(C, n._segments), u.push(S, n.getCurves()), n._overlapsOnly = !0;
                                }
                            }
                            function P(t) {
                                for(var e = [], i = 0, n = t && t.length; i < n; i++)e.push(S[t[i]]);
                                return e;
                            }
                            if (m.length) {
                                k(x), w && k(w);
                                for(var A = Array(S.length), I = 0, T = S.length; I < T; I++)A[I] = S[I].getValues();
                                for(var E = f.findCurveBoundsCollisions(A, A, 0, !0), L = {}, I = 0; I < S.length; I++){
                                    var M = S[I], B = M._path._id;
                                    (L[B] = L[B] || {})[M.getIndex()] = {
                                        hor: P(E[I].hor),
                                        ver: P(E[I].ver)
                                    };
                                }
                                for(var I = 0, T = m.length; I < T; I++)y(m[I]._segment, l, d, L, p);
                                for(var I = 0, T = C.length; I < T; I++){
                                    var O = C[I], N = O._intersection;
                                    O._winding || y(O, l, d, L, p), N && N._overlap || (O._path._overlapsOnly = !1);
                                }
                                v = b(C, p);
                            } else v = g(w ? x.concat(w) : x.slice(), function(t) {
                                return !!p[t];
                            });
                            return a(v, !0, t, e, o);
                        }
                        function c(t, e, i) {
                            var n = s(t), r = s(e), o = n.getIntersections(r, h), l = "subtract" === i, u = "divide" === i, c = {}, d = [];
                            function p(t) {
                                if (!c[t._id] && (u || r.contains(t.getPointAt(t.getLength() / 2)) ^ l)) return d.unshift(t), c[t._id] = !0;
                            }
                            for(var f = o.length - 1; f >= 0; f--){
                                var g = o[f].split();
                                g && (p(g) && g.getFirstSegment().setHandleIn(0, 0), n.getLastSegment().setHandleOut(0, 0));
                            }
                            return p(n), a(d, !1, t, e);
                        }
                        function d(t, e) {
                            for(var i = t; i;){
                                if (i === e) return;
                                i = i._previous;
                            }
                            for(; t._next && t._next !== e;)t = t._next;
                            if (!t._next) {
                                for(; e._previous;)e = e._previous;
                                t._next = e, e._previous = t;
                            }
                        }
                        function p(t) {
                            for(var e = t.length - 1; e >= 0; e--)t[e].clearHandles();
                        }
                        function g(t, e, n) {
                            var r = t && t.length;
                            if (r) {
                                var s = u.each(t, function(t, e) {
                                    this[t._id] = {
                                        container: null,
                                        winding: t.isClockwise() ? 1 : -1,
                                        index: e
                                    };
                                }, {}), a = t.slice().sort(function(t, e) {
                                    return i(e.getArea()) - i(t.getArea());
                                }), o = a[0], h = f.findItemBoundsCollisions(a, null, v.GEOMETRIC_EPSILON);
                                null == n && (n = o.isClockwise());
                                for(var l = 0; l < r; l++){
                                    var c = a[l], d = s[c._id], p = 0, g = h[l];
                                    if (g) {
                                        for(var _ = null, m = g.length - 1; m >= 0; m--)if (g[m] < l) {
                                            _ = _ || c.getInteriorPoint();
                                            var y = a[g[m]];
                                            if (y.contains(_)) {
                                                var b = s[y._id];
                                                p = b.winding, d.winding += p, d.container = b.exclude ? b.container : y;
                                                break;
                                            }
                                        }
                                    }
                                    if (e(d.winding) === e(p)) d.exclude = !0, t[d.index] = null;
                                    else {
                                        var x = d.container;
                                        c.setClockwise(x ? !x.isClockwise() : n);
                                    }
                                }
                            }
                            return t;
                        }
                        function _(t, e, i) {
                            var n, r, s, a = e && [], o = !1, h = i || [], l = i && {};
                            function u(t) {
                                return t._path._id + "." + t._segment1._index;
                            }
                            for(var c = (i && i.length) - 1; c >= 0; c--){
                                var f = i[c];
                                f._path && (l[u(f)] = !0);
                            }
                            for(var c = t.length - 1; c >= 0; c--){
                                var g, v = t[c], _ = v._time, m = _, y = e && !e(v), f = v._curve;
                                if (f && (f !== r ? (o = !f.hasHandles() || l && l[u(f)], n = [], s = null, r = f) : s >= 1e-8 && (_ /= s)), y) {
                                    n && n.push(v);
                                    continue;
                                }
                                if (e && a.unshift(v), s = m, _ < 1e-8) g = f._segment1;
                                else if (_ > .99999999) g = f._segment2;
                                else {
                                    var b = f.divideAtTime(_, !0);
                                    o && h.push(f, b), g = b._segment1;
                                    for(var x = n.length - 1; x >= 0; x--){
                                        var w = n[x];
                                        w._time = (w._time - _) / (1 - _);
                                    }
                                }
                                v._setSegment(g);
                                var C = g._intersection, S = v._intersection;
                                if (C) {
                                    d(C, S);
                                    for(var k = C; k;)d(k._intersection, C), k = k._next;
                                } else g._intersection = S;
                            }
                            return i || p(h), a || t;
                        }
                        function m(n, r, s, a, o) {
                            var h, l, u = Array.isArray(r) ? r : r[s ? "hor" : "ver"], c = +!!s, d = 1 ^ c, p = [
                                n.x,
                                n.y
                            ], f = p[c], g = p[d], v = f - 1e-9, _ = f + 1e-9, y = 0, b = 0, x = 0, w = 0, C = !1, S = !1, k = 1, P = [];
                            function A(i) {
                                var l = i[d + 0], u = i[d + 2], p = i[d + 4], y = i[d + 6];
                                if (g <= e(l, u, p, y) && g >= t(l, u, p, y)) {
                                    for(var b, S = i[c + 0], A = i[c + 2], I = i[c + 4], T = i[c + 6], E = v > e(S, A, I, T) || _ < t(S, A, I, T) ? [
                                        i
                                    ] : R.getMonoCurves(i, s), L = 0, M = E.length; L < M; L++)if (b = function(i) {
                                        var l = i[d + 0], u = i[d + 6];
                                        if (!(g < t(l, u) || g > e(l, u))) {
                                            var p = i[c + 0], y = i[c + 2], b = i[c + 4], S = i[c + 6];
                                            if (l === u) {
                                                (p < _ && S > v || S < _ && p > v) && (C = !0);
                                                return;
                                            }
                                            var A = g === l ? 0 : g === u || v > e(p, y, b, S) || _ < t(p, y, b, S) ? 1 : R.solveCubic(i, d, g, P, 0, 1) > 0 ? P[0] : 1, I = 0 === A ? p : 1 === A ? S : R.getPoint(i, A)[s ? "y" : "x"], T = l > u ? 1 : -1, E = h[d] > h[d + 6] ? 1 : -1, L = h[c + 6];
                                            return g !== l ? (I < v ? x += T : I > _ ? w += T : C = !0, I > f - 1e-6 && I < f + 1e-6 && (k /= 2)) : (T !== E ? p < v ? x += T : p > _ && (w += T) : p != L && (L < _ && I > _ ? (w += T, C = !0) : L > v && I < v && (x += T, C = !0)), k /= 4), h = i, !o && I > v && I < _ && 0 === R.getTangent(i, A)[s ? "x" : "y"] && m(n, r, !s, a, !0);
                                        }
                                    }(E[L])) return b;
                                }
                            }
                            for(var I = 0, T = u.length; I < T; I++){
                                var E, L = u[I], M = L._path, B = L.getValues();
                                if ((!I || u[I - 1]._path !== M) && (h = null, M._closed || (l = R.getValues(M.getLastCurve().getSegment2(), L.getSegment1(), null, !a))[d] !== l[d + 6] && (h = l), !h)) {
                                    h = B;
                                    for(var O = M.getLastCurve(); O && O !== L;){
                                        var N = O.getValues();
                                        if (N[d] !== N[d + 6]) {
                                            h = N;
                                            break;
                                        }
                                        O = O.getPrevious();
                                    }
                                }
                                if (E = A(B)) return E;
                                if (I + 1 === T || u[I + 1]._path !== M) {
                                    if (l && (E = A(l))) return E;
                                    !C || x || w || (x = w = M.isClockwise(a) ^ s ? 1 : -1), y += x, b += w, x = w = 0, C && (S = !0, C = !1), l = null;
                                }
                            }
                            return {
                                winding: e(y = i(y), b = i(b)),
                                windingL: y,
                                windingR: b,
                                quality: k,
                                onPath: S
                            };
                        }
                        function y(t, e, n, r, s) {
                            var a, o = [], h = t, l = 0;
                            do {
                                var u = t.getCurve();
                                if (u) {
                                    var c = u.getLength();
                                    o.push({
                                        segment: t,
                                        curve: u,
                                        length: c
                                    }), l += c;
                                }
                                t = t.getNext();
                            }while (t && !t._intersection && t !== h);
                            for(var d = [
                                .5,
                                .25,
                                .75
                            ], a = {
                                winding: 0,
                                quality: -1
                            }, p = 0; p < d.length && a.quality < .5; p++)for(var c = l * d[p], f = 0, g = o.length; f < g; f++){
                                var _ = o[f], y = _.length;
                                if (c <= y) {
                                    var u = _.curve, b = u._path, x = b._parent, w = x instanceof j ? x : b, C = v.clamp(u.getTimeAt(c), .001, .999), S = u.getPointAtTime(C), k = i(u.getTangentAtTime(C).y) < Math.SQRT1_2, P = null;
                                    if (s.subtract && n) {
                                        var A = (w === e ? n : e)._getWinding(S, k, !0);
                                        if (w === e && A.winding || w === n && !A.winding) {
                                            if (A.quality < 1) continue;
                                            else P = {
                                                winding: 0,
                                                quality: 1
                                            };
                                        }
                                    }
                                    (P = P || m(S, r[b._id][u.getIndex()], k, !0)).quality > a.quality && (a = P);
                                    break;
                                }
                                c -= y;
                            }
                            for(var f = o.length - 1; f >= 0; f--)o[f].segment._winding = a;
                        }
                        function b(t, e) {
                            var i, n = [];
                            function r(t) {
                                var i;
                                return !!(t && !t._visited && (!e || e[(i = t._winding || {}).winding] && !(e.unite && 2 === i.winding && i.windingL && i.windingR)));
                            }
                            function s(t) {
                                if (t) {
                                    for(var e = 0, n = i.length; e < n; e++)if (t === i[e]) return !0;
                                }
                                return !1;
                            }
                            function a(t) {
                                for(var e = t._segments, i = 0, n = e.length; i < n; i++)e[i]._visited = !0;
                            }
                            t.sort(function(t, e) {
                                var i = t._intersection, n = e._intersection, r = !!(i && i._overlap), s = !!(n && n._overlap), a = t._path, o = e._path;
                                return r ^ s ? r ? 1 : -1 : !i ^ !n ? i ? 1 : -1 : a !== o ? a._id - o._id : t._index - e._index;
                            });
                            for(var o = 0, h = t.length; o < h; o++){
                                var l, u, c, d = t[o], p = r(d), f = null, g = !1, v = !0, _ = [];
                                if (p && d._path._overlapsOnly) {
                                    var m = d._path, y = d._intersection._segment._path;
                                    m.compare(y) && (m.getArea() && n.push(m.clone(!1)), a(m), a(y), p = !1);
                                }
                                for(; p;){
                                    var b = !f, x = function(t, e) {
                                        var n = t._intersection, a = n, o = [];
                                        function h(n, a) {
                                            for(; n && n !== a;){
                                                var h = n._segment, l = h && h._path;
                                                if (l) {
                                                    var u = h.getNext() || l.getFirstSegment(), c = u._intersection;
                                                    h !== t && (s(h) || s(u) || u && r(h) && (r(u) || c && r(c._segment))) && o.push(h), e && i.push(h);
                                                }
                                                n = n._next;
                                            }
                                        }
                                        if (e && (i = [
                                            t
                                        ]), n) {
                                            for(h(n); n && n._previous;)n = n._previous;
                                            h(n, a);
                                        }
                                        return o;
                                    }(d, b), w = x.shift(), g = !b && (s(d) || s(w)), C = !g && w;
                                    if (b && (f = new D(A.NO_INSERT), l = null), g) {
                                        (d.isFirst() || d.isLast()) && (v = d._path._closed), d._visited = !0;
                                        break;
                                    }
                                    if (C && l && (_.push(l), l = null), l || (C && x.push(d), l = {
                                        start: f._segments.length,
                                        crossings: x,
                                        visited: u = [],
                                        handleIn: c
                                    }), C && (d = w), !r(d)) {
                                        f.removeSegments(l.start);
                                        for(var S = 0, k = u.length; S < k; S++)u[S]._visited = !1;
                                        u.length = 0;
                                        do (d = l && l.crossings.shift()) && d._path || (d = null, (l = _.pop()) && (u = l.visited, c = l.handleIn));
                                        while (l && !r(d));
                                        if (!d) break;
                                    }
                                    var P = d.getNext();
                                    f.add(new N(d._point, c, P && d._handleOut)), d._visited = !0, u.push(d), d = P || d._path.getFirstSegment(), c = P && P._handleIn;
                                }
                                g && (v && (f.getFirstSegment().setHandleIn(c), f.setClosed(v)), 0 !== f.getArea() && n.push(f));
                            }
                            return n;
                        }
                        return {
                            _getWinding: function(t, e, i) {
                                return m(t, this.getCurves(), e, i);
                            },
                            unite: function(t, e) {
                                return l(this, t, "unite", e);
                            },
                            intersect: function(t, e) {
                                return l(this, t, "intersect", e);
                            },
                            subtract: function(t, e) {
                                return l(this, t, "subtract", e);
                            },
                            exclude: function(t, e) {
                                return l(this, t, "exclude", e);
                            },
                            divide: function(t, e) {
                                return e && (!1 == e.trace || e.stroke) ? c(this, t, "divide") : a([
                                    this.subtract(t, e),
                                    this.intersect(t, e)
                                ], !0, this, t, e);
                            },
                            resolveCrossings: function() {
                                var t = this._children, e = t || [
                                    this
                                ];
                                function i(t, e) {
                                    var i = t && t._intersection;
                                    return i && i._overlap && i._path === e;
                                }
                                var n = !1, r = !1, s = this.getIntersections(null, function(t) {
                                    return t.hasOverlap() && (n = !0) || t.isCrossing() && (r = !0);
                                }), a = n && r && [];
                                if (s = V.expand(s), n) for(var o = _(s, function(t) {
                                    return t.hasOverlap();
                                }, a), h = o.length - 1; h >= 0; h--){
                                    var l = o[h], c = l._path, d = l._segment, f = d.getPrevious(), g = d.getNext();
                                    i(f, c) && i(g, c) && (d.remove(), f._handleOut._set(0, 0), g._handleIn._set(0, 0), f === d || f.getCurve().hasLength() || (g._handleIn.set(f._handleIn), f.remove()));
                                }
                                r && (_(s, n && function(t) {
                                    var e = t.getCurve(), i = t.getSegment(), n = t._intersection, r = n._curve, s = n._segment;
                                    if (e && r && e._path && r._path) return !0;
                                    i && (i._intersection = null), s && (s._intersection = null);
                                }, a), a && p(a), e = b(u.each(e, function(t) {
                                    u.push(this, t._segments);
                                }, [])));
                                var v, m = e.length;
                                return m > 1 && t ? (e !== t && this.setChildren(e), v = this) : 1 !== m || t || (e[0] !== this && this.setSegments(e[0].removeSegments()), v = this), v || ((v = new j(A.NO_INSERT)).addChildren(e), (v = v.reduce()).copyAttributes(this), this.replaceWith(v)), v;
                            },
                            reorient: function(t, e) {
                                var i = this._children;
                                return i && i.length ? this.setChildren(g(this.removeChildren(), function(e) {
                                    return !!(t ? e : 1 & e);
                                }, e)) : e !== o && this.setClockwise(e), this;
                            },
                            getInteriorPoint: function() {
                                var i = this.getBounds().getCenter(!0);
                                if (!this.contains(i)) {
                                    for(var n = this.getCurves(), r = i.y, s = [], a = [], o = 0, h = n.length; o < h; o++){
                                        var l = n[o].getValues(), u = l[1], c = l[3], d = l[5], p = l[7];
                                        if (r >= t(u, c, d, p) && r <= e(u, c, d, p)) for(var f = R.getMonoCurves(l), g = 0, v = f.length; g < v; g++){
                                            var _ = f[g], m = _[1], y = _[7];
                                            if (m !== y && (r >= m && r <= y || r >= y && r <= m)) {
                                                var b = r === m ? _[0] : r === y ? _[6] : 1 === R.solveCubic(_, 1, r, a, 0, 1) ? R.getPoint(_, a[0]).x : (_[0] + _[6]) / 2;
                                                s.push(b);
                                            }
                                        }
                                    }
                                    s.length > 1 && (s.sort(function(t, e) {
                                        return t - e;
                                    }), i.x = (s[0] + s[1]) / 2);
                                }
                                return i;
                            }
                        };
                    });
                    var H = u.extend({
                        _class: "PathFlattener",
                        initialize: function(t, e, i, n, r) {
                            var s, a = [], o = [], h = 0, l = 1 / (i || 32), u = t._segments, c = u[0];
                            function d(t, i) {
                                var s = R.getValues(t, i, r);
                                a.push(s), function t(i, r, s, a) {
                                    if (!(a - s > l) || n && R.isStraight(i) || R.isFlatEnough(i, e || .25)) {
                                        var u = i[6] - i[0], c = i[7] - i[1], d = Math.sqrt(u * u + c * c);
                                        d > 0 && (h += d, o.push({
                                            offset: h,
                                            curve: i,
                                            index: r,
                                            time: a
                                        }));
                                    } else {
                                        var p = R.subdivide(i, .5), f = (s + a) / 2;
                                        t(p[0], r, s, f), t(p[1], r, f, a);
                                    }
                                }(s, t._index, 0, 1);
                            }
                            for(var p = 1, f = u.length; p < f; p++)d(c, s = u[p]), c = s;
                            t._closed && d(s || c, u[0]), this.curves = a, this.parts = o, this.length = h, this.index = 0;
                        },
                        _get: function(t) {
                            for(var e, i = this.parts, n = i.length, r = this.index; e = r, r && !(i[--r].offset < t););
                            for(; e < n; e++){
                                var s = i[e];
                                if (s.offset >= t) {
                                    this.index = e;
                                    var a = i[e - 1], o = a && a.index === s.index ? a.time : 0, h = a ? a.offset : 0;
                                    return {
                                        index: s.index,
                                        time: o + (s.time - o) * (t - h) / (s.offset - h)
                                    };
                                }
                            }
                            return {
                                index: i[n - 1].index,
                                time: 1
                            };
                        },
                        drawPart: function(t, e, i) {
                            for(var n = this._get(e), r = this._get(i), s = n.index, a = r.index; s <= a; s++){
                                var o = R.getPart(this.curves[s], s === n.index ? n.time : 0, s === r.index ? r.time : 1);
                                s === n.index && t.moveTo(o[0], o[1]), t.bezierCurveTo.apply(t, o.slice(2));
                            }
                        }
                    }, u.each(R._evaluateMethods, function(t) {
                        this[t + "At"] = function(e) {
                            var i = this._get(e);
                            return R[t](this.curves[i.index], i.time);
                        };
                    }, {})), q = u.extend({
                        initialize: function(t) {
                            for(var e, i = this.points = [], n = t._segments, r = t._closed, s = 0, a = n.length; s < a; s++){
                                var o = n[s].point;
                                e && e.equals(o) || i.push(e = o.clone());
                            }
                            r && (i.unshift(i[i.length - 1]), i.push(i[1])), this.closed = r;
                        },
                        fit: function(t) {
                            var e = this.points, i = e.length, n = null;
                            return i > 0 && (n = [
                                new N(e[0])
                            ], i > 1 && (this.fitCubic(n, t, 0, i - 1, e[1].subtract(e[0]), e[i - 2].subtract(e[i - 1])), this.closed && (n.shift(), n.pop()))), n;
                        },
                        fitCubic: function(t, e, i, n, r, s) {
                            var a = this.points;
                            if (n - i == 1) {
                                var o = a[i], h = a[n], l = o.getDistance(h) / 3;
                                this.addCurve(t, [
                                    o,
                                    o.add(r.normalize(l)),
                                    h.add(s.normalize(l)),
                                    h
                                ]);
                                return;
                            }
                            for(var u, c = this.chordLengthParameterize(i, n), d = Math.max(e, e * e), p = !0, f = 0; f <= 4; f++){
                                var g = this.generateBezier(i, n, c, r, s), v = this.findMaxError(i, n, g, c);
                                if (v.error < e && p) return void this.addCurve(t, g);
                                if (u = v.index, v.error >= d) break;
                                p = this.reparameterize(i, n, c, g), d = v.error;
                            }
                            var _ = a[u - 1].subtract(a[u + 1]);
                            this.fitCubic(t, e, i, u, r, _), this.fitCubic(t, e, u, n, _.negate(), s);
                        },
                        addCurve: function(t, e) {
                            t[t.length - 1].setHandleOut(e[1].subtract(e[0])), t.push(new N(e[3], e[2].subtract(e[3])));
                        },
                        generateBezier: function(t, e, i, n, r) {
                            for(var s = Math.abs, a = this.points, o = a[t], h = a[e], l = [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0
                                ]
                            ], u = [
                                0,
                                0
                            ], c = 0, d = e - t + 1; c < d; c++){
                                var p = i[c], f = 1 - p, g = 3 * p * f, v = f * f * f, _ = g * f, m = g * p, y = p * p * p, b = n.normalize(_), x = r.normalize(m), w = a[t + c].subtract(o.multiply(v + _)).subtract(h.multiply(m + y));
                                l[0][0] += b.dot(b), l[0][1] += b.dot(x), l[1][0] = l[0][1], l[1][1] += x.dot(x), u[0] += b.dot(w), u[1] += x.dot(w);
                            }
                            var C, S, k = l[0][0] * l[1][1] - l[1][0] * l[0][1];
                            if (s(k) > 1e-12) {
                                var P = l[0][0] * u[1] - l[1][0] * u[0];
                                C = (u[0] * l[1][1] - u[1] * l[0][1]) / k, S = P / k;
                            } else {
                                var A = l[0][0] + l[0][1], I = l[1][0] + l[1][1];
                                C = S = s(A) > 1e-12 ? u[0] / A : s(I) > 1e-12 ? u[1] / I : 0;
                            }
                            var T, E, L = h.getDistance(o), M = 1e-12 * L;
                            if (C < M || S < M) C = S = L / 3;
                            else {
                                var B = h.subtract(o);
                                T = n.normalize(C), E = r.normalize(S), T.dot(B) - E.dot(B) > L * L && (C = S = L / 3, T = E = null);
                            }
                            return [
                                o,
                                o.add(T || n.normalize(C)),
                                h.add(E || r.normalize(S)),
                                h
                            ];
                        },
                        reparameterize: function(t, e, i, n) {
                            for(var r = t; r <= e; r++)i[r - t] = this.findRoot(n, this.points[r], i[r - t]);
                            for(var r = 1, s = i.length; r < s; r++)if (i[r] <= i[r - 1]) return !1;
                            return !0;
                        },
                        findRoot: function(t, e, i) {
                            for(var n = [], r = [], s = 0; s <= 2; s++)n[s] = t[s + 1].subtract(t[s]).multiply(3);
                            for(var s = 0; s <= 1; s++)r[s] = n[s + 1].subtract(n[s]).multiply(2);
                            var a = this.evaluate(3, t, i), o = this.evaluate(2, n, i), h = this.evaluate(1, r, i), l = a.subtract(e), u = o.dot(o) + l.dot(h);
                            return v.isMachineZero(u) ? i : i - l.dot(o) / u;
                        },
                        evaluate: function(t, e, i) {
                            for(var n = e.slice(), r = 1; r <= t; r++)for(var s = 0; s <= t - r; s++)n[s] = n[s].multiply(1 - i).add(n[s + 1].multiply(i));
                            return n[0];
                        },
                        chordLengthParameterize: function(t, e) {
                            for(var i = [
                                0
                            ], n = t + 1; n <= e; n++)i[n - t] = i[n - t - 1] + this.points[n].getDistance(this.points[n - 1]);
                            for(var n = 1, r = e - t; n <= r; n++)i[n] /= i[r];
                            return i;
                        },
                        findMaxError: function(t, e, i, n) {
                            for(var r = Math.floor((e - t + 1) / 2), s = 0, a = t + 1; a < e; a++){
                                var o = this.evaluate(3, i, n[a - t]).subtract(this.points[a]), h = o.x * o.x + o.y * o.y;
                                h >= s && (s = h, r = a);
                            }
                            return {
                                error: s,
                                index: r
                            };
                        }
                    }), U = A.extend({
                        _class: "TextItem",
                        _applyMatrix: !1,
                        _canApplyMatrix: !1,
                        _serializeFields: {
                            content: null
                        },
                        _boundsOptions: {
                            stroke: !1,
                            handle: !1
                        },
                        initialize: function(t) {
                            this._content = "", this._lines = [];
                            var e = t && u.isPlainObject(t) && t.x === o && t.y === o;
                            this._initialize(e && t, !e && m.read(arguments));
                        },
                        _equals: function(t) {
                            return this._content === t._content;
                        },
                        copyContent: function(t) {
                            this.setContent(t._content);
                        },
                        getContent: function() {
                            return this._content;
                        },
                        setContent: function(t) {
                            this._content = "" + t, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
                        },
                        isEmpty: function() {
                            return !this._content;
                        },
                        getCharacterStyle: "#getStyle",
                        setCharacterStyle: "#setStyle",
                        getParagraphStyle: "#getStyle",
                        setParagraphStyle: "#setStyle"
                    }), W = U.extend({
                        _class: "PointText",
                        initialize: function() {
                            U.apply(this, arguments);
                        },
                        getPoint: function() {
                            var t = this._matrix.getTranslation();
                            return new y(t.x, t.y, this, "setPoint");
                        },
                        setPoint: function() {
                            var t = m.read(arguments);
                            this.translate(t.subtract(this._matrix.getTranslation()));
                        },
                        _draw: function(t, e, i) {
                            if (this._content) {
                                this._setStyles(t, e, i);
                                var n = this._lines, r = this._style, s = r.hasFill(), a = r.hasStroke(), o = r.getLeading(), h = t.shadowColor;
                                t.font = r.getFontStyle(), t.textAlign = r.getJustification();
                                for(var l = 0, u = n.length; l < u; l++){
                                    t.shadowColor = h;
                                    var c = n[l];
                                    s && (t.fillText(c, 0, 0), t.shadowColor = "rgba(0,0,0,0)"), a && t.strokeText(c, 0, 0), t.translate(0, o);
                                }
                            }
                        },
                        _getBounds: function(t, e) {
                            var i = this._style, n = this._lines, r = n.length, s = i.getJustification(), a = i.getLeading(), o = this.getView().getTextWidth(i.getFontStyle(), n), h = 0;
                            "left" !== s && (h -= o / ("center" === s ? 2 : 1));
                            var l = new w(h, r ? -0.75 * a : 0, o, r * a);
                            return t ? t._transformBounds(l, l) : l;
                        }
                    }), G = u.extend(new function() {
                        var t, e = {
                            gray: [
                                "gray"
                            ],
                            rgb: [
                                "red",
                                "green",
                                "blue"
                            ],
                            hsb: [
                                "hue",
                                "saturation",
                                "brightness"
                            ],
                            hsl: [
                                "hue",
                                "saturation",
                                "lightness"
                            ],
                            gradient: [
                                "gradient",
                                "origin",
                                "destination",
                                "highlight"
                            ]
                        }, i = {}, n = {
                            transparent: [
                                0,
                                0,
                                0,
                                0
                            ]
                        }, r = [
                            [
                                0,
                                3,
                                1
                            ],
                            [
                                2,
                                0,
                                1
                            ],
                            [
                                1,
                                0,
                                3
                            ],
                            [
                                1,
                                2,
                                0
                            ],
                            [
                                3,
                                1,
                                0
                            ],
                            [
                                0,
                                1,
                                2
                            ]
                        ], s = {
                            "rgb-hsb": function(t, e, i) {
                                var n = Math.max(t, e, i), r = n - Math.min(t, e, i);
                                return [
                                    0 === r ? 0 : (n == t ? (e - i) / r + 6 * (e < i) : n == e ? (i - t) / r + 2 : (t - e) / r + 4) * 60,
                                    0 === n ? 0 : r / n,
                                    n
                                ];
                            },
                            "hsb-rgb": function(t, e, i) {
                                var n = Math.floor(t = (t / 60 % 6 + 6) % 6), s = t - n, n = r[n], a = [
                                    i,
                                    i * (1 - e),
                                    i * (1 - e * s),
                                    i * (1 - e * (1 - s))
                                ];
                                return [
                                    a[n[0]],
                                    a[n[1]],
                                    a[n[2]]
                                ];
                            },
                            "rgb-hsl": function(t, e, i) {
                                var n = Math.max(t, e, i), r = Math.min(t, e, i), s = n - r, a = 0 === s, o = a ? 0 : (n == t ? (e - i) / s + 6 * (e < i) : n == e ? (i - t) / s + 2 : (t - e) / s + 4) * 60, h = (n + r) / 2;
                                return [
                                    o,
                                    a ? 0 : h < .5 ? s / (n + r) : s / (2 - n - r),
                                    h
                                ];
                            },
                            "hsl-rgb": function(t, e, i) {
                                if (t = (t / 360 % 1 + 1) % 1, 0 === e) return [
                                    i,
                                    i,
                                    i
                                ];
                                for(var n = [
                                    t + 1 / 3,
                                    t,
                                    t - 1 / 3
                                ], r = i < .5 ? i * (1 + e) : i + e - i * e, s = 2 * i - r, a = [], o = 0; o < 3; o++){
                                    var h = n[o];
                                    h < 0 && (h += 1), h > 1 && (h -= 1), a[o] = 6 * h < 1 ? s + (r - s) * 6 * h : 2 * h < 1 ? r : 3 * h < 2 ? s + (r - s) * (2 / 3 - h) * 6 : s;
                                }
                                return a;
                            },
                            "rgb-gray": function(t, e, i) {
                                return [
                                    .2989 * t + .587 * e + .114 * i
                                ];
                            },
                            "gray-rgb": function(t) {
                                return [
                                    t,
                                    t,
                                    t
                                ];
                            },
                            "gray-hsb": function(t) {
                                return [
                                    0,
                                    0,
                                    t
                                ];
                            },
                            "gray-hsl": function(t) {
                                return [
                                    0,
                                    0,
                                    t
                                ];
                            },
                            "gradient-rgb": function() {
                                return [];
                            },
                            "rgb-gradient": function() {
                                return [];
                            }
                        };
                        return u.each(e, function(t, n) {
                            i[n] = [], u.each(t, function(t, r) {
                                var s = u.capitalize(t), a = /^(hue|saturation)$/.test(t), o = i[n][r] = "gradient" === n ? "gradient" === t ? function(t) {
                                    var e = this._components[0];
                                    return t = Z.read(Array.isArray(t) ? t : arguments, 0, {
                                        readNull: !0
                                    }), e !== t && (e && e._removeOwner(this), t && t._addOwner(this)), t;
                                } : function() {
                                    return m.read(arguments, 0, {
                                        readNull: "highlight" === t,
                                        clone: !0
                                    });
                                } : function(t) {
                                    return null == t || isNaN(t) ? 0 : +t;
                                };
                                this["get" + s] = function() {
                                    return this._type === n || a && /^hs[bl]$/.test(this._type) ? this._components[r] : this._convert(n)[r];
                                }, this["set" + s] = function(t) {
                                    this._type === n || a && /^hs[bl]$/.test(this._type) || (this._components = this._convert(n), this._properties = e[n], this._type = n), this._components[r] = o.call(this, t), this._changed();
                                };
                            }, this);
                        }, {
                            _class: "Color",
                            _readIndex: !0,
                            initialize: function r(s) {
                                var a, o, l, c, d = arguments, p = this.__read, f = 0;
                                Array.isArray(s) && (s = (d = s)[0]);
                                var g = null != s && typeof s;
                                if ("string" === g && s in e && (a = s, Array.isArray(s = d[1]) ? (o = s, l = d[2]) : (p && (f = 1), d = u.slice(d, 1), g = typeof s)), !o) {
                                    if (c = "number" === g ? d : "object" === g && null != s.length ? s : null) {
                                        a || (a = c.length >= 3 ? "rgb" : "gray");
                                        var v = e[a].length;
                                        l = c[v], p && (f += c === arguments ? v + +(null != l) : 1), c.length > v && (c = u.slice(c, 0, v));
                                    } else if ("string" === g) {
                                        var _ = function(e) {
                                            var i, r = e.match(/^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i) || e.match(/^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i), s = "rgb";
                                            if (r) {
                                                var a = r[4] ? 4 : 3;
                                                i = Array(a);
                                                for(var o = 0; o < a; o++){
                                                    var l = r[o + 1];
                                                    i[o] = parseInt(1 == l.length ? l + l : l, 16) / 255;
                                                }
                                            } else if (r = e.match(/^(rgb|hsl)a?\((.*)\)$/)) {
                                                s = r[1], i = r[2].trim().split(/[,\s]+/g);
                                                for(var u = "hsl" === s, o = 0, c = Math.min(i.length, 4); o < c; o++){
                                                    var d = i[o], l = parseFloat(d);
                                                    u ? 0 === o ? l *= ({
                                                        turn: 360,
                                                        rad: 180 / Math.PI,
                                                        grad: .9
                                                    })[d.match(/([a-z]*)$/)[1]] || 1 : o < 3 && (l /= 100) : o < 3 && (l /= /%$/.test(d) ? 100 : 255), i[o] = l;
                                                }
                                            } else {
                                                var p = n[e];
                                                if (!p) {
                                                    if (h) {
                                                        t || ((t = th.getContext(1, 1)).globalCompositeOperation = "copy"), t.fillStyle = "rgba(0,0,0,0)", t.fillStyle = e, t.fillRect(0, 0, 1, 1);
                                                        var f = t.getImageData(0, 0, 1, 1).data;
                                                        p = n[e] = [
                                                            f[0] / 255,
                                                            f[1] / 255,
                                                            f[2] / 255
                                                        ];
                                                    } else p = [
                                                        0,
                                                        0,
                                                        0
                                                    ];
                                                }
                                                i = p.slice();
                                            }
                                            return [
                                                s,
                                                i
                                            ];
                                        }(s);
                                        a = _[0], 4 === (o = _[1]).length && (l = o[3], o.length--);
                                    } else if ("object" === g) {
                                        if (s.constructor === r) {
                                            if (a = s._type, o = s._components.slice(), l = s._alpha, "gradient" === a) for(var m = 1, y = o.length; m < y; m++){
                                                var b = o[m];
                                                b && (o[m] = b.clone());
                                            }
                                        } else if (s.constructor === Z) a = "gradient", c = d;
                                        else {
                                            var x = e[a = "hue" in s ? "lightness" in s ? "hsl" : "hsb" : "gradient" in s || "stops" in s || "radial" in s ? "gradient" : "gray" in s ? "gray" : "rgb"], w = i[a];
                                            this._components = o = [];
                                            for(var m = 0, y = x.length; m < y; m++){
                                                var C = s[x[m]];
                                                null == C && !m && "gradient" === a && "stops" in s && (C = {
                                                    stops: s.stops,
                                                    radial: s.radial
                                                }), null != (C = w[m].call(this, C)) && (o[m] = C);
                                            }
                                            l = s.alpha;
                                        }
                                    }
                                    p && a && (f = 1);
                                }
                                if (this._type = a || "rgb", !o) {
                                    this._components = o = [];
                                    for(var w = i[this._type], m = 0, y = w.length; m < y; m++){
                                        var C = w[m].call(this, c && c[m]);
                                        null != C && (o[m] = C);
                                    }
                                }
                                return this._components = o, this._properties = e[this._type], this._alpha = l, p && (this.__read = f), this;
                            },
                            set: "#initialize",
                            _serialize: function(t, e) {
                                var i = this.getComponents();
                                return u.serialize(/^(gray|rgb)$/.test(this._type) ? i : [
                                    this._type
                                ].concat(i), t, !0, e);
                            },
                            _changed: function() {
                                this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
                            },
                            _convert: function(t) {
                                var e;
                                return this._type === t ? this._components.slice() : (e = s[this._type + "-" + t]) ? e.apply(this, this._components) : s["rgb-" + t].apply(this, s[this._type + "-rgb"].apply(this, this._components));
                            },
                            convert: function(t) {
                                return new G(t, this._convert(t), this._alpha);
                            },
                            getType: function() {
                                return this._type;
                            },
                            setType: function(t) {
                                this._components = this._convert(t), this._properties = e[t], this._type = t;
                            },
                            getComponents: function() {
                                var t = this._components.slice();
                                return null != this._alpha && t.push(this._alpha), t;
                            },
                            getAlpha: function() {
                                return null != this._alpha ? this._alpha : 1;
                            },
                            setAlpha: function(t) {
                                this._alpha = null == t ? null : Math.min(Math.max(t, 0), 1), this._changed();
                            },
                            hasAlpha: function() {
                                return null != this._alpha;
                            },
                            equals: function(t) {
                                var e = u.isPlainValue(t, !0) ? G.read(arguments) : t;
                                return e === this || e && this._class === e._class && this._type === e._type && this.getAlpha() === e.getAlpha() && u.equals(this._components, e._components) || !1;
                            },
                            toString: function() {
                                for(var t = this._properties, e = [], i = "gradient" === this._type, n = g.instance, r = 0, s = t.length; r < s; r++){
                                    var a = this._components[r];
                                    null != a && e.push(t[r] + ": " + (i ? a : n.number(a)));
                                }
                                return null != this._alpha && e.push("alpha: " + n.number(this._alpha)), "{ " + e.join(", ") + " }";
                            },
                            toCSS: function(t) {
                                var e = this._convert("rgb"), i = t || null == this._alpha ? 1 : this._alpha;
                                function n(t) {
                                    return Math.round((t < 0 ? 0 : t > 1 ? 1 : t) * 255);
                                }
                                return e = [
                                    n(e[0]),
                                    n(e[1]),
                                    n(e[2])
                                ], i < 1 && e.push(i < 0 ? 0 : i), t ? "#" + (0x1000000 + (e[0] << 16) + (e[1] << 8) + e[2]).toString(16).slice(1) : (4 == e.length ? "rgba(" : "rgb(") + e.join(",") + ")";
                            },
                            toCanvasStyle: function(t, e) {
                                if (this._canvasStyle) return this._canvasStyle;
                                if ("gradient" !== this._type) return this._canvasStyle = this.toCSS();
                                var i, n = this._components, r = n[0], s = r._stops, a = n[1], o = n[2], h = n[3], l = e && e.inverted();
                                if (l && (a = l._transformPoint(a), o = l._transformPoint(o), h && (h = l._transformPoint(h))), r._radial) {
                                    var u = o.getDistance(a);
                                    if (h) {
                                        var c = h.subtract(a);
                                        c.getLength() > u && (h = a.add(c.normalize(u - .1)));
                                    }
                                    var d = h || a;
                                    i = t.createRadialGradient(d.x, d.y, 0, a.x, a.y, u);
                                } else i = t.createLinearGradient(a.x, a.y, o.x, o.y);
                                for(var p = 0, f = s.length; p < f; p++){
                                    var g = s[p], v = g._offset;
                                    i.addColorStop(null == v ? p / (f - 1) : v, g._color.toCanvasStyle());
                                }
                                return this._canvasStyle = i;
                            },
                            transform: function(t) {
                                if ("gradient" === this._type) {
                                    for(var e = this._components, i = 1, n = e.length; i < n; i++){
                                        var r = e[i];
                                        t._transformPoint(r, r, !0);
                                    }
                                    this._changed();
                                }
                            },
                            statics: {
                                _types: e,
                                random: function() {
                                    var t = Math.random;
                                    return new G(t(), t(), t());
                                },
                                _setOwner: function(t, e, i) {
                                    return t && (t._owner && e && t._owner !== e && (t = t.clone()), !t._owner ^ !e && (t._owner = e || null, t._setter = i || null)), t;
                                }
                            }
                        });
                    }, new function() {
                        return u.each({
                            add: function(t, e) {
                                return t + e;
                            },
                            subtract: function(t, e) {
                                return t - e;
                            },
                            multiply: function(t, e) {
                                return t * e;
                            },
                            divide: function(t, e) {
                                return t / e;
                            }
                        }, function(t, e) {
                            this[e] = function(e) {
                                e = G.read(arguments);
                                for(var i = this._type, n = this._components, r = e._convert(i), s = 0, a = n.length; s < a; s++)r[s] = t(n[s], r[s]);
                                return new G(i, r, null != this._alpha ? t(this._alpha, e.getAlpha()) : null);
                            };
                        }, {});
                    }), Z = u.extend({
                        _class: "Gradient",
                        initialize: function(t, e) {
                            this._id = _.get(), t && u.isPlainObject(t) && (this.set(t), t = e = null), null == this._stops && this.setStops(t || [
                                "white",
                                "black"
                            ]), null == this._radial && this.setRadial("string" == typeof e && "radial" === e || e || !1);
                        },
                        _serialize: function(t, e) {
                            return e.add(this, function() {
                                return u.serialize([
                                    this._stops,
                                    this._radial
                                ], t, !0, e);
                            });
                        },
                        _changed: function() {
                            for(var t = 0, e = this._owners && this._owners.length; t < e; t++)this._owners[t]._changed();
                        },
                        _addOwner: function(t) {
                            this._owners || (this._owners = []), this._owners.push(t);
                        },
                        _removeOwner: function(t) {
                            var e = this._owners ? this._owners.indexOf(t) : -1;
                            -1 != e && (this._owners.splice(e, 1), this._owners.length || (this._owners = o));
                        },
                        clone: function() {
                            for(var t = [], e = 0, i = this._stops.length; e < i; e++)t[e] = this._stops[e].clone();
                            return new Z(t, this._radial);
                        },
                        getStops: function() {
                            return this._stops;
                        },
                        setStops: function(t) {
                            if (t.length < 2) throw Error("Gradient stop list needs to contain at least two stops.");
                            var e = this._stops;
                            if (e) for(var i = 0, n = e.length; i < n; i++)e[i]._owner = o;
                            e = this._stops = X.readList(t, 0, {
                                clone: !0
                            });
                            for(var i = 0, n = e.length; i < n; i++)e[i]._owner = this;
                            this._changed();
                        },
                        getRadial: function() {
                            return this._radial;
                        },
                        setRadial: function(t) {
                            this._radial = t, this._changed();
                        },
                        equals: function(t) {
                            if (t === this) return !0;
                            if (t && this._class === t._class) {
                                var e = this._stops, i = t._stops, n = e.length;
                                if (n === i.length) {
                                    for(var r = 0; r < n; r++)if (!e[r].equals(i[r])) return !1;
                                    return !0;
                                }
                            }
                            return !1;
                        }
                    }), X = u.extend({
                        _class: "GradientStop",
                        initialize: function(t, e) {
                            var i = t, n = e;
                            "object" == typeof t && e === o && (Array.isArray(t) && "number" != typeof t[0] ? (i = t[0], n = t[1]) : ("color" in t || "offset" in t || "rampPoint" in t) && (i = t.color, n = t.offset || t.rampPoint || 0)), this.setColor(i), this.setOffset(n);
                        },
                        clone: function() {
                            return new X(this._color.clone(), this._offset);
                        },
                        _serialize: function(t, e) {
                            var i = this._color, n = this._offset;
                            return u.serialize(null == n ? [
                                i
                            ] : [
                                i,
                                n
                            ], t, !0, e);
                        },
                        _changed: function() {
                            this._owner && this._owner._changed(129);
                        },
                        getOffset: function() {
                            return this._offset;
                        },
                        setOffset: function(t) {
                            this._offset = t, this._changed();
                        },
                        getRampPoint: "#getOffset",
                        setRampPoint: "#setOffset",
                        getColor: function() {
                            return this._color;
                        },
                        setColor: function() {
                            G._setOwner(this._color, null), this._color = G._setOwner(G.read(arguments, 0), this, "setColor"), this._changed();
                        },
                        equals: function(t) {
                            return t === this || t && this._class === t._class && this._color.equals(t._color) && this._offset == t._offset || !1;
                        }
                    }), $ = u.extend(new function() {
                        var t = {
                            fillColor: null,
                            fillRule: "nonzero",
                            strokeColor: null,
                            strokeWidth: 1,
                            strokeCap: "butt",
                            strokeJoin: "miter",
                            strokeScaling: !0,
                            miterLimit: 10,
                            dashOffset: 0,
                            dashArray: [],
                            shadowColor: null,
                            shadowBlur: 0,
                            shadowOffset: new m,
                            selectedColor: null
                        }, e = u.set({}, t, {
                            fontFamily: "sans-serif",
                            fontWeight: "normal",
                            fontSize: 12,
                            leading: null,
                            justification: "left"
                        }), i = u.set({}, e, {
                            fillColor: new G
                        }), n = {
                            strokeWidth: 193,
                            strokeCap: 193,
                            strokeJoin: 193,
                            strokeScaling: 201,
                            miterLimit: 193,
                            fontFamily: 9,
                            fontWeight: 9,
                            fontSize: 9,
                            font: 9,
                            leading: 9,
                            justification: 9
                        }, r = {
                            beans: !0
                        }, s = {
                            _class: "Style",
                            beans: !0,
                            initialize: function(n, r, s) {
                                this._values = {}, this._owner = r, this._project = r && r._project || s || td.project, this._defaults = !r || r instanceof I ? e : r instanceof U ? i : t, n && this.set(n);
                            }
                        };
                        return u.each(e, function(t, e) {
                            var i = /Color$/.test(e), a = "shadowOffset" === e, h = u.capitalize(e), l = n[e], c = "set" + h, d = "get" + h;
                            s[c] = function(t) {
                                var n = this._owner, r = n && n._children, s = r && r.length > 0 && !(n instanceof j);
                                if (s) for(var a = 0, o = r.length; a < o; a++)r[a]._style[c](t);
                                if (("selectedColor" === e || !s) && e in this._defaults) {
                                    var h = this._values[e];
                                    h !== t && (i && (h && (G._setOwner(h, null), h._canvasStyle = null), t && t.constructor === G && (t = G._setOwner(t, n, s && c))), this._values[e] = t, n && n._changed(l || 129));
                                }
                            }, s[d] = function(t) {
                                var n, r = this._owner, s = r && r._children, h = s && s.length > 0 && !(r instanceof j);
                                if (h && !t) for(var l = 0, p = s.length; l < p; l++){
                                    var f = s[l]._style[d]();
                                    if (l) {
                                        if (!u.equals(n, f)) return o;
                                    } else n = f;
                                }
                                else if (e in this._defaults) {
                                    var n = this._values[e];
                                    if (n === o) (n = this._defaults[e]) && n.clone && (n = n.clone());
                                    else {
                                        var g = i ? G : a ? m : null;
                                        g && !(n && n.constructor === g) && (this._values[e] = n = g.read([
                                            n
                                        ], 0, {
                                            readNull: !0,
                                            clone: !0
                                        }));
                                    }
                                }
                                return n && i && (n = G._setOwner(n, r, h && c)), n;
                            }, r[d] = function(t) {
                                return this._style[d](t);
                            }, r[c] = function(t) {
                                this._style[c](t);
                            };
                        }), u.each({
                            Font: "FontFamily",
                            WindingRule: "FillRule"
                        }, function(t, e) {
                            var i = "get" + e, n = "set" + e;
                            s[i] = r[i] = "#get" + t, s[n] = r[n] = "#set" + t;
                        }), A.inject(r), s;
                    }, {
                        set: function(t) {
                            var e = t instanceof $, i = e ? t._values : t;
                            if (i) {
                                for(var n in i)if (n in this._defaults) {
                                    var r = i[n];
                                    this[n] = r && e && r.clone ? r.clone() : r;
                                }
                            }
                        },
                        equals: function(t) {
                            function e(t, e, i) {
                                var n = t._values, r = e._values, s = e._defaults;
                                for(var a in n){
                                    var h = n[a], l = r[a];
                                    if (!(i && a in r) && !u.equals(h, l === o ? s[a] : l)) return !1;
                                }
                                return !0;
                            }
                            return t === this || t && this._class === t._class && e(this, t) && e(t, this, !0) || !1;
                        },
                        _dispose: function() {
                            var t;
                            (t = this.getFillColor()) && (t._canvasStyle = null), (t = this.getStrokeColor()) && (t._canvasStyle = null), (t = this.getShadowColor()) && (t._canvasStyle = null);
                        },
                        hasFill: function() {
                            var t = this.getFillColor();
                            return !!t && t.alpha > 0;
                        },
                        hasStroke: function() {
                            var t = this.getStrokeColor();
                            return !!t && t.alpha > 0 && this.getStrokeWidth() > 0;
                        },
                        hasShadow: function() {
                            var t = this.getShadowColor();
                            return !!t && t.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
                        },
                        getView: function() {
                            return this._project._view;
                        },
                        getFontStyle: function() {
                            var t = this.getFontSize();
                            return this.getFontWeight() + " " + t + (/[a-z]/i.test(t + "") ? " " : "px ") + this.getFontFamily();
                        },
                        getFont: "#getFontFamily",
                        setFont: "#setFontFamily",
                        getLeading: function t() {
                            var e = t.base.call(this), i = this.getFontSize();
                            return /pt|em|%|px/.test(i) && (i = this.getView().getPixelSize(i)), null != e ? e : 1.2 * i;
                        }
                    }), Q = new function() {
                        function t(t, e, i, n) {
                            for(var r = [
                                "",
                                "webkit",
                                "moz",
                                "Moz",
                                "ms",
                                "o"
                            ], s = e[0].toUpperCase() + e.substring(1), a = 0; a < 6; a++){
                                var o = r[a], h = o ? o + s : e;
                                if (h in t) {
                                    if (!i) return t[h];
                                    t[h] = n;
                                    break;
                                }
                            }
                        }
                        return {
                            getStyles: function(t) {
                                var e = t && 9 !== t.nodeType ? t.ownerDocument : t, i = e && e.defaultView;
                                return i && i.getComputedStyle(t, "");
                            },
                            getBounds: function(t, e) {
                                var i, n = t.ownerDocument, r = n.body, s = n.documentElement;
                                try {
                                    i = t.getBoundingClientRect();
                                } catch (t) {
                                    i = {
                                        left: 0,
                                        top: 0,
                                        width: 0,
                                        height: 0
                                    };
                                }
                                var a = i.left - (s.clientLeft || r.clientLeft || 0), o = i.top - (s.clientTop || r.clientTop || 0);
                                if (!e) {
                                    var h = n.defaultView;
                                    a += h.pageXOffset || s.scrollLeft || r.scrollLeft, o += h.pageYOffset || s.scrollTop || r.scrollTop;
                                }
                                return new w(a, o, i.width, i.height);
                            },
                            getViewportBounds: function(t) {
                                var e = t.ownerDocument, i = e.defaultView, n = e.documentElement;
                                return new w(0, 0, i.innerWidth || n.clientWidth, i.innerHeight || n.clientHeight);
                            },
                            getOffset: function(t, e) {
                                return Q.getBounds(t, e).getPoint();
                            },
                            getSize: function(t) {
                                return Q.getBounds(t, !0).getSize();
                            },
                            isInvisible: function(t) {
                                return Q.getSize(t).equals(new b(0, 0));
                            },
                            isInView: function(t) {
                                return !Q.isInvisible(t) && Q.getViewportBounds(t).intersects(Q.getBounds(t, !0));
                            },
                            isInserted: function(t) {
                                return l.body.contains(t);
                            },
                            getPrefixed: function(e, i) {
                                return e && t(e, i);
                            },
                            setPrefixed: function(e, i, n) {
                                if ("object" == typeof i) for(var r in i)t(e, r, !0, i[r]);
                                else t(e, i, !0, n);
                            }
                        };
                    }, Y = {
                        add: function(t, e) {
                            if (t) for(var i in e)for(var n = e[i], r = i.split(/[\s,]+/g), s = 0, a = r.length; s < a; s++){
                                var o = r[s], h = t === l && ("touchstart" === o || "touchmove" === o) && {
                                    passive: !1
                                };
                                t.addEventListener(o, n, h);
                            }
                        },
                        remove: function(t, e) {
                            if (t) for(var i in e)for(var n = e[i], r = i.split(/[\s,]+/g), s = 0, a = r.length; s < a; s++)t.removeEventListener(r[s], n, !1);
                        },
                        getPoint: function(t) {
                            var e = t.targetTouches ? t.targetTouches.length ? t.targetTouches[0] : t.changedTouches[0] : t;
                            return new m(e.pageX || e.clientX + l.documentElement.scrollLeft, e.pageY || e.clientY + l.documentElement.scrollTop);
                        },
                        getTarget: function(t) {
                            return t.target || t.srcElement;
                        },
                        getRelatedTarget: function(t) {
                            return t.relatedTarget || t.toElement;
                        },
                        getOffset: function(t, e) {
                            return Y.getPoint(t).subtract(Q.getOffset(e || Y.getTarget(t)));
                        }
                    };
                    Y.requestAnimationFrame = new function() {
                        var t, e = Q.getPrefixed(h, "requestAnimationFrame"), i = !1, n = [];
                        function r() {
                            var t = n;
                            n = [];
                            for(var s = 0, a = t.length; s < a; s++)t[s]();
                            (i = e && n.length) && e(r);
                        }
                        return function(s) {
                            n.push(s), e ? i || (e(r), i = !0) : t || (t = setInterval(r, 1e3 / 60));
                        };
                    };
                    var J = u.extend(c, {
                        _class: "View",
                        initialize: function t(e, i) {
                            function n(t) {
                                return i[t] || parseInt(i.getAttribute(t), 10);
                            }
                            function r() {
                                var t = Q.getSize(i);
                                return t.isNaN() || t.isZero() ? new b(n("width"), n("height")) : t;
                            }
                            if (h && i) {
                                this._id = i.getAttribute("id"), null == this._id && i.setAttribute("id", this._id = "paper-view-" + t._id++), Y.add(i, this._viewEvents);
                                var s, a = "none";
                                if (Q.setPrefixed(i.style, {
                                    userDrag: a,
                                    userSelect: a,
                                    touchCallout: a,
                                    contentZooming: a,
                                    tapHighlightColor: "rgba(0,0,0,0)"
                                }), d.hasAttribute(i, "resize")) {
                                    var o = this;
                                    Y.add(h, this._windowEvents = {
                                        resize: function() {
                                            o.setViewSize(r());
                                        }
                                    });
                                }
                                if (s = r(), d.hasAttribute(i, "stats") && "undefined" != typeof Stats) {
                                    this._stats = new Stats;
                                    var u = this._stats.domElement, c = u.style, p = Q.getOffset(i);
                                    c.position = "absolute", c.left = p.x + "px", c.top = p.y + "px", l.body.appendChild(u);
                                }
                            } else s = new b(i), i = null;
                            this._project = e, this._scope = e._scope, this._element = i, this._pixelRatio || (this._pixelRatio = h && h.devicePixelRatio || 1), this._setElementSize(s.width, s.height), this._viewSize = s, t._views.push(this), t._viewsById[this._id] = this, (this._matrix = new S)._owner = this, t._focused || (t._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = {
                                native: {},
                                virtual: {}
                            }, this._autoUpdate = !td.agent.node, this._needsUpdate = !1;
                        },
                        remove: function() {
                            if (!this._project) return !1;
                            J._focused === this && (J._focused = null), J._views.splice(J._views.indexOf(this), 1), delete J._viewsById[this._id];
                            var t = this._project;
                            return t._view === this && (t._view = null), Y.remove(this._element, this._viewEvents), Y.remove(h, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
                        },
                        _events: u.each(A._itemHandlers.concat([
                            "onResize",
                            "onKeyDown",
                            "onKeyUp"
                        ]), function(t) {
                            this[t] = {};
                        }, {
                            onFrame: {
                                install: function() {
                                    this.play();
                                },
                                uninstall: function() {
                                    this.pause();
                                }
                            }
                        }),
                        _animate: !1,
                        _time: 0,
                        _count: 0,
                        getAutoUpdate: function() {
                            return this._autoUpdate;
                        },
                        setAutoUpdate: function(t) {
                            this._autoUpdate = t, t && this.requestUpdate();
                        },
                        update: function() {},
                        draw: function() {
                            this.update();
                        },
                        requestUpdate: function() {
                            if (!this._requested) {
                                var t = this;
                                Y.requestAnimationFrame(function() {
                                    if (t._requested = !1, t._animate) {
                                        t.requestUpdate();
                                        var e = t._element;
                                        (!Q.getPrefixed(l, "hidden") || "true" === d.getAttribute(e, "keepalive")) && Q.isInView(e) && t._handleFrame();
                                    }
                                    t._autoUpdate && t.update();
                                }), this._requested = !0;
                            }
                        },
                        play: function() {
                            this._animate = !0, this.requestUpdate();
                        },
                        pause: function() {
                            this._animate = !1;
                        },
                        _handleFrame: function() {
                            td = this._scope;
                            var t = Date.now() / 1e3, e = this._last ? t - this._last : 0;
                            this._last = t, this.emit("frame", new u({
                                delta: e,
                                time: this._time += e,
                                count: this._count++
                            })), this._stats && this._stats.update();
                        },
                        _animateItem: function(t, e) {
                            var i = this._frameItems;
                            e ? (i[t._id] = {
                                item: t,
                                time: 0,
                                count: 0
                            }, 1 == ++this._frameItemCount && this.on("frame", this._handleFrameItems)) : (delete i[t._id], 0 == --this._frameItemCount && this.off("frame", this._handleFrameItems));
                        },
                        _handleFrameItems: function(t) {
                            for(var e in this._frameItems){
                                var i = this._frameItems[e];
                                i.item.emit("frame", new u(t, {
                                    time: i.time += t.delta,
                                    count: i.count++
                                }));
                            }
                        },
                        _changed: function() {
                            this._project._changed(4097), this._bounds = this._decomposed = o;
                        },
                        getElement: function() {
                            return this._element;
                        },
                        getPixelRatio: function() {
                            return this._pixelRatio;
                        },
                        getResolution: function() {
                            return 72 * this._pixelRatio;
                        },
                        getViewSize: function() {
                            var t = this._viewSize;
                            return new x(t.width, t.height, this, "setViewSize");
                        },
                        setViewSize: function() {
                            var t = b.read(arguments), e = t.subtract(this._viewSize);
                            !e.isZero() && (this._setElementSize(t.width, t.height), this._viewSize.set(t), this._changed(), this.emit("resize", {
                                size: t,
                                delta: e
                            }), this._autoUpdate && this.update());
                        },
                        _setElementSize: function(t, e) {
                            var i = this._element;
                            i && (i.width !== t && (i.width = t), i.height !== e && (i.height = e));
                        },
                        getBounds: function() {
                            return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(new w(new m, this._viewSize))), this._bounds;
                        },
                        getSize: function() {
                            return this.getBounds().getSize();
                        },
                        isVisible: function() {
                            return Q.isInView(this._element);
                        },
                        isInserted: function() {
                            return Q.isInserted(this._element);
                        },
                        getPixelSize: function(t) {
                            var e, i = this._element;
                            if (i) {
                                var n = i.parentNode, r = l.createElement("div");
                                r.style.fontSize = t, n.appendChild(r), e = parseFloat(Q.getStyles(r).fontSize), n.removeChild(r);
                            } else e = parseFloat(e);
                            return e;
                        },
                        getTextWidth: function(t, e) {
                            return 0;
                        }
                    }, u.each([
                        "rotate",
                        "scale",
                        "shear",
                        "skew"
                    ], function(t) {
                        var e = "rotate" === t;
                        this[t] = function() {
                            var i = arguments, n = (e ? u : m).read(i), r = m.read(i, 0, {
                                readNull: !0
                            });
                            return this.transform(new S()[t](n, r || this.getCenter(!0)));
                        };
                    }, {
                        _decompose: function() {
                            return this._decomposed || (this._decomposed = this._matrix.decompose());
                        },
                        translate: function() {
                            var t = new S;
                            return this.transform(t.translate.apply(t, arguments));
                        },
                        getCenter: function() {
                            return this.getBounds().getCenter();
                        },
                        setCenter: function() {
                            var t = m.read(arguments);
                            this.translate(this.getCenter().subtract(t));
                        },
                        getZoom: function() {
                            var t = this._decompose().scaling;
                            return (t.x + t.y) / 2;
                        },
                        setZoom: function(t) {
                            this.transform(new S().scale(t / this.getZoom(), this.getCenter()));
                        },
                        getRotation: function() {
                            return this._decompose().rotation;
                        },
                        setRotation: function(t) {
                            var e = this.getRotation();
                            null != e && null != t && this.rotate(t - e);
                        },
                        getScaling: function() {
                            var t = this._decompose().scaling;
                            return new y(t.x, t.y, this, "setScaling");
                        },
                        setScaling: function() {
                            var t = this.getScaling(), e = m.read(arguments, 0, {
                                clone: !0,
                                readNull: !0
                            });
                            t && e && this.scale(e.x / t.x, e.y / t.y);
                        },
                        getMatrix: function() {
                            return this._matrix;
                        },
                        setMatrix: function() {
                            var t = this._matrix;
                            t.set.apply(t, arguments);
                        },
                        transform: function(t) {
                            this._matrix.append(t);
                        },
                        scrollBy: function() {
                            this.translate(m.read(arguments).negate());
                        }
                    }), {
                        projectToView: function() {
                            return this._matrix._transformPoint(m.read(arguments));
                        },
                        viewToProject: function() {
                            return this._matrix._inverseTransform(m.read(arguments));
                        },
                        getEventPoint: function(t) {
                            return this.viewToProject(Y.getOffset(t, this._element));
                        }
                    }, {
                        statics: {
                            _views: [],
                            _viewsById: {},
                            _id: 0,
                            create: function(t, e) {
                                return l && "string" == typeof e && (e = l.getElementById(e)), new (h ? K : J)(t, e);
                            }
                        }
                    }, new function() {
                        if (h) {
                            var t, e, i, n, r, s = !1, a = !1, o = h.navigator;
                            o.pointerEnabled || o.msPointerEnabled ? (i = "pointerdown MSPointerDown", n = "pointermove MSPointerMove", r = "pointerup pointercancel MSPointerUp MSPointerCancel") : (i = "touchstart", n = "touchmove", r = "touchend touchcancel", "ontouchstart" in h && o.userAgent.match(/mobile|tablet|ip(ad|hone|od)|android|silk/i) || (i += " mousedown", n += " mousemove", r += " mouseup"));
                            var u = {}, c = {
                                mouseout: function(t) {
                                    var e = J._focused, i = Y.getRelatedTarget(t);
                                    if (e && (!i || "HTML" === i.nodeName)) {
                                        var n = Y.getOffset(t, e._element), r = n.x, s = Math.abs, a = s(r), o = a - 0x2000000;
                                        n.x = s(o) < a ? o * (r < 0 ? -1 : 1) : r, A(e, t, e.viewToProject(n));
                                    }
                                },
                                scroll: P
                            };
                            u[i] = function(t) {
                                var e = J._focused = k(t);
                                s || (s = !0, e._handleMouseEvent("mousedown", t));
                            }, c[n] = function(i) {
                                var n = J._focused;
                                if (!a) {
                                    var r = k(i);
                                    r ? n !== r && (n && A(n, i), t || (t = n), n = J._focused = e = r) : e && e === n && (t && !t.isInserted() && (t = null), n = J._focused = t, t = null, P());
                                }
                                n && A(n, i);
                            }, c[i] = function() {
                                a = !0;
                            }, c[r] = function(t) {
                                var e = J._focused;
                                e && s && e._handleMouseEvent("mouseup", t), a = s = !1;
                            }, Y.add(l, c), Y.add(h, {
                                load: P
                            });
                            var d, p, f, g, v, _, m, y, b = !1, x = !1, w = {
                                doubleclick: "click",
                                mousedrag: "mousemove"
                            }, C = !1, S = {
                                mousedown: {
                                    mousedown: 1,
                                    mousedrag: 1,
                                    click: 1,
                                    doubleclick: 1
                                },
                                mouseup: {
                                    mouseup: 1,
                                    mousedrag: 1,
                                    click: 1,
                                    doubleclick: 1
                                },
                                mousemove: {
                                    mousedrag: 1,
                                    mousemove: 1,
                                    mouseenter: 1,
                                    mouseleave: 1
                                }
                            };
                            return {
                                _viewEvents: u,
                                _handleMouseEvent: function(t, e, i) {
                                    var n = this._itemEvents, r = n.native[t], a = "mousemove" === t, o = this._scope.tool, h = this;
                                    function l(t) {
                                        return n.virtual[t] || h.responds(t) || o && o.responds(t);
                                    }
                                    a && s && l("mousedrag") && (t = "mousedrag"), i || (i = this.getEventPoint(e));
                                    var u = this.getBounds().contains(i), c = r && u && h._project.hitTest(i, {
                                        tolerance: 0,
                                        fill: !0,
                                        stroke: !0
                                    }), w = c && c.item || null, S = !1, k = {};
                                    if (k[t.substr(5)] = !0, r && w !== g && (g && I(g, null, "mouseleave", e, i), w && I(w, null, "mouseenter", e, i), g = w), C ^ u && (I(this, null, u ? "mouseenter" : "mouseleave", e, i), S = !0), (u || k.drag) && !i.equals(p) && (T(this, w, a ? t : "mousemove", e, i, p), S = !0), C = u, k.down && u || k.up && d) {
                                        if (T(this, w, t, e, i, d), k.down) {
                                            if (y = w === _ && Date.now() - m < 300, f = _ = w, !x && w) {
                                                for(var P = w; P && !P.responds("mousedrag");)P = P._parent;
                                                P && (v = w);
                                            }
                                            d = i;
                                        } else k.up && (x || w !== f || (m = Date.now(), T(this, w, y ? "doubleclick" : "click", e, i, d), y = !1), f = v = null);
                                        C = !1, S = !0;
                                    }
                                    p = i, S && o && (b = o._handleMouseEvent(t, e, i, k) || b), !1 !== e.cancelable && (b && !k.move || k.down && l("mouseup")) && e.preventDefault();
                                },
                                _handleKeyEvent: function(t, e, i, n) {
                                    var r, s = this._scope, a = s.tool;
                                    function o(a) {
                                        a.responds(t) && (td = s, a.emit(t, r = r || new te(t, e, i, n)));
                                    }
                                    this.isVisible() && (o(this), a && a.responds(t) && o(a));
                                },
                                _countItemEvent: function(t, e) {
                                    var i = this._itemEvents, n = i.native, r = i.virtual;
                                    for(var s in S)n[s] = (n[s] || 0) + (S[s][t] || 0) * e;
                                    r[t] = (r[t] || 0) + e;
                                },
                                statics: {
                                    updateFocus: P,
                                    _resetState: function() {
                                        s = a = b = C = !1, t = e = d = p = f = g = v = _ = m = y = null;
                                    }
                                }
                            };
                        }
                        function k(t) {
                            var e = Y.getTarget(t);
                            return e.getAttribute && J._viewsById[e.getAttribute("id")];
                        }
                        function P() {
                            var t = J._focused;
                            if (!t || !t.isVisible()) {
                                for(var i = 0, n = J._views.length; i < n; i++)if ((t = J._views[i]).isVisible()) {
                                    J._focused = e = t;
                                    break;
                                }
                            }
                        }
                        function A(t, e, i) {
                            t._handleMouseEvent("mousemove", e, i);
                        }
                        function I(t, e, i, n, r, s, a) {
                            for(var o, h = !1; t && t !== a && !function t(i, a) {
                                if (i.responds(a)) {
                                    if (o || (o = new tn(a, n, r, e || i, s ? r.subtract(s) : null)), i.emit(a, o) && (b = !0, o.prevented && (x = !0), o.stopped)) return h = !0;
                                } else {
                                    var l = w[a];
                                    if (l) return t(i, l);
                                }
                            }(t, i);)t = t._parent;
                            return h;
                        }
                        function T(t, e, i, n, r, s) {
                            return t._project.removeOn(i), x = b = !1, v && I(v, null, i, n, r, s) || e && e !== v && !e.isDescendant(v) && I(e, null, "mousedrag" === i ? "mousemove" : i, n, r, s, v) || I(t, v || e || t, i, n, r, s);
                        }
                    }), K = J.extend({
                        _class: "CanvasView",
                        initialize: function(t, e) {
                            if (!(e instanceof h.HTMLCanvasElement)) {
                                var i = b.read(arguments, 1);
                                if (i.isZero()) throw Error("Cannot create CanvasView with the provided argument: " + u.slice(arguments, 1));
                                e = th.getCanvas(i);
                            }
                            var n = this._context = e.getContext("2d");
                            if (n.save(), this._pixelRatio = 1, !/^off|false$/.test(d.getAttribute(e, "hidpi"))) {
                                var r = h.devicePixelRatio || 1, s = Q.getPrefixed(n, "backingStorePixelRatio") || 1;
                                this._pixelRatio = r / s;
                            }
                            J.call(this, t, e), this._needsUpdate = !0;
                        },
                        remove: function t() {
                            return this._context.restore(), t.base.call(this);
                        },
                        _setElementSize: function t(e, i) {
                            var n = this._pixelRatio;
                            if (t.base.call(this, e * n, i * n), 1 !== n) {
                                var r = this._element, s = this._context;
                                if (!d.hasAttribute(r, "resize")) {
                                    var a = r.style;
                                    a.width = e + "px", a.height = i + "px";
                                }
                                s.restore(), s.save(), s.scale(n, n);
                            }
                        },
                        getContext: function() {
                            return this._context;
                        },
                        getPixelSize: function t(e) {
                            var i, n = td.agent;
                            if (n && n.firefox) i = t.base.call(this, e);
                            else {
                                var r = this._context, s = r.font;
                                r.font = e + " serif", i = parseFloat(r.font), r.font = s;
                            }
                            return i;
                        },
                        getTextWidth: function(t, e) {
                            var i = this._context, n = i.font, r = 0;
                            i.font = t;
                            for(var s = 0, a = e.length; s < a; s++)r = Math.max(r, i.measureText(e[s]).width);
                            return i.font = n, r;
                        },
                        update: function() {
                            if (!this._needsUpdate) return !1;
                            var t = this._project, e = this._context, i = this._viewSize;
                            return e.clearRect(0, 0, i.width + 1, i.height + 1), t && t.draw(e, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
                        }
                    }), tt = u.extend({
                        _class: "Event",
                        initialize: function(t) {
                            this.event = t, this.type = t && t.type;
                        },
                        prevented: !1,
                        stopped: !1,
                        preventDefault: function() {
                            this.prevented = !0, this.event.preventDefault();
                        },
                        stopPropagation: function() {
                            this.stopped = !0, this.event.stopPropagation();
                        },
                        stop: function() {
                            this.stopPropagation(), this.preventDefault();
                        },
                        getTimeStamp: function() {
                            return this.event.timeStamp;
                        },
                        getModifiers: function() {
                            return ti.modifiers;
                        }
                    }), te = tt.extend({
                        _class: "KeyEvent",
                        initialize: function(t, e, i, n) {
                            this.type = t, this.event = e, this.key = i, this.character = n;
                        },
                        toString: function() {
                            return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
                        }
                    }), ti = new function() {
                        var t, e, i = {
                            "	": "tab",
                            " ": "space",
                            "\b": "backspace",
                            "": "delete",
                            Spacebar: "space",
                            Del: "delete",
                            Win: "meta",
                            Esc: "escape"
                        }, n = {
                            tab: "	",
                            space: " ",
                            enter: "\r"
                        }, r = {}, s = {}, a = new u({
                            shift: !1,
                            control: !1,
                            alt: !1,
                            meta: !1,
                            capsLock: !1,
                            space: !1
                        }).inject({
                            option: {
                                get: function() {
                                    return this.alt;
                                }
                            },
                            command: {
                                get: function() {
                                    var t = td && td.agent;
                                    return t && t.mac ? this.meta : this.control;
                                }
                            }
                        });
                        function c(t) {
                            var e = t.key || t.keyIdentifier;
                            return i[e = /^U\+/.test(e) ? String.fromCharCode(parseInt(e.substr(2), 16)) : /^Arrow[A-Z]/.test(e) ? e.substr(5) : "Unidentified" === e || e === o ? String.fromCharCode(t.keyCode) : e] || (e.length > 1 ? u.hyphenate(e) : e.toLowerCase());
                        }
                        function d(e, i, n, o) {
                            var h, l = J._focused;
                            if (r[i] = e, e ? s[i] = n : delete s[i], i.length > 1 && (h = u.camelize(i)) in a) {
                                a[h] = e;
                                var c = td && td.agent;
                                if ("meta" === h && c && c.mac) {
                                    if (e) t = {};
                                    else {
                                        for(var p in t)p in s && d(!1, p, t[p], o);
                                        t = null;
                                    }
                                }
                            } else e && t && (t[i] = n);
                            l && l._handleKeyEvent(e ? "keydown" : "keyup", o, i, n);
                        }
                        return Y.add(l, {
                            keydown: function(t) {
                                var i = c(t), r = td && td.agent;
                                i.length > 1 || r && r.chrome && (t.altKey || r.mac && t.metaKey || !r.mac && t.ctrlKey) ? d(!0, i, n[i] || (i.length > 1 ? "" : i), t) : e = i;
                            },
                            keypress: function(t) {
                                if (e) {
                                    var i = c(t), n = t.charCode, r = n >= 32 ? String.fromCharCode(n) : i.length > 1 ? "" : i;
                                    i !== e && (i = r.toLowerCase()), d(!0, i, r, t), e = null;
                                }
                            },
                            keyup: function(t) {
                                var e = c(t);
                                e in s && d(!1, e, s[e], t);
                            }
                        }), Y.add(h, {
                            blur: function(t) {
                                for(var e in s)d(!1, e, s[e], t);
                            }
                        }), {
                            modifiers: a,
                            isDown: function(t) {
                                return !!r[t];
                            }
                        };
                    }, tn = tt.extend({
                        _class: "MouseEvent",
                        initialize: function(t, e, i, n, r) {
                            this.type = t, this.event = e, this.point = i, this.target = n, this.delta = r;
                        },
                        toString: function() {
                            return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
                        }
                    }), tr = tt.extend({
                        _class: "ToolEvent",
                        _item: null,
                        initialize: function(t, e, i) {
                            this.tool = t, this.type = e, this.event = i;
                        },
                        _choosePoint: function(t, e) {
                            return t || (e ? e.clone() : null);
                        },
                        getPoint: function() {
                            return this._choosePoint(this._point, this.tool._point);
                        },
                        setPoint: function(t) {
                            this._point = t;
                        },
                        getLastPoint: function() {
                            return this._choosePoint(this._lastPoint, this.tool._lastPoint);
                        },
                        setLastPoint: function(t) {
                            this._lastPoint = t;
                        },
                        getDownPoint: function() {
                            return this._choosePoint(this._downPoint, this.tool._downPoint);
                        },
                        setDownPoint: function(t) {
                            this._downPoint = t;
                        },
                        getMiddlePoint: function() {
                            return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
                        },
                        setMiddlePoint: function(t) {
                            this._middlePoint = t;
                        },
                        getDelta: function() {
                            return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
                        },
                        setDelta: function(t) {
                            this._delta = t;
                        },
                        getCount: function() {
                            return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
                        },
                        setCount: function(t) {
                            this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = t;
                        },
                        getItem: function() {
                            if (!this._item) {
                                var t = this.tool._scope.project.hitTest(this.getPoint());
                                if (t) {
                                    for(var e = t.item, i = e._parent; /^(Group|CompoundPath)$/.test(i._class);)e = i, i = i._parent;
                                    this._item = e;
                                }
                            }
                            return this._item;
                        },
                        setItem: function(t) {
                            this._item = t;
                        },
                        toString: function() {
                            return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
                        }
                    }), ts = p.extend({
                        _class: "Tool",
                        _list: "tools",
                        _reference: "tool",
                        _events: [
                            "onMouseDown",
                            "onMouseUp",
                            "onMouseDrag",
                            "onMouseMove",
                            "onActivate",
                            "onDeactivate",
                            "onEditOptions",
                            "onKeyDown",
                            "onKeyUp"
                        ],
                        initialize: function(t) {
                            p.call(this), this._moveCount = -1, this._downCount = -1, this.set(t);
                        },
                        getMinDistance: function() {
                            return this._minDistance;
                        },
                        setMinDistance: function(t) {
                            this._minDistance = t, null != t && null != this._maxDistance && t > this._maxDistance && (this._maxDistance = t);
                        },
                        getMaxDistance: function() {
                            return this._maxDistance;
                        },
                        setMaxDistance: function(t) {
                            this._maxDistance = t, null != this._minDistance && null != t && t < this._minDistance && (this._minDistance = t);
                        },
                        getFixedDistance: function() {
                            return this._minDistance == this._maxDistance ? this._minDistance : null;
                        },
                        setFixedDistance: function(t) {
                            this._minDistance = this._maxDistance = t;
                        },
                        _handleMouseEvent: function(t, e, i, n) {
                            td = this._scope, n.drag && !this.responds(t) && (t = "mousemove");
                            var r = n.move || n.drag, s = this.responds(t), a = this.minDistance, o = this.maxDistance, h = !1, l = this;
                            function u(t, e) {
                                var s = i, a = r ? l._point : l._downPoint || s;
                                if (r) {
                                    if (l._moveCount >= 0 && s.equals(a)) return !1;
                                    if (a && (null != t || null != e)) {
                                        var o = s.subtract(a), h = o.getLength();
                                        if (h < (t || 0)) return !1;
                                        e && (s = a.add(o.normalize(Math.min(h, e))));
                                    }
                                    l._moveCount++;
                                }
                                return l._point = s, l._lastPoint = a || s, n.down && (l._moveCount = -1, l._downPoint = s, l._downCount++), !0;
                            }
                            function c() {
                                s && (h = l.emit(t, new tr(l, t, e)) || h);
                            }
                            if (n.down) u(), c();
                            else if (n.up) u(null, o), c();
                            else if (s) for(; u(a, o);)c();
                            return h;
                        }
                    }), ta = u.extend(c, {
                        _class: "Tween",
                        statics: {
                            easings: {
                                linear: function(t) {
                                    return t;
                                },
                                easeInQuad: function(t) {
                                    return t * t;
                                },
                                easeOutQuad: function(t) {
                                    return t * (2 - t);
                                },
                                easeInOutQuad: function(t) {
                                    return t < .5 ? 2 * t * t : -1 + 2 * (2 - t) * t;
                                },
                                easeInCubic: function(t) {
                                    return t * t * t;
                                },
                                easeOutCubic: function(t) {
                                    return --t * t * t + 1;
                                },
                                easeInOutCubic: function(t) {
                                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                                },
                                easeInQuart: function(t) {
                                    return t * t * t * t;
                                },
                                easeOutQuart: function(t) {
                                    return 1 - --t * t * t * t;
                                },
                                easeInOutQuart: function(t) {
                                    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
                                },
                                easeInQuint: function(t) {
                                    return t * t * t * t * t;
                                },
                                easeOutQuint: function(t) {
                                    return 1 + --t * t * t * t * t;
                                },
                                easeInOutQuint: function(t) {
                                    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
                                }
                            }
                        },
                        initialize: function t(e, i, n, r, s, a) {
                            this.object = e;
                            var o = typeof s, h = "function" === o;
                            this.type = h ? o : "string" === o ? s : "linear", this.easing = h ? s : t.easings[this.type], this.duration = r, this.running = !1, this._then = null, this._startTime = null;
                            var l = i || n;
                            this._keys = l ? Object.keys(l) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = l && this._getState(i), this._to = l && this._getState(n), !1 !== a && this.start();
                        },
                        then: function(t) {
                            return this._then = t, this;
                        },
                        start: function() {
                            return this._startTime = null, this.running = !0, this;
                        },
                        stop: function() {
                            return this.running = !1, this;
                        },
                        update: function(t) {
                            if (this.running) {
                                t >= 1 && (t = 1, this.running = !1);
                                for(var e = this.easing(t), i = this._keys, n = function(i) {
                                    return "function" == typeof i ? i(e, t) : i;
                                }, r = 0, s = i && i.length; r < s; r++){
                                    var a = i[r], o = n(this._from[a]), h = n(this._to[a]), l = o && h && o.__add && h.__add ? h.__subtract(o).__multiply(e).__add(o) : (h - o) * e + o;
                                    this._setProperty(this._parsedKeys[a], l);
                                }
                                this.responds("update") && this.emit("update", new u({
                                    progress: t,
                                    factor: e
                                })), !this.running && this._then && this._then(this.object);
                            }
                            return this;
                        },
                        _events: {
                            onUpdate: {}
                        },
                        _handleFrame: function(t) {
                            var e = this._startTime, i = e ? (t - e) / this.duration : 0;
                            e || (this._startTime = t), this.update(i);
                        },
                        _getState: function(t) {
                            for(var e = this._keys, i = {}, n = 0, r = e.length; n < r; n++){
                                var s, a = e[n], o = this._parsedKeys[a], h = this._getProperty(o);
                                if (t) {
                                    var l = this._resolveValue(h, t[a]);
                                    this._setProperty(o, l), s = (s = this._getProperty(o)) && s.clone ? s.clone() : s, this._setProperty(o, h);
                                } else s = h && h.clone ? h.clone() : h;
                                i[a] = s;
                            }
                            return i;
                        },
                        _resolveValue: function(t, e) {
                            if (e) {
                                if (Array.isArray(e) && 2 === e.length) {
                                    var i = e[0];
                                    return i && i.match && i.match(/^[+\-\*\/]=/) ? this._calculate(t, i[0], e[1]) : e;
                                } else if ("string" == typeof e) {
                                    var n = e.match(/^[+\-*/]=(.*)/);
                                    if (n) {
                                        var r = JSON.parse(n[1].replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": '));
                                        return this._calculate(t, e[0], r);
                                    }
                                }
                            }
                            return e;
                        },
                        _calculate: function(t, e, i) {
                            return td.PaperScript.calculateBinary(t, e, i);
                        },
                        _parseKeys: function(t) {
                            for(var e = {}, i = 0, n = t.length; i < n; i++){
                                var r = t[i], s = r.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
                                e[r] = s.split("/");
                            }
                            return e;
                        },
                        _getProperty: function(t, e) {
                            for(var i = this.object, n = 0, r = t.length - (e || 0); n < r && i; n++)i = i[t[n]];
                            return i;
                        },
                        _setProperty: function(t, e) {
                            var i = this._getProperty(t, 1);
                            i && (i[t[t.length - 1]] = e);
                        }
                    }), to = {
                        request: function(t) {
                            var e = new a.XMLHttpRequest;
                            return e.open((t.method || "get").toUpperCase(), t.url, u.pick(t.async, !0)), t.mimeType && e.overrideMimeType(t.mimeType), e.onload = function() {
                                var i = e.status;
                                0 === i || 200 === i ? t.onLoad && t.onLoad.call(e, e.responseText) : e.onerror();
                            }, e.onerror = function() {
                                var i = e.status, n = 'Could not load "' + t.url + '" (Status: ' + i + ")";
                                if (t.onError) t.onError(n, i);
                                else throw Error(n);
                            }, e.send(null);
                        }
                    }, th = {
                        canvases: [],
                        getCanvas: function(t, e) {
                            if (!h) return null;
                            var i, n = !0;
                            "object" == typeof t && (e = t.height, t = t.width), this.canvases.length ? i = this.canvases.pop() : (i = l.createElement("canvas"), n = !1);
                            var r = i.getContext("2d");
                            if (!r) throw Error("Canvas " + i + " is unable to provide a 2D context.");
                            return i.width === t && i.height === e ? n && r.clearRect(0, 0, t + 1, e + 1) : (i.width = t, i.height = e), r.save(), i;
                        },
                        getContext: function(t, e) {
                            var i = this.getCanvas(t, e);
                            return i ? i.getContext("2d") : null;
                        },
                        release: function(t) {
                            var e = t && t.canvas ? t.canvas : t;
                            e && e.getContext && (e.getContext("2d").restore(), this.canvases.push(e));
                        }
                    }, tl = new function() {
                        var t, e, i, n, r, s, a, o, h, l, c, d = Math.min, p = Math.max, f = Math.abs;
                        function g(t, e, i) {
                            return .2989 * t + .587 * e + .114 * i;
                        }
                        function v(t, e, i, n) {
                            var r = n - g(t, e, i), n = g(h = t + r, l = e + r, c = i + r), s = d(h, l, c), a = p(h, l, c);
                            if (s < 0) {
                                var o = n - s;
                                h = n + (h - n) * n / o, l = n + (l - n) * n / o, c = n + (c - n) * n / o;
                            }
                            if (a > 255) {
                                var u = 255 - n, f = a - n;
                                h = n + (h - n) * u / f, l = n + (l - n) * u / f, c = n + (c - n) * u / f;
                            }
                        }
                        function _(t, e, i) {
                            return p(t, e, i) - d(t, e, i);
                        }
                        function m(t, e, i, n) {
                            var r, s = [
                                t,
                                e,
                                i
                            ], a = p(t, e, i), o = d(t, e, i);
                            r = 0 === d(o = o === t ? 0 : o === e ? 1 : 2, a = a === t ? 0 : a === e ? 1 : 2) ? 1 === p(o, a) ? 2 : 1 : 0, s[a] > s[o] ? (s[r] = (s[r] - s[o]) * n / (s[a] - s[o]), s[a] = n) : s[r] = s[a] = 0, s[o] = 0, h = s[0], l = s[1], c = s[2];
                        }
                        var y = {
                            multiply: function() {
                                h = r * t / 255, l = s * e / 255, c = a * i / 255;
                            },
                            screen: function() {
                                h = r + t - r * t / 255, l = s + e - s * e / 255, c = a + i - a * i / 255;
                            },
                            overlay: function() {
                                h = r < 128 ? 2 * r * t / 255 : 255 - 2 * (255 - r) * (255 - t) / 255, l = s < 128 ? 2 * s * e / 255 : 255 - 2 * (255 - s) * (255 - e) / 255, c = a < 128 ? 2 * a * i / 255 : 255 - 2 * (255 - a) * (255 - i) / 255;
                            },
                            "soft-light": function() {
                                var n = t * r / 255;
                                h = n + r * (255 - (255 - r) * (255 - t) / 255 - n) / 255, l = (n = e * s / 255) + s * (255 - (255 - s) * (255 - e) / 255 - n) / 255, c = (n = i * a / 255) + a * (255 - (255 - a) * (255 - i) / 255 - n) / 255;
                            },
                            "hard-light": function() {
                                h = t < 128 ? 2 * t * r / 255 : 255 - 2 * (255 - t) * (255 - r) / 255, l = e < 128 ? 2 * e * s / 255 : 255 - 2 * (255 - e) * (255 - s) / 255, c = i < 128 ? 2 * i * a / 255 : 255 - 2 * (255 - i) * (255 - a) / 255;
                            },
                            "color-dodge": function() {
                                h = 0 === r ? 0 : 255 === t ? 255 : d(255, 255 * r / (255 - t)), l = 0 === s ? 0 : 255 === e ? 255 : d(255, 255 * s / (255 - e)), c = 0 === a ? 0 : 255 === i ? 255 : d(255, 255 * a / (255 - i));
                            },
                            "color-burn": function() {
                                h = 255 === r ? 255 : 0 === t ? 0 : p(0, 255 - (255 - r) * 255 / t), l = 255 === s ? 255 : 0 === e ? 0 : p(0, 255 - (255 - s) * 255 / e), c = 255 === a ? 255 : 0 === i ? 0 : p(0, 255 - (255 - a) * 255 / i);
                            },
                            darken: function() {
                                h = r < t ? r : t, l = s < e ? s : e, c = a < i ? a : i;
                            },
                            lighten: function() {
                                h = r > t ? r : t, l = s > e ? s : e, c = a > i ? a : i;
                            },
                            difference: function() {
                                (h = r - t) < 0 && (h = -h), (l = s - e) < 0 && (l = -l), (c = a - i) < 0 && (c = -c);
                            },
                            exclusion: function() {
                                h = r + t * (255 - r - r) / 255, l = s + e * (255 - s - s) / 255, c = a + i * (255 - a - a) / 255;
                            },
                            hue: function() {
                                m(t, e, i, _(r, s, a)), v(h, l, c, g(r, s, a));
                            },
                            saturation: function() {
                                m(r, s, a, _(t, e, i)), v(h, l, c, g(r, s, a));
                            },
                            luminosity: function() {
                                v(r, s, a, g(t, e, i));
                            },
                            color: function() {
                                v(t, e, i, g(r, s, a));
                            },
                            add: function() {
                                h = d(r + t, 255), l = d(s + e, 255), c = d(a + i, 255);
                            },
                            subtract: function() {
                                h = p(r - t, 0), l = p(s - e, 0), c = p(a - i, 0);
                            },
                            average: function() {
                                h = (r + t) / 2, l = (s + e) / 2, c = (a + i) / 2;
                            },
                            negation: function() {
                                h = 255 - f(255 - t - r), l = 255 - f(255 - e - s), c = 255 - f(255 - i - a);
                            }
                        }, b = this.nativeModes = u.each([
                            "source-over",
                            "source-in",
                            "source-out",
                            "source-atop",
                            "destination-over",
                            "destination-in",
                            "destination-out",
                            "destination-atop",
                            "lighter",
                            "darker",
                            "copy",
                            "xor"
                        ], function(t) {
                            this[t] = !0;
                        }, {}), x = th.getContext(1, 1);
                        x && (u.each(y, function(t, e) {
                            var i = "darken" === e, n = !1;
                            x.save();
                            try {
                                x.fillStyle = i ? "#300" : "#a00", x.fillRect(0, 0, 1, 1), x.globalCompositeOperation = e, x.globalCompositeOperation === e && (x.fillStyle = i ? "#a00" : "#300", x.fillRect(0, 0, 1, 1), n = x.getImageData(0, 0, 1, 1).data[0] !== i ? 170 : 51);
                            } catch (t) {}
                            x.restore(), b[e] = n;
                        }), th.release(x)), this.process = function(u, d, p, f, g) {
                            var v = d.canvas, _ = "normal" === u;
                            if (_ || b[u]) p.save(), p.setTransform(1, 0, 0, 1, 0, 0), p.globalAlpha = f, _ || (p.globalCompositeOperation = u), p.drawImage(v, g.x, g.y), p.restore();
                            else {
                                var m = y[u];
                                if (!m) return;
                                for(var x = p.getImageData(g.x, g.y, v.width, v.height), w = x.data, C = d.getImageData(0, 0, v.width, v.height).data, S = 0, k = w.length; S < k; S += 4){
                                    t = C[S], r = w[S], e = C[S + 1], s = w[S + 1], i = C[S + 2], a = w[S + 2], n = C[S + 3], o = w[S + 3], m();
                                    var P = n * f / 255, A = 1 - P;
                                    w[S] = P * h + A * r, w[S + 1] = P * l + A * s, w[S + 2] = P * c + A * a, w[S + 3] = n * f + A * o;
                                }
                                p.putImageData(x, g.x, g.y);
                            }
                        };
                    }, tu = new function() {
                        var t = "http://www.w3.org/2000/svg", e = "http://www.w3.org/2000/xmlns", i = "http://www.w3.org/1999/xlink", n = {
                            href: i,
                            xlink: e,
                            xmlns: e + "/",
                            "xmlns:xlink": e + "/"
                        };
                        function r(t, e, i) {
                            for(var r in e){
                                var s = e[r], a = n[r];
                                "number" == typeof s && i && (s = i.number(s)), a ? t.setAttributeNS(a, r, s) : t.setAttribute(r, s);
                            }
                            return t;
                        }
                        return {
                            svg: t,
                            xmlns: e,
                            xlink: i,
                            create: function(e, i, n) {
                                return r(l.createElementNS(t, e), i, n);
                            },
                            get: function(t, e) {
                                var i = n[e], r = i ? t.getAttributeNS(i, e) : t.getAttribute(e);
                                return "null" === r ? null : r;
                            },
                            set: r
                        };
                    }, tc = u.each({
                        fillColor: [
                            "fill",
                            "color"
                        ],
                        fillRule: [
                            "fill-rule",
                            "string"
                        ],
                        strokeColor: [
                            "stroke",
                            "color"
                        ],
                        strokeWidth: [
                            "stroke-width",
                            "number"
                        ],
                        strokeCap: [
                            "stroke-linecap",
                            "string"
                        ],
                        strokeJoin: [
                            "stroke-linejoin",
                            "string"
                        ],
                        strokeScaling: [
                            "vector-effect",
                            "lookup",
                            {
                                true: "none",
                                false: "non-scaling-stroke"
                            },
                            function(t, e) {
                                return !e && (t instanceof F || t instanceof E || t instanceof U);
                            }
                        ],
                        miterLimit: [
                            "stroke-miterlimit",
                            "number"
                        ],
                        dashArray: [
                            "stroke-dasharray",
                            "array"
                        ],
                        dashOffset: [
                            "stroke-dashoffset",
                            "number"
                        ],
                        fontFamily: [
                            "font-family",
                            "string"
                        ],
                        fontWeight: [
                            "font-weight",
                            "string"
                        ],
                        fontSize: [
                            "font-size",
                            "number"
                        ],
                        justification: [
                            "text-anchor",
                            "lookup",
                            {
                                left: "start",
                                center: "middle",
                                right: "end"
                            }
                        ],
                        opacity: [
                            "opacity",
                            "number"
                        ],
                        blendMode: [
                            "mix-blend-mode",
                            "style"
                        ]
                    }, function(t, e) {
                        var i = u.capitalize(e), n = t[2];
                        this[e] = {
                            type: t[1],
                            property: e,
                            attribute: t[0],
                            toSVG: n,
                            fromSVG: n && u.each(n, function(t, e) {
                                this[t] = e;
                            }, {}),
                            exportFilter: t[3],
                            get: "get" + i,
                            set: "set" + i
                        };
                    }, {});
                    new function() {
                        function t(t, e, i) {
                            var r, s = new u, a = t.getTranslation();
                            if (e && (t.isInvertible() ? (r = (t = t._shiftless())._inverseTransform(a), a = null) : r = new m, s[i ? "cx" : "x"] = r.x, s[i ? "cy" : "y"] = r.y), !t.isIdentity()) {
                                var o = t.decompose();
                                if (o) {
                                    var h = [], l = o.rotation, c = o.scaling, d = o.skewing;
                                    a && !a.isZero() && h.push("translate(" + n.point(a) + ")"), l && h.push("rotate(" + n.number(l) + ")"), v.isZero(c.x - 1) && v.isZero(c.y - 1) || h.push("scale(" + n.point(c) + ")"), d.x && h.push("skewX(" + n.number(d.x) + ")"), d.y && h.push("skewY(" + n.number(d.y) + ")"), s.transform = h.join(" ");
                                } else s.transform = "matrix(" + t.getValues().join(",") + ")";
                            }
                            return s;
                        }
                        function e(e, i) {
                            for(var r = t(e._matrix), s = e._children, a = tu.create("g", r, n), o = 0, l = s.length; o < l; o++){
                                var u = s[o], d = c(u, i);
                                if (d) {
                                    if (u.isClipMask()) {
                                        var p = tu.create("clipPath");
                                        p.appendChild(d), h(u, p, "clip"), tu.set(a, {
                                            "clip-path": "url(#" + p.id + ")"
                                        });
                                    } else a.appendChild(d);
                                }
                            }
                            return a;
                        }
                        function i(e) {
                            var i = e._type, r = e._radius, s = t(e._matrix, !0, "rectangle" !== i);
                            if ("rectangle" === i) {
                                i = "rect";
                                var a = e._size, o = a.width, h = a.height;
                                s.x -= o / 2, s.y -= h / 2, s.width = o, s.height = h, r.isZero() && (r = null);
                            }
                            return r && ("circle" === i ? s.r = r : (s.rx = r.width, s.ry = r.height)), tu.create(i, s, n);
                        }
                        var n, r, s = {
                            Group: e,
                            Layer: e,
                            Raster: function(e, i) {
                                var r = t(e._matrix, !0), s = e.getSize(), a = e.getImage();
                                return r.x -= s.width / 2, r.y -= s.height / 2, r.width = s.width, r.height = s.height, r.href = !1 == i.embedImages && a && a.src || e.toDataURL(), tu.create("image", r, n);
                            },
                            Path: function(e, r) {
                                var s = r.matchShapes;
                                if (s) {
                                    var a = e.toShape(!1);
                                    if (a) return i(a, r);
                                }
                                var o, h = e._segments, l = h.length, u = t(e._matrix);
                                if (s && l >= 2 && !e.hasHandles()) {
                                    if (l > 2) {
                                        o = e._closed ? "polygon" : "polyline";
                                        for(var c = [], d = 0; d < l; d++)c.push(n.point(h[d]._point));
                                        u.points = c.join(" ");
                                    } else {
                                        o = "line";
                                        var p = h[0]._point, f = h[1]._point;
                                        u.set({
                                            x1: p.x,
                                            y1: p.y,
                                            x2: f.x,
                                            y2: f.y
                                        });
                                    }
                                } else o = "path", u.d = e.getPathData(null, r.precision);
                                return tu.create(o, u, n);
                            },
                            Shape: i,
                            CompoundPath: function(e, i) {
                                var r = t(e._matrix), s = e.getPathData(null, i.precision);
                                return s && (r.d = s), tu.create("path", r, n);
                            },
                            SymbolItem: function(e, i) {
                                var r = t(e._matrix, !0), s = e._definition, a = o(s, "symbol"), l = s._item, u = l.getStrokeBounds();
                                return a || ((a = tu.create("symbol", {
                                    viewBox: n.rectangle(u)
                                })).appendChild(c(l, i)), h(s, a, "symbol")), r.href = "#" + a.id, r.x += u.x, r.y += u.y, r.width = u.width, r.height = u.height, r.overflow = "visible", tu.create("use", r, n);
                            },
                            PointText: function(e) {
                                var i = tu.create("text", t(e._matrix, !0), n);
                                return i.textContent = e._content, i;
                            }
                        };
                        function o(t, e) {
                            return r || (r = {
                                ids: {},
                                svgs: {}
                            }), t && r.svgs[e + "-" + (t._id || t.__id || (t.__id = _.get("svg")))];
                        }
                        function h(t, e, i) {
                            r || o();
                            var n = r.ids[i] = (r.ids[i] || 0) + 1;
                            e.id = i + "-" + n, r.svgs[i + "-" + (t._id || t.__id)] = e;
                        }
                        function l(t, e) {
                            var i = t, n = null;
                            if (r) {
                                for(var s in i = "svg" === t.nodeName.toLowerCase() && t, r.svgs)n || (i || (i = tu.create("svg")).appendChild(t), n = i.insertBefore(tu.create("defs"), i.firstChild)), n.appendChild(r.svgs[s]);
                                r = null;
                            }
                            return e.asString ? new a.XMLSerializer().serializeToString(i) : i;
                        }
                        function c(t, e, i) {
                            var r, a, l, c, d = s[t._class], p = d && d(t, e);
                            if (p) {
                                var f = e.onExport;
                                f && (p = f(t, p, e) || p);
                                var g = JSON.stringify(t._data);
                                g && "{}" !== g && "null" !== g && p.setAttribute("data-paper-data", g);
                            }
                            return p && (r = p, a = {}, l = !i && t.getParent(), c = [], null != t._name && (a.id = t._name), u.each(tc, function(e) {
                                var i = e.get, r = e.type, s = t[i]();
                                if (e.exportFilter ? e.exportFilter(t, s) : !l || !u.equals(l[i](), s)) {
                                    if ("color" === r && null != s) {
                                        var d = s.getAlpha();
                                        d < 1 && (a[e.attribute + "-opacity"] = d);
                                    }
                                    "style" === r ? c.push(e.attribute + ": " + s) : a[e.attribute] = null == s ? "none" : "color" === r ? s.gradient ? function(t) {
                                        var e = o(t, "color");
                                        if (!e) {
                                            var i, r = t.getGradient(), s = r._radial, a = t.getOrigin(), l = t.getDestination();
                                            if (s) {
                                                i = {
                                                    cx: a.x,
                                                    cy: a.y,
                                                    r: a.getDistance(l)
                                                };
                                                var u = t.getHighlight();
                                                u && (i.fx = u.x, i.fy = u.y);
                                            } else i = {
                                                x1: a.x,
                                                y1: a.y,
                                                x2: l.x,
                                                y2: l.y
                                            };
                                            i.gradientUnits = "userSpaceOnUse", e = tu.create((s ? "radial" : "linear") + "Gradient", i, n);
                                            for(var c = r._stops, d = 0, p = c.length; d < p; d++){
                                                var f = c[d], g = f._color, v = g.getAlpha(), _ = f._offset;
                                                i = {
                                                    offset: null == _ ? d / (p - 1) : _
                                                }, g && (i["stop-color"] = g.toCSS(!0)), v < 1 && (i["stop-opacity"] = v), e.appendChild(tu.create("stop", i, n));
                                            }
                                            h(t, e, "color");
                                        }
                                        return "url(#" + e.id + ")";
                                    }(s, t) : s.toCSS(!0) : "array" === r ? s.join(",") : "lookup" === r ? e.toSVG[s] : s;
                                }
                            }), c.length && (a.style = c.join(";")), 1 === a.opacity && delete a.opacity, t._visible || (a.visibility = "hidden"), tu.set(r, a, n));
                        }
                        function d(t) {
                            return t || (t = {}), n = new g(t.precision), t;
                        }
                        A.inject({
                            exportSVG: function(t) {
                                return l(c(this, t = d(t), !0), t);
                            }
                        }), P.inject({
                            exportSVG: function(e) {
                                e = d(e);
                                var i = this._children, r = this.getView(), s = u.pick(e.bounds, "view"), a = e.matrix || "view" === s && r._matrix, o = a && S.read([
                                    a
                                ]), h = "view" === s ? new w([
                                    0,
                                    0
                                ], r.getViewSize()) : "content" === s ? A._getBounds(i, o, {
                                    stroke: !0
                                }).rect : w.read([
                                    s
                                ], 0, {
                                    readNull: !0
                                }), p = {
                                    version: "1.1",
                                    xmlns: tu.svg,
                                    "xmlns:xlink": tu.xlink
                                };
                                h && (p.width = h.width, p.height = h.height, (h.x || 0 === h.x || h.y || 0 === h.y) && (p.viewBox = n.rectangle(h)));
                                var f = tu.create("svg", p, n), g = f;
                                o && !o.isIdentity() && (g = f.appendChild(tu.create("g", t(o), n)));
                                for(var v = 0, _ = i.length; v < _; v++)g.appendChild(c(i[v], e, !0));
                                return l(f, e);
                            }
                        });
                    }, new function() {
                        var t, e = {};
                        function i(e, i, n, r, s, a) {
                            var o = tu.get(e, i) || a, h = null == o ? r ? null : n ? "" : 0 : n ? o : parseFloat(o);
                            return /%\s*$/.test(o) ? h / 100 * (s ? 1 : t[/x|^width/.test(i) ? "width" : "height"]) : h;
                        }
                        function n(t, e, n, r, s, a, o) {
                            return e = i(t, e || "x", !1, r, s, a), n = i(t, n || "y", !1, r, s, o), r && (null == e || null == n) ? null : new m(e, n);
                        }
                        function r(t, e, n, r, s) {
                            return e = i(t, e || "width", !1, r, s), n = i(t, n || "height", !1, r, s), r && (null == e || null == n) ? null : new b(e, n);
                        }
                        function s(t, e, i) {
                            return "none" === t ? null : "number" === e ? parseFloat(t) : "array" === e ? t ? t.split(/[\s,]+/g).map(parseFloat) : [] : "color" === e ? C(t) || t : "lookup" === e ? i[t] : t;
                        }
                        function c(t, e, i, n) {
                            var r = t.childNodes, s = "clippath" === e, a = "defs" === e, o = new I, h = o._project, l = h._currentStyle, u = [];
                            if (s || a || (h._currentStyle = (o = x(o, t, n))._style.clone()), n) for(var c = t.querySelectorAll("defs"), d = 0, p = c.length; d < p; d++)k(c[d], i, !1);
                            for(var d = 0, p = r.length; d < p; d++){
                                var f, g = r[d];
                                !(1 === g.nodeType && !/^defs$/i.test(g.nodeName) && (f = k(g, i, !1))) || f instanceof B || u.push(f);
                            }
                            return o.addChildren(u), s && (o = x(o.reduce(), t, n)), h._currentStyle = l, (s || a) && (o.remove(), o = null), o;
                        }
                        function d(t, e) {
                            for(var i = t.getAttribute("points").match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g), n = [], r = 0, s = i.length; r < s; r += 2)n.push(new m(parseFloat(i[r]), parseFloat(i[r + 1])));
                            var a = new D(n);
                            return "polygon" === e && a.closePath(), a;
                        }
                        function p(t, r) {
                            var s, a = (i(t, "href", !0) || "").substring(1), o = "radialgradient" === r;
                            if (a) (s = e[a].getGradient())._radial ^ o && ((s = s.clone())._radial = o);
                            else {
                                for(var h = t.childNodes, l = [], u = 0, c = h.length; u < c; u++){
                                    var d = h[u];
                                    1 === d.nodeType && l.push(x(new X, d));
                                }
                                s = new Z(l, o);
                            }
                            var p, f, g, v = "userSpaceOnUse" !== i(t, "gradientUnits", !0);
                            return o ? (f = (p = n(t, "cx", "cy", !1, v, "50%", "50%")).add(i(t, "r", !1, !1, v, "50%"), 0), g = n(t, "fx", "fy", !0, v)) : (p = n(t, "x1", "y1", !1, v, "0%", "0%"), f = n(t, "x2", "y2", !1, v, "100%", "0%")), x(new G(s, p, f, g), t)._scaleToBounds = v, null;
                        }
                        var f = {
                            "#document": function(t, e, i, n) {
                                for(var r = t.childNodes, s = 0, a = r.length; s < a; s++){
                                    var o = r[s];
                                    if (1 === o.nodeType) return k(o, i, n);
                                }
                            },
                            g: c,
                            svg: c,
                            clippath: c,
                            polygon: d,
                            polyline: d,
                            path: function(t) {
                                return F.create(t.getAttribute("d"));
                            },
                            lineargradient: p,
                            radialgradient: p,
                            image: function(t) {
                                var e = new L(i(t, "href", !0));
                                return e.on("load", function() {
                                    var e = r(t);
                                    this.setSize(e);
                                    var i = n(t).add(e.divide(2));
                                    this._matrix.append(new S().translate(i));
                                }), e;
                            },
                            symbol: function(t, e, i, n) {
                                return new B(c(t, e, i, n), !0);
                            },
                            defs: c,
                            use: function(t) {
                                var r = e[(i(t, "href", !0) || "").substring(1)], s = n(t);
                                return r ? r instanceof B ? r.place(s) : r.clone().translate(s) : null;
                            },
                            circle: function(t) {
                                return new E.Circle(n(t, "cx", "cy"), i(t, "r"));
                            },
                            ellipse: function(t) {
                                return new E.Ellipse({
                                    center: n(t, "cx", "cy"),
                                    radius: r(t, "rx", "ry")
                                });
                            },
                            rect: function(t) {
                                return new E.Rectangle(new w(n(t), r(t)), r(t, "rx", "ry"));
                            },
                            line: function(t) {
                                return new D.Line(n(t, "x1", "y1"), n(t, "x2", "y2"));
                            },
                            text: function(t) {
                                var e = new W(n(t).add(n(t, "dx", "dy")));
                                return e.setContent(t.textContent.trim() || ""), e;
                            },
                            switch: c
                        };
                        function g(t, e, i, n) {
                            if (t.transform) {
                                for(var r = (n.getAttribute(i) || "").split(/\)\s*/g), s = new S, a = 0, o = r.length; a < o; a++){
                                    var h = r[a];
                                    if (!h) break;
                                    for(var l = h.split(/\(\s*/), u = l[0], c = l[1].split(/[\s,]+/g), d = 0, p = c.length; d < p; d++)c[d] = parseFloat(c[d]);
                                    switch(u){
                                        case "matrix":
                                            s.append(new S(c[0], c[1], c[2], c[3], c[4], c[5]));
                                            break;
                                        case "rotate":
                                            s.rotate(c[0], c[1] || 0, c[2] || 0);
                                            break;
                                        case "translate":
                                            s.translate(c[0], c[1] || 0);
                                            break;
                                        case "scale":
                                            s.scale(c);
                                            break;
                                        case "skewX":
                                            s.skew(c[0], 0);
                                            break;
                                        case "skewY":
                                            s.skew(0, c[0]);
                                    }
                                }
                                t.transform(s);
                            }
                        }
                        function v(t, e, i) {
                            var n = "fill-opacity" === i ? "getFillColor" : "getStrokeColor", r = t[n] && t[n]();
                            r && r.setAlpha(parseFloat(e));
                        }
                        var _ = u.set(u.each(tc, function(t) {
                            this[t.attribute] = function(e, i) {
                                if (e[t.set] && (e[t.set](s(i, t.type, t.fromSVG)), "color" === t.type)) {
                                    var n = e[t.get]();
                                    if (n && n._scaleToBounds) {
                                        var r = e.getBounds();
                                        n.transform(new S().translate(r.getPoint()).scale(r.getSize()));
                                    }
                                }
                            };
                        }, {}), {
                            id: function(t, i) {
                                e[i] = t, t.setName && t.setName(i);
                            },
                            "clip-path": function(t, e) {
                                var i = C(e);
                                if (i) {
                                    if ((i = i.clone()).setClipMask(!0), !(t instanceof I)) return new I(i, t);
                                    t.insertChild(0, i);
                                }
                            },
                            gradientTransform: g,
                            transform: g,
                            "fill-opacity": v,
                            "stroke-opacity": v,
                            visibility: function(t, e) {
                                t.setVisible && t.setVisible("visible" === e);
                            },
                            display: function(t, e) {
                                t.setVisible && t.setVisible(null !== e);
                            },
                            "stop-color": function(t, e) {
                                t.setColor && t.setColor(e);
                            },
                            "stop-opacity": function(t, e) {
                                t._color && t._color.setAlpha(parseFloat(e));
                            },
                            offset: function(t, e) {
                                if (t.setOffset) {
                                    var i = e.match(/(.*)%$/);
                                    t.setOffset(i ? i[1] / 100 : parseFloat(e));
                                }
                            },
                            viewBox: function(t, e, i, n, a) {
                                var o, h, l = new w(s(e, "array")), u = r(n, null, null, !0);
                                if (t instanceof I) {
                                    var c = u ? u.divide(l.getSize()) : 1, h = new S().scale(c).translate(l.getPoint().negate());
                                    o = t;
                                } else t instanceof B && (u && l.setSize(u), o = t._item);
                                if (o) {
                                    if ("visible" !== y(n, "overflow", a)) {
                                        var d = new E.Rectangle(l);
                                        d.setClipMask(!0), o.addChild(d);
                                    }
                                    h && o.transform(h);
                                }
                            }
                        });
                        function y(t, e, i) {
                            var n = t.attributes[e], r = n && n.value;
                            if (!r && t.style) {
                                var s = u.camelize(e);
                                (r = t.style[s]) || i.node[s] === i.parent[s] || (r = i.node[s]);
                            }
                            return r ? "none" === r ? null : r : o;
                        }
                        function x(t, e, i) {
                            var n = e.parentNode, r = {
                                node: Q.getStyles(e) || {},
                                parent: !i && !/^defs$/i.test(n.tagName) && Q.getStyles(n) || {}
                            };
                            return u.each(_, function(i, n) {
                                var s = y(e, n, r);
                                t = s !== o && i(t, s, n, e, r) || t;
                            }), t;
                        }
                        function C(t) {
                            var i = t && t.match(/\((?:["'#]*)([^"')]+)/), n = i && i[1], r = n && e[h ? n.replace(h.location.href.split("#")[0] + "#", "") : n];
                            return r && r._scaleToBounds && ((r = r.clone())._scaleToBounds = !0), r;
                        }
                        function k(i, n, s) {
                            var a, o, h, c = i.nodeName.toLowerCase(), d = "#document" !== c, p = l.body;
                            s && d && (t = td.getView().getSize(), t = r(i, null, null, !0) || t, a = tu.create("svg", {
                                style: "stroke-width: 1px; stroke-miterlimit: 10"
                            }), o = i.parentNode, h = i.nextSibling, a.appendChild(i), p.appendChild(a));
                            var g = td.settings, v = g.applyMatrix, _ = g.insertItems;
                            g.applyMatrix = !1, g.insertItems = !1;
                            var m = f[c], y = m && m(i, c, n, s) || null;
                            if (g.insertItems = _, g.applyMatrix = v, y) {
                                !d || y instanceof I || (y = x(y, i, s));
                                var b = n.onImport, w = d && i.getAttribute("data-paper-data");
                                b && (y = b(i, y, n) || y), n.expandShapes && y instanceof E && (y.remove(), y = y.toPath()), w && (y._data = JSON.parse(w));
                            }
                            return a && (p.removeChild(a), o && (h ? o.insertBefore(i, h) : o.appendChild(i))), s && (e = {}, y && u.pick(n.applyMatrix, v) && y.matrix.apply(!0, !0)), y;
                        }
                        function T(t, e, i) {
                            if (!t) return null;
                            e = "function" == typeof e ? {
                                onLoad: e
                            } : e || {};
                            var n = td, r = null;
                            function s(s) {
                                try {
                                    var l = "object" == typeof s ? s : new a.DOMParser().parseFromString(s.trim(), "image/svg+xml");
                                    if (!l.nodeName) throw l = null, Error("Unsupported SVG source: " + t);
                                    td = n, r = k(l, e, !0), e && !1 === e.insert || i._insertItem(o, r);
                                    var u = e.onLoad;
                                    u && u(r, s);
                                } catch (t) {
                                    h(t);
                                }
                            }
                            function h(t, i) {
                                var n = e.onError;
                                if (n) n(t, i);
                                else throw Error(t);
                            }
                            if ("string" != typeof t || /^[\s\S]*</.test(t)) {
                                if ("undefined" != typeof File && t instanceof File) {
                                    var u = new FileReader;
                                    return u.onload = function() {
                                        s(u.result);
                                    }, u.onerror = function() {
                                        h(u.error);
                                    }, u.readAsText(t);
                                } else s(t);
                            } else {
                                var c = l.getElementById(t);
                                c ? s(c) : to.request({
                                    url: t,
                                    async: !0,
                                    onLoad: s,
                                    onError: h
                                });
                            }
                            return r;
                        }
                        A.inject({
                            importSVG: function(t, e) {
                                return T(t, e, this);
                            }
                        }), P.inject({
                            importSVG: function(t, e) {
                                return this.activate(), T(t, e, this);
                            }
                        });
                    }, u.exports.PaperScript = (function() {
                        var t, e, c = this, p = c.acorn;
                        if (!p) try {
                            p = i("./node_modules/acorn/dist/acorn.mjs");
                        } catch (t) {}
                        function f(t, e) {
                            return (c.acorn || p).parse(t, e);
                        }
                        !p && (p = t = e = {}, function(i, a) {
                            if ("object" == typeof t && "object" == typeof e) return a(t);
                            n = [
                                t
                            ], (s = "function" == typeof (r = a) ? r.apply(t, n) : r) === o || (e.exports = s);
                        }(0, function(t) {
                            "use strict";
                            t.version = "0.5.0", t.parse = function(t, r) {
                                return n = (i = String(t)).length, C(r), tG(), function(t) {
                                    g = v = s, e.locations && (_ = new tW), m = b = null, y = [], tQ();
                                    var i = t || t8(), n = !0;
                                    for(t || (i.body = []); u !== L;){
                                        var r = eu();
                                        i.body.push(r), n && ee(r) && t9(!0), n = !1;
                                    }
                                    return et(i, "Program");
                                }(e.program);
                            };
                            var e, i, n, r, s, a, o, h, l, u, c, d, p, f, g, v, _, m, y, b, x, w = t.defaultOptions = {
                                ecmaVersion: 5,
                                strictSemicolons: !1,
                                allowTrailingCommas: !0,
                                forbidReserved: !1,
                                allowReturnOutsideFunction: !1,
                                locations: !1,
                                onComment: null,
                                ranges: !1,
                                program: null,
                                sourceFile: null,
                                directSourceFile: null
                            };
                            function C(t) {
                                for(var i in e = t || {}, w)Object.prototype.hasOwnProperty.call(e, i) || (e[i] = w[i]);
                                r = e.sourceFile || null;
                            }
                            var S = t.getLineInfo = function(t, e) {
                                for(var i = 1, n = 0;;){
                                    tH.lastIndex = n;
                                    var r = tH.exec(t);
                                    if (r && r.index < e) ++i, n = r.index + r[0].length;
                                    else break;
                                }
                                return {
                                    line: i,
                                    column: e - n
                                };
                            };
                            function k(t, e) {
                                var n = S(i, t), r = SyntaxError(e += " (" + n.line + ":" + n.column + ")");
                                throw r.pos = t, r.loc = n, r.raisedAt = s, r;
                            }
                            t.tokenize = function(t, r) {
                                n = (i = String(t)).length, C(r), tG();
                                var g = {};
                                function _(t) {
                                    return v = o, tQ(t), g.start = a, g.end = o, g.startLoc = h, g.endLoc = l, g.type = u, g.value = c, g;
                                }
                                return _.jumpTo = function(t, n) {
                                    if (s = t, e.locations) {
                                        var r;
                                        for(p = 1, f = tH.lastIndex = 0; (r = tH.exec(i)) && r.index < t;)++p, f = r.index + r[0].length;
                                    }
                                    d = n, t$();
                                }, _;
                            };
                            var P = [], A = {
                                type: "num"
                            }, I = {
                                type: "regexp"
                            }, T = {
                                type: "string"
                            }, E = {
                                type: "name"
                            }, L = {
                                type: "eof"
                            }, M = {
                                keyword: "break"
                            }, B = {
                                keyword: "case",
                                beforeExpr: !0
                            }, O = {
                                keyword: "catch"
                            }, N = {
                                keyword: "continue"
                            }, z = {
                                keyword: "debugger"
                            }, R = {
                                keyword: "default"
                            }, V = {
                                keyword: "do",
                                isLoop: !0
                            }, F = {
                                keyword: "else",
                                beforeExpr: !0
                            }, D = {
                                keyword: "finally"
                            }, j = {
                                keyword: "for",
                                isLoop: !0
                            }, H = {
                                keyword: "function"
                            }, q = {
                                keyword: "if"
                            }, U = {
                                keyword: "return",
                                beforeExpr: !0
                            }, W = {
                                keyword: "switch"
                            }, G = {
                                keyword: "throw",
                                beforeExpr: !0
                            }, Z = {
                                keyword: "try"
                            }, X = {
                                keyword: "var"
                            }, $ = {
                                keyword: "while",
                                isLoop: !0
                            }, Q = {
                                keyword: "with"
                            }, Y = {
                                keyword: "new",
                                beforeExpr: !0
                            }, J = {
                                keyword: "this"
                            }, K = {
                                keyword: "null",
                                atomValue: null
                            }, tt = {
                                keyword: "true",
                                atomValue: !0
                            }, te = {
                                keyword: "false",
                                atomValue: !1
                            }, ti = {
                                keyword: "in",
                                binop: 7,
                                beforeExpr: !0
                            }, tn = {
                                break: M,
                                case: B,
                                catch: O,
                                continue: N,
                                debugger: z,
                                default: R,
                                do: V,
                                else: F,
                                finally: D,
                                for: j,
                                function: H,
                                if: q,
                                return: U,
                                switch: W,
                                throw: G,
                                try: Z,
                                var: X,
                                while: $,
                                with: Q,
                                null: K,
                                true: tt,
                                false: te,
                                new: Y,
                                in: ti,
                                instanceof: {
                                    keyword: "instanceof",
                                    binop: 7,
                                    beforeExpr: !0
                                },
                                this: J,
                                typeof: {
                                    keyword: "typeof",
                                    prefix: !0,
                                    beforeExpr: !0
                                },
                                void: {
                                    keyword: "void",
                                    prefix: !0,
                                    beforeExpr: !0
                                },
                                delete: {
                                    keyword: "delete",
                                    prefix: !0,
                                    beforeExpr: !0
                                }
                            }, tr = {
                                type: "[",
                                beforeExpr: !0
                            }, ts = {
                                type: "]"
                            }, ta = {
                                type: "{",
                                beforeExpr: !0
                            }, to = {
                                type: "}"
                            }, th = {
                                type: "(",
                                beforeExpr: !0
                            }, tl = {
                                type: ")"
                            }, tu = {
                                type: ",",
                                beforeExpr: !0
                            }, tc = {
                                type: ";",
                                beforeExpr: !0
                            }, td = {
                                type: ":",
                                beforeExpr: !0
                            }, tp = {
                                type: "."
                            }, tf = {
                                type: "?",
                                beforeExpr: !0
                            }, tg = {
                                binop: 10,
                                beforeExpr: !0
                            }, tv = {
                                isAssign: !0,
                                beforeExpr: !0
                            }, t_ = {
                                isAssign: !0,
                                beforeExpr: !0
                            }, tm = {
                                postfix: !0,
                                prefix: !0,
                                isUpdate: !0
                            }, ty = {
                                prefix: !0,
                                beforeExpr: !0
                            }, tb = {
                                binop: 1,
                                beforeExpr: !0
                            }, tx = {
                                binop: 2,
                                beforeExpr: !0
                            }, tw = {
                                binop: 3,
                                beforeExpr: !0
                            }, tC = {
                                binop: 4,
                                beforeExpr: !0
                            }, tS = {
                                binop: 5,
                                beforeExpr: !0
                            }, tk = {
                                binop: 6,
                                beforeExpr: !0
                            }, tP = {
                                binop: 7,
                                beforeExpr: !0
                            }, tA = {
                                binop: 8,
                                beforeExpr: !0
                            }, tI = {
                                binop: 9,
                                prefix: !0,
                                beforeExpr: !0
                            }, tT = {
                                binop: 10,
                                beforeExpr: !0
                            };
                            for(var tE in t.tokTypes = {
                                bracketL: tr,
                                bracketR: ts,
                                braceL: ta,
                                braceR: to,
                                parenL: th,
                                parenR: tl,
                                comma: tu,
                                semi: tc,
                                colon: td,
                                dot: tp,
                                question: tf,
                                slash: tg,
                                eq: tv,
                                name: E,
                                eof: L,
                                num: A,
                                regexp: I,
                                string: T
                            }, tn)t.tokTypes["_" + tE] = tn[tE];
                            function tL(t) {
                                t = t.split(" ");
                                var e = "", i = [];
                                e: for(var n = 0; n < t.length; ++n){
                                    for(var r = 0; r < i.length; ++r)if (i[r][0].length == t[n].length) {
                                        i[r].push(t[n]);
                                        continue e;
                                    }
                                    i.push([
                                        t[n]
                                    ]);
                                }
                                function s(t) {
                                    if (1 == t.length) return e += "return str === " + JSON.stringify(t[0]) + ";";
                                    e += "switch(str){";
                                    for(var i = 0; i < t.length; ++i)e += "case " + JSON.stringify(t[i]) + ":";
                                    e += "return true}return false;";
                                }
                                if (i.length > 3) {
                                    i.sort(function(t, e) {
                                        return e.length - t.length;
                                    }), e += "switch(str.length){";
                                    for(var n = 0; n < i.length; ++n){
                                        var a = i[n];
                                        e += "case " + a[0].length + ":", s(a);
                                    }
                                    e += "}";
                                } else s(t);
                                return Function("str", e);
                            }
                            var tM = tL("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), tB = tL("class enum extends super const export import"), tO = tL("implements interface let package private protected public static yield"), tN = tL("eval arguments"), tz = tL("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), tR = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, tV = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", tF = RegExp("[" + tV + "]"), tD = RegExp("[" + tV + "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u0620-\u0649\u0672-\u06D3\u06E7-\u06E8\u06FB-\u06FC\u0730-\u074A\u0800-\u0814\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0840-\u0857\u08E4-\u08FE\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09D7\u09DF-\u09E0\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5F-\u0B60\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C01-\u0C03\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62-\u0C63\u0C66-\u0C6F\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2-\u0CE3\u0CE6-\u0CEF\u0D02\u0D03\u0D46-\u0D48\u0D57\u0D62-\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E34-\u0E3A\u0E40-\u0E45\u0E50-\u0E59\u0EB4-\u0EB9\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F41-\u0F47\u0F71-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1029\u1040-\u1049\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u170E-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17B2\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1920-\u192B\u1930-\u193B\u1951-\u196D\u19B0-\u19C0\u19C8-\u19C9\u19D0-\u19D9\u1A00-\u1A15\u1A20-\u1A53\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1B46-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C00-\u1C22\u1C40-\u1C49\u1C5B-\u1C7D\u1CD0-\u1CD2\u1D00-\u1DBE\u1E01-\u1F15\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2D81-\u2D96\u2DE0-\u2DFF\u3021-\u3028\u3099\u309A\uA640-\uA66D\uA674-\uA67D\uA69F\uA6F0-\uA6F1\uA7F8-\uA800\uA806\uA80B\uA823-\uA827\uA880-\uA881\uA8B4-\uA8C4\uA8D0-\uA8D9\uA8F3-\uA8F7\uA900-\uA909\uA926-\uA92D\uA930-\uA945\uA980-\uA983\uA9B3-\uA9C0\uAA00-\uAA27\uAA40-\uAA41\uAA4C-\uAA4D\uAA50-\uAA59\uAA7B\uAAE0-\uAAE9\uAAF2-\uAAF3\uABC0-\uABE1\uABEC\uABED\uABF0-\uABF9\uFB20-\uFB28\uFE00-\uFE0F\uFE20-\uFE26\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F]"), tj = /[\n\r\u2028\u2029]/, tH = /\r\n|[\n\r\u2028\u2029]/g, tq = t.isIdentifierStart = function(t) {
                                return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && tF.test(String.fromCharCode(t)));
                            }, tU = t.isIdentifierChar = function(t) {
                                return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && tD.test(String.fromCharCode(t))));
                            };
                            function tW() {
                                this.line = p, this.column = s - f;
                            }
                            function tG() {
                                p = 1, s = f = 0, d = !0, t$();
                            }
                            function tZ(t, i) {
                                o = s, e.locations && (l = new tW), u = t, t$(), c = i, d = t.beforeExpr;
                            }
                            function tX() {
                                for(var t = s, r = e.onComment && e.locations && new tW, a = i.charCodeAt(s += 2); s < n && 10 !== a && 13 !== a && 8232 !== a && 8233 !== a;)++s, a = i.charCodeAt(s);
                                e.onComment && e.onComment(!1, i.slice(t + 2, s), t, s, r, e.locations && new tW);
                            }
                            function t$() {
                                for(; s < n;){
                                    var t = i.charCodeAt(s);
                                    if (32 === t) ++s;
                                    else if (13 === t) {
                                        ++s;
                                        var r = i.charCodeAt(s);
                                        10 === r && ++s, e.locations && (++p, f = s);
                                    } else if (10 === t || 8232 === t || 8233 === t) ++s, e.locations && (++p, f = s);
                                    else if (t > 8 && t < 14) ++s;
                                    else if (47 === t) {
                                        var r = i.charCodeAt(s + 1);
                                        if (42 === r) !function() {
                                            var t, n = e.onComment && e.locations && new tW, r = s, a = i.indexOf("*/", s += 2);
                                            if (-1 === a && k(s - 2, "Unterminated comment"), s = a + 2, e.locations) for(tH.lastIndex = r; (t = tH.exec(i)) && t.index < s;)++p, f = t.index + t[0].length;
                                            e.onComment && e.onComment(!0, i.slice(r + 2, a), r, s, n, e.locations && new tW);
                                        }();
                                        else if (47 === r) tX();
                                        else break;
                                    } else if (160 === t) ++s;
                                    else if (t >= 5760 && tR.test(String.fromCharCode(t))) ++s;
                                    else break;
                                }
                            }
                            function tQ(t) {
                                if (t ? s = a + 1 : a = s, e.locations && (h = new tW), t) return tJ();
                                if (s >= n) return tZ(L);
                                var r = i.charCodeAt(s);
                                if (tq(r) || 92 === r) return t5();
                                var o = function(t) {
                                    switch(t){
                                        case 46:
                                            return (o = i.charCodeAt(s + 1)) >= 48 && o <= 57 ? t0(!0) : (++s, tZ(tp));
                                        case 40:
                                            return ++s, tZ(th);
                                        case 41:
                                            return ++s, tZ(tl);
                                        case 59:
                                            return ++s, tZ(tc);
                                        case 44:
                                            return ++s, tZ(tu);
                                        case 91:
                                            return ++s, tZ(tr);
                                        case 93:
                                            return ++s, tZ(ts);
                                        case 123:
                                            return ++s, tZ(ta);
                                        case 125:
                                            return ++s, tZ(to);
                                        case 58:
                                            return ++s, tZ(td);
                                        case 63:
                                            return ++s, tZ(tf);
                                        case 48:
                                            var r, o, h, l, u = i.charCodeAt(s + 1);
                                            if (120 === u || 88 === u) return s += 2, null == (r = tK(16)) && k(a + 2, "Expected hexadecimal number"), tq(i.charCodeAt(s)) && k(s, "Identifier directly after number"), tZ(A, r);
                                        case 49:
                                        case 50:
                                        case 51:
                                        case 52:
                                        case 53:
                                        case 54:
                                        case 55:
                                        case 56:
                                        case 57:
                                            return t0(!1);
                                        case 34:
                                        case 39:
                                            var c = t;
                                            s++;
                                            for(var g = "";;){
                                                s >= n && k(a, "Unterminated string constant");
                                                var _ = i.charCodeAt(s);
                                                if (_ === c) return ++s, tZ(T, g);
                                                if (92 === _) {
                                                    _ = i.charCodeAt(++s);
                                                    var m = /^[0-7]+/.exec(i.slice(s, s + 3));
                                                    for(m && (m = m[0]); m && parseInt(m, 8) > 255;)m = m.slice(0, -1);
                                                    if ("0" === m && (m = null), ++s, m) b && k(s - 2, "Octal literal in strict mode"), g += String.fromCharCode(parseInt(m, 8)), s += m.length - 1;
                                                    else switch(_){
                                                        case 110:
                                                            g += "\n";
                                                            break;
                                                        case 114:
                                                            g += "\r";
                                                            break;
                                                        case 120:
                                                            g += String.fromCharCode(t1(2));
                                                            break;
                                                        case 117:
                                                            g += String.fromCharCode(t1(4));
                                                            break;
                                                        case 85:
                                                            g += String.fromCharCode(t1(8));
                                                            break;
                                                        case 116:
                                                            g += "	";
                                                            break;
                                                        case 98:
                                                            g += "\b";
                                                            break;
                                                        case 118:
                                                            g += "\v";
                                                            break;
                                                        case 102:
                                                            g += "\f";
                                                            break;
                                                        case 48:
                                                            g += "\0";
                                                            break;
                                                        case 13:
                                                            10 === i.charCodeAt(s) && ++s;
                                                        case 10:
                                                            e.locations && (f = s, ++p);
                                                            break;
                                                        default:
                                                            g += String.fromCharCode(_);
                                                    }
                                                } else (13 === _ || 10 === _ || 8232 === _ || 8233 === _) && k(a, "Unterminated string constant"), g += String.fromCharCode(_), ++s;
                                            }
                                            return;
                                        case 47:
                                            return h = i.charCodeAt(s + 1), d ? (++s, tJ()) : 61 === h ? tY(t_, 2) : tY(tg, 1);
                                        case 37:
                                        case 42:
                                            return 61 === i.charCodeAt(s + 1) ? tY(t_, 2) : tY(tT, 1);
                                        case 124:
                                        case 38:
                                            return (l = i.charCodeAt(s + 1)) === t ? tY(124 === t ? tb : tx, 2) : 61 === l ? tY(t_, 2) : tY(124 === t ? tw : tS, 1);
                                        case 94:
                                            return 61 === i.charCodeAt(s + 1) ? tY(t_, 2) : tY(tC, 1);
                                        case 43:
                                        case 45:
                                            var y = i.charCodeAt(s + 1);
                                            if (y === t) return 45 == y && 62 == i.charCodeAt(s + 2) && tj.test(i.slice(v, s)) ? (s += 3, tX(), t$(), tQ()) : tY(tm, 2);
                                            return 61 === y ? tY(t_, 2) : tY(tI, 1);
                                        case 60:
                                        case 62:
                                            var x = i.charCodeAt(s + 1), w = 1;
                                            if (x === t) return (w = 62 === t && 62 === i.charCodeAt(s + 2) ? 3 : 2, 61 === i.charCodeAt(s + w)) ? tY(t_, w + 1) : tY(tA, w);
                                            return 33 == x && 60 == t && 45 == i.charCodeAt(s + 2) && 45 == i.charCodeAt(s + 3) ? (s += 4, tX(), t$(), tQ()) : (61 === x && (w = 61 === i.charCodeAt(s + 2) ? 3 : 2), tY(tP, w));
                                        case 61:
                                        case 33:
                                            return 61 === i.charCodeAt(s + 1) ? tY(tk, 61 === i.charCodeAt(s + 2) ? 3 : 2) : tY(61 === t ? tv : ty, 1);
                                        case 126:
                                            return tY(ty, 1);
                                    }
                                    return !1;
                                }(r);
                                if (!1 === o) {
                                    var l = String.fromCharCode(r);
                                    if ("\\" === l || tF.test(l)) return t5();
                                    k(s, "Unexpected character '" + l + "'");
                                }
                                return o;
                            }
                            function tY(t, e) {
                                var n = i.slice(s, s + e);
                                s += e, tZ(t, n);
                            }
                            function tJ() {
                                for(var t, e, r = "", a = s;;){
                                    s >= n && k(a, "Unterminated regular expression");
                                    var o = i.charAt(s);
                                    if (tj.test(o) && k(a, "Unterminated regular expression"), t) t = !1;
                                    else {
                                        if ("[" === o) e = !0;
                                        else if ("]" === o && e) e = !1;
                                        else if ("/" === o && !e) break;
                                        t = "\\" === o;
                                    }
                                    ++s;
                                }
                                var r = i.slice(a, s);
                                ++s;
                                var h = t2();
                                h && !/^[gmsiy]*$/.test(h) && k(a, "Invalid regexp flag");
                                try {
                                    var l = new RegExp(r, h);
                                } catch (t) {
                                    t instanceof SyntaxError && k(a, t.message), k(t);
                                }
                                return tZ(I, l);
                            }
                            function tK(t, e) {
                                for(var n = s, r = 0, a = 0, o = null == e ? 1 / 0 : e; a < o; ++a){
                                    var h, l = i.charCodeAt(s);
                                    if ((h = l >= 97 ? l - 97 + 10 : l >= 65 ? l - 65 + 10 : l >= 48 && l <= 57 ? l - 48 : 1 / 0) >= t) break;
                                    ++s, r = r * t + h;
                                }
                                return s === n || null != e && s - n !== e ? null : r;
                            }
                            function t0(t) {
                                var e = s, n = !1, r = 48 === i.charCodeAt(s);
                                t || null !== tK(10) || k(e, "Invalid number"), 46 === i.charCodeAt(s) && (++s, tK(10), n = !0);
                                var a = i.charCodeAt(s);
                                (69 === a || 101 === a) && ((43 === (a = i.charCodeAt(++s)) || 45 === a) && ++s, null === tK(10) && k(e, "Invalid number"), n = !0), tq(i.charCodeAt(s)) && k(s, "Identifier directly after number");
                                var o, h = i.slice(e, s);
                                return n ? o = parseFloat(h) : r && 1 !== h.length ? /[89]/.test(h) || b ? k(e, "Invalid number") : o = parseInt(h, 8) : o = parseInt(h, 10), tZ(A, o);
                            }
                            function t1(t) {
                                var e = tK(16, t);
                                return null === e && k(a, "Bad character escape sequence"), e;
                            }
                            function t2() {
                                x = !1;
                                for(var t, e = !0, n = s;;){
                                    var r = i.charCodeAt(s);
                                    if (tU(r)) x && (t += i.charAt(s)), ++s;
                                    else if (92 === r) {
                                        x || (t = i.slice(n, s)), x = !0, 117 != i.charCodeAt(++s) && k(s, "Expecting Unicode escape sequence \\uXXXX"), ++s;
                                        var a = t1(4), o = String.fromCharCode(a);
                                        o || k(s - 1, "Invalid Unicode escape"), (e ? tq(a) : tU(a)) || k(s - 4, "Invalid Unicode escape"), t += o;
                                    } else break;
                                    e = !1;
                                }
                                return x ? t : i.slice(n, s);
                            }
                            function t5() {
                                var t = t2(), e = E;
                                return !x && tz(t) && (e = tn[t]), tZ(e, t);
                            }
                            function t3() {
                                g = a, v = o, _ = l, tQ();
                            }
                            function t9(t) {
                                if (b = t, s = a, e.locations) for(; s < f;)f = i.lastIndexOf("\n", f - 2) + 1, --p;
                                t$(), tQ();
                            }
                            function t6() {
                                this.type = null, this.start = a, this.end = null;
                            }
                            function t4() {
                                this.start = h, this.end = null, null !== r && (this.source = r);
                            }
                            function t8() {
                                var t = new t6;
                                return e.locations && (t.loc = new t4), e.directSourceFile && (t.sourceFile = e.directSourceFile), e.ranges && (t.range = [
                                    a,
                                    0
                                ]), t;
                            }
                            function t7(t) {
                                var i = new t6;
                                return i.start = t.start, e.locations && (i.loc = new t4, i.loc.start = t.loc.start), e.ranges && (i.range = [
                                    t.range[0],
                                    0
                                ]), i;
                            }
                            function et(t, i) {
                                return t.type = i, t.end = v, e.locations && (t.loc.end = _), e.ranges && (t.range[1] = v), t;
                            }
                            function ee(t) {
                                return e.ecmaVersion >= 5 && "ExpressionStatement" === t.type && "Literal" === t.expression.type && "use strict" === t.expression.value;
                            }
                            function ei(t) {
                                if (u === t) return t3(), !0;
                            }
                            function en() {
                                return !e.strictSemicolons && (u === L || u === to || tj.test(i.slice(v, a)));
                            }
                            function er() {
                                ei(tc) || en() || ea();
                            }
                            function es(t) {
                                u === t ? t3() : ea();
                            }
                            function ea() {
                                k(a, "Unexpected token");
                            }
                            function eo(t) {
                                "Identifier" !== t.type && "MemberExpression" !== t.type && k(t.start, "Assigning to rvalue"), b && "Identifier" === t.type && tN(t.name) && k(t.start, "Assigning to " + t.name + " in strict mode");
                            }
                            var eh = {
                                kind: "loop"
                            }, el = {
                                kind: "switch"
                            };
                            function eu() {
                                (u === tg || u === t_ && "/=" == c) && tQ(!0);
                                var t, n, r = u, s = t8();
                                switch(r){
                                    case M:
                                    case N:
                                        t3();
                                        var o = r === M;
                                        ei(tc) || en() ? s.label = null : u !== E ? ea() : (s.label = eS(), er());
                                        for(var h = 0; h < y.length; ++h){
                                            var l = y[h];
                                            if ((null == s.label || l.name === s.label.name) && (null != l.kind && (o || "loop" === l.kind) || s.label && o)) break;
                                        }
                                        return h === y.length && k(s.start, "Unsyntactic " + r.keyword), et(s, o ? "BreakStatement" : "ContinueStatement");
                                    case z:
                                        return t3(), er(), et(s, "DebuggerStatement");
                                    case V:
                                        return t3(), y.push(eh), s.body = eu(), y.pop(), es($), s.test = ec(), er(), et(s, "DoWhileStatement");
                                    case j:
                                        if (t3(), y.push(eh), es(th), u === tc) return ep(s, null);
                                        if (u === X) {
                                            var d = t8();
                                            if (t3(), eg(d, !0), et(d, "VariableDeclaration"), 1 === d.declarations.length && ei(ti)) return ef(s, d);
                                            return ep(s, d);
                                        }
                                        var d = ev(!1, !0);
                                        if (ei(ti)) return eo(d), ef(s, d);
                                        return ep(s, d);
                                    case H:
                                        return t3(), ew(s, !0);
                                    case q:
                                        return t3(), s.test = ec(), s.consequent = eu(), s.alternate = ei(F) ? eu() : null, et(s, "IfStatement");
                                    case U:
                                        return m || e.allowReturnOutsideFunction || k(a, "'return' outside of function"), t3(), ei(tc) || en() ? s.argument = null : (s.argument = ev(), er()), et(s, "ReturnStatement");
                                    case W:
                                        for(t3(), s.discriminant = ec(), s.cases = [], es(ta), y.push(el); u != to;)if (u === B || u === R) {
                                            var p = u === B;
                                            t && et(t, "SwitchCase"), s.cases.push(t = t8()), t.consequent = [], t3(), p ? t.test = ev() : (n && k(g, "Multiple default clauses"), n = !0, t.test = null), es(td);
                                        } else t || ea(), t.consequent.push(eu());
                                        return t && et(t, "SwitchCase"), t3(), y.pop(), et(s, "SwitchStatement");
                                    case G:
                                        return t3(), tj.test(i.slice(v, a)) && k(v, "Illegal newline after throw"), s.argument = ev(), er(), et(s, "ThrowStatement");
                                    case Z:
                                        if (t3(), s.block = ed(), s.handler = null, u === O) {
                                            var f = t8();
                                            t3(), es(th), f.param = eS(), b && tN(f.param.name) && k(f.param.start, "Binding " + f.param.name + " in strict mode"), es(tl), f.guard = null, f.body = ed(), s.handler = et(f, "CatchClause");
                                        }
                                        return s.guardedHandlers = P, s.finalizer = ei(D) ? ed() : null, s.handler || s.finalizer || k(s.start, "Missing catch or finally clause"), et(s, "TryStatement");
                                    case X:
                                        return t3(), eg(s), er(), et(s, "VariableDeclaration");
                                    case $:
                                        return t3(), s.test = ec(), y.push(eh), s.body = eu(), y.pop(), et(s, "WhileStatement");
                                    case Q:
                                        return b && k(a, "'with' in strict mode"), t3(), s.object = ec(), s.body = eu(), et(s, "WithStatement");
                                    case ta:
                                        return ed();
                                    case tc:
                                        return t3(), et(s, "EmptyStatement");
                                    default:
                                        var _ = c, x = ev();
                                        if (!(r === E && "Identifier" === x.type && ei(td))) return s.expression = x, er(), et(s, "ExpressionStatement");
                                        for(var h = 0; h < y.length; ++h)y[h].name === _ && k(x.start, "Label '" + _ + "' is already declared");
                                        var w = u.isLoop ? "loop" : u === W ? "switch" : null;
                                        return y.push({
                                            name: _,
                                            kind: w
                                        }), s.body = eu(), y.pop(), s.label = x, et(s, "LabeledStatement");
                                }
                            }
                            function ec() {
                                es(th);
                                var t = ev();
                                return es(tl), t;
                            }
                            function ed(t) {
                                var e, i = t8(), n = !0, r = !1;
                                for(i.body = [], es(ta); !ei(to);){
                                    var s = eu();
                                    i.body.push(s), n && t && ee(s) && (e = r, t9(r = !0)), n = !1;
                                }
                                return r && !e && t9(!1), et(i, "BlockStatement");
                            }
                            function ep(t, e) {
                                return t.init = e, es(tc), t.test = u === tc ? null : ev(), es(tc), t.update = u === tl ? null : ev(), es(tl), t.body = eu(), y.pop(), et(t, "ForStatement");
                            }
                            function ef(t, e) {
                                return t.left = e, t.right = ev(), es(tl), t.body = eu(), y.pop(), et(t, "ForInStatement");
                            }
                            function eg(t, e) {
                                for(t.declarations = [], t.kind = "var";;){
                                    var i = t8();
                                    if (i.id = eS(), b && tN(i.id.name) && k(i.id.start, "Binding " + i.id.name + " in strict mode"), i.init = ei(tv) ? ev(!0, e) : null, t.declarations.push(et(i, "VariableDeclarator")), !ei(tu)) break;
                                }
                                return t;
                            }
                            function ev(t, e) {
                                var i = e_(e);
                                if (!t && u === tu) {
                                    var n = t7(i);
                                    for(n.expressions = [
                                        i
                                    ]; ei(tu);)n.expressions.push(e_(e));
                                    return et(n, "SequenceExpression");
                                }
                                return i;
                            }
                            function e_(t) {
                                var e = function(t) {
                                    var e, i = (e = t, function t(e, i, n) {
                                        var r = u.binop;
                                        if (null != r && (!n || u !== ti) && r > i) {
                                            var s = t7(e);
                                            s.left = e, s.operator = c;
                                            var a = u;
                                            return t3(), s.right = t(em(), r, n), t(et(s, a === tb || a === tx ? "LogicalExpression" : "BinaryExpression"), i, n);
                                        }
                                        return e;
                                    }(em(), -1, e));
                                    if (ei(tf)) {
                                        var n = t7(i);
                                        return n.test = i, n.consequent = ev(!0), es(td), n.alternate = ev(!0, t), et(n, "ConditionalExpression");
                                    }
                                    return i;
                                }(t);
                                if (u.isAssign) {
                                    var i = t7(e);
                                    return i.operator = c, i.left = e, t3(), i.right = e_(t), eo(e), et(i, "AssignmentExpression");
                                }
                                return e;
                            }
                            function em() {
                                if (u.prefix) {
                                    var t = t8(), e = u.isUpdate;
                                    return t.operator = c, t.prefix = !0, d = !0, t3(), t.argument = em(), e ? eo(t.argument) : b && "delete" === t.operator && "Identifier" === t.argument.type && k(t.start, "Deleting local variable in strict mode"), et(t, e ? "UpdateExpression" : "UnaryExpression");
                                }
                                for(var i = ey(eb()); u.postfix && !en();){
                                    var t = t7(i);
                                    t.operator = c, t.prefix = !1, t.argument = i, eo(i), t3(), i = et(t, "UpdateExpression");
                                }
                                return i;
                            }
                            function ey(t, e) {
                                if (ei(tp)) {
                                    var i = t7(t);
                                    return i.object = t, i.property = eS(!0), i.computed = !1, ey(et(i, "MemberExpression"), e);
                                }
                                if (ei(tr)) {
                                    var i = t7(t);
                                    return i.object = t, i.property = ev(), i.computed = !0, es(ts), ey(et(i, "MemberExpression"), e);
                                }
                                if (!(!e && ei(th))) return t;
                                var i = t7(t);
                                return i.callee = t, i.arguments = eC(tl, !1), ey(et(i, "CallExpression"), e);
                            }
                            function eb() {
                                switch(u){
                                    case J:
                                        var t, n = t8();
                                        return t3(), et(n, "ThisExpression");
                                    case E:
                                        return eS();
                                    case A:
                                    case T:
                                    case I:
                                        var n = t8();
                                        return n.value = c, n.raw = i.slice(a, o), t3(), et(n, "Literal");
                                    case K:
                                    case tt:
                                    case te:
                                        var n = t8();
                                        return n.value = u.atomValue, n.raw = u.keyword, t3(), et(n, "Literal");
                                    case th:
                                        var r = h, s = a;
                                        t3();
                                        var d = ev();
                                        return d.start = s, d.end = o, e.locations && (d.loc.start = r, d.loc.end = l), e.ranges && (d.range = [
                                            s,
                                            o
                                        ]), es(tl), d;
                                    case tr:
                                        var n = t8();
                                        return t3(), n.elements = eC(ts, !0, !0), et(n, "ArrayExpression");
                                    case ta:
                                        return function() {
                                            var t = t8(), i = !0, n = !1;
                                            for(t.properties = [], t3(); !ei(to);){
                                                if (i) i = !1;
                                                else if (es(tu), e.allowTrailingCommas && ei(to)) break;
                                                var r, s = {
                                                    key: ex()
                                                }, a = !1;
                                                if (ei(td) ? (s.value = ev(!0), r = s.kind = "init") : e.ecmaVersion >= 5 && "Identifier" === s.key.type && ("get" === s.key.name || "set" === s.key.name) ? (a = n = !0, r = s.kind = s.key.name, s.key = ex(), u !== th && ea(), s.value = ew(t8(), !1)) : ea(), "Identifier" === s.key.type && (b || n)) for(var o = 0; o < t.properties.length; ++o){
                                                    var h = t.properties[o];
                                                    if (h.key.name === s.key.name) {
                                                        var l = r == h.kind || a && "init" === h.kind || "init" === r && ("get" === h.kind || "set" === h.kind);
                                                        l && !b && "init" === r && "init" === h.kind && (l = !1), l && k(s.key.start, "Redefinition of property");
                                                    }
                                                }
                                                t.properties.push(s);
                                            }
                                            return et(t, "ObjectExpression");
                                        }();
                                    case H:
                                        var n = t8();
                                        return t3(), ew(n, !1);
                                    case Y:
                                        return t = t8(), t3(), t.callee = ey(eb(), !0), ei(th) ? t.arguments = eC(tl, !1) : t.arguments = P, et(t, "NewExpression");
                                    default:
                                        ea();
                                }
                            }
                            function ex() {
                                return u === A || u === T ? eb() : eS(!0);
                            }
                            function ew(t, e) {
                                u === E ? t.id = eS() : e ? ea() : t.id = null, t.params = [];
                                var i = !0;
                                for(es(th); !ei(tl);)i ? i = !1 : es(tu), t.params.push(eS());
                                var n = m, r = y;
                                if (m = !0, y = [], t.body = ed(!0), m = n, y = r, b || t.body.body.length && ee(t.body.body[0])) for(var s = t.id ? -1 : 0; s < t.params.length; ++s){
                                    var a = s < 0 ? t.id : t.params[s];
                                    if ((tO(a.name) || tN(a.name)) && k(a.start, "Defining '" + a.name + "' in strict mode"), s >= 0) for(var o = 0; o < s; ++o)a.name === t.params[o].name && k(a.start, "Argument name clash in strict mode");
                                }
                                return et(t, e ? "FunctionDeclaration" : "FunctionExpression");
                            }
                            function eC(t, i, n) {
                                for(var r = [], s = !0; !ei(t);){
                                    if (s) s = !1;
                                    else if (es(tu), i && e.allowTrailingCommas && ei(t)) break;
                                    n && u === tu ? r.push(null) : r.push(ev(!0));
                                }
                                return r;
                            }
                            function eS(t) {
                                var n = t8();
                                return t && "everywhere" == e.forbidReserved && (t = !1), u === E ? (!t && (e.forbidReserved && (3 === e.ecmaVersion ? tM : tB)(c) || b && tO(c)) && -1 == i.slice(a, o).indexOf("\\") && k(a, "The keyword '" + c + "' is reserved"), n.name = c) : t && u.keyword ? n.name = u.keyword : ea(), d = !1, t3(), et(n, "Identifier");
                            }
                        }), p.version || (p = null));
                        var g = {
                            "+": "__add",
                            "-": "__subtract",
                            "*": "__multiply",
                            "/": "__divide",
                            "%": "__modulo",
                            "==": "__equals",
                            "!=": "__equals"
                        }, v = {
                            "-": "__negate",
                            "+": "__self"
                        }, _ = u.each([
                            "add",
                            "subtract",
                            "multiply",
                            "divide",
                            "modulo",
                            "equals",
                            "negate"
                        ], function(t) {
                            this["__" + t] = "#" + t;
                        }, {
                            __self: function() {
                                return this;
                            }
                        });
                        function y(t, e, i) {
                            var n = g[e];
                            if (t && t[n]) {
                                var r = t[n](i);
                                return "!=" === e ? !r : r;
                            }
                            switch(e){
                                case "+":
                                    return t + i;
                                case "-":
                                    return t - i;
                                case "*":
                                    return t * i;
                                case "/":
                                    return t / i;
                                case "%":
                                    return t % i;
                                case "==":
                                    return t == i;
                                case "!=":
                                    return t != i;
                            }
                        }
                        function x(t, e) {
                            var i = v[t];
                            if (e && e[i]) return e[i]();
                            switch(t){
                                case "+":
                                    return +e;
                                case "-":
                                    return -e;
                            }
                        }
                        function w(t, e) {
                            if (!t) return "";
                            var i = [];
                            function n(t) {
                                for(var e = 0, n = i.length; e < n; e++){
                                    var r = i[e];
                                    if (r[0] >= t) break;
                                    t += r[1];
                                }
                                return t;
                            }
                            function r(e) {
                                return t.substring(n(e.range[0]), n(e.range[1]));
                            }
                            function s(e, r) {
                                for(var s = n(e.range[0]), a = n(e.range[1]), o = 0, h = i.length - 1; h >= 0; h--)if (s > i[h][0]) {
                                    o = h + 1;
                                    break;
                                }
                                i.splice(o, 0, [
                                    s,
                                    r.length - a + s
                                ]), t = t.substring(0, s) + r + t.substring(a);
                            }
                            var o, u = (e = e || {}).url || "", c = e.sourceMaps, d = e.paperFeatures || {}, p = e.source || t, _ = e.offset || 0, m = td.agent, y = m.versionNumber, b = !1, x = /\r\n|\n|\r/mg;
                            if (c && (m.chrome && y >= 30 || m.webkit && y >= 537.76 || m.firefox && y >= 23 || m.node)) {
                                if (m.node) _ -= 2;
                                else if (h && u && !h.location.href.indexOf(u)) {
                                    var w = l.getElementsByTagName("html")[0].innerHTML;
                                    _ = w.substr(0, w.indexOf(t) + 1).match(x).length + 1;
                                }
                                var C = [
                                    "AA" + function(t) {
                                        var e = "";
                                        for(t = (Math.abs(t) << 1) + +(t < 0); t || !e;){
                                            var i = 31 & t;
                                            (t >>= 5) && (i |= 32), e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[i];
                                        }
                                        return e;
                                    }((b = _ > 0 && !(m.chrome && y >= 36 || m.safari && y >= 600 || m.firefox && y >= 40 || m.node)) ? 0 : _) + "A"
                                ];
                                C.length = (t.match(x) || []).length + 1 + (b ? _ : 0), o = {
                                    version: 3,
                                    file: u,
                                    names: [],
                                    mappings: C.join(";AACA"),
                                    sourceRoot: "",
                                    sources: [
                                        u
                                    ],
                                    sourcesContent: [
                                        p
                                    ]
                                };
                            }
                            return (!1 !== d.operatorOverloading || !1 !== d.moduleExports) && function e(i, a, o) {
                                if (i) {
                                    for(var h in i)if ("range" !== h && "loc" !== h) {
                                        var l = i[h];
                                        if (Array.isArray(l)) for(var u = 0, c = l.length; u < c; u++)e(l[u], i, o);
                                        else l && "object" == typeof l && e(l, i, o);
                                    }
                                    !1 !== o.operatorOverloading && function(e, i) {
                                        switch(e.type){
                                            case "UnaryExpression":
                                                if (e.operator in v && "Literal" !== e.argument.type) {
                                                    var a = r(e.argument);
                                                    s(e, '$__("' + e.operator + '", ' + a + ")");
                                                }
                                                break;
                                            case "BinaryExpression":
                                                if (e.operator in g && "Literal" !== e.left.type) {
                                                    var o, h, l = r(e.left), u = r(e.right), c = (o = e.left, h = e.right, t.substring(n(o.range[1]), n(h.range[0]))), d = e.operator;
                                                    s(e, "__$__(" + l + "," + c.replace(RegExp("\\" + d), '"' + d + '"') + ", " + u + ")");
                                                }
                                                break;
                                            case "UpdateExpression":
                                            case "AssignmentExpression":
                                                var p = i && i.type;
                                                if (!("ForStatement" === p || "BinaryExpression" === p && /^[=!<>]/.test(i.operator) || "MemberExpression" === p && i.computed)) {
                                                    if ("UpdateExpression" === e.type) {
                                                        var a = r(e.argument), f = "__$__(" + a + ', "' + e.operator[0] + '", 1)', _ = a + " = " + f;
                                                        e.prefix ? _ = "(" + _ + ")" : ("AssignmentExpression" === p || "VariableDeclarator" === p || "BinaryExpression" === p) && (r(i.left || i.id) === a && (_ = f), _ = a + "; " + _), s(e, _);
                                                    } else if (/^.=$/.test(e.operator) && "Literal" !== e.left.type) {
                                                        var l = r(e.left), u = r(e.right), f = l + " = __$__(" + l + ', "' + e.operator[0] + '", ' + u + ")";
                                                        s(e, /^\(.*\)$/.test(r(e)) ? "(" + f + ")" : f);
                                                    }
                                                }
                                        }
                                    }(i, a), !1 !== o.moduleExports && function(t) {
                                        switch(t.type){
                                            case "ExportDefaultDeclaration":
                                                s({
                                                    range: [
                                                        t.start,
                                                        t.declaration.start
                                                    ]
                                                }, "module.exports = ");
                                                break;
                                            case "ExportNamedDeclaration":
                                                var e = t.declaration, i = t.specifiers;
                                                if (e) {
                                                    var n = e.declarations;
                                                    n && (n.forEach(function(t) {
                                                        s(t, "module.exports." + r(t));
                                                    }), s({
                                                        range: [
                                                            t.start,
                                                            e.start + e.kind.length
                                                        ]
                                                    }, ""));
                                                } else if (i) {
                                                    var a = i.map(function(t) {
                                                        var e = r(t);
                                                        return "module.exports." + e + " = " + e + "; ";
                                                    }).join("");
                                                    a && s(t, a);
                                                }
                                        }
                                    }(i);
                                }
                            }(f(t, {
                                ranges: !0,
                                preserveParens: !0,
                                sourceType: "module"
                            }), null, d), o && (b && (t = Array(_ + 1).join("\n") + t), /^(inline|both)$/.test(c) && (t += "\n//# sourceMappingURL=data:application/json;base64," + a.btoa(unescape(encodeURIComponent(JSON.stringify(o))))), t += "\n//# sourceURL=" + (u || "paperscript")), {
                                url: u,
                                source: p,
                                code: t,
                                map: o
                            };
                        }
                        function C(t, e, i) {
                            td = e;
                            var n, r = e.getView(), s = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(t) && !/\bnew\s+Tool\b/.test(t) ? new ts : null, a = s ? s._events : [], o = [
                                "onFrame",
                                "onResize"
                            ].concat(a), h = [], c = [];
                            function d(e, i) {
                                for(var n in e)(i || !/^_/.test(n)) && RegExp("([\\b\\s\\W]|^)" + n.replace(/\$/g, "\\$") + "\\b").test(t) && (h.push(n), c.push(e[n]));
                            }
                            t = ("object" == typeof t ? t : w(t, i)).code, d({
                                __$__: y,
                                $__: x,
                                paper: e,
                                tool: s
                            }, !0), d(e), t = "var module = { exports: {} }; " + t;
                            var p = u.each(o, function(e) {
                                RegExp("\\s+" + e + "\\b").test(t) && (h.push(e), this.push("module.exports." + e + " = " + e + ";"));
                            }, []).join("\n");
                            p && (t += "\n" + p), t += "\nreturn module.exports;";
                            var f = td.agent;
                            if (l && (f.chrome || f.firefox && f.versionNumber < 40)) {
                                var g = l.createElement("script"), v = l.head || l.getElementsByTagName("head")[0];
                                f.firefox && (t = "\n" + t), g.appendChild(l.createTextNode("document.__paperscript__ = function(" + h + ") {" + t + "\n}")), v.appendChild(g), n = l.__paperscript__, delete l.__paperscript__, v.removeChild(g);
                            } else n = Function(h, t);
                            var p = n && n.apply(e, c), _ = p || {};
                            return u.each(a, function(t) {
                                var e = _[t];
                                e && (s[t] = e);
                            }), r && (_.onResize && r.setOnResize(_.onResize), r.emit("resize", {
                                size: r.size,
                                delta: new m
                            }), _.onFrame && r.setOnFrame(_.onFrame), r.requestUpdate()), p;
                        }
                        function S(t) {
                            if (/^text\/(?:x-|)paperscript$/.test(t.type) && "true" !== d.getAttribute(t, "ignore")) {
                                var e = d.getAttribute(t, "canvas"), i = l.getElementById(e), n = t.src || t.getAttribute("data-src"), r = d.hasAttribute(t, "async"), s = "data-paper-scope";
                                if (!i) throw Error('Unable to find canvas with id "' + e + '"');
                                var a = d.get(i.getAttribute(s)) || new d().setup(i);
                                return i.setAttribute(s, a._id), n ? to.request({
                                    url: n,
                                    async: r,
                                    mimeType: "text/plain",
                                    onLoad: function(t) {
                                        C(t, a, n);
                                    }
                                }) : C(t.innerHTML, a, t.baseURI), t.setAttribute("data-paper-ignore", "true"), a;
                            }
                        }
                        function k() {
                            u.each(l && l.getElementsByTagName("script"), S);
                        }
                        return m.inject(_), b.inject(_), G.inject(_), h && ("complete" === l.readyState ? setTimeout(k) : Y.add(h, {
                            load: k
                        })), {
                            compile: w,
                            execute: C,
                            load: function(t) {
                                return t ? S(t) : k();
                            },
                            parse: f,
                            calculateBinary: y,
                            calculateUnary: x
                        };
                    }).call(this);
                    var td = new (d.inject(u.exports, {
                        Base: u,
                        Numerical: v,
                        Key: ti,
                        DomEvent: Y,
                        DomElement: Q,
                        document: l,
                        window: h,
                        Symbol: B,
                        PlacedSymbol: M
                    }));
                    return td.agent.node && i(1)(td), (s = "function" == typeof (r = td) ? r.call(e, i, e, t) : r) !== o && (t.exports = s), td;
                }).call(this, "object" == typeof self ? self : null);
            },
            "./src/arcTail.ts": function(t, e, i) {
                "use strict";
                var n, r = this && this.__extends || (n = function(t, e) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, e) {
                        t.__proto__ = e;
                    } || function(t, e) {
                        for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                    })(t, e);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ArcTail = void 0;
                var s = i("./node_modules/paper/dist/paper-full.js"), a = i("./src/bubble.ts"), o = i("./src/utilities.ts"), h = i("./src/curveTail.ts"), l = i("./src/comical.ts");
                e.ArcTail = function(t) {
                    function e(e, i, n, r, s, a, o, h) {
                        var l = t.call(this, e, i, r, s, a, o, h) || this;
                        return l.mid = n, l;
                    }
                    return r(e, t), e.prototype.makeShapes = function() {
                        console.assert(!!this.bubble, "ArcTail::makeShapes() - this.bubble is null or undefined");
                        var t, e, i, n = this.pathFill, r = this.pathstroke;
                        o.activateLayer(this.lowerLayer);
                        var h = this.root, u = this.bubble && "speech" === this.bubble.getFullSpec().style;
                        if (u) {
                            var c = this.makeBezier(this.root, this.mid, this.tip);
                            c.remove();
                            var d = this.getBubblePath();
                            if (d instanceof s.Path) {
                                var p = c.getIntersections(d);
                                if (0 === p.length) return;
                                p.sort(function(t, e) {
                                    return t.curveOffset - e.curveOffset;
                                }), h = p[0].point;
                            } else console.assert(!1, "speech bubble outline should be a path or a group with second element path"), u = !1;
                        }
                        var f = this.tip.subtract(h).angle, g = 9, v = !1;
                        if (u) {
                            var d = this.getBubblePath(), _ = d.getOffsetOf(h), m = (_ + 10) % d.length;
                            t = this.nudgeTowards(d.getLocationAt(m).point, this.root);
                            var y = _ - 10;
                            y < 0 && (y += d.length), e = this.nudgeTowards(d.getLocationAt(y).point, this.root);
                            var b = this.mid.subtract(h);
                            g = 20 * (b.length > 10 ? .25 : .3);
                        } else {
                            var x = this.mid.subtract(this.root).angle, w = new s.Point(0, 0);
                            w.angle = x + 90, w.length = 9, t = this.root.add(w), e = this.root.subtract(w);
                        }
                        var C = this.makeBezier(h, this.mid, this.tip);
                        C.remove();
                        var S = C.curves[1].length / C.length, k = new s.Point(0, 0);
                        k.angle = f + 90, k.length = g * S;
                        var P = this.mid.add(k), A = this.mid.subtract(k), I = k.divide(1e3);
                        if (!0 !== this.spec.joiner ? (this.pathstroke = this.makeBezier(t, P, this.tip.add(I)), i = this.makeBezier(this.tip.subtract(I), A, e)) : (this.pathstroke = this.makeBezier(this.root.add(k), P, this.tip.add(k)), i = this.makeBezier(this.tip.subtract(k), A, this.root.subtract(k))), !0 !== this.spec.joiner) {
                            var T = 16, b = this.mid.subtract(h), E = this.tip.subtract(this.mid), L = b.angle - E.angle, M = 0 > Math.sin(L * Math.PI / 180);
                            if (T *= Math.min(1.8 * Math.abs(Math.sin(L * Math.PI / 180)), 1), M) {
                                var B = P.subtract(t);
                                B.angle -= 70, B.length = T, this.pathstroke.segments[0].handleOut = B;
                            } else {
                                var O = A.subtract(e);
                                O.angle += 70, O.length = T, i.segments[2].handleIn = O;
                            }
                        }
                        this.pathstroke.addSegments(i.segments), i.remove(), r && (this.pathstroke.insertBelow(r), r.remove());
                        var N = 1;
                        this.bubble && (N = this.bubble.getBorderWidth()), this.pathstroke.strokeWidth = N, this.bubble && this.bubble.usingOverlay() ? (this.pathstroke.strokeColor = new s.Color("black"), o.activateLayer(this.upperLayer), this.pathFill = this.pathstroke.clone(), this.pathFill.remove(), n ? (this.pathFill.insertBelow(n), n.remove()) : this.upperLayer.addChild(this.pathFill), this.pathFill.fillColor = this.getFillColor(), this.pathFill.strokeColor = new s.Color("white"), this.pathFill.strokeColor.alpha = .01, this.clickAction && l.Comical.setItemOnClick(this.pathFill, this.clickAction)) : (this.pathstroke.fillColor = a.Bubble.almostInvisibleColor, this.pathstroke.strokeColor = a.Bubble.almostInvisibleColor, this.clickAction && l.Comical.setItemOnClick(this.pathstroke, this.clickAction));
                    }, e.prototype.getBubblePath = function() {
                        var t = this.bubble.outline;
                        return t instanceof s.Path || (t = this.bubble.outline.children[1]), t;
                    }, e.prototype.nudgeTowards = function(t, e) {
                        var i = e.subtract(t);
                        return i.length = 1, t.add(i);
                    }, e.prototype.makeBezier = function(t, e, i) {
                        var n = new s.Path;
                        n.add(new s.Segment(t));
                        var r = i.subtract(t), a = r.multiply(.3), o = r.multiply(.3);
                        return a.length = Math.min(a.length, e.subtract(t).length / 2), o.length = Math.min(o.length, i.subtract(e).length / 2), n.add(new s.Segment(e, new s.Point(0, 0).subtract(a), o)), n.add(new s.Segment(i)), n;
                    }, e;
                }(h.CurveTail);
            },
            "./src/bubble.ts": function(t, e, i) {
                "use strict";
                var n = this && this.__assign || function() {
                    return (n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var r in e = arguments[i])Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                        return t;
                    }).apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Bubble = void 0;
                var r = i("./node_modules/paper/dist/paper-full.js"), s = i("./src/comical.ts"), a = i("./src/arcTail.ts"), o = i("./src/thoughtTail.ts"), h = i("./src/lineTail.ts"), l = i("./src/speechBubble.ts"), u = i("./src/thoughtBubble.ts"), c = i("./src/captionBubble.ts"), d = i("./src/utilities.ts"), p = i("./src/random.ts"), f = i("./src/circleBubble.ts");
                e.Bubble = function() {
                    function t(e) {
                        this.oulineStrokeColor = null, this.combinedShapes = void 0, this.tails = [], this.hScale = 1, this.vScale = 1, this.oldContentWidth = 0, this.oldContentHeight = 0, this.content = e, this.spec = t.getBubbleSpec(this.content);
                    }
                    return t.prototype.usingOverlay = function() {
                        return !!this.fillArea;
                    }, t.getBubbleSpec = function(e) {
                        var i = e.getAttribute("data-bubble");
                        return i ? JSON.parse(i.replace(/`/g, '"')) : t.getDefaultBubbleSpec(e, "none");
                    }, t.getDefaultBubbleSpec = function(e, i) {
                        if (!i || "none" === i) return {
                            version: s.Comical.bubbleVersion,
                            style: "none",
                            tails: [],
                            level: s.Comical.getMaxLevel(e) + 1,
                            backgroundColors: [
                                "transparent"
                            ],
                            shadowOffset: 0,
                            outerBorderColor: void 0
                        };
                        var n = t.makeDefaultTail(e), r = {
                            version: s.Comical.bubbleVersion,
                            style: i,
                            tails: [
                                n
                            ],
                            level: s.Comical.getMaxLevel(e) + 1
                        };
                        return "caption" === i ? (r.backgroundColors = [
                            "#FFFFFF",
                            "#DFB28B"
                        ], r.tails = [], r.shadowOffset = 5) : ("pointedArcs" === i || "circle" === i || "rectangle" === i) && (r.tails = []), r;
                    }, t.prototype.getSpecLevel = function() {
                        return this.spec.level;
                    }, t.prototype.getFullSpec = function() {
                        var t = s.Comical.findAncestors(this);
                        if (0 == t.length) return this.spec;
                        var e = t[0], i = n(n({}, e.spec), {
                            tails: this.spec.tails
                        });
                        return this.spec.hasOwnProperty("order") ? i.order = this.spec.order : delete i.order, i;
                    }, t.prototype.getBubbleSpec = function() {
                        return this.spec;
                    }, t.prototype.setBubbleSpec = function(t) {
                        console.assert(!!(t.version && t.level && t.tails && t.style), "Bubble lacks minimum fields"), this.spec = t, this.persistBubbleSpec();
                    }, t.prototype.persistBubbleSpecWithoutMonitoring = function() {
                        var t = this;
                        this.callWithMonitoringDisabled(function() {
                            t.persistBubbleSpec();
                        });
                    }, t.prototype.persistBubbleSpec = function() {
                        var t = JSON.stringify(this.spec).replace(/"/g, "`");
                        this.content.setAttribute("data-bubble", t);
                    }, t.prototype.comparePossibleArrays = function(t, e) {
                        if (!t && !e) return !0;
                        if (!t || !e || t.length != e.length) return !1;
                        for(var i = 0; i < t.length; i++)if (t[i] !== e[i]) return !1;
                        return !0;
                    }, t.prototype.mergeWithNewBubbleProps = function(e) {
                        var i = t.getDefaultBubbleSpec(this.content, e.style || this.spec.style), r = this.spec, s = {};
                        if (e.style && r.style !== e.style) {
                            var a = t.getDefaultBubbleSpec(this.content, r.style);
                            r.tails && a.tails && r.tails.length === a.tails.length && (s.tails = r.tails.slice(0, i.tails.length), s.tails.length < i.tails.length && s.tails.push(i.tails[0])), this.comparePossibleArrays(r.backgroundColors, a.backgroundColors) && (s.backgroundColors = i.backgroundColors), r.borderStyle === a.borderStyle && (s.borderStyle = i.borderStyle), r.shadowOffset === a.shadowOffset && (s.shadowOffset = i.shadowOffset), r.outerBorderColor === a.outerBorderColor && (s.outerBorderColor = i.outerBorderColor);
                        }
                        var o = n(n(n(n({}, i), r), s), e);
                        this.setBubbleSpec(o);
                    }, t.prototype.getStyle = function() {
                        return this.getFullSpec().style;
                    }, t.prototype.setStyle = function(t) {
                        this.spec.style = t, this.persistBubbleSpec();
                    }, t.prototype.setLayers = function(t, e, i) {
                        this.setLowerLayer(t), this.setUpperLayer(e), this.setHandleLayer(i);
                    }, t.prototype.getLowerLayer = function() {
                        return this.lowerLayer;
                    }, t.prototype.setLowerLayer = function(t) {
                        this.lowerLayer = t;
                    }, t.prototype.getUpperLayer = function() {
                        return this.upperLayer;
                    }, t.prototype.setUpperLayer = function(t) {
                        this.upperLayer = t;
                    }, t.prototype.setHandleLayer = function(t) {
                        this.handleLayer = t;
                    }, t.prototype.initializeLayers = function() {
                        this.lowerLayer || (this.lowerLayer = new r.Layer), this.upperLayer || (this.upperLayer = new r.Layer), this.handleLayer || (this.handleLayer = new r.Layer);
                    }, t.prototype.initialize = function() {
                        var t = this;
                        this.initializeLayers();
                        for(var e = 0; e < this.tails.length; ++e)this.tails[e].remove();
                        this.tails = [], this.loadShapeAsync(function(e) {
                            t.makeShapes(e), t.isTransparent() && (t.outline.strokeWidth = 0, t.shadowShape && (t.shadowShape.strokeWidth = 0, t.shadowShape.fillColor = new r.Color(0, 0, 0, 0))), t.adjustSizeAndPosition();
                        }), this.spec.tails && this.spec.tails.forEach(function(e) {
                            t.makeTail(e);
                        }), this.adjustSizeAndPosition(), this.monitorContent();
                    }, t.prototype.isTransparent = function() {
                        if ("caption" !== this.spec.style && "none" !== this.spec.style || this.spec.tails.length > 0) return !1;
                        var t = this.spec.outerBorderColor;
                        if (t && "none" !== t || this.spec.shadowOffset) return !1;
                        var e = this.spec.backgroundColors;
                        return !!e && 1 === e.length && "transparent" === e[0];
                    }, t.getShapeSvgString = function(e) {
                        var i = "";
                        switch(e){
                            case "ellipse":
                                i = t.ellipseBubble();
                                break;
                            case "shout":
                                i = t.shoutBubble();
                                break;
                            default:
                                console.log("unknown bubble type; using default"), i = t.ellipseBubble();
                        }
                        return i;
                    }, t.prototype.getComputedShape = function() {
                        this.content && (this.oldContentHeight = this.content.offsetHeight, this.oldContentWidth = this.content.offsetWidth);
                        var t = this.getStyle();
                        switch(d.activateLayer(this.lowerLayer), t){
                            case "pointedArcs":
                                return this.makePointedArcBubble();
                            case "thought":
                                return u.makeThoughtBubble(this);
                            case "speech":
                                return l.makeSpeechBubble(this.content.offsetWidth, this.content.offsetHeight, .6, .8);
                            case "circle":
                                return f.makeCircleBubble(this.content.offsetWidth, this.content.offsetHeight);
                            case "caption":
                            case "caption-withTail":
                            case "rectangle":
                            case "none":
                                var e = this.getFullSpec(), i = e.cornerRadiusX && e.cornerRadiusY ? new r.Size(e.cornerRadiusX, e.cornerRadiusY) : void 0;
                                return c.makeCaptionBox(this, i, this.getBorderWidth(), 3 * ("none" == t));
                            default:
                                return;
                        }
                    }, t.prototype.loadShapeAsync = function(e) {
                        var i = this.getStyle();
                        this.shapeIsComputed = !1;
                        var n = this.getComputedShape();
                        if (n) {
                            this.shapeIsComputed = !0, e(n);
                            return;
                        }
                        var r = t.getShapeSvgString(i);
                        d.activateLayer(this.lowerLayer), this.lowerLayer.project.importSVG(r, {
                            onLoad: function(t) {
                                e(t);
                            }
                        });
                    }, t.prototype.hasOuterBorder = function() {
                        return !!this.getFullSpec().outerBorderColor && "none" !== this.spec.outerBorderColor;
                    }, t.prototype.makeShapes = function(t) {
                        var e = this, i = this.outline, n = this.fillArea;
                        d.activateLayer(this.lowerLayer), this.setOutline(t);
                        var a = t.getItem({
                            recursive: !0,
                            match: function(t) {
                                return "outlineShape" === t.name;
                            }
                        });
                        if (a && (t.remove(), this.setOutline(a.toPath()), this.lowerLayer.addChild(this.outline)), i && (this.outline.insertBelow(i), i.remove()), this.outline.strokeWidth = this.getBorderWidth(), this.hScale = this.vScale = 1, this.contentHolder = t.getItem({
                            recursive: !0,
                            match: function(t) {
                                return "content-holder" === t.name;
                            }
                        }), this.spec.shadowOffset && (this.shadowShape && this.shadowShape.remove(), this.shadowShape = this.outline.clone({
                            deep: !0
                        }), this.shadowShape.insertBelow(this.outline), this.shadowShape.fillColor = this.shadowShape.strokeColor), this.contentHolder.remove(), a && !this.hasOuterBorder() ? (this.outline.fillColor = this.getBackgroundColor(), s.Comical.setItemOnClick(this.outline, function() {
                            s.Comical.activateBubble(e);
                        })) : (this.fillArea = this.outline.clone({
                            insert: !1
                        }), s.Comical.setItemOnClick(this.fillArea, function() {
                            s.Comical.activateBubble(e);
                        }), this.fillArea.strokeWidth = 0, this.outline.strokeWidth *= 2, this.fillArea.fillColor = this.getBackgroundColor(), n ? (this.fillArea.insertBelow(n), n.remove()) : this.upperLayer.addChild(this.fillArea)), this.hasOuterBorder()) {
                            var o = this.outline.clone();
                            o.fillColor = new r.Color(this.getFullSpec().outerBorderColor), o.insertBelow(this.outline);
                            var h = this.contentHolder.size.width, l = this.content.offsetWidth / h, u = this.contentHolder.size.height, c = this.content.offsetHeight / u, p = o.bounds.width, f = o.bounds.height;
                            o.scale((p + 16 / l) / p, (f + 16 / c) / f), o.strokeWidth = 1;
                            var g = new r.Group([
                                o,
                                this.outline
                            ]);
                            this.outline = g;
                        }
                    }, t.prototype.getDefaultContentHolder = function() {
                        var t = new r.Point(this.content.offsetLeft, this.content.offsetTop), e = new r.Size(this.content.offsetWidth, this.content.offsetHeight), i = new r.Shape.Rectangle(t, e);
                        return i.name = "content-holder", i.strokeColor = new r.Color("red"), i.fillColor = new r.Color("transparent"), i;
                    }, t.prototype.getBorderWidth = function() {
                        var e = this.getStyle();
                        return "rectangle" === e ? 1 : "none" === e ? 0 : t.defaultBorderWidth;
                    }, t.prototype.getBackgroundColor = function() {
                        var t = this.getFullSpec();
                        if (t.backgroundColors || "none" !== t.style || (t.backgroundColors = [
                            "transparent"
                        ], this.setBubbleSpec(t)), t.backgroundColors && t.backgroundColors.length) {
                            if (1 === t.backgroundColors.length) return new r.Color(t.backgroundColors[0]);
                            var e = new r.Gradient, i = [];
                            t.backgroundColors.forEach(function(e, n) {
                                return i.push(new r.GradientStop(new r.Color(e), 1 / (t.backgroundColors.length - 1) * n));
                            }), e.stops = i;
                            var n = this.content.offsetWidth / 2, a = new r.Point(n, this.outline.bounds.top), o = new r.Point(n, this.outline.bounds.top + this.outline.bounds.height);
                            return new r.Color(e, a, o);
                        }
                        return s.Comical.backColor;
                    }, t.prototype.adjustSizeAndPosition = function() {
                        var t = this, e = -1, i = -1;
                        if (this.content && (e = this.content.offsetWidth, i = this.content.offsetHeight), e < 1 || i < 1) return void window.setTimeout(function() {
                            t.adjustSizeAndPosition();
                        }, 100);
                        if (this.shapeIsComputed && Math.abs(e - this.oldContentWidth) + Math.abs(i - this.oldContentHeight) > .001) {
                            var n = this.getComputedShape();
                            this.makeShapes(n);
                        }
                        if (this.contentHolder) {
                            var a = this.getScaleFactors(), o = a[0], h = a[1], l = o / this.hScale, u = h / this.vScale;
                            this.outline.scale(l, u), this.shadowShape && this.shadowShape.scale(l, u), this.fillArea && this.fillArea.scale(l, u), this.hScale = o, this.vScale = h;
                        }
                        var c = this.content.offsetLeft, d = this.content.offsetTop, p = new r.Point(c + e / 2, d + i / 2);
                        this.outline && (this.getBorderWidth() % 2 == 1 && (p = p.add(new r.Point(.5, .5))), this.outline.position = p, this.fillArea && (this.fillArea.position = p), this.shadowShape && (this.shadowShape.position = this.outline.position.add(this.spec.shadowOffset || 0))), this.tails.forEach(function(t) {
                            t.adjustRoot(p);
                        });
                        var f = s.Comical.findChild(this);
                        if (f) {
                            console.assert(f.tails.length <= 1, "A child may only have at most 1 tail."), f.adjustJoiners(p);
                            var g = !this.isOverlapping(f);
                            f.tails.forEach(function(t) {
                                t.setTailAndHandleVisibility(g);
                            });
                        }
                        var v = s.Comical.findParent(this);
                        if (v) {
                            var _ = !this.isOverlapping(v);
                            console.assert(this.tails.length <= 1, "A child bubble may have at most 1 tail."), this.tails.forEach(function(t) {
                                t.setTailAndHandleVisibility(_);
                            });
                        }
                        this.uniteShapes();
                    }, t.prototype.setOutline = function(t) {
                        this.outline = t, this.oulineStrokeColor = t.strokeColor;
                    }, t.prototype.uniteShapes = function() {
                        var t = this, e = s.Comical.findRelatives(this, !0);
                        e.forEach(function(t) {
                            t.combinedShapes && (t.combinedShapes.remove(), t.combinedShapes = void 0);
                        });
                        var i = e[0];
                        if (!e.some(function(t) {
                            return !t.outline || !t.outline.unite;
                        })) {
                            var n = [], a = i.outline.clone({
                                insert: !1
                            });
                            a = i.uniteTails(a, n);
                            for(var o = 1; o < e.length; o++)e[o].isOverlapping(e[o - 1]) ? e[o].tails.forEach(function(e) {
                                return e.pathstroke && t.hideShape(e.pathstroke);
                            }) : a = e[o].uniteTails(a, n), a = a.unite(e[o].outline), this.hideShape(e[o].outline);
                            if (a.strokeWidth = this.getBorderWidth(), a.strokeColor = this.oulineStrokeColor, a.fillColor = this.getBackgroundColor(), i.combinedShapes = a, n.length) {
                                var h = [
                                    a
                                ];
                                n.forEach(function(i) {
                                    if (i.pathstroke) {
                                        var n = i.pathstroke.clone({
                                            insert: !1
                                        });
                                        t.hideShape(i.pathstroke), e.forEach(function(t) {
                                            if (t.tails.includes(i)) {
                                                var e = t.outline.getIntersections(n);
                                                e.length > 0 && (n = i.makeShape(e[0].point)).remove();
                                            }
                                        }), h.push(n);
                                    }
                                }), i.combinedShapes = new r.Group(h);
                            }
                            i.combinedShapes.insertBelow(i.outline), i.combinedShapes.sendToBack(), this.hideShape(i.outline), e.forEach(function(t) {
                                t.shadowShape && t.shadowShape.sendToBack();
                            });
                        }
                    }, t.prototype.uniteTails = function(t, e) {
                        var i = this, n = t;
                        return this.tails.forEach(function(t) {
                            t.canUnite() && t.pathstroke ? (n = n.unite(t.pathstroke, {
                                insert: !1
                            }), i.hideShape(t.pathstroke)) : e.push(t);
                        }), n;
                    }, t.prototype.hideShape = function(e) {
                        e.strokeColor = t.almostInvisibleColor, e.fillColor = t.almostInvisibleColor;
                    }, t.prototype.getScaleFactors = function() {
                        var t = this.content.offsetWidth, e = this.content.offsetHeight;
                        return [
                            t / this.contentHolder.size.width,
                            e / this.contentHolder.size.height
                        ];
                    }, t.prototype.isOverlapping = function(t) {
                        return !!this.outline && !!t.outline && !!this.outline.intersects(t.outline);
                    }, t.prototype.isHitByPoint = function(t) {
                        var e;
                        return this.fillArea ? !!this.fillArea.hitTest(t) : (null == (e = this.outline) ? void 0 : e.fillColor) && this.outline.fillColor.alpha > 0 ? !!this.outline.hitTest(t) : this.isContentHitByPoint(t);
                    }, t.prototype.isContentHitByPoint = function(t) {
                        var e = this.content.offsetLeft, i = e + this.content.offsetWidth, n = this.content.offsetTop, r = n + this.content.offsetHeight;
                        return e <= t.x && t.x <= i && n <= t.y && t.y <= r;
                    }, t.prototype.adjustJoiners = function(t) {
                        var e = this;
                        this.tails.forEach(function(i) {
                            i.spec.joiner && i.adjustTip(t) && e.persistBubbleSpecWithoutMonitoring();
                        });
                    }, t.prototype.callWithMonitoringDisabled = function(t) {
                        var e = !!this.observer;
                        this.stopMonitoring(), t(), e && this.monitorContent();
                    }, t.prototype.stopMonitoring = function() {
                        this.observer && (this.observer.disconnect(), this.observer = void 0);
                    }, t.prototype.monitorContent = function() {
                        var t = this;
                        this.observer = new MutationObserver(function() {
                            return t.adjustSizeAndPosition();
                        }), this.observer.observe(this.content, {
                            attributes: !0,
                            characterData: !0,
                            childList: !0,
                            subtree: !0
                        });
                    }, t.prototype.makeTail = function(t) {
                        var e, i = this, n = this.spec.style;
                        if (0 !== this.spec.tails.length) {
                            var l = new r.Point(t.tipX, t.tipY), u = new r.Point(t.midpointX, t.midpointY), c = this.calculateTailStartPoint();
                            switch(d.activateLayer(this.upperLayer), n){
                                case "thought":
                                    e = new o.ThoughtTail(c, l, u, this.lowerLayer, this.upperLayer, this.handleLayer, t, this);
                                    break;
                                case "caption":
                                case "rectangle":
                                case "none":
                                    e = new h.LineTail(c, l, this.lowerLayer, this.upperLayer, this.handleLayer, t, this);
                                    break;
                                default:
                                    e = new a.ArcTail(c, l, u, this.lowerLayer, this.upperLayer, this.handleLayer, t, this);
                            }
                            e.makeShapes(), e.onClick(function() {
                                s.Comical.activateBubble(i);
                            }), this.tails.push(e);
                        }
                    }, t.prototype.showHandles = function() {
                        this.tails.forEach(function(t) {
                            t.showHandles();
                        });
                    }, t.prototype.calculateTailStartPoint = function() {
                        return new r.Point(this.content.offsetLeft + this.content.offsetWidth / 2, this.content.offsetTop + this.content.offsetHeight / 2);
                    }, t.makeDefaultTail = function(e) {
                        var i = e.parentElement, n = e.offsetLeft, s = e.offsetWidth, a = n + s, o = e.offsetTop, h = e.offsetHeight, l = o + h, u = i.offsetWidth, c = 0 + u, d = i.offsetHeight, p = new r.Point(n - 0 + s / 2, o - 0 + h / 2), f = n - 0 - s / 2;
                        n - 0 < c - a && (f = a - 0 + s / 2);
                        var g = l - 0 + 20;
                        g > d - 5 && (g = d - 5), g < l - 0 && (g = o - 0 - 20) < 5 && (g = 5), f < 0 && (f = 0), f > u && (f = u), g < 0 && (g = 0), g > d && (g = d);
                        var v = new r.Point(f, g), _ = t.defaultMid(p, v, new r.Size(e.offsetWidth, e.offsetHeight));
                        return {
                            tipX: f,
                            tipY: g,
                            midpointX: _.x,
                            midpointY: _.y,
                            autoCurve: !0
                        };
                    }, t.adjustTowards = function(t, e, i) {
                        var n = e.subtract(t), r = Math.min(0 == n.x ? Number.MAX_VALUE : i.width / 2 / Math.abs(n.x), 0 == n.y ? Number.MAX_VALUE : i.height / 2 / Math.abs(n.y));
                        return t.add(n.multiply(r));
                    }, t.defaultMid = function(e, i, n, r) {
                        var s = t.adjustTowards(e, i, n), a = (r ? t.adjustTowards(i, e, r) : i).subtract(s), o = s.add(a.divide(2));
                        return a = a.divide(5), a.angle -= 90, Math.abs(a.x) > Math.abs(a.y) ? a.length *= a.y / a.x : a.length *= a.x / a.y, o.add(a);
                    }, t.prototype.makeBubbleItem = function(t, e) {
                        var i = this.content.clientWidth, n = this.content.clientHeight, s = l.makeSpeechBubbleParts(i + 2 * t, n + 2 * t, .6, .8), a = s[0], o = s[1];
                        a.remove();
                        var h = o.size.width / (i + 2 * t), u = o.size.height / (n + 2 * t);
                        o.set({
                            center: o.position,
                            size: new r.Size(i * h, n * u)
                        });
                        for(var c = Math.max(Math.round((i + n) * 2 / 30), 5), d = [], f = new p.SimpleRandom(i + n), g = a.length / c, v = g / 2, _ = 0; _ < c; _++){
                            var m = _ * g + v * f.nextDouble(), y = a.getLocationAt(m).point;
                            d.push(y);
                        }
                        var b = e(d, o.position);
                        return new r.Group([
                            b,
                            o
                        ]);
                    }, t.prototype.makePointedArcBubble = function() {
                        return this.makeBubbleItem(7, function(t, e) {
                            for(var i = new r.Path, n = 0; n < t.length; n++){
                                var s = t[n], a = n < t.length - 1 ? t[n + 1] : t[0], o = new r.Point((s.x + a.x) / 2, (s.y + a.y) / 2), h = o.subtract(e);
                                h.length = 7;
                                var l = o.subtract(h), u = new r.Path.Arc(s, l, a);
                                u.remove(), i.addSegments(u.segments);
                            }
                            return i.strokeWidth = 1, i.strokeColor = new r.Color("black"), i.closed = !0, i.name = "outlineShape", i;
                        });
                    }, t.ellipseBubble = function() {
                        return '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n      <svg\n         xmlns:dc="http://purl.org/dc/elements/1.1/"\n         xmlns:cc="http://creativecommons.org/ns#"\n         xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n         xmlns:svg="http://www.w3.org/2000/svg"\n         xmlns="http://www.w3.org/2000/svg"\n         id="svg8"\n         version="1.1"\n         viewBox="0 0 100 100"\n         height="100mm"\n         width="100mm">\n        <defs\n           id="defs2" />\n        <metadata\n           id="metadata5">\n          <rdf:RDF>\n            <cc:Work\n               rdf:about="">\n              <dc:format>image/svg+xml</dc:format>\n              <dc:type\n                 rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n              <dc:title></dc:title>\n            </cc:Work>\n          </rdf:RDF>\n        </metadata>\n        <g\n           transform="translate(0,-197)"\n           id="layer1">\n          <ellipse\n             ry="49.702854"\n             rx="49.608364"\n             cy="247.10715"\n             cx="50.36533"\n             id="outlineShape"\n             style="fill:#ffffff;stroke:#000000;stroke-width:0.26660731;stroke-opacity:1" />\n          <rect\n            id="content-holder"\n            class="content-holder"\n             y="214.03423"\n             x="13.229166"\n             height="65.956848"\n             width="74.461304"\n             style="fill:none;stroke:#000000;stroke-width:0.26458332;stroke-opacity:1" />\n        </g>\n      </svg>';
                    }, t.shoutBubble = function() {
                        return '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n        <svg\n           xmlns:dc="http://purl.org/dc/elements/1.1/"\n           xmlns:cc="http://creativecommons.org/ns#"\n           xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n           xmlns:svg="http://www.w3.org/2000/svg"\n           xmlns="http://www.w3.org/2000/svg"\n           id="svg8"\n           version="1.1"\n           viewBox="0 0 100 100"\n           height="100mm"\n           width="100mm">\n          <defs\n             id="defs2" />\n          <metadata\n             id="metadata5">\n            <rdf:RDF>\n              <cc:Work\n                 rdf:about="">\n                <dc:format>image/svg+xml</dc:format>\n                <dc:type\n                   rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n                <dc:title></dc:title>\n              </cc:Work>\n            </rdf:RDF>\n          </metadata>\n          <g\n             transform="translate(0,-197)"\n             id="layer1">\n             <path\n             id="path4528"\n             d="m 34.773809,223.10566 14.174107,-25.89137 12.662202,25.51339 21.92262,-25.13542 -6.199227,26.04296 19.050415,-5.82123 -18.898809,23.62351 22.489583,8.50447 -22.678569,13.60714 20.78869,31.56101 -39.498513,-24.94643 2.834823,21.73363 -17.386906,-21.73363 -17.575892,27.0253 0.566965,-27.0253 L 4.346726,290.00744 22.489583,258.44643 0.37797618,247.67411 22.867559,235.76786 1.7008928,199.29316 Z"\n             style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />\n             <rect\n             id="content-holder"\n             y="223.63522"\n             x="22.830175"\n             height="46.376858"\n             width="54.503334"\n             style="fill:none;stroke:#000000;stroke-width:0.18981449;stroke-opacity:1;fill-opacity:0" />\n          </g>\n        </svg>';
                    }, t.defaultBorderWidth = 3, t.almostInvisibleColor = new r.Color(1, 1, 1, .001), t;
                }();
            },
            "./src/captionBubble.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.makeCaptionBox = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js");
                e.makeCaptionBox = function(t, e, i, r) {
                    var s, a, o, h, l, u, c, d, p = t.getDefaultContentHolder(), f = (s = p.bounds, a = e, o = i, h = r, l = s.topLeft.subtract(o + h), u = new n.Size(s.size.add((h + o) * 2)), c = new n.Rectangle(l, u), (d = new n.Path.Rectangle(c, a)).name = "outlineShape", d.strokeColor = new n.Color("black"), d);
                    return new n.Group([
                        f,
                        p
                    ]);
                };
            },
            "./src/circleBubble.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.makeCircleBubble = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js");
                e.makeCircleBubble = function(t, e) {
                    t <= 0 && (console.assert(!1, "Invalid width. Received: " + t + ". Expected: width > 0"), t = 1), e <= 0 && (console.assert(!1, "Invalid height. Received: " + e + ". Expected: height > 0"), e = 1);
                    var i = 0 + t / 2, r = 0 + e / 2, s = Math.sqrt(i * i + r * r), a = new n.Path.Circle(new n.Point(i, r), s);
                    a.name = "outlineShape", a.strokeColor = new n.Color("black");
                    var o = new n.Shape.Rectangle(new n.Point(0, 0), new n.Point(0 + t, 0 + e));
                    return o.name = "content-holder", o.strokeColor = new n.Color("red"), o.fillColor = new n.Color("transparent"), new n.Group([
                        a,
                        o
                    ]);
                };
            },
            "./src/comical.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Comical = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js"), r = i("./src/bubble.ts"), s = i("./src/uniqueId.ts");
                e.Comical = function() {
                    function t() {}
                    return t.setUserInterfaceProperties = function(e) {
                        t.tailHandleColor = new n.Color(e.tailHandleColor);
                    }, t.setSelectorForBubblesWhichTailMidpointMayOverlap = function(e) {
                        t.selectorForBubblesWhichTailMidpointMayOverlap = e;
                    }, t.getSelectorForBubblesWhichTailMidpointMayOverlap = function() {
                        return t.selectorForBubblesWhichTailMidpointMayOverlap;
                    }, t.startEditing = function(e) {
                        e.forEach(function(e) {
                            return t.convertBubbleJsonToCanvas(e);
                        });
                    }, t.stopEditing = function() {
                        var e = [];
                        t.activeContainers.forEach(function(t, i) {
                            e.push(i);
                        }), e.forEach(function(e) {
                            return t.convertCanvasToSvgImg(e);
                        });
                    }, t.convertCanvasToSvgImg = function(e) {
                        var i = e.getElementsByTagName("canvas")[0];
                        if (i) {
                            var n = this.activeContainers.get(e);
                            if (!n) return void console.error("attempting convertCanvasToSvgImg on non-active element");
                            var r = n.bubbleList;
                            if (0 !== r.length && t.isAnyBubbleVisible(r)) {
                                n.project.getItems({
                                    recursive: !0,
                                    match: function(t) {
                                        return t.name && t.name.startsWith("handle");
                                    }
                                }).forEach(function(t) {
                                    return t.remove();
                                });
                                var a = n.project.exportSVG();
                                a.classList.add("comical-generated"), s.uniqueIds(a), i.parentElement.insertBefore(a, i);
                            }
                            i.remove(), t.stopMonitoring(e), this.activeContainers.delete(e);
                        }
                    }, t.isAnyBubbleVisible = function(t) {
                        for(var e = 0; e < t.length; e++)if (!t[e].isTransparent()) return !0;
                        return !1;
                    }, t.stopMonitoring = function(e) {
                        var i = t.activeContainers.get(e);
                        i && i.bubbleList.forEach(function(t) {
                            return t.stopMonitoring();
                        });
                    }, t.activateElement = function(e) {
                        var i = void 0;
                        e && (i = t.getBubblesInSameCanvas(e).find(function(t) {
                            return t.content === e;
                        })), t.activateBubble(i);
                    }, t.activateBubble = function(e) {
                        e != t.activeBubble && (t.hideHandles(), t.activeBubble = e, t.activeBubble && t.activeBubble.showHandles(), t.activeBubbleListener && t.activeBubbleListener(t.activeBubble ? t.activeBubble.content : void 0));
                    }, t.hideHandles = function() {
                        t.activeContainers.forEach(function(t) {
                            t.handleLayer && t.handleLayer.removeChildren();
                        });
                    }, t.update = function(e) {
                        t.stopMonitoring(e);
                        var i = this.activeContainers.get(e);
                        if (!i) return void console.error("invoked update on an element that is not active");
                        for(i.project.activate(); i.project.layers.length > 1;){
                            var s = i.project.layers.pop();
                            s && s.remove();
                        }
                        i.project.layers.length > 0 && i.project.layers[0].activate(), i.project.activeLayer.removeChildren();
                        var a = e.ownerDocument.evaluate(".//*[@data-bubble]", e, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null), o = [];
                        i.bubbleList = o;
                        for(var h = [], l = 0; l < a.snapshotLength; l++){
                            var u = a.snapshotItem(l), c = new r.Bubble(u);
                            o.push(c);
                            var d = c.getSpecLevel();
                            d || (d = 0), h.push(d);
                        }
                        h.sort();
                        for(var p = {}, l = 0; l < h.length; ++l)if (0 == l || h[l - 1] != h[l]) {
                            var d = h[l], f = new n.Layer, g = new n.Layer;
                            p[d] = [
                                f,
                                g
                            ];
                        }
                        i.handleLayer = new n.Layer;
                        for(var l = 0; l < o.length; ++l){
                            var c = o[l], d = c.getSpecLevel();
                            d || (d = 0);
                            var v = p[d], _ = v[0], m = v[1];
                            c.setLayers(_, m, i.handleLayer), c.initialize();
                        }
                    }, t.sortBubbleListTopLevelFirst = function(t) {
                        t.sort(function(t, e) {
                            var i = t.getBubbleSpec().level;
                            i || (i = 0);
                            var n = e.getBubbleSpec().level;
                            return n || (n = 0), n - i;
                        });
                    }, t.getMaxLevel = function(e) {
                        var i = t.getBubblesInSameCanvas(e);
                        if (0 === i.length) return 0;
                        var n = Number.MIN_VALUE;
                        return i.forEach(function(t) {
                            return n = Math.max(n, t.getBubbleSpec().level || 0);
                        }), n;
                    }, t.setItemOnClick = function(t, e) {
                        t.data || (t.data = {}), t.data.onClick = e;
                    }, t.isDraggableNear = function(e, i, r) {
                        var s = t.activeContainers.get(e);
                        if (!s) return !1;
                        var a = new n.Point(i, r), o = s.project.hitTest(a);
                        return o && o.item && o.item.data && o.item.data.hasOwnProperty("onDrag");
                    }, t.convertBubbleJsonToCanvas = function(e) {
                        var i = e.ownerDocument.createElement("canvas");
                        i.style.position = "absolute", i.style.top = "0", i.style.left = "0", i.classList.add("comical-generated"), i.classList.add("comical-editing");
                        var r = e.getElementsByClassName("comical-generated")[0];
                        r ? (r.parentElement.insertBefore(i, r), r.remove()) : e.insertBefore(i, e.firstChild);
                        var s = this.getScaling(e);
                        i.width = e.clientWidth / s.x, i.height = e.clientHeight / s.y, n.setup(i);
                        var a = null, o = n.project;
                        i.addEventListener("mousedown", function(t) {
                            var e = new n.Point(t.offsetX, t.offsetY), i = o.hitTest(e);
                            a = i ? i.item : null;
                        }), i.addEventListener("mousemove", function(t) {
                            var e = new n.Point(t.offsetX, t.offsetY);
                            a && 1 === t.buttons && a.data && a.data.hasOwnProperty("onDrag") && a.data.onDrag(e);
                        }), i.addEventListener("mouseup", function(t) {
                            a = null;
                        }), i.addEventListener("click", function(t) {
                            var e = new n.Point(t.offsetX, t.offsetY), i = o.hitTest(e);
                            i && i.item && i.item.data && i.item.data.hasOwnProperty("onClick") && i.item.data.onClick();
                        }), i.addEventListener("dblclick", function(t) {
                            var e = new n.Point(t.offsetX, t.offsetY), i = o.hitTest(e);
                            i && i.item && i.item.data && i.item.data.hasOwnProperty("onDoubleClick") && i.item.data.onDoubleClick();
                        });
                        var h = {
                            project: n.project,
                            bubbleList: []
                        };
                        this.activeContainers.set(e, h), t.update(e);
                    }, t.getScaling = function(t) {
                        var e = t.getBoundingClientRect(), i = e.width, r = e.height, s = t.offsetWidth, a = t.offsetHeight;
                        return new n.Point(i / s, r / a);
                    }, t.setActiveBubbleListener = function(e) {
                        t.activeBubbleListener = e;
                    }, t.initializeChild = function(e, i) {
                        var s = t.getBubblesInSameCanvas(i), a = s.find(function(t) {
                            return t.content === i;
                        });
                        if (!a) return void console.error("trying to make child of element not already active in Comical");
                        var o = a.getBubbleSpec();
                        o.order || (o.order = 1, a.persistBubbleSpec());
                        var h = s.find(function(t) {
                            return t.content === e;
                        });
                        h || (h = new r.Bubble(e));
                        var l = t.getLastInFamily(i), u = l.getBubbleSpec().order || 1, c = l.calculateTailStartPoint(), d = h.calculateTailStartPoint(), p = r.Bubble.defaultMid(d, c, new n.Size(e.offsetWidth, e.offsetHeight), new n.Size(l.content.offsetWidth, l.content.offsetHeight)), f = {
                            version: t.bubbleVersion,
                            style: o.style,
                            tails: [
                                {
                                    tipX: c.x,
                                    tipY: c.y,
                                    midpointX: p.x,
                                    midpointY: p.y,
                                    joiner: !0,
                                    autoCurve: !0
                                }
                            ],
                            outerBorderColor: o.outerBorderColor,
                            level: o.level,
                            order: u + 1
                        };
                        h.setBubbleSpec(f);
                    }, t.somethingHit = function(e, i, r) {
                        var s = t.activeContainers.get(e);
                        return !!s && !!s.project.hitTest(new n.Point(i, r));
                    }, t.isAreaCompletelyIntersected = function(t, e, i, n, r) {
                        var s = this.somethingHit(t, e, n), a = this.somethingHit(t, i, n), o = this.somethingHit(t, e, r), h = this.somethingHit(t, i, r);
                        return s && a && o && h;
                    }, t.getBubbleHit = function(e, i, r, s, a) {
                        var o = t.activeContainers.get(e);
                        if (o) {
                            var h = o.bubbleList.filter(function(t) {
                                if (a && t.content.matches(a)) return !1;
                                var e = window.getComputedStyle(t.content);
                                return "none" !== e.display && (!s || "none" !== e.pointerEvents);
                            });
                            if (0 !== h.length) return t.sortBubbleListTopLevelFirst(h), h.find(function(t) {
                                return t.isHitByPoint(new n.Point(i, r));
                            });
                        }
                    }, t.comicalParentOf = function(e) {
                        for(var i = e; i;){
                            var n = t.activeContainers.get(i);
                            if (n) return [
                                i,
                                n
                            ];
                            i = i.parentElement;
                        }
                        return [
                            void 0,
                            void 0
                        ];
                    }, t.bubbleWithContentAtPoint = function(e, i, n) {
                        var r = t.activeContainers.get(e);
                        if (r) for(var s = 0; s < r.bubbleList.length; s++){
                            var a = r.bubbleList[s], o = t.getBoundsRelativeToParent(e, a.content);
                            if (i >= o.left && i <= o.right && n >= o.top && n <= o.bottom) return a;
                        }
                    }, t.getBoundsRelativeToParent = function(t, e) {
                        var i = t.getBoundingClientRect(), n = e.getBoundingClientRect(), r = i.left, s = i.top;
                        return {
                            left: n.left - r,
                            right: n.right - r,
                            width: n.width,
                            top: n.top - s,
                            bottom: n.bottom - s,
                            height: n.height
                        };
                    }, t.getPointOutsideBubblesAlong = function(t, e, i, n) {
                        for(var r = i.subtract(e).divide(n), s = 1; s <= n; s++){
                            var a = e.add(r.multiply(s));
                            if (!this.getBubbleHit(t, a.x, a.y)) return a;
                        }
                    }, t.movePointOutsideBubble = function(e, i, n, r, s) {
                        var a = t.comicalParentOf(e)[0];
                        if (!a) return i;
                        var o = this.getBubbleHit(a, i.x, i.y, !1, s);
                        if (!o) return i;
                        for(var h = void 0, l = Math.max(i.subtract(n).length, i.subtract(r).length), u = Math.max(Math.min(l - .1, 5), 2); !h && u < l;){
                            h = t.getPointOutsideBubblesAlong(a, i, n, u);
                            var c = t.getPointOutsideBubblesAlong(a, i, r, u);
                            (c && !h || c && h && c.subtract(i).length < h.subtract(i).length) && (h = c), u *= 1.9;
                        }
                        if (!h) return i;
                        for(var d = i;;){
                            var p = h.subtract(d).divide(2);
                            if (p.length < 1) return h;
                            var f = d.add(p), g = this.getBubbleHit(a, f.x, f.y, !1, s);
                            g && (g === o || g.outline.intersects(o.outline)) ? d = f : h = f;
                        }
                    }, t.okToMoveTo = function(e, i) {
                        var n = t.comicalParentOf(e)[0];
                        if (!n) return !0;
                        var r = this.getBubbleHit(n, i.x, i.y), s = null == r ? void 0 : r.getFullSpec();
                        return (!r || (null == s ? void 0 : s.style) === "none" && !(s.tails.length > 0)) && !(i.x < 0) && !(i.y < 0) && !(i.x >= n.clientWidth) && !(i.y >= n.clientHeight);
                    }, t.getBubblesInSameCanvas = function(e) {
                        for(var i = t.activeContainers.entries(), n = i.next(); !n.done;){
                            if (n.value[0].contains(e)) return n.value[1].bubbleList;
                            n = i.next();
                        }
                        return [];
                    }, t.getLastInFamily = function(e) {
                        var i = r.Bubble.getBubbleSpec(e).level, n = t.getBubblesInSameCanvas(e).filter(function(t) {
                            return t.getBubbleSpec().level === i && t.getBubbleSpec().order;
                        }).sort(function(t, e) {
                            return t.getBubbleSpec().order - e.getBubbleSpec().order;
                        });
                        return n[n.length - 1];
                    }, t.findChild = function(e) {
                        var i = e.getSpecLevel(), n = e.getBubbleSpec().order;
                        if (n) {
                            var r = t.getBubblesInSameCanvas(e.content).filter(function(t) {
                                return t.getBubbleSpec().level === i && t.getBubbleSpec().order && t.getBubbleSpec().order > n;
                            }).sort(function(t, e) {
                                return t.getBubbleSpec().order - e.getBubbleSpec().order;
                            });
                            if (r.length > 0) return r[0];
                        }
                    }, t.findParent = function(e) {
                        var i = t.findAncestors(e);
                        return i && i.length > 0 ? i[i.length - 1] : void 0;
                    }, t.findAncestors = function(e) {
                        var i = e.getSpecLevel(), n = e.getBubbleSpec().order;
                        return n ? t.getBubblesInSameCanvas(e.content).filter(function(t) {
                            return t.getBubbleSpec().level === i && t.getBubbleSpec().order && t.getBubbleSpec().order < n;
                        }).sort(function(t, e) {
                            return t.getBubbleSpec().order - e.getBubbleSpec().order;
                        }) : [];
                    }, t.findRelatives = function(e, i) {
                        void 0 === i && (i = !1);
                        var n = e.getSpecLevel(), r = e.getBubbleSpec().order;
                        return r ? t.getBubblesInSameCanvas(e.content).filter(function(t) {
                            return t.getBubbleSpec().level === n && t.getBubbleSpec().order && (i || t.getBubbleSpec().order !== r);
                        }).sort(function(t, e) {
                            return t.getBubbleSpec().order - e.getBubbleSpec().order;
                        }) : i ? [
                            e
                        ] : [];
                    }, t.deleteBubbleFromFamily = function(t, e) {
                        var i = r.Bubble.getBubbleSpec(t), n = i.order;
                        if (n && n > 0) {
                            var s = new r.Bubble(t);
                            this.findRelatives(s).forEach(function(t, e) {
                                var r = t.getBubbleSpec();
                                0 === e && 1 === n && (r = i), r.order && r.order > n && r.order--, t.setBubbleSpec(r);
                            });
                        }
                        e.removeChild(t), this.update(e);
                    }, t.backColor = new n.Color("white"), t.tailHandleColor = new n.Color("orange"), t.selectorForBubblesWhichTailMidpointMayOverlap = "", t.activeContainers = new Map, t.bubbleVersion = "1.0", t;
                }();
            },
            "./src/curveTail.ts": function(t, e, i) {
                "use strict";
                var n, r = this && this.__extends || (n = function(t, e) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, e) {
                        t.__proto__ = e;
                    } || function(t, e) {
                        for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                    })(t, e);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.CurveTail = void 0;
                var s = i("./src/tail.ts"), a = i("./node_modules/paper/dist/paper-full.js"), o = i("./src/comical.ts"), h = i("./src/bubble.ts"), l = i("./src/handle.ts");
                e.CurveTail = function(t) {
                    function e() {
                        return null !== t && t.apply(this, arguments) || this;
                    }
                    return r(e, t), e.prototype.adjustForChangedRoot = function(t) {
                        var e = this.mid.add(t.divide(2));
                        if (this.bubble && this.spec.autoCurve) {
                            var i = o.Comical.findParent(this.bubble);
                            e = h.Bubble.defaultMid(this.currentStartPoint(), this.tip, new a.Size(this.bubble.content.offsetWidth, this.bubble.content.offsetHeight), i ? new a.Size(i.content.offsetWidth, i.content.offsetHeight) : void 0);
                        }
                        this.bubble && (e = o.Comical.movePointOutsideBubble(this.bubble.content, e, this.tip, this.root, o.Comical.getSelectorForBubblesWhichTailMidpointMayOverlap())), this.mid = e, this.midHandle && this.midHandle.setPosition(e), this.spec && (this.spec.midpointX = e.x, this.spec.midpointY = e.y);
                    }, e.prototype.adjustForChangedTip = function(t) {
                        this.adjustForChangedRoot(t);
                    }, e.prototype.showHandlesInternal = function() {
                        var e = this;
                        t.prototype.showHandlesInternal.call(this), this.midHandle = new l.Handle(this.handleLayer, this.mid, !!this.spec.autoCurve), this.midHandle.bringToFront(), this.midHandle.onDrag = function(t) {
                            if (e.bubble) {
                                var i = o.Comical.comicalParentOf(e.bubble.content)[0];
                                if (i && o.Comical.getBubbleHit(i, t.x, t.y, !1, o.Comical.getSelectorForBubblesWhichTailMidpointMayOverlap())) return;
                            }
                            e.spec.autoCurve = !1, e.midHandle.setAutoMode(!1), e.midHandle.setPosition(t), e.mid = t, e.makeShapes(), e.spec.midpointX = t.x, e.spec.midpointY = t.y, e.persistSpecChanges(), e.uniteBubbleShapes();
                        }, this.midHandle.onDoubleClick = function() {
                            e.spec.autoCurve = !0, e.adjustForChangedRoot(new a.Point(0, 0)), e.makeShapes(), e.persistSpecChanges(), e.midHandle.setAutoMode(!0), e.uniteBubbleShapes();
                        };
                    }, e.prototype.setTailAndHandleVisibility = function(e) {
                        t.prototype.setTailAndHandleVisibility.call(this, e), this.midHandle && this.midHandle.setVisibility(e);
                    }, e;
                }(s.Tail);
            },
            "./src/handle.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Handle = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js"), r = i("./src/utilities.ts"), s = i("./src/tail.ts"), a = i("./src/comical.ts");
                e.Handle = function() {
                    function t(e, i, s) {
                        r.activateLayer(e), this.circle = new n.Path.Circle(i, 5), this.circle.strokeColor = a.Comical.tailHandleColor, this.circle.strokeWidth = 1, this.circle.name = "handle" + t.handleIndex++, this.circle.visible = !0, this.circle.data = this, this.setAutoMode(s);
                    }
                    return t.prototype.setAutoMode = function(t) {
                        this.circle.fillColor = t ? s.Tail.transparentColor : a.Comical.tailHandleColor;
                    }, t.prototype.getPosition = function() {
                        return this.circle.position;
                    }, t.prototype.setPosition = function(t) {
                        this.circle.position = t;
                    }, t.prototype.setVisibility = function(t) {
                        this.circle.visible = t;
                    }, t.prototype.bringToFront = function() {
                        this.circle.bringToFront();
                    }, t.handleIndex = 0, t;
                }();
            },
            "./src/index.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Bubble = e.Comical = void 0;
                var n = i("./src/comical.ts");
                Object.defineProperty(e, "Comical", {
                    enumerable: !0,
                    get: function() {
                        return n.Comical;
                    }
                });
                var r = i("./src/bubble.ts");
                Object.defineProperty(e, "Bubble", {
                    enumerable: !0,
                    get: function() {
                        return r.Bubble;
                    }
                });
            },
            "./src/lineTail.ts": function(t, e, i) {
                "use strict";
                var n, r = this && this.__extends || (n = function(t, e) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, e) {
                        t.__proto__ = e;
                    } || function(t, e) {
                        for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                    })(t, e);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.LineTail = void 0;
                var s = i("./src/tail.ts"), a = i("./node_modules/paper/dist/paper-full.js"), o = i("./src/comical.ts");
                e.LineTail = function(t) {
                    function e(e, i, n, r, s, a, o) {
                        var h = t.call(this, e, i, n, r, s, a, o) || this;
                        return h.tailWidth = 1, h;
                    }
                    return r(e, t), e.prototype.canUnite = function() {
                        return !1;
                    }, e.prototype.makeShapes = function() {
                        var t = this.pathstroke;
                        this.lowerLayer.activate(), this.pathstroke = this.makeShape(this.root), t && (this.pathstroke.insertBelow(t), t.remove());
                    }, e.prototype.makeShape = function(t) {
                        var e = new a.Path.Line(t, this.tip);
                        return e.strokeColor = new a.Color("black"), e.strokeWidth = this.tailWidth, e;
                    }, e.prototype.onClick = function(t) {
                        this.clickAction = t, this.pathstroke && o.Comical.setItemOnClick(this.pathstroke, t);
                    }, e;
                }(s.Tail);
            },
            "./src/random.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SimpleRandom = void 0, e.SimpleRandom = function() {
                    function t(t) {
                        this.seed = t;
                    }
                    return t.prototype.next = function(t, e) {
                        return e = e || 0, t = t || 0, this.seed = (9301 * this.seed + 49297) % 233280, t + this.seed / 233280 * (e - t);
                    }, t.prototype.nextDouble = function() {
                        return this.next(0, 1);
                    }, t;
                }();
            },
            "./src/speechBubble.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.makeSpeechBubble = e.makeSpeechBubbleParts = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js");
                function r(t, e, i, r) {
                    t <= 0 && (console.assert(!1, "Invalid width. Received: " + t + ". Expected: width > 0"), t = 1), e <= 0 && (console.assert(!1, "Invalid height. Received: " + e + ". Expected: height > 0"), e = 1);
                    var s = 0 + t / 2, a = 0 + e / 2, o = 0 + t, h = 0 + e, l = t / 2 * i, u = e / 2 * r, c = new n.Segment({
                        point: new n.Point(s, 0),
                        handleOut: new n.Point(l, 0),
                        handleIn: new n.Point(-l, 0)
                    }), d = new n.Segment({
                        point: new n.Point(o, a),
                        handleIn: new n.Point(0, -u),
                        handleOut: new n.Point(0, u)
                    }), p = new n.Segment({
                        point: new n.Point(s, h),
                        handleIn: new n.Point(l, 0),
                        handleOut: new n.Point(-l, 0)
                    }), f = new n.Segment({
                        point: new n.Point(0, a),
                        handleIn: new n.Point(0, u),
                        handleOut: new n.Point(0, -u)
                    }), g = new n.Path({
                        segments: [
                            c,
                            d,
                            p,
                            f
                        ],
                        strokeColor: new n.Color("black")
                    });
                    g.name = "outlineShape";
                    var v = g.curves[0], _ = v.getLocationAt(v.length * t / (t + e)).point, m = g.curves[2], y = m.getLocationAt(m.length * t / (t + e)).point, b = new n.Shape.Rectangle(_, y);
                    return b.name = "content-holder", b.strokeColor = new n.Color("red"), b.fillColor = new n.Color("transparent"), g.closed = !0, [
                        g,
                        b
                    ];
                }
                e.makeSpeechBubbleParts = r, e.makeSpeechBubble = function(t, e, i, s) {
                    var a = r(t, e, i, s), o = a[0], h = a[1];
                    return new n.Group([
                        o,
                        h
                    ]);
                };
            },
            "./src/tail.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Tail = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js"), r = i("./src/comical.ts"), s = i("./src/utilities.ts"), a = i("./src/handle.ts");
                e.Tail = function() {
                    function t(t, e, i, n, r, s, a) {
                        this.lowerLayer = i, this.upperLayer = n, this.handleLayer = r, this.spec = s, this.root = t, this.tip = e, this.bubble = a;
                    }
                    return t.prototype.getFillColor = function() {
                        return this.debugMode ? new n.Color("yellow") : this.bubble ? this.bubble.getBackgroundColor() : r.Comical.backColor;
                    }, t.prototype.makeShapes = function() {
                        throw Error("Each subclass must implement makeShapes");
                    }, t.prototype.fillPaths = function() {
                        return this.pathFill ? [
                            this.pathFill
                        ] : [];
                    }, t.prototype.allPaths = function() {
                        var t = this.fillPaths();
                        return this.pathstroke && t.push(this.pathstroke), t;
                    }, t.prototype.onClick = function(t) {
                        this.clickAction = t, this.allPaths().forEach(function(e) {
                            r.Comical.setItemOnClick(e, t);
                        });
                    }, t.prototype.adjustForChangedRoot = function(t) {}, t.prototype.adjustRoot = function(t) {
                        var e = t.subtract(this.root);
                        Math.abs(e.x) + Math.abs(e.y) < 1e-4 || (this.root = t, this.adjustForChangedRoot(e), this.makeShapes(), this.persistSpecChanges());
                    }, t.prototype.adjustForChangedTip = function(t) {}, t.prototype.canUnite = function() {
                        return void 0 !== this.pathstroke;
                    }, t.prototype.uniteBubbleShapes = function() {
                        this.bubble && this.bubble.uniteShapes();
                    }, t.prototype.adjustTip = function(t) {
                        var e = t.subtract(this.tip);
                        Math.abs(e.x) + Math.abs(e.y) < 1e-4 || (this.tip = t, this.adjustForChangedTip(e), this.makeShapes(), this.spec && (this.spec.tipX = this.tip.x, this.spec.tipY = this.tip.y), this.persistSpecChanges(), this.uniteBubbleShapes());
                    }, t.prototype.remove = function() {
                        this.allPaths().forEach(function(t) {
                            return t.remove();
                        });
                    }, t.prototype.currentStartPoint = function() {
                        return this.bubble ? this.bubble.calculateTailStartPoint() : this.root;
                    }, t.prototype.showHandles = function() {
                        this.showHandlesInternal(), this.isBubbleOverlappingParent() && this.setTailAndHandleVisibility(!1);
                    }, t.prototype.okToMoveHandleTo = function(t) {
                        return !this.bubble || r.Comical.okToMoveTo(this.bubble.content, t);
                    }, t.prototype.showHandlesInternal = function() {
                        var t, e = this;
                        this.state = "idle", s.activateLayer(this.handleLayer), this.handleLayer.visible = !0, this.spec.joiner || ((t = new a.Handle(this.handleLayer, this.tip, !0)).onDrag = function(i) {
                            if (e.okToMoveHandleTo(i)) {
                                var n = i.subtract(t.getPosition()).divide(2);
                                t.setPosition(i), e.tip = i, e.adjustForChangedTip(n), e.makeShapes(), e.spec.tipX = e.tip.x, e.spec.tipY = e.tip.y, e.persistSpecChanges(), e.uniteBubbleShapes();
                            }
                        });
                    }, t.prototype.persistSpecChanges = function() {
                        this.bubble && this.bubble.persistBubbleSpecWithoutMonitoring();
                    }, t.prototype.isBubbleOverlappingParent = function() {
                        if (this.bubble) {
                            var t = r.Comical.findParent(this.bubble);
                            if (t && this.bubble.isOverlapping(t)) return !0;
                        }
                        return !1;
                    }, t.prototype.setTailAndHandleVisibility = function(t) {
                        this.allPaths().forEach(function(e) {
                            return e.visible = t;
                        });
                    }, t.transparentColor = new n.Color("#FFFFFF11"), t;
                }();
            },
            "./src/thoughtBubble.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.makeThoughtBubble = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js"), r = i("./src/random.ts");
                e.makeThoughtBubble = function(t) {
                    var e = t.content.clientWidth, i = t.content.clientHeight, s = new r.SimpleRandom(e + i);
                    return t.makeBubbleItem(0, function(e, i) {
                        for(var r = new n.Path, a = 0; a < e.length; a++){
                            var o = e[a], h = a < e.length - 1 ? e[a + 1] : e[0], l = new n.Point((o.x + h.x) / 2, (o.y + h.y) / 2), u = l.subtract(i);
                            u.length = 9 - 4.5 * s.nextDouble();
                            var c = l.add(u), d = new n.Path.Arc(o, c, h);
                            d.remove(), r.addSegments(d.segments);
                        }
                        return r.strokeWidth = t.getBorderWidth(), r.strokeColor = new n.Color("black"), r.closed = !0, r.name = "outlineShape", r;
                    });
                };
            },
            "./src/thoughtTail.ts": function(t, e, i) {
                "use strict";
                var n, r = this && this.__extends || (n = function(t, e) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, e) {
                        t.__proto__ = e;
                    } || function(t, e) {
                        for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                    })(t, e);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                }), s = this && this.__spreadArrays || function() {
                    for(var t = 0, e = 0, i = arguments.length; e < i; e++)t += arguments[e].length;
                    for(var n = Array(t), r = 0, e = 0; e < i; e++)for(var s = arguments[e], a = 0, o = s.length; a < o; a++, r++)n[r] = s[a];
                    return n;
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ThoughtTail = void 0;
                var a = i("./node_modules/paper/dist/paper-full.js"), o = i("./src/utilities.ts"), h = i("./src/curveTail.ts"), l = i("./src/comical.ts");
                e.ThoughtTail = function(t) {
                    function e(e, i, n, r, s, a, o, h) {
                        var l = t.call(this, e, i, r, s, a, o, h) || this;
                        return l.mid = n, l;
                    }
                    return r(e, t), e.prototype.makeShapes = function() {
                        this.miniBubbleFillPaths && this.miniBubbleFillPaths.forEach(function(t) {
                            return t.remove();
                        }), this.miniBubbleStrokePaths && this.miniBubbleStrokePaths.forEach(function(t) {
                            return t.remove();
                        });
                        var t = o.makeArc(this.tip, this.mid, this.root);
                        t.remove();
                        var e = t.length, i = 3;
                        this.miniBubbleFillPaths = [], this.miniBubbleStrokePaths = [];
                        var n = i;
                        for(o.activateLayer(this.upperLayer); n < e;){
                            var r = !0 !== this.spec.joiner ? 13 * n / e + 7 : 13.5, s = n + r;
                            if (s >= e) break;
                            var h = t.getLocationAt(s).point, u = h.add(t.getLocationAt(n).point).divide(2);
                            if (this.bubble.isHitByPoint(u)) break;
                            var c = new a.Path.Ellipse({
                                center: h,
                                size: new a.Size(r + 5, r)
                            });
                            c.strokeWidth = 2 * this.bubble.getBorderWidth(), c.strokeColor = new a.Color("black"), this.miniBubbleStrokePaths.push(c);
                            var d = c.clone();
                            d.fillColor = this.getFillColor(), d.strokeWidth = 0, this.clickAction && l.Comical.setItemOnClick(d, this.clickAction), this.miniBubbleFillPaths.push(d), i += 2, n += 2 * r + i;
                        }
                    }, e.prototype.fillPaths = function() {
                        return this.miniBubbleFillPaths || [];
                    }, e.prototype.allPaths = function() {
                        var t = this.fillPaths();
                        return this.miniBubbleStrokePaths && (t = s(t, this.miniBubbleStrokePaths)), t;
                    }, e;
                }(h.CurveTail);
            },
            "./src/uniqueId.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.uniqueIds = void 0, e.uniqueIds = function(t) {
                    for(var e = t.ownerDocument.evaluate(".//*[@id]", t, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null), i = {}, n = "i" + function() {
                        for(var t = [], e = "0123456789abcdef", i = 0; i < 36; i++)t[i] = e.substr(Math.floor(16 * Math.random()), 1);
                        return t[14] = "4", t[19] = e.substr(8 | t[19], 1), t[8] = t[13] = t[18] = t[23] = "-", t.join("");
                    }(), r = 0; r < e.snapshotLength; r++){
                        var s = e.snapshotItem(r), a = s.getAttribute("id");
                        if (a) {
                            var o = n + a;
                            i[a] = o, s.setAttribute("id", o);
                        }
                    }
                    !function t(e, i) {
                        for(var n = 0; n < e.children.length; n++)t(e.children[n], i);
                        for(var r = 0; r < e.attributes.length; r++){
                            var s = e.attributes[r];
                            if (s.value && s.value.startsWith("url(#") && s.value.endsWith(")")) {
                                var a = i[s.value.substring(5, s.value.length - 1)];
                                a && e.setAttribute(s.name, "url(#" + a + ")");
                            }
                        }
                    }(t, i);
                };
            },
            "./src/utilities.ts": function(t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.makeArc = e.activateLayer = void 0;
                var n = i("./node_modules/paper/dist/paper-full.js");
                e.activateLayer = function(t) {
                    t && (t.project.activate(), t.activate());
                }, e.makeArc = function(t, e, i) {
                    var r = Math.abs(e.subtract(t).angle - i.subtract(t).angle);
                    return r < 1e-4 || 1e-4 > Math.abs(r - 180) ? new n.Path.Line(t, i) : new n.Path.Arc(t, e, i);
                };
            },
            0: function(t, e) {},
            1: function(t, e) {}
        }, e = {};
        function i(n) {
            if (e[n]) return e[n].exports;
            var r = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
        }
        return i.m = t, i.c = e, i.d = function(t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, i.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, i.t = function(t, e) {
            if (1 & e && (t = i(t)), 8 & e || 4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var r in t)i.d(n, r, (function(e) {
                return t[e];
            }).bind(null, r));
            return n;
        }, i.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return i.d(e, "a", e), e;
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, i.p = "", i(i.s = "./src/index.ts");
    }(), window.Comical = e.Comical, window.Bubble = e.Bubble;
})();


const $aa1b5a77d2b6e958$export$ed8f9fd6ddd98a4e = window.Comical;
const $aa1b5a77d2b6e958$export$646feb54fbadbe06 = window.Bubble;
const $aa1b5a77d2b6e958$export$bea538f52bd0d8d7 = window.BubbleSpec;
const $aa1b5a77d2b6e958$export$129050bef66e141a = window.BubbleSpecPattern;
const $aa1b5a77d2b6e958$export$b79c344a3fdad757 = window.TailSpec;


// magnetic.js (ESM version for GSAP 3)

var $bvJM2 = parcelRequire("bvJM2");
var $bvJM2 = parcelRequire("bvJM2");
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);


var $1974f63041948ee8$export$99ee26438460406a = (0, $bvJM2.gsap).registerPlugin((0, $7d9b5a7dd4dbaff5$export$855822f522f18eef)) || (0, $bvJM2.gsap), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;


class $9d336583e383008f$export$22547e9306ed2dc0 {
    constructor(element, options = {}){
        this.elem = typeof element === "string" ? document.querySelector(element) : element;
        if (!this.elem) throw new Error("Invalid element selector or node");
        this.options = Object.assign({
            y: 0.2,
            x: 0.2,
            s: 0.2,
            rs: 0.7
        }, options);
        this.cursor = {
            x: 0,
            y: 0
        };
        this.bounds = this.elem.getBoundingClientRect();
        this.size = {
            height: this.bounds.height,
            width: this.bounds.width
        };
        this.center = {
            x: 0,
            y: 0
        };
        this.x = 0;
        this.y = 0;
        this.dist = 0;
        this.threshold = 50;
        this.isHover = 0;
        this.state = false;
        this.init();
    }
    cursorPosition(e) {
        this.cursor = {
            x: e.clientX,
            y: e.clientY
        };
    }
    listener() {
        this.bounds = this.elem.getBoundingClientRect();
        this.center = {
            x: this.bounds.left + this.size.width / 2,
            y: this.bounds.top + this.size.height / 2
        };
        this.x = this.cursor.x - this.center.x;
        this.y = this.cursor.y - this.center.y;
        this.dist = Math.sqrt(this.x ** 2 + this.y ** 2);
        this.isHover = this.dist < this.size.width / 2 + this.threshold;
        if (this.isHover) this.on();
        else if (this.state && !this.isHover) this.off();
    }
    on() {
        (0, $1974f63041948ee8$export$99ee26438460406a).to(this.elem, {
            duration: 0.5,
            x: this.x * 0.8,
            y: this.y * 0.8,
            skewX: this.x > 0 ? this.x * 0.125 : this.x * -0.125,
            scale: 1.1,
            rotation: this.x * 0.05,
            ease: (0, $bvJM2.Power2).easeOut
        });
        this.state = true;
    }
    off() {
        (0, $1974f63041948ee8$export$99ee26438460406a).to(this.elem, {
            duration: 1,
            x: 0,
            y: 0,
            rotation: 0,
            skewX: 0,
            skewY: 0,
            scale: 1,
            ease: (0, $bvJM2.Elastic).easeOut.config(1.2, 0.4)
        });
        this.state = false;
    }
    init() {
        window.addEventListener("mousemove", (e)=>{
            this.cursorPosition(e);
            this.listener();
        });
    }
}


function $774ffded8a8a101b$export$91d0b15145fa548e() {
    document.querySelectorAll(".magnetic").forEach((el)=>{
        new (0, $9d336583e383008f$export$22547e9306ed2dc0)(el);
    });
}


/**
 * cursor.js
 * https://www.jqueryscript.net/animation/custom-cursor-magnetic.html
 * 
 * Przerobiona cursor.js (ESM version, no jQuery)


Klasa  | Opis efektu
-visible	| Kursor staje się widoczny. :before zaczyna się skalować (scale(0.2))
-active	| Kursor wciśnięty (mousedown). Delikatnie powiększa/zmniejsza :before
-pointer	| Po najechaniu na link, przycisk lub element z data-cursor. :before mniejsze (scale(0.15))
-text	| Kursor pokazuje tekst w .cb-cursor-text. :before powiększone (scale(1.7)), tekst widoczny
-opaque	| Kursor półprzezroczysty z trybem mix-blend-mode: soft-light
-exclusion	| Tryb mieszania mix-blend-mode: exclusion, tło #ececec
-normal	| Tryb mieszania normalny (mix-blend-mode: normal)
-inverse	| Kolor kursora biały
-lg	| Duże kółko (scale(2))
-xl	| Bardzo duże kółko (scale(3))
-hidden	| Kółko niewidoczne (scale(0))

// Ustawione w CSS.
-color-red	| color: red
-color-green	| color: #51c67d


Zastosowanie:
<!-- link → ma -pointer -->
<a href="#">Link</a>

<!-- element z tekstem w kursorze -->
<div data-cursor-text="Kliknij mnie!">Hover me</div>

<!-- duży kursor -->
<div data-cursor="-lg">Duży kursor</div>

<!-- przyciąganie do elementu -->
<div data-cursor-stick="#target">Hover me</div>
<div id="target">Cel przyciągania</div>

<!-- kolor czerwony -->
<div data-cursor="-color-red">Czerwony kursor</div>

<!-- kombinacja klas -->
<div data-cursor="-xl -color-green">Extra duży zielony</div>


 **/ 
class $18804b4322ce8597$export$b6a79797ad180576 {
    constructor(options = {}){
        this.options = Object.assign({
            container: "body",
            speed: 0.7,
            ease: "expo.out",
            visibleTimeout: 300
        }, options);
        this.body = document.querySelector(this.options.container);
        if (!this.body) {
            console.warn("Cursor: container not found:", this.options.container);
            return;
        }
        this.el = document.createElement("div");
        this.el.className = "cb-cursor";
        this.text = document.createElement("div");
        this.text.className = "cb-cursor-text";
        this.el.appendChild(this.text);
        this.body.prepend(this.el);
        this.pos = {
            x: 0,
            y: 0
        };
        this.visible = false;
        this.stick = null;
        this.bind();
        this.move(-window.innerWidth, -window.innerHeight, 0);
    }
    bind() {
        document.addEventListener("mouseleave", ()=>this.hide());
        document.addEventListener("mouseenter", ()=>this.show());
        document.addEventListener("mousemove", (e)=>{
            this.pos = {
                x: this.stick ? this.stick.x - (this.stick.x - e.clientX) * 0.15 : e.clientX,
                y: this.stick ? this.stick.y - (this.stick.y - e.clientY) * 0.15 : e.clientY
            };
            this.update();
        });
        document.addEventListener("mousedown", ()=>this.setState("-active"));
        document.addEventListener("mouseup", ()=>this.removeState("-active"));
        document.querySelectorAll("a, input, textarea, button").forEach((el)=>{
            el.addEventListener("mouseenter", ()=>this.setState("-pointer"));
            el.addEventListener("mouseleave", ()=>this.removeState("-pointer"));
        });
        document.querySelectorAll("[data-cursor]").forEach((el)=>{
            el.addEventListener("mouseenter", (e)=>this.setState(e.currentTarget.dataset.cursor));
            el.addEventListener("mouseleave", (e)=>this.removeState(e.currentTarget.dataset.cursor));
        });
        document.querySelectorAll("[data-cursor-text]").forEach((el)=>{
            el.addEventListener("mouseenter", (e)=>this.setText(e.currentTarget.dataset.cursorText));
            el.addEventListener("mouseleave", ()=>this.removeText());
        });
        document.querySelectorAll("[data-cursor-stick]").forEach((el)=>{
            el.addEventListener("mouseenter", (e)=>this.setStick(e.currentTarget.dataset.cursorStick));
            el.addEventListener("mouseleave", ()=>this.removeStick());
        });
    }
    /** =====================
   *   STANY / KLASY
   * ===================== */ setState(state) {
        if (!state) return;
        this.el.classList.add(...state.trim().split(/\s+/));
    }
    removeState(state) {
        if (!state) return;
        this.el.classList.remove(...state.trim().split(/\s+/));
    }
    setText(text) {
        if (!text) return;
        this.text.innerHTML = text;
        this.el.classList.add("-text");
    }
    removeText() {
        this.el.classList.remove("-text");
    }
    /** =====================
   *   STICK (PRZYCIĄGANIE)
   * ===================== */ setStick(selector) {
        const target = document.querySelector(selector);
        if (!target) return;
        const bound = target.getBoundingClientRect();
        this.stick = {
            y: bound.top + bound.height / 2,
            x: bound.left + bound.width / 2
        };
        this.move(this.stick.x, this.stick.y, 0.5);
    }
    removeStick() {
        this.stick = null;
    }
    /** =====================
   *   ANIMACJE / RUCH
   * ===================== */ update() {
        this.move();
        this.show();
    }
    move(x, y, duration) {
        if (!this.pos) return;
        (0, $1974f63041948ee8$export$99ee26438460406a).to(this.el, {
            x: x ?? this.pos.x,
            y: y ?? this.pos.y,
            force3D: true,
            overwrite: true,
            ease: this.options.ease,
            duration: this.visible ? duration ?? this.options.speed : 0
        });
    }
    show() {
        if (this.visible) return;
        clearTimeout(this.visibleInt);
        this.el.classList.add("-visible");
        this.visibleInt = setTimeout(()=>this.visible = true, 20);
    }
    hide() {
        clearTimeout(this.visibleInt);
        this.el.classList.remove("-visible");
        this.visibleInt = setTimeout(()=>this.visible = false, this.options.visibleTimeout);
    }
}
function $18804b4322ce8597$export$c4d12dff0a005262(options) {
    // jeśli urządzenie dotykowe → przerwij
    if (window.innerWidth < 768) return null;
    return new $18804b4322ce8597$export$b6a79797ad180576(options);
}


/**
 * Obsługa animacji myszeczki (ikonka przewijania)
 */ function $b4b19b631c15dcd3$export$1430582b2cd0d38a() {
    const myszeczki = document.querySelectorAll('.myszeczka');
    if (!myszeczki.length) {
        console.warn("\u26A0\uFE0F Nie znaleziono \u017Cadnej .myszeczka w dokumencie.");
        return; // kończymy funkcję — nic do obserwowania
    }
    myszeczki.forEach((myszeczka)=>{
        const sekcja = myszeczka.closest('section, .section');
        if (!sekcja) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                myszeczka.classList.toggle('myszeczka--ukryta', !entry.isIntersecting);
            });
        }, {
            threshold: 1
        });
        observer.observe(sekcja);
        // Sekcja z wewnetrznym przewijaniem (sticky-section): myszeczka znika, gdy
        // doscrollowano do konca, bo nie ma juz co przewijac.
        const stickyContent = sekcja.querySelector('.sticky-content');
        if (stickyContent) {
            const sprawdzKoniec = ()=>{
                const koniec = stickyContent.scrollTop >= stickyContent.scrollHeight - stickyContent.clientHeight - 2;
                myszeczka.classList.toggle('myszeczka--koniec', koniec);
            };
            stickyContent.addEventListener('scroll', sprawdzKoniec, {
                passive: true
            });
            sprawdzKoniec();
        }
    });
}


/**
 * Animacja listy elementów w ofercie
 *
 * Obserwuje sekcje (domyślnie: #section3 .subsection)
 * Kiedy sekcja pojawia się w widoku, odpala animację
 * elementów <li> wewnątrz listy o klasie .animated-list
 * Każdy element wchodzi sekwencyjnie, jeden po drugim
 *
 * Użyty IntersectionObserver do wykrycia, że sekcja
 * weszła w widok (threshold 0.1 = 10% sekcji widocznej)
 *  - threshold: 0.1 → określa, jak wcześnie zaczyna animować
 *  - duration (ms): czas trwania animacji pojedynczego elementu
 *  - możesz też zmienić selektor sekcji (np. zamiast #section3)
 **/ function $fc7ee5b041f264c5$export$835c57e70a82f2a8() {
    // 🔹 Funkcja animująca pojedynczy element
    function animateItem(item, duration = 300) {
        return new Promise((resolve)=>{
            function onAnimationEnd() {
                item.removeEventListener('animationend', onAnimationEnd);
                resolve();
            }
            item.addEventListener('animationend', onAnimationEnd);
            // Reset animacji
            item.style.animation = 'none';
            item.style.opacity = 0;
            item.style.transform = 'translateY(-50px)';
            // Krótkie opóźnienie, żeby reset zadziałał
            setTimeout(()=>{
                item.style.animation = `fadeDropIn ${duration}ms forwards cubic-bezier(0.4, 0, 0.2, 1)`;
            }, 20);
        });
    }
    // Funkcja animująca listę sekwencyjnie
    async function animateListSequentially(listElement) {
        const items = listElement.querySelectorAll('li');
        if (!items.length) return;
        // Reset wszystkiego na start
        items.forEach((item)=>{
            item.style.animation = 'none';
            item.style.opacity = 0;
            item.style.transform = 'translateY(-50px)';
        });
        // Animuj kolejno, czekając na zakończenie poprzedniego
        for (const item of items)await animateItem(item);
    }
    // Obserwator sekcji (np. #section3)
    const sections = document.querySelectorAll('#section3 .subsection');
    if (!sections.length) {
        console.warn("\u26A0\uFE0F Nie znaleziono sekcji do animowania (#section3 .subsection)");
        return;
    }
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const ul = entry.target.querySelector('.animated-list');
                if (ul) animateListSequentially(ul);
            }
        });
    }, observerOptions);
    sections.forEach((section)=>observer.observe(section));
}


window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($dc57b31f1b066f38$exports)));
window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($dc57b31f1b066f38$exports)));
window.addEventListener('DOMContentLoaded', ()=>{
    // PACZKA 1 – rzeczy krytyczne (ładowane natychmiast)
    (0, $8f731f645b12aa47$export$b0c9e2140e094320)();
    (0, $c2175d535efe4d56$export$22ea07d0c2ddb570)();
    (0, $c2175d535efe4d56$export$f556f36ead468c30)();
    // PACZKA 2 – rzeczy lekkie, ale potrzebne od razu (np. audio, player)
    requestAnimationFrame(()=>{
        (0, $842f69af235281a6$export$7cc880c51f50f061)();
        // initPlayerControl();
        // Inicjalizacja dla wszystkich playerów na stronie
        document.querySelectorAll('.playeros').forEach((container)=>new (0, $03290796f2fc6bfc$export$832cc5475f11d8b4)(container));
    });
    // PACZKA 3 – rzeczy lekkie, które nie muszą być natychmiast
    requestAnimationFrame(()=>{
        (0, $30eef45fbcef7f49$export$a671ad4ae5dc9baf)();
        (0, $c37127fb35c64e86$export$93f7ad4ec63225e6)();
        (0, $7cb61fe63502ce5a$export$41d3aefe73d36205)('[data-resolver-first]');
        // puenta: literkowanie dopiero, gdy napis dojedzie scrollem do docelowej pozycji
        (0, $7cb61fe63502ce5a$export$41d3aefe73d36205)('[data-resolver-second]', {
            scrollContainer: '.sticky-content',
            settleTarget: '.facetos-content',
            threshold: 0.1
        });
    });
    // --- 💤 Lazy init (sekcje ciężkie graficznie) ---
    $bdaa65c8cc66fe0a$var$initWhenVisible('#canvas-1', ()=>(0, $d205a870e220ee31$export$eba565bdc753e540)('#canvas-1', {
            reveal: '.noir-enter-image'
        }));
    $bdaa65c8cc66fe0a$var$initWhenVisible('#section2b', ()=>{
        (0, $e84e48740dbfbbb6$export$a7f2c272381f5db7)('#section2b');
        (0, $b199725cc0758a2e$export$e9d04ed4d4d1e83d)('#section2b');
    });
    // PACZKA 4 – reszta, mniej krytyczne efekty
    requestAnimationFrame(()=>{
        (0, $e82d643cecacd259$export$f4b3eaae6950b78f)();
        (0, $774ffded8a8a101b$export$91d0b15145fa548e)();
        (0, $18804b4322ce8597$export$c4d12dff0a005262)();
        (0, $b4b19b631c15dcd3$export$1430582b2cd0d38a)();
        (0, $fc7ee5b041f264c5$export$835c57e70a82f2a8)();
    });
});
// ---------------------
// Lazy init helper
// ---------------------
function $bdaa65c8cc66fe0a$var$initWhenVisible(selector, callback) {
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                callback();
                observer.disconnect();
            }
        });
    });
    document.querySelectorAll(selector).forEach((el)=>observer.observe(el));
}

})();
//# sourceMappingURL=main.js.map
